var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  }
});
var _a, _focused, _cleanup, _setup, _b, _online, _cleanup2, _setup2, _c, _gcTimeout, _d, _initialState, _revertState, _cache, _client, _retryer, _defaultOptions, _abortSignalConsumed, _Query_instances, dispatch_fn, _e, _queries, _f, _observers, _mutationCache, _retryer2, _Mutation_instances, dispatch_fn2, _g, _mutations, _scopes, _mutationId, _h, _queryCache, _mutationCache2, _defaultOptions2, _queryDefaults, _mutationDefaults, _mountCount, _unsubscribeFocus, _unsubscribeOnline, _i, _client2, _currentQuery, _currentQueryInitialState, _currentResult, _currentResultState, _currentResultOptions, _currentThenable, _selectError, _selectFn, _selectResult, _lastQueryWithDefinedData, _staleTimeoutId, _refetchIntervalId, _currentRefetchInterval, _trackedProps, _QueryObserver_instances, executeFetch_fn, updateStaleTimeout_fn, computeRefetchInterval_fn, updateRefetchInterval_fn, updateTimers_fn, clearStaleTimeout_fn, clearRefetchInterval_fn, updateQuery_fn, notify_fn, _j;
import * as React from "react";
import React__default, { useEffect, Suspense, useState, useCallback, memo, useMemo, useRef, Fragment, createRef } from "react";
import { connect, Provider, useDispatch, useSelector } from "react-redux";
import { combineReducers, createStore, applyMiddleware, bindActionCreators } from "redux";
import thunk from "redux-thunk";
import { NumericFormat } from "react-number-format";
import { OverlayTrigger, Tooltip, Modal, Popover, Carousel } from "react-bootstrap";
import _, { filter as filter$1, kebabCase, has as has$1, omit, map as map$3, isUndefined as isUndefined$3, find, get, every, trim as trim$1, extend as extend$1, mapValues, values, cloneDeep, isArray as isArray$5, sortBy, forEach as forEach$1, each, result, isEmpty as isEmpty$3, first, findIndex } from "lodash";
import parse, { domToReact } from "html-react-parser";
import { useMediaQuery } from "react-responsive";
import { useIdleTimer } from "react-idle-timer";
import { useTimer } from "reactjs-countdown-hook";
import dayjs from "dayjs";
function _mergeNamespaces(n, m) {
  for (var i = 0; i < m.length; i++) {
    const e = m[i];
    if (typeof e !== "string" && !Array.isArray(e)) {
      for (const k in e) {
        if (k !== "default" && !(k in n)) {
          const d = Object.getOwnPropertyDescriptor(e, k);
          if (d) {
            Object.defineProperty(n, k, d.get ? d : {
              enumerable: true,
              get: () => e[k]
            });
          }
        }
      }
    }
  }
  return Object.freeze(Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }));
}
const ACCOUNT_SUMMARY_PENDING = "ACCOUNT_SUMMARY_PENDING";
const ACCOUNT_SUMMARY_SUCCESS = "ACCOUNT_SUMMARY_SUCCESS";
const ACCOUNT_SUMMARY_FAILURE = "ACCOUNT_SUMMARY_FAILURE";
const actionType = {
  ACCOUNT_SUMMARY_PENDING,
  ACCOUNT_SUMMARY_SUCCESS,
  ACCOUNT_SUMMARY_FAILURE
};
const initialHomeState$2 = {
  loading: true,
  summary: null
};
function AccountOverview(state = initialHomeState$2, action) {
  switch (action.type) {
    case actionType.ACCOUNT_SUMMARY_SUCCESS: {
      return Object.assign({}, state, {
        loading: false,
        summary: action.payload
      });
    }
    case actionType.ACCOUNT_SUMMARY_FAILURE: {
      return Object.assign({}, state, {
        loading: false,
        summary: action.payload
      });
    }
    default:
      return state;
  }
}
const SET_ACCOUNT_LOADED = "SET_ACCOUNT_LOADED";
const SET_ACCOUNT_DETAILS = "SET_ACCOUNT_DETAILS";
const SET_ACCOUNT_DETAILS_LOADED = "SET_ACCOUNT_DETAILS_LOADED";
const SET_SUMMARY_TOTAL = "SET_SUMMARY_TOTAL";
const SET_ACCOUNT_SUMMARY_LIST = "SET_ACCOUNT_SUMMARY_LIST";
const SET_SELECTED_ACCOUNT = "SET_SELECTED_ACCOUNT";
const SET_CURRENT_ACCOUNT = "SET_CURRENT_ACCOUNT";
const SET_CLICKED_ACCOUNT = "SET_CLICKED_ACCOUNT";
const SET_DEFAULT_GRPID_INDID = "SET_DEFAULT_GRPID_INDID";
const SET_SHOW_ACCOUNT_SWITCH_MODAL = "SET_SHOW_ACCOUNT_SWITCH_MODAL";
const SET_IS_CONTINUE_CALLED = "SET_IS_CONTINUE_CALLED";
const SET_PROVIDER_URL_AND_PHONE_NUMBER = "SET_PROVIDER_URL_AND_PHONE_NUMBER";
const SET_CSS = "SET_CSS";
const SET_SWITCH_CONTEXT_IN_PROGRESS = "SET_SWITCH_CONTEXT_IN_PROGRESS";
const SET_ACCOUNT_MENU_LIST = "SET_ACCOUNT_MENU_LIST";
const SET_DISPLAY_TOTAL_REWARDS = "SET_DISPLAY_TOTAL_REWARDS";
const SET_LEGACY_ACTIVE_ACCOUNT = "SET_LEGACY_ACTIVE_ACCOUNT";
const SET_OPEN_SAVE_CHANGES = "SET_OPEN_SAVE_CHANGES";
const SET_ACTIVE_NAV_ITEMS = "SET_ACTIVE_NAV_ITEMS";
const SET_ACCOUNT_MENU_ACTIVE = "SET_ACCOUNT_MENU_ACTIVE";
const SET_ACTIVE_MENU_TIER = "SET_ACTIVE_MENU_TIER";
const SET_ACTIVE_MENU_ITEM = "SET_ACTIVE_MENU_ITEM";
const SET_ACTIVE_SUB_MENU_ITEM = "SET_ACTIVE_SUB_MENU_ITEM";
const SET_MENU_NAVIGATION = "SET_MENU_NAVIGATION";
const SET_IS_INCOMPLETE_MODAL = "SET_IS_INCOMPLETE_MODAL";
const SET_NEXT_VAL = "SET_NEXT_VAL";
const SET_IS_ENROLL = "SET_IS_ENROLL";
const SET_MOBILE_MENU_ACTIVE = "SET_MOBILE_MENU_ACTIVE";
const SET_ON_VIEW_ALL_PREVENT = "SET_ON_VIEW_ALL_PREVENT";
const SET_IS_ACCOUNT_DROPDOWN_ACTIVE = "SET_IS_ACCOUNT_DROPDOWN_ACTIVE";
const SET_IS_ENROLLMENT_PAGE = "SET_IS_ENROLLMENT_PAGE";
const SET_NAV_SETTINGS = "SET_NAV_SETTINGS";
const SET_NAV_UPDATE = "SET_NAV_UPDATE";
const SET_ACCOUNT_OPEN_REFRESH_IN_PRG = "SET_ACCOUNT_OPEN_REFRESH_IN_PRG";
const initialAccountState = {
  accounts: null,
  accountSummaryList: null,
  accountSummaryListLoaded: false,
  accountMenuList: null,
  accountDetails: {
    groupDetails: {
      productId: "not-initialized",
      groupClientId: "not-initialized"
    },
    groupId: "not-initialized",
    productId: "not-initialized"
  },
  accountsDetailsLoaded: false,
  // set to true for testing
  accountsGrouped: [],
  accountURL: "",
  activeGroupAccount: {
    individualId: null,
    groupId: null
  },
  clickedAccount: "",
  cssGroupClientId: "not-initialized",
  cssGroupId: "not-initialized",
  cssProductId: "not-initialized",
  currentAccount: {
    individualId: null,
    groupId: null
  },
  currentContext: "",
  database: "",
  defaultGroupId: "",
  defaultIndId: "",
  groupId: "",
  individualId: "",
  isAccountSelected: false,
  isContinueCalled: false,
  planId: "",
  planName: "",
  selectedAccount: null,
  showAccountSwitchModal: false,
  summaryOfAllAccounts: {
    totalBalance: null,
    asOfDate: null
  },
  switchContextInProgress: false,
  totalBal: 0,
  urlPhoneNumberData: null
};
function account(state = initialAccountState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_ACCOUNT_LOADED: {
      const groupAcct = {
        individualId: payload.individualId,
        groupId: payload.groupId
      };
      return {
        ...state,
        ...payload,
        activeGroupAccount: { ...state.activeGroupAccount, ...groupAcct }
      };
    }
    case SET_ACCOUNT_DETAILS:
      return {
        ...state,
        accountDetails: payload,
        activeGroupAccount: {
          ...state.activeGroupAccount,
          individualId: payload.individualId,
          groupId: payload.groupId
        }
      };
    case SET_ACCOUNT_SUMMARY_LIST:
      return {
        ...state,
        accountSummaryList: payload,
        accountSummaryListLoaded: true
      };
    case SET_SUMMARY_TOTAL:
      return {
        ...state,
        summaryOfAllAccounts: {
          ...state.summaryOfAllAccounts,
          asOfDate: payload.asOfDate,
          totalBalance: payload.totalBalance
        }
      };
    case SET_ACCOUNT_MENU_LIST:
      return {
        ...state,
        accountMenuList: payload
      };
    case SET_SELECTED_ACCOUNT:
      return {
        ...state,
        selectedAccount: payload
      };
    case SET_CURRENT_ACCOUNT:
      return {
        ...state,
        currentAccount: payload
      };
    case SET_CLICKED_ACCOUNT:
      return {
        ...state,
        clickedAccount: payload
      };
    case SET_DEFAULT_GRPID_INDID:
      return {
        ...state,
        defaultGroupId: payload.defaultGroupId,
        defaultIndId: payload.defaultIndId
      };
    case SET_SHOW_ACCOUNT_SWITCH_MODAL:
      return {
        ...state,
        showAccountSwitchModal: payload
      };
    case SET_IS_CONTINUE_CALLED:
      return {
        ...state,
        isContinueCalled: payload
      };
    case SET_PROVIDER_URL_AND_PHONE_NUMBER:
      return {
        ...state,
        urlPhoneNumberData: payload
      };
    case SET_CSS: {
      if (payload.type === "group") {
        return {
          ...state,
          cssGroupId: payload.groupId,
          cssGroupClientId: payload.groupClient
        };
      }
      if (payload.type === "product" || payload.type === "all") {
        return {
          ...state,
          cssGroupId: payload.groupId,
          cssGroupClientId: payload.groupClient,
          cssProductId: payload.productId
        };
      }
      return state;
    }
    case SET_ACCOUNT_DETAILS_LOADED:
      return {
        ...state,
        accountsDetailsLoaded: payload
      };
    case SET_SWITCH_CONTEXT_IN_PROGRESS:
      return {
        ...state,
        switchContextInProgress: payload
      };
    default:
      return state;
  }
}
const SET_ADVICE_BASIC_LOADED = "SET_ADVICE_BASIC_LOADED";
const initialHomeState$1 = {
  adviceOverviewBasicLoaded: false,
  adviceAllowed: false,
  alreadyEnrolled: false,
  feEnabled: false,
  fundLineupStatus: "",
  guidanceAllowed: false,
  guidanceHeaderDataLoaded: false,
  ibbotsonEnabled: false,
  individualOptions: null,
  managedAccountsAllowed: false,
  managedAccountsOptions: null,
  ManagedAccountsTranslations: null,
  nextGenAdvisoryServicesEnabled: false
};
function advice(state = initialHomeState$1, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_ADVICE_BASIC_LOADED: {
      return {
        ...state,
        ...payload,
        adviceOverviewBasicLoaded: true
      };
    }
    default:
      return state;
  }
}
const SET_ACCU = "SET_ACCU";
const SET_ACCU_LOGO_LOADED = "SET_ACCU_LOGO_LOADED";
const SET_CACHE = "SET_CACHE";
const SET_GLOBAL_SETTINGS = "SET_GLOBAL_SETTINGS";
const INITIALIZE_HEADER = "INITIALIZE_HEADER";
const SET_HDR_PLAN_MESSAGES = "SET_HDR_PLAN_MESSAGES";
const SET_USER_PROFILE_DATA = "SET_USER_PROFILE_DATA";
const SET_PLAN_TXN_ACCESS = "SET_PLAN_TXN_ACCESS";
const SET_PSC_PATH_URL = "SET_PSC_PATH_URL";
const SET_NON_AUTH_HEADER = "SET_NON_AUTH_HEADER";
const SET_INIT_HEADER_DONE = "SET_INIT_HEADER_DONE";
const SET_IFRAME_URL = "SET_IFRAME_URL";
const SET_ACTIVE_MENU_MODAL = "SET_ACTIVE_MENU_MODAL";
const SET_SHOW_ERROR_MODAL = "SET_SHOW_ERROR_MODAL";
const SET_IS_DEEPLINK = "SET_IS_DEEPLINK";
const SET_HEADER_TITLE = "SET_HEADER_TITLE";
const SET_ARTICLES_CLICKED = "SET_ARTICLES_CLICKED";
const SET_NEW_ACCOUNT_OPENED = "SET_NEW_ACCOUNT_OPENED";
const SET_SHOW_SAVE_CHANGES_MODAL = "SET_SHOW_SAVE_CHANGES_MODAL";
const SET_SHOW_CONTEXT_SWITCH_BLOCKED_MODAL = "SET_SHOW_CONTEXT_SWITCH_BLOCKED_MODAL";
const SET_SHOW_OPEN_ACCOUNT_WARNING = "SET_SHOW_OPEN_ACCOUNT_WARNING";
const SET_TRANSLATIONS = "SET_TRANSLATIONS";
const SET_IS_EMULATOR_LOADED = "SET_IS_EMULATOR_LOADED";
const SET_AUTHENTICATION_STATUS = "SET__AUTHENTICATION_STATUS";
const SET_ACCU_CUSTOMIZATIONS = "SET_ACCU_CUSTOMIZATIONS";
const SET_INIT_CUSTOMIZATIONS_DONE = "SET_INIT_CUSTOMIZATION_DONE";
const SET_SITE_CONTACT_INFO = "SET_SITE_CONTACT_INFO";
const SET_SITE_CONTACT_INFO_LANG_CODE = "SET_SITE_CONTACT_INFO_LANG_CODE";
const initialHomeState = {
  accu: null,
  accuLogoLoaded: false,
  accuCustomization: {},
  accuLogo: "",
  accuLogoPNG: "",
  accuLogoClass: "",
  accuLogoAltAttribute: "site logo",
  accountMenu: null,
  accountOpenInProgress: false,
  advice: null,
  authenticated: false,
  authenticationStatus: {
    accuCode: "",
    authenticated: false,
    inboundSSOUser: false,
    partialAuth: false,
    registered: false
  },
  availableLocales: null,
  baseApiUrl: "",
  cache: void 0,
  educationCenterUrl: "",
  faviconIco: "",
  faviconPng: "",
  homePageEligibility: false,
  iframeUrl: "",
  initializeHeader: false,
  initializeHeaderDone: false,
  initLogin: false,
  initializeCustomizationsDone: false,
  isArticlesClicked: false,
  menuItemModalManifest: [],
  planMessagingSlides: [],
  planMessagingSvcCalled: false,
  showChangeLanguageButton: false,
  showGenericLogoPrelogin: false,
  showNonAuthHeader: void 0,
  ssoLogin: false,
  summaryOfAllAccounts: {
    totalBalance: 0
  },
  styleEnv: null,
  title: "",
  txnAccess: {
    chatEnable: false,
    chatBotEnable: false,
    liveChatEnable: false,
    enterpriseChatEnable: false,
    liatEnabled: false,
    advisoryServiceEnabled: false,
    financialEngineSSOEnabled: false,
    changeAllocationsEnabled: false,
    dnpSSOEnabled: false,
    wellnessEnabled: false,
    changeLanguageEnabled: false,
    retirementPlannerEnabled: false,
    savingsPlannerEnabled: false,
    performanceEnabled: false,
    wnspwbEnabled: false,
    txnAccessLoaded: false,
    quickViewEnabled: false,
    newBalancesViewEnabled: false,
    experimentsEnabled: false
  },
  translations: null,
  userProfile: {
    firstName: "",
    lastName: ""
  },
  urlPscPath: null,
  iframeSrcUrl: "",
  activeMenuModal: null,
  errorModal: {
    show: false,
    message: {
      header: null,
      body: null
    },
    footer: {
      canShow: false,
      code: null
    }
  },
  isDeepLinkEnabled: false,
  showContextSwitchBlockedModal: false,
  openAccountWarning: {
    show: false,
    isOts: false,
    redirect: null
  }
};
function header(state = initialHomeState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_ACCU: {
      return { ...state, accu: payload };
    }
    case SET_NON_AUTH_HEADER: {
      return {
        ...state,
        showNonAuthHeader: payload.showNonAuthHeader,
        initLogin: payload.initLogin,
        ssoLogin: payload.ssoLogin
      };
    }
    case SET_ACCU_LOGO_LOADED: {
      return { ...state, accuLogoLoaded: payload };
    }
    case SET_ACCU_CUSTOMIZATIONS:
      return {
        ...state,
        ...payload
      };
    case SET_INIT_CUSTOMIZATIONS_DONE: {
      return {
        ...state,
        initializeCustomizationsDone: true
      };
    }
    case SET_INIT_HEADER_DONE: {
      return {
        ...state,
        initializeHeaderDone: payload
      };
    }
    case SET_TRANSLATIONS: {
      return {
        ...state,
        translations: payload.header,
        title: payload.title
      };
    }
    case SET_GLOBAL_SETTINGS: {
      return {
        ...state,
        styleEnv: payload.styleEnv,
        iframeUrl: payload.iframeUrl,
        availableLocales: payload.availableLocales,
        showChangeLanguageButton: payload.showChangeLanguageButton,
        baseApiUrl: payload.baseApiUrl
      };
    }
    case SET_AUTHENTICATION_STATUS: {
      return {
        ...state,
        authenticationStatus: { ...state.authenticationStatus, ...payload },
        authenticated: payload.authenticated
      };
    }
    case SET_HDR_PLAN_MESSAGES: {
      return {
        ...state,
        planMessagingSlides: payload,
        planMessagingSvcCalled: true
      };
    }
    case SET_USER_PROFILE_DATA: {
      return {
        ...state,
        userProfile: payload
      };
    }
    case SET_PLAN_TXN_ACCESS: {
      return {
        ...state,
        txnAccess: payload
      };
    }
    case SET_PSC_PATH_URL: {
      return {
        ...state,
        urlPscPath: payload
      };
    }
    case SET_SHOW_SAVE_CHANGES_MODAL: {
      return {
        ...state,
        showSaveChangesModal: payload
      };
    }
    case INITIALIZE_HEADER: {
      return {
        ...state,
        initializeHeader: true
      };
    }
    case SET_IFRAME_URL:
      return {
        ...state,
        iframeSrcUrl: payload
      };
    case SET_ACTIVE_MENU_MODAL:
      return {
        ...state,
        activeMenuModal: payload
      };
    case SET_SHOW_ERROR_MODAL:
      return {
        ...state,
        errorModal: {
          show: payload.show,
          message: payload.message || {
            header: null,
            body: null
          },
          footer: payload.footer || {
            canShow: false,
            code: null
          }
        }
      };
    case SET_IS_DEEPLINK:
      return {
        ...state,
        isDeepLinkEnabled: payload
      };
    case SET_HEADER_TITLE:
      return {
        ...state,
        title: payload
      };
    case SET_ARTICLES_CLICKED:
      return {
        ...state,
        isArticlesClicked: payload
      };
    case SET_NEW_ACCOUNT_OPENED:
      return {
        ...state,
        accountOpenInProgress: payload
      };
    case SET_SHOW_CONTEXT_SWITCH_BLOCKED_MODAL:
      return {
        ...state,
        showContextSwitchBlockedModal: payload
      };
    case SET_SHOW_OPEN_ACCOUNT_WARNING:
      return {
        ...state,
        openAccountWarning: payload
      };
    default:
      return state;
  }
}
const initialState$2 = {
  accountMenuList: [],
  displayTotalRewards: false,
  legacyActiveGroupAccount: null,
  openSaveChanges: false,
  activeNavItems: {},
  accountMenuActive: false,
  activeMenuTier: 0,
  activeMenuItem: null,
  activeSubMenuItem: null,
  accountOpenInPrg: false,
  nonSubMenuGroups: [
    "investment-options",
    "account-details",
    "my-contributions",
    "payroll-calendar",
    "prior-contributions",
    "beneficiary",
    "rate-of-return",
    "landing",
    "demin-landing"
  ],
  mobileMenuActive: false,
  callbacksArr: [],
  menuNavigation: {},
  integratedNavSettings: null,
  isIncompleteModalExist: false,
  isEnroll: false,
  isEnrollmentPage: false,
  isAccountDropDownActive: false,
  nextVal: "",
  navUpdated: false,
  onViewAllPrevent: null
};
const navMenu = (state = initialState$2, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_ACCOUNT_MENU_LIST:
      return {
        ...state,
        accountMenuList: payload
      };
    case SET_DISPLAY_TOTAL_REWARDS:
      return {
        ...state,
        displayTotalRewards: payload
      };
    case SET_LEGACY_ACTIVE_ACCOUNT:
      return {
        ...state,
        legacyActiveGroupAccount: payload
      };
    case SET_OPEN_SAVE_CHANGES:
      return {
        ...state,
        openSaveChanges: payload
      };
    case SET_ACTIVE_NAV_ITEMS:
      return payload.tierToActivate ? {
        ...state,
        activeNavItems: {
          ...state.activeNavItems,
          [payload.tierToActivate]: payload.navItem
        }
      } : {
        ...state,
        activeNavItems: {
          ...payload
        }
      };
    case SET_ACCOUNT_MENU_ACTIVE:
      return {
        ...state,
        accountMenuActive: payload
      };
    case SET_ACTIVE_MENU_TIER:
      return {
        ...state,
        activeMenuTier: payload
      };
    case SET_ACTIVE_MENU_ITEM:
      return {
        ...state,
        activeMenuItem: payload
      };
    case SET_ACTIVE_SUB_MENU_ITEM:
      return {
        ...state,
        activeSubMenuItem: payload
      };
    case SET_MENU_NAVIGATION:
      return {
        ...state,
        menuNavigation: {
          ...state.menuNavigation,
          [payload.groupId]: payload.tmpMenuNavigation
        }
      };
    case SET_IS_INCOMPLETE_MODAL:
      return {
        ...state,
        isIncompleteModalExist: payload
      };
    case SET_IS_ENROLL:
      return {
        ...state,
        isEnroll: payload
      };
    case SET_NEXT_VAL:
      return {
        ...state,
        nextVal: payload
      };
    case SET_MOBILE_MENU_ACTIVE:
      return {
        ...state,
        mobileMenuActive: payload
      };
    case SET_ON_VIEW_ALL_PREVENT:
      return {
        ...state,
        onViewAllPrevent: payload
      };
    case SET_IS_ACCOUNT_DROPDOWN_ACTIVE:
      return {
        ...state,
        isAccountDropDownActive: payload
      };
    case SET_IS_ENROLLMENT_PAGE:
      return {
        ...state,
        isEnrollmentPage: payload
      };
    case SET_NAV_SETTINGS:
      return {
        ...state,
        integratedNavSettings: payload,
        navUpdated: false
      };
    case SET_NAV_UPDATE:
      return {
        ...state,
        navUpdated: true,
        integratedNavSettings: payload
      };
    case SET_ACCOUNT_OPEN_REFRESH_IN_PRG:
      return {
        ...state,
        accountOpenInPrg: payload
      };
    default:
      return state;
  }
};
const initialState$1 = {
  accuCustomization: {},
  authenticated: false,
  authenticationStatus: {
    accuCode: "",
    authenticated: false,
    inboundSSOUser: false,
    partialAuth: false,
    registered: false
  },
  initializeCustomizationsDone: false,
  isEmulator: false,
  isEmulatorCallLoaded: false,
  siteContactInfo: {
    endTime: "",
    beginTime: "",
    timeZone: "",
    tdd: "",
    intlNumber: "",
    phone: "",
    alias: "",
    email: ""
  },
  translations: null,
  selectedLanguage: ""
};
const shared = (state = initialState$1, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_TRANSLATIONS:
      return {
        ...state,
        translations: payload
      };
    case SET_IS_EMULATOR_LOADED:
      return {
        ...state,
        isEmulator: payload.isEmulator,
        isEmulatorCallLoaded: payload.isEmulatorCallLoaded
      };
    case SET_AUTHENTICATION_STATUS: {
      return {
        ...state,
        authenticationStatus: { ...state.authenticationStatus, ...payload },
        authenticated: payload.authenticated
      };
    }
    case SET_ACCU_CUSTOMIZATIONS:
      return {
        ...state,
        ...payload
      };
    case SET_INIT_CUSTOMIZATIONS_DONE:
      return {
        ...state,
        initializeCustomizationsDone: true
      };
    case SET_SITE_CONTACT_INFO:
      return {
        ...state,
        siteContactInfo: payload
      };
    case SET_SITE_CONTACT_INFO_LANG_CODE:
      return {
        ...state,
        selectedLanguage: payload.langCode
      };
    default:
      return state;
  }
};
const GET_SITE_CONTACT_INFO_SUCCESS = "GET_SITE_CONTACT_INFO_SUCCESS";
const initialState = {
  endTime: "",
  beginTime: "",
  timeZone: "",
  tdd: "",
  intlNumber: "",
  phone: "",
  alias: "",
  email: ""
};
const siteContactInfo = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SITE_CONTACT_INFO_SUCCESS:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};
const OPEN_OR_CLOSE_SSO_MODAL = "OPEN_OR_CLOSE_SSO_MODAL";
const OPEN_OR_CLOSE_SSO_INVESTING_MODAL = "OPEN_OR_CLOSE_SSO_INVESTING_MODAL";
const SET_ACTIVE_DEEP_LINK = "SET_ACTIVE_DEEP_LINK";
const initialSSOState = {
  showSSOModal: false,
  showSSOInvestingModal: false,
  activeDeepLinkItem: null
};
function sso(state = initialSSOState, action) {
  const { type, payload } = action;
  switch (type) {
    case OPEN_OR_CLOSE_SSO_MODAL: {
      return {
        ...state,
        showSSOModal: payload
      };
    }
    case OPEN_OR_CLOSE_SSO_INVESTING_MODAL: {
      return {
        ...state,
        showSSOInvestingModal: payload
      };
    }
    case SET_ACTIVE_DEEP_LINK: {
      return {
        ...state,
        activeDeepLinkItem: payload
      };
    }
    default:
      return state;
  }
}
const allReducers = combineReducers({
  accountOverview: AccountOverview,
  account,
  advice,
  header,
  shared,
  navMenu,
  siteContactInfo,
  sso
});
const store = createStore(allReducers, applyMiddleware(thunk));
function bind(fn, thisArg) {
  return function wrap2() {
    return fn.apply(thisArg, arguments);
  };
}
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = /* @__PURE__ */ ((cache2) => (thing) => {
  const str = toString.call(thing);
  return cache2[str] || (cache2[str] = str.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null));
const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type;
};
const typeOfTest = (type) => (thing) => typeof thing === type;
const { isArray: isArray$4 } = Array;
const isUndefined$2 = typeOfTest("undefined");
function isBuffer$2(val) {
  return val !== null && !isUndefined$2(val) && val.constructor !== null && !isUndefined$2(val.constructor) && isFunction$5(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  let result2;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result2 = ArrayBuffer.isView(val);
  } else {
    result2 = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result2;
}
const isString$1 = typeOfTest("string");
const isFunction$5 = typeOfTest("function");
const isNumber = typeOfTest("number");
const isObject$3 = (thing) => thing !== null && typeof thing === "object";
const isBoolean = (thing) => thing === true || thing === false;
const isPlainObject$2 = (val) => {
  if (kindOf(val) !== "object") {
    return false;
  }
  const prototype2 = getPrototypeOf(val);
  return (prototype2 === null || prototype2 === Object.prototype || Object.getPrototypeOf(prototype2) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
const isDate = kindOfTest("Date");
const isFile = kindOfTest("File");
const isBlob = kindOfTest("Blob");
const isFileList = kindOfTest("FileList");
const isStream = (val) => isObject$3(val) && isFunction$5(val.pipe);
const isFormData = (thing) => {
  let kind;
  return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction$5(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
  kind === "object" && isFunction$5(thing.toString) && thing.toString() === "[object FormData]"));
};
const isURLSearchParams = kindOfTest("URLSearchParams");
const [isReadableStream, isRequest, isResponse, isHeaders] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest);
const trim = (str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(obj, fn, { allOwnKeys = false } = {}) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  let i;
  let l;
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray$4(obj)) {
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;
    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}
function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
const _global = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context) => !isUndefined$2(context) && context !== _global;
function merge$1() {
  const { caseless } = isContextDefined(this) && this || {};
  const result2 = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result2, key) || key;
    if (isPlainObject$2(result2[targetKey]) && isPlainObject$2(val)) {
      result2[targetKey] = merge$1(result2[targetKey], val);
    } else if (isPlainObject$2(val)) {
      result2[targetKey] = merge$1({}, val);
    } else if (isArray$4(val)) {
      result2[targetKey] = val.slice();
    } else {
      result2[targetKey] = val;
    }
  };
  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result2;
}
const extend = (a, b, thisArg, { allOwnKeys } = {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction$5(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, { allOwnKeys });
  return a;
};
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
};
const inherits = (constructor, superConstructor, props, descriptors2) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, "super", {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};
const toFlatObject = (sourceObj, destObj, filter3, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};
  destObj = destObj || {};
  if (sourceObj == null) return destObj;
  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter3 !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter3 || filter3(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === void 0 || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray$4(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};
const isTypedArray$2 = /* @__PURE__ */ ((TypedArray) => {
  return (thing) => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];
  const iterator2 = generator.call(obj);
  let result2;
  while ((result2 = iterator2.next()) && !result2.done) {
    const pair = result2.value;
    fn.call(obj, pair[0], pair[1]);
  }
};
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];
  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }
  return arr;
};
const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str) => {
  return str.toLowerCase().replace(
    /[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};
const hasOwnProperty$6 = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop) => hasOwnProperty2.call(obj, prop))(Object.prototype);
const isRegExp$1 = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer) => {
  const descriptors2 = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach(descriptors2, (descriptor, name2) => {
    let ret;
    if ((ret = reducer(descriptor, name2, obj)) !== false) {
      reducedDescriptors[name2] = ret || descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};
const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name2) => {
    if (isFunction$5(obj) && ["arguments", "caller", "callee"].indexOf(name2) !== -1) {
      return false;
    }
    const value = obj[name2];
    if (!isFunction$5(value)) return;
    descriptor.enumerable = false;
    if ("writable" in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error("Can not rewrite read-only method '" + name2 + "'");
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};
  const define = (arr) => {
    arr.forEach((value) => {
      obj[value] = true;
    });
  };
  isArray$4(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
  return obj;
};
const noop$3 = () => {
};
const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction$5(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj) => {
  const stack = new Array(10);
  const visit2 = (source, i) => {
    if (isObject$3(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }
      if (!("toJSON" in source)) {
        stack[i] = source;
        const target = isArray$4(source) ? [] : {};
        forEach(source, (value, key) => {
          const reducedValue = visit2(value, i + 1);
          !isUndefined$2(reducedValue) && (target[key] = reducedValue);
        });
        stack[i] = void 0;
        return target;
      }
    }
    return source;
  };
  return visit2(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable$1 = (thing) => thing && (isObject$3(thing) || isFunction$5(thing)) && isFunction$5(thing.then) && isFunction$5(thing.catch);
const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }
  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({ source, data }) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);
    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    };
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === "function",
  isFunction$5(_global.postMessage)
);
const asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind(_global) : typeof process !== "undefined" && process.nextTick || _setImmediate;
const utils$1 = {
  isArray: isArray$4,
  isArrayBuffer,
  isBuffer: isBuffer$2,
  isFormData,
  isArrayBufferView,
  isString: isString$1,
  isNumber,
  isBoolean,
  isObject: isObject$3,
  isPlainObject: isPlainObject$2,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined: isUndefined$2,
  isDate,
  isFile,
  isBlob,
  isRegExp: isRegExp$1,
  isFunction: isFunction$5,
  isStream,
  isURLSearchParams,
  isTypedArray: isTypedArray$2,
  isFileList,
  forEach,
  merge: merge$1,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: hasOwnProperty$6,
  hasOwnProp: hasOwnProperty$6,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$3,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable: isThenable$1,
  setImmediate: _setImmediate,
  asap
};
function AxiosError(message, code, config2, request, response) {
  Error.call(this);
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }
  this.message = message;
  this.name = "AxiosError";
  code && (this.code = code);
  config2 && (this.config = config2);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}
utils$1.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const prototype$1 = AxiosError.prototype;
const descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((code) => {
  descriptors[code] = { value: code };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: true });
AxiosError.from = (error, code, config2, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);
  utils$1.toFlatObject(error, axiosError, function filter3(obj) {
    return obj !== Error.prototype;
  }, (prop) => {
    return prop !== "isAxiosError";
  });
  AxiosError.call(axiosError, error.message, code, config2, request, response);
  axiosError.cause = error;
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
const httpAdapter = null;
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}
function removeBrackets(key) {
  return utils$1.endsWith(key, "[]") ? key.slice(0, -2) : key;
}
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each2(token, i) {
    token = removeBrackets(token);
    return !dots && i ? "[" + token + "]" : token;
  }).join(dots ? "." : "");
}
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});
function toFormData(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError("target must be an object");
  }
  formData = formData || new FormData();
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    return !utils$1.isUndefined(source[option]);
  });
  const metaTokens = options.metaTokens;
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);
  if (!utils$1.isFunction(visitor)) {
    throw new TypeError("visitor must be a function");
  }
  function convertValue(value) {
    if (value === null) return "";
    if (utils$1.isDate(value)) {
      return value.toISOString();
    }
    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError("Blob is not supported. Use a Buffer instead.");
    }
    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }
  function defaultVisitor(value, key, path) {
    let arr = value;
    if (value && !path && typeof value === "object") {
      if (utils$1.endsWith(key, "{}")) {
        key = metaTokens ? key : key.slice(0, -2);
        value = JSON.stringify(value);
      } else if (utils$1.isArray(value) && isFlatArray(value) || (utils$1.isFileList(value) || utils$1.endsWith(key, "[]")) && (arr = utils$1.toArray(value))) {
        key = removeBrackets(key);
        arr.forEach(function each2(el2, index2) {
          !(utils$1.isUndefined(el2) || el2 === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index2, dots) : indexes === null ? key : key + "[]",
            convertValue(el2)
          );
        });
        return false;
      }
    }
    if (isVisitable(value)) {
      return true;
    }
    formData.append(renderKey(path, key, dots), convertValue(value));
    return false;
  }
  const stack = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build(value, path) {
    if (utils$1.isUndefined(value)) return;
    if (stack.indexOf(value) !== -1) {
      throw Error("Circular reference detected in " + path.join("."));
    }
    stack.push(value);
    utils$1.forEach(value, function each2(el2, key) {
      const result2 = !(utils$1.isUndefined(el2) || el2 === null) && visitor.call(
        formData,
        el2,
        utils$1.isString(key) ? key.trim() : key,
        path,
        exposedHelpers
      );
      if (result2 === true) {
        build(el2, path ? path.concat(key) : [key]);
      }
    });
    stack.pop();
  }
  if (!utils$1.isObject(obj)) {
    throw new TypeError("data must be an object");
  }
  build(obj);
  return formData;
}
function encode$1(str) {
  const charMap = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}
function AxiosURLSearchParams(params, options) {
  this._pairs = [];
  params && toFormData(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name2, value) {
  this._pairs.push([name2, value]);
};
prototype.toString = function toString2(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;
  return this._pairs.map(function each2(pair) {
    return _encode(pair[0]) + "=" + _encode(pair[1]);
  }, "").join("&");
};
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url2, params, options) {
  if (!params) {
    return url2;
  }
  const _encode = options && options.encode || encode;
  if (utils$1.isFunction(options)) {
    options = {
      serialize: options
    };
  }
  const serializeFn = options && options.serialize;
  let serializedParams;
  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, options).toString(_encode);
  }
  if (serializedParams) {
    const hashmarkIndex = url2.indexOf("#");
    if (hashmarkIndex !== -1) {
      url2 = url2.slice(0, hashmarkIndex);
    }
    url2 += (url2.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url2;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id2) {
    if (this.handlers[id2]) {
      this.handlers[id2] = null;
    }
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
const URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
const FormData$1 = typeof FormData !== "undefined" ? FormData : null;
const Blob$1 = typeof Blob !== "undefined" ? Blob : null;
const platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
const _navigator = typeof navigator === "object" && navigator || void 0;
const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0);
const hasStandardBrowserWebWorkerEnv = (() => {
  return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const origin = hasBrowserEnv && window.location.href || "http://localhost";
const utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  navigator: _navigator,
  origin
}, Symbol.toStringTag, { value: "Module" }));
const platform = {
  ...utils,
  ...platform$1
};
function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString("base64"));
        return false;
      }
      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}
function parsePropPath(name2) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name2).map((match) => {
    return match[0] === "[]" ? "" : match[1] || match[0];
  });
}
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}
function formDataToJSON(formData) {
  function buildPath(path, value, target, index2) {
    let name2 = path[index2++];
    if (name2 === "__proto__") return true;
    const isNumericKey = Number.isFinite(+name2);
    const isLast = index2 >= path.length;
    name2 = !name2 && utils$1.isArray(target) ? target.length : name2;
    if (isLast) {
      if (utils$1.hasOwnProp(target, name2)) {
        target[name2] = [target[name2], value];
      } else {
        target[name2] = value;
      }
      return !isNumericKey;
    }
    if (!target[name2] || !utils$1.isObject(target[name2])) {
      target[name2] = [];
    }
    const result2 = buildPath(path, value, target[name2], index2);
    if (result2 && utils$1.isArray(target[name2])) {
      target[name2] = arrayToObject(target[name2]);
    }
    return !isNumericKey;
  }
  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};
    utils$1.forEachEntry(formData, (name2, value) => {
      buildPath(parsePropPath(name2), value, obj, 0);
    });
    return obj;
  }
  return null;
}
function stringifySafely(rawValue2, parser, encoder) {
  if (utils$1.isString(rawValue2)) {
    try {
      (parser || JSON.parse)(rawValue2);
      return utils$1.trim(rawValue2);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (0, JSON.stringify)(rawValue2);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || "";
    const hasJSONContentType = contentType.indexOf("application/json") > -1;
    const isObjectPayload = utils$1.isObject(data);
    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }
    const isFormData2 = utils$1.isFormData(data);
    if (isFormData2) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }
    if (utils$1.isArrayBuffer(data) || utils$1.isBuffer(data) || utils$1.isStream(data) || utils$1.isFile(data) || utils$1.isBlob(data) || utils$1.isReadableStream(data)) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
      return data.toString();
    }
    let isFileList2;
    if (isObjectPayload) {
      if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }
      if ((isFileList2 = utils$1.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
        const _FormData = this.env && this.env.FormData;
        return toFormData(
          isFileList2 ? { "files[]": data } : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }
    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType("application/json", false);
      return stringifySafely(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    const transitional2 = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    const JSONRequested = this.responseType === "json";
    if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
      return data;
    }
    if (data && utils$1.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }
    return data;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (method) => {
  defaults.headers[method] = {};
});
const ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
const parseHeaders = (rawHeaders) => {
  const parsed = {};
  let key;
  let val;
  let i;
  rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
    i = line.indexOf(":");
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();
    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }
    if (key === "set-cookie") {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    }
  });
  return parsed;
};
const $internals = Symbol("internals");
function normalizeHeader(header2) {
  return header2 && String(header2).trim().toLowerCase();
}
function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }
  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
  const tokens = /* @__PURE__ */ Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;
  while (match = tokensRE.exec(str)) {
    tokens[match[1]] = match[2];
  }
  return tokens;
}
const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header2, filter3, isHeaderNameFilter) {
  if (utils$1.isFunction(filter3)) {
    return filter3.call(this, value, header2);
  }
  if (isHeaderNameFilter) {
    value = header2;
  }
  if (!utils$1.isString(value)) return;
  if (utils$1.isString(filter3)) {
    return value.indexOf(filter3) !== -1;
  }
  if (utils$1.isRegExp(filter3)) {
    return filter3.test(value);
  }
}
function formatHeader(header2) {
  return header2.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
    return char.toUpperCase() + str;
  });
}
function buildAccessors(obj, header2) {
  const accessorName = utils$1.toCamelCase(" " + header2);
  ["get", "set", "has"].forEach((methodName) => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header2, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}
class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }
  set(header2, valueOrRewrite, rewrite) {
    const self2 = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader) {
        throw new Error("header name must be a non-empty string");
      }
      const key = utils$1.findKey(self2, lHeader);
      if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
        self2[key || _header] = normalizeValue(_value);
      }
    }
    const setHeaders = (headers, _rewrite) => utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
    if (utils$1.isPlainObject(header2) || header2 instanceof this.constructor) {
      setHeaders(header2, valueOrRewrite);
    } else if (utils$1.isString(header2) && (header2 = header2.trim()) && !isValidHeaderName(header2)) {
      setHeaders(parseHeaders(header2), valueOrRewrite);
    } else if (utils$1.isHeaders(header2)) {
      for (const [key, value] of header2.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header2 != null && setHeader(valueOrRewrite, header2, rewrite);
    }
    return this;
  }
  get(header2, parser) {
    header2 = normalizeHeader(header2);
    if (header2) {
      const key = utils$1.findKey(this, header2);
      if (key) {
        const value = this[key];
        if (!parser) {
          return value;
        }
        if (parser === true) {
          return parseTokens(value);
        }
        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }
        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(header2, matcher) {
    header2 = normalizeHeader(header2);
    if (header2) {
      const key = utils$1.findKey(this, header2);
      return !!(key && this[key] !== void 0 && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }
    return false;
  }
  delete(header2, matcher) {
    const self2 = this;
    let deleted = false;
    function deleteHeader(_header) {
      _header = normalizeHeader(_header);
      if (_header) {
        const key = utils$1.findKey(self2, _header);
        if (key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher))) {
          delete self2[key];
          deleted = true;
        }
      }
    }
    if (utils$1.isArray(header2)) {
      header2.forEach(deleteHeader);
    } else {
      deleteHeader(header2);
    }
    return deleted;
  }
  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;
    while (i--) {
      const key = keys[i];
      if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }
    return deleted;
  }
  normalize(format2) {
    const self2 = this;
    const headers = {};
    utils$1.forEach(this, (value, header2) => {
      const key = utils$1.findKey(headers, header2);
      if (key) {
        self2[key] = normalizeValue(value);
        delete self2[header2];
        return;
      }
      const normalized = format2 ? formatHeader(header2) : String(header2).trim();
      if (normalized !== header2) {
        delete self2[header2];
      }
      self2[normalized] = normalizeValue(value);
      headers[normalized] = true;
    });
    return this;
  }
  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }
  toJSON(asStrings) {
    const obj = /* @__PURE__ */ Object.create(null);
    utils$1.forEach(this, (value, header2) => {
      value != null && value !== false && (obj[header2] = asStrings && utils$1.isArray(value) ? value.join(", ") : value);
    });
    return obj;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([header2, value]) => header2 + ": " + value).join("\n");
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }
  static concat(first2, ...targets) {
    const computed = new this(first2);
    targets.forEach((target) => computed.set(target));
    return computed;
  }
  static accessor(header2) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype2 = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      if (!accessors[lHeader]) {
        buildAccessors(prototype2, _header);
        accessors[lHeader] = true;
      }
    }
    utils$1.isArray(header2) ? header2.forEach(defineAccessor) : defineAccessor(header2);
    return this;
  }
}
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({ value }, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1);
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders);
function transformData(fns, response) {
  const config2 = this || defaults;
  const context = response || config2;
  const headers = AxiosHeaders.from(context.headers);
  let data = context.data;
  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(config2, data, headers.normalize(), response ? response.status : void 0);
  });
  headers.normalize();
  return data;
}
function isCancel(value) {
  return !!(value && value.__CANCEL__);
}
function CanceledError(message, config2, request) {
  AxiosError.call(this, message == null ? "canceled" : message, AxiosError.ERR_CANCELED, config2, request);
  this.name = "CanceledError";
}
utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});
function settle(resolve2, reject, response) {
  const validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve2(response);
  } else {
    reject(new AxiosError(
      "Request failed with status code " + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}
function parseProtocol(url2) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url2);
  return match && match[1] || "";
}
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;
  min = min !== void 0 ? min : 1e3;
  return function push2(chunkLength) {
    const now = Date.now();
    const startedAt = timestamps[tail];
    if (!firstSampleTS) {
      firstSampleTS = now;
    }
    bytes[head] = chunkLength;
    timestamps[head] = now;
    let i = tail;
    let bytesCount = 0;
    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }
    head = (head + 1) % samplesCount;
    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }
    if (now - firstSampleTS < min) {
      return;
    }
    const passed = startedAt && now - startedAt;
    return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
  };
}
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1e3 / freq;
  let lastArgs;
  let timer2;
  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer2) {
      clearTimeout(timer2);
      timer2 = null;
    }
    fn.apply(null, args);
  };
  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if (passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer2) {
        timer2 = setTimeout(() => {
          timer2 = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };
  const flush = () => lastArgs && invoke(lastArgs);
  return [throttled, flush];
}
const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);
  return throttle((e) => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : void 0;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data = {
      loaded,
      total,
      progress: total ? loaded / total : void 0,
      bytes: progressBytes,
      rate: rate ? rate : void 0,
      estimated: rate && total && inRange ? (total - loaded) / rate : void 0,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? "download" : "upload"]: true
    };
    listener(data);
  }, freq);
};
const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;
  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};
const asyncDecorator = (fn) => (...args) => utils$1.asap(() => fn(...args));
const isURLSameOrigin = platform.hasStandardBrowserEnv ? /* @__PURE__ */ ((origin2, isMSIE) => (url2) => {
  url2 = new URL(url2, platform.origin);
  return origin2.protocol === url2.protocol && origin2.host === url2.host && (isMSIE || origin2.port === url2.port);
})(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => true;
const cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(name2, value, expires, path, domain, secure) {
      const cookie = [name2 + "=" + encodeURIComponent(value)];
      utils$1.isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
      utils$1.isString(path) && cookie.push("path=" + path);
      utils$1.isString(domain) && cookie.push("domain=" + domain);
      secure === true && cookie.push("secure");
      document.cookie = cookie.join("; ");
    },
    read(name2) {
      const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove(name2) {
      this.write(name2, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(url2) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url2);
}
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
  let isRelativeUrl = !isAbsoluteURL(requestedURL);
  if (baseURL && isRelativeUrl || allowAbsoluteUrls == false) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
const headersToObject = (thing) => thing instanceof AxiosHeaders ? { ...thing } : thing;
function mergeConfig(config1, config2) {
  config2 = config2 || {};
  const config3 = {};
  function getMergedValue(target, source, prop, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({ caseless }, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(a, b, prop, caseless) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(a, b, prop, caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(void 0, a, prop, caseless);
    }
  }
  function valueFromConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(void 0, b);
    }
  }
  function defaultToConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(void 0, b);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(void 0, a);
    }
  }
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(void 0, a);
    }
  }
  const mergeMap2 = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b, prop) => mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true)
  };
  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge2 = mergeMap2[prop] || mergeDeepProperties;
    const configValue = merge2(config1[prop], config2[prop], prop);
    utils$1.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config3[prop] = configValue);
  });
  return config3;
}
const resolveConfig = (config2) => {
  const newConfig = mergeConfig({}, config2);
  let { data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth } = newConfig;
  newConfig.headers = headers = AxiosHeaders.from(headers);
  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url), config2.params, config2.paramsSerializer);
  if (auth) {
    headers.set(
      "Authorization",
      "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : ""))
    );
  }
  let contentType;
  if (utils$1.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(void 0);
    } else if ((contentType = headers.getContentType()) !== false) {
      const [type, ...tokens] = contentType ? contentType.split(";").map((token) => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || "multipart/form-data", ...tokens].join("; "));
    }
  }
  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
    if (withXSRFToken || withXSRFToken !== false && isURLSameOrigin(newConfig.url)) {
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);
      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }
  return newConfig;
};
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
const xhrAdapter = isXHRAdapterSupported && function(config2) {
  return new Promise(function dispatchXhrRequest(resolve2, reject) {
    const _config = resolveConfig(config2);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders.from(_config.headers).normalize();
    let { responseType, onUploadProgress, onDownloadProgress } = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;
    function done() {
      flushUpload && flushUpload();
      flushDownload && flushDownload();
      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
      _config.signal && _config.signal.removeEventListener("abort", onCanceled);
    }
    let request = new XMLHttpRequest();
    request.open(_config.method.toUpperCase(), _config.url, true);
    request.timeout = _config.timeout;
    function onloadend() {
      if (!request) {
        return;
      }
      const responseHeaders = AxiosHeaders.from(
        "getAllResponseHeaders" in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config2,
        request
      };
      settle(function _resolve(value) {
        resolve2(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request = null;
    }
    if ("onloadend" in request) {
      request.onloadend = onloadend;
    } else {
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(new AxiosError("Request aborted", AxiosError.ECONNABORTED, config2, request));
      request = null;
    };
    request.onerror = function handleError() {
      reject(new AxiosError("Network Error", AxiosError.ERR_NETWORK, config2, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
      const transitional2 = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional2.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config2,
        request
      ));
      request = null;
    };
    requestData === void 0 && requestHeaders.setContentType(null);
    if ("setRequestHeader" in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }
    if (!utils$1.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request.responseType = _config.responseType;
    }
    if (onDownloadProgress) {
      [downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true);
      request.addEventListener("progress", downloadThrottled);
    }
    if (onUploadProgress && request.upload) {
      [uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress);
      request.upload.addEventListener("progress", uploadThrottled);
      request.upload.addEventListener("loadend", flushUpload);
    }
    if (_config.cancelToken || _config.signal) {
      onCanceled = (cancel) => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config2, request) : cancel);
        request.abort();
        request = null;
      };
      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
      }
    }
    const protocol = parseProtocol(_config.url);
    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError("Unsupported protocol " + protocol + ":", AxiosError.ERR_BAD_REQUEST, config2));
      return;
    }
    request.send(requestData || null);
  });
};
const composeSignals = (signals, timeout2) => {
  const { length } = signals = signals ? signals.filter(Boolean) : [];
  if (timeout2 || length) {
    let controller = new AbortController();
    let aborted;
    const onabort = function(reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof AxiosError ? err : new CanceledError(err instanceof Error ? err.message : err));
      }
    };
    let timer2 = timeout2 && setTimeout(() => {
      timer2 = null;
      onabort(new AxiosError(`timeout ${timeout2} of ms exceeded`, AxiosError.ETIMEDOUT));
    }, timeout2);
    const unsubscribe = () => {
      if (signals) {
        timer2 && clearTimeout(timer2);
        timer2 = null;
        signals.forEach((signal2) => {
          signal2.unsubscribe ? signal2.unsubscribe(onabort) : signal2.removeEventListener("abort", onabort);
        });
        signals = null;
      }
    };
    signals.forEach((signal2) => signal2.addEventListener("abort", onabort));
    const { signal } = controller;
    signal.unsubscribe = () => utils$1.asap(unsubscribe);
    return signal;
  }
};
const streamChunk = function* (chunk2, chunkSize) {
  let len = chunk2.byteLength;
  if (len < chunkSize) {
    yield chunk2;
    return;
  }
  let pos = 0;
  let end;
  while (pos < len) {
    end = pos + chunkSize;
    yield chunk2.slice(pos, end);
    pos = end;
  }
};
const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk2 of readStream(iterable)) {
    yield* streamChunk(chunk2, chunkSize);
  }
};
const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }
  const reader = stream.getReader();
  try {
    for (; ; ) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
};
const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator2 = readBytes(stream, chunkSize);
  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };
  return new ReadableStream({
    async pull(controller) {
      try {
        const { done: done2, value } = await iterator2.next();
        if (done2) {
          _onFinish();
          controller.close();
          return;
        }
        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator2.return();
    }
  }, {
    highWaterMark: 2
  });
};
const isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === "function";
const encodeText = isFetchSupported && (typeof TextEncoder === "function" ? /* @__PURE__ */ ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) : async (str) => new Uint8Array(await new Response(str).arrayBuffer()));
const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false;
  }
};
const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;
  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      duplexAccessed = true;
      return "half";
    }
  }).headers.has("Content-Type");
  return duplexAccessed && !hasContentType;
});
const DEFAULT_CHUNK_SIZE = 64 * 1024;
const supportsResponseStream = isReadableStreamSupported && test(() => utils$1.isReadableStream(new Response("").body));
const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};
isFetchSupported && ((res) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((type) => {
    !resolvers[type] && (resolvers[type] = utils$1.isFunction(res[type]) ? (res2) => res2[type]() : (_2, config2) => {
      throw new AxiosError(`Response type '${type}' is not supported`, AxiosError.ERR_NOT_SUPPORT, config2);
    });
  });
})(new Response());
const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }
  if (utils$1.isBlob(body)) {
    return body.size;
  }
  if (utils$1.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: "POST",
      body
    });
    return (await _request.arrayBuffer()).byteLength;
  }
  if (utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
    return body.byteLength;
  }
  if (utils$1.isURLSearchParams(body)) {
    body = body + "";
  }
  if (utils$1.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};
const resolveBodyLength = async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());
  return length == null ? getBodyLength(body) : length;
};
const fetchAdapter = isFetchSupported && (async (config2) => {
  let {
    url: url2,
    method,
    data,
    signal,
    cancelToken,
    timeout: timeout2,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = "same-origin",
    fetchOptions
  } = resolveConfig(config2);
  responseType = responseType ? (responseType + "").toLowerCase() : "text";
  let composedSignal = composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout2);
  let request;
  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
    composedSignal.unsubscribe();
  });
  let requestContentLength;
  try {
    if (onUploadProgress && supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
      let _request = new Request(url2, {
        method: "POST",
        body: data,
        duplex: "half"
      });
      let contentTypeHeader;
      if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) {
        headers.setContentType(contentTypeHeader);
      }
      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );
        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }
    if (!utils$1.isString(withCredentials)) {
      withCredentials = withCredentials ? "include" : "omit";
    }
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url2, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : void 0
    });
    let response = await fetch(request);
    const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
    if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
      const options = {};
      ["status", "statusText", "headers"].forEach((prop) => {
        options[prop] = response[prop];
      });
      const responseContentLength = utils$1.toFiniteNumber(response.headers.get("content-length"));
      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];
      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }
    responseType = responseType || "text";
    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || "text"](response, config2);
    !isStreamResponse && unsubscribe && unsubscribe();
    return await new Promise((resolve2, reject) => {
      settle(resolve2, reject, {
        data: responseData,
        headers: AxiosHeaders.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config: config2,
        request
      });
    });
  } catch (err) {
    unsubscribe && unsubscribe();
    if (err && err.name === "TypeError" && /fetch/i.test(err.message)) {
      throw Object.assign(
        new AxiosError("Network Error", AxiosError.ERR_NETWORK, config2, request),
        {
          cause: err.cause || err
        }
      );
    }
    throw AxiosError.from(err, err && err.code, config2, request);
  }
});
const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};
utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, "name", { value });
    } catch (e) {
    }
    Object.defineProperty(fn, "adapterName", { value });
  }
});
const renderReason = (reason) => `- ${reason}`;
const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;
const adapters = {
  getAdapter: (adapters2) => {
    adapters2 = utils$1.isArray(adapters2) ? adapters2 : [adapters2];
    const { length } = adapters2;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters2[i];
      let id2;
      adapter = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id2 = String(nameOrAdapter)).toLowerCase()];
        if (adapter === void 0) {
          throw new AxiosError(`Unknown adapter '${id2}'`);
        }
      }
      if (adapter) {
        break;
      }
      rejectedReasons[id2 || "#" + i] = adapter;
    }
    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(
        ([id2, state]) => `adapter ${id2} ` + (state === false ? "is not supported by the environment" : "is not available in the build")
      );
      let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
      throw new AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return adapter;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(config2) {
  if (config2.cancelToken) {
    config2.cancelToken.throwIfRequested();
  }
  if (config2.signal && config2.signal.aborted) {
    throw new CanceledError(null, config2);
  }
}
function dispatchRequest(config2) {
  throwIfCancellationRequested(config2);
  config2.headers = AxiosHeaders.from(config2.headers);
  config2.data = transformData.call(
    config2,
    config2.transformRequest
  );
  if (["post", "put", "patch"].indexOf(config2.method) !== -1) {
    config2.headers.setContentType("application/x-www-form-urlencoded", false);
  }
  const adapter = adapters.getAdapter(config2.adapter || defaults.adapter);
  return adapter(config2).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config2);
    response.data = transformData.call(
      config2,
      config2.transformResponse,
      response
    );
    response.headers = AxiosHeaders.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config2);
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config2,
          config2.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders.from(reason.response.headers);
      }
    }
    return Promise.reject(reason);
  });
}
const VERSION$1 = "1.8.1";
const validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((type, i) => {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return (value, opt, opts) => {
    if (validator2 === false) {
      throw new AxiosError(
        formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")),
        AxiosError.ERR_DEPRECATED
      );
    }
    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version2 + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
validators$1.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator2 = schema[opt];
    if (validator2) {
      const value = options[opt];
      const result2 = value === void 0 || validator2(value, opt, options);
      if (result2 !== true) {
        throw new AxiosError("option " + opt + " must be " + result2, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError("Unknown option " + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}
const validator = {
  assertOptions,
  validators: validators$1
};
const validators = validator.validators;
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config2) {
    try {
      return await this._request(configOrUrl, config2);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};
        Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
        try {
          if (!err.stack) {
            err.stack = stack;
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) {
            err.stack += "\n" + stack;
          }
        } catch (e) {
        }
      }
      throw err;
    }
  }
  _request(configOrUrl, config2) {
    if (typeof configOrUrl === "string") {
      config2 = config2 || {};
      config2.url = configOrUrl;
    } else {
      config2 = configOrUrl || {};
    }
    config2 = mergeConfig(this.defaults, config2);
    const { transitional: transitional2, paramsSerializer, headers } = config2;
    if (transitional2 !== void 0) {
      validator.assertOptions(transitional2, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }
    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config2.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }
    if (config2.allowAbsoluteUrls !== void 0) ;
    else if (this.defaults.allowAbsoluteUrls !== void 0) {
      config2.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
    } else {
      config2.allowAbsoluteUrls = true;
    }
    validator.assertOptions(config2, {
      baseUrl: validators.spelling("baseURL"),
      withXsrfToken: validators.spelling("withXSRFToken")
    }, true);
    config2.method = (config2.method || this.defaults.method || "get").toLowerCase();
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config2.method]
    );
    headers && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (method) => {
        delete headers[method];
      }
    );
    config2.headers = AxiosHeaders.concat(contextHeaders, headers);
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config2) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i = 0;
    let len;
    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), void 0];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;
      promise = Promise.resolve(config2);
      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }
      return promise;
    }
    len = requestInterceptorChain.length;
    let newConfig = config2;
    i = 0;
    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }
    i = 0;
    len = responseInterceptorChain.length;
    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }
    return promise;
  }
  getUri(config2) {
    config2 = mergeConfig(this.defaults, config2);
    const fullPath = buildFullPath(config2.baseURL, config2.url, config2.allowAbsoluteUrls);
    return buildURL(fullPath, config2.params, config2.paramsSerializer);
  }
}
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
  Axios.prototype[method] = function(url2, config2) {
    return this.request(mergeConfig(config2 || {}, {
      method,
      url: url2,
      data: (config2 || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url2, data, config2) {
      return this.request(mergeConfig(config2 || {}, {
        method,
        headers: isForm ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: url2,
        data
      }));
    };
  }
  Axios.prototype[method] = generateHTTPMethod();
  Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
class CancelToken {
  constructor(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve2) {
      resolvePromise = resolve2;
    });
    const token = this;
    this.promise.then((cancel) => {
      if (!token._listeners) return;
      let i = token._listeners.length;
      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });
    this.promise.then = (onfulfilled) => {
      let _resolve;
      const promise = new Promise((resolve2) => {
        token.subscribe(resolve2);
        _resolve = resolve2;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message, config2, request) {
      if (token.reason) {
        return;
      }
      token.reason = new CanceledError(message, config2, request);
      resolvePromise(token.reason);
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index2 = this._listeners.indexOf(listener);
    if (index2 !== -1) {
      this._listeners.splice(index2, 1);
    }
  }
  toAbortSignal() {
    const controller = new AbortController();
    const abort = (err) => {
      controller.abort(err);
    };
    this.subscribe(abort);
    controller.signal.unsubscribe = () => this.unsubscribe(abort);
    return controller.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}
function spread(callback) {
  return function wrap2(arr) {
    return callback.apply(null, arr);
  };
}
function isAxiosError(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
}
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});
function createInstance$1(defaultConfig) {
  const context = new Axios(defaultConfig);
  const instance = bind(Axios.prototype.request, context);
  utils$1.extend(instance, Axios.prototype, context, { allOwnKeys: true });
  utils$1.extend(instance, context, null, { allOwnKeys: true });
  instance.create = function create(instanceConfig) {
    return createInstance$1(mergeConfig(defaultConfig, instanceConfig));
  };
  return instance;
}
const axios = createInstance$1(defaults);
axios.Axios = Axios;
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION$1;
axios.toFormData = toFormData;
axios.AxiosError = AxiosError;
axios.Cancel = axios.CanceledError;
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread;
axios.isAxiosError = isAxiosError;
axios.mergeConfig = mergeConfig;
axios.AxiosHeaders = AxiosHeaders;
axios.formToJSON = (thing) => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode;
axios.default = axios;
class Service {
  constructor() {
    const service = axios.create({
      withCredentials: true
    });
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
  }
  handleSuccess(response) {
    return response;
  }
  handleError(error) {
    switch (error.response.status) {
      case 401:
        console.error(error.response.status);
        break;
      case 404:
        console.error(error.response.status);
        break;
      default:
        console.error(error.response.status);
        break;
    }
    return Promise.reject(error);
  }
  get(path) {
    return this.service.get(path).then((response) => response.data);
  }
  patch(path, payload) {
    return this.service.request({
      method: "PATCH",
      url: path,
      responseType: "json",
      data: payload
    }).then((response) => response.data);
  }
  post(path, payload) {
    return this.service.request({
      method: "POST",
      url: path,
      responseType: "json",
      data: payload
    }).then((response) => response.data);
  }
}
const Service$1 = new Service();
function getAccountSummary$1() {
  return function(dispatch) {
    dispatch(getAccountSummaryPending());
    return Service$1.get(`${""}/participant-web-services/rest/accounts/summary`).then((summary) => {
      dispatch(getAccountSummarySuccess(summary));
    }).catch((error) => {
      console.log("Error: ", error);
      dispatch(getAccountSummaryFailed({ data: void 0, error: "SERVER_ERROR" }));
    });
  };
}
function getAccountSummaryPending() {
  return {
    type: actionType.ACCOUNT_SUMMARY_PENDING
  };
}
function getAccountSummaryFailed(error) {
  return {
    type: actionType.ACCOUNT_SUMMARY_FAILURE,
    payload: error
  };
}
function getAccountSummarySuccess(summary) {
  return {
    type: actionType.ACCOUNT_SUMMARY_SUCCESS,
    payload: summary
  };
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React__default, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a) m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React2 = React__default;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format2) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format2, args);
          }
        }
      }
      function printWarning(level, format2, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format2 += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format2);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign2 = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign2({}, props, {
                value: prevLog
              }),
              info: assign2({}, props, {
                value: prevInfo
              }),
              warn: assign2({}, props, {
                value: prevWarn
              }),
              error: assign2({}, props, {
                value: prevError
              }),
              group: assign2({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign2({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign2({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name2, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }
          return "\n" + prefix + name2;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;
                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }
                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name2 = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name2 ? describeBuiltInComponentFrame(name2) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype2 = Component.prototype;
        return !!(prototype2 && prototype2.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty2 = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values2, location2, componentName, element) {
        {
          var has2 = Function.call.bind(hasOwnProperty2);
          for (var typeSpecName in typeSpecs) {
            if (has2(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location2, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location2, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location2, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray2(a) {
        return isArrayImpl(a);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      function hasValidRef(config2) {
        {
          if (hasOwnProperty2.call(config2, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config2, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config2.ref !== void 0;
      }
      function hasValidKey(config2) {
        {
          if (hasOwnProperty2.call(config2, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config2.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config2, self2) {
        {
          if (typeof config2.ref === "string" && ReactCurrentOwner.current && self2) ;
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self2, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self2
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config2, maybeKey, source, self2) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config2)) {
            {
              checkKeyStringCoercion(config2.key);
            }
            key = "" + config2.key;
          }
          if (hasValidRef(config2)) {
            ref = config2.ref;
            warnIfStringRefCannotBeAutoConverted(config2, self2);
          }
          for (propName in config2) {
            if (hasOwnProperty2.call(config2, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config2[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self2, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name2 = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name2) {
              return "\n\nCheck the render method of `" + name2 + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }
          if (isArray2(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator2 = iteratorFn.call(node);
                var step;
                while (!(step = iterator2.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes2;
          if (typeof type === "function") {
            propTypes2 = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes2 = type.propTypes;
          } else {
            return;
          }
          if (propTypes2) {
            var name2 = getComponentNameFromType(type);
            checkPropTypes(propTypes2, element.props, "prop", name2, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      var didWarnAboutKeySpread = {};
      function jsxWithValidation(type, props, key, isStaticChildren, source, self2) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum();
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray2(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self2);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray2(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          {
            if (hasOwnProperty2.call(props, "key")) {
              var componentName = getComponentNameFromType(type);
              var keys = Object.keys(props).filter(function(k) {
                return k !== "key";
              });
              var beforeExample = keys.length > 0 ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
              if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? "{" + keys.join(": ..., ") + ": ...}" : "{}";
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx = jsxWithValidationDynamic;
      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
const ObjectUtil = {
  /**
   *
   * @function isUndefined
   * @memberOf common.util.ObjectUtil
   * @static
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is `undefined`, else `false`.
   * @description Checks if `value` is `undefined`.
   * @example
   *
   * ObjectUtil.isUndefined(void 0);
   * // => true
   *
   */
  isUndefined: function(value) {
    return value === void 0;
  },
  /**
   *
   * @function isDefined
   * @memberOf common.util.ObjectUtil
   * @static
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is defined or not `undefined`, else `false`.
   * @description Checks if `value` is defined or not `undefined`.
   * @example
   *
   * ObjectUtil.isDefined(void 0);
   * // => false
   *
   */
  isDefined: function(value) {
    return !ObjectUtil.isUndefined(value);
  },
  /**
   *
   * @function isNull
   * @memberOf common.util.ObjectUtil
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is `null`, else `false`.
   * @static
   * @description Checks if `value` is `null`.
   * @example
   *
   * ObjectUtil.isNull(null);
   * // => true
   *
   * ObjectUtil.isNull(undefined);
   * // => false
   *
   */
  isNull: function(value) {
    return value === null;
  },
  /**
   *
   * @function isUndefinedOrNull
   * @memberOf common.util.ObjectUtil
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is `undefined` or 'null', else `false`.
   * @static
   * @description Checks if `value` is `undefined` or is `null`.
   * @example
   *
   * ObjectUtil.isUndefinedOrNull(void 0);
   * // => true
   *
   * ObjectUtil.isUndefinedOrNull(null);
   * // => true
   *
   * ObjectUtil.isUndefinedOrNull(undefined);
   * // => true
   *
   * ObjectUtil.isUndefinedOrNull(5);
   * // => false
   *
   */
  isUndefinedOrNull: function(value) {
    return ObjectUtil.isUndefined(value) || ObjectUtil.isNull(value);
  },
  /**
   *
   * @function isArray
   * @memberOf common.util.ObjectUtil
   * @param {*} value
   * @description Checks to see if 'value' is an array
   * Will not work in IE; use lodash _.isArray instead
   */
  /* isArray: function (value) {
      return Array.isArray(value);
  }, */
  /**
   *
   * @function isArrayEmpty
   * @memberOf common.util.ObjectUtil
   * @param {*} value The value to check.
   * @static
   * @returns {boolean} Returns `true` if the `value` has a length property less than or equal to zero, else `false`.
   * @description Checks if `value` is `null` or is `undefined` or is an array with no items.
   * @example
   *
   * ObjectUtil.isArrayEmpty(null);
   * // => true
   *
   * ObjectUtil.isArrayEmpty([]);
   * // => true
   *
   * ObjectUtil.isArrayEmpty([1, 2, 3]);
   * // => false
   *
   */
  isArrayEmpty: function(value) {
    if (!value) {
      return true;
    } else {
      return ObjectUtil.isDefined(value.length) && value.length <= 0;
    }
  },
  /**
   *
   * @function getPropertyByString
   * @memberOf common.util.ObjectUtil
   * @param {Object} object The source object containing the requested property.
   * @param {String|Array} property The property being requested.
   * @static
   * @description returns a property from a given object. If no property is given, the object is returned.
   * If no object is provided, it returns null.
   * @example
   * Allows for object property look up by a string with dot notation in it; for example, take object:
   *
   * var obj = { a: { b: "1", c: "2" } };
   *
   * If you want to access property "a.b" in obj you can use:
   *
   * var ab = getPropertyByString(obj, "a.b")
   *
   * or
   *
   * var ab = getPropertyByString(obj, "[a][b]");
   *
   * @returns {*} A reference to the property in the object.
   *
   */
  getPropertyByString: function(object, property) {
    if (ObjectUtil.isUndefinedOrNull(object) || ObjectUtil.isUndefinedOrNull(property) || property === "") {
      return null;
    }
    function usingArrayNotation(o, ref, i) {
      return !ref ? o : o[ref.slice(0, i ? -1 : ref.length)];
    }
    function usingDotNotation(o, ref) {
      return ref.split("[").reduce(usingArrayNotation, o);
    }
    return !property ? object : property.split(".").reduce(usingDotNotation, object);
  },
  /**
   *
   * @function isPropertyDefined
   * @memberOf common.util.ObjectUtil
   * @param {Object} obj the object to inspect
   * @param {String} prop the property to check for in dot.path notation
   * @static
   * @description returns a property from a given object. If no property is given, the object is returned.
   * @returns {*|boolean}
   *
   */
  isPropertyDefined: function(obj, prop) {
    return ObjectUtil.isDefined(ObjectUtil.getPropertyByString(obj, prop));
  },
  /**
   *
   * @function defaultIfUndefined
   * @memberOf common.util.ObjectUtil
   * @param {Object} obj the object to use
   * @param {String} propPath the property to check for in dot.path notation
   * @param {String} defValue the value to use in case obj.propPath is unavailable
   * @static
   * @description returns a default value, found at obj.propPath if available and from defValue if not.
   * @returns {*}
   *
   */
  defaultIfUndefined: function(obj, propPath, defValue) {
    if (ObjectUtil.isUndefined(obj)) {
      return defValue;
    }
    const p = ObjectUtil.getPropertyByString(obj, propPath);
    if (ObjectUtil.isDefined(p)) {
      return p;
    } else {
      return defValue;
    }
  },
  /**
   *
   * @function isBoolean
   * @memberOf common.util.ObjectUtil
   * @param {*} val the value to inspect
   * @static
   * @description determines if a given val is a boolean from if it is defined and either true or false.
   * @returns {boolean}
   *
   */
  isBoolean: function(val) {
    return ObjectUtil.isDefined(val) && (val === true || val === false);
  },
  /**
   *
   * @param val
   * @returns {*|boolean}
   */
  isString: function(val) {
    return typeof val === "string" || val instanceof String;
  },
  /**
   *
   * @function isEmptyString
   * @memberOf common.util.ObjectUtil
   * @param {*} val the value to inspect
   * @static
   * @description determines if a given val is an empty string.
   * @returns {boolean}
   *
   */
  isEmptyString: function(val) {
    return val === "";
  },
  /**
   *
   * @function isObject
   * @memberOf common.util.ObjectUtil
   * @param {*} val the value to inspect
   * @static
   * @description determines if a given val is an object.
   * @returns {boolean}
   *
   */
  isObject: function(val) {
    return val !== null && typeof val === "object";
  },
  /**
   *
   * @function isEmptyObject
   * @memberOf common.util.ObjectUtil
   * @param {*} val the value to inspect
   * @static
   * @description determines if a given val is an empty object.
   * @returns {boolean}
   *
   */
  isEmptyObject: function(val) {
    if (ObjectUtil.isDefined(val) && ObjectUtil.isObject(val)) {
      const isEmpty2 = function(obj) {
        for (const prop in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            return false;
          }
        }
        return true;
      };
      return isEmpty2(val);
    } else {
      return true;
    }
  },
  /**
   *
   * @function hasValue
   * @memberOf common.util.ObjectUtil
   * @param {*} val the value to inspect
   * @static
   * @description determines if a given val has a value.
   * @returns {boolean}
   *
   */
  hasValue: function(val) {
    const defined = ObjectUtil.isDefined(val);
    const notNull = !ObjectUtil.isNull(val);
    const notBlank = !ObjectUtil.isEmptyString(val);
    const notEmpty2 = ObjectUtil.isObject(val) ? !ObjectUtil.isEmptyObject(val) : true;
    return defined && notNull && notBlank && notEmpty2;
  },
  /**
   *
   * @function isYes
   * @memberOf common.util.ObjectUtil
   * @param {*} value The value to check.
   * @description Checks if `value` is `yes`.
   * @static
   * @returns {boolean} Returns `true` if the `value` is `yes`, else `false`.
   * @example
   *
   * ObjectUtil.isYes("yes");
   * // => true
   *
   */
  isYes: function(value) {
    return value.toLowerCase() === "yes";
  },
  /**
   *
   * @function isNo
   * @memberOf common.util.ObjectUtil
   * @param {*} value The value to check.
   * @description Checks if `value` is `no`.
   * @static
   * @returns {boolean} Returns `true` if the `value` is `no`, else `false`.
   * @example
   *
   * ObjectUtil.isNo("no");
   * // => true
   *
   */
  isNo: function(value) {
    return value.toLowerCase() === "no";
  },
  /**
   * Returns boolean given "N", "n", "Y", or "y"
   * @param ind
   */
  getBooleanFromIndicator: function(ind, defaultVal) {
    if (ind) {
      switch (ind) {
        case "N":
          return false;
        case "n":
          return false;
        case "Y":
          return true;
        case "y":
          return true;
        default:
          return Boolean(defaultVal);
      }
    }
    return false;
  },
  /**
   *
   * @function isDate
   * @memberOf common.util.ObjectUtil
   * @param {*} value The value to check.
   * @description Checks if `value` is a date object.
   * @static
   * @returns {boolean} Returns `true` if the `value` is an instanceof Date.
   *
   */
  isDate: function(value) {
    return value instanceof Date && !isNaN(value.valueOf());
  },
  /**
   *
   * @function formatDate
   * @memberOf common.util.ObjectUtil
   * @param {date} dateString The date to format.
   * @description Checks for and translates dates with 3-letter month names to mm/dd/yyyy.
   * @returns {string} returns a date formatted as mm/dd/yyyy.
   *
   */
  formatDate: function(dateString) {
    if (dateString && ObjectUtil.isString(dateString) && dateString.match(/^\d{1,2}-[A-z]{3}-\d{4}$/)) {
      const splitDate = dateString.split("-");
      const day = splitDate[0];
      const month = splitDate[1];
      const year = splitDate[2];
      let monthNumber = 1;
      switch (String(month).toLowerCase()) {
        case "feb":
          monthNumber = 2;
          break;
        case "mar":
          monthNumber = 3;
          break;
        case "apr":
          monthNumber = 4;
          break;
        case "may":
          monthNumber = 5;
          break;
        case "jun":
          monthNumber = 6;
          break;
        case "jul":
          monthNumber = 7;
          break;
        case "aug":
          monthNumber = 8;
          break;
        case "sep":
          monthNumber = 9;
          break;
        case "oct":
          monthNumber = 10;
          break;
        case "nov":
          monthNumber = 11;
          break;
        case "dec":
          monthNumber = 12;
          break;
        default:
          monthNumber = 1;
      }
      dateString = "" + monthNumber + "/" + day + "/" + year;
      return dateString;
    } else {
      return dateString;
    }
  },
  /**
   *
   * @function formatTimestamp
   * @memberOf common.util.ObjectUtil
   * @param {datetime} timestamp
   * @description formats date object as mm/dd/yyyy.
   * @returns {string} Returns 'mm/dd/yyyy'
   * @example
   *
   * ObjectUtil.isYes("yes");
   * // => true
   *
   */
  formatTimestamp: function(timestamp) {
    if (!ObjectUtil.isUndefinedOrNull(timestamp)) {
      const dateObject = new Date(timestamp);
      return dateObject.getMonth() + 1 + "/" + dateObject.getDate() + "/" + dateObject.getFullYear();
    }
  },
  /**
   *
   * @function cleanDateString
   * @memberOf common.util.ObjectUtil
   * @param {string} dateString
   * @description removes leaning zeroes from months and days of dates in the format of mm/dd/year
   * @returns {string} Returns 'mm/dd/yyyy' with zeros being stripped
   * @example '05/07/2015' becomes '5/7/2015'
   *
   */
  cleanDateString: function(dateString) {
    if (!ObjectUtil.isUndefinedOrNull(dateString) && dateString.length > 0) {
      let firstChar = dateString.substr(0, 1);
      if (firstChar === "0") {
        dateString = dateString.substr(1);
      }
      const arr = dateString.split("/");
      if (arr.length < 3) {
        return null;
      }
      firstChar = arr[1].substr(0, 1);
      if (firstChar === "0") {
        arr[1] = arr[1].substr(1);
      }
      return arr[0] + "/" + arr[1] + "/" + arr[2];
    } else {
      return null;
    }
  },
  /**
   * @memberOf common.service.business.RetirementSavingsService
   * @description Rounds value down to deferral slider step
   * @param value
   * @returns {number|*}
   */
  roundDownValueToStep: function(value, step) {
    value = Math.floor(value / step) * step;
    return value;
  },
  /**
   * @memberOf common.service.business.RetirementSavingsService
   * @description Rounds value up to deferral slider step
   * @param value
   * @returns {number}
   */
  roundUpValueToStep: function(value, step) {
    return Math.ceil(value / step) * step;
  },
  /**
   * @memberOf common.util
   * @description Returns a number with X digits after the decimal place
   * @param value
   * @param digits
   * @returns {number}
   */
  fixedPointNotationNumber: function(value, digits) {
    const num = value.toFixed(digits);
    return Number.parseFloat(num);
  },
  /**
   * @memberOf common.util
   * @description Returns a a boolean representing if the user is on a mobile device
   * @returns {boolean}
   */
  detectMobile: function() {
    return !!(navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i));
  },
  /**
   * @memberOf common.util
   * @description Returns the value inside the obj for the given path.
   * @param {Object} obj object that will be searched for the path
   * @param {string} path dot notation string like obj.information.first
   * @returns {*}
   */
  resolve: function(obj, path) {
    return path.split(".").reduce(function(prev, curr) {
      return prev ? prev[curr] : null;
    }, obj || self);
  },
  /**
   *
   * @namespace errors
   * @memberOf common.util.ObjectUtil
   * @property {string} UNDEFINED_OR_NULL
   * @property {string} UNDEFINED
   * @property {string} IS_EMPTY
   *
   */
  errors: {
    UNDEFINED_OR_NULL: "{0} is undefined or null",
    UNDEFINED: "{0} is undefined",
    IS_EMPTY: "{0} is empty or blank"
  }
};
const ToolTip = ({ text, placement, children }) => {
  const tt = /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { id: "modal-tooltip", children: text });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(OverlayTrigger, { overlay: tt, placement, children });
};
const MonthlyPlanList = (props) => {
  const account2 = props.account;
  const accountList = props.accountList;
  const detailPageUrl = account2.fullUrl;
  const dbPlanBalanceDisclosureTooltip = props.dbPlanBalanceDisclosureTooltip;
  const trsAccountsAnnuityDisclaimerTooltip = props.trsAccountsAnnuityDisclaimerTooltip;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: detailPageUrl, className: "account-name", children: account2.name }),
    account2.definedBenefit && account2.planType !== "TRS-monthly" && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      !account2.definedBenefit.accruedBenefitAmount && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "n/a" }),
      account2.definedBenefit.accruedBenefitAmount && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ToolTip, { text: dbPlanBalanceDisclosureTooltip, placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "currency-plan", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          NumericFormat,
          {
            value: account2.definedBenefit.accruedBenefitAmount,
            fixedDecimalScale: true,
            decimalScale: 2,
            displayType: "text",
            thousandSeparator: true
          }
        ) }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          PlanFrequency,
          {
            frequency: account2.definedBenefit.accruedBenefitFreq,
            addClassName: false
          }
        )
      ] })
    ] }),
    account2.definedBenefit && account2.planType === "TRS-monthly" && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      !account2.definedBenefit.acccruedBenefitAmount && account2.definedBenefit.vendorPptStatusCode !== "PAY" && /* @__PURE__ */ jsxRuntimeExports.jsx(PlanFrequency, { addClassName: true }),
      !account2.definedBenefit.acccruedBenefitAmount && account2.definedBenefit.vendorPptStatusCode === "PAY" && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "currency-plan", children: accountList.inPayStatus }),
      account2.definedBenefit.acccruedBenefitAmount && /* @__PURE__ */ jsxRuntimeExports.jsxs(ToolTip, { text: trsAccountsAnnuityDisclaimerTooltip, placement: "bottom", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "currency-plan", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          NumericFormat,
          {
            value: account2.definedBenefit.acccruedBenefitAmount,
            fixedDecimalScale: true,
            decimalScale: 2,
            displayType: "text",
            thousandSeparator: true
          }
        ) }),
        account2.definedBenefit.accruedBenefitFreq === "M" || account2.planType === "TRS-monthly" && /* @__PURE__ */ jsxRuntimeExports.jsx(
          PlanFrequency,
          {
            frequency: account2.definedBenefit.accruedBenefitFreq,
            addClassName: true
          }
        ),
        account2.definedBenefit.accruedBenefitFreq === "Q" || account2.definedBenefit.accruedBenefitFreq === "A"(
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            PlanFrequency,
            {
              frequency: account2.definedBenefit.accruedBenefitFreq,
              addClassName: true
            }
          )
        )
      ] })
    ] }),
    !account2.definedBenefit && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "n/a" })
  ] });
};
const PlanFrequency = (props) => {
  props.frequency;
  props.addClassName ? "currency-plan" : "";
};
const PlanList = (props) => {
  const accountUrl = location.origin + "/" + props.plan.accountURL;
  const enrollNow = accountUrl.indexOf("participant/enroll/") > -1;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: "account-name", href: accountUrl, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: props.plan.name }) }),
    enrollNow == true ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-left", children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: "account-name", href: accountUrl, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        type: "button",
        name: "enrollMsg",
        className: "btn btn-primary enroll-now-btn",
        id: "enrollMsg",
        value: "Enroll Now"
      }
    ) }) }) : null,
    props.showEnrollmentLink === true ? /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: "info-link", href: props.enrollmentUrlBase + props.plan.groupId, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "info-link-text", children: "Enrollment now open" }) }) : null,
    enrollNow == false ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "currency-plan", children: [
      typeof props.plan.totalBalance !== "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx("sup", { children: "$" }) : "",
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        NumericFormat,
        {
          value: props.plan.totalBalance,
          displayType: "text",
          thousandSeparator: true,
          decimalSeparator: ".",
          decimalScale: 2,
          fixedDecimalScale: true
        }
      )
    ] }) }) }) : null
  ] });
};
class AccountSummary extends React__default.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      nonQualAccountDataFetched: false,
      nonQualAccountEligibilityMap: {}
    };
    let enrollmentUrlBase = location.protocol + "//" + location.hostname;
    if (location.port !== "") {
      enrollmentUrlBase += ":" + location.port;
    }
    enrollmentUrlBase += "/participant/accounts/#/enrollment-summary/";
    this.enrollmentUrlBase = enrollmentUrlBase;
  }
  componentDidUpdate(nextProp) {
    if (!this.state.nonQualAccountDataFetched && nextProp.accountSummaryData.nonMonthlyAccounts) {
      nextProp.accountSummaryData.nonMonthlyAccounts.map((account2) => {
        if (ObjectUtil.isUndefinedOrNull(account2.pcapAccountId)) {
          axios.get(
            "/participant-web-services/rest/nonqual/isParticipantEnrollmentEligible/" + account2.groupId,
            {
              // `withCredentials` indicates whether or not cross-site Access-Control requests should be made using credentials
              // don't change this!!!
              withCredentials: true
            }
          ).then((res) => {
            if (res.data.nonQualEnrollmentEligibility && typeof res.data.nonQualEnrollmentEligibility.participantEnrollmentEligible !== "undefined") {
              const obj = {};
              obj[account2.groupId] = res.data.nonQualEnrollmentEligibility.participantEnrollmentEligible;
              const map2 = Object.assign(
                obj,
                this.state.nonQualAccountEligibilityMap
              );
              this.setState({
                nonQualAccountEligibilityMap: map2
              });
            }
          }).catch((error) => {
            console.log("Error: ", error);
          });
        }
      });
      this.setState({
        nonQualAccountDataFetched: true
      });
    }
  }
  componentDidMount() {
    this.props.getAccountSummary();
  }
  render() {
    const {
      accountSummaryData,
      accountSummaryLoaded,
      totalBalanceTooltip,
      dbPlanBalanceDisclosureTooltip,
      trsAccountsAnnuityDisclaimerTooltip
    } = this.props;
    let plans;
    let newTotalBalanceTooltip = totalBalanceTooltip;
    if (accountSummaryLoaded) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: " Loading ... " });
    }
    if (accountSummaryData.error === void 0) {
      const map2 = this.state.nonQualAccountEligibilityMap;
      plans = accountSummaryData.nonMonthlyAccounts.map((plan) => {
        plan.totalBalance = plan.totalBalance !== null ? plan.totalBalance : "Not Available";
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          PlanList,
          {
            plan,
            showEnrollmentLink: map2[plan.groupId],
            enrollmentUrlBase: this.enrollmentUrlBase
          },
          plan.groupId
        );
      });
      if (accountSummaryData.monthlyAccounts !== null) {
        accountSummaryData.monthlyAccounts.map((plan) => {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            MonthlyPlanList,
            {
              account: plan,
              dbPlanBalanceDisclosureTooltip,
              trsAccountsAnnuityDisclaimerTooltip
            },
            plan.groupId
          );
        });
      }
    }
    if (accountSummaryData.error === void 0) {
      newTotalBalanceTooltip = "The total balance is the entire value of your plan account (vested and non-vested). Select a plan and click on “Balance details” for additional balance information.";
      return /* @__PURE__ */ jsxRuntimeExports.jsx("section", { className: "pod my-account-pod", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "account-container", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "visible-xs", children: "Balance" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "total-balance", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "currency currency-total", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("sup", { children: "$" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ToolTip, { text: newTotalBalanceTooltip, placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            NumericFormat,
            {
              value: accountSummaryData.totalBalance,
              fixedDecimalScale: true,
              decimalScale: 2,
              displayType: "text",
              thousandSeparator: true
            }
          ) })
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "total-balance-date", children: /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Total account balance " }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "myAccountList", children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "account-list list-unstyled", children: plans }) })
      ] }) });
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx("section", { className: "pod my-account-pod", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "account-container", children: accountSummaryData.error }) });
    }
  }
}
const mapStateToProps$2 = (state, ownProps) => {
  return {
    accountSummaryData: state.accountOverview.summary,
    accountSummaryLoaded: state.accountOverview.loading,
    totalBalanceTooltip: ownProps.totalBalanceTooltip,
    dbPlanBalanceDisclosureTooltip: ownProps.dbPlanBalanceDisclosureTooltip,
    trsAccountsAnnuityDisclaimerTooltip: ownProps.trsAccountsAnnuityDisclaimerTooltip
  };
};
const mapDispatchToProps$2 = (dispatch) => {
  return bindActionCreators(
    {
      getAccountSummary: getAccountSummary$1
    },
    dispatch
  );
};
const AccountSummaryComponent = connect(mapStateToProps$2, mapDispatchToProps$2)(AccountSummary);
const AccountSummaryProviderComponent = function(props) {
  return React__default.createElement(
    Provider,
    { store },
    React__default.createElement(AccountSummaryComponent, {
      totalBalanceTooltip: props.totalBalanceTooltip,
      dbPlanBalanceDisclosureTooltip: props.dbPlanBalanceDisclosureTooltip,
      trsAccountsAnnuityDisclaimerTooltip: props.trsAccountsAnnuityDisclaimerTooltip
    })
  );
};
const StringUtil = function() {
  const INVALID_DATA = "Undefined template provided";
  const supplant = function(template, values2, pattern = null) {
    if (!template) {
      throw new Error(INVALID_DATA);
    }
    pattern = pattern || /\{([^\{\}]*)\}/g;
    return template.replace(pattern, function(a, b) {
      let p = b.split("."), r = values2;
      try {
        for (let s = 0; s < p.length; s++) {
          r = r[p[s]];
        }
      } catch (e) {
        r = a;
      }
      return typeof r === "string" || typeof r === "number" ? r : typeof r;
    });
  };
  return {
    supplant
  };
};
const StringUtil$1 = StringUtil();
const URLUtil = function() {
  const getURLParam = function(key) {
    const urlParams = getParams();
    if (urlParams) {
      return getParamValue(urlParams, key);
    }
    return null;
  };
  var getParams = function() {
    let queryString = "";
    if (window.location.search !== "") {
      queryString = window.location.search.substring(1);
    } else {
      queryString = window.location.hash.substring(window.location.hash.indexOf("?") + 1);
    }
    if (queryString.length > 0) {
      return queryString;
    }
    return false;
  };
  var getParamValue = function(params, key) {
    if (params && key) {
      const paramArray = params.split("&");
      for (let i = 0; i < paramArray.length; i++) {
        const param = paramArray[i].split("=");
        if (param[0] === key) {
          return param[1];
        }
      }
    }
    return null;
  };
  function getSearchableQueries(url2) {
    let search, queries, queryStart, queryEnd, queryString, split;
    search = {};
    queryStart = url2.indexOf("?");
    if (queryStart !== -1) {
      queryString = url2.substring(queryStart + 1);
      queryEnd = queryString.indexOf("#");
      if (queryEnd !== -1) {
        queryString = queryString.substring(0, queryEnd);
      }
      queries = queryString.split("&");
      for (let i = 0, n = queries.length; i < n; i++) {
        split = queries[i].split("=");
        search[split[0]] = split[1];
      }
    }
    return search;
  }
  const IURLUtils = {
    getURLParam,
    getAllUrlParams: getParams,
    getSearchableQueries
  };
  return IURLUtils;
};
const UrlUtil = URLUtil();
const LogEnhancer = function($log) {
  let INVALID_DATA;
  const context = "[JS]";
  const separator = " - ";
  let localLogLevel;
  let globalLogLevel;
  const _$log = function($log2) {
    return {
      log: $log2.log,
      debug: $log2.debug,
      info: $log2.info,
      warn: $log2.warn,
      error: $log2.error
    };
  }($log);
  const loggerLevel = {
    /**
     * @property {String} LEVEL_LOG A constant. Indicates the "all" logging level.
     * @static
     */
    LEVEL_ALL: 0,
    // Its not required here since we are logging globalLevel >= localLoglevel
    /**
     * @property {String} LEVEL_LOG A constant. Indicates the "log" logging level.
     * @static
     */
    LEVEL_LOG: 2,
    /**
     * @property {String} LEVEL_DEBUG A constant. Indicates the "debug" logging level.
     * @static
     */
    LEVEL_DEBUG: 4,
    /**
     * @property {String} LEVEL_INFO A constant. Indicates the "info" logging level.
     * @static
     */
    LEVEL_INFO: 6,
    /**
     * @property {String} LEVEL_WARN A constant. Indicates the "warn" logging level.
     * @static
     */
    LEVEL_WARN: 8,
    /**
     * @property {String} LEVEL_ERROR A constant. Indicates the "error" logging level.
     * @static
     */
    LEVEL_ERROR: 12
  };
  const levelMarkup = {};
  levelMarkup["" + loggerLevel.LEVEL_INFO] = "[INFO]";
  levelMarkup["" + loggerLevel.LEVEL_DEBUG] = "[DEBUG]";
  levelMarkup["" + loggerLevel.LEVEL_WARN] = "[WARN]";
  levelMarkup["" + loggerLevel.LEVEL_ERROR] = "[ERROR]";
  levelMarkup["" + loggerLevel.LEVEL_LOG] = "[LOG]";
  levelMarkup["" + loggerLevel.LEVEL_ALL] = "[LOG]";
  const colorify = function(message, colorCSS) {
    const canColorize = colorCSS !== void 0;
    return canColorize ? ["%c" + message, colorCSS] : [message];
  };
  const prepareLogFn = function(logFn, className, colorCSS) {
    const getLogLevel = function(logFn2) {
      switch (logFn2) {
        case _$log.info:
          localLogLevel = loggerLevel.LEVEL_INFO;
          return localLogLevel;
        case _$log.debug:
          localLogLevel = loggerLevel.LEVEL_DEBUG;
          return localLogLevel;
        case _$log.warn:
          localLogLevel = loggerLevel.LEVEL_WARN;
          return localLogLevel;
        case _$log.error:
          localLogLevel = loggerLevel.LEVEL_ERROR;
          return localLogLevel;
        case _$log.log:
          localLogLevel = loggerLevel.LEVEL_LOG;
          return localLogLevel;
        default:
          localLogLevel = loggerLevel.LEVEL_ALL;
          return localLogLevel;
      }
    };
    const enhancedLogFn = function() {
      try {
        let args = Array.prototype.slice.call(arguments), now = getTimestamp(), logLevel = getLogLevel(logFn), level = levelMarkup["" + logLevel], _context = context !== "" ? context + " " : "";
        if (checkLogLevel(logLevel)) {
          if (!className && args[0] instanceof Error) {
            className = String(args[0].stack);
          }
          args[0] = StringUtil$1.supplant("{0}{1} {2} {3}{4}", [
            _context,
            now,
            level,
            className ? className : "",
            args[0]
          ]);
          args = colorify(StringUtil$1.supplant.apply(null, args), colorCSS);
          logFn.apply(null, args);
        }
      } catch (error) {
        $log.error("LogEnhancer ERROR: " + error);
        INVALID_DATA = error;
        throw new Error(INVALID_DATA);
      }
    };
    enhancedLogFn.logs = [];
    return enhancedLogFn;
  };
  var getTimestamp = function() {
    const date = /* @__PURE__ */ new Date();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    let milliseconds = date.getMilliseconds();
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    if (milliseconds < 10) {
      milliseconds = "00" + milliseconds;
    } else if (milliseconds < 100) {
      milliseconds = "0" + milliseconds;
    }
    return hours + ":" + minutes + ":" + seconds + ":" + milliseconds;
  };
  var checkLogLevel = function(logLevel) {
    if (localLogLevel >= globalLogLevel) {
      return true;
    } else if (logLevel >= globalLogLevel) {
      return true;
    }
    return false;
  };
  const getInstance = function(className, colorCSS, customSeparator) {
    className = className !== void 0 ? className + (customSeparator || separator) : "";
    const instance = {
      log: prepareLogFn(_$log.log, className, colorCSS),
      debug: prepareLogFn(_$log.debug, className, colorCSS),
      info: prepareLogFn(_$log.info, className, colorCSS),
      warn: prepareLogFn(_$log.warn, className, colorCSS),
      error: prepareLogFn(_$log.error, className)
      // No styling of ERROR messages
    };
    globalLogLevel = loggerLevel.LEVEL_ERROR;
    if (UrlUtil.getURLParam("debug") === "true") {
      globalLogLevel = loggerLevel.LEVEL_DEBUG;
    }
    return instance;
  };
  $log.log = prepareLogFn($log.log);
  $log.info = prepareLogFn($log.info);
  $log.warn = prepareLogFn($log.warn);
  $log.debug = prepareLogFn($log.debug);
  $log.error = prepareLogFn($log.error);
  $log.getInstance = getInstance;
  $log._$log = _$log;
  $log.colorify = colorify;
  $log.prepareLogFn = prepareLogFn;
  $log.INVALID_DATA = INVALID_DATA;
  $log.context = context;
  return $log;
};
LogEnhancer.$inject = ["$log"];
const ExternalLogger = function() {
  const prepareLogToConsole = function(method) {
    const console2 = window.console;
    const logFn = function(message) {
      if (isAvailableConsoleFor(method)) {
        try {
          console2[method](message);
        } catch (e) {
          console2.error("Error in console." + method + "():", e);
        }
      }
    };
    return logFn;
  };
  const isFunction2 = function(fn) {
    return typeof fn === typeof Function;
  };
  const isAvailableConsoleFor = function(method) {
    const console2 = window.console;
    if (!method) {
      throw new Error("isAvailableConsoleFor():: Undefined method provided");
    }
    return console2 && console2[method] && isFunction2(console2[method]);
  };
  const $log = {
    log: prepareLogToConsole("log"),
    info: prepareLogToConsole("info"),
    warn: prepareLogToConsole("warn"),
    debug: prepareLogToConsole("debug"),
    error: prepareLogToConsole("error"),
    prepareLogToConsole,
    isFunction: isFunction2,
    isAvailableConsoleFor
  };
  return new LogEnhancer($log);
};
const ExternalLogger$1 = ExternalLogger();
var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$1.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
    t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result2) {
      result2.done ? resolve2(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_2 = 0)), _2) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _2.label++;
          return { value: op[1], done: false };
        case 5:
          _2.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _2.ops.pop();
          _2.trys.pop();
          continue;
        default:
          if (!(t = _2.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _2 = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _2.label = op[1];
            break;
          }
          if (op[0] === 6 && _2.label < t[1]) {
            _2.label = t[1];
            t = op;
            break;
          }
          if (t && _2.label < t[2]) {
            _2.label = t[2];
            _2.ops.push(op);
            break;
          }
          if (t[2]) _2.ops.pop();
          _2.trys.pop();
          continue;
      }
      op = body.call(thisArg, _2);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __values$1(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function() {
      if (o && i >= o.length) o = void 0;
      return { value: o && o[i++], done: !o };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read$1(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to, from2, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from2.length, ar; i < l; i++) {
    if (ar || !(i in from2)) {
      if (!ar) ar = Array.prototype.slice.call(from2, 0, i);
      ar[i] = from2[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from2));
}
function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function awaitReturn(f) {
    return function(v) {
      return Promise.resolve(v).then(f, reject);
    };
  }
  function verb(n, f) {
    if (g[n]) {
      i[n] = function(v) {
        return new Promise(function(a, b) {
          q.push([n, v, a, b]) > 1 || resume(n, v);
        });
      };
      if (f) i[n] = f(i[n]);
    }
  }
  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle2(q[0][3], e);
    }
  }
  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle2(q[0][2], r);
  }
  function fulfill(value) {
    resume("next", value);
  }
  function reject(value) {
    resume("throw", value);
  }
  function settle2(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
}
function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values$1 === "function" ? __values$1(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i);
  function verb(n) {
    i[n] = o[n] && function(v) {
      return new Promise(function(resolve2, reject) {
        v = o[n](v), settle2(resolve2, reject, v.done, v.value);
      });
    };
  }
  function settle2(resolve2, reject, d, v) {
    Promise.resolve(v).then(function(v2) {
      resolve2({ value: v2, done: d });
    }, reject);
  }
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var SUCCESS_MESSAGE = "Event tracked successfully";
var UNEXPECTED_ERROR_MESSAGE$1 = "Unexpected error occurred";
var MAX_RETRIES_EXCEEDED_MESSAGE$1 = "Event rejected due to exceeded retry count";
var OPT_OUT_MESSAGE = "Event skipped due to optOut config";
var MISSING_API_KEY_MESSAGE = "Event rejected due to missing API key";
var INVALID_API_KEY = "Invalid API key";
var CLIENT_NOT_INITIALIZED = "Client not initialized";
var IdentifyOperation;
(function(IdentifyOperation2) {
  IdentifyOperation2["SET"] = "$set";
  IdentifyOperation2["SET_ONCE"] = "$setOnce";
  IdentifyOperation2["ADD"] = "$add";
  IdentifyOperation2["APPEND"] = "$append";
  IdentifyOperation2["PREPEND"] = "$prepend";
  IdentifyOperation2["REMOVE"] = "$remove";
  IdentifyOperation2["PREINSERT"] = "$preInsert";
  IdentifyOperation2["POSTINSERT"] = "$postInsert";
  IdentifyOperation2["UNSET"] = "$unset";
  IdentifyOperation2["CLEAR_ALL"] = "$clearAll";
})(IdentifyOperation || (IdentifyOperation = {}));
var RevenueProperty;
(function(RevenueProperty2) {
  RevenueProperty2["REVENUE_PRODUCT_ID"] = "$productId";
  RevenueProperty2["REVENUE_QUANTITY"] = "$quantity";
  RevenueProperty2["REVENUE_PRICE"] = "$price";
  RevenueProperty2["REVENUE_TYPE"] = "$revenueType";
  RevenueProperty2["REVENUE_CURRENCY"] = "$currency";
  RevenueProperty2["REVENUE"] = "$revenue";
})(RevenueProperty || (RevenueProperty = {}));
var SpecialEventType;
(function(SpecialEventType2) {
  SpecialEventType2["IDENTIFY"] = "$identify";
  SpecialEventType2["GROUP_IDENTIFY"] = "$groupidentify";
  SpecialEventType2["REVENUE"] = "revenue_amount";
})(SpecialEventType || (SpecialEventType = {}));
var LogLevel;
(function(LogLevel2) {
  LogLevel2[LogLevel2["None"] = 0] = "None";
  LogLevel2[LogLevel2["Error"] = 1] = "Error";
  LogLevel2[LogLevel2["Warn"] = 2] = "Warn";
  LogLevel2[LogLevel2["Verbose"] = 3] = "Verbose";
  LogLevel2[LogLevel2["Debug"] = 4] = "Debug";
})(LogLevel || (LogLevel = {}));
var ServerZone;
(function(ServerZone2) {
  ServerZone2["US"] = "US";
  ServerZone2["EU"] = "EU";
})(ServerZone || (ServerZone = {}));
var Status;
(function(Status2) {
  Status2["Unknown"] = "unknown";
  Status2["Skipped"] = "skipped";
  Status2["Success"] = "success";
  Status2["RateLimit"] = "rate_limit";
  Status2["PayloadTooLarge"] = "payload_too_large";
  Status2["Invalid"] = "invalid";
  Status2["Failed"] = "failed";
  Status2["Timeout"] = "Timeout";
  Status2["SystemError"] = "SystemError";
})(Status || (Status = {}));
var OfflineDisabled = null;
var DEFAULT_CSS_SELECTOR_ALLOWLIST = [
  "a",
  "button",
  "input",
  "select",
  "textarea",
  "label",
  "video",
  "audio",
  '[contenteditable="true" i]',
  "[data-amp-default-track]",
  ".amp-default-track"
];
var DEFAULT_DATA_ATTRIBUTE_PREFIX = "data-amp-track-";
var DEFAULT_ACTION_CLICK_ALLOWLIST = ["div", "span", "h1", "h2", "h3", "h4", "h5", "h6"];
var buildResult = function(event, code, message) {
  if (code === void 0) {
    code = 0;
  }
  if (message === void 0) {
    message = Status.Unknown;
  }
  return { event, code, message };
};
var UUID = function(a) {
  return a ? (
    // a random number from 0 to 15
    (a ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    a / 4).toString(16)
  ) : (
    // or otherwise a concatenated string:
    (String(1e7) + // 10000000 +
    String(-1e3) + // -1000 +
    String(-4e3) + // -4000 +
    String(-8e3) + // -80000000 +
    String(-1e11)).replace(
      // replacing
      /[018]/g,
      // zeroes, ones, and eights with
      UUID
    )
  );
};
var Timeline = (
  /** @class */
  function() {
    function Timeline2(client2) {
      this.client = client2;
      this.queue = [];
      this.applying = false;
      this.plugins = [];
    }
    Timeline2.prototype.register = function(plugin, config2) {
      var _a2, _b2;
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_c2) {
          switch (_c2.label) {
            case 0:
              if (this.plugins.some(function(existingPlugin) {
                return existingPlugin.name === plugin.name;
              })) {
                config2.loggerProvider.warn("Plugin with name ".concat(plugin.name, " already exists, skipping registration"));
                return [
                  2
                  /*return*/
                ];
              }
              if (plugin.name === void 0) {
                plugin.name = UUID();
                config2.loggerProvider.warn("Plugin name is undefined. \n      Generating a random UUID for plugin name: ".concat(plugin.name, ". \n      Set a name for the plugin to prevent it from being added multiple times."));
              }
              plugin.type = (_a2 = plugin.type) !== null && _a2 !== void 0 ? _a2 : "enrichment";
              return [4, (_b2 = plugin.setup) === null || _b2 === void 0 ? void 0 : _b2.call(plugin, config2, this.client)];
            case 1:
              _c2.sent();
              this.plugins.push(plugin);
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    Timeline2.prototype.deregister = function(pluginName, config2) {
      var _a2;
      return __awaiter(this, void 0, void 0, function() {
        var index2, plugin;
        return __generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              index2 = this.plugins.findIndex(function(plugin2) {
                return plugin2.name === pluginName;
              });
              if (index2 === -1) {
                config2.loggerProvider.warn("Plugin with name ".concat(pluginName, " does not exist, skipping deregistration"));
                return [
                  2
                  /*return*/
                ];
              }
              plugin = this.plugins[index2];
              this.plugins.splice(index2, 1);
              return [4, (_a2 = plugin.teardown) === null || _a2 === void 0 ? void 0 : _a2.call(plugin)];
            case 1:
              _b2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    Timeline2.prototype.reset = function(client2) {
      this.applying = false;
      var plugins = this.plugins;
      plugins.map(function(plugin) {
        var _a2;
        return (_a2 = plugin.teardown) === null || _a2 === void 0 ? void 0 : _a2.call(plugin);
      });
      this.plugins = [];
      this.client = client2;
    };
    Timeline2.prototype.push = function(event) {
      var _this = this;
      return new Promise(function(resolve2) {
        _this.queue.push([event, resolve2]);
        _this.scheduleApply(0);
      });
    };
    Timeline2.prototype.scheduleApply = function(timeout2) {
      var _this = this;
      if (this.applying)
        return;
      this.applying = true;
      setTimeout(function() {
        void _this.apply(_this.queue.shift()).then(function() {
          _this.applying = false;
          if (_this.queue.length > 0) {
            _this.scheduleApply(0);
          }
        });
      }, timeout2);
    };
    Timeline2.prototype.apply = function(item) {
      return __awaiter(this, void 0, void 0, function() {
        var _a2, event, _b2, resolve2, before, before_1, before_1_1, plugin, e, e_1_1, enrichment, enrichment_1, enrichment_1_1, plugin, e, e_2_1, destination, executeDestinations;
        var e_1, _c2, e_2, _d2;
        return __generator(this, function(_e2) {
          switch (_e2.label) {
            case 0:
              if (!item) {
                return [
                  2
                  /*return*/
                ];
              }
              _a2 = __read$1(item, 1), event = _a2[0];
              _b2 = __read$1(item, 2), resolve2 = _b2[1];
              before = this.plugins.filter(function(plugin2) {
                return plugin2.type === "before";
              });
              _e2.label = 1;
            case 1:
              _e2.trys.push([1, 6, 7, 8]);
              before_1 = __values$1(before), before_1_1 = before_1.next();
              _e2.label = 2;
            case 2:
              if (!!before_1_1.done) return [3, 5];
              plugin = before_1_1.value;
              if (!plugin.execute) {
                return [3, 4];
              }
              return [4, plugin.execute(__assign$1({}, event))];
            case 3:
              e = _e2.sent();
              if (e === null) {
                resolve2({ event, code: 0, message: "" });
                return [
                  2
                  /*return*/
                ];
              } else {
                event = e;
              }
              _e2.label = 4;
            case 4:
              before_1_1 = before_1.next();
              return [3, 2];
            case 5:
              return [3, 8];
            case 6:
              e_1_1 = _e2.sent();
              e_1 = { error: e_1_1 };
              return [3, 8];
            case 7:
              try {
                if (before_1_1 && !before_1_1.done && (_c2 = before_1.return)) _c2.call(before_1);
              } finally {
                if (e_1) throw e_1.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 8:
              enrichment = this.plugins.filter(function(plugin2) {
                return plugin2.type === "enrichment" || plugin2.type === void 0;
              });
              _e2.label = 9;
            case 9:
              _e2.trys.push([9, 14, 15, 16]);
              enrichment_1 = __values$1(enrichment), enrichment_1_1 = enrichment_1.next();
              _e2.label = 10;
            case 10:
              if (!!enrichment_1_1.done) return [3, 13];
              plugin = enrichment_1_1.value;
              if (!plugin.execute) {
                return [3, 12];
              }
              return [4, plugin.execute(__assign$1({}, event))];
            case 11:
              e = _e2.sent();
              if (e === null) {
                resolve2({ event, code: 0, message: "" });
                return [
                  2
                  /*return*/
                ];
              } else {
                event = e;
              }
              _e2.label = 12;
            case 12:
              enrichment_1_1 = enrichment_1.next();
              return [3, 10];
            case 13:
              return [3, 16];
            case 14:
              e_2_1 = _e2.sent();
              e_2 = { error: e_2_1 };
              return [3, 16];
            case 15:
              try {
                if (enrichment_1_1 && !enrichment_1_1.done && (_d2 = enrichment_1.return)) _d2.call(enrichment_1);
              } finally {
                if (e_2) throw e_2.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 16:
              destination = this.plugins.filter(function(plugin2) {
                return plugin2.type === "destination";
              });
              executeDestinations = destination.map(function(plugin2) {
                var eventClone = __assign$1({}, event);
                return plugin2.execute(eventClone).catch(function(e2) {
                  return buildResult(eventClone, 0, String(e2));
                });
              });
              void Promise.all(executeDestinations).then(function(_a3) {
                var _b3 = __read$1(_a3, 1), result2 = _b3[0];
                var resolveResult = result2 || buildResult(event, 100, "Event not tracked, no destination plugins on the instance");
                resolve2(resolveResult);
              });
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    Timeline2.prototype.flush = function() {
      return __awaiter(this, void 0, void 0, function() {
        var queue, destination, executeDestinations;
        var _this = this;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              queue = this.queue;
              this.queue = [];
              return [4, Promise.all(queue.map(function(item) {
                return _this.apply(item);
              }))];
            case 1:
              _a2.sent();
              destination = this.plugins.filter(function(plugin) {
                return plugin.type === "destination";
              });
              executeDestinations = destination.map(function(plugin) {
                return plugin.flush && plugin.flush();
              });
              return [4, Promise.all(executeDestinations)];
            case 2:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    return Timeline2;
  }()
);
var UNSET_VALUE = "-";
var AMPLITUDE_PREFIX = "AMP";
var STORAGE_PREFIX = "".concat(AMPLITUDE_PREFIX, "_unsent");
var AMPLITUDE_SERVER_URL = "https://api2.amplitude.com/2/httpapi";
var EU_AMPLITUDE_SERVER_URL = "https://api.eu.amplitude.com/2/httpapi";
var AMPLITUDE_BATCH_SERVER_URL = "https://api2.amplitude.com/batch";
var EU_AMPLITUDE_BATCH_SERVER_URL = "https://api.eu.amplitude.com/batch";
var MAX_PROPERTY_KEYS = 1e3;
var isValidObject = function(properties) {
  if (Object.keys(properties).length > MAX_PROPERTY_KEYS) {
    return false;
  }
  for (var key in properties) {
    var value = properties[key];
    if (!isValidProperties(key, value))
      return false;
  }
  return true;
};
var isValidProperties = function(property, value) {
  var e_1, _a2;
  if (typeof property !== "string")
    return false;
  if (Array.isArray(value)) {
    var isValid = true;
    try {
      for (var value_1 = __values$1(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()) {
        var valueElement = value_1_1.value;
        if (Array.isArray(valueElement)) {
          return false;
        } else if (typeof valueElement === "object") {
          isValid = isValid && isValidObject(valueElement);
        } else if (!["number", "string"].includes(typeof valueElement)) {
          return false;
        }
        if (!isValid) {
          return false;
        }
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (value_1_1 && !value_1_1.done && (_a2 = value_1.return)) _a2.call(value_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  } else if (value === null || value === void 0) {
    return false;
  } else if (typeof value === "object") {
    return isValidObject(value);
  } else if (!["number", "string", "boolean"].includes(typeof value)) {
    return false;
  }
  return true;
};
var Identify = (
  /** @class */
  function() {
    function Identify2() {
      this._propertySet = /* @__PURE__ */ new Set();
      this._properties = {};
    }
    Identify2.prototype.getUserProperties = function() {
      return __assign$1({}, this._properties);
    };
    Identify2.prototype.set = function(property, value) {
      this._safeSet(IdentifyOperation.SET, property, value);
      return this;
    };
    Identify2.prototype.setOnce = function(property, value) {
      this._safeSet(IdentifyOperation.SET_ONCE, property, value);
      return this;
    };
    Identify2.prototype.append = function(property, value) {
      this._safeSet(IdentifyOperation.APPEND, property, value);
      return this;
    };
    Identify2.prototype.prepend = function(property, value) {
      this._safeSet(IdentifyOperation.PREPEND, property, value);
      return this;
    };
    Identify2.prototype.postInsert = function(property, value) {
      this._safeSet(IdentifyOperation.POSTINSERT, property, value);
      return this;
    };
    Identify2.prototype.preInsert = function(property, value) {
      this._safeSet(IdentifyOperation.PREINSERT, property, value);
      return this;
    };
    Identify2.prototype.remove = function(property, value) {
      this._safeSet(IdentifyOperation.REMOVE, property, value);
      return this;
    };
    Identify2.prototype.add = function(property, value) {
      this._safeSet(IdentifyOperation.ADD, property, value);
      return this;
    };
    Identify2.prototype.unset = function(property) {
      this._safeSet(IdentifyOperation.UNSET, property, UNSET_VALUE);
      return this;
    };
    Identify2.prototype.clearAll = function() {
      this._properties = {};
      this._properties[IdentifyOperation.CLEAR_ALL] = UNSET_VALUE;
      return this;
    };
    Identify2.prototype._safeSet = function(operation, property, value) {
      if (this._validate(operation, property, value)) {
        var userPropertyMap = this._properties[operation];
        if (userPropertyMap === void 0) {
          userPropertyMap = {};
          this._properties[operation] = userPropertyMap;
        }
        userPropertyMap[property] = value;
        this._propertySet.add(property);
        return true;
      }
      return false;
    };
    Identify2.prototype._validate = function(operation, property, value) {
      if (this._properties[IdentifyOperation.CLEAR_ALL] !== void 0) {
        return false;
      }
      if (this._propertySet.has(property)) {
        return false;
      }
      if (operation === IdentifyOperation.ADD) {
        return typeof value === "number";
      }
      if (operation !== IdentifyOperation.UNSET && operation !== IdentifyOperation.REMOVE) {
        return isValidProperties(property, value);
      }
      return true;
    };
    return Identify2;
  }()
);
var createTrackEvent = function(eventInput, eventProperties, eventOptions) {
  var baseEvent = typeof eventInput === "string" ? { event_type: eventInput } : eventInput;
  return __assign$1(__assign$1(__assign$1({}, baseEvent), eventOptions), eventProperties && { event_properties: eventProperties });
};
var createIdentifyEvent = function(identify2, eventOptions) {
  var identifyEvent = __assign$1(__assign$1({}, eventOptions), { event_type: SpecialEventType.IDENTIFY, user_properties: identify2.getUserProperties() });
  return identifyEvent;
};
var createGroupIdentifyEvent = function(groupType, groupName, identify2, eventOptions) {
  var _a2;
  var groupIdentify = __assign$1(__assign$1({}, eventOptions), { event_type: SpecialEventType.GROUP_IDENTIFY, group_properties: identify2.getUserProperties(), groups: (_a2 = {}, _a2[groupType] = groupName, _a2) });
  return groupIdentify;
};
var createGroupEvent = function(groupType, groupName, eventOptions) {
  var _a2;
  var identify2 = new Identify();
  identify2.set(groupType, groupName);
  var groupEvent = __assign$1(__assign$1({}, eventOptions), { event_type: SpecialEventType.IDENTIFY, user_properties: identify2.getUserProperties(), groups: (_a2 = {}, _a2[groupType] = groupName, _a2) });
  return groupEvent;
};
var createRevenueEvent = function(revenue, eventOptions) {
  return __assign$1(__assign$1({}, eventOptions), { event_type: SpecialEventType.REVENUE, event_properties: revenue.getEventProperties() });
};
var returnWrapper = function(awaitable) {
  return {
    promise: awaitable || Promise.resolve()
  };
};
var AmplitudeCore = (
  /** @class */
  function() {
    function AmplitudeCore2(name2) {
      if (name2 === void 0) {
        name2 = "$default";
      }
      this.initializing = false;
      this.isReady = false;
      this.q = [];
      this.dispatchQ = [];
      this.logEvent = this.track.bind(this);
      this.timeline = new Timeline(this);
      this.name = name2;
    }
    AmplitudeCore2.prototype._init = function(config2) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              this.config = config2;
              this.timeline.reset(this);
              return [4, this.runQueuedFunctions("q")];
            case 1:
              _a2.sent();
              this.isReady = true;
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AmplitudeCore2.prototype.runQueuedFunctions = function(queueName) {
      return __awaiter(this, void 0, void 0, function() {
        var queuedFunctions, queuedFunctions_1, queuedFunctions_1_1, queuedFunction, val, e_1_1;
        var e_1, _a2;
        return __generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              queuedFunctions = this[queueName];
              this[queueName] = [];
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 8, 9, 10]);
              queuedFunctions_1 = __values$1(queuedFunctions), queuedFunctions_1_1 = queuedFunctions_1.next();
              _b2.label = 2;
            case 2:
              if (!!queuedFunctions_1_1.done) return [3, 7];
              queuedFunction = queuedFunctions_1_1.value;
              val = queuedFunction();
              if (!(val && "promise" in val)) return [3, 4];
              return [4, val.promise];
            case 3:
              _b2.sent();
              return [3, 6];
            case 4:
              return [4, val];
            case 5:
              _b2.sent();
              _b2.label = 6;
            case 6:
              queuedFunctions_1_1 = queuedFunctions_1.next();
              return [3, 2];
            case 7:
              return [3, 10];
            case 8:
              e_1_1 = _b2.sent();
              e_1 = { error: e_1_1 };
              return [3, 10];
            case 9:
              try {
                if (queuedFunctions_1_1 && !queuedFunctions_1_1.done && (_a2 = queuedFunctions_1.return)) _a2.call(queuedFunctions_1);
              } finally {
                if (e_1) throw e_1.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 10:
              if (!this[queueName].length) return [3, 12];
              return [4, this.runQueuedFunctions(queueName)];
            case 11:
              _b2.sent();
              _b2.label = 12;
            case 12:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AmplitudeCore2.prototype.track = function(eventInput, eventProperties, eventOptions) {
      var event = createTrackEvent(eventInput, eventProperties, eventOptions);
      return returnWrapper(this.dispatch(event));
    };
    AmplitudeCore2.prototype.identify = function(identify2, eventOptions) {
      var event = createIdentifyEvent(identify2, eventOptions);
      return returnWrapper(this.dispatch(event));
    };
    AmplitudeCore2.prototype.groupIdentify = function(groupType, groupName, identify2, eventOptions) {
      var event = createGroupIdentifyEvent(groupType, groupName, identify2, eventOptions);
      return returnWrapper(this.dispatch(event));
    };
    AmplitudeCore2.prototype.setGroup = function(groupType, groupName, eventOptions) {
      var event = createGroupEvent(groupType, groupName, eventOptions);
      return returnWrapper(this.dispatch(event));
    };
    AmplitudeCore2.prototype.revenue = function(revenue, eventOptions) {
      var event = createRevenueEvent(revenue, eventOptions);
      return returnWrapper(this.dispatch(event));
    };
    AmplitudeCore2.prototype.add = function(plugin) {
      if (!this.isReady) {
        this.q.push(this._addPlugin.bind(this, plugin));
        return returnWrapper();
      }
      return this._addPlugin(plugin);
    };
    AmplitudeCore2.prototype._addPlugin = function(plugin) {
      return returnWrapper(this.timeline.register(plugin, this.config));
    };
    AmplitudeCore2.prototype.remove = function(pluginName) {
      if (!this.isReady) {
        this.q.push(this._removePlugin.bind(this, pluginName));
        return returnWrapper();
      }
      return this._removePlugin(pluginName);
    };
    AmplitudeCore2.prototype._removePlugin = function(pluginName) {
      return returnWrapper(this.timeline.deregister(pluginName, this.config));
    };
    AmplitudeCore2.prototype.dispatchWithCallback = function(event, callback) {
      if (!this.isReady) {
        return callback(buildResult(event, 0, CLIENT_NOT_INITIALIZED));
      }
      void this.process(event).then(callback);
    };
    AmplitudeCore2.prototype.dispatch = function(event) {
      return __awaiter(this, void 0, void 0, function() {
        var _this = this;
        return __generator(this, function(_a2) {
          if (!this.isReady) {
            return [2, new Promise(function(resolve2) {
              _this.dispatchQ.push(_this.dispatchWithCallback.bind(_this, event, resolve2));
            })];
          }
          return [2, this.process(event)];
        });
      });
    };
    AmplitudeCore2.prototype.process = function(event) {
      return __awaiter(this, void 0, void 0, function() {
        var result2, e_2, message, result2;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              if (this.config.optOut) {
                return [2, buildResult(event, 0, OPT_OUT_MESSAGE)];
              }
              return [4, this.timeline.push(event)];
            case 1:
              result2 = _a2.sent();
              result2.code === 200 ? this.config.loggerProvider.log(result2.message) : result2.code === 100 ? this.config.loggerProvider.warn(result2.message) : this.config.loggerProvider.error(result2.message);
              return [2, result2];
            case 2:
              e_2 = _a2.sent();
              message = String(e_2);
              this.config.loggerProvider.error(message);
              result2 = buildResult(event, 0, message);
              return [2, result2];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AmplitudeCore2.prototype.setOptOut = function(optOut) {
      if (!this.isReady) {
        this.q.push(this._setOptOut.bind(this, Boolean(optOut)));
        return;
      }
      this._setOptOut(optOut);
    };
    AmplitudeCore2.prototype._setOptOut = function(optOut) {
      this.config.optOut = Boolean(optOut);
    };
    AmplitudeCore2.prototype.flush = function() {
      return returnWrapper(this.timeline.flush());
    };
    return AmplitudeCore2;
  }()
);
var Revenue = (
  /** @class */
  function() {
    function Revenue2() {
      this.productId = "";
      this.quantity = 1;
      this.price = 0;
    }
    Revenue2.prototype.setProductId = function(productId) {
      this.productId = productId;
      return this;
    };
    Revenue2.prototype.setQuantity = function(quantity) {
      if (quantity > 0) {
        this.quantity = quantity;
      }
      return this;
    };
    Revenue2.prototype.setPrice = function(price) {
      this.price = price;
      return this;
    };
    Revenue2.prototype.setRevenueType = function(revenueType) {
      this.revenueType = revenueType;
      return this;
    };
    Revenue2.prototype.setCurrency = function(currency) {
      this.currency = currency;
      return this;
    };
    Revenue2.prototype.setRevenue = function(revenue) {
      this.revenue = revenue;
      return this;
    };
    Revenue2.prototype.setEventProperties = function(properties) {
      if (isValidObject(properties)) {
        this.properties = properties;
      }
      return this;
    };
    Revenue2.prototype.getEventProperties = function() {
      var eventProperties = this.properties ? __assign$1({}, this.properties) : {};
      eventProperties[RevenueProperty.REVENUE_PRODUCT_ID] = this.productId;
      eventProperties[RevenueProperty.REVENUE_QUANTITY] = this.quantity;
      eventProperties[RevenueProperty.REVENUE_PRICE] = this.price;
      eventProperties[RevenueProperty.REVENUE_TYPE] = this.revenueType;
      eventProperties[RevenueProperty.REVENUE_CURRENCY] = this.currency;
      eventProperties[RevenueProperty.REVENUE] = this.revenue;
      return eventProperties;
    };
    return Revenue2;
  }()
);
var chunk = function(arr, size) {
  var chunkSize = Math.max(size, 1);
  return arr.reduce(function(chunks, element, index2) {
    var chunkIndex = Math.floor(index2 / chunkSize);
    if (!chunks[chunkIndex]) {
      chunks[chunkIndex] = [];
    }
    chunks[chunkIndex].push(element);
    return chunks;
  }, []);
};
var PREFIX$1 = "Amplitude Logger ";
var Logger = (
  /** @class */
  function() {
    function Logger2() {
      this.logLevel = LogLevel.None;
    }
    Logger2.prototype.disable = function() {
      this.logLevel = LogLevel.None;
    };
    Logger2.prototype.enable = function(logLevel) {
      if (logLevel === void 0) {
        logLevel = LogLevel.Warn;
      }
      this.logLevel = logLevel;
    };
    Logger2.prototype.log = function() {
      var args = [];
      for (var _i2 = 0; _i2 < arguments.length; _i2++) {
        args[_i2] = arguments[_i2];
      }
      if (this.logLevel < LogLevel.Verbose) {
        return;
      }
      console.log("".concat(PREFIX$1, "[Log]: ").concat(args.join(" ")));
    };
    Logger2.prototype.warn = function() {
      var args = [];
      for (var _i2 = 0; _i2 < arguments.length; _i2++) {
        args[_i2] = arguments[_i2];
      }
      if (this.logLevel < LogLevel.Warn) {
        return;
      }
      console.warn("".concat(PREFIX$1, "[Warn]: ").concat(args.join(" ")));
    };
    Logger2.prototype.error = function() {
      var args = [];
      for (var _i2 = 0; _i2 < arguments.length; _i2++) {
        args[_i2] = arguments[_i2];
      }
      if (this.logLevel < LogLevel.Error) {
        return;
      }
      console.error("".concat(PREFIX$1, "[Error]: ").concat(args.join(" ")));
    };
    Logger2.prototype.debug = function() {
      var args = [];
      for (var _i2 = 0; _i2 < arguments.length; _i2++) {
        args[_i2] = arguments[_i2];
      }
      if (this.logLevel < LogLevel.Debug) {
        return;
      }
      console.log("".concat(PREFIX$1, "[Debug]: ").concat(args.join(" ")));
    };
    return Logger2;
  }()
);
var getDefaultConfig = function() {
  return {
    flushMaxRetries: 12,
    flushQueueSize: 200,
    flushIntervalMillis: 1e4,
    instanceName: "$default_instance",
    logLevel: LogLevel.Warn,
    loggerProvider: new Logger(),
    offline: false,
    optOut: false,
    serverUrl: AMPLITUDE_SERVER_URL,
    serverZone: "US",
    useBatch: false
  };
};
var Config = (
  /** @class */
  function() {
    function Config2(options) {
      var _a2, _b2, _c2, _d2;
      this._optOut = false;
      var defaultConfig = getDefaultConfig();
      this.apiKey = options.apiKey;
      this.flushIntervalMillis = (_a2 = options.flushIntervalMillis) !== null && _a2 !== void 0 ? _a2 : defaultConfig.flushIntervalMillis;
      this.flushMaxRetries = options.flushMaxRetries || defaultConfig.flushMaxRetries;
      this.flushQueueSize = options.flushQueueSize || defaultConfig.flushQueueSize;
      this.instanceName = options.instanceName || defaultConfig.instanceName;
      this.loggerProvider = options.loggerProvider || defaultConfig.loggerProvider;
      this.logLevel = (_b2 = options.logLevel) !== null && _b2 !== void 0 ? _b2 : defaultConfig.logLevel;
      this.minIdLength = options.minIdLength;
      this.plan = options.plan;
      this.ingestionMetadata = options.ingestionMetadata;
      this.offline = options.offline !== void 0 ? options.offline : defaultConfig.offline;
      this.optOut = (_c2 = options.optOut) !== null && _c2 !== void 0 ? _c2 : defaultConfig.optOut;
      this.serverUrl = options.serverUrl;
      this.serverZone = options.serverZone || defaultConfig.serverZone;
      this.storageProvider = options.storageProvider;
      this.transportProvider = options.transportProvider;
      this.useBatch = (_d2 = options.useBatch) !== null && _d2 !== void 0 ? _d2 : defaultConfig.useBatch;
      this.loggerProvider.enable(this.logLevel);
      var serverConfig = createServerConfig(options.serverUrl, options.serverZone, options.useBatch);
      this.serverZone = serverConfig.serverZone;
      this.serverUrl = serverConfig.serverUrl;
    }
    Object.defineProperty(Config2.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(optOut) {
        this._optOut = optOut;
      },
      enumerable: false,
      configurable: true
    });
    return Config2;
  }()
);
var getServerUrl = function(serverZone, useBatch) {
  if (serverZone === "EU") {
    return useBatch ? EU_AMPLITUDE_BATCH_SERVER_URL : EU_AMPLITUDE_SERVER_URL;
  }
  return useBatch ? AMPLITUDE_BATCH_SERVER_URL : AMPLITUDE_SERVER_URL;
};
var createServerConfig = function(serverUrl, serverZone, useBatch) {
  if (serverUrl === void 0) {
    serverUrl = "";
  }
  if (serverZone === void 0) {
    serverZone = getDefaultConfig().serverZone;
  }
  if (useBatch === void 0) {
    useBatch = getDefaultConfig().useBatch;
  }
  if (serverUrl) {
    return { serverUrl, serverZone: void 0 };
  }
  var _serverZone = ["US", "EU"].includes(serverZone) ? serverZone : getDefaultConfig().serverZone;
  return {
    serverZone: _serverZone,
    serverUrl: getServerUrl(_serverZone, useBatch)
  };
};
var RequestMetadata = (
  /** @class */
  function() {
    function RequestMetadata2() {
      this.sdk = {
        metrics: {
          histogram: {}
        }
      };
    }
    RequestMetadata2.prototype.recordHistogram = function(key, value) {
      this.sdk.metrics.histogram[key] = value;
    };
    return RequestMetadata2;
  }()
);
function getErrorMessage(error) {
  if (error instanceof Error)
    return error.message;
  return String(error);
}
function getResponseBodyString(res) {
  var responseBodyString = "";
  try {
    if ("body" in res) {
      responseBodyString = JSON.stringify(res.body, null, 2);
    }
  } catch (_a2) {
  }
  return responseBodyString;
}
var Destination = (
  /** @class */
  function() {
    function Destination2() {
      this.name = "amplitude";
      this.type = "destination";
      this.retryTimeout = 1e3;
      this.throttleTimeout = 3e4;
      this.storageKey = "";
      this.scheduleId = null;
      this.scheduledTimeout = 0;
      this.flushId = null;
      this.queue = [];
    }
    Destination2.prototype.setup = function(config2) {
      var _a2;
      return __awaiter(this, void 0, void 0, function() {
        var unsent;
        var _this = this;
        return __generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              this.config = config2;
              this.storageKey = "".concat(STORAGE_PREFIX, "_").concat(this.config.apiKey.substring(0, 10));
              return [4, (_a2 = this.config.storageProvider) === null || _a2 === void 0 ? void 0 : _a2.get(this.storageKey)];
            case 1:
              unsent = _b2.sent();
              if (unsent && unsent.length > 0) {
                void Promise.all(unsent.map(function(event) {
                  return _this.execute(event);
                })).catch();
              }
              return [2, Promise.resolve(void 0)];
          }
        });
      });
    };
    Destination2.prototype.execute = function(event) {
      var _this = this;
      if (!event.insert_id) {
        event.insert_id = UUID();
      }
      return new Promise(function(resolve2) {
        var context = {
          event,
          attempts: 0,
          callback: function(result2) {
            return resolve2(result2);
          },
          timeout: 0
        };
        _this.queue.push(context);
        _this.schedule(_this.config.flushIntervalMillis);
        _this.saveEvents();
      });
    };
    Destination2.prototype.removeEventsExceedFlushMaxRetries = function(list) {
      var _this = this;
      return list.filter(function(context) {
        context.attempts += 1;
        if (context.attempts < _this.config.flushMaxRetries) {
          return true;
        }
        void _this.fulfillRequest([context], 500, MAX_RETRIES_EXCEEDED_MESSAGE$1);
        return false;
      });
    };
    Destination2.prototype.scheduleEvents = function(list) {
      var _this = this;
      list.forEach(function(context) {
        _this.schedule(context.timeout === 0 ? _this.config.flushIntervalMillis : context.timeout);
      });
    };
    Destination2.prototype.schedule = function(timeout2) {
      var _this = this;
      if (this.config.offline) {
        return;
      }
      if (this.scheduleId === null || this.scheduleId && timeout2 > this.scheduledTimeout) {
        if (this.scheduleId) {
          clearTimeout(this.scheduleId);
        }
        this.scheduledTimeout = timeout2;
        this.scheduleId = setTimeout(function() {
          _this.queue = _this.queue.map(function(context) {
            context.timeout = 0;
            return context;
          });
          void _this.flush(true);
        }, timeout2);
        return;
      }
    };
    Destination2.prototype.resetSchedule = function() {
      this.scheduleId = null;
      this.scheduledTimeout = 0;
    };
    Destination2.prototype.flush = function(useRetry) {
      if (useRetry === void 0) {
        useRetry = false;
      }
      return __awaiter(this, void 0, void 0, function() {
        var list, later, batches;
        var _this = this;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (this.config.offline) {
                this.resetSchedule();
                this.config.loggerProvider.debug("Skipping flush while offline.");
                return [
                  2
                  /*return*/
                ];
              }
              if (this.flushId) {
                this.resetSchedule();
                this.config.loggerProvider.debug("Skipping flush because previous flush has not resolved.");
                return [
                  2
                  /*return*/
                ];
              }
              this.flushId = this.scheduleId;
              this.resetSchedule();
              list = [];
              later = [];
              this.queue.forEach(function(context) {
                return context.timeout === 0 ? list.push(context) : later.push(context);
              });
              batches = chunk(list, this.config.flushQueueSize);
              return [4, batches.reduce(function(promise, batch) {
                return __awaiter(_this, void 0, void 0, function() {
                  return __generator(this, function(_a3) {
                    switch (_a3.label) {
                      case 0:
                        return [4, promise];
                      case 1:
                        _a3.sent();
                        return [4, this.send(batch, useRetry)];
                      case 2:
                        return [2, _a3.sent()];
                    }
                  });
                });
              }, Promise.resolve())];
            case 1:
              _a2.sent();
              this.flushId = null;
              this.scheduleEvents(this.queue);
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    Destination2.prototype.send = function(list, useRetry) {
      if (useRetry === void 0) {
        useRetry = true;
      }
      return __awaiter(this, void 0, void 0, function() {
        var payload, serverUrl, res, e_1, errorMessage;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!this.config.apiKey) {
                return [2, this.fulfillRequest(list, 400, MISSING_API_KEY_MESSAGE)];
              }
              payload = {
                api_key: this.config.apiKey,
                events: list.map(function(context) {
                  var _a3 = context.event;
                  _a3.extra;
                  var eventWithoutExtra = __rest(_a3, ["extra"]);
                  return eventWithoutExtra;
                }),
                options: {
                  min_id_length: this.config.minIdLength
                },
                client_upload_time: (/* @__PURE__ */ new Date()).toISOString(),
                request_metadata: this.config.requestMetadata
              };
              this.config.requestMetadata = new RequestMetadata();
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 3, , 4]);
              serverUrl = createServerConfig(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl;
              return [4, this.config.transportProvider.send(serverUrl, payload)];
            case 2:
              res = _a2.sent();
              if (res === null) {
                this.fulfillRequest(list, 0, UNEXPECTED_ERROR_MESSAGE$1);
                return [
                  2
                  /*return*/
                ];
              }
              if (!useRetry) {
                if ("body" in res) {
                  this.fulfillRequest(list, res.statusCode, "".concat(res.status, ": ").concat(getResponseBodyString(res)));
                } else {
                  this.fulfillRequest(list, res.statusCode, res.status);
                }
                return [
                  2
                  /*return*/
                ];
              }
              this.handleResponse(res, list);
              return [3, 4];
            case 3:
              e_1 = _a2.sent();
              errorMessage = getErrorMessage(e_1);
              this.config.loggerProvider.error(errorMessage);
              this.handleResponse({ status: Status.Failed, statusCode: 0 }, list);
              return [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    Destination2.prototype.handleResponse = function(res, list) {
      var status = res.status;
      switch (status) {
        case Status.Success: {
          this.handleSuccessResponse(res, list);
          break;
        }
        case Status.Invalid: {
          this.handleInvalidResponse(res, list);
          break;
        }
        case Status.PayloadTooLarge: {
          this.handlePayloadTooLargeResponse(res, list);
          break;
        }
        case Status.RateLimit: {
          this.handleRateLimitResponse(res, list);
          break;
        }
        default: {
          this.config.loggerProvider.warn(`{code: 0, error: "Status '`.concat(status, "' provided for ").concat(list.length, ' events"}'));
          this.handleOtherResponse(list);
          break;
        }
      }
    };
    Destination2.prototype.handleSuccessResponse = function(res, list) {
      this.fulfillRequest(list, res.statusCode, SUCCESS_MESSAGE);
    };
    Destination2.prototype.handleInvalidResponse = function(res, list) {
      var _this = this;
      if (res.body.missingField || res.body.error.startsWith(INVALID_API_KEY)) {
        this.fulfillRequest(list, res.statusCode, res.body.error);
        return;
      }
      var dropIndex = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read$1(Object.values(res.body.eventsWithInvalidFields)), false), __read$1(Object.values(res.body.eventsWithMissingFields)), false), __read$1(Object.values(res.body.eventsWithInvalidIdLengths)), false), __read$1(res.body.silencedEvents), false).flat();
      var dropIndexSet = new Set(dropIndex);
      var retry = list.filter(function(context, index2) {
        if (dropIndexSet.has(index2)) {
          _this.fulfillRequest([context], res.statusCode, res.body.error);
          return;
        }
        return true;
      });
      if (retry.length > 0) {
        this.config.loggerProvider.warn(getResponseBodyString(res));
      }
      var tryable = this.removeEventsExceedFlushMaxRetries(retry);
      this.scheduleEvents(tryable);
    };
    Destination2.prototype.handlePayloadTooLargeResponse = function(res, list) {
      if (list.length === 1) {
        this.fulfillRequest(list, res.statusCode, res.body.error);
        return;
      }
      this.config.loggerProvider.warn(getResponseBodyString(res));
      this.config.flushQueueSize /= 2;
      var tryable = this.removeEventsExceedFlushMaxRetries(list);
      this.scheduleEvents(tryable);
    };
    Destination2.prototype.handleRateLimitResponse = function(res, list) {
      var _this = this;
      var dropUserIds = Object.keys(res.body.exceededDailyQuotaUsers);
      var dropDeviceIds = Object.keys(res.body.exceededDailyQuotaDevices);
      var throttledIndex = res.body.throttledEvents;
      var dropUserIdsSet = new Set(dropUserIds);
      var dropDeviceIdsSet = new Set(dropDeviceIds);
      var throttledIndexSet = new Set(throttledIndex);
      var retry = list.filter(function(context, index2) {
        if (context.event.user_id && dropUserIdsSet.has(context.event.user_id) || context.event.device_id && dropDeviceIdsSet.has(context.event.device_id)) {
          _this.fulfillRequest([context], res.statusCode, res.body.error);
          return;
        }
        if (throttledIndexSet.has(index2)) {
          context.timeout = _this.throttleTimeout;
        }
        return true;
      });
      if (retry.length > 0) {
        this.config.loggerProvider.warn(getResponseBodyString(res));
      }
      var tryable = this.removeEventsExceedFlushMaxRetries(retry);
      this.scheduleEvents(tryable);
    };
    Destination2.prototype.handleOtherResponse = function(list) {
      var _this = this;
      var later = list.map(function(context) {
        context.timeout = context.attempts * _this.retryTimeout;
        return context;
      });
      var tryable = this.removeEventsExceedFlushMaxRetries(later);
      this.scheduleEvents(tryable);
    };
    Destination2.prototype.fulfillRequest = function(list, code, message) {
      this.removeEvents(list);
      list.forEach(function(context) {
        return context.callback(buildResult(context.event, code, message));
      });
    };
    Destination2.prototype.saveEvents = function() {
      if (!this.config.storageProvider) {
        return;
      }
      var updatedEvents = this.queue.map(function(context) {
        return context.event;
      });
      void this.config.storageProvider.set(this.storageKey, updatedEvents);
    };
    Destination2.prototype.removeEvents = function(eventsToRemove) {
      this.queue = this.queue.filter(function(queuedContext) {
        return !eventsToRemove.some(function(context) {
          return context.event.insert_id === queuedContext.event.insert_id;
        });
      });
      this.saveEvents();
    };
    return Destination2;
  }()
);
var getStacktrace = function(ignoreDepth) {
  var trace = new Error().stack || "";
  return trace.split("\n").slice(2 + ignoreDepth).map(function(text) {
    return text.trim();
  });
};
var getClientLogConfig = function(client2) {
  return function() {
    var _a2 = __assign$1({}, client2.config), logger2 = _a2.loggerProvider, logLevel = _a2.logLevel;
    return {
      logger: logger2,
      logLevel
    };
  };
};
var getValueByStringPath = function(obj, path) {
  var e_1, _a2;
  path = path.replace(/\[(\w+)\]/g, ".$1");
  path = path.replace(/^\./, "");
  try {
    for (var _b2 = __values$1(path.split(".")), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
      var attr2 = _c2.value;
      if (attr2 in obj) {
        obj = obj[attr2];
      } else {
        return;
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c2 && !_c2.done && (_a2 = _b2.return)) _a2.call(_b2);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  return obj;
};
var getClientStates = function(client2, paths) {
  return function() {
    var e_2, _a2;
    var res = {};
    try {
      for (var paths_1 = __values$1(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
        var path = paths_1_1.value;
        res[path] = getValueByStringPath(client2, path);
      }
    } catch (e_2_1) {
      e_2 = { error: e_2_1 };
    } finally {
      try {
        if (paths_1_1 && !paths_1_1.done && (_a2 = paths_1.return)) _a2.call(paths_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    return res;
  };
};
var debugWrapper = function(fn, fnName, getLogConfig, getStates, fnContext) {
  if (fnContext === void 0) {
    fnContext = null;
  }
  return function() {
    var args = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      args[_i2] = arguments[_i2];
    }
    var _a2 = getLogConfig(), logger2 = _a2.logger, logLevel = _a2.logLevel;
    if (logLevel && logLevel < LogLevel.Debug || !logLevel || !logger2) {
      return fn.apply(fnContext, args);
    }
    var debugContext = {
      type: "invoke public method",
      name: fnName,
      args,
      stacktrace: getStacktrace(1),
      time: {
        start: (/* @__PURE__ */ new Date()).toISOString()
      },
      states: {}
    };
    if (getStates && debugContext.states) {
      debugContext.states.before = getStates();
    }
    var result2 = fn.apply(fnContext, args);
    if (result2 && result2.promise) {
      result2.promise.then(function() {
        if (getStates && debugContext.states) {
          debugContext.states.after = getStates();
        }
        if (debugContext.time) {
          debugContext.time.end = (/* @__PURE__ */ new Date()).toISOString();
        }
        logger2.debug(JSON.stringify(debugContext, null, 2));
      });
    } else {
      if (getStates && debugContext.states) {
        debugContext.states.after = getStates();
      }
      if (debugContext.time) {
        debugContext.time.end = (/* @__PURE__ */ new Date()).toISOString();
      }
      logger2.debug(JSON.stringify(debugContext, null, 2));
    }
    return result2;
  };
};
var MemoryStorage = (
  /** @class */
  function() {
    function MemoryStorage2() {
      this.memoryStorage = /* @__PURE__ */ new Map();
    }
    MemoryStorage2.prototype.isEnabled = function() {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          return [2, true];
        });
      });
    };
    MemoryStorage2.prototype.get = function(key) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          return [2, this.memoryStorage.get(key)];
        });
      });
    };
    MemoryStorage2.prototype.getRaw = function(key) {
      return __awaiter(this, void 0, void 0, function() {
        var value;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.get(key)];
            case 1:
              value = _a2.sent();
              return [2, value ? JSON.stringify(value) : void 0];
          }
        });
      });
    };
    MemoryStorage2.prototype.set = function(key, value) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          this.memoryStorage.set(key, value);
          return [
            2
            /*return*/
          ];
        });
      });
    };
    MemoryStorage2.prototype.remove = function(key) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          this.memoryStorage.delete(key);
          return [
            2
            /*return*/
          ];
        });
      });
    };
    MemoryStorage2.prototype.reset = function() {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          this.memoryStorage.clear();
          return [
            2
            /*return*/
          ];
        });
      });
    };
    return MemoryStorage2;
  }()
);
var BaseTransport = (
  /** @class */
  function() {
    function BaseTransport2() {
    }
    BaseTransport2.prototype.send = function(_serverUrl, _payload) {
      return Promise.resolve(null);
    };
    BaseTransport2.prototype.buildResponse = function(responseJSON) {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _j2, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
      if (typeof responseJSON !== "object") {
        return null;
      }
      var statusCode = responseJSON.code || 0;
      var status = this.buildStatus(statusCode);
      switch (status) {
        case Status.Success:
          return {
            status,
            statusCode,
            body: {
              eventsIngested: (_a2 = responseJSON.events_ingested) !== null && _a2 !== void 0 ? _a2 : 0,
              payloadSizeBytes: (_b2 = responseJSON.payload_size_bytes) !== null && _b2 !== void 0 ? _b2 : 0,
              serverUploadTime: (_c2 = responseJSON.server_upload_time) !== null && _c2 !== void 0 ? _c2 : 0
            }
          };
        case Status.Invalid:
          return {
            status,
            statusCode,
            body: {
              error: (_d2 = responseJSON.error) !== null && _d2 !== void 0 ? _d2 : "",
              missingField: (_e2 = responseJSON.missing_field) !== null && _e2 !== void 0 ? _e2 : "",
              eventsWithInvalidFields: (_f2 = responseJSON.events_with_invalid_fields) !== null && _f2 !== void 0 ? _f2 : {},
              eventsWithMissingFields: (_g2 = responseJSON.events_with_missing_fields) !== null && _g2 !== void 0 ? _g2 : {},
              eventsWithInvalidIdLengths: (_h2 = responseJSON.events_with_invalid_id_lengths) !== null && _h2 !== void 0 ? _h2 : {},
              epsThreshold: (_j2 = responseJSON.eps_threshold) !== null && _j2 !== void 0 ? _j2 : 0,
              exceededDailyQuotaDevices: (_k = responseJSON.exceeded_daily_quota_devices) !== null && _k !== void 0 ? _k : {},
              silencedDevices: (_l = responseJSON.silenced_devices) !== null && _l !== void 0 ? _l : [],
              silencedEvents: (_m = responseJSON.silenced_events) !== null && _m !== void 0 ? _m : [],
              throttledDevices: (_o = responseJSON.throttled_devices) !== null && _o !== void 0 ? _o : {},
              throttledEvents: (_p = responseJSON.throttled_events) !== null && _p !== void 0 ? _p : []
            }
          };
        case Status.PayloadTooLarge:
          return {
            status,
            statusCode,
            body: {
              error: (_q = responseJSON.error) !== null && _q !== void 0 ? _q : ""
            }
          };
        case Status.RateLimit:
          return {
            status,
            statusCode,
            body: {
              error: (_r = responseJSON.error) !== null && _r !== void 0 ? _r : "",
              epsThreshold: (_s = responseJSON.eps_threshold) !== null && _s !== void 0 ? _s : 0,
              throttledDevices: (_t = responseJSON.throttled_devices) !== null && _t !== void 0 ? _t : {},
              throttledUsers: (_u = responseJSON.throttled_users) !== null && _u !== void 0 ? _u : {},
              exceededDailyQuotaDevices: (_v = responseJSON.exceeded_daily_quota_devices) !== null && _v !== void 0 ? _v : {},
              exceededDailyQuotaUsers: (_w = responseJSON.exceeded_daily_quota_users) !== null && _w !== void 0 ? _w : {},
              throttledEvents: (_x = responseJSON.throttled_events) !== null && _x !== void 0 ? _x : []
            }
          };
        case Status.Timeout:
        default:
          return {
            status,
            statusCode
          };
      }
    };
    BaseTransport2.prototype.buildStatus = function(code) {
      if (code >= 200 && code < 300) {
        return Status.Success;
      }
      if (code === 429) {
        return Status.RateLimit;
      }
      if (code === 413) {
        return Status.PayloadTooLarge;
      }
      if (code === 408) {
        return Status.Timeout;
      }
      if (code >= 400 && code < 500) {
        return Status.Invalid;
      }
      if (code >= 500) {
        return Status.Failed;
      }
      return Status.Unknown;
    };
    return BaseTransport2;
  }()
);
var getGlobalScope = function() {
  var ampIntegrationContextName = "ampIntegrationContext";
  if (typeof globalThis !== "undefined" && typeof globalThis[ampIntegrationContextName] !== "undefined") {
    return globalThis[ampIntegrationContextName];
  }
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  return void 0;
};
var getQueryParams = function() {
  var _a2;
  var globalScope = getGlobalScope();
  if (!((_a2 = globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) === null || _a2 === void 0 ? void 0 : _a2.search)) {
    return {};
  }
  var pairs = globalScope.location.search.substring(1).split("&").filter(Boolean);
  var params = pairs.reduce(function(acc, curr) {
    var query = curr.split("=", 2);
    var key = tryDecodeURIComponent(query[0]);
    var value = tryDecodeURIComponent(query[1]);
    if (!value) {
      return acc;
    }
    acc[key] = value;
    return acc;
  }, {});
  return params;
};
var tryDecodeURIComponent = function(value) {
  if (value === void 0) {
    value = "";
  }
  try {
    return decodeURIComponent(value);
  } catch (_a2) {
    return "";
  }
};
var UTM_CAMPAIGN = "utm_campaign";
var UTM_CONTENT = "utm_content";
var UTM_ID = "utm_id";
var UTM_MEDIUM = "utm_medium";
var UTM_SOURCE = "utm_source";
var UTM_TERM = "utm_term";
var DCLID = "dclid";
var FBCLID = "fbclid";
var GBRAID = "gbraid";
var GCLID = "gclid";
var KO_CLICK_ID = "ko_click_id";
var LI_FAT_ID = "li_fat_id";
var MSCLKID = "msclkid";
var RDT_CID = "rtd_cid";
var TTCLID = "ttclid";
var TWCLID = "twclid";
var WBRAID = "wbraid";
var BASE_CAMPAIGN = {
  utm_campaign: void 0,
  utm_content: void 0,
  utm_id: void 0,
  utm_medium: void 0,
  utm_source: void 0,
  utm_term: void 0,
  referrer: void 0,
  referring_domain: void 0,
  dclid: void 0,
  gbraid: void 0,
  gclid: void 0,
  fbclid: void 0,
  ko_click_id: void 0,
  li_fat_id: void 0,
  msclkid: void 0,
  rtd_cid: void 0,
  ttclid: void 0,
  twclid: void 0,
  wbraid: void 0
};
var CampaignParser = (
  /** @class */
  function() {
    function CampaignParser2() {
    }
    CampaignParser2.prototype.parse = function() {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          return [2, __assign$1(__assign$1(__assign$1(__assign$1({}, BASE_CAMPAIGN), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
        });
      });
    };
    CampaignParser2.prototype.getUtmParam = function() {
      var params = getQueryParams();
      var utmCampaign = params[UTM_CAMPAIGN];
      var utmContent = params[UTM_CONTENT];
      var utmId = params[UTM_ID];
      var utmMedium = params[UTM_MEDIUM];
      var utmSource = params[UTM_SOURCE];
      var utmTerm = params[UTM_TERM];
      return {
        utm_campaign: utmCampaign,
        utm_content: utmContent,
        utm_id: utmId,
        utm_medium: utmMedium,
        utm_source: utmSource,
        utm_term: utmTerm
      };
    };
    CampaignParser2.prototype.getReferrer = function() {
      var _a2, _b2;
      var data = {
        referrer: void 0,
        referring_domain: void 0
      };
      try {
        data.referrer = document.referrer || void 0;
        data.referring_domain = (_b2 = (_a2 = data.referrer) === null || _a2 === void 0 ? void 0 : _a2.split("/")[2]) !== null && _b2 !== void 0 ? _b2 : void 0;
      } catch (_c2) {
      }
      return data;
    };
    CampaignParser2.prototype.getClickIds = function() {
      var _a2;
      var params = getQueryParams();
      return _a2 = {}, _a2[DCLID] = params[DCLID], _a2[FBCLID] = params[FBCLID], _a2[GBRAID] = params[GBRAID], _a2[GCLID] = params[GCLID], _a2[KO_CLICK_ID] = params[KO_CLICK_ID], _a2[LI_FAT_ID] = params[LI_FAT_ID], _a2[MSCLKID] = params[MSCLKID], _a2[RDT_CID] = params[RDT_CID], _a2[TTCLID] = params[TTCLID], _a2[TWCLID] = params[TWCLID], _a2[WBRAID] = params[WBRAID], _a2;
    };
    return CampaignParser2;
  }()
);
var getCookieName = function(apiKey, postKey, limit) {
  if (postKey === void 0) {
    postKey = "";
  }
  if (limit === void 0) {
    limit = 10;
  }
  return [AMPLITUDE_PREFIX, postKey, apiKey.substring(0, limit)].filter(Boolean).join("_");
};
var getOldCookieName = function(apiKey) {
  return "".concat(AMPLITUDE_PREFIX.toLowerCase(), "_").concat(apiKey.substring(0, 6));
};
var domainWithoutSubdomain = function(domain) {
  var parts = domain.split(".");
  if (parts.length <= 2) {
    return domain;
  }
  return parts.slice(parts.length - 2, parts.length).join(".");
};
var isDirectTraffic = function(current) {
  return Object.values(current).every(function(value) {
    return !value;
  });
};
var isNewCampaign = function(current, previous, options, logger2, isNewSession2) {
  if (isNewSession2 === void 0) {
    isNewSession2 = true;
  }
  current.referrer;
  var referring_domain = current.referring_domain, currentCampaign = __rest(current, ["referrer", "referring_domain"]);
  var _a2 = previous || {};
  _a2.referrer;
  var prevReferringDomain = _a2.referring_domain, previousCampaign = __rest(_a2, ["referrer", "referring_domain"]);
  if (isExcludedReferrer(options.excludeReferrers, current.referring_domain)) {
    logger2.debug("This is not a new campaign because ".concat(current.referring_domain, " is in the exclude referrer list."));
    return false;
  }
  if (!isNewSession2 && isDirectTraffic(current) && previous) {
    logger2.debug("This is not a new campaign because this is a direct traffic in the same session.");
    return false;
  }
  var hasNewCampaign = JSON.stringify(currentCampaign) !== JSON.stringify(previousCampaign);
  var hasNewDomain = domainWithoutSubdomain(referring_domain || "") !== domainWithoutSubdomain(prevReferringDomain || "");
  var result2 = !previous || hasNewCampaign || hasNewDomain;
  if (!result2) {
    logger2.debug("This is not a new campaign because it's the same as the previous one.");
  } else {
    logger2.debug("This is a new campaign. An $identify event will be sent.");
  }
  return result2;
};
var isExcludedReferrer = function(excludeReferrers, referringDomain) {
  if (excludeReferrers === void 0) {
    excludeReferrers = [];
  }
  if (referringDomain === void 0) {
    referringDomain = "";
  }
  return excludeReferrers.some(function(value) {
    return value instanceof RegExp ? value.test(referringDomain) : value === referringDomain;
  });
};
var createCampaignEvent = function(campaign, options) {
  var campaignParameters = __assign$1(__assign$1({}, BASE_CAMPAIGN), campaign);
  var identifyEvent = Object.entries(campaignParameters).reduce(function(identify2, _a2) {
    var _b2;
    var _c2 = __read$1(_a2, 2), key = _c2[0], value = _c2[1];
    identify2.setOnce("initial_".concat(key), (_b2 = value !== null && value !== void 0 ? value : options.initialEmptyValue) !== null && _b2 !== void 0 ? _b2 : "EMPTY");
    if (value) {
      return identify2.set(key, value);
    }
    return identify2.unset(key);
  }, new Identify());
  return createIdentifyEvent(identifyEvent);
};
var getDefaultExcludedReferrers = function(cookieDomain) {
  var domain = cookieDomain;
  if (domain) {
    if (domain.startsWith(".")) {
      domain = domain.substring(1);
    }
    return [new RegExp("".concat(domain.replace(".", "\\."), "$"))];
  }
  return [];
};
var getStorageKey = function(apiKey, postKey, limit) {
  if (limit === void 0) {
    limit = 10;
  }
  return [AMPLITUDE_PREFIX, postKey, apiKey.substring(0, limit)].filter(Boolean).join("_");
};
var isNewSession = function(sessionTimeout, lastEventTime) {
  if (lastEventTime === void 0) {
    lastEventTime = Date.now();
  }
  var currentTime = Date.now();
  var timeSinceLastEvent = currentTime - lastEventTime;
  return timeSinceLastEvent > sessionTimeout;
};
var WebAttribution = (
  /** @class */
  function() {
    function WebAttribution2(options, config2) {
      var _a2;
      this.shouldTrackNewCampaign = false;
      this.options = __assign$1({ initialEmptyValue: "EMPTY", resetSessionOnNewCampaign: false, excludeReferrers: getDefaultExcludedReferrers((_a2 = config2.cookieOptions) === null || _a2 === void 0 ? void 0 : _a2.domain) }, options);
      this.storage = config2.cookieStorage;
      this.storageKey = getStorageKey(config2.apiKey, "MKTG");
      this.currentCampaign = BASE_CAMPAIGN;
      this.sessionTimeout = config2.sessionTimeout;
      this.lastEventTime = config2.lastEventTime;
      this.logger = config2.loggerProvider;
      config2.loggerProvider.log("Installing web attribution tracking.");
    }
    WebAttribution2.prototype.init = function() {
      return __awaiter(this, void 0, void 0, function() {
        var isEventInNewSession;
        var _a2;
        return __generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, this.fetchCampaign()];
            case 1:
              _a2 = __read$1.apply(void 0, [_b2.sent(), 2]), this.currentCampaign = _a2[0], this.previousCampaign = _a2[1];
              isEventInNewSession = !this.lastEventTime ? true : isNewSession(this.sessionTimeout, this.lastEventTime);
              if (!isNewCampaign(this.currentCampaign, this.previousCampaign, this.options, this.logger, isEventInNewSession)) return [3, 3];
              this.shouldTrackNewCampaign = true;
              return [4, this.storage.set(this.storageKey, this.currentCampaign)];
            case 2:
              _b2.sent();
              _b2.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    WebAttribution2.prototype.fetchCampaign = function() {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, Promise.all([new CampaignParser().parse(), this.storage.get(this.storageKey)])];
            case 1:
              return [2, _a2.sent()];
          }
        });
      });
    };
    WebAttribution2.prototype.generateCampaignEvent = function(event_id) {
      this.shouldTrackNewCampaign = false;
      var campaignEvent = createCampaignEvent(this.currentCampaign, this.options);
      if (event_id) {
        campaignEvent.event_id = event_id;
      }
      return campaignEvent;
    };
    WebAttribution2.prototype.shouldSetSessionIdOnNewCampaign = function() {
      return this.shouldTrackNewCampaign && !!this.options.resetSessionOnNewCampaign;
    };
    return WebAttribution2;
  }()
);
var CookieStorage = (
  /** @class */
  function() {
    function CookieStorage2(options) {
      this.options = __assign$1({}, options);
    }
    CookieStorage2.prototype.isEnabled = function() {
      return __awaiter(this, void 0, void 0, function() {
        var testStrorage, testKey, value;
        return __generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (!getGlobalScope()) {
                return [2, false];
              }
              CookieStorage2.testValue = String(Date.now());
              testStrorage = new CookieStorage2(this.options);
              testKey = "AMP_TEST";
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 4, 5, 7]);
              return [4, testStrorage.set(testKey, CookieStorage2.testValue)];
            case 2:
              _b2.sent();
              return [4, testStrorage.get(testKey)];
            case 3:
              value = _b2.sent();
              return [2, value === CookieStorage2.testValue];
            case 4:
              _b2.sent();
              return [2, false];
            case 5:
              return [4, testStrorage.remove(testKey)];
            case 6:
              _b2.sent();
              return [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    CookieStorage2.prototype.get = function(key) {
      var _a2;
      return __awaiter(this, void 0, void 0, function() {
        var value, decodedValue;
        return __generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, this.getRaw(key)];
            case 1:
              value = _b2.sent();
              if (!value) {
                return [2, void 0];
              }
              try {
                decodedValue = (_a2 = decodeCookiesAsDefault(value)) !== null && _a2 !== void 0 ? _a2 : decodeCookiesWithDoubleUrlEncoding(value);
                if (decodedValue === void 0) {
                  console.error("Amplitude Logger [Error]: Failed to decode cookie value for key: ".concat(key, ", value: ").concat(value));
                  return [2, void 0];
                }
                return [2, JSON.parse(decodedValue)];
              } catch (_c2) {
                console.error("Amplitude Logger [Error]: Failed to parse cookie value for key: ".concat(key, ", value: ").concat(value));
                return [2, void 0];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    CookieStorage2.prototype.getRaw = function(key) {
      var _a2, _b2;
      return __awaiter(this, void 0, void 0, function() {
        var globalScope, cookie, match;
        return __generator(this, function(_c2) {
          globalScope = getGlobalScope();
          cookie = (_b2 = (_a2 = globalScope === null || globalScope === void 0 ? void 0 : globalScope.document) === null || _a2 === void 0 ? void 0 : _a2.cookie.split("; ")) !== null && _b2 !== void 0 ? _b2 : [];
          match = cookie.find(function(c) {
            return c.indexOf(key + "=") === 0;
          });
          if (!match) {
            return [2, void 0];
          }
          return [2, match.substring(key.length + 1)];
        });
      });
    };
    CookieStorage2.prototype.set = function(key, value) {
      var _a2;
      return __awaiter(this, void 0, void 0, function() {
        var expirationDays, expires, expireDate, date, str, globalScope, errorMessage;
        return __generator(this, function(_b2) {
          try {
            expirationDays = (_a2 = this.options.expirationDays) !== null && _a2 !== void 0 ? _a2 : 0;
            expires = value !== null ? expirationDays : -1;
            expireDate = void 0;
            if (expires) {
              date = /* @__PURE__ */ new Date();
              date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1e3);
              expireDate = date;
            }
            str = "".concat(key, "=").concat(btoa(encodeURIComponent(JSON.stringify(value))));
            if (expireDate) {
              str += "; expires=".concat(expireDate.toUTCString());
            }
            str += "; path=/";
            if (this.options.domain) {
              str += "; domain=".concat(this.options.domain);
            }
            if (this.options.secure) {
              str += "; Secure";
            }
            if (this.options.sameSite) {
              str += "; SameSite=".concat(this.options.sameSite);
            }
            globalScope = getGlobalScope();
            if (globalScope) {
              globalScope.document.cookie = str;
            }
          } catch (error) {
            errorMessage = error instanceof Error ? error.message : String(error);
            console.error("Amplitude Logger [Error]: Failed to set cookie for key: ".concat(key, ". Error: ").concat(errorMessage));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    };
    CookieStorage2.prototype.remove = function(key) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.set(key, null)];
            case 1:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    CookieStorage2.prototype.reset = function() {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          return [
            2
            /*return*/
          ];
        });
      });
    };
    return CookieStorage2;
  }()
);
var decodeCookiesAsDefault = function(value) {
  try {
    return decodeURIComponent(atob(value));
  } catch (_a2) {
    return void 0;
  }
};
var decodeCookiesWithDoubleUrlEncoding = function(value) {
  try {
    return decodeURIComponent(atob(decodeURIComponent(value)));
  } catch (_a2) {
    return void 0;
  }
};
var FetchTransport = (
  /** @class */
  function(_super) {
    __extends(FetchTransport2, _super);
    function FetchTransport2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    FetchTransport2.prototype.send = function(serverUrl, payload) {
      return __awaiter(this, void 0, void 0, function() {
        var options, response, responseText;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (typeof fetch === "undefined") {
                throw new Error("FetchTransport is not supported");
              }
              options = {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "*/*"
                },
                body: JSON.stringify(payload),
                method: "POST"
              };
              return [4, fetch(serverUrl, options)];
            case 1:
              response = _a2.sent();
              return [4, response.text()];
            case 2:
              responseText = _a2.sent();
              try {
                return [2, this.buildResponse(JSON.parse(responseText))];
              } catch (_b2) {
                return [2, this.buildResponse({ code: response.status })];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    return FetchTransport2;
  }(BaseTransport)
);
var ApplicationContextProviderImpl = (
  /** @class */
  function() {
    function ApplicationContextProviderImpl2() {
    }
    ApplicationContextProviderImpl2.prototype.getApplicationContext = function() {
      return {
        versionName: this.versionName,
        language: getLanguage$1(),
        platform: "Web",
        os: void 0,
        deviceModel: void 0
      };
    };
    return ApplicationContextProviderImpl2;
  }()
);
var getLanguage$1 = function() {
  return typeof navigator !== "undefined" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
};
var EventBridgeImpl = (
  /** @class */
  function() {
    function EventBridgeImpl2() {
      this.queue = [];
    }
    EventBridgeImpl2.prototype.logEvent = function(event) {
      if (!this.receiver) {
        if (this.queue.length < 512) {
          this.queue.push(event);
        }
      } else {
        this.receiver(event);
      }
    };
    EventBridgeImpl2.prototype.setEventReceiver = function(receiver) {
      this.receiver = receiver;
      if (this.queue.length > 0) {
        this.queue.forEach(function(event) {
          receiver(event);
        });
        this.queue = [];
      }
    };
    return EventBridgeImpl2;
  }()
);
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var isEqual = function(obj1, obj2) {
  var e_1, _a2;
  var primitive = ["string", "number", "boolean", "undefined"];
  var typeA = typeof obj1;
  var typeB = typeof obj2;
  if (typeA !== typeB) {
    return false;
  }
  try {
    for (var primitive_1 = __values(primitive), primitive_1_1 = primitive_1.next(); !primitive_1_1.done; primitive_1_1 = primitive_1.next()) {
      var p = primitive_1_1.value;
      if (p === typeA) {
        return obj1 === obj2;
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (primitive_1_1 && !primitive_1_1.done && (_a2 = primitive_1.return)) _a2.call(primitive_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  if (obj1 == null && obj2 == null) {
    return true;
  } else if (obj1 == null || obj2 == null) {
    return false;
  }
  if (obj1.length !== obj2.length) {
    return false;
  }
  var isArrayA = Array.isArray(obj1);
  var isArrayB = Array.isArray(obj2);
  if (isArrayA !== isArrayB) {
    return false;
  }
  if (isArrayA && isArrayB) {
    for (var i = 0; i < obj1.length; i++) {
      if (!isEqual(obj1[i], obj2[i])) {
        return false;
      }
    }
  } else {
    var sorted1 = Object.keys(obj1).sort();
    var sorted2 = Object.keys(obj2).sort();
    if (!isEqual(sorted1, sorted2)) {
      return false;
    }
    var result_1 = true;
    Object.keys(obj1).forEach(function(key) {
      if (!isEqual(obj1[key], obj2[key])) {
        result_1 = false;
      }
    });
    return result_1;
  }
  return true;
};
var ID_OP_SET = "$set";
var ID_OP_UNSET = "$unset";
var ID_OP_CLEAR_ALL = "$clearAll";
if (!Object.entries) {
  Object.entries = function(obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  };
}
var IdentityStoreImpl = (
  /** @class */
  function() {
    function IdentityStoreImpl2() {
      this.identity = { userProperties: {} };
      this.listeners = /* @__PURE__ */ new Set();
    }
    IdentityStoreImpl2.prototype.editIdentity = function() {
      var self2 = this;
      var actingUserProperties = __assign({}, this.identity.userProperties);
      var actingIdentity = __assign(__assign({}, this.identity), { userProperties: actingUserProperties });
      return {
        setUserId: function(userId) {
          actingIdentity.userId = userId;
          return this;
        },
        setDeviceId: function(deviceId) {
          actingIdentity.deviceId = deviceId;
          return this;
        },
        setUserProperties: function(userProperties) {
          actingIdentity.userProperties = userProperties;
          return this;
        },
        setOptOut: function(optOut) {
          actingIdentity.optOut = optOut;
          return this;
        },
        updateUserProperties: function(actions) {
          var e_1, _a2, e_2, _b2, e_3, _c2;
          var actingProperties = actingIdentity.userProperties || {};
          try {
            for (var _d2 = __values(Object.entries(actions)), _e2 = _d2.next(); !_e2.done; _e2 = _d2.next()) {
              var _f2 = __read(_e2.value, 2), action = _f2[0], properties = _f2[1];
              switch (action) {
                case ID_OP_SET:
                  try {
                    for (var _g2 = (e_2 = void 0, __values(Object.entries(properties))), _h2 = _g2.next(); !_h2.done; _h2 = _g2.next()) {
                      var _j2 = __read(_h2.value, 2), key = _j2[0], value = _j2[1];
                      actingProperties[key] = value;
                    }
                  } catch (e_2_1) {
                    e_2 = { error: e_2_1 };
                  } finally {
                    try {
                      if (_h2 && !_h2.done && (_b2 = _g2.return)) _b2.call(_g2);
                    } finally {
                      if (e_2) throw e_2.error;
                    }
                  }
                  break;
                case ID_OP_UNSET:
                  try {
                    for (var _k = (e_3 = void 0, __values(Object.keys(properties))), _l = _k.next(); !_l.done; _l = _k.next()) {
                      var key = _l.value;
                      delete actingProperties[key];
                    }
                  } catch (e_3_1) {
                    e_3 = { error: e_3_1 };
                  } finally {
                    try {
                      if (_l && !_l.done && (_c2 = _k.return)) _c2.call(_k);
                    } finally {
                      if (e_3) throw e_3.error;
                    }
                  }
                  break;
                case ID_OP_CLEAR_ALL:
                  actingProperties = {};
                  break;
              }
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (_e2 && !_e2.done && (_a2 = _d2.return)) _a2.call(_d2);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
          actingIdentity.userProperties = actingProperties;
          return this;
        },
        commit: function() {
          self2.setIdentity(actingIdentity);
          return this;
        }
      };
    };
    IdentityStoreImpl2.prototype.getIdentity = function() {
      return __assign({}, this.identity);
    };
    IdentityStoreImpl2.prototype.setIdentity = function(identity2) {
      var originalIdentity = __assign({}, this.identity);
      this.identity = __assign({}, identity2);
      if (!isEqual(originalIdentity, this.identity)) {
        this.listeners.forEach(function(listener) {
          listener(identity2);
        });
      }
    };
    IdentityStoreImpl2.prototype.addIdentityListener = function(listener) {
      this.listeners.add(listener);
    };
    IdentityStoreImpl2.prototype.removeIdentityListener = function(listener) {
      this.listeners.delete(listener);
    };
    return IdentityStoreImpl2;
  }()
);
var safeGlobal = typeof globalThis !== "undefined" ? globalThis : typeof global !== "undefined" ? global : self;
var AnalyticsConnector = (
  /** @class */
  function() {
    function AnalyticsConnector2() {
      this.identityStore = new IdentityStoreImpl();
      this.eventBridge = new EventBridgeImpl();
      this.applicationContextProvider = new ApplicationContextProviderImpl();
    }
    AnalyticsConnector2.getInstance = function(instanceName) {
      if (!safeGlobal["analyticsConnectorInstances"]) {
        safeGlobal["analyticsConnectorInstances"] = {};
      }
      if (!safeGlobal["analyticsConnectorInstances"][instanceName]) {
        safeGlobal["analyticsConnectorInstances"][instanceName] = new AnalyticsConnector2();
      }
      return safeGlobal["analyticsConnectorInstances"][instanceName];
    };
    return AnalyticsConnector2;
  }()
);
var getAnalyticsConnector = function(instanceName) {
  if (instanceName === void 0) {
    instanceName = "$default_instance";
  }
  return AnalyticsConnector.getInstance(instanceName);
};
var setConnectorUserId = function(userId, instanceName) {
  getAnalyticsConnector(instanceName).identityStore.editIdentity().setUserId(userId).commit();
};
var setConnectorDeviceId = function(deviceId, instanceName) {
  getAnalyticsConnector(instanceName).identityStore.editIdentity().setDeviceId(deviceId).commit();
};
var IdentityEventSender = (
  /** @class */
  function() {
    function IdentityEventSender2() {
      this.name = "identity";
      this.type = "before";
      this.identityStore = getAnalyticsConnector().identityStore;
    }
    IdentityEventSender2.prototype.execute = function(context) {
      return __awaiter(this, void 0, void 0, function() {
        var userProperties;
        return __generator(this, function(_a2) {
          userProperties = context.user_properties;
          if (userProperties) {
            this.identityStore.editIdentity().updateUserProperties(userProperties).commit();
          }
          return [2, context];
        });
      });
    };
    IdentityEventSender2.prototype.setup = function(config2) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          if (config2.instanceName) {
            this.identityStore = getAnalyticsConnector(config2.instanceName).identityStore;
          }
          return [
            2
            /*return*/
          ];
        });
      });
    };
    return IdentityEventSender2;
  }()
);
var getLanguage = function() {
  var _a2, _b2, _c2, _d2;
  if (typeof navigator === "undefined")
    return "";
  var userLanguage = navigator.userLanguage;
  return (_d2 = (_c2 = (_b2 = (_a2 = navigator.languages) === null || _a2 === void 0 ? void 0 : _a2[0]) !== null && _b2 !== void 0 ? _b2 : navigator.language) !== null && _c2 !== void 0 ? _c2 : userLanguage) !== null && _d2 !== void 0 ? _d2 : "";
};
var isTrackingEnabled = function(autocapture, event) {
  if (typeof autocapture === "boolean") {
    return autocapture;
  }
  if ((autocapture === null || autocapture === void 0 ? void 0 : autocapture[event]) === false) {
    return false;
  }
  return true;
};
var isAttributionTrackingEnabled = function(autocapture) {
  return isTrackingEnabled(autocapture, "attribution");
};
var isFileDownloadTrackingEnabled = function(autocapture) {
  return isTrackingEnabled(autocapture, "fileDownloads");
};
var isFormInteractionTrackingEnabled = function(autocapture) {
  return isTrackingEnabled(autocapture, "formInteractions");
};
var isPageViewTrackingEnabled = function(autocapture) {
  return isTrackingEnabled(autocapture, "pageViews");
};
var isSessionTrackingEnabled = function(autocapture) {
  return isTrackingEnabled(autocapture, "sessions");
};
var isElementInteractionsEnabled = function(autocapture) {
  if (typeof autocapture === "boolean") {
    return autocapture;
  }
  if (typeof autocapture === "object" && (autocapture.elementInteractions === true || typeof autocapture.elementInteractions === "object")) {
    return true;
  }
  return false;
};
var getElementInteractionsConfig = function(config2) {
  if (isElementInteractionsEnabled(config2.autocapture) && typeof config2.autocapture === "object" && typeof config2.autocapture.elementInteractions === "object") {
    return config2.autocapture.elementInteractions;
  }
  return void 0;
};
var getPageViewTrackingConfig = function(config2) {
  var trackOn = function() {
    return false;
  };
  var trackHistoryChanges = void 0;
  var eventType;
  var pageCounter = config2.pageCounter;
  var isDefaultPageViewTrackingEnabled = isPageViewTrackingEnabled(config2.defaultTracking);
  if (isDefaultPageViewTrackingEnabled) {
    trackOn = void 0;
    eventType = void 0;
    if (config2.defaultTracking && typeof config2.defaultTracking === "object" && config2.defaultTracking.pageViews && typeof config2.defaultTracking.pageViews === "object") {
      if ("trackOn" in config2.defaultTracking.pageViews) {
        trackOn = config2.defaultTracking.pageViews.trackOn;
      }
      if ("trackHistoryChanges" in config2.defaultTracking.pageViews) {
        trackHistoryChanges = config2.defaultTracking.pageViews.trackHistoryChanges;
      }
      if ("eventType" in config2.defaultTracking.pageViews && config2.defaultTracking.pageViews.eventType) {
        eventType = config2.defaultTracking.pageViews.eventType;
      }
    }
  }
  return {
    trackOn,
    trackHistoryChanges,
    eventType,
    pageCounter
  };
};
var getAttributionTrackingConfig = function(config2) {
  if (isAttributionTrackingEnabled(config2.defaultTracking) && config2.defaultTracking && typeof config2.defaultTracking === "object" && config2.defaultTracking.attribution && typeof config2.defaultTracking.attribution === "object") {
    return __assign$1({}, config2.defaultTracking.attribution);
  }
  return {};
};
var convertProxyObjectToRealObject = function(instance, queue) {
  for (var i = 0; i < queue.length; i++) {
    var _a2 = queue[i], name_1 = _a2.name, args = _a2.args, resolve2 = _a2.resolve;
    var fn = instance && instance[name_1];
    if (typeof fn === "function") {
      var result2 = fn.apply(instance, args);
      if (typeof resolve2 === "function") {
        resolve2(result2 === null || result2 === void 0 ? void 0 : result2.promise);
      }
    }
  }
  return instance;
};
var isInstanceProxy = function(instance) {
  var instanceProxy = instance;
  return instanceProxy && instanceProxy._q !== void 0;
};
var VERSION = "2.11.13";
var LIBPREFIX = "amplitude-ts";
var BROWSER_PLATFORM = "Web";
var IP_ADDRESS = "$remote";
var Context$1 = (
  /** @class */
  function() {
    function Context2() {
      this.name = "@amplitude/plugin-context-browser";
      this.type = "before";
      this.library = "".concat(LIBPREFIX, "/").concat(VERSION);
      if (typeof navigator !== "undefined") {
        this.userAgent = navigator.userAgent;
      }
    }
    Context2.prototype.setup = function(config2) {
      this.config = config2;
      return Promise.resolve(void 0);
    };
    Context2.prototype.execute = function(context) {
      return __awaiter(this, void 0, void 0, function() {
        var time, lastEventId, nextEventId, event;
        var _a2, _b2;
        return __generator(this, function(_c2) {
          time = (/* @__PURE__ */ new Date()).getTime();
          lastEventId = (_a2 = this.config.lastEventId) !== null && _a2 !== void 0 ? _a2 : -1;
          nextEventId = (_b2 = context.event_id) !== null && _b2 !== void 0 ? _b2 : lastEventId + 1;
          this.config.lastEventId = nextEventId;
          if (!context.time) {
            this.config.lastEventTime = time;
          }
          event = __assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1({ user_id: this.config.userId, device_id: this.config.deviceId, session_id: this.config.sessionId, time }, this.config.appVersion && { app_version: this.config.appVersion }), this.config.trackingOptions.platform && { platform: BROWSER_PLATFORM }), this.config.trackingOptions.language && { language: getLanguage() }), this.config.trackingOptions.ipAddress && { ip: IP_ADDRESS }), { insert_id: UUID(), partner_id: this.config.partnerId, plan: this.config.plan }), this.config.ingestionMetadata && {
            ingestion_metadata: {
              source_name: this.config.ingestionMetadata.sourceName,
              source_version: this.config.ingestionMetadata.sourceVersion
            }
          }), context), { event_id: nextEventId, library: this.library, user_agent: this.userAgent });
          return [2, event];
        });
      });
    };
    return Context2;
  }()
);
var BrowserStorage = (
  /** @class */
  function() {
    function BrowserStorage2(storage) {
      this.storage = storage;
    }
    BrowserStorage2.prototype.isEnabled = function() {
      return __awaiter(this, void 0, void 0, function() {
        var random, testStorage, testKey, value;
        return __generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (!this.storage) {
                return [2, false];
              }
              random = String(Date.now());
              testStorage = new BrowserStorage2(this.storage);
              testKey = "AMP_TEST";
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 4, 5, 7]);
              return [4, testStorage.set(testKey, random)];
            case 2:
              _b2.sent();
              return [4, testStorage.get(testKey)];
            case 3:
              value = _b2.sent();
              return [2, value === random];
            case 4:
              _b2.sent();
              return [2, false];
            case 5:
              return [4, testStorage.remove(testKey)];
            case 6:
              _b2.sent();
              return [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    BrowserStorage2.prototype.get = function(key) {
      return __awaiter(this, void 0, void 0, function() {
        var value;
        return __generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              _b2.trys.push([0, 2, , 3]);
              return [4, this.getRaw(key)];
            case 1:
              value = _b2.sent();
              if (!value) {
                return [2, void 0];
              }
              return [2, JSON.parse(value)];
            case 2:
              _b2.sent();
              console.error("[Amplitude] Error: Could not get value from storage");
              return [2, void 0];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    BrowserStorage2.prototype.getRaw = function(key) {
      return __awaiter(this, void 0, void 0, function() {
        var _a2;
        return __generator(this, function(_b2) {
          return [2, ((_a2 = this.storage) === null || _a2 === void 0 ? void 0 : _a2.getItem(key)) || void 0];
        });
      });
    };
    BrowserStorage2.prototype.set = function(key, value) {
      return __awaiter(this, void 0, void 0, function() {
        var _a2;
        return __generator(this, function(_b2) {
          try {
            (_a2 = this.storage) === null || _a2 === void 0 ? void 0 : _a2.setItem(key, JSON.stringify(value));
          } catch (_c2) {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    };
    BrowserStorage2.prototype.remove = function(key) {
      return __awaiter(this, void 0, void 0, function() {
        var _a2;
        return __generator(this, function(_b2) {
          try {
            (_a2 = this.storage) === null || _a2 === void 0 ? void 0 : _a2.removeItem(key);
          } catch (_c2) {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    };
    BrowserStorage2.prototype.reset = function() {
      return __awaiter(this, void 0, void 0, function() {
        var _a2;
        return __generator(this, function(_b2) {
          try {
            (_a2 = this.storage) === null || _a2 === void 0 ? void 0 : _a2.clear();
          } catch (_c2) {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    };
    return BrowserStorage2;
  }()
);
var MAX_ARRAY_LENGTH = 1e3;
var LocalStorage = (
  /** @class */
  function(_super) {
    __extends(LocalStorage2, _super);
    function LocalStorage2(config2) {
      var _a2;
      var _this = _super.call(this, (_a2 = getGlobalScope()) === null || _a2 === void 0 ? void 0 : _a2.localStorage) || this;
      _this.loggerProvider = config2 === null || config2 === void 0 ? void 0 : config2.loggerProvider;
      return _this;
    }
    LocalStorage2.prototype.set = function(key, value) {
      return __awaiter(this, void 0, void 0, function() {
        var droppedEventsCount;
        var _a2;
        return __generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (!(Array.isArray(value) && value.length > MAX_ARRAY_LENGTH)) return [3, 2];
              droppedEventsCount = value.length - MAX_ARRAY_LENGTH;
              return [4, _super.prototype.set.call(this, key, value.slice(0, MAX_ARRAY_LENGTH))];
            case 1:
              _b2.sent();
              (_a2 = this.loggerProvider) === null || _a2 === void 0 ? void 0 : _a2.error("Failed to save ".concat(droppedEventsCount, " events because the queue length exceeded ").concat(MAX_ARRAY_LENGTH, "."));
              return [3, 4];
            case 2:
              return [4, _super.prototype.set.call(this, key, value)];
            case 3:
              _b2.sent();
              _b2.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    return LocalStorage2;
  }(BrowserStorage)
);
var SessionStorage = (
  /** @class */
  function(_super) {
    __extends(SessionStorage2, _super);
    function SessionStorage2() {
      var _a2;
      return _super.call(this, (_a2 = getGlobalScope()) === null || _a2 === void 0 ? void 0 : _a2.sessionStorage) || this;
    }
    return SessionStorage2;
  }(BrowserStorage)
);
var XHRTransport = (
  /** @class */
  function(_super) {
    __extends(XHRTransport2, _super);
    function XHRTransport2() {
      var _this = _super.apply(this, __spreadArray([], __read$1(arguments), false)) || this;
      _this.state = {
        done: 4
      };
      return _this;
    }
    XHRTransport2.prototype.send = function(serverUrl, payload) {
      return __awaiter(this, void 0, void 0, function() {
        var _this = this;
        return __generator(this, function(_a2) {
          return [2, new Promise(function(resolve2, reject) {
            if (typeof XMLHttpRequest === "undefined") {
              reject(new Error("XHRTransport is not supported."));
            }
            var xhr = new XMLHttpRequest();
            xhr.open("POST", serverUrl, true);
            xhr.onreadystatechange = function() {
              if (xhr.readyState === _this.state.done) {
                var responseText = xhr.responseText;
                try {
                  resolve2(_this.buildResponse(JSON.parse(responseText)));
                } catch (_a3) {
                  resolve2(_this.buildResponse({ code: xhr.status }));
                }
              }
            };
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.setRequestHeader("Accept", "*/*");
            xhr.send(JSON.stringify(payload));
          })];
        });
      });
    };
    return XHRTransport2;
  }(BaseTransport)
);
var SendBeaconTransport = (
  /** @class */
  function(_super) {
    __extends(SendBeaconTransport2, _super);
    function SendBeaconTransport2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    SendBeaconTransport2.prototype.send = function(serverUrl, payload) {
      return __awaiter(this, void 0, void 0, function() {
        var _this = this;
        return __generator(this, function(_a2) {
          return [2, new Promise(function(resolve2, reject) {
            var globalScope = getGlobalScope();
            if (!(globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator.sendBeacon)) {
              throw new Error("SendBeaconTransport is not supported");
            }
            try {
              var data = JSON.stringify(payload);
              var success = globalScope.navigator.sendBeacon(serverUrl, JSON.stringify(payload));
              if (success) {
                return resolve2(_this.buildResponse({
                  code: 200,
                  events_ingested: payload.events.length,
                  payload_size_bytes: data.length,
                  server_upload_time: Date.now()
                }));
              }
              return resolve2(_this.buildResponse({ code: 500 }));
            } catch (e) {
              reject(e);
            }
          })];
        });
      });
    };
    return SendBeaconTransport2;
  }(BaseTransport)
);
var parseLegacyCookies = function(apiKey_1, cookieStorage_1) {
  var args_1 = [];
  for (var _i2 = 2; _i2 < arguments.length; _i2++) {
    args_1[_i2 - 2] = arguments[_i2];
  }
  return __awaiter(void 0, __spreadArray([apiKey_1, cookieStorage_1], __read$1(args_1), false), void 0, function(apiKey, cookieStorage, deleteLegacyCookies) {
    var cookieName, cookies2, _a2, deviceId, userId, optOut, sessionId, lastEventTime, lastEventId;
    if (deleteLegacyCookies === void 0) {
      deleteLegacyCookies = true;
    }
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          cookieName = getOldCookieName(apiKey);
          return [4, cookieStorage.getRaw(cookieName)];
        case 1:
          cookies2 = _b2.sent();
          if (!cookies2) {
            return [2, {
              optOut: false
            }];
          }
          if (!deleteLegacyCookies) return [3, 3];
          return [4, cookieStorage.remove(cookieName)];
        case 2:
          _b2.sent();
          _b2.label = 3;
        case 3:
          _a2 = __read$1(cookies2.split("."), 6), deviceId = _a2[0], userId = _a2[1], optOut = _a2[2], sessionId = _a2[3], lastEventTime = _a2[4], lastEventId = _a2[5];
          return [2, {
            deviceId,
            userId: decode(userId),
            sessionId: parseTime(sessionId),
            lastEventId: parseTime(lastEventId),
            lastEventTime: parseTime(lastEventTime),
            optOut: Boolean(optOut)
          }];
      }
    });
  });
};
var parseTime = function(num) {
  var integer = parseInt(num, 32);
  if (isNaN(integer)) {
    return void 0;
  }
  return integer;
};
var decode = function(value) {
  if (!atob || !escape || !value) {
    return void 0;
  }
  try {
    return decodeURIComponent(escape(atob(value)));
  } catch (_a2) {
    return void 0;
  }
};
var DEFAULT_EVENT_PREFIX = "[Amplitude]";
var DEFAULT_FORM_START_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Form Started");
var DEFAULT_FORM_SUBMIT_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Form Submitted");
var DEFAULT_FILE_DOWNLOAD_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " File Downloaded");
var DEFAULT_SESSION_START_EVENT = "session_start";
var DEFAULT_SESSION_END_EVENT = "session_end";
var FILE_EXTENSION = "".concat(DEFAULT_EVENT_PREFIX, " File Extension");
var FILE_NAME = "".concat(DEFAULT_EVENT_PREFIX, " File Name");
var LINK_ID = "".concat(DEFAULT_EVENT_PREFIX, " Link ID");
var LINK_TEXT = "".concat(DEFAULT_EVENT_PREFIX, " Link Text");
var LINK_URL = "".concat(DEFAULT_EVENT_PREFIX, " Link URL");
var FORM_ID = "".concat(DEFAULT_EVENT_PREFIX, " Form ID");
var FORM_NAME = "".concat(DEFAULT_EVENT_PREFIX, " Form Name");
var FORM_DESTINATION = "".concat(DEFAULT_EVENT_PREFIX, " Form Destination");
var DEFAULT_IDENTITY_STORAGE = "cookie";
var DEFAULT_SERVER_ZONE = "US";
var BrowserConfig = (
  /** @class */
  function(_super) {
    __extends(BrowserConfig2, _super);
    function BrowserConfig2(apiKey, appVersion, cookieStorage, cookieOptions, defaultTracking, autocapture, deviceId, flushIntervalMillis, flushMaxRetries, flushQueueSize, identityStorage, ingestionMetadata, instanceName, lastEventId, lastEventTime, loggerProvider, logLevel, minIdLength, offline, optOut, partnerId, plan, serverUrl, serverZone, sessionId, sessionTimeout, storageProvider, trackingOptions, transport, useBatch, fetchRemoteConfig, userId, pageCounter, debugLogsEnabled) {
      if (cookieStorage === void 0) {
        cookieStorage = new MemoryStorage();
      }
      if (cookieOptions === void 0) {
        cookieOptions = {
          domain: "",
          expiration: 365,
          sameSite: "Lax",
          secure: false,
          upgrade: true
        };
      }
      if (flushIntervalMillis === void 0) {
        flushIntervalMillis = 1e3;
      }
      if (flushMaxRetries === void 0) {
        flushMaxRetries = 5;
      }
      if (flushQueueSize === void 0) {
        flushQueueSize = 30;
      }
      if (identityStorage === void 0) {
        identityStorage = DEFAULT_IDENTITY_STORAGE;
      }
      if (loggerProvider === void 0) {
        loggerProvider = new Logger();
      }
      if (logLevel === void 0) {
        logLevel = LogLevel.Warn;
      }
      if (offline === void 0) {
        offline = false;
      }
      if (optOut === void 0) {
        optOut = false;
      }
      if (serverUrl === void 0) {
        serverUrl = "";
      }
      if (serverZone === void 0) {
        serverZone = DEFAULT_SERVER_ZONE;
      }
      if (sessionTimeout === void 0) {
        sessionTimeout = 30 * 60 * 1e3;
      }
      if (storageProvider === void 0) {
        storageProvider = new LocalStorage({ loggerProvider });
      }
      if (trackingOptions === void 0) {
        trackingOptions = {
          ipAddress: true,
          language: true,
          platform: true
        };
      }
      if (transport === void 0) {
        transport = "fetch";
      }
      if (useBatch === void 0) {
        useBatch = false;
      }
      if (fetchRemoteConfig === void 0) {
        fetchRemoteConfig = false;
      }
      var _this = _super.call(this, { apiKey, storageProvider, transportProvider: createTransport(transport) }) || this;
      _this.apiKey = apiKey;
      _this.appVersion = appVersion;
      _this.cookieOptions = cookieOptions;
      _this.defaultTracking = defaultTracking;
      _this.autocapture = autocapture;
      _this.flushIntervalMillis = flushIntervalMillis;
      _this.flushMaxRetries = flushMaxRetries;
      _this.flushQueueSize = flushQueueSize;
      _this.identityStorage = identityStorage;
      _this.ingestionMetadata = ingestionMetadata;
      _this.instanceName = instanceName;
      _this.loggerProvider = loggerProvider;
      _this.logLevel = logLevel;
      _this.minIdLength = minIdLength;
      _this.offline = offline;
      _this.partnerId = partnerId;
      _this.plan = plan;
      _this.serverUrl = serverUrl;
      _this.serverZone = serverZone;
      _this.sessionTimeout = sessionTimeout;
      _this.storageProvider = storageProvider;
      _this.trackingOptions = trackingOptions;
      _this.transport = transport;
      _this.useBatch = useBatch;
      _this.fetchRemoteConfig = fetchRemoteConfig;
      _this._optOut = false;
      _this._cookieStorage = cookieStorage;
      _this.deviceId = deviceId;
      _this.lastEventId = lastEventId;
      _this.lastEventTime = lastEventTime;
      _this.optOut = optOut;
      _this.sessionId = sessionId;
      _this.pageCounter = pageCounter;
      _this.userId = userId;
      _this.debugLogsEnabled = debugLogsEnabled;
      _this.loggerProvider.enable(debugLogsEnabled ? LogLevel.Debug : _this.logLevel);
      return _this;
    }
    Object.defineProperty(BrowserConfig2.prototype, "cookieStorage", {
      get: function() {
        return this._cookieStorage;
      },
      set: function(cookieStorage) {
        if (this._cookieStorage !== cookieStorage) {
          this._cookieStorage = cookieStorage;
          this.updateStorage();
        }
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(BrowserConfig2.prototype, "deviceId", {
      get: function() {
        return this._deviceId;
      },
      set: function(deviceId) {
        if (this._deviceId !== deviceId) {
          this._deviceId = deviceId;
          this.updateStorage();
        }
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(BrowserConfig2.prototype, "userId", {
      get: function() {
        return this._userId;
      },
      set: function(userId) {
        if (this._userId !== userId) {
          this._userId = userId;
          this.updateStorage();
        }
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(BrowserConfig2.prototype, "sessionId", {
      get: function() {
        return this._sessionId;
      },
      set: function(sessionId) {
        if (this._sessionId !== sessionId) {
          this._sessionId = sessionId;
          this.updateStorage();
        }
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(BrowserConfig2.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(optOut) {
        if (this._optOut !== optOut) {
          this._optOut = optOut;
          this.updateStorage();
        }
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(BrowserConfig2.prototype, "lastEventTime", {
      get: function() {
        return this._lastEventTime;
      },
      set: function(lastEventTime) {
        if (this._lastEventTime !== lastEventTime) {
          this._lastEventTime = lastEventTime;
          this.updateStorage();
        }
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(BrowserConfig2.prototype, "lastEventId", {
      get: function() {
        return this._lastEventId;
      },
      set: function(lastEventId) {
        if (this._lastEventId !== lastEventId) {
          this._lastEventId = lastEventId;
          this.updateStorage();
        }
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(BrowserConfig2.prototype, "pageCounter", {
      get: function() {
        return this._pageCounter;
      },
      set: function(pageCounter) {
        if (this._pageCounter !== pageCounter) {
          this._pageCounter = pageCounter;
          this.updateStorage();
        }
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(BrowserConfig2.prototype, "debugLogsEnabled", {
      set: function(debugLogsEnabled) {
        if (this._debugLogsEnabled !== debugLogsEnabled) {
          this._debugLogsEnabled = debugLogsEnabled;
          this.updateStorage();
        }
      },
      enumerable: false,
      configurable: true
    });
    BrowserConfig2.prototype.updateStorage = function() {
      var cache2 = {
        deviceId: this._deviceId,
        userId: this._userId,
        sessionId: this._sessionId,
        optOut: this._optOut,
        lastEventTime: this._lastEventTime,
        lastEventId: this._lastEventId,
        pageCounter: this._pageCounter,
        debugLogsEnabled: this._debugLogsEnabled
      };
      void this.cookieStorage.set(getCookieName(this.apiKey), cache2);
    };
    return BrowserConfig2;
  }(Config)
);
var useBrowserConfig = function(apiKey_1) {
  var args_1 = [];
  for (var _i2 = 1; _i2 < arguments.length; _i2++) {
    args_1[_i2 - 1] = arguments[_i2];
  }
  return __awaiter(void 0, __spreadArray([apiKey_1], __read$1(args_1), false), void 0, function(apiKey, options, amplitudeInstance) {
    var identityStorage, cookieOptions, _a2, _b2, cookieStorage, legacyCookies, previousCookies, queryParams, deviceId, lastEventId, lastEventTime, optOut, sessionId, userId, trackingOptions, pageCounter, debugLogsEnabled, browserConfig;
    var _c2;
    var _d2, _e2, _f2, _g2, _h2, _j2, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    if (options === void 0) {
      options = {};
    }
    return __generator(this, function(_3) {
      switch (_3.label) {
        case 0:
          identityStorage = options.identityStorage || DEFAULT_IDENTITY_STORAGE;
          _c2 = {};
          if (!(identityStorage !== DEFAULT_IDENTITY_STORAGE)) return [3, 1];
          _a2 = "";
          return [3, 5];
        case 1:
          if (!((_e2 = (_d2 = options.cookieOptions) === null || _d2 === void 0 ? void 0 : _d2.domain) !== null && _e2 !== void 0)) return [3, 2];
          _b2 = _e2;
          return [3, 4];
        case 2:
          return [4, getTopLevelDomain()];
        case 3:
          _b2 = _3.sent();
          _3.label = 4;
        case 4:
          _a2 = _b2;
          _3.label = 5;
        case 5:
          cookieOptions = __assign$1.apply(void 0, [(_c2.domain = _a2, _c2.expiration = 365, _c2.sameSite = "Lax", _c2.secure = false, _c2.upgrade = true, _c2), options.cookieOptions]);
          cookieStorage = createCookieStorage(options.identityStorage, cookieOptions);
          return [4, parseLegacyCookies(apiKey, cookieStorage, (_g2 = (_f2 = options.cookieOptions) === null || _f2 === void 0 ? void 0 : _f2.upgrade) !== null && _g2 !== void 0 ? _g2 : true)];
        case 6:
          legacyCookies = _3.sent();
          return [4, cookieStorage.get(getCookieName(apiKey))];
        case 7:
          previousCookies = _3.sent();
          queryParams = getQueryParams();
          deviceId = (_m = (_l = (_k = (_j2 = (_h2 = options.deviceId) !== null && _h2 !== void 0 ? _h2 : queryParams.ampDeviceId) !== null && _j2 !== void 0 ? _j2 : queryParams.deviceId) !== null && _k !== void 0 ? _k : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _l !== void 0 ? _l : legacyCookies.deviceId) !== null && _m !== void 0 ? _m : UUID();
          lastEventId = (_o = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventId) !== null && _o !== void 0 ? _o : legacyCookies.lastEventId;
          lastEventTime = (_p = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventTime) !== null && _p !== void 0 ? _p : legacyCookies.lastEventTime;
          optOut = (_r = (_q = options.optOut) !== null && _q !== void 0 ? _q : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.optOut) !== null && _r !== void 0 ? _r : legacyCookies.optOut;
          sessionId = (_s = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.sessionId) !== null && _s !== void 0 ? _s : legacyCookies.sessionId;
          userId = (_u = (_t = options.userId) !== null && _t !== void 0 ? _t : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _u !== void 0 ? _u : legacyCookies.userId;
          amplitudeInstance.previousSessionDeviceId = (_v = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _v !== void 0 ? _v : legacyCookies.deviceId;
          amplitudeInstance.previousSessionUserId = (_w = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _w !== void 0 ? _w : legacyCookies.userId;
          trackingOptions = {
            ipAddress: (_y = (_x = options.trackingOptions) === null || _x === void 0 ? void 0 : _x.ipAddress) !== null && _y !== void 0 ? _y : true,
            language: (_0 = (_z = options.trackingOptions) === null || _z === void 0 ? void 0 : _z.language) !== null && _0 !== void 0 ? _0 : true,
            platform: (_2 = (_1 = options.trackingOptions) === null || _1 === void 0 ? void 0 : _1.platform) !== null && _2 !== void 0 ? _2 : true
          };
          pageCounter = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.pageCounter;
          debugLogsEnabled = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.debugLogsEnabled;
          if (options.autocapture !== void 0) {
            options.defaultTracking = options.autocapture;
          }
          browserConfig = new BrowserConfig(apiKey, options.appVersion, cookieStorage, cookieOptions, options.defaultTracking, options.autocapture, deviceId, options.flushIntervalMillis, options.flushMaxRetries, options.flushQueueSize, identityStorage, options.ingestionMetadata, options.instanceName, lastEventId, lastEventTime, options.loggerProvider, options.logLevel, options.minIdLength, options.offline, optOut, options.partnerId, options.plan, options.serverUrl, options.serverZone, sessionId, options.sessionTimeout, options.storageProvider, trackingOptions, options.transport, options.useBatch, options.fetchRemoteConfig, userId, pageCounter, debugLogsEnabled);
          return [4, browserConfig.storageProvider.isEnabled()];
        case 8:
          if (!_3.sent()) {
            browserConfig.loggerProvider.warn("Storage provider ".concat(browserConfig.storageProvider.constructor.name, " is not enabled. Falling back to MemoryStorage."));
            browserConfig.storageProvider = new MemoryStorage();
          }
          return [2, browserConfig];
      }
    });
  });
};
var createCookieStorage = function(identityStorage, cookieOptions) {
  if (identityStorage === void 0) {
    identityStorage = DEFAULT_IDENTITY_STORAGE;
  }
  if (cookieOptions === void 0) {
    cookieOptions = {};
  }
  switch (identityStorage) {
    case "localStorage":
      return new LocalStorage();
    case "sessionStorage":
      return new SessionStorage();
    case "none":
      return new MemoryStorage();
    case "cookie":
    default:
      return new CookieStorage(__assign$1(__assign$1({}, cookieOptions), { expirationDays: cookieOptions.expiration }));
  }
};
var createTransport = function(transport) {
  if (transport === "xhr") {
    return new XHRTransport();
  }
  if (transport === "beacon") {
    return new SendBeaconTransport();
  }
  return new FetchTransport();
};
var getTopLevelDomain = function(url2) {
  return __awaiter(void 0, void 0, void 0, function() {
    var host, parts, levels, storageKey, i, i, domain, options, storage, value;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, new CookieStorage().isEnabled()];
        case 1:
          if (!_a2.sent() || (typeof location === "undefined" || !location.hostname)) {
            return [2, ""];
          }
          host = location.hostname;
          parts = host.split(".");
          levels = [];
          storageKey = "AMP_TLDTEST";
          for (i = parts.length - 2; i >= 0; --i) {
            levels.push(parts.slice(i).join("."));
          }
          i = 0;
          _a2.label = 2;
        case 2:
          if (!(i < levels.length)) return [3, 7];
          domain = levels[i];
          options = { domain: "." + domain };
          storage = new CookieStorage(options);
          return [4, storage.set(storageKey, 1)];
        case 3:
          _a2.sent();
          return [4, storage.get(storageKey)];
        case 4:
          value = _a2.sent();
          if (!value) return [3, 6];
          return [4, storage.remove(storageKey)];
        case 5:
          _a2.sent();
          return [2, "." + domain];
        case 6:
          i++;
          return [3, 2];
        case 7:
          return [2, ""];
      }
    });
  });
};
var omitUndefined = function(input) {
  var obj = {};
  for (var key in input) {
    var val = input[key];
    if (val) {
      obj[key] = val;
    }
  }
  return obj;
};
var defaultPageViewEvent = "[Amplitude] Page Viewed";
var pageViewTrackingPlugin = function(options) {
  if (options === void 0) {
    options = {};
  }
  var amplitude;
  var globalScope = getGlobalScope();
  var loggerProvider = void 0;
  var pushState;
  var localConfig;
  var trackOn = options.trackOn, trackHistoryChanges = options.trackHistoryChanges, _a2 = options.eventType, eventType = _a2 === void 0 ? defaultPageViewEvent : _a2;
  var getDecodeURI = function(locationStr) {
    var decodedLocationStr = locationStr;
    try {
      decodedLocationStr = decodeURI(locationStr);
    } catch (e) {
      loggerProvider === null || loggerProvider === void 0 ? void 0 : loggerProvider.error("Malformed URI sequence: ", e);
    }
    return decodedLocationStr;
  };
  var createPageViewEvent = function() {
    return __awaiter(void 0, void 0, void 0, function() {
      var locationHREF, _a3;
      var _b2;
      return __generator(this, function(_c2) {
        switch (_c2.label) {
          case 0:
            locationHREF = getDecodeURI(typeof location !== "undefined" && location.href || "");
            _b2 = {
              event_type: eventType
            };
            _a3 = [{}];
            return [4, getCampaignParams()];
          case 1:
            return [2, (_b2.event_properties = __assign$1.apply(void 0, [__assign$1.apply(void 0, _a3.concat([_c2.sent()])), { "[Amplitude] Page Domain": (
              /* istanbul ignore next */
              typeof location !== "undefined" && location.hostname || ""
            ), "[Amplitude] Page Location": locationHREF, "[Amplitude] Page Path": (
              /* istanbul ignore next */
              typeof location !== "undefined" && getDecodeURI(location.pathname) || ""
            ), "[Amplitude] Page Title": (
              /* istanbul ignore next */
              typeof document !== "undefined" && document.title || ""
            ), "[Amplitude] Page URL": locationHREF.split("?")[0] }]), _b2)];
        }
      });
    });
  };
  var shouldTrackOnPageLoad = function() {
    return typeof trackOn === "undefined" || typeof trackOn === "function" && trackOn();
  };
  var previousURL = typeof location !== "undefined" ? location.href : null;
  var trackHistoryPageView = function() {
    return __awaiter(void 0, void 0, void 0, function() {
      var newURL, shouldTrackPageView, _b2, _c2;
      return __generator(this, function(_d2) {
        switch (_d2.label) {
          case 0:
            newURL = location.href;
            shouldTrackPageView = shouldTrackHistoryPageView(trackHistoryChanges, newURL, previousURL || "") && shouldTrackOnPageLoad();
            previousURL = newURL;
            if (!shouldTrackPageView) return [3, 4];
            loggerProvider === null || loggerProvider === void 0 ? void 0 : loggerProvider.log("Tracking page view event");
            if (!(amplitude === null || amplitude === void 0)) return [3, 1];
            return [3, 3];
          case 1:
            _c2 = (_b2 = amplitude).track;
            return [4, createPageViewEvent()];
          case 2:
            _c2.apply(_b2, [_d2.sent()]);
            _d2.label = 3;
          case 3:
            _d2.label = 4;
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  };
  var trackHistoryPageViewWrapper = function() {
    void trackHistoryPageView();
  };
  var plugin = {
    name: "@amplitude/plugin-page-view-tracking-browser",
    type: "enrichment",
    setup: function(config2, client2) {
      return __awaiter(void 0, void 0, void 0, function() {
        var _a3, _b2;
        return __generator(this, function(_c2) {
          switch (_c2.label) {
            case 0:
              amplitude = client2;
              localConfig = config2;
              loggerProvider = config2.loggerProvider;
              loggerProvider.log("Installing @amplitude/plugin-page-view-tracking-browser");
              if (globalScope) {
                globalScope.addEventListener("popstate", trackHistoryPageViewWrapper);
                pushState = globalScope.history.pushState;
                globalScope.history.pushState = new Proxy(globalScope.history.pushState, {
                  apply: function(target, thisArg, _a4) {
                    var _b3 = __read$1(_a4, 3), state = _b3[0], unused = _b3[1], url2 = _b3[2];
                    target.apply(thisArg, [state, unused, url2]);
                    void trackHistoryPageView();
                  }
                });
              }
              if (!shouldTrackOnPageLoad()) return [3, 2];
              loggerProvider.log("Tracking page view event");
              _b2 = (_a3 = amplitude).track;
              return [4, createPageViewEvent()];
            case 1:
              _b2.apply(_a3, [_c2.sent()]);
              _c2.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    },
    execute: function(event) {
      return __awaiter(void 0, void 0, void 0, function() {
        var pageViewEvent;
        return __generator(this, function(_a3) {
          switch (_a3.label) {
            case 0:
              if (!(trackOn === "attribution" && isCampaignEvent(event))) return [3, 2];
              loggerProvider === null || loggerProvider === void 0 ? void 0 : loggerProvider.log("Enriching campaign event to page view event with campaign parameters");
              return [4, createPageViewEvent()];
            case 1:
              pageViewEvent = _a3.sent();
              event.event_type = pageViewEvent.event_type;
              event.event_properties = __assign$1(__assign$1({}, event.event_properties), pageViewEvent.event_properties);
              _a3.label = 2;
            case 2:
              if (localConfig && event.event_type === eventType) {
                localConfig.pageCounter = !localConfig.pageCounter ? 1 : localConfig.pageCounter + 1;
                event.event_properties = __assign$1(__assign$1({}, event.event_properties), { "[Amplitude] Page Counter": localConfig.pageCounter });
              }
              return [2, event];
          }
        });
      });
    },
    teardown: function() {
      return __awaiter(void 0, void 0, void 0, function() {
        return __generator(this, function(_a3) {
          if (globalScope) {
            globalScope.removeEventListener("popstate", trackHistoryPageViewWrapper);
            if (pushState) {
              globalScope.history.pushState = pushState;
            }
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }
  };
  return plugin;
};
var getCampaignParams = function() {
  return __awaiter(void 0, void 0, void 0, function() {
    var _a2;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          _a2 = omitUndefined;
          return [4, new CampaignParser().parse()];
        case 1:
          return [2, _a2.apply(void 0, [_b2.sent()])];
      }
    });
  });
};
var isCampaignEvent = function(event) {
  if (event.event_type === "$identify" && event.user_properties) {
    var properties = event.user_properties;
    var $set = properties[IdentifyOperation.SET] || {};
    var $unset = properties[IdentifyOperation.UNSET] || {};
    var userProperties_1 = __spreadArray(__spreadArray([], __read$1(Object.keys($set)), false), __read$1(Object.keys($unset)), false);
    return Object.keys(BASE_CAMPAIGN).every(function(value) {
      return userProperties_1.includes(value);
    });
  }
  return false;
};
var shouldTrackHistoryPageView = function(trackingOption, newURLStr, oldURLStr) {
  switch (trackingOption) {
    case "pathOnly": {
      if (oldURLStr == "")
        return true;
      var newURL = new URL(newURLStr);
      var oldURL = new URL(oldURLStr);
      var newBaseStr = newURL.origin + newURL.pathname;
      var oldBaseStr = oldURL.origin + oldURL.pathname;
      return newBaseStr !== oldBaseStr;
    }
    default:
      return newURLStr !== oldURLStr;
  }
};
var formInteractionTracking = function() {
  var observer;
  var eventListeners = [];
  var addEventListener = function(element, type2, handler) {
    element.addEventListener(type2, handler);
    eventListeners.push({
      element,
      type: type2,
      handler
    });
  };
  var removeClickListeners = function() {
    eventListeners.forEach(function(_a2) {
      var element = _a2.element, type2 = _a2.type, handler = _a2.handler;
      element === null || element === void 0 ? void 0 : element.removeEventListener(type2, handler);
    });
    eventListeners = [];
  };
  var name2 = "@amplitude/plugin-form-interaction-tracking-browser";
  var type = "enrichment";
  var setup = function(config2, amplitude) {
    return __awaiter(void 0, void 0, void 0, function() {
      var _a2;
      return __generator(this, function(_b2) {
        (_a2 = getGlobalScope()) === null || _a2 === void 0 ? void 0 : _a2.addEventListener("load", function() {
          if (!amplitude) {
            config2.loggerProvider.warn("Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked.");
            return;
          }
          if (typeof document === "undefined") {
            return;
          }
          var addFormInteractionListener = function(form) {
            var hasFormChanged = false;
            addEventListener(form, "change", function() {
              var _a3;
              var formDestination = extractFormAction(form);
              if (!hasFormChanged) {
                amplitude.track(DEFAULT_FORM_START_EVENT, (_a3 = {}, _a3[FORM_ID] = stringOrUndefined(form.id), _a3[FORM_NAME] = stringOrUndefined(form.name), _a3[FORM_DESTINATION] = formDestination, _a3));
              }
              hasFormChanged = true;
            });
            addEventListener(form, "submit", function() {
              var _a3, _b3;
              var formDestination = extractFormAction(form);
              if (!hasFormChanged) {
                amplitude.track(DEFAULT_FORM_START_EVENT, (_a3 = {}, _a3[FORM_ID] = stringOrUndefined(form.id), _a3[FORM_NAME] = stringOrUndefined(form.name), _a3[FORM_DESTINATION] = formDestination, _a3));
              }
              amplitude.track(DEFAULT_FORM_SUBMIT_EVENT, (_b3 = {}, _b3[FORM_ID] = stringOrUndefined(form.id), _b3[FORM_NAME] = stringOrUndefined(form.name), _b3[FORM_DESTINATION] = formDestination, _b3));
              hasFormChanged = false;
            });
          };
          var forms = Array.from(document.getElementsByTagName("form"));
          forms.forEach(addFormInteractionListener);
          if (typeof MutationObserver !== "undefined") {
            observer = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                  if (node.nodeName === "FORM") {
                    addFormInteractionListener(node);
                  }
                  if ("querySelectorAll" in node && typeof node.querySelectorAll === "function") {
                    Array.from(node.querySelectorAll("form")).map(addFormInteractionListener);
                  }
                });
              });
            });
            observer.observe(document.body, {
              subtree: true,
              childList: true
            });
          }
        });
        return [
          2
          /*return*/
        ];
      });
    });
  };
  var execute = function(event) {
    return __awaiter(void 0, void 0, void 0, function() {
      return __generator(this, function(_a2) {
        return [2, event];
      });
    });
  };
  var teardown = function() {
    return __awaiter(void 0, void 0, void 0, function() {
      return __generator(this, function(_a2) {
        observer === null || observer === void 0 ? void 0 : observer.disconnect();
        removeClickListeners();
        return [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: name2,
    type,
    setup,
    execute,
    teardown
  };
};
var stringOrUndefined = function(name2) {
  if (typeof name2 !== "string") {
    return void 0;
  }
  return name2;
};
var extractFormAction = function(form) {
  var formDestination = form.getAttribute("action");
  try {
    formDestination = new URL(encodeURI(formDestination !== null && formDestination !== void 0 ? formDestination : ""), window.location.href).href;
  } catch (_a2) {
  }
  return formDestination;
};
var fileDownloadTracking = function() {
  var observer;
  var eventListeners = [];
  var addEventListener = function(element, type2, handler) {
    element.addEventListener(type2, handler);
    eventListeners.push({
      element,
      type: type2,
      handler
    });
  };
  var removeClickListeners = function() {
    eventListeners.forEach(function(_a2) {
      var element = _a2.element, type2 = _a2.type, handler = _a2.handler;
      element === null || element === void 0 ? void 0 : element.removeEventListener(type2, handler);
    });
    eventListeners = [];
  };
  var name2 = "@amplitude/plugin-file-download-tracking-browser";
  var type = "enrichment";
  var setup = function(config2, amplitude) {
    return __awaiter(void 0, void 0, void 0, function() {
      var _a2;
      return __generator(this, function(_b2) {
        (_a2 = getGlobalScope()) === null || _a2 === void 0 ? void 0 : _a2.addEventListener("load", function() {
          if (!amplitude) {
            config2.loggerProvider.warn("File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked.");
            return;
          }
          if (typeof document === "undefined") {
            return;
          }
          var addFileDownloadListener = function(a) {
            var url2;
            try {
              url2 = new URL(a.href, window.location.href);
            } catch (_a3) {
              return;
            }
            var result2 = ext.exec(url2.href);
            var fileExtension = result2 === null || result2 === void 0 ? void 0 : result2[1];
            if (fileExtension) {
              addEventListener(a, "click", function() {
                var _a3;
                if (fileExtension) {
                  amplitude.track(DEFAULT_FILE_DOWNLOAD_EVENT, (_a3 = {}, _a3[FILE_EXTENSION] = fileExtension, _a3[FILE_NAME] = url2.pathname, _a3[LINK_ID] = a.id, _a3[LINK_TEXT] = a.text, _a3[LINK_URL] = a.href, _a3));
                }
              });
            }
          };
          var ext = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)(\?.+)?$/;
          var links = Array.from(document.getElementsByTagName("a"));
          links.forEach(addFileDownloadListener);
          if (typeof MutationObserver !== "undefined") {
            observer = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                  if (node.nodeName === "A") {
                    addFileDownloadListener(node);
                  }
                  if ("querySelectorAll" in node && typeof node.querySelectorAll === "function") {
                    Array.from(node.querySelectorAll("a")).map(addFileDownloadListener);
                  }
                });
              });
            });
            observer.observe(document.body, {
              subtree: true,
              childList: true
            });
          }
        });
        return [
          2
          /*return*/
        ];
      });
    });
  };
  var execute = function(event) {
    return __awaiter(void 0, void 0, void 0, function() {
      return __generator(this, function(_a2) {
        return [2, event];
      });
    });
  };
  var teardown = function() {
    return __awaiter(void 0, void 0, void 0, function() {
      return __generator(this, function(_a2) {
        observer === null || observer === void 0 ? void 0 : observer.disconnect();
        removeClickListeners();
        return [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: name2,
    type,
    setup,
    execute,
    teardown
  };
};
var notified = false;
var detNotify = function(config2) {
  if (notified || config2.defaultTracking !== void 0) {
    return;
  }
  var message = "`options.defaultTracking` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to `options.defaultTracking`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:\n\namplitude.init(<YOUR_API_KEY>, {\n  defaultTracking: true,\n});\n\nVisit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.";
  config2.loggerProvider.warn(message);
  notified = true;
};
var networkConnectivityCheckerPlugin = function() {
  var name2 = "@amplitude/plugin-network-checker-browser";
  var type = "before";
  var globalScope = getGlobalScope();
  var eventListeners = [];
  var addNetworkListener = function(type2, handler) {
    if (globalScope) {
      globalScope.addEventListener(type2, handler);
      eventListeners.push({
        type: type2,
        handler
      });
    }
  };
  var removeNetworkListeners = function() {
    eventListeners.forEach(function(_a2) {
      var type2 = _a2.type, handler = _a2.handler;
      if (globalScope) {
        globalScope.removeEventListener(type2, handler);
      }
    });
    eventListeners = [];
  };
  var setup = function(config2, amplitude) {
    return __awaiter(void 0, void 0, void 0, function() {
      return __generator(this, function(_a2) {
        if (typeof navigator === "undefined") {
          config2.loggerProvider.debug("Network connectivity checker plugin is disabled because navigator is not available.");
          config2.offline = false;
          return [
            2
            /*return*/
          ];
        }
        config2.offline = !navigator.onLine;
        addNetworkListener("online", function() {
          config2.loggerProvider.debug("Network connectivity changed to online.");
          config2.offline = false;
          setTimeout(function() {
            amplitude.flush();
          }, config2.flushIntervalMillis);
        });
        addNetworkListener("offline", function() {
          config2.loggerProvider.debug("Network connectivity changed to offline.");
          config2.offline = true;
        });
        return [
          2
          /*return*/
        ];
      });
    });
  };
  var teardown = function() {
    return __awaiter(void 0, void 0, void 0, function() {
      return __generator(this, function(_a2) {
        removeNetworkListeners();
        return [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: name2,
    type,
    setup,
    teardown
  };
};
var UNEXPECTED_NETWORK_ERROR_MESSAGE = "Network error occurred, remote config fetch failed";
var SUCCESS_REMOTE_CONFIG = "Remote config successfully fetched";
var MAX_RETRIES_EXCEEDED_MESSAGE = "Remote config fetch rejected due to exceeded retry count";
var TIMEOUT_MESSAGE = "Remote config fetch rejected due to timeout after 5 seconds";
var UNEXPECTED_ERROR_MESSAGE = "Unexpected error occurred";
var REMOTE_CONFIG_SERVER_URL = "https://sr-client-cfg.amplitude.com/config";
var REMOTE_CONFIG_SERVER_URL_STAGING = "https://sr-client-cfg.stag2.amplitude.com/config";
var REMOTE_CONFIG_SERVER_URL_EU = "https://sr-client-cfg.eu.amplitude.com/config";
var RemoteConfigFetch = (
  /** @class */
  function() {
    function RemoteConfigFetch2(_a2) {
      var localConfig = _a2.localConfig, configKeys = _a2.configKeys;
      var _this = this;
      this.retryTimeout = 1e3;
      this.attempts = 0;
      this.sessionTargetingMatch = false;
      this.metrics = {};
      this.getRemoteConfig = function(configNamespace, key, sessionId) {
        return __awaiter(_this, void 0, void 0, function() {
          var fetchStartTime, configAPIResponse, remoteConfig;
          return __generator(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                fetchStartTime = Date.now();
                return [4, this.fetchWithTimeout(sessionId)];
              case 1:
                configAPIResponse = _a3.sent();
                if (configAPIResponse) {
                  remoteConfig = configAPIResponse.configs && configAPIResponse.configs[configNamespace];
                  if (remoteConfig) {
                    this.metrics.fetchTimeAPISuccess = Date.now() - fetchStartTime;
                    return [2, remoteConfig[key]];
                  }
                }
                this.metrics.fetchTimeAPIFail = Date.now() - fetchStartTime;
                return [2, void 0];
            }
          });
        });
      };
      this.fetchWithTimeout = function(sessionId) {
        return __awaiter(_this, void 0, void 0, function() {
          var controller, timeoutId, remoteConfig;
          return __generator(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                controller = new AbortController();
                timeoutId = setTimeout(function() {
                  return controller.abort();
                }, 5e3);
                return [4, this.fetchRemoteConfig(controller.signal, sessionId)];
              case 1:
                remoteConfig = _a3.sent();
                clearTimeout(timeoutId);
                return [2, remoteConfig];
            }
          });
        });
      };
      this.fetchRemoteConfig = function(signal, sessionId) {
        return __awaiter(_this, void 0, void 0, function() {
          var urlParams, _a3, _b2, configKey, options, serverUrl, res, parsedStatus, e_1, knownError;
          var e_2, _c2;
          var _d2;
          return __generator(this, function(_e2) {
            switch (_e2.label) {
              case 0:
                if (sessionId === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries) {
                  return [2, this.completeRequest({ err: MAX_RETRIES_EXCEEDED_MESSAGE })];
                } else if (signal.aborted) {
                  return [2, this.completeRequest({ err: TIMEOUT_MESSAGE })];
                } else if (sessionId !== this.lastFetchedSessionId) {
                  this.lastFetchedSessionId = sessionId;
                  this.attempts = 0;
                }
                _e2.label = 1;
              case 1:
                _e2.trys.push([1, 3, , 4]);
                urlParams = new URLSearchParams({
                  api_key: this.localConfig.apiKey
                });
                try {
                  for (_a3 = __values$1(this.configKeys), _b2 = _a3.next(); !_b2.done; _b2 = _a3.next()) {
                    configKey = _b2.value;
                    urlParams.append("config_keys", configKey);
                  }
                } catch (e_2_1) {
                  e_2 = { error: e_2_1 };
                } finally {
                  try {
                    if (_b2 && !_b2.done && (_c2 = _a3.return)) _c2.call(_a3);
                  } finally {
                    if (e_2) throw e_2.error;
                  }
                }
                if (sessionId) {
                  urlParams.set("session_id", String(sessionId));
                }
                options = {
                  headers: {
                    Accept: "*/*"
                  },
                  method: "GET"
                };
                serverUrl = "".concat(this.getServerUrl(), "?").concat(urlParams.toString());
                this.attempts += 1;
                return [4, fetch(serverUrl, __assign$1(__assign$1({}, options), { signal }))];
              case 2:
                res = _e2.sent();
                if (res === null) {
                  return [2, this.completeRequest({ err: UNEXPECTED_ERROR_MESSAGE })];
                }
                parsedStatus = new BaseTransport().buildStatus(res.status);
                switch (parsedStatus) {
                  case Status.Success:
                    this.attempts = 0;
                    return [2, this.parseAndStoreConfig(res)];
                  case Status.Failed:
                    return [2, this.retryFetch(signal, sessionId)];
                  default:
                    return [2, this.completeRequest({ err: UNEXPECTED_NETWORK_ERROR_MESSAGE })];
                }
              case 3:
                e_1 = _e2.sent();
                knownError = e_1;
                if (signal.aborted) {
                  return [2, this.completeRequest({ err: TIMEOUT_MESSAGE })];
                }
                return [2, this.completeRequest({ err: (_d2 = knownError.message) !== null && _d2 !== void 0 ? _d2 : UNEXPECTED_ERROR_MESSAGE })];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      this.retryFetch = function(signal, sessionId) {
        return __awaiter(_this, void 0, void 0, function() {
          var _this2 = this;
          return __generator(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                return [4, new Promise(function(resolve2) {
                  return setTimeout(resolve2, _this2.attempts * _this2.retryTimeout);
                })];
              case 1:
                _a3.sent();
                return [2, this.fetchRemoteConfig(signal, sessionId)];
            }
          });
        });
      };
      this.parseAndStoreConfig = function(res) {
        return __awaiter(_this, void 0, void 0, function() {
          var remoteConfig;
          return __generator(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                return [4, res.json()];
              case 1:
                remoteConfig = _a3.sent();
                this.completeRequest({ success: SUCCESS_REMOTE_CONFIG });
                return [2, remoteConfig];
            }
          });
        });
      };
      this.localConfig = localConfig;
      this.configKeys = configKeys;
    }
    RemoteConfigFetch2.prototype.getServerUrl = function() {
      if (this.localConfig.serverZone === ServerZone.STAGING) {
        return REMOTE_CONFIG_SERVER_URL_STAGING;
      }
      if (this.localConfig.serverZone === ServerZone.EU) {
        return REMOTE_CONFIG_SERVER_URL_EU;
      }
      return REMOTE_CONFIG_SERVER_URL;
    };
    RemoteConfigFetch2.prototype.completeRequest = function(_a2) {
      var err = _a2.err, success = _a2.success;
      if (err) {
        throw new Error(err);
      } else if (success) {
        this.localConfig.loggerProvider.log(success);
      }
    };
    return RemoteConfigFetch2;
  }()
);
var createRemoteConfigFetch$1 = function(_a2) {
  var localConfig = _a2.localConfig, configKeys = _a2.configKeys;
  return __awaiter(void 0, void 0, void 0, function() {
    return __generator(this, function(_b2) {
      return [2, new RemoteConfigFetch({ localConfig, configKeys })];
    });
  });
};
var createRemoteConfigFetch = createRemoteConfigFetch$1;
var BrowserJoinedConfigGenerator = (
  /** @class */
  function() {
    function BrowserJoinedConfigGenerator2(localConfig) {
      this.config = localConfig;
      this.config.loggerProvider.debug("Local configuration before merging with remote config", JSON.stringify(this.config, null, 2));
    }
    BrowserJoinedConfigGenerator2.prototype.initialize = function() {
      return __awaiter(this, void 0, void 0, function() {
        var _a2;
        return __generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              _a2 = this;
              return [4, createRemoteConfigFetch({
                localConfig: this.config,
                configKeys: ["analyticsSDK"]
              })];
            case 1:
              _a2.remoteConfigFetch = _b2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    BrowserJoinedConfigGenerator2.prototype.generateJoinedConfig = function() {
      return __awaiter(this, void 0, void 0, function() {
        var remoteConfig, _a2, e_1;
        var _b2, _c2, _d2;
        var _e2;
        return __generator(this, function(_f2) {
          switch (_f2.label) {
            case 0:
              _f2.trys.push([0, 3, , 4]);
              _a2 = this.remoteConfigFetch;
              if (!_a2) return [3, 2];
              return [4, this.remoteConfigFetch.getRemoteConfig("analyticsSDK", "browserSDK", this.config.sessionId)];
            case 1:
              _a2 = _f2.sent();
              _f2.label = 2;
            case 2:
              remoteConfig = _a2;
              this.config.loggerProvider.debug("Remote configuration:", JSON.stringify(remoteConfig, null, 2));
              if (remoteConfig && "autocapture" in remoteConfig) {
                if (typeof remoteConfig.autocapture === "boolean") {
                  this.config.autocapture = remoteConfig.autocapture;
                }
                if (typeof remoteConfig.autocapture === "object") {
                  if (this.config.autocapture === void 0) {
                    this.config.autocapture = remoteConfig.autocapture;
                  }
                  if (typeof this.config.autocapture === "boolean") {
                    this.config.autocapture = __assign$1({ attribution: this.config.autocapture, fileDownloads: this.config.autocapture, formInteractions: this.config.autocapture, pageViews: this.config.autocapture, sessions: this.config.autocapture, elementInteractions: this.config.autocapture }, remoteConfig.autocapture);
                  }
                  if (typeof this.config.autocapture === "object") {
                    this.config.autocapture = __assign$1(__assign$1({}, this.config.autocapture), remoteConfig.autocapture);
                  }
                }
                this.config.defaultTracking = this.config.autocapture;
              }
              this.config.loggerProvider.debug("Joined configuration: ", JSON.stringify(this.config, null, 2));
              (_b2 = (_e2 = this.config).requestMetadata) !== null && _b2 !== void 0 ? _b2 : _e2.requestMetadata = new RequestMetadata();
              if ((_c2 = this.remoteConfigFetch) === null || _c2 === void 0 ? void 0 : _c2.metrics.fetchTimeAPISuccess) {
                this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_success", this.remoteConfigFetch.metrics.fetchTimeAPISuccess);
              }
              if ((_d2 = this.remoteConfigFetch) === null || _d2 === void 0 ? void 0 : _d2.metrics.fetchTimeAPIFail) {
                this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_fail", this.remoteConfigFetch.metrics.fetchTimeAPIFail);
              }
              return [3, 4];
            case 3:
              e_1 = _f2.sent();
              this.config.loggerProvider.error("Failed to fetch remote configuration because of error: ", e_1);
              return [3, 4];
            case 4:
              return [2, this.config];
          }
        });
      });
    };
    return BrowserJoinedConfigGenerator2;
  }()
);
var createBrowserJoinedConfigGenerator = function(localConfig) {
  return __awaiter(void 0, void 0, void 0, function() {
    var joinedConfigGenerator;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          joinedConfigGenerator = new BrowserJoinedConfigGenerator(localConfig);
          return [4, joinedConfigGenerator.initialize()];
        case 1:
          _a2.sent();
          return [2, joinedConfigGenerator];
      }
    });
  });
};
var PLUGIN_NAME = "@amplitude/plugin-autocapture-browser";
var AMPLITUDE_ELEMENT_CLICKED_EVENT = "[Amplitude] Element Clicked";
var AMPLITUDE_ELEMENT_CHANGED_EVENT = "[Amplitude] Element Changed";
var AMPLITUDE_EVENT_PROP_ELEMENT_ID = "[Amplitude] Element ID";
var AMPLITUDE_EVENT_PROP_ELEMENT_CLASS = "[Amplitude] Element Class";
var AMPLITUDE_EVENT_PROP_ELEMENT_TAG = "[Amplitude] Element Tag";
var AMPLITUDE_EVENT_PROP_ELEMENT_TEXT = "[Amplitude] Element Text";
var AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY = "[Amplitude] Element Hierarchy";
var AMPLITUDE_EVENT_PROP_ELEMENT_HREF = "[Amplitude] Element Href";
var AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT = "[Amplitude] Element Position Left";
var AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP = "[Amplitude] Element Position Top";
var AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL = "[Amplitude] Element Aria Label";
var AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES = "[Amplitude] Element Attributes";
var AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR = "[Amplitude] Element Selector";
var AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL = "[Amplitude] Element Parent Label";
var AMPLITUDE_EVENT_PROP_PAGE_URL = "[Amplitude] Page URL";
var AMPLITUDE_EVENT_PROP_PAGE_TITLE = "[Amplitude] Page Title";
var AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT = "[Amplitude] Viewport Height";
var AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH = "[Amplitude] Viewport Width";
var AMPLITUDE_ORIGIN = "https://app.amplitude.com";
var AMPLITUDE_ORIGIN_EU = "https://app.eu.amplitude.com";
var AMPLITUDE_ORIGIN_STAGING = "https://apps.stag2.amplitude.com";
var AMPLITUDE_ORIGINS_MAP = {
  US: AMPLITUDE_ORIGIN,
  EU: AMPLITUDE_ORIGIN_EU,
  STAGING: AMPLITUDE_ORIGIN_STAGING
};
var AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL = "https://cdn.amplitude.com/libs/visual-tagging-selector-1.0.0-alpha.js.gz";
var AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS = "amp-visual-tagging-selector-highlight";
function isFunction$4(value) {
  return typeof value === "function";
}
function createErrorClass(createImpl) {
  var _super = function(instance) {
    Error.call(instance);
    instance.stack = new Error().stack;
  };
  var ctorFunc = createImpl(_super);
  ctorFunc.prototype = Object.create(Error.prototype);
  ctorFunc.prototype.constructor = ctorFunc;
  return ctorFunc;
}
var UnsubscriptionError = createErrorClass(function(_super) {
  return function UnsubscriptionErrorImpl(errors) {
    _super(this);
    this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
      return i + 1 + ") " + err.toString();
    }).join("\n  ") : "";
    this.name = "UnsubscriptionError";
    this.errors = errors;
  };
});
function arrRemove(arr, item) {
  if (arr) {
    var index2 = arr.indexOf(item);
    0 <= index2 && arr.splice(index2, 1);
  }
}
var Subscription = function() {
  function Subscription2(initialTeardown) {
    this.initialTeardown = initialTeardown;
    this.closed = false;
    this._parentage = null;
    this._finalizers = null;
  }
  Subscription2.prototype.unsubscribe = function() {
    var e_1, _a2, e_2, _b2;
    var errors;
    if (!this.closed) {
      this.closed = true;
      var _parentage = this._parentage;
      if (_parentage) {
        this._parentage = null;
        if (Array.isArray(_parentage)) {
          try {
            for (var _parentage_1 = __values$1(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
              var parent_1 = _parentage_1_1.value;
              parent_1.remove(this);
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (_parentage_1_1 && !_parentage_1_1.done && (_a2 = _parentage_1.return)) _a2.call(_parentage_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        } else {
          _parentage.remove(this);
        }
      }
      var initialFinalizer = this.initialTeardown;
      if (isFunction$4(initialFinalizer)) {
        try {
          initialFinalizer();
        } catch (e) {
          errors = e instanceof UnsubscriptionError ? e.errors : [e];
        }
      }
      var _finalizers = this._finalizers;
      if (_finalizers) {
        this._finalizers = null;
        try {
          for (var _finalizers_1 = __values$1(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
            var finalizer = _finalizers_1_1.value;
            try {
              execFinalizer(finalizer);
            } catch (err) {
              errors = errors !== null && errors !== void 0 ? errors : [];
              if (err instanceof UnsubscriptionError) {
                errors = __spreadArray(__spreadArray([], __read$1(errors)), __read$1(err.errors));
              } else {
                errors.push(err);
              }
            }
          }
        } catch (e_2_1) {
          e_2 = { error: e_2_1 };
        } finally {
          try {
            if (_finalizers_1_1 && !_finalizers_1_1.done && (_b2 = _finalizers_1.return)) _b2.call(_finalizers_1);
          } finally {
            if (e_2) throw e_2.error;
          }
        }
      }
      if (errors) {
        throw new UnsubscriptionError(errors);
      }
    }
  };
  Subscription2.prototype.add = function(teardown) {
    var _a2;
    if (teardown && teardown !== this) {
      if (this.closed) {
        execFinalizer(teardown);
      } else {
        if (teardown instanceof Subscription2) {
          if (teardown.closed || teardown._hasParent(this)) {
            return;
          }
          teardown._addParent(this);
        }
        (this._finalizers = (_a2 = this._finalizers) !== null && _a2 !== void 0 ? _a2 : []).push(teardown);
      }
    }
  };
  Subscription2.prototype._hasParent = function(parent) {
    var _parentage = this._parentage;
    return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
  };
  Subscription2.prototype._addParent = function(parent) {
    var _parentage = this._parentage;
    this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
  };
  Subscription2.prototype._removeParent = function(parent) {
    var _parentage = this._parentage;
    if (_parentage === parent) {
      this._parentage = null;
    } else if (Array.isArray(_parentage)) {
      arrRemove(_parentage, parent);
    }
  };
  Subscription2.prototype.remove = function(teardown) {
    var _finalizers = this._finalizers;
    _finalizers && arrRemove(_finalizers, teardown);
    if (teardown instanceof Subscription2) {
      teardown._removeParent(this);
    }
  };
  Subscription2.EMPTY = function() {
    var empty = new Subscription2();
    empty.closed = true;
    return empty;
  }();
  return Subscription2;
}();
Subscription.EMPTY;
function isSubscription(value) {
  return value instanceof Subscription || value && "closed" in value && isFunction$4(value.remove) && isFunction$4(value.add) && isFunction$4(value.unsubscribe);
}
function execFinalizer(finalizer) {
  if (isFunction$4(finalizer)) {
    finalizer();
  } else {
    finalizer.unsubscribe();
  }
}
var config$1 = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: false,
  useDeprecatedNextContext: false
};
var timeoutProvider = {
  setTimeout: function(handler, timeout2) {
    var args = [];
    for (var _i2 = 2; _i2 < arguments.length; _i2++) {
      args[_i2 - 2] = arguments[_i2];
    }
    return setTimeout.apply(void 0, __spreadArray([handler, timeout2], __read$1(args)));
  },
  clearTimeout: function(handle) {
    var delegate = timeoutProvider.delegate;
    return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
  },
  delegate: void 0
};
function reportUnhandledError(err) {
  timeoutProvider.setTimeout(function() {
    {
      throw err;
    }
  });
}
function noop$2() {
}
function errorContext(cb) {
  {
    cb();
  }
}
var Subscriber = function(_super) {
  __extends(Subscriber2, _super);
  function Subscriber2(destination) {
    var _this = _super.call(this) || this;
    _this.isStopped = false;
    if (destination) {
      _this.destination = destination;
      if (isSubscription(destination)) {
        destination.add(_this);
      }
    } else {
      _this.destination = EMPTY_OBSERVER;
    }
    return _this;
  }
  Subscriber2.create = function(next, error, complete) {
    return new SafeSubscriber(next, error, complete);
  };
  Subscriber2.prototype.next = function(value) {
    if (this.isStopped) ;
    else {
      this._next(value);
    }
  };
  Subscriber2.prototype.error = function(err) {
    if (this.isStopped) ;
    else {
      this.isStopped = true;
      this._error(err);
    }
  };
  Subscriber2.prototype.complete = function() {
    if (this.isStopped) ;
    else {
      this.isStopped = true;
      this._complete();
    }
  };
  Subscriber2.prototype.unsubscribe = function() {
    if (!this.closed) {
      this.isStopped = true;
      _super.prototype.unsubscribe.call(this);
      this.destination = null;
    }
  };
  Subscriber2.prototype._next = function(value) {
    this.destination.next(value);
  };
  Subscriber2.prototype._error = function(err) {
    try {
      this.destination.error(err);
    } finally {
      this.unsubscribe();
    }
  };
  Subscriber2.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  };
  return Subscriber2;
}(Subscription);
var ConsumerObserver = function() {
  function ConsumerObserver2(partialObserver) {
    this.partialObserver = partialObserver;
  }
  ConsumerObserver2.prototype.next = function(value) {
    var partialObserver = this.partialObserver;
    if (partialObserver.next) {
      try {
        partialObserver.next(value);
      } catch (error) {
        handleUnhandledError(error);
      }
    }
  };
  ConsumerObserver2.prototype.error = function(err) {
    var partialObserver = this.partialObserver;
    if (partialObserver.error) {
      try {
        partialObserver.error(err);
      } catch (error) {
        handleUnhandledError(error);
      }
    } else {
      handleUnhandledError(err);
    }
  };
  ConsumerObserver2.prototype.complete = function() {
    var partialObserver = this.partialObserver;
    if (partialObserver.complete) {
      try {
        partialObserver.complete();
      } catch (error) {
        handleUnhandledError(error);
      }
    }
  };
  return ConsumerObserver2;
}();
var SafeSubscriber = function(_super) {
  __extends(SafeSubscriber2, _super);
  function SafeSubscriber2(observerOrNext, error, complete) {
    var _this = _super.call(this) || this;
    var partialObserver;
    if (isFunction$4(observerOrNext) || !observerOrNext) {
      partialObserver = {
        next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : void 0,
        error: error !== null && error !== void 0 ? error : void 0,
        complete: complete !== null && complete !== void 0 ? complete : void 0
      };
    } else {
      {
        partialObserver = observerOrNext;
      }
    }
    _this.destination = new ConsumerObserver(partialObserver);
    return _this;
  }
  return SafeSubscriber2;
}(Subscriber);
function handleUnhandledError(error) {
  {
    reportUnhandledError(error);
  }
}
function defaultErrorHandler(err) {
  throw err;
}
var EMPTY_OBSERVER = {
  closed: true,
  next: noop$2,
  error: defaultErrorHandler,
  complete: noop$2
};
var observable = function() {
  return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
function identity(x) {
  return x;
}
function pipeFromArray(fns) {
  if (fns.length === 0) {
    return identity;
  }
  if (fns.length === 1) {
    return fns[0];
  }
  return function piped(input) {
    return fns.reduce(function(prev, fn) {
      return fn(prev);
    }, input);
  };
}
var Observable = function() {
  function Observable2(subscribe) {
    if (subscribe) {
      this._subscribe = subscribe;
    }
  }
  Observable2.prototype.lift = function(operator) {
    var observable2 = new Observable2();
    observable2.source = this;
    observable2.operator = operator;
    return observable2;
  };
  Observable2.prototype.subscribe = function(observerOrNext, error, complete) {
    var _this = this;
    var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new SafeSubscriber(observerOrNext, error, complete);
    errorContext(function() {
      var _a2 = _this, operator = _a2.operator, source = _a2.source;
      subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
    });
    return subscriber;
  };
  Observable2.prototype._trySubscribe = function(sink) {
    try {
      return this._subscribe(sink);
    } catch (err) {
      sink.error(err);
    }
  };
  Observable2.prototype.forEach = function(next, promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function(resolve2, reject) {
      var subscriber = new SafeSubscriber({
        next: function(value) {
          try {
            next(value);
          } catch (err) {
            reject(err);
            subscriber.unsubscribe();
          }
        },
        error: reject,
        complete: resolve2
      });
      _this.subscribe(subscriber);
    });
  };
  Observable2.prototype._subscribe = function(subscriber) {
    var _a2;
    return (_a2 = this.source) === null || _a2 === void 0 ? void 0 : _a2.subscribe(subscriber);
  };
  Observable2.prototype[observable] = function() {
    return this;
  };
  Observable2.prototype.pipe = function() {
    var operations = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      operations[_i2] = arguments[_i2];
    }
    return pipeFromArray(operations)(this);
  };
  Observable2.prototype.toPromise = function(promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function(resolve2, reject) {
      var value;
      _this.subscribe(function(x) {
        return value = x;
      }, function(err) {
        return reject(err);
      }, function() {
        return resolve2(value);
      });
    });
  };
  Observable2.create = function(subscribe) {
    return new Observable2(subscribe);
  };
  return Observable2;
}();
function getPromiseCtor(promiseCtor) {
  var _a2;
  return (_a2 = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config$1.Promise) !== null && _a2 !== void 0 ? _a2 : Promise;
}
function isObserver(value) {
  return value && isFunction$4(value.next) && isFunction$4(value.error) && isFunction$4(value.complete);
}
function isSubscriber(value) {
  return value && value instanceof Subscriber || isObserver(value) && isSubscription(value);
}
function hasLift(source) {
  return isFunction$4(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
  return function(source) {
    if (hasLift(source)) {
      return source.lift(function(liftedSource) {
        try {
          return init(liftedSource, this);
        } catch (err) {
          this.error(err);
        }
      });
    }
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
  return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = function(_super) {
  __extends(OperatorSubscriber2, _super);
  function OperatorSubscriber2(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
    var _this = _super.call(this, destination) || this;
    _this.onFinalize = onFinalize;
    _this.shouldUnsubscribe = shouldUnsubscribe;
    _this._next = onNext ? function(value) {
      try {
        onNext(value);
      } catch (err) {
        destination.error(err);
      }
    } : _super.prototype._next;
    _this._error = onError ? function(err) {
      try {
        onError(err);
      } catch (err2) {
        destination.error(err2);
      } finally {
        this.unsubscribe();
      }
    } : _super.prototype._error;
    _this._complete = onComplete ? function() {
      try {
        onComplete();
      } catch (err) {
        destination.error(err);
      } finally {
        this.unsubscribe();
      }
    } : _super.prototype._complete;
    return _this;
  }
  OperatorSubscriber2.prototype.unsubscribe = function() {
    var _a2;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var closed_1 = this.closed;
      _super.prototype.unsubscribe.call(this);
      !closed_1 && ((_a2 = this.onFinalize) === null || _a2 === void 0 ? void 0 : _a2.call(this));
    }
  };
  return OperatorSubscriber2;
}(Subscriber);
var dateTimestampProvider = {
  now: function() {
    return Date.now();
  },
  delegate: void 0
};
var Action = function(_super) {
  __extends(Action2, _super);
  function Action2(scheduler, work) {
    return _super.call(this) || this;
  }
  Action2.prototype.schedule = function(state, delay2) {
    return this;
  };
  return Action2;
}(Subscription);
var intervalProvider = {
  setInterval: function(handler, timeout2) {
    var args = [];
    for (var _i2 = 2; _i2 < arguments.length; _i2++) {
      args[_i2 - 2] = arguments[_i2];
    }
    return setInterval.apply(void 0, __spreadArray([handler, timeout2], __read$1(args)));
  },
  clearInterval: function(handle) {
    return clearInterval(handle);
  },
  delegate: void 0
};
var AsyncAction = function(_super) {
  __extends(AsyncAction2, _super);
  function AsyncAction2(scheduler, work) {
    var _this = _super.call(this, scheduler, work) || this;
    _this.scheduler = scheduler;
    _this.work = work;
    _this.pending = false;
    return _this;
  }
  AsyncAction2.prototype.schedule = function(state, delay2) {
    var _a2;
    if (delay2 === void 0) {
      delay2 = 0;
    }
    if (this.closed) {
      return this;
    }
    this.state = state;
    var id2 = this.id;
    var scheduler = this.scheduler;
    if (id2 != null) {
      this.id = this.recycleAsyncId(scheduler, id2, delay2);
    }
    this.pending = true;
    this.delay = delay2;
    this.id = (_a2 = this.id) !== null && _a2 !== void 0 ? _a2 : this.requestAsyncId(scheduler, this.id, delay2);
    return this;
  };
  AsyncAction2.prototype.requestAsyncId = function(scheduler, _id, delay2) {
    if (delay2 === void 0) {
      delay2 = 0;
    }
    return intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay2);
  };
  AsyncAction2.prototype.recycleAsyncId = function(_scheduler, id2, delay2) {
    if (delay2 === void 0) {
      delay2 = 0;
    }
    if (delay2 != null && this.delay === delay2 && this.pending === false) {
      return id2;
    }
    if (id2 != null) {
      intervalProvider.clearInterval(id2);
    }
    return void 0;
  };
  AsyncAction2.prototype.execute = function(state, delay2) {
    if (this.closed) {
      return new Error("executing a cancelled action");
    }
    this.pending = false;
    var error = this._execute(state, delay2);
    if (error) {
      return error;
    } else if (this.pending === false && this.id != null) {
      this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    }
  };
  AsyncAction2.prototype._execute = function(state, _delay) {
    var errored = false;
    var errorValue;
    try {
      this.work(state);
    } catch (e) {
      errored = true;
      errorValue = e ? e : new Error("Scheduled action threw falsy error");
    }
    if (errored) {
      this.unsubscribe();
      return errorValue;
    }
  };
  AsyncAction2.prototype.unsubscribe = function() {
    if (!this.closed) {
      var _a2 = this, id2 = _a2.id, scheduler = _a2.scheduler;
      var actions = scheduler.actions;
      this.work = this.state = this.scheduler = null;
      this.pending = false;
      arrRemove(actions, this);
      if (id2 != null) {
        this.id = this.recycleAsyncId(scheduler, id2, null);
      }
      this.delay = null;
      _super.prototype.unsubscribe.call(this);
    }
  };
  return AsyncAction2;
}(Action);
var Scheduler = function() {
  function Scheduler2(schedulerActionCtor, now) {
    if (now === void 0) {
      now = Scheduler2.now;
    }
    this.schedulerActionCtor = schedulerActionCtor;
    this.now = now;
  }
  Scheduler2.prototype.schedule = function(work, delay2, state) {
    if (delay2 === void 0) {
      delay2 = 0;
    }
    return new this.schedulerActionCtor(this, work).schedule(state, delay2);
  };
  Scheduler2.now = dateTimestampProvider.now;
  return Scheduler2;
}();
var AsyncScheduler = function(_super) {
  __extends(AsyncScheduler2, _super);
  function AsyncScheduler2(SchedulerAction, now) {
    if (now === void 0) {
      now = Scheduler.now;
    }
    var _this = _super.call(this, SchedulerAction, now) || this;
    _this.actions = [];
    _this._active = false;
    return _this;
  }
  AsyncScheduler2.prototype.flush = function(action) {
    var actions = this.actions;
    if (this._active) {
      actions.push(action);
      return;
    }
    var error;
    this._active = true;
    do {
      if (error = action.execute(action.state, action.delay)) {
        break;
      }
    } while (action = actions.shift());
    this._active = false;
    if (error) {
      while (action = actions.shift()) {
        action.unsubscribe();
      }
      throw error;
    }
  };
  return AsyncScheduler2;
}(Scheduler);
var asyncScheduler = new AsyncScheduler(AsyncAction);
var async = asyncScheduler;
var EMPTY = new Observable(function(subscriber) {
  return subscriber.complete();
});
function isScheduler(value) {
  return value && isFunction$4(value.schedule);
}
function last(arr) {
  return arr[arr.length - 1];
}
function popScheduler(args) {
  return isScheduler(last(args)) ? args.pop() : void 0;
}
function popNumber(args, defaultValue) {
  return typeof last(args) === "number" ? args.pop() : defaultValue;
}
var isArrayLike$2 = function(x) {
  return x && typeof x.length === "number" && typeof x !== "function";
};
function isPromise(value) {
  return isFunction$4(value === null || value === void 0 ? void 0 : value.then);
}
function isInteropObservable(input) {
  return isFunction$4(input[observable]);
}
function isAsyncIterable(obj) {
  return Symbol.asyncIterator && isFunction$4(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}
function createInvalidObservableTypeError(input) {
  return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function getSymbolIterator() {
  if (typeof Symbol !== "function" || !Symbol.iterator) {
    return "@@iterator";
  }
  return Symbol.iterator;
}
var iterator = getSymbolIterator();
function isIterable(input) {
  return isFunction$4(input === null || input === void 0 ? void 0 : input[iterator]);
}
function readableStreamLikeToAsyncGenerator(readableStream) {
  return __asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
    var reader, _a2, value, done;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          reader = readableStream.getReader();
          _b2.label = 1;
        case 1:
          _b2.trys.push([1, , 9, 10]);
          _b2.label = 2;
        case 2:
          return [4, __await(reader.read())];
        case 3:
          _a2 = _b2.sent(), value = _a2.value, done = _a2.done;
          if (!done) return [3, 5];
          return [4, __await(void 0)];
        case 4:
          return [2, _b2.sent()];
        case 5:
          return [4, __await(value)];
        case 6:
          return [4, _b2.sent()];
        case 7:
          _b2.sent();
          return [3, 2];
        case 8:
          return [3, 10];
        case 9:
          reader.releaseLock();
          return [7];
        case 10:
          return [2];
      }
    });
  });
}
function isReadableStreamLike(obj) {
  return isFunction$4(obj === null || obj === void 0 ? void 0 : obj.getReader);
}
function innerFrom(input) {
  if (input instanceof Observable) {
    return input;
  }
  if (input != null) {
    if (isInteropObservable(input)) {
      return fromInteropObservable(input);
    }
    if (isArrayLike$2(input)) {
      return fromArrayLike(input);
    }
    if (isPromise(input)) {
      return fromPromise(input);
    }
    if (isAsyncIterable(input)) {
      return fromAsyncIterable(input);
    }
    if (isIterable(input)) {
      return fromIterable(input);
    }
    if (isReadableStreamLike(input)) {
      return fromReadableStreamLike(input);
    }
  }
  throw createInvalidObservableTypeError(input);
}
function fromInteropObservable(obj) {
  return new Observable(function(subscriber) {
    var obs = obj[observable]();
    if (isFunction$4(obs.subscribe)) {
      return obs.subscribe(subscriber);
    }
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function fromArrayLike(array) {
  return new Observable(function(subscriber) {
    for (var i = 0; i < array.length && !subscriber.closed; i++) {
      subscriber.next(array[i]);
    }
    subscriber.complete();
  });
}
function fromPromise(promise) {
  return new Observable(function(subscriber) {
    promise.then(function(value) {
      if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
      }
    }, function(err) {
      return subscriber.error(err);
    }).then(null, reportUnhandledError);
  });
}
function fromIterable(iterable) {
  return new Observable(function(subscriber) {
    var e_1, _a2;
    try {
      for (var iterable_1 = __values$1(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
        var value = iterable_1_1.value;
        subscriber.next(value);
        if (subscriber.closed) {
          return;
        }
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (iterable_1_1 && !iterable_1_1.done && (_a2 = iterable_1.return)) _a2.call(iterable_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    subscriber.complete();
  });
}
function fromAsyncIterable(asyncIterable) {
  return new Observable(function(subscriber) {
    process$1(asyncIterable, subscriber).catch(function(err) {
      return subscriber.error(err);
    });
  });
}
function fromReadableStreamLike(readableStream) {
  return fromAsyncIterable(readableStreamLikeToAsyncGenerator(readableStream));
}
function process$1(asyncIterable, subscriber) {
  var asyncIterable_1, asyncIterable_1_1;
  var e_2, _a2;
  return __awaiter(this, void 0, void 0, function() {
    var value, e_2_1;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          _b2.trys.push([0, 5, 6, 11]);
          asyncIterable_1 = __asyncValues(asyncIterable);
          _b2.label = 1;
        case 1:
          return [4, asyncIterable_1.next()];
        case 2:
          if (!(asyncIterable_1_1 = _b2.sent(), !asyncIterable_1_1.done)) return [3, 4];
          value = asyncIterable_1_1.value;
          subscriber.next(value);
          if (subscriber.closed) {
            return [2];
          }
          _b2.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          e_2_1 = _b2.sent();
          e_2 = { error: e_2_1 };
          return [3, 11];
        case 6:
          _b2.trys.push([6, , 9, 10]);
          if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a2 = asyncIterable_1.return))) return [3, 8];
          return [4, _a2.call(asyncIterable_1)];
        case 7:
          _b2.sent();
          _b2.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (e_2) throw e_2.error;
          return [7];
        case 10:
          return [7];
        case 11:
          subscriber.complete();
          return [2];
      }
    });
  });
}
function executeSchedule(parentSubscription, scheduler, work, delay2, repeat) {
  if (delay2 === void 0) {
    delay2 = 0;
  }
  if (repeat === void 0) {
    repeat = false;
  }
  var scheduleSubscription = scheduler.schedule(function() {
    work();
    if (repeat) {
      parentSubscription.add(this.schedule(null, delay2));
    } else {
      this.unsubscribe();
    }
  }, delay2);
  parentSubscription.add(scheduleSubscription);
  if (!repeat) {
    return scheduleSubscription;
  }
}
function observeOn(scheduler, delay2) {
  if (delay2 === void 0) {
    delay2 = 0;
  }
  return operate(function(source, subscriber) {
    source.subscribe(createOperatorSubscriber(subscriber, function(value) {
      return executeSchedule(subscriber, scheduler, function() {
        return subscriber.next(value);
      }, delay2);
    }, function() {
      return executeSchedule(subscriber, scheduler, function() {
        return subscriber.complete();
      }, delay2);
    }, function(err) {
      return executeSchedule(subscriber, scheduler, function() {
        return subscriber.error(err);
      }, delay2);
    }));
  });
}
function subscribeOn(scheduler, delay2) {
  if (delay2 === void 0) {
    delay2 = 0;
  }
  return operate(function(source, subscriber) {
    subscriber.add(scheduler.schedule(function() {
      return source.subscribe(subscriber);
    }, delay2));
  });
}
function scheduleObservable(input, scheduler) {
  return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
}
function schedulePromise(input, scheduler) {
  return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
}
function scheduleArray(input, scheduler) {
  return new Observable(function(subscriber) {
    var i = 0;
    return scheduler.schedule(function() {
      if (i === input.length) {
        subscriber.complete();
      } else {
        subscriber.next(input[i++]);
        if (!subscriber.closed) {
          this.schedule();
        }
      }
    });
  });
}
function scheduleIterable(input, scheduler) {
  return new Observable(function(subscriber) {
    var iterator$1;
    executeSchedule(subscriber, scheduler, function() {
      iterator$1 = input[iterator]();
      executeSchedule(subscriber, scheduler, function() {
        var _a2;
        var value;
        var done;
        try {
          _a2 = iterator$1.next(), value = _a2.value, done = _a2.done;
        } catch (err) {
          subscriber.error(err);
          return;
        }
        if (done) {
          subscriber.complete();
        } else {
          subscriber.next(value);
        }
      }, 0, true);
    });
    return function() {
      return isFunction$4(iterator$1 === null || iterator$1 === void 0 ? void 0 : iterator$1.return) && iterator$1.return();
    };
  });
}
function scheduleAsyncIterable(input, scheduler) {
  if (!input) {
    throw new Error("Iterable cannot be null");
  }
  return new Observable(function(subscriber) {
    executeSchedule(subscriber, scheduler, function() {
      var iterator2 = input[Symbol.asyncIterator]();
      executeSchedule(subscriber, scheduler, function() {
        iterator2.next().then(function(result2) {
          if (result2.done) {
            subscriber.complete();
          } else {
            subscriber.next(result2.value);
          }
        });
      }, 0, true);
    });
  });
}
function scheduleReadableStreamLike(input, scheduler) {
  return scheduleAsyncIterable(readableStreamLikeToAsyncGenerator(input), scheduler);
}
function scheduled(input, scheduler) {
  if (input != null) {
    if (isInteropObservable(input)) {
      return scheduleObservable(input, scheduler);
    }
    if (isArrayLike$2(input)) {
      return scheduleArray(input, scheduler);
    }
    if (isPromise(input)) {
      return schedulePromise(input, scheduler);
    }
    if (isAsyncIterable(input)) {
      return scheduleAsyncIterable(input, scheduler);
    }
    if (isIterable(input)) {
      return scheduleIterable(input, scheduler);
    }
    if (isReadableStreamLike(input)) {
      return scheduleReadableStreamLike(input, scheduler);
    }
  }
  throw createInvalidObservableTypeError(input);
}
function from(input, scheduler) {
  return scheduler ? scheduled(input, scheduler) : innerFrom(input);
}
function isValidDate(value) {
  return value instanceof Date && !isNaN(value);
}
var TimeoutError = createErrorClass(function(_super) {
  return function TimeoutErrorImpl(info) {
    if (info === void 0) {
      info = null;
    }
    _super(this);
    this.message = "Timeout has occurred";
    this.name = "TimeoutError";
    this.info = info;
  };
});
function timeout(config2, schedulerArg) {
  var _a2 = isValidDate(config2) ? { first: config2 } : typeof config2 === "number" ? { each: config2 } : config2, first2 = _a2.first, each2 = _a2.each, _b2 = _a2.with, _with = _b2 === void 0 ? timeoutErrorFactory : _b2, _c2 = _a2.scheduler, scheduler = _c2 === void 0 ? asyncScheduler : _c2, _d2 = _a2.meta, meta = _d2 === void 0 ? null : _d2;
  if (first2 == null && each2 == null) {
    throw new TypeError("No timeout provided.");
  }
  return operate(function(source, subscriber) {
    var originalSourceSubscription;
    var timerSubscription;
    var lastValue = null;
    var seen = 0;
    var startTimer = function(delay2) {
      timerSubscription = executeSchedule(subscriber, scheduler, function() {
        try {
          originalSourceSubscription.unsubscribe();
          innerFrom(_with({
            meta,
            lastValue,
            seen
          })).subscribe(subscriber);
        } catch (err) {
          subscriber.error(err);
        }
      }, delay2);
    };
    originalSourceSubscription = source.subscribe(createOperatorSubscriber(subscriber, function(value) {
      timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
      seen++;
      subscriber.next(lastValue = value);
      each2 > 0 && startTimer(each2);
    }, void 0, void 0, function() {
      if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) {
        timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
      }
      lastValue = null;
    }));
    !seen && startTimer(first2 != null ? typeof first2 === "number" ? first2 : +first2 - scheduler.now() : each2);
  });
}
function timeoutErrorFactory(info) {
  throw new TimeoutError(info);
}
function map$2(project, thisArg) {
  return operate(function(source, subscriber) {
    var index2 = 0;
    source.subscribe(createOperatorSubscriber(subscriber, function(value) {
      subscriber.next(project.call(thisArg, value, index2++));
    }));
  });
}
var isArray$3 = Array.isArray;
function callOrApply(fn, args) {
  return isArray$3(args) ? fn.apply(void 0, __spreadArray([], __read$1(args))) : fn(args);
}
function mapOneOrManyArgs(fn) {
  return map$2(function(args) {
    return callOrApply(fn, args);
  });
}
function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
  var buffer2 = [];
  var active = 0;
  var index2 = 0;
  var isComplete = false;
  var checkComplete = function() {
    if (isComplete && !buffer2.length && !active) {
      subscriber.complete();
    }
  };
  var outerNext = function(value) {
    return active < concurrent ? doInnerSub(value) : buffer2.push(value);
  };
  var doInnerSub = function(value) {
    active++;
    var innerComplete = false;
    innerFrom(project(value, index2++)).subscribe(createOperatorSubscriber(subscriber, function(innerValue) {
      {
        subscriber.next(innerValue);
      }
    }, function() {
      innerComplete = true;
    }, void 0, function() {
      if (innerComplete) {
        try {
          active--;
          var _loop_1 = function() {
            var bufferedValue = buffer2.shift();
            if (innerSubScheduler) ;
            else {
              doInnerSub(bufferedValue);
            }
          };
          while (buffer2.length && active < concurrent) {
            _loop_1();
          }
          checkComplete();
        } catch (err) {
          subscriber.error(err);
        }
      }
    }));
  };
  source.subscribe(createOperatorSubscriber(subscriber, outerNext, function() {
    isComplete = true;
    checkComplete();
  }));
  return function() {
  };
}
function mergeMap(project, resultSelector, concurrent) {
  if (concurrent === void 0) {
    concurrent = Infinity;
  }
  if (isFunction$4(resultSelector)) {
    return mergeMap(function(a, i) {
      return map$2(function(b, ii) {
        return resultSelector(a, b, i, ii);
      })(innerFrom(project(a, i)));
    }, concurrent);
  } else if (typeof resultSelector === "number") {
    concurrent = resultSelector;
  }
  return operate(function(source, subscriber) {
    return mergeInternals(source, subscriber, project, concurrent);
  });
}
function mergeAll(concurrent) {
  if (concurrent === void 0) {
    concurrent = Infinity;
  }
  return mergeMap(identity, concurrent);
}
var nodeEventEmitterMethods = ["addListener", "removeListener"];
var eventTargetMethods = ["addEventListener", "removeEventListener"];
var jqueryMethods = ["on", "off"];
function fromEvent(target, eventName, options, resultSelector) {
  if (isFunction$4(options)) {
    resultSelector = options;
    options = void 0;
  }
  if (resultSelector) {
    return fromEvent(target, eventName, options).pipe(mapOneOrManyArgs(resultSelector));
  }
  var _a2 = __read$1(isEventTarget(target) ? eventTargetMethods.map(function(methodName) {
    return function(handler) {
      return target[methodName](eventName, handler, options);
    };
  }) : isNodeStyleEventEmitter(target) ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target, eventName)) : isJQueryStyleEventEmitter(target) ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a2[0], remove = _a2[1];
  if (!add) {
    if (isArrayLike$2(target)) {
      return mergeMap(function(subTarget) {
        return fromEvent(subTarget, eventName, options);
      })(innerFrom(target));
    }
  }
  if (!add) {
    throw new TypeError("Invalid event target");
  }
  return new Observable(function(subscriber) {
    var handler = function() {
      var args = [];
      for (var _i2 = 0; _i2 < arguments.length; _i2++) {
        args[_i2] = arguments[_i2];
      }
      return subscriber.next(1 < args.length ? args : args[0]);
    };
    add(handler);
    return function() {
      return remove(handler);
    };
  });
}
function toCommonHandlerRegistry(target, eventName) {
  return function(methodName) {
    return function(handler) {
      return target[methodName](eventName, handler);
    };
  };
}
function isNodeStyleEventEmitter(target) {
  return isFunction$4(target.addListener) && isFunction$4(target.removeListener);
}
function isJQueryStyleEventEmitter(target) {
  return isFunction$4(target.on) && isFunction$4(target.off);
}
function isEventTarget(target) {
  return isFunction$4(target.addEventListener) && isFunction$4(target.removeEventListener);
}
function timer(dueTime, intervalOrScheduler, scheduler) {
  if (scheduler === void 0) {
    scheduler = async;
  }
  var intervalDuration = -1;
  if (intervalOrScheduler != null) {
    if (isScheduler(intervalOrScheduler)) {
      scheduler = intervalOrScheduler;
    } else {
      intervalDuration = intervalOrScheduler;
    }
  }
  return new Observable(function(subscriber) {
    var due = isValidDate(dueTime) ? +dueTime - scheduler.now() : dueTime;
    if (due < 0) {
      due = 0;
    }
    var n = 0;
    return scheduler.schedule(function() {
      if (!subscriber.closed) {
        subscriber.next(n++);
        if (0 <= intervalDuration) {
          this.schedule(void 0, intervalDuration);
        } else {
          subscriber.complete();
        }
      }
    }, due);
  });
}
function merge() {
  var args = [];
  for (var _i2 = 0; _i2 < arguments.length; _i2++) {
    args[_i2] = arguments[_i2];
  }
  var scheduler = popScheduler(args);
  var concurrent = popNumber(args, Infinity);
  var sources = args;
  return !sources.length ? EMPTY : sources.length === 1 ? innerFrom(sources[0]) : mergeAll(concurrent)(from(sources, scheduler));
}
function filter2(predicate, thisArg) {
  return operate(function(source, subscriber) {
    var index2 = 0;
    source.subscribe(createOperatorSubscriber(subscriber, function(value) {
      return predicate.call(thisArg, value, index2++) && subscriber.next(value);
    }));
  });
}
function buffer(closingNotifier) {
  return operate(function(source, subscriber) {
    var currentBuffer = [];
    source.subscribe(createOperatorSubscriber(subscriber, function(value) {
      return currentBuffer.push(value);
    }, function() {
      subscriber.next(currentBuffer);
      subscriber.complete();
    }));
    innerFrom(closingNotifier).subscribe(createOperatorSubscriber(subscriber, function() {
      var b = currentBuffer;
      currentBuffer = [];
      subscriber.next(b);
    }, noop$2));
    return function() {
      currentBuffer = null;
    };
  });
}
function debounceTime(dueTime, scheduler) {
  if (scheduler === void 0) {
    scheduler = asyncScheduler;
  }
  return operate(function(source, subscriber) {
    var activeTask = null;
    var lastValue = null;
    var lastTime = null;
    var emit = function() {
      if (activeTask) {
        activeTask.unsubscribe();
        activeTask = null;
        var value = lastValue;
        lastValue = null;
        subscriber.next(value);
      }
    };
    function emitWhenIdle() {
      var targetTime = lastTime + dueTime;
      var now = scheduler.now();
      if (now < targetTime) {
        activeTask = this.schedule(void 0, targetTime - now);
        subscriber.add(activeTask);
        return;
      }
      emit();
    }
    source.subscribe(createOperatorSubscriber(subscriber, function(value) {
      lastValue = value;
      lastTime = scheduler.now();
      if (!activeTask) {
        activeTask = scheduler.schedule(emitWhenIdle, dueTime);
        subscriber.add(activeTask);
      }
    }, function() {
      emit();
      subscriber.complete();
    }, void 0, function() {
      lastValue = activeTask = null;
    }));
  });
}
function take(count) {
  return count <= 0 ? function() {
    return EMPTY;
  } : operate(function(source, subscriber) {
    var seen = 0;
    source.subscribe(createOperatorSubscriber(subscriber, function(value) {
      if (++seen <= count) {
        subscriber.next(value);
        if (count <= seen) {
          subscriber.complete();
        }
      }
    }));
  });
}
function mapTo(value) {
  return map$2(function() {
    return value;
  });
}
function delayWhen(delayDurationSelector, subscriptionDelay) {
  return mergeMap(function(value, index2) {
    return innerFrom(delayDurationSelector(value, index2)).pipe(take(1), mapTo(value));
  });
}
function delay(due, scheduler) {
  if (scheduler === void 0) {
    scheduler = asyncScheduler;
  }
  var duration2 = timer(due, scheduler);
  return delayWhen(function() {
    return duration2;
  });
}
function pairwise() {
  return operate(function(source, subscriber) {
    var prev;
    var hasPrev = false;
    source.subscribe(createOperatorSubscriber(subscriber, function(value) {
      var p = prev;
      prev = value;
      hasPrev && subscriber.next([p, value]);
      hasPrev = true;
    }));
  });
}
function switchMap(project, resultSelector) {
  return operate(function(source, subscriber) {
    var innerSubscriber = null;
    var index2 = 0;
    var isComplete = false;
    var checkComplete = function() {
      return isComplete && !innerSubscriber && subscriber.complete();
    };
    source.subscribe(createOperatorSubscriber(subscriber, function(value) {
      innerSubscriber === null || innerSubscriber === void 0 ? void 0 : innerSubscriber.unsubscribe();
      var innerIndex = 0;
      var outerIndex = index2++;
      innerFrom(project(value, outerIndex)).subscribe(innerSubscriber = createOperatorSubscriber(subscriber, function(innerValue) {
        return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
      }, function() {
        innerSubscriber = null;
        checkComplete();
      }));
    }, function() {
      isComplete = true;
      checkComplete();
    }));
  });
}
var config;
var rootDocument;
function finder(input, options) {
  if (input.nodeType !== Node.ELEMENT_NODE) {
    throw new Error("Can't generate CSS selector for non-element node type.");
  }
  if ("html" === input.tagName.toLowerCase()) {
    return "html";
  }
  var defaults2 = {
    root: document.body,
    idName: function(_name) {
      return true;
    },
    className: function(_name) {
      return true;
    },
    tagName: function(_name) {
      return true;
    },
    attr: function(_name, _value) {
      return false;
    },
    seedMinLength: 1,
    optimizedMinLength: 2,
    threshold: 1e3,
    maxNumberOfTries: 1e4
  };
  config = __assign$1(__assign$1({}, defaults2), options);
  rootDocument = findRootDocument(config.root, defaults2);
  var path = bottomUpSearch(input, "all", function() {
    return bottomUpSearch(input, "two", function() {
      return bottomUpSearch(input, "one", function() {
        return bottomUpSearch(input, "none");
      });
    });
  });
  if (path) {
    var optimized = sort(optimize(path, input));
    if (optimized.length > 0) {
      path = optimized[0];
    }
    return selector(path);
  } else {
    throw new Error("Selector was not found.");
  }
}
function findRootDocument(rootNode, defaults2) {
  if (rootNode.nodeType === Node.DOCUMENT_NODE) {
    return rootNode;
  }
  if (rootNode === defaults2.root) {
    return rootNode.ownerDocument;
  }
  return rootNode;
}
function bottomUpSearch(input, limit, fallback) {
  var path = null;
  var stack = [];
  var current = input;
  var i = 0;
  var _loop_1 = function() {
    var e_1, _a2;
    var level = maybe(id(current)) || maybe.apply(void 0, __spreadArray([], __read$1(attr(current)), false)) || maybe.apply(void 0, __spreadArray([], __read$1(classNames(current)), false)) || maybe(tagName(current)) || [any()];
    var nth = index$1(current);
    if (limit == "all") {
      if (nth) {
        level = level.concat(level.filter(dispensableNth).map(function(node2) {
          return nthChild(node2, nth);
        }));
      }
    } else if (limit == "two") {
      level = level.slice(0, 1);
      if (nth) {
        level = level.concat(level.filter(dispensableNth).map(function(node2) {
          return nthChild(node2, nth);
        }));
      }
    } else if (limit == "one") {
      var _b2 = __read$1(level = level.slice(0, 1), 1), node = _b2[0];
      if (nth && dispensableNth(node)) {
        level = [nthChild(node, nth)];
      }
    } else if (limit == "none") {
      level = [any()];
      if (nth) {
        level = [nthChild(level[0], nth)];
      }
    }
    try {
      for (var level_1 = (e_1 = void 0, __values$1(level)), level_1_1 = level_1.next(); !level_1_1.done; level_1_1 = level_1.next()) {
        var node = level_1_1.value;
        node.level = i;
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (level_1_1 && !level_1_1.done && (_a2 = level_1.return)) _a2.call(level_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    stack.push(level);
    if (stack.length >= config.seedMinLength) {
      path = findUniquePath(stack, fallback);
      if (path) {
        return "break";
      }
    }
    current = current.parentElement;
    i++;
  };
  while (current) {
    var state_1 = _loop_1();
    if (state_1 === "break")
      break;
  }
  if (!path) {
    path = findUniquePath(stack, fallback);
  }
  if (!path && fallback) {
    return fallback();
  }
  return path;
}
function findUniquePath(stack, fallback) {
  var e_2, _a2;
  var numCombinations = stack.reduce(function(acc, i) {
    return acc * i.length;
  }, 1);
  if (numCombinations > config.threshold) {
    return fallback ? fallback() : null;
  }
  var paths = sort(combinations(stack));
  try {
    for (var paths_1 = __values$1(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
      var candidate = paths_1_1.value;
      if (unique(candidate)) {
        return candidate;
      }
    }
  } catch (e_2_1) {
    e_2 = { error: e_2_1 };
  } finally {
    try {
      if (paths_1_1 && !paths_1_1.done && (_a2 = paths_1.return)) _a2.call(paths_1);
    } finally {
      if (e_2) throw e_2.error;
    }
  }
  return null;
}
function selector(path) {
  var node = path[0];
  var query = node.name;
  for (var i = 1; i < path.length; i++) {
    var level = path[i].level || 0;
    if (node.level === level - 1) {
      query = "".concat(path[i].name, " > ").concat(query);
    } else {
      query = "".concat(path[i].name, " ").concat(query);
    }
    node = path[i];
  }
  return query;
}
function penalty(path) {
  return path.map(function(node) {
    return node.penalty;
  }).reduce(function(acc, i) {
    return acc + i;
  }, 0);
}
function unique(path) {
  var css = selector(path);
  switch (rootDocument.querySelectorAll(css).length) {
    case 0:
      throw new Error("Can't select any node with this selector: ".concat(css));
    case 1:
      return true;
    default:
      return false;
  }
}
function id(input) {
  var elementId = input.getAttribute("id");
  if (elementId && config.idName(elementId)) {
    return {
      name: "#" + CSS.escape(elementId),
      penalty: 0
    };
  }
  return null;
}
function attr(input) {
  var attrs = Array.from(input.attributes).filter(function(attr2) {
    return config.attr(attr2.name, attr2.value);
  });
  return attrs.map(function(attr2) {
    return {
      name: "[".concat(CSS.escape(attr2.name), '="').concat(CSS.escape(attr2.value), '"]'),
      penalty: 0.5
    };
  });
}
function classNames(input) {
  var names = Array.from(input.classList).filter(config.className);
  return names.map(function(name2) {
    return {
      name: "." + CSS.escape(name2),
      penalty: 1
    };
  });
}
function tagName(input) {
  var name2 = input.tagName.toLowerCase();
  if (config.tagName(name2)) {
    return {
      name: name2,
      penalty: 2
    };
  }
  return null;
}
function any() {
  return {
    name: "*",
    penalty: 3
  };
}
function index$1(input) {
  var parent = input.parentNode;
  if (!parent) {
    return null;
  }
  var child = parent.firstChild;
  if (!child) {
    return null;
  }
  var i = 0;
  while (child) {
    if (child.nodeType === Node.ELEMENT_NODE) {
      i++;
    }
    if (child === input) {
      break;
    }
    child = child.nextSibling;
  }
  return i;
}
function nthChild(node, i) {
  return {
    name: node.name + ":nth-child(".concat(i, ")"),
    penalty: node.penalty + 1
  };
}
function dispensableNth(node) {
  return node.name !== "html" && !node.name.startsWith("#");
}
function maybe() {
  var level = [];
  for (var _i2 = 0; _i2 < arguments.length; _i2++) {
    level[_i2] = arguments[_i2];
  }
  var list = level.filter(notEmpty);
  if (list.length > 0) {
    return list;
  }
  return null;
}
function notEmpty(value) {
  return value !== null && value !== void 0;
}
function combinations(stack, path) {
  var _a2, _b2, node, e_3_1;
  var e_3, _c2;
  if (path === void 0) {
    path = [];
  }
  return __generator(this, function(_d2) {
    switch (_d2.label) {
      case 0:
        if (!(stack.length > 0)) return [3, 9];
        _d2.label = 1;
      case 1:
        _d2.trys.push([1, 6, 7, 8]);
        _a2 = __values$1(stack[0]), _b2 = _a2.next();
        _d2.label = 2;
      case 2:
        if (!!_b2.done) return [3, 5];
        node = _b2.value;
        return [5, __values$1(combinations(stack.slice(1, stack.length), path.concat(node)))];
      case 3:
        _d2.sent();
        _d2.label = 4;
      case 4:
        _b2 = _a2.next();
        return [3, 2];
      case 5:
        return [3, 8];
      case 6:
        e_3_1 = _d2.sent();
        e_3 = { error: e_3_1 };
        return [3, 8];
      case 7:
        try {
          if (_b2 && !_b2.done && (_c2 = _a2.return)) _c2.call(_a2);
        } finally {
          if (e_3) throw e_3.error;
        }
        return [
          7
          /*endfinally*/
        ];
      case 8:
        return [3, 11];
      case 9:
        return [4, path];
      case 10:
        _d2.sent();
        _d2.label = 11;
      case 11:
        return [
          2
          /*return*/
        ];
    }
  });
}
function sort(paths) {
  return __spreadArray([], __read$1(paths), false).sort(function(a, b) {
    return penalty(a) - penalty(b);
  });
}
function optimize(path, input, scope) {
  var i, newPath, newPathKey;
  if (scope === void 0) {
    scope = {
      counter: 0,
      visited: /* @__PURE__ */ new Map()
    };
  }
  return __generator(this, function(_a2) {
    switch (_a2.label) {
      case 0:
        if (!(path.length > 2 && path.length > config.optimizedMinLength)) return [3, 5];
        i = 1;
        _a2.label = 1;
      case 1:
        if (!(i < path.length - 1)) return [3, 5];
        if (scope.counter > config.maxNumberOfTries) {
          return [
            2
            /*return*/
          ];
        }
        scope.counter += 1;
        newPath = __spreadArray([], __read$1(path), false);
        newPath.splice(i, 1);
        newPathKey = selector(newPath);
        if (scope.visited.has(newPathKey)) {
          return [
            2
            /*return*/
          ];
        }
        if (!(unique(newPath) && same(newPath, input))) return [3, 4];
        return [4, newPath];
      case 2:
        _a2.sent();
        scope.visited.set(newPathKey, true);
        return [5, __values$1(optimize(newPath, input, scope))];
      case 3:
        _a2.sent();
        _a2.label = 4;
      case 4:
        i++;
        return [3, 1];
      case 5:
        return [
          2
          /*return*/
        ];
    }
  });
}
function same(path, input) {
  return rootDocument.querySelector(selector(path)) === input;
}
var SENSITIVE_TAGS = ["input", "select", "textarea"];
var createShouldTrackEvent = function(autocaptureOptions, allowlist) {
  return function(actionType2, element) {
    var _a2, _b2, _c2;
    var pageUrlAllowlist = autocaptureOptions.pageUrlAllowlist, shouldTrackEventResolver = autocaptureOptions.shouldTrackEventResolver;
    var tag = (_b2 = (_a2 = element === null || element === void 0 ? void 0 : element.tagName) === null || _a2 === void 0 ? void 0 : _a2.toLowerCase) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
    if (!tag) {
      return false;
    }
    if (shouldTrackEventResolver) {
      return shouldTrackEventResolver(actionType2, element);
    }
    if (!isPageUrlAllowed(window.location.href, pageUrlAllowlist)) {
      return false;
    }
    var elementType = String(element === null || element === void 0 ? void 0 : element.getAttribute("type")) || "";
    if (typeof elementType === "string") {
      switch (elementType.toLowerCase()) {
        case "hidden":
          return false;
        case "password":
          return false;
      }
    }
    if (allowlist) {
      var hasMatchAnyAllowedSelector = allowlist.some(function(selector2) {
        var _a3;
        return !!((_a3 = element === null || element === void 0 ? void 0 : element.matches) === null || _a3 === void 0 ? void 0 : _a3.call(element, selector2));
      });
      if (!hasMatchAnyAllowedSelector) {
        return false;
      }
    }
    switch (tag) {
      case "input":
      case "select":
      case "textarea":
        return actionType2 === "change" || actionType2 === "click";
      default: {
        var computedStyle = (_c2 = window === null || window === void 0 ? void 0 : window.getComputedStyle) === null || _c2 === void 0 ? void 0 : _c2.call(window, element);
        if (computedStyle && computedStyle.getPropertyValue("cursor") === "pointer" && actionType2 === "click") {
          return true;
        }
        return actionType2 === "click";
      }
    }
  };
};
var isNonSensitiveString = function(text) {
  if (text == null) {
    return false;
  }
  if (typeof text === "string") {
    var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
    if (ccRegex.test((text || "").replace(/[- ]/g, ""))) {
      return false;
    }
    var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
    if (ssnRegex.test(text)) {
      return false;
    }
  }
  return true;
};
var isTextNode = function(node) {
  return !!node && node.nodeType === 3;
};
var isNonSensitiveElement = function(element) {
  var _a2, _b2, _c2;
  var tag = (_b2 = (_a2 = element === null || element === void 0 ? void 0 : element.tagName) === null || _a2 === void 0 ? void 0 : _a2.toLowerCase) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
  var isContentEditable = element instanceof HTMLElement ? ((_c2 = element.getAttribute("contenteditable")) === null || _c2 === void 0 ? void 0 : _c2.toLowerCase()) === "true" : false;
  return !SENSITIVE_TAGS.includes(tag) && !isContentEditable;
};
var getText = function(element) {
  var text = "";
  if (isNonSensitiveElement(element) && element.childNodes && element.childNodes.length) {
    element.childNodes.forEach(function(child) {
      var childText = "";
      if (isTextNode(child)) {
        if (child.textContent) {
          childText = child.textContent;
        }
      } else {
        childText = getText(child);
      }
      text += childText.split(/(\s+)/).filter(isNonSensitiveString).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
    });
  }
  return text;
};
var getSelector = function(element, logger2) {
  var _a2, _b2;
  var selector2 = "";
  try {
    selector2 = finder(element, {
      className: function(name2) {
        return name2 !== AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS;
      },
      maxNumberOfTries: 1e3
    });
    return selector2;
  } catch (error) {
    if (logger2) {
      var typedError = error;
      logger2.warn("Failed to get selector with finder, use fallback strategy instead: ".concat(typedError.toString()));
    }
  }
  var tag = (_b2 = (_a2 = element === null || element === void 0 ? void 0 : element.tagName) === null || _a2 === void 0 ? void 0 : _a2.toLowerCase) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
  if (tag) {
    selector2 = tag;
  }
  var id2 = element.getAttribute("id");
  var className = element.getAttribute("class");
  if (id2) {
    selector2 = "#".concat(id2);
  } else if (className) {
    var classes = className.split(" ").filter(function(name2) {
      return name2 !== AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS;
    }).join(".");
    if (classes) {
      selector2 = "".concat(selector2, ".").concat(classes);
    }
  }
  return selector2;
};
var isPageUrlAllowed = function(url2, pageUrlAllowlist) {
  if (!pageUrlAllowlist || !pageUrlAllowlist.length) {
    return true;
  }
  return pageUrlAllowlist.some(function(allowedUrl) {
    if (typeof allowedUrl === "string") {
      return url2 === allowedUrl;
    }
    return url2.match(allowedUrl);
  });
};
var getAttributesWithPrefix = function(element, prefix) {
  return element.getAttributeNames().reduce(function(attributes, attributeName) {
    if (attributeName.startsWith(prefix)) {
      var attributeKey = attributeName.replace(prefix, "");
      var attributeValue = element.getAttribute(attributeName);
      if (attributeKey) {
        attributes[attributeKey] = attributeValue || "";
      }
    }
    return attributes;
  }, {});
};
var isEmpty$2 = function(value) {
  return value === void 0 || value === null || typeof value === "object" && Object.keys(value).length === 0 || typeof value === "string" && value.trim().length === 0;
};
var removeEmptyProperties = function(properties) {
  return Object.keys(properties).reduce(function(filteredProperties, key) {
    var value = properties[key];
    if (!isEmpty$2(value)) {
      filteredProperties[key] = value;
    }
    return filteredProperties;
  }, {});
};
var getNearestLabel = function(element) {
  var parent = element.parentElement;
  if (!parent) {
    return "";
  }
  var labelElement;
  try {
    labelElement = parent.querySelector(":scope>span,h1,h2,h3,h4,h5,h6");
  } catch (error) {
    labelElement = null;
  }
  if (labelElement) {
    var labelText = labelElement.textContent || "";
    return isNonSensitiveString(labelText) ? labelText : "";
  }
  return getNearestLabel(parent);
};
var getClosestElement = function(element, selectors) {
  if (!element) {
    return null;
  }
  if (selectors.some(function(selector2) {
    var _a2;
    return (_a2 = element === null || element === void 0 ? void 0 : element.matches) === null || _a2 === void 0 ? void 0 : _a2.call(element, selector2);
  })) {
    return element;
  }
  return getClosestElement(element === null || element === void 0 ? void 0 : element.parentElement, selectors);
};
var getEventTagProps = function(element, logger2) {
  var _a2;
  var _b2, _c2;
  if (!element) {
    return {};
  }
  var tag = (_c2 = (_b2 = element === null || element === void 0 ? void 0 : element.tagName) === null || _b2 === void 0 ? void 0 : _b2.toLowerCase) === null || _c2 === void 0 ? void 0 : _c2.call(_b2);
  var selector2 = getSelector(element, logger2);
  var properties = (_a2 = {}, _a2[AMPLITUDE_EVENT_PROP_ELEMENT_TAG] = tag, _a2[AMPLITUDE_EVENT_PROP_ELEMENT_TEXT] = getText(element), _a2[AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR] = selector2, _a2[AMPLITUDE_EVENT_PROP_PAGE_URL] = window.location.href.split("?")[0], _a2);
  return removeEmptyProperties(properties);
};
var asyncLoadScript = function(url2) {
  return new Promise(function(resolve2, reject) {
    var _a2;
    try {
      var scriptElement = document.createElement("script");
      scriptElement.type = "text/javascript";
      scriptElement.async = true;
      scriptElement.src = url2;
      scriptElement.addEventListener("load", function() {
        resolve2({ status: true });
      }, { once: true });
      scriptElement.addEventListener("error", function() {
        reject({
          status: false,
          message: "Failed to load the script ".concat(url2)
        });
      });
      (_a2 = document.head) === null || _a2 === void 0 ? void 0 : _a2.appendChild(scriptElement);
    } catch (error) {
      reject(error);
    }
  });
};
function generateUniqueId() {
  return "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
}
var filterOutNonTrackableEvents = function(event) {
  if (event.event.target === null || !event.closestTrackedAncestor) {
    return false;
  }
  return true;
};
var WindowMessenger = (
  /** @class */
  function() {
    function WindowMessenger2(_a2) {
      var _b2 = _a2 === void 0 ? {} : _a2, _c2 = _b2.origin, origin2 = _c2 === void 0 ? AMPLITUDE_ORIGIN : _c2;
      var _this = this;
      this.endpoint = AMPLITUDE_ORIGIN;
      this.requestCallbacks = {};
      this.onSelect = function(data) {
        _this.notify({ action: "element-selected", data });
      };
      this.onTrack = function(type, properties) {
        if (type === "selector-mode-changed") {
          _this.notify({ action: "track-selector-mode-changed", data: properties });
        } else if (type === "selector-moved") {
          _this.notify({ action: "track-selector-moved", data: properties });
        }
      };
      this.endpoint = origin2;
    }
    WindowMessenger2.prototype.notify = function(message) {
      var _a2, _b2, _c2, _d2;
      (_b2 = (_a2 = this.logger) === null || _a2 === void 0 ? void 0 : _a2.debug) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, "Message sent: ", JSON.stringify(message));
      (_d2 = (_c2 = window.opener) === null || _c2 === void 0 ? void 0 : _c2.postMessage) === null || _d2 === void 0 ? void 0 : _d2.call(_c2, message, this.endpoint);
    };
    WindowMessenger2.prototype.sendRequest = function(action, args, options) {
      var _this = this;
      if (options === void 0) {
        options = { timeout: 15e3 };
      }
      var id2 = generateUniqueId();
      var request = {
        id: id2,
        action,
        args
      };
      var promise = new Promise(function(resolve2, reject) {
        _this.requestCallbacks[id2] = { resolve: resolve2, reject };
        _this.notify(request);
        if ((options === null || options === void 0 ? void 0 : options.timeout) > 0) {
          setTimeout(function() {
            reject(new Error("".concat(action, " timed out (id: ").concat(id2, ")")));
            delete _this.requestCallbacks[id2];
          }, options.timeout);
        }
      });
      return promise;
    };
    WindowMessenger2.prototype.handleResponse = function(response) {
      var _a2;
      if (!this.requestCallbacks[response.id]) {
        (_a2 = this.logger) === null || _a2 === void 0 ? void 0 : _a2.warn("No callback found for request id: ".concat(response.id));
        return;
      }
      this.requestCallbacks[response.id].resolve(response.responseData);
      delete this.requestCallbacks[response.id];
    };
    WindowMessenger2.prototype.setup = function(_a2) {
      var _this = this;
      var _b2 = _a2 === void 0 ? {} : _a2, logger2 = _b2.logger, endpoint = _b2.endpoint, isElementSelectable = _b2.isElementSelectable, cssSelectorAllowlist = _b2.cssSelectorAllowlist, actionClickAllowlist = _b2.actionClickAllowlist;
      this.logger = logger2;
      if (endpoint && this.endpoint === AMPLITUDE_ORIGIN) {
        this.endpoint = endpoint;
      }
      var amplitudeVisualTaggingSelectorInstance = null;
      window.addEventListener("message", function(event) {
        var _a3, _b3, _c2, _d2, _e2;
        (_b3 = (_a3 = _this.logger) === null || _a3 === void 0 ? void 0 : _a3.debug) === null || _b3 === void 0 ? void 0 : _b3.call(_a3, "Message received: ", JSON.stringify(event));
        if (_this.endpoint !== event.origin) {
          return;
        }
        var eventData = event === null || event === void 0 ? void 0 : event.data;
        var action = eventData === null || eventData === void 0 ? void 0 : eventData.action;
        if (!action) {
          return;
        }
        if ("id" in eventData) {
          (_d2 = (_c2 = _this.logger) === null || _c2 === void 0 ? void 0 : _c2.debug) === null || _d2 === void 0 ? void 0 : _d2.call(_c2, "Received Response to previous request: ", JSON.stringify(event));
          _this.handleResponse(eventData);
        } else {
          if (action === "ping") {
            _this.notify({ action: "pong" });
          } else if (action === "initialize-visual-tagging-selector") {
            var actionData_1 = eventData === null || eventData === void 0 ? void 0 : eventData.data;
            asyncLoadScript(AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL).then(function() {
              var _a4;
              amplitudeVisualTaggingSelectorInstance = (_a4 = window === null || window === void 0 ? void 0 : window.amplitudeVisualTaggingSelector) === null || _a4 === void 0 ? void 0 : _a4.call(window, {
                getEventTagProps,
                isElementSelectable: function(element) {
                  if (isElementSelectable) {
                    return isElementSelectable((actionData_1 === null || actionData_1 === void 0 ? void 0 : actionData_1.actionType) || "click", element);
                  }
                  return true;
                },
                onTrack: _this.onTrack,
                onSelect: _this.onSelect,
                visualHighlightClass: AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS,
                messenger: _this,
                cssSelectorAllowlist,
                actionClickAllowlist
              });
              _this.notify({ action: "selector-loaded" });
            }).catch(function() {
              var _a4;
              (_a4 = _this.logger) === null || _a4 === void 0 ? void 0 : _a4.warn("Failed to initialize visual tagging selector");
            });
          } else if (action === "close-visual-tagging-selector") {
            (_e2 = amplitudeVisualTaggingSelectorInstance === null || amplitudeVisualTaggingSelectorInstance === void 0 ? void 0 : amplitudeVisualTaggingSelectorInstance.close) === null || _e2 === void 0 ? void 0 : _e2.call(amplitudeVisualTaggingSelectorInstance);
          }
        }
      });
      this.notify({ action: "page-loaded" });
    };
    return WindowMessenger2;
  }()
);
var BLOCKED_ATTRIBUTES = [
  // Already captured elsewhere in the hierarchy object
  "id",
  "class",
  // non-useful and potentially large attribute
  "style",
  // sensitive as prefilled form data may populate this attribute
  "value",
  // DOM events
  "onclick",
  "onchange",
  "oninput",
  "onblur",
  "onsubmit",
  "onfocus",
  "onkeydown",
  "onkeyup",
  "onkeypress",
  // React specific
  "data-reactid",
  "data-react-checksum",
  "data-reactroot"
];
var SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST = ["type"];
var SVG_TAGS = ["svg", "path", "g"];
var HIGHLY_SENSITIVE_INPUT_TYPES = ["password", "hidden"];
var MAX_ATTRIBUTE_LENGTH = 128;
var MAX_HIERARCHY_LENGTH = 1024;
function getElementProperties(element) {
  var e_1, _a2;
  var _b2, _c2, _d2, _e2;
  if (element === null) {
    return null;
  }
  var tagName2 = String(element.tagName).toLowerCase();
  var properties = {
    tag: tagName2
  };
  var siblings = Array.from((_c2 = (_b2 = element.parentElement) === null || _b2 === void 0 ? void 0 : _b2.children) !== null && _c2 !== void 0 ? _c2 : []);
  if (siblings.length) {
    properties.index = siblings.indexOf(element);
    properties.indexOfType = siblings.filter(function(el2) {
      return el2.tagName === element.tagName;
    }).indexOf(element);
  }
  var prevSiblingTag = (_e2 = (_d2 = element.previousElementSibling) === null || _d2 === void 0 ? void 0 : _d2.tagName) === null || _e2 === void 0 ? void 0 : _e2.toLowerCase();
  if (prevSiblingTag) {
    properties.prevSib = String(prevSiblingTag);
  }
  var id2 = element.getAttribute("id");
  if (id2) {
    properties.id = String(id2);
  }
  var classes = Array.from(element.classList);
  if (classes.length) {
    properties.classes = classes;
  }
  var attributes = {};
  var attributesArray = Array.from(element.attributes);
  var filteredAttributes = attributesArray.filter(function(attr3) {
    return !BLOCKED_ATTRIBUTES.includes(attr3.name);
  });
  var isSensitiveElement = !isNonSensitiveElement(element);
  if (!HIGHLY_SENSITIVE_INPUT_TYPES.includes(String(element.getAttribute("type"))) && !SVG_TAGS.includes(tagName2)) {
    try {
      for (var filteredAttributes_1 = __values$1(filteredAttributes), filteredAttributes_1_1 = filteredAttributes_1.next(); !filteredAttributes_1_1.done; filteredAttributes_1_1 = filteredAttributes_1.next()) {
        var attr2 = filteredAttributes_1_1.value;
        if (isSensitiveElement && !SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST.includes(attr2.name)) {
          continue;
        }
        attributes[attr2.name] = String(attr2.value).substring(0, MAX_ATTRIBUTE_LENGTH);
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (filteredAttributes_1_1 && !filteredAttributes_1_1.done && (_a2 = filteredAttributes_1.return)) _a2.call(filteredAttributes_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }
  if (Object.keys(attributes).length) {
    properties.attrs = attributes;
  }
  return properties;
}
function getAncestors(targetEl) {
  var ancestors = [];
  if (!targetEl) {
    return ancestors;
  }
  ancestors.push(targetEl);
  var current = targetEl.parentElement;
  while (current && current.tagName !== "HTML") {
    ancestors.push(current);
    current = current.parentElement;
  }
  return ancestors;
}
var getHierarchy = function(element) {
  var hierarchy = [];
  if (!element) {
    return [];
  }
  var ancestors = getAncestors(element);
  hierarchy = ensureListUnderLimit(ancestors.map(function(el2) {
    return getElementProperties(el2);
  }), MAX_HIERARCHY_LENGTH);
  return hierarchy;
};
function ensureListUnderLimit(list, bytesLimit) {
  var numChars = 0;
  for (var i = 0; i < list.length; i++) {
    var node = list[i];
    if (node === null) {
      numChars += 4;
    } else {
      var value = ensureUnicodePythonCompatible(node);
      numChars += value ? Array.from(value).length : 4;
    }
    if (numChars > bytesLimit) {
      return list.slice(0, i);
    }
  }
  return list;
}
function ensureUnicodePythonCompatible(value, nested) {
  if (nested === void 0) {
    nested = false;
  }
  try {
    if (value == null) {
      if (nested) {
        return "None";
      }
      return null;
    } else if (typeof value === "string") {
      if (nested) {
        value = value.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
        if (value.includes('"')) {
          return "'".concat(value, "'");
        }
        if (value.includes("'")) {
          return '"'.concat(value.replace(/'/g, "\\'"), '"');
        }
        return "'".concat(value, "'");
      }
      return value;
    } else if (typeof value === "boolean") {
      return value ? "True" : "False";
    } else if (Array.isArray(value)) {
      var elements = value.map(function(o) {
        return ensureUnicodePythonCompatible(o, true);
      });
      return "[".concat(elements.join(", "), "]");
    } else if (typeof value === "object") {
      var entries = Object.entries(value).filter(function(_a2) {
        var _b2 = __read$1(_a2, 1), key = _b2[0];
        return key != null;
      }).map(function(_a2) {
        var _b2 = __read$1(_a2, 2), key = _b2[0], val = _b2[1];
        return "".concat(String(ensureUnicodePythonCompatible(key, true)), ": ").concat(String(ensureUnicodePythonCompatible(val, true)));
      });
      var result2 = "{".concat(entries.join(", "), "}");
      if (result2.includes("\\'")) {
        result2 = result2.replace(/'/g, "'").replace(/'/g, "\\'");
      }
      return result2;
    }
    return value.toString();
  } catch (e) {
    return null;
  }
}
var RAGE_CLICK_THRESHOLD = 5;
function trackClicks(_a2) {
  var amplitude = _a2.amplitude, allObservables = _a2.allObservables, options = _a2.options, shouldTrackEvent = _a2.shouldTrackEvent;
  var clickObservable = allObservables.clickObservable;
  var comparisonTrigger = clickObservable.pipe(pairwise(), filter2(function(_a3) {
    var _b2 = __read$1(_a3, 2), prev = _b2[0], current = _b2[1];
    var targetChanged = prev.event.target !== current.event.target;
    var samePos = Math.abs(current.event.screenX - prev.event.screenX) <= 20 && Math.abs(current.event.screenY - prev.event.screenY) <= 20;
    return targetChanged && !samePos;
  }));
  var timeoutTrigger = clickObservable.pipe(debounceTime(options.debounceTime), map$2(function() {
    return "timeout";
  }));
  var triggers = merge(comparisonTrigger, timeoutTrigger);
  var bufferedClicks = clickObservable.pipe(delay(0), filter2(filterOutNonTrackableEvents), filter2(function(click) {
    return shouldTrackEvent("click", click.closestTrackedAncestor);
  }), buffer(triggers));
  return bufferedClicks.subscribe(function(clicks) {
    var e_1, _a3;
    var clickType = clicks.length >= RAGE_CLICK_THRESHOLD ? AMPLITUDE_ELEMENT_CLICKED_EVENT : AMPLITUDE_ELEMENT_CLICKED_EVENT;
    try {
      for (var clicks_1 = __values$1(clicks), clicks_1_1 = clicks_1.next(); !clicks_1_1.done; clicks_1_1 = clicks_1.next()) {
        var click = clicks_1_1.value;
        amplitude === null || amplitude === void 0 ? void 0 : amplitude.track(clickType, click.targetElementProperties, {
          time: click.timestamp
        });
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (clicks_1_1 && !clicks_1_1.done && (_a3 = clicks_1.return)) _a3.call(clicks_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  });
}
function trackChange(_a2) {
  var amplitude = _a2.amplitude, allObservables = _a2.allObservables, getEventProperties = _a2.getEventProperties, shouldTrackEvent = _a2.shouldTrackEvent;
  var changeObservable = allObservables.changeObservable;
  var filteredChangeObservable = changeObservable.pipe(filter2(filterOutNonTrackableEvents), filter2(function(changeEvent) {
    return shouldTrackEvent("change", changeEvent.closestTrackedAncestor);
  }));
  return filteredChangeObservable.subscribe(function(changeEvent) {
    amplitude === null || amplitude === void 0 ? void 0 : amplitude.track(AMPLITUDE_ELEMENT_CHANGED_EVENT, getEventProperties("change", changeEvent.closestTrackedAncestor));
  });
}
function trackActionClick(_a2) {
  var amplitude = _a2.amplitude, allObservables = _a2.allObservables, options = _a2.options, getEventProperties = _a2.getEventProperties, shouldTrackEvent = _a2.shouldTrackEvent, shouldTrackActionClick = _a2.shouldTrackActionClick;
  var clickObservable = allObservables.clickObservable, mutationObservable = allObservables.mutationObservable, navigateObservable = allObservables.navigateObservable;
  var filteredClickObservable = clickObservable.pipe(filter2(function(click) {
    return !shouldTrackEvent("click", click.closestTrackedAncestor);
  }), map$2(function(click) {
    var closestActionClickEl = getClosestElement(click.event.target, options.actionClickAllowlist);
    click.closestTrackedAncestor = closestActionClickEl;
    if (click.closestTrackedAncestor !== null) {
      click.targetElementProperties = getEventProperties(click.type, click.closestTrackedAncestor);
    }
    return click;
  }), filter2(filterOutNonTrackableEvents), filter2(function(clickEvent) {
    return shouldTrackActionClick("click", clickEvent.closestTrackedAncestor);
  }));
  var changeObservables = [mutationObservable];
  if (navigateObservable) {
    changeObservables.push(navigateObservable);
  }
  var mutationOrNavigate = merge.apply(void 0, __spreadArray([], __read$1(changeObservables), false));
  var actionClicks = filteredClickObservable.pipe(
    // If a mutation occurs within 0.5 seconds of a click event (timeout({ first: 500 })), it emits the original first click event.
    // take 1 to only limit the action events in case there are multiple
    switchMap(function(click) {
      return mutationOrNavigate.pipe(
        take(1),
        timeout({ first: 500, with: function() {
          return EMPTY;
        } }),
        // in case of timeout, map to empty to prevent any click from being emitted
        map$2(function() {
          return click;
        })
      );
    })
  );
  return actionClicks.subscribe(function(actionClick) {
    amplitude === null || amplitude === void 0 ? void 0 : amplitude.track(AMPLITUDE_ELEMENT_CLICKED_EVENT, getEventProperties("click", actionClick.closestTrackedAncestor), {
      time: actionClick.timestamp
    });
  });
}
var ObservablesEnum;
(function(ObservablesEnum2) {
  ObservablesEnum2["ClickObservable"] = "clickObservable";
  ObservablesEnum2["ChangeObservable"] = "changeObservable";
  ObservablesEnum2["NavigateObservable"] = "navigateObservable";
  ObservablesEnum2["MutationObservable"] = "mutationObservable";
})(ObservablesEnum || (ObservablesEnum = {}));
function isElementBasedEvent(event) {
  return event.type === "click" || event.type === "change";
}
var autocapturePlugin = function(options) {
  var _a2, _b2, _c2;
  if (options === void 0) {
    options = {};
  }
  var _d2 = options.dataAttributePrefix, dataAttributePrefix = _d2 === void 0 ? DEFAULT_DATA_ATTRIBUTE_PREFIX : _d2, _e2 = options.visualTaggingOptions, visualTaggingOptions = _e2 === void 0 ? {
    enabled: true,
    messenger: new WindowMessenger()
  } : _e2;
  options.cssSelectorAllowlist = (_a2 = options.cssSelectorAllowlist) !== null && _a2 !== void 0 ? _a2 : DEFAULT_CSS_SELECTOR_ALLOWLIST;
  options.actionClickAllowlist = (_b2 = options.actionClickAllowlist) !== null && _b2 !== void 0 ? _b2 : DEFAULT_ACTION_CLICK_ALLOWLIST;
  options.debounceTime = (_c2 = options.debounceTime) !== null && _c2 !== void 0 ? _c2 : 0;
  var name2 = PLUGIN_NAME;
  var type = "enrichment";
  var subscriptions = [];
  var logger2 = void 0;
  var createObservables = function() {
    var _a3;
    var clickObservable = fromEvent(document, "click", { capture: true }).pipe(map$2(function(click) {
      return addAdditionalEventProperties(click, "click");
    }));
    var changeObservable = fromEvent(document, "change", { capture: true }).pipe(map$2(function(change) {
      return addAdditionalEventProperties(change, "change");
    }));
    var navigateObservable;
    if (window.navigation) {
      navigateObservable = fromEvent(window.navigation, "navigate").pipe(map$2(function(navigate) {
        return addAdditionalEventProperties(navigate, "navigate");
      }));
    }
    var mutationObservable = new Observable(function(observer) {
      var mutationObserver = new MutationObserver(function(mutations) {
        observer.next(mutations);
      });
      mutationObserver.observe(document.body, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
      });
      return function() {
        return mutationObserver.disconnect();
      };
    }).pipe(map$2(function(mutation) {
      return addAdditionalEventProperties(mutation, "mutation");
    }));
    return _a3 = {}, _a3[ObservablesEnum.ClickObservable] = clickObservable, _a3[ObservablesEnum.ChangeObservable] = changeObservable, // [ObservablesEnum.ErrorObservable]: errorObservable,
    _a3[ObservablesEnum.NavigateObservable] = navigateObservable, _a3[ObservablesEnum.MutationObservable] = mutationObservable, _a3;
  };
  var getEventProperties = function(actionType2, element) {
    var _a3;
    var _b3, _c3;
    var tag = (_c3 = (_b3 = element === null || element === void 0 ? void 0 : element.tagName) === null || _b3 === void 0 ? void 0 : _b3.toLowerCase) === null || _c3 === void 0 ? void 0 : _c3.call(_b3);
    var rect = typeof element.getBoundingClientRect === "function" ? element.getBoundingClientRect() : { left: null, top: null };
    var ariaLabel = element.getAttribute("aria-label");
    var attributes = getAttributesWithPrefix(element, dataAttributePrefix);
    var nearestLabel = getNearestLabel(element);
    var selector2 = getSelector(element, logger2);
    var properties = (_a3 = {}, _a3[AMPLITUDE_EVENT_PROP_ELEMENT_ID] = element.getAttribute("id") || "", _a3[AMPLITUDE_EVENT_PROP_ELEMENT_CLASS] = element.getAttribute("class"), _a3[AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY] = getHierarchy(element), _a3[AMPLITUDE_EVENT_PROP_ELEMENT_TAG] = tag, _a3[AMPLITUDE_EVENT_PROP_ELEMENT_TEXT] = getText(element), _a3[AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT] = rect.left == null ? null : Math.round(rect.left), _a3[AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP] = rect.top == null ? null : Math.round(rect.top), _a3[AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL] = ariaLabel, _a3[AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES] = attributes, _a3[AMPLITUDE_EVENT_PROP_ELEMENT_SELECTOR] = selector2, _a3[AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL] = nearestLabel, _a3[AMPLITUDE_EVENT_PROP_PAGE_URL] = window.location.href.split("?")[0], _a3[AMPLITUDE_EVENT_PROP_PAGE_TITLE] = typeof document !== "undefined" && document.title || "", _a3[AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT] = window.innerHeight, _a3[AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH] = window.innerWidth, _a3);
    if (tag === "a" && actionType2 === "click" && element instanceof HTMLAnchorElement) {
      properties[AMPLITUDE_EVENT_PROP_ELEMENT_HREF] = element.href;
    }
    return removeEmptyProperties(properties);
  };
  var addAdditionalEventProperties = function(event, type2) {
    var baseEvent = {
      event,
      timestamp: Date.now(),
      type: type2
    };
    if (isElementBasedEvent(baseEvent) && baseEvent.event.target !== null) {
      var closestTrackedAncestor = getClosestElement(baseEvent.event.target, options.cssSelectorAllowlist);
      if (closestTrackedAncestor) {
        baseEvent.closestTrackedAncestor = closestTrackedAncestor;
        baseEvent.targetElementProperties = getEventProperties(baseEvent.type, closestTrackedAncestor);
      }
      return baseEvent;
    }
    return baseEvent;
  };
  var setup = function(config2, amplitude) {
    return __awaiter(void 0, void 0, void 0, function() {
      var shouldTrackEvent, shouldTrackActionClick, allObservables, clickTrackingSubscription, changeSubscription, actionClickSubscription, allowlist, actionClickAllowlist;
      var _a3, _b3;
      return __generator(this, function(_c3) {
        logger2 = config2.loggerProvider;
        if (typeof document === "undefined") {
          return [
            2
            /*return*/
          ];
        }
        shouldTrackEvent = createShouldTrackEvent(options, options.cssSelectorAllowlist);
        shouldTrackActionClick = createShouldTrackEvent(options, options.actionClickAllowlist);
        allObservables = createObservables();
        clickTrackingSubscription = trackClicks({
          allObservables,
          options,
          amplitude,
          shouldTrackEvent
        });
        subscriptions.push(clickTrackingSubscription);
        changeSubscription = trackChange({
          allObservables,
          getEventProperties,
          amplitude,
          shouldTrackEvent
        });
        subscriptions.push(changeSubscription);
        actionClickSubscription = trackActionClick({
          allObservables,
          options,
          getEventProperties,
          amplitude,
          shouldTrackEvent,
          shouldTrackActionClick
        });
        subscriptions.push(actionClickSubscription);
        (_a3 = config2 === null || config2 === void 0 ? void 0 : config2.loggerProvider) === null || _a3 === void 0 ? void 0 : _a3.log("".concat(name2, " has been successfully added."));
        if (window.opener && visualTaggingOptions.enabled) {
          allowlist = options.cssSelectorAllowlist;
          actionClickAllowlist = options.actionClickAllowlist;
          (_b3 = visualTaggingOptions.messenger) === null || _b3 === void 0 ? void 0 : _b3.setup(__assign$1(__assign$1({ logger: config2 === null || config2 === void 0 ? void 0 : config2.loggerProvider }, (config2 === null || config2 === void 0 ? void 0 : config2.serverZone) && { endpoint: AMPLITUDE_ORIGINS_MAP[config2.serverZone] }), { isElementSelectable: createShouldTrackEvent(options, __spreadArray(__spreadArray([], __read$1(allowlist), false), __read$1(actionClickAllowlist), false)), cssSelectorAllowlist: allowlist, actionClickAllowlist }));
        }
        return [
          2
          /*return*/
        ];
      });
    });
  };
  var execute = function(event) {
    return __awaiter(void 0, void 0, void 0, function() {
      return __generator(this, function(_a3) {
        return [2, event];
      });
    });
  };
  var teardown = function() {
    return __awaiter(void 0, void 0, void 0, function() {
      var subscriptions_1, subscriptions_1_1, subscription;
      var e_1, _a3;
      return __generator(this, function(_b3) {
        try {
          for (subscriptions_1 = __values$1(subscriptions), subscriptions_1_1 = subscriptions_1.next(); !subscriptions_1_1.done; subscriptions_1_1 = subscriptions_1.next()) {
            subscription = subscriptions_1_1.value;
            subscription.unsubscribe();
          }
        } catch (e_1_1) {
          e_1 = { error: e_1_1 };
        } finally {
          try {
            if (subscriptions_1_1 && !subscriptions_1_1.done && (_a3 = subscriptions_1.return)) _a3.call(subscriptions_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        return [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: name2,
    type,
    setup,
    execute,
    teardown
  };
};
var AmplitudeBrowser = (
  /** @class */
  function(_super) {
    __extends(AmplitudeBrowser2, _super);
    function AmplitudeBrowser2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    AmplitudeBrowser2.prototype.init = function(apiKey, userIdOrOptions, maybeOptions) {
      if (apiKey === void 0) {
        apiKey = "";
      }
      var userId;
      var options;
      if (arguments.length > 2) {
        userId = userIdOrOptions;
        options = maybeOptions;
      } else {
        if (typeof userIdOrOptions === "string") {
          userId = userIdOrOptions;
          options = void 0;
        } else {
          userId = userIdOrOptions === null || userIdOrOptions === void 0 ? void 0 : userIdOrOptions.userId;
          options = userIdOrOptions;
        }
      }
      return returnWrapper(this._init(__assign$1(__assign$1({}, options), { userId, apiKey })));
    };
    AmplitudeBrowser2.prototype._init = function(options) {
      return __awaiter(this, void 0, void 0, function() {
        var browserOptions, joinedConfigGenerator, attributionTrackingOptions, queryParams, querySessionId, connector;
        var _this = this;
        var _a2, _b2, _c2;
        return __generator(this, function(_d2) {
          switch (_d2.label) {
            case 0:
              if (this.initializing) {
                return [
                  2
                  /*return*/
                ];
              }
              this.initializing = true;
              return [4, useBrowserConfig(options.apiKey, options, this)];
            case 1:
              browserOptions = _d2.sent();
              if (!options.fetchRemoteConfig) return [3, 4];
              return [4, createBrowserJoinedConfigGenerator(browserOptions)];
            case 2:
              joinedConfigGenerator = _d2.sent();
              return [4, joinedConfigGenerator.generateJoinedConfig()];
            case 3:
              browserOptions = _d2.sent();
              _d2.label = 4;
            case 4:
              return [4, _super.prototype._init.call(this, browserOptions)];
            case 5:
              _d2.sent();
              this.logBrowserOptions(browserOptions);
              if (!isAttributionTrackingEnabled(this.config.defaultTracking)) return [3, 7];
              attributionTrackingOptions = getAttributionTrackingConfig(this.config);
              this.webAttribution = new WebAttribution(attributionTrackingOptions, this.config);
              return [4, this.webAttribution.init()];
            case 6:
              _d2.sent();
              _d2.label = 7;
            case 7:
              queryParams = getQueryParams();
              querySessionId = Number.isNaN(Number(queryParams.ampSessionId)) ? void 0 : Number(queryParams.ampSessionId);
              this.setSessionId((_c2 = (_b2 = (_a2 = options.sessionId) !== null && _a2 !== void 0 ? _a2 : querySessionId) !== null && _b2 !== void 0 ? _b2 : this.config.sessionId) !== null && _c2 !== void 0 ? _c2 : Date.now());
              connector = getAnalyticsConnector(options.instanceName);
              connector.identityStore.setIdentity({
                userId: this.config.userId,
                deviceId: this.config.deviceId
              });
              if (!(this.config.offline !== OfflineDisabled)) return [3, 9];
              return [4, this.add(networkConnectivityCheckerPlugin()).promise];
            case 8:
              _d2.sent();
              _d2.label = 9;
            case 9:
              return [4, this.add(new Destination()).promise];
            case 10:
              _d2.sent();
              return [4, this.add(new Context$1()).promise];
            case 11:
              _d2.sent();
              return [4, this.add(new IdentityEventSender()).promise];
            case 12:
              _d2.sent();
              detNotify(this.config);
              if (!isFileDownloadTrackingEnabled(this.config.defaultTracking)) return [3, 14];
              this.config.loggerProvider.debug("Adding file download tracking plugin");
              return [4, this.add(fileDownloadTracking()).promise];
            case 13:
              _d2.sent();
              _d2.label = 14;
            case 14:
              if (!isFormInteractionTrackingEnabled(this.config.defaultTracking)) return [3, 16];
              this.config.loggerProvider.debug("Adding form interaction plugin");
              return [4, this.add(formInteractionTracking()).promise];
            case 15:
              _d2.sent();
              _d2.label = 16;
            case 16:
              if (!isPageViewTrackingEnabled(this.config.defaultTracking)) return [3, 18];
              this.config.loggerProvider.debug("Adding page view tracking plugin");
              return [4, this.add(pageViewTrackingPlugin(getPageViewTrackingConfig(this.config))).promise];
            case 17:
              _d2.sent();
              _d2.label = 18;
            case 18:
              if (!isElementInteractionsEnabled(this.config.autocapture)) return [3, 20];
              this.config.loggerProvider.debug("Adding user interactions plugin (autocapture plugin)");
              return [4, this.add(autocapturePlugin(getElementInteractionsConfig(this.config))).promise];
            case 19:
              _d2.sent();
              _d2.label = 20;
            case 20:
              this.initializing = false;
              return [4, this.runQueuedFunctions("dispatchQ")];
            case 21:
              _d2.sent();
              connector.eventBridge.setEventReceiver(function(event) {
                void _this.track(event.eventType, event.eventProperties);
              });
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AmplitudeBrowser2.prototype.getUserId = function() {
      var _a2;
      return (_a2 = this.config) === null || _a2 === void 0 ? void 0 : _a2.userId;
    };
    AmplitudeBrowser2.prototype.setUserId = function(userId) {
      if (!this.config) {
        this.q.push(this.setUserId.bind(this, userId));
        return;
      }
      this.config.loggerProvider.debug("function setUserId: ", userId);
      if (userId !== this.config.userId || userId === void 0) {
        this.config.userId = userId;
        setConnectorUserId(userId, this.config.instanceName);
      }
    };
    AmplitudeBrowser2.prototype.getDeviceId = function() {
      var _a2;
      return (_a2 = this.config) === null || _a2 === void 0 ? void 0 : _a2.deviceId;
    };
    AmplitudeBrowser2.prototype.setDeviceId = function(deviceId) {
      if (!this.config) {
        this.q.push(this.setDeviceId.bind(this, deviceId));
        return;
      }
      this.config.loggerProvider.debug("function setDeviceId: ", deviceId);
      this.config.deviceId = deviceId;
      setConnectorDeviceId(deviceId, this.config.instanceName);
    };
    AmplitudeBrowser2.prototype.reset = function() {
      this.setDeviceId(UUID());
      this.setUserId(void 0);
    };
    AmplitudeBrowser2.prototype.getSessionId = function() {
      var _a2;
      return (_a2 = this.config) === null || _a2 === void 0 ? void 0 : _a2.sessionId;
    };
    AmplitudeBrowser2.prototype.setSessionId = function(sessionId) {
      var _a2;
      var promises = [];
      if (!this.config) {
        this.q.push(this.setSessionId.bind(this, sessionId));
        return returnWrapper(Promise.resolve());
      }
      if (sessionId === this.config.sessionId) {
        return returnWrapper(Promise.resolve());
      }
      this.config.loggerProvider.debug("function setSessionId: ", sessionId);
      var previousSessionId = this.getSessionId();
      var lastEventTime = this.config.lastEventTime;
      var lastEventId = (_a2 = this.config.lastEventId) !== null && _a2 !== void 0 ? _a2 : -1;
      this.config.sessionId = sessionId;
      this.config.lastEventTime = void 0;
      this.config.pageCounter = 0;
      if (isSessionTrackingEnabled(this.config.defaultTracking)) {
        if (previousSessionId && lastEventTime) {
          promises.push(this.track(DEFAULT_SESSION_END_EVENT, void 0, {
            device_id: this.previousSessionDeviceId,
            event_id: ++lastEventId,
            session_id: previousSessionId,
            time: lastEventTime + 1,
            user_id: this.previousSessionUserId
          }).promise);
        }
        this.config.lastEventTime = this.config.sessionId;
      }
      var isCampaignEventTracked = this.trackCampaignEventIfNeeded(++lastEventId, promises);
      if (isSessionTrackingEnabled(this.config.defaultTracking)) {
        promises.push(this.track(DEFAULT_SESSION_START_EVENT, void 0, {
          event_id: isCampaignEventTracked ? ++lastEventId : lastEventId,
          session_id: this.config.sessionId,
          time: this.config.lastEventTime
        }).promise);
      }
      this.previousSessionDeviceId = this.config.deviceId;
      this.previousSessionUserId = this.config.userId;
      return returnWrapper(Promise.all(promises));
    };
    AmplitudeBrowser2.prototype.extendSession = function() {
      if (!this.config) {
        this.q.push(this.extendSession.bind(this));
        return;
      }
      this.config.lastEventTime = Date.now();
    };
    AmplitudeBrowser2.prototype.setTransport = function(transport) {
      if (!this.config) {
        this.q.push(this.setTransport.bind(this, transport));
        return;
      }
      this.config.transportProvider = createTransport(transport);
    };
    AmplitudeBrowser2.prototype.identify = function(identify2, eventOptions) {
      if (isInstanceProxy(identify2)) {
        var queue = identify2._q;
        identify2._q = [];
        identify2 = convertProxyObjectToRealObject(new Identify(), queue);
      }
      if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.user_id) {
        this.setUserId(eventOptions.user_id);
      }
      if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.device_id) {
        this.setDeviceId(eventOptions.device_id);
      }
      return _super.prototype.identify.call(this, identify2, eventOptions);
    };
    AmplitudeBrowser2.prototype.groupIdentify = function(groupType, groupName, identify2, eventOptions) {
      if (isInstanceProxy(identify2)) {
        var queue = identify2._q;
        identify2._q = [];
        identify2 = convertProxyObjectToRealObject(new Identify(), queue);
      }
      return _super.prototype.groupIdentify.call(this, groupType, groupName, identify2, eventOptions);
    };
    AmplitudeBrowser2.prototype.revenue = function(revenue, eventOptions) {
      if (isInstanceProxy(revenue)) {
        var queue = revenue._q;
        revenue._q = [];
        revenue = convertProxyObjectToRealObject(new Revenue(), queue);
      }
      return _super.prototype.revenue.call(this, revenue, eventOptions);
    };
    AmplitudeBrowser2.prototype.trackCampaignEventIfNeeded = function(lastEventId, promises) {
      if (!this.webAttribution || !this.webAttribution.shouldTrackNewCampaign) {
        return false;
      }
      var campaignEvent = this.webAttribution.generateCampaignEvent(lastEventId);
      if (promises) {
        promises.push(this.track(campaignEvent).promise);
      } else {
        this.track(campaignEvent);
      }
      this.config.loggerProvider.log("Tracking attribution.");
      return true;
    };
    AmplitudeBrowser2.prototype.process = function(event) {
      return __awaiter(this, void 0, void 0, function() {
        var currentTime, isEventInNewSession, shouldSetSessionIdOnNewCampaign;
        return __generator(this, function(_a2) {
          currentTime = Date.now();
          isEventInNewSession = isNewSession(this.config.sessionTimeout, this.config.lastEventTime);
          shouldSetSessionIdOnNewCampaign = this.webAttribution && this.webAttribution.shouldSetSessionIdOnNewCampaign();
          if (event.event_type !== DEFAULT_SESSION_START_EVENT && event.event_type !== DEFAULT_SESSION_END_EVENT && (!event.session_id || event.session_id === this.getSessionId())) {
            if (isEventInNewSession || shouldSetSessionIdOnNewCampaign) {
              this.setSessionId(currentTime);
              if (shouldSetSessionIdOnNewCampaign) {
                this.config.loggerProvider.log("Created a new session for new campaign.");
              }
            } else if (!isEventInNewSession) {
              this.trackCampaignEventIfNeeded();
            }
          }
          return [2, _super.prototype.process.call(this, event)];
        });
      });
    };
    AmplitudeBrowser2.prototype.logBrowserOptions = function(browserConfig) {
      try {
        var browserConfigCopy = __assign$1(__assign$1({}, browserConfig), { apiKey: browserConfig.apiKey.substring(0, 10) + "********" });
        this.config.loggerProvider.debug("Initialized Amplitude with BrowserConfig:", JSON.stringify(browserConfigCopy));
      } catch (e) {
        this.config.loggerProvider.error("Error logging browser config", e);
      }
    };
    return AmplitudeBrowser2;
  }(AmplitudeCore)
);
var createInstance = function() {
  var client2 = new AmplitudeBrowser();
  return {
    init: debugWrapper(client2.init.bind(client2), "init", getClientLogConfig(client2), getClientStates(client2, ["config"])),
    add: debugWrapper(client2.add.bind(client2), "add", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.plugins"])),
    remove: debugWrapper(client2.remove.bind(client2), "remove", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.plugins"])),
    track: debugWrapper(client2.track.bind(client2), "track", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
    logEvent: debugWrapper(client2.logEvent.bind(client2), "logEvent", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
    identify: debugWrapper(client2.identify.bind(client2), "identify", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
    groupIdentify: debugWrapper(client2.groupIdentify.bind(client2), "groupIdentify", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
    setGroup: debugWrapper(client2.setGroup.bind(client2), "setGroup", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
    revenue: debugWrapper(client2.revenue.bind(client2), "revenue", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
    flush: debugWrapper(client2.flush.bind(client2), "flush", getClientLogConfig(client2), getClientStates(client2, ["config.apiKey", "timeline.queue.length"])),
    getUserId: debugWrapper(client2.getUserId.bind(client2), "getUserId", getClientLogConfig(client2), getClientStates(client2, ["config", "config.userId"])),
    setUserId: debugWrapper(client2.setUserId.bind(client2), "setUserId", getClientLogConfig(client2), getClientStates(client2, ["config", "config.userId"])),
    getDeviceId: debugWrapper(client2.getDeviceId.bind(client2), "getDeviceId", getClientLogConfig(client2), getClientStates(client2, ["config", "config.deviceId"])),
    setDeviceId: debugWrapper(client2.setDeviceId.bind(client2), "setDeviceId", getClientLogConfig(client2), getClientStates(client2, ["config", "config.deviceId"])),
    reset: debugWrapper(client2.reset.bind(client2), "reset", getClientLogConfig(client2), getClientStates(client2, ["config", "config.userId", "config.deviceId"])),
    getSessionId: debugWrapper(client2.getSessionId.bind(client2), "getSessionId", getClientLogConfig(client2), getClientStates(client2, ["config"])),
    setSessionId: debugWrapper(client2.setSessionId.bind(client2), "setSessionId", getClientLogConfig(client2), getClientStates(client2, ["config"])),
    extendSession: debugWrapper(client2.extendSession.bind(client2), "extendSession", getClientLogConfig(client2), getClientStates(client2, ["config"])),
    setOptOut: debugWrapper(client2.setOptOut.bind(client2), "setOptOut", getClientLogConfig(client2), getClientStates(client2, ["config"])),
    setTransport: debugWrapper(client2.setTransport.bind(client2), "setTransport", getClientLogConfig(client2), getClientStates(client2, ["config"]))
  };
};
const client = createInstance();
client.add;
client.extendSession;
client.flush;
client.getDeviceId;
client.getSessionId;
client.getUserId;
client.groupIdentify;
var identify = client.identify;
client.init;
client.logEvent;
client.remove;
client.reset;
client.revenue;
client.setDeviceId;
client.setGroup;
client.setOptOut;
client.setSessionId;
client.setTransport;
client.setUserId;
client.track;
const getEnvironmentDisplayName = (currentHost) => {
  let envDisplayName2;
  const devEnvRegex = /(proj\d+)|(uat\d+\w+)|(uat\.)|(cte\d+)|(cdemo\d+)|(aws\.gwl\.com)|(^uat)|(qa)|(localhost)|(evaluate\d+)/i;
  const regexNames = currentHost.match(devEnvRegex);
  if (regexNames === void 0 || regexNames === null) {
    envDisplayName2 = "Production";
  } else if (regexNames[0] === "uat.") {
    envDisplayName2 = "uat";
  } else {
    envDisplayName2 = regexNames[0];
  }
  return envDisplayName2;
};
const EventBus = function($window, $document) {
  const $log = ExternalLogger$1.getInstance("EventBus");
  const api = this;
  api.legacyInstance = null;
  api.empowerWebInstance = null;
  const listeners = {};
  const _isDeepLoggingEnabled = UrlUtil.getURLParam("logEvents") === "true";
  const _isDebugEnabled = UrlUtil.getURLParam("debug") === "true";
  api.addEventListener = function(type, callback, scope, aScope) {
    let args = [];
    const numOfArgs = arguments.length;
    if (_.isUndefined(type)) {
      throw new Error("event type must be defined");
    }
    if (_.isUndefined(callback)) {
      throw new Error("callback must be defined");
    }
    for (let i = 0; i < numOfArgs; i++) {
      args.push(arguments[i]);
    }
    args = args.length > 3 ? args.splice(4, args.length - 1) : [];
    const newListener = {
      scope,
      callback,
      args
    };
    if (_.isUndefined(listeners[type])) {
      listeners[type] = [];
    }
    listeners[type].push(newListener);
    if (!_.isUndefined(aScope)) {
      $log.debug(
        "!EventBus - Clean up param aScope!\nEvent type:",
        type,
        "Callback:",
        callback,
        "Scope:",
        scope,
        "Angular Scope:",
        aScope
      );
      if (!_.isUndefined(aScope.$on)) {
        aScope.$on("$destroy", function() {
          $log.debug("Scope DESTROYED - removing event listeners");
          return api.removeEventListener(type, callback, scope);
        });
      }
    }
  };
  api.removeEventListener = function(type, callback, scope) {
    if (typeof listeners[type] !== "undefined") {
      const newArray = [];
      _.each(listeners[type], function(thisListener) {
        if (thisListener.scope === scope && thisListener.callback === callback) {
          $log.debug("removing this listener");
        } else {
          newArray.push(thisListener);
        }
      });
      if (newArray.length > 0) {
        listeners[type] = newArray;
      } else {
        delete listeners[type];
      }
    }
  };
  api.stripProperties = function(inData) {
    if (!inData) {
      return inData;
    }
    const data = _.assign({}, inData);
    const keys = Object.getOwnPropertyNames(data);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (_.startsWith(key, "$")) {
        delete data[key];
        if (_isDeepLoggingEnabled && _isDebugEnabled) {
          console.log("filteredPropery", key);
        }
      }
    }
    if (_.isArray(inData)) {
      return Object.values(data);
    } else {
      return data;
    }
  };
  api.getEmpowerWebInstance = function() {
    return api.empowerWebInstance;
  };
  api.dispatchAmplitude = function(payload) {
    const empowerWebInstance = api.getEmpowerWebInstance();
    const currentUrl = $window.location.href;
    payload.event_properties.currentURL = currentUrl;
    if (empowerWebInstance) {
      if (payload.event_properties.userProperties) {
        const updatedUserProperties = api.setAmplitudeUserProperites(
          payload.event_properties.userProperties
        );
        if (payload.event_type === "initialize_application_complete_event") {
          api.setUserIdentify(updatedUserProperties);
        }
        payload.event_properties.userProperties = updatedUserProperties;
        payload.user_properties = updatedUserProperties;
      }
      empowerWebInstance.track(payload);
    }
  };
  api.getLegacyInstance = function() {
    return api.legacyInstance;
  };
  api.dispatch = function(type, inTarget, legacyData = {}) {
    const target = api.stripProperties(inTarget);
    const currentUrl = $window.location.href;
    const event = {
      type,
      target,
      currentURL: currentUrl
    };
    let args = [];
    const numOfArgs = arguments.length;
    for (let i = 0; i < numOfArgs; i++) {
      const arg = api.stripProperties(arguments[i]);
      args.push(arg);
    }
    const legacyInstance = api.getLegacyInstance();
    const legacyEvent = { type, currentUrl, legacyData };
    if (legacyInstance) {
      if (legacyData.userProperties) {
        const updatedUserProperties = api.setAmplitudeUserProperites(
          legacyData.userProperties
        );
        const payload = {
          event_type: "legacy_ga_event",
          event_properties: legacyEvent,
          user_properties: updatedUserProperties
        };
        legacyInstance.track(payload);
      } else {
        legacyInstance.track("legacy_ga_event", legacyEvent);
      }
    }
    args = args.length > 2 ? args.splice(2, args.length - 1) : [];
    args = args.length > 0 ? args.concat([event]) : args = [event];
    const typeListeners = !_.isUndefined(listeners[type]) ? listeners[type] : [];
    const globalListeners = !_.isUndefined(listeners.GLOBAL) ? listeners.GLOBAL : [];
    const typeAndGlobalListeners = typeListeners.concat(globalListeners);
    if (typeAndGlobalListeners.length <= 0) {
      $log.warn("dispatch( No listeners so not dispatching `{0}` )", [type]);
    } else {
      $log.debug("dispatch( type = {0} )", [type]);
    }
    const logData = args[0] || {};
    logData.type = type;
    if (_isDeepLoggingEnabled) {
      console.log(logData);
    }
    _.each(typeAndGlobalListeners, function(thisListener) {
      if (thisListener && thisListener.callback) {
        try {
          thisListener.callback.apply(thisListener.scope, args);
        } catch (err) {
          $log.error(err);
          if (err.stack) {
            $log.error(err.stack);
          }
        }
      }
    });
  };
  api.hasEventListener = function(type, callback, scope) {
    if (typeof listeners[type] !== "undefined") {
      const numOfCallbacks = listeners[type].length;
      if (callback === void 0 && scope === void 0) {
        return numOfCallbacks > 0;
      }
      for (let i = 0; i < numOfCallbacks; i++) {
        const listener = listeners[type][i];
        if ((scope ? listener.scope === scope : true) && listener.callback === callback) {
          return true;
        }
      }
    }
    return false;
  };
  api.getEvents = function() {
    let str = "";
    {
      for (const type in listeners) {
        if (Object.prototype.hasOwnProperty.call(listeners, type)) {
          const numOfCallbacks = listeners[type].length;
          for (let i = 0; i < numOfCallbacks; i++) {
            const listener = listeners[type][i];
            str += listener.scope && listener.scope.className ? listener.scope.className : "anonymous";
            str += " listen for '" + type + "'\n";
          }
        }
      }
    }
    return str;
  };
  api.extractEvent = function(args) {
    if (args) {
      return args[args.length - 1];
    }
  };
  api.addToGlobal = function() {
    var _a2;
    if (!api.existsOnGlobal()) {
      $log.debug(
        "addToGlobal( Adding the eventBus to globalThis object `empower.eventBus` )"
      );
      _.extend($window, {
        empower: {
          eventBus: api
        }
      });
      if ((_a2 = $document[0]) == null ? void 0 : _a2.createEvent) {
        const event = $document[0].createEvent("Event");
        event.initEvent("eventBusReady", true, true);
        $document[0].dispatchEvent(event);
      } else {
        const event = new CustomEvent("eventBusReady");
        document.dispatchEvent(event, true, true);
      }
    }
  };
  api.existsOnGlobal = function() {
    return !_.isUndefined($window.empower) && !_.isNull($window.empower) && !_.isUndefined($window.empower.eventBus) && !_.isNull($window.empower.eventBus);
  };
  api.setAmplitudeUserProperites = function(userProperties) {
    const env = getEnvironmentDisplayName(window.location.host);
    const appendPayload = userProperties;
    appendPayload.environment = env;
    appendPayload.hostname = window.location.hostname;
    appendPayload.protocol = window.location.protocol;
    appendPayload.accu = userProperties.accu || window.accu;
    return appendPayload;
  };
  api.pageViewTrackingEnrichment = function() {
    return {
      name: "page-view-tracking-enrichment",
      type: "enrichment",
      setup: async () => void 0,
      execute: async (event) => {
        const isPageView = String(event.event_type).indexOf("Page View") > -1;
        if (!isPageView) {
          return event;
        }
        event.event_properties = {
          ...event.event_properties,
          page_path_hash: window.location.pathname + window.location.hash
        };
        return event;
      }
    };
  };
  api.createLegacyInstance = function(userId) {
    api.legacyInstance = createInstance();
    api.legacyInstance.add(api.pageViewTrackingEnrichment());
    const amplitudeEnv = getEnvironmentDisplayName(window.location.host);
    const legacyApiKey = amplitudeEnv === "Production" ? "c165f6e95ef99c534bc070242a5aa219" : "ca5490bfc27fecd4e3d6561e0d151018";
    const serverUrl = "https://webusage.retirementpartner.com/2/httpapi";
    api.legacyInstance.init(legacyApiKey, userId, {
      serverUrl,
      defaultTracking: false
    });
  };
  api.createEmpowerWebInstance = function(userId) {
    api.empowerWebInstance = createInstance();
    api.empowerWebInstance.add(api.pageViewTrackingEnrichment());
    const amplitudeEnv = getEnvironmentDisplayName(window.location.host);
    const apiKey = amplitudeEnv === "Production" ? "46a3bf0f27a13623b0932e31b3ae5fef" : "b9061098a0f6dd38efa3db6cc647372a";
    const serverUrl = "https://webusage.retirementpartner.com/2/httpapi";
    api.empowerWebInstance.init(apiKey, userId, {
      serverUrl,
      defaultTracking: {
        attribution: true,
        // You can opt out of marketing attribution tracking by setting to false
        pageViews: {
          trackHistoryChanges: "all"
        },
        sessions: true,
        formInteractions: true,
        fileDownloads: true
      }
    });
  };
  api.amplitudeInit = function({ userId = "" }) {
    api.createLegacyInstance(userId);
    api.createEmpowerWebInstance(userId);
  };
  api.setUserIdentify = function(userProperties) {
    const identifyEvent = new Identify();
    const updatedUserProperties = api.setAmplitudeUserProperites(userProperties);
    for (const key in updatedUserProperties) {
      identifyEvent.set(key, updatedUserProperties[key]);
    }
    identify(identifyEvent);
  };
  return api.existsOnGlobal() ? $window.empower.eventBus : api;
};
EventBus.$inject = ["$window", "$document"];
const TEN_YEARS_IN_MILLISECONDS = 31536e7;
const getCookie$1 = (cookieKey) => {
  let cookieValue = document.cookie.split("; ").find((row) => row.startsWith(`${cookieKey}=`));
  if (cookieValue) {
    cookieValue = cookieValue.split("=")[1];
  }
  return cookieValue;
};
const saveCookie = (name2, value, path, domain, inputExpire, expireDays) => {
  const currentDate = /* @__PURE__ */ new Date();
  const date = /* @__PURE__ */ new Date();
  if (expireDays) {
    date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1e3);
  }
  const expire = expireDays ? date.toUTCString() : new Date(currentDate.getTime() + TEN_YEARS_IN_MILLISECONDS).toUTCString();
  document.cookie = name2 + "=" + value + (path ? ";path=" + path : "") + (domain ? ";domain=" + domain : "") + (inputExpire ? ";expires=" + expire : "");
};
const deleteCookie = (name2, path, domain) => {
  if (getCookie$1(name2)) {
    document.cookie = name2 + "=" + (path ? ";path=" + path : "") + (domain ? ";domain=" + domain : "") + ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
};
const dispatchEventBus = (type, ...data) => {
  const eventBus = new EventBus(window, document);
  if (ObjectUtil.isUndefinedOrNull(type)) {
    console.warn("please check the event type");
  }
  return () => {
    eventBus.dispatch(type, ...data);
  };
};
const updateAccuCookie = (newAccuCode) => {
  deleteCookie("accu", "/");
  saveCookie("accu", newAccuCode, "/");
  deleteCookie("accu", "/participant");
  saveCookie("accu", newAccuCode, "/participant");
  deleteCookie("clientAccu", "/");
  saveCookie("clientAccu", newAccuCode, "/");
  deleteCookie("clientAccu", "/participant");
  saveCookie("clientAccu", newAccuCode, "/participant");
};
const setAuthStatus = (authenticationStatus) => {
  return {
    type: SET_AUTHENTICATION_STATUS,
    payload: authenticationStatus
  };
};
const setAccuCustomizations = (payload) => {
  sessionStorage.setItem("accuFaviconPng", payload.faviconPng);
  return {
    type: SET_ACCU_CUSTOMIZATIONS,
    payload
  };
};
const setInitCustomizationsDone = () => {
  return {
    type: SET_INIT_CUSTOMIZATIONS_DONE
  };
};
const setTranslations = (translations) => {
  return {
    type: SET_TRANSLATIONS,
    payload: translations
  };
};
const setSiteContactInfo = (payload) => {
  return {
    type: SET_SITE_CONTACT_INFO,
    payload
  };
};
const setLanguageCode = (langCode) => {
  return {
    type: SET_SITE_CONTACT_INFO_LANG_CODE,
    payload: { langCode }
  };
};
function getAccuCode() {
  return function(dispatch) {
    const accu2 = getCookie$1("accu");
    dispatch(setAccu(accu2));
  };
}
const setAccu = (accu2) => {
  return {
    type: SET_ACCU,
    payload: accu2
  };
};
const setCache = (statusState) => {
  return {
    type: SET_CACHE,
    payload: statusState === "clear" ? void 0 : statusState
  };
};
const setNonAuthHeader = (payload) => {
  return {
    type: SET_NON_AUTH_HEADER,
    payload
  };
};
const setAccuLogoLoaded = () => {
  return {
    type: SET_ACCU_LOGO_LOADED,
    payload: true
  };
};
const setGlobalSettings = (payload) => {
  return {
    type: SET_GLOBAL_SETTINGS,
    payload
  };
};
const setInitHeaderDone = (payload) => {
  return {
    type: SET_INIT_HEADER_DONE,
    payload
  };
};
const setPlanTxnAccess = (txnAccess) => {
  return {
    type: SET_PLAN_TXN_ACCESS,
    payload: txnAccess
  };
};
const setHeaderPlanMessages = (data) => {
  return {
    type: SET_HDR_PLAN_MESSAGES,
    payload: data
  };
};
const setUserData = (data) => {
  return {
    type: SET_USER_PROFILE_DATA,
    payload: data
  };
};
const setPscUrl = (data) => {
  return {
    type: SET_PSC_PATH_URL,
    payload: data
  };
};
const setIframeUrl = (payload) => {
  return {
    type: SET_IFRAME_URL,
    payload
  };
};
const setActiveMenuModal = (payload) => {
  return {
    type: SET_ACTIVE_MENU_MODAL,
    payload
  };
};
const setShowErrorModal = (payload) => {
  return {
    type: SET_SHOW_ERROR_MODAL,
    payload
  };
};
const setIsDeepLink = (payload) => {
  return {
    type: SET_IS_DEEPLINK,
    payload
  };
};
const setArticlesClicked = (payload) => {
  return {
    type: SET_ARTICLES_CLICKED,
    payload
  };
};
const setAccountOpenInProgress = (payload) => {
  return {
    type: SET_NEW_ACCOUNT_OPENED,
    payload
  };
};
const setShowContextSwitchBlockedModal = (payload) => {
  return {
    type: SET_SHOW_CONTEXT_SWITCH_BLOCKED_MODAL,
    payload
  };
};
const setShowOpenAccountWarning = (payload) => {
  return {
    type: SET_SHOW_OPEN_ACCOUNT_WARNING,
    payload
  };
};
var dist = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.sanitizeUrl = exports.BLANK_URL = void 0;
  var invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
  var htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
  var htmlCtrlEntityRegex = /&(newline|tab);/gi;
  var ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
  var urlSchemeRegex = /^.+(:|&colon;)/gim;
  var relativeFirstCharacters = [".", "/"];
  exports.BLANK_URL = "about:blank";
  function isRelativeUrlWithoutProtocol(url2) {
    return relativeFirstCharacters.indexOf(url2[0]) > -1;
  }
  function decodeHtmlCharacters(str) {
    var removedNullByte = str.replace(ctrlCharactersRegex, "");
    return removedNullByte.replace(htmlEntitiesRegex, function(match, dec) {
      return String.fromCharCode(dec);
    });
  }
  function sanitizeUrl(url2) {
    if (!url2) {
      return exports.BLANK_URL;
    }
    var sanitizedUrl = decodeHtmlCharacters(url2).replace(htmlCtrlEntityRegex, "").replace(ctrlCharactersRegex, "").trim();
    if (!sanitizedUrl) {
      return exports.BLANK_URL;
    }
    if (isRelativeUrlWithoutProtocol(sanitizedUrl)) {
      return sanitizedUrl;
    }
    var urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
    if (!urlSchemeParseResults) {
      return sanitizedUrl;
    }
    var urlScheme = urlSchemeParseResults[0];
    if (invalidProtocolRegex.test(urlScheme)) {
      return exports.BLANK_URL;
    }
    return sanitizedUrl;
  }
  exports.sanitizeUrl = sanitizeUrl;
})(dist);
const isLegacy = (menuItem) => {
  const rc = !!menuItem && !!menuItem.url && menuItem.url.indexOf("/#/") === -1;
  return rc;
};
const getCurrentDomain = () => {
  let currentDomain = window.location.protocol + "//" + window.location.hostname;
  const port = window.location.port;
  if (port !== "") {
    currentDomain += ":" + port;
  }
  currentDomain += "/";
  return currentDomain;
};
const getIframeView = (menuItem) => {
  return dist.sanitizeUrl("" + menuItem.url);
};
const ReferenceData = {
  AVAILABLE_LOCALES: [
    {
      code: "en_US",
      name: "English (US)"
    }
  ],
  FUND_LINEUP_STATUS: {
    PENDING: "pending",
    INELIGIBLE: "ineligible",
    FAILED: "failed",
    ACTIVE: "active",
    NO_LINEUP: "no_lineup"
  },
  MOBILE_TABLET_PHONE_WIDTH: 960,
  ACCESS_DENIED_URL: "/participant/accounts/#/accessDeniedError/44403",
  ACCTS_CUSTOMIZATON_RETRIEVAL_URL: "customizations/{accu}/{accu}{suffixPath}",
  ACCOUNT_DETAILS_MOCK: "/participant/accounts/assets/data/get-account-details.json",
  ACCOUNT_DETAILS_URL: "/participant-web-services/rest/accounts/account/{individualId}/{groupId}",
  ACCOUNT_DETAILS_SUMMARY_URL: "/participant-web-services/rest/accounts/summary",
  ACCOUNT_MENU_URL: "/participant-web-services/rest/menu/getAccountMenuDetails",
  ACCOUNT_SUMMARY_MOCK: "assets/data/get-account-summary.json",
  ACCOUNT_SUMMARY_URL: "/participant-web-services/rest/accounts/summary",
  ACCOUNT_SUMMARY_REFRESH: "/participant-web-services/rest/accounts/summary?refreshAccountsList",
  ACTIVITY_URL: "/participant-web-services/rest/nonauth/service/activity",
  ADVICE_PAGE_URL: "/participant/home/#/advice",
  ALLOCATIONS_SELECTION: "/#/guidance/allocations/selection",
  ALLOCATIONS_SELECTION_W_EQTY_TARGET: "/guidance/allocations/selection/{userEquityTargetPercentage}",
  AUTH_DATA_URL: "/participant-web-services/rest/nonauth/isAuthenticated",
  ENTERPRISE_CHAT_AVAILABILITY: "/participant-web-services/rest/partialauth/chat/availability",
  ENTERPRISE_CHAT_EXECUTE: "/participant-web-services/rest/partialauth/chat/execute",
  CLEAR_LANGUAGE_COOKIES: "/participant-web-services/rest/nonauth/clearLanguageCookies",
  CLEAR_ENGLISH_LANG_COOKIES: "/participant-web-services/rest/nonauth/setAccuCodeCookies",
  CLEAR_SPANISH_LANG_COOKIES: "/participant-web-services/rest/nonauth/clearSpanishLanguageCookies",
  DEFAULT_ACCTS_CUST_RETRIEVAL_URL: "customizations/Default/AccountsDefaultCustomization.json",
  DEFAULT_CUSTOM_LOGO_INVENTORY: "customizations/Default/logoCustomizationInventory.json",
  ELIGIBILITY_URL: "/participant-web-services/rest/home/eligibility",
  GET_FE_SAML_TOKEN: "/participant-web-services/rest/sso/femaSaml",
  GET_FE_SAML_TOKEN_FOR_PLAN: "/participant-web-services/rest/sso/femaSaml/indId/{individualId}/group/{groupId}?pagecode={pagecode}&treatment={treatment}&lastAlert={lastAlert}&clickthrough={clickthrough}",
  GET_TAS_SSO_URL: "/participant-web-services/rest/sso/tasSSO/indId/{individualId}/group/{groupId}",
  GET_INTEGRATED_ELIGIBILITY: "/participant-web-services/rest/home/eligibility",
  GET_SITE_CONTACT_INFO: "/participant-web-services/rest/sitecontactinfo/{gaId}",
  GET_SITE_CONTACT_INFO_PRELOGIN: "/participant-web-services/rest/nonauth/getPreLoginContactInfoByAccu/{accu}/{accuSpecificPrimDb}/{portalType}",
  GET_TOPNAV_LINKS: "/participant-web-services/rest/menu/topNavLinks",
  GET_TOPNAV_LINKS_REFRESH: "/participant-web-services/rest/menu/topNavLinks?refreshAccountsList",
  GROUP_MENU_URL: "/participant-web-services/rest/menu/getGroupNavigationMenu/groupId/{groupId}",
  HDR_PLAN_MSGS_URL: "/participant-web-services/rest/nonauth/bulletins/bulletinsForGrps/function/KP",
  INVESTMENT_OPTIONS_OVERVIEW: "/#/account/{individualId}/{groupId}/investment-options/investment-overview?ignoreDuplicateSets=true",
  INVESTMENT_OVERVIEW_GET_BASIC: "/participant-web-services/rest/investments/services/{individualId}/{groupId}/guidanceInfo",
  IS_PAE_USER: "/participant-web-services/rest/sso/isPAEUser",
  INTEGRATED_DASHBOARD: "/participant/home/#/dashboard/retirement-income",
  KEEP_ALIVE_URL: "/participant-web-services/rest/nonauth/keepAlive",
  LOGIN_APP_URL: "/participant",
  LOGIN_URL_W_ACCU: "/participant/#/login?accu=",
  LOGOUT_LEGACY_URL: "/logoutNextgen.do",
  LOGOUT_SVC_URL: "/participant-web-services/rest/nonauth/logOut",
  PARTICIPANT_APP_URL: "/participant/accounts",
  PARTICIPANT_OVERVIEW_URL: "/participant/accounts/#/overview",
  PRIMARY_PLAN_URL: "/participant-web-services/rest/accounts/primaryPlan",
  PRIMARY_PLAN_BY_IND_ID: "/participant-web-services/rest/accounts/primaryPlanByIndId/{individualId}/{dbName}?accuCode={accuCode}",
  PROFILE_MOBILE: "/#/profile?accu={accuCode}",
  PSC_PATH_URL: "/participant-web-services/rest/nonauth/getPSCPath",
  PSC_PATH_DEFAULT_URL: "https://proj4-plan.retirementpartner.com/psc/?accu=PlanEmpower",
  RETIREMENT_INCOME_URL: "/participant/home/#/dashboard/retirement-income",
  RETRIEVE_LANGUAGE_CODE: "/participant-web-services/rest/partialauth/profile/retrieveLanguageCode",
  SAVINGS_AND_BILL: "/participant/accounts/#/savingsAndBill",
  SET_ACCU_CODE_COOKIES: "/participant-web-services/rest/nonauth/setAccuCodeCookies",
  SET_LANGUAGE_COOKIES: "/participant-web-services/rest/partialauth/profile/setSpnLangCookies",
  SHOW_TOTAL_REWARDS: "/participant-web-services/rest/accounts/hasCharltonPartService",
  TXN_ACCESS_URL: "/participant-web-services/rest/primaryPlan/hasTxnAccess/",
  UPDATE_NEW_ACCT_CONTEXT: "/participant-web-services/rest/partialauth/oneId/retrieveNewAccountInfo?refreshAccountsList",
  UPDATE_DEFAULT_PLAN: "/participant-web-services/rest/partialauth/oneId/refreshSessionWithContextSwitch/{individualId}/{dbName}/{accuCode}/{updateDefault}?gaId={gaId}",
  UPDATE_LANGUAGE_CODE: "/participant-web-services/rest/partialauth/profile/updateLanguageCode",
  USER_PROFILE_URL: "/participant-web-services/rest/accounts/user/profile",
  BANK_ACCOUNTS_URL: "/participant-web-services/rest/partBankAccount/getBankAccounts?gaId={groupId}&indId={individualId}&usageType={usageType}&active=true",
  BANK_ACCOUNTS_URL_CHANGE_PAYMENT: "/participant-web-services/rest/partBankAccount/getBankAccounts?gaId={groupId}&indId={individualId}&active=true",
  CLEAR_IBBOTSON_URL: "/participant-web-services/rest/investments/services/ibbotsonReturn/{groupId}",
  PROVIDER_URL_AND_PHONE_NUMBER_API: "/participant-web-services/rest/accounts/{individualId}/{groupId}/getProviderUrlAndPhoneNumber",
  GET_GROUP_TXN_ACCESS: "/participant-web-services/rest/groupTxnAccess/{individualId}/{groupId}/txnCodes/{txnCodes}",
  GET_MA_DETAILS: "/participant-web-services/rest/accounts/account/MAEnrollmentDetails/{individualId}/{groupId}",
  GET_NQ_ENROLL_ELIGIBILITY: "/participant-web-services/rest/nonqual/isParticipantEnrollmentEligible/{groupId}",
  SAML_TOKEN_API_URLS: {
    getComputerShareSamlTokenApi: "/participant-web-services/rest/sso/computerShareSaml/individualId/{individualId}/groupId/{groupId}",
    getPrudentialSamlTokenApi: "/participant-web-services/rest/sso/prudentialSSO/indId/{individualId}/group/{groupId}",
    getJPMorganSamlTokenApi: "/participant-web-services/rest/sso/jpmorganSSO/indId/{individualId}/group/{groupId}",
    getCharltonSamlTokenApi: "/participant-web-services/rest/sso/charltonSSO/indId/{individualId}/group/{groupId}",
    showTotalRewardsApi: "/participant-web-services/rest/accounts/hasCharltonPartService",
    getMillimanSamlTokenApi: "/participant-web-services/rest/sso/millimanSSO/indId/{individualId}/group/{groupId}",
    getDNPSamlTokenApi: "/participant-web-services/rest/sso/dnpSSO/indId/{individualId}/group/{groupId}",
    getHewittSamlTokenApi: "/participant-web-services/rest/sso/ipAonHewittSSO/indId/{individualId}/group/{groupId}",
    getBPSSamlTokenApi: "/participant-web-services/rest/sso/bpsSSO/indId/{individualId}/group/{groupId}",
    getOptumSamlTokenApi: "/participant-web-services/rest/sso/optumSSO/indId/{individualId}/group/{groupId}",
    getNewportSamlTokenApi: "/participant-web-services/rest/sso/newportSSO/indId/{individualId}/group/{groupId}",
    getOctober3SamlTokenApi: "/participant-web-services/rest/sso/october3SSO/indId/{individualId}/group/{groupId}",
    getNewportAppleSamlTokenApi: "/participant-web-services/rest/sso/newportAppleSSO/indId/{individualId}/group/{groupId}",
    getFindleySamlTokenApi: "/participant-web-services/rest/sso/findleySSO/indId/{individualId}/group/{groupId}",
    getAonSamlTokenApi: "/participant-web-services/rest/sso/aonSSO/indId/{individualId}/group/{groupId}",
    getCBNSamlTokenApi: "/participant-web-services/rest/sso/commonBondSSO/indId/{individualId}/group/{groupId}",
    getCBNInstSamlTokenApi: "/participant-web-services/rest/sso/commonBondSSOInst/indId/{individualId}/group/{groupId}",
    getRiteAidSamlTokenApi: "/participant-web-services/rest/sso/riteAidSSO/indId/{individualId}/group/{groupId}",
    getTRSMillimanSamlTokenApi: "/participant-web-services/rest/sso/millimantrsSSO/indId/{individualId}/group/{groupId}",
    getHSABankSamlTokenApi: "/participant-web-services/rest/sso/hsaBankSSO/indId/{individualId}/group/{groupId}",
    getPershingSamlTokenApi: "/participant-web-services/rest/sso/pershingSSO/indId/{individualId}/group/{groupId}",
    getAbbvieSamlTokenApi: "/participant-web-services/rest/sso/abbvieSSO/indId/:individualId/group/:groupId",
    getEtradeSamlTokenApi: "/participant-web-services/rest/sso/etradeSSO/indId/:individualId/group/:groupId",
    getMyDeferralSamlTokenApi: "/participant-web-services/rest/sso/myDeferralSSO/indId/:individualId/group/:groupId",
    getThreeMSamlTokenApi: "/participant-web-services/rest/sso/threeMSSO/indId/:individualId/group/:groupId",
    getMilliman2SamlTokenApi: "/participant-web-services/rest/sso/milliman2SSO/indId/:individualId/group/:groupId",
    getCandidlySamlTokenApi: "/participant-web-services/rest/sso/candidlySSO/indId/:individualId/group/:groupId",
    getBlueRidgeSamlTokenApi: "/participant-web-services/rest/sso/blueridgeSSO/indId/:individualId/group/:groupId",
    getWellspanSamlTokenApi: "/participant-web-services/rest/sso/wellspanSSO/indId/:individualId/group/:groupId",
    getOptumCycSamlTokenApi: "/participant-web-services/rest/sso/optumcycSSO/indId/:individualId/group/:groupId"
  },
  ROUTES_TO_CHECK: [
    "/retirement-income",
    "/social-security",
    "/other-assets",
    "/income-gap",
    "/dashboard/hsa",
    "/healthcare-costs",
    "/how-do-i-compare",
    "/maximizer",
    "/pre-retirement"
  ],
  PREVENT_NAVIGATION_URLS_URL_ARRAY: [
    "/withdrawal/advisory",
    "/withdrawal/nonrothallocations",
    "/withdrawal/rothallocations",
    "/withdrawal/beneficiary",
    "/withdrawal/accumulation",
    "/distribution/types",
    "/distribution/reasons",
    "/distribution/amount",
    "/distribution/citizenship-verification",
    "/distribution/review",
    "/distribution/employment-check",
    "/loan/reasons",
    "/loan/quotes",
    "loan/loanRepayment",
    "/loan/updates",
    "/loan/requestSummary",
    "/loan/principalResidenceReqDoc",
    "/rmd/request",
    "/rmd/citizenship-verification"
  ],
  errorModal: {
    FEATURE_NOT_AVAILABLE: "This feature is not available until you complete the steps to open your new account",
    UNAUTHORIZED: "You are not authorized to view this page.",
    HEADING_TITLE: "Unable to continue.",
    PAE_MESSAGES: [
      {
        MSG: "Non participant users are prohibited from navigating to this page.",
        CODE: "PAE002"
      }
    ],
    ACCOUNT_OPENING_IN_PROGRESS: {
      TITLE: "Account Opening",
      MSG: "Account Opening still in progress. Please click 'Done' to complete."
    }
  },
  LANGUAGES: {
    ENG: "ENG",
    SPN: "SPN"
  },
  PC_API: {
    MESSAGES: {
      GET_USER_MESSAGES: "/api/message/getUserMessages",
      UPDATE_USER_MESSAGES: "/api/message/updateUserMessages"
    },
    AUTH: {
      SWITCH_USER: "/api/login/switchUser"
    },
    FUNNEL_ATTRIBUTES: {
      GET_FUNNEL_ATTRIBUTES: "/api/profile/getFunnelAttributes"
    },
    ACCOUNTS: {
      GET_ACCOUNTS_LIST: "/api/newaccount/getAccounts2"
    }
  },
  CHAT: {
    PLATFORM: "Web"
  },
  USER_TYPE_PARTICIPANT: "PARTICIPANT",
  USER_TYPE_PRIVILEGED: "PRIVILEGED",
  USER_TYPE_PAE: "PAE",
  HAS_RETAIL_ACCOUNT: {
    SITE_NAME: ["empower-retail-pcap", "empower-retail-pcap-ps", "empower-retail-pcap-cash"]
  }
};
const getItemDisplayText = (translations, item) => {
  return String(item.displayText).indexOf("cx") === 0 && translations.integrated[item.displayText] ? translations.integrated[item.displayText] : item.displayText;
};
const getMenuItemAliasMappings = (val) => {
  const aliasMappings = {
    "on-demand-statements": "documents-statements"
  };
  let url2 = val ? val : "";
  const start = url2.lastIndexOf("/") > -1 ? url2.lastIndexOf("/") : 0;
  const end = url2.indexOf("?") > -1 ? url2.indexOf("?") : url2.length;
  url2 = url2.slice(start, end);
  return aliasMappings[val];
};
const getUniqueMenuTitle = (menuItem) => {
  if (!menuItem.url && typeof menuItem == "string" || menuItem instanceof String) {
    const title = kebabCase(menuItem);
    return title;
  } else {
    let url2 = menuItem.url + "";
    const start = url2.lastIndexOf("/") > -1 ? url2.lastIndexOf("/") : 0;
    const end = url2.indexOf("?") > -1 ? url2.indexOf("?") : url2.length;
    url2 = url2.slice(start, end);
    const title = kebabCase(url2.replace(/\/|#|\./, ""));
    return title;
  }
};
const getUniqueModuleTitle = (menuItem) => {
  if (!menuItem.url && typeof menuItem == "string" || menuItem instanceof String) {
    return kebabCase(menuItem);
  } else {
    let url2 = menuItem.url;
    const start = 0;
    const end = url2.lastIndexOf("/") > -1 ? url2.lastIndexOf("/") : 0;
    url2 = url2.slice(start, end);
    const title = kebabCase(url2.replace(/\/|#|\./, ""));
    return title;
  }
};
const currentMenuParam = (menuItem, currentMenuItem) => {
  let params = window.location.href.split("/");
  if (params[params.length - 1].indexOf("?") > -1) {
    params = params.concat(params[params.length - 1].split("?"));
  }
  const aliasMapping = getMenuItemAliasMappings(params[params.length - 1]);
  if (aliasMapping) {
    params.push(aliasMapping);
  }
  return params.indexOf(getUniqueMenuTitle(menuItem)) > -1 || currentMenuItem === getUniqueMenuTitle(menuItem);
};
const currentSubMenuParam = (subMenuItem, currentSubMenuItem) => {
  const rc = currentSubMenuItem === getUniqueMenuTitle(subMenuItem);
  return rc;
};
const getCurrentMenuItem = (menu, currentMenuItem, currentSubMenuItem) => {
  return filter$1(menu, (item) => {
    return currentMenuParam(item, currentMenuItem) || currentSubMenuParam(item, currentSubMenuItem);
  })[0];
};
const getUrlForNavItem = (navItem, subMenuItem, activeGroupAccount, nonSubMenuGroups) => {
  let urlStr = getCurrentDomain() + "participant/accounts/#/account/" + activeGroupAccount.individualId + "/" + activeGroupAccount.groupId;
  if (navItem.subMenu) {
    const navSubItem = navItem.subMenu[0];
    if (nonSubMenuGroups.indexOf(getUniqueMenuTitle(navItem)) > -1) {
      urlStr += "/" + getUniqueMenuTitle(navItem) + "/" + getUniqueMenuTitle(navSubItem);
    } else {
      if (navSubItem.url && (navSubItem.url.indexOf("/#/") > -1 || navSubItem.type === "nextGen")) {
        urlStr += "/ngfeat/";
      } else {
        urlStr += "/feat/";
      }
      urlStr += getUniqueMenuTitle(navItem);
      if (navSubItem !== null && navSubItem !== void 0) {
        urlStr += "/" + getUniqueMenuTitle(navSubItem);
      }
    }
  } else if (navItem.url && navItem.url.indexOf("##/") > -1) {
    urlStr += "/" + getUniqueModuleTitle(navItem) + "/" + getUniqueMenuTitle(navItem);
  } else if (navItem.url && navItem.url.indexOf("#/") > -1) {
    urlStr += "/" + getUniqueMenuTitle(navItem);
  } else if (navItem.type === "nextGen") {
    urlStr += "/ngfeat/" + getUniqueMenuTitle(navItem);
  } else {
    urlStr += "/feat/" + getUniqueMenuTitle(navItem);
  }
  return urlStr;
};
const originalEnrollValidations = (navMenu2, dispatch) => {
  const url2 = window.location.href;
  const statePreventEnroll = url2.indexOf("enroll") !== -1 && url2.indexOf("error") === -1 && url2.indexOf("confirm-changes") === -1;
  const isEnrollmentPage = window.location.href.indexOf("/participant/enroll/") !== -1;
  const preventEnroll = isEnrollmentPage && statePreventEnroll;
  const preventEnrollWithLogout = preventEnroll && !navMenu2.isIncompleteModalExist;
  if (preventEnroll || preventEnrollWithLogout) {
    dispatch(setIsEnrollmentPage(true));
    return true;
  } else {
    dispatch(setIsEnrollmentPage(false));
  }
  return false;
};
const isPreventUrl = (navMenu2, dispatch) => {
  if (originalEnrollValidations(navMenu2, dispatch)) {
    return true;
  }
  const hasPreventURl = ReferenceData.PREVENT_NAVIGATION_URLS_URL_ARRAY.some((url2) => {
    return window.location.href.indexOf(url2) !== -1;
  });
  return hasPreventURl && navMenu2.isIncompleteModalExist;
};
const accountDropdownMenuClick = (submenu, activeGroupAccount, nonSubMenuGroups, isDesktop, accountOpenInProgress) => {
  let url2 = "";
  if (submenu.userAccountId || submenu.url.indexOf("participant/home/#") > -1) {
    url2 = submenu.url;
  } else {
    url2 = getUrlForNavItem(submenu, null, activeGroupAccount, nonSubMenuGroups);
  }
  if (isDesktop) {
    window.location.href = url2;
    if (accountOpenInProgress && url2.indexOf("participant/home/#") > -1) {
      setTimeout(() => {
        window.location.reload();
      }, 1e3);
    }
  }
  const payload = {
    url: url2,
    title: submenu.displayText
  };
  return payload;
};
const isMobileBrowser = () => {
  return window.innerWidth < ReferenceData.MOBILE_TABLET_PHONE_WIDTH;
};
const convertDisplayText = (translations, navList) => {
  return navList.map((item) => {
    const displayText = getItemDisplayText(translations, item);
    if (item.subMenu && item.subMenu.length > 0) {
      const subMenu = item.subMenu.map((sublist) => {
        const displayText2 = getItemDisplayText(translations, sublist);
        const subsetName = sublist.subsetName ? `- ${sublist.subsetName}` : void 0;
        return {
          ...sublist,
          displayText: displayText2,
          subsetName
        };
      });
      return {
        ...item,
        displayText,
        subMenu
      };
    }
    return {
      ...item,
      displayText
    };
  });
};
const logger$3 = ExternalLogger$1.getInstance("navMenuActions");
const setAccountMenuList = (payload) => {
  return {
    type: SET_ACCOUNT_MENU_LIST,
    payload
  };
};
const setActiveNavItems = (payload) => {
  return {
    type: SET_ACTIVE_NAV_ITEMS,
    payload
  };
};
const setDisplayTotalRewards = (payload) => {
  return {
    type: SET_DISPLAY_TOTAL_REWARDS,
    payload
  };
};
const setOpenSaveChanges = (payload) => {
  return {
    type: SET_OPEN_SAVE_CHANGES,
    payload
  };
};
const setAccountMenuActive = (payload) => {
  return {
    type: SET_ACCOUNT_MENU_ACTIVE,
    payload
  };
};
const setActiveMenuTier = (payload) => {
  return {
    type: SET_ACTIVE_MENU_TIER,
    payload
  };
};
const setActiveMenuItem = (payload) => {
  return {
    type: SET_ACTIVE_MENU_ITEM,
    payload
  };
};
const setActiveSubMenuItem = (payload) => {
  return {
    type: SET_ACTIVE_SUB_MENU_ITEM,
    payload
  };
};
const setMenuNavigation = (payload) => {
  return {
    type: SET_MENU_NAVIGATION,
    payload
  };
};
const inactivate = (tierToInactivate) => {
  return (dispatch, getState) => {
    const state = getState();
    const activeNavItems = state.navMenu.activeNavItems;
    if (has$1(activeNavItems, tierToInactivate)) {
      const tiersToInactivate = [
        tierToInactivate,
        tierToInactivate + 1,
        tierToInactivate + 2
      ];
      dispatch(setActiveNavItems(omit(activeNavItems, tiersToInactivate)));
      const tierToActivate = tierToInactivate - 1;
      dispatch(setActiveMenuTier(tierToActivate));
    } else {
      dispatch(setActiveNavItems({}));
      dispatch(setActiveMenuTier(0));
    }
  };
};
const callSetActiveMenuItem = () => {
  return (dispatch, getState) => {
    const state = getState();
    const activeSubMenuItem = state.navMenu.activeSubMenuItem;
    const activeMenuItem = state.navMenu.activeMenuItem;
    const activeGroupAccount = state.account.activeGroupAccount;
    const menuNavigation = state.navMenu.menuNavigation[activeGroupAccount.groupId];
    if (menuNavigation && menuNavigation.length > 0) {
      const menuItems = [].concat.apply(
        [],
        map$3(menuNavigation, function(category) {
          return category.subMenu;
        })
      );
      const newActiveMenuItem = getCurrentMenuItem(
        menuItems,
        activeMenuItem,
        activeSubMenuItem
      );
      dispatch(setActiveMenuItem(newActiveMenuItem));
      if (newActiveMenuItem) {
        if (!isUndefined$3(newActiveMenuItem)) {
          if (window.location.href.indexOf("account-details") > 0) {
            let tmpActiveMenuItem = null;
            const tmpMenuItem = menuItems[0];
            if (tmpMenuItem.subMenu && tmpMenuItem.subMenu.length > 0) {
              tmpActiveMenuItem = tmpMenuItem.subMenu[0];
            } else {
              tmpActiveMenuItem = tmpMenuItem;
            }
            if (getUrlForNavItem(tmpActiveMenuItem, null, activeGroupAccount).indexOf(
              "account-details"
            ) > 0) {
              ExternalLogger$1.debug(
                "resetting activeMenuItem to first item in the menu if the browser URL is account details"
              );
              dispatch(setActiveMenuItem(tmpActiveMenuItem));
            } else {
              ExternalLogger$1.debug(
                "resetting activeMenuItem to null as account details not found in menu"
              );
              dispatch(setActiveMenuItem(null));
            }
          }
        }
        if (!activeSubMenuItem && newActiveMenuItem.subMenu && newActiveMenuItem.subMenu.length > 0) {
          dispatch(setActiveSubMenuItem(newActiveMenuItem.subMenu[0]));
        }
        if (isLegacy(activeMenuItem) || isLegacy(activeSubMenuItem)) {
          const tmpMenuItem = activeSubMenuItem ? activeSubMenuItem : activeMenuItem;
          const legacyIframeUrl = getIframeView(tmpMenuItem);
          dispatch(setIframeUrl(legacyIframeUrl));
        }
      } else {
        logger$3.debug("activeMenuItem is undefined. Resolve.");
      }
    } else {
      logger$3.debug("MenuNavigation array has no data. deferred reject.");
    }
  };
};
const setIsIncompleteModal = (payload) => {
  return {
    type: SET_IS_INCOMPLETE_MODAL,
    payload
  };
};
const setNextVal = (payload) => {
  return {
    type: SET_NEXT_VAL,
    payload
  };
};
const setupModalScope = (e, menuType, header2) => {
  const accuCode = header2.accu;
  let nextVal = e !== null && e !== void 0 && e.currentTarget != void 0 && e.currentTarget.href != void 0 ? e.currentTarget.href : "";
  if (nextVal === "" || nextVal === void 0 || nextVal.indexOf("unsafe:javascript") !== -1 || menuType === "PROFILE_MOBILE" || menuType === "LOGOUT") {
    const pcap_routing = {
      1100: "/participant/home/#/dashboard/retirement-income",
      1101: "/participant/home/#/net-worth",
      1102: "/participant/home/#/all-transactions",
      1401: "/participant/home/#/portfolio",
      1402: "/participant/home/#/portfolio/balances",
      1403: "/participant/home/#/portfolio/allocation",
      1404: "/participant/home/#/portfolio/allocation",
      1405: "/participant/home/#/portfolio/sectors",
      1504: "/participant/accounts/#/wellness",
      1509: "/participant/home/#/dashboard/retirement-income",
      1513: "/participant/home/#/retirement-planner",
      1514: "/participant/home/#/savings-planner",
      1515: "/participant/accounts/#/guidance/allocations/selection",
      1517: "/participant/accounts/#/studentLoan"
    };
    if (menuType === "LIAT_LOGO" || menuType === "LIAT_HOME") {
      const url2 = window.location.href;
      let transition = true;
      const statesToCheck = ReferenceData.ROUTES_TO_CHECK;
      let re;
      const leading = /^.*/;
      const noTrailingSlash = /[^/]*$/;
      for (let i = 0; i < statesToCheck.length; i++) {
        re = new RegExp(leading.source + statesToCheck[i] + noTrailingSlash.source);
        if (re.test(url2)) {
          transition = false;
          break;
        }
      }
      if (transition) {
        nextVal = ReferenceData.RETIREMENT_INCOME_URL;
      }
    } else if (menuType === "INVESTING") {
      nextVal = ReferenceData.PARTICIPANT_APP_URL + ReferenceData.ALLOCATIONS_SELECTION;
    } else if (menuType === "WELLNESS") {
      nextVal = ReferenceData.PARTICIPANT_APP_URL + "/#/wellness";
    } else if (menuType === "PROFILE_MOBILE") {
      const url2 = StringUtil$1.supplant(ReferenceData.PROFILE_MOBILE, { accuCode });
      nextVal = ReferenceData.LOGIN_APP_URL + url2;
    } else if (menuType === "LOGOUT") {
      nextVal = menuType;
    } else if (menuType === "BREADCRUMB") {
      const href = e.originalEvent.explicitOriginalTarget ? e.originalEvent.explicitOriginalTarget.href : e.originalEvent.target.href;
      nextVal = href;
    } else if (menuType === "CHANGEACCOUNT" || menuType === "NOTIFICATION") {
      nextVal = menuType;
    } else if (menuType === "INTEGRATED_PROFILE") {
      nextVal = "/participant/home/#/settings/profile";
    } else if (menuType in pcap_routing) {
      nextVal = pcap_routing[menuType];
    } else if (menuType !== "" && menuType !== void 0) {
      nextVal = menuType;
    }
  }
  return nextVal;
};
const preventNavigation = (e, menuType, header2) => {
  return (dispatch) => {
    if (e !== null && e !== void 0) {
      e.preventDefault();
    }
    const nextVal = setupModalScope(e, menuType, header2);
    dispatch(setNextVal(nextVal));
    dispatch(setOpenSaveChanges(true));
  };
};
const setMobileMenuActiveSetting = (payload) => {
  return {
    type: SET_MOBILE_MENU_ACTIVE,
    payload
  };
};
const setOnViewAllPrevent = (payload) => {
  return {
    type: SET_ON_VIEW_ALL_PREVENT,
    payload
  };
};
const setIsEnrollmentPage = (payload) => {
  return {
    type: SET_IS_ENROLLMENT_PAGE,
    payload
  };
};
const setNavSettings = (payload) => {
  return {
    type: SET_NAV_SETTINGS,
    payload
  };
};
const setNavUpdated = (payload) => {
  return {
    type: SET_NAV_UPDATE,
    payload
  };
};
const isActivated = (navItem, accountURL, trackClick, activeNavItems) => {
  if (trackClick && trackClick === "accountClick") {
    return find(activeNavItems, function(actItem) {
      return actItem.accountURL === accountURL;
    });
  } else if (trackClick && trackClick === "headerClick" && find(activeNavItems, function(actItem) {
    return actItem.accountURL == accountURL;
  })) {
    return find(activeNavItems, function(actItem) {
      return actItem.transactionCode == navItem.transactionCode;
    });
  }
  return false;
};
const DEFAULT_MESSAGE = "An error has occurred. Please contact a Participant Services Representative if the problem persists.";
const FAIL = "FAIL";
const UNKNOWN = "Unknown";
const logErrorObj = (errorObj, faultLabel = "Fault") => {
  const logger2 = ExternalLogger$1.getInstance("errorUtils");
  const message = `Failed to execute ${errorObj.method} request to ${errorObj.url}. Response code: ${errorObj.httpCode}. Status: ${errorObj.status}. Code: ${errorObj.code}. ${errorObj.errorMessage}`;
  logger2.error("{0}( fault = {1} )", [faultLabel, message]);
};
const handleFault = (fault, faultLabel = "Fault") => {
  const httpCode = get(fault, "status") || get(fault, "response.status") || UNKNOWN;
  const url2 = get(fault, "request.responseURL") || get(fault, "config.url") || UNKNOWN;
  const method = get(fault, "config.method") || UNKNOWN;
  const isApiError = true;
  const code = get(fault, "data.error.code") || UNKNOWN;
  const message = get(fault, "data.error.message") || DEFAULT_MESSAGE;
  let errorMessage = get(fault, "message") || "";
  const status = get(fault, "data.status") || UNKNOWN;
  if (!get(fault, "data")) {
    errorMessage = "Empty data response from server";
  }
  const errorObj = {
    isApiError,
    httpCode,
    code,
    url: url2,
    method,
    errorMessage,
    message,
    status,
    hasCode: !!code && code !== UNKNOWN
  };
  if (get(fault, "config.data")) {
    errorObj.requestData = JSON.stringify(fault.config.data);
  }
  logErrorObj(errorObj, faultLabel);
  return errorObj;
};
const executeGet = (url2, faultLabel, params) => {
  return axios.get(url2, { ...params, withCredentials: true }).then((response) => {
    checkResponseForError(response);
    return response;
  }).catch((err) => {
    throw handleFault(err, faultLabel);
  });
};
const executePost = (url2, faultLabel, params, options) => {
  return axios.post(url2, params, options).then((response) => {
    checkResponseForError(response);
    return response;
  }).catch((err) => {
    throw handleFault(err, faultLabel);
  });
};
const checkResponseForError = (response) => {
  if (!get(response, "data") || get(response, "data.status") === FAIL) {
    throw response;
  }
};
let cache$1 = void 0;
let getAuthStatusRequestOut = false;
const isLocalhost$1 = () => String(window.location.href).indexOf("localhost") > -1;
const hasMocks$1 = () => UrlUtil.getURLParam("useMocks") === "true";
const getCache = () => {
  return cache$1;
};
const clearCache = () => {
  cache$1 = void 0;
};
const getAuthData = () => {
  if (getCache()) {
    clearCache();
  }
  getAuthStatusRequestOut = false;
  if (!getAuthStatusRequestOut && cache$1 === void 0) {
    getAuthStatusRequestOut = true;
    const liveUrl = "" + ReferenceData.AUTH_DATA_URL;
    const mock = window.location.origin + window.location.pathname + "data/is-Authenticated.json";
    const url2 = hasMocks$1() && isLocalhost$1() ? mock : liveUrl;
    const param = {};
    return axios.post(url2, param, { withCredentials: true }).then((response) => {
      getAuthStatusRequestOut = false;
      if (response.data && !ObjectUtil.isUndefinedOrNull(response.data.authenticated)) {
        globalThis.userIsAuthenticated = response.data.authenticated;
      }
      cache$1 = response.data;
      return response.data;
    }).catch((err) => {
      throw handleFault(err, "getAuthDataFault");
    });
  }
};
const getBaseApiUrl = () => {
  const baseApiUrl = "";
  let newBaseApiUrl = window.location.origin;
  const https = "https://";
  const http = "http://";
  const period = ".";
  const toLangCode = "es";
  const setWindowLocation = () => {
    if (!window.location.origin) {
      window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
    }
    return newBaseApiUrl = window.location.origin;
  };
  if (baseApiUrl.indexOf(https + toLangCode) >= 0 || baseApiUrl.indexOf(http + toLangCode) >= 0) {
    newBaseApiUrl = newBaseApiUrl.replace(https + toLangCode + period, https);
    newBaseApiUrl = newBaseApiUrl.replace(http + toLangCode + period, http);
  }
  if (baseApiUrl.indexOf(https + toLangCode) < 0 && baseApiUrl.indexOf(http + toLangCode) < 0) {
    newBaseApiUrl = newBaseApiUrl.replace(https, https + toLangCode + period);
    newBaseApiUrl = newBaseApiUrl.replace(http, http + toLangCode + period);
  }
  if (newBaseApiUrl === "" || newBaseApiUrl.indexOf(https + toLangCode) >= 0 || newBaseApiUrl.indexOf(http + toLangCode) >= 0) {
    setWindowLocation();
    if (newBaseApiUrl.indexOf(https + toLangCode) >= 0 || newBaseApiUrl.indexOf(http + toLangCode) >= 0) {
      newBaseApiUrl = newBaseApiUrl.replace(https + toLangCode + period, https);
      newBaseApiUrl = newBaseApiUrl.replace(http + toLangCode + period, http);
    }
  }
  if (newBaseApiUrl.indexOf(https + toLangCode) < 0 && newBaseApiUrl.indexOf(http + toLangCode) < 0) {
    setWindowLocation();
    if (newBaseApiUrl.indexOf(https + toLangCode) < 0 && newBaseApiUrl.indexOf(http + toLangCode) < 0) {
      newBaseApiUrl = newBaseApiUrl.replace(https, https + toLangCode + period);
      newBaseApiUrl = newBaseApiUrl.replace(http, http + toLangCode + period);
    }
  }
  return newBaseApiUrl;
};
const clearResponseLanguageCookies = () => {
  const clearLanguageCookiesResult = (response) => {
    return response;
  };
  const newBaseApiUrl = getBaseApiUrl();
  const selectedLanguage = newBaseApiUrl.includes("es");
  const clearCookieUrl = selectedLanguage ? `${newBaseApiUrl + ReferenceData.CLEAR_SPANISH_LANG_COOKIES}` : `${newBaseApiUrl + ReferenceData.CLEAR_ENGLISH_LANG_COOKIES}`;
  return executeGet(clearCookieUrl, "clearLanguageCookiesFault").then(clearLanguageCookiesResult).catch((error) => {
    console.log("Error: ", error);
  });
};
const clearLanguageCookies = () => {
  const clearLanguageCookiesResult = (response) => {
    return response;
  };
  const clearCookieUrl = "" + ReferenceData.CLEAR_LANGUAGE_COOKIES;
  return executeGet(clearCookieUrl, "clearLanguageCookiesFault").then(clearLanguageCookiesResult).catch((error) => {
    console.log("Error: ", error);
  });
};
const setAccuCodeCookies = () => {
  const setAccuCodeCookiesResult = (result2) => {
    if (result2) {
      return result2.data;
    } else {
      return null;
    }
  };
  const newBaseApiUrl = getBaseApiUrl();
  const setAccuCodeCookieUrl = newBaseApiUrl + ReferenceData.SET_ACCU_CODE_COOKIES;
  return executeGet(setAccuCodeCookieUrl, "setAccuCodeCookiesFault").then(setAccuCodeCookiesResult).catch((error) => {
    console.log("Error: ", error);
  });
};
const mocksContainedInWithQuery = (str, query) => {
  return str.indexOf(query) > -1;
};
const hasMocks = () => {
  const query = "useMocks=true";
  const { hash, search } = window.location;
  return mocksContainedInWithQuery(search, query) || mocksContainedInWithQuery(hash, query);
};
const isLocalhost = () => String(window.location.href).indexOf("localhost") > -1;
const islocalMocksTrue = () => isLocalhost() && hasMocks();
const localMocksTrue = islocalMocksTrue();
const islocalMocksFalse = () => isLocalhost() && !hasMocks();
islocalMocksFalse();
const pcapBundle = () => String(window.location.href).indexOf("pcapBundle") > -1;
const pcapBundleEnv = pcapBundle();
const injectPcapApiParam = (str) => {
  return str;
};
function getParameterByName(name2, url2 = window.location.href) {
  name2 = name2.replace(/[[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name2 + "(=([^&#]*)|&|#|$)"), results = regex.exec(url2);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
const getLocation = ({ host, href }) => {
  const location2 = href.slice(href.indexOf(host) + host.length + 1);
  return location2;
};
var loglevel$1 = { exports: {} };
(function(module) {
  (function(root2, definition) {
    if (module.exports) {
      module.exports = definition();
    } else {
      root2.log = definition();
    }
  })(commonjsGlobal, function() {
    var noop2 = function() {
    };
    var undefinedType = "undefined";
    var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ];
    var _loggersByName = {};
    var defaultLogger = null;
    function bindMethod(obj, methodName) {
      var method = obj[methodName];
      if (typeof method.bind === "function") {
        return method.bind(obj);
      } else {
        try {
          return Function.prototype.bind.call(method, obj);
        } catch (e) {
          return function() {
            return Function.prototype.apply.apply(method, [obj, arguments]);
          };
        }
      }
    }
    function traceForIE() {
      if (console.log) {
        if (console.log.apply) {
          console.log.apply(console, arguments);
        } else {
          Function.prototype.apply.apply(console.log, [console, arguments]);
        }
      }
      if (console.trace) console.trace();
    }
    function realMethod(methodName) {
      if (methodName === "debug") {
        methodName = "log";
      }
      if (typeof console === undefinedType) {
        return false;
      } else if (methodName === "trace" && isIE) {
        return traceForIE;
      } else if (console[methodName] !== void 0) {
        return bindMethod(console, methodName);
      } else if (console.log !== void 0) {
        return bindMethod(console, "log");
      } else {
        return noop2;
      }
    }
    function replaceLoggingMethods() {
      var level = this.getLevel();
      for (var i = 0; i < logMethods.length; i++) {
        var methodName = logMethods[i];
        this[methodName] = i < level ? noop2 : this.methodFactory(methodName, level, this.name);
      }
      this.log = this.debug;
      if (typeof console === undefinedType && level < this.levels.SILENT) {
        return "No console available for logging";
      }
    }
    function enableLoggingWhenConsoleArrives(methodName) {
      return function() {
        if (typeof console !== undefinedType) {
          replaceLoggingMethods.call(this);
          this[methodName].apply(this, arguments);
        }
      };
    }
    function defaultMethodFactory(methodName, _level, _loggerName) {
      return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }
    function Logger2(name2, factory) {
      var self2 = this;
      var inheritedLevel;
      var defaultLevel;
      var userLevel;
      var storageKey = "loglevel";
      if (typeof name2 === "string") {
        storageKey += ":" + name2;
      } else if (typeof name2 === "symbol") {
        storageKey = void 0;
      }
      function persistLevelIfPossible(levelNum) {
        var levelName = (logMethods[levelNum] || "silent").toUpperCase();
        if (typeof window === undefinedType || !storageKey) return;
        try {
          window.localStorage[storageKey] = levelName;
          return;
        } catch (ignore) {
        }
        try {
          window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
        } catch (ignore) {
        }
      }
      function getPersistedLevel() {
        var storedLevel;
        if (typeof window === undefinedType || !storageKey) return;
        try {
          storedLevel = window.localStorage[storageKey];
        } catch (ignore) {
        }
        if (typeof storedLevel === undefinedType) {
          try {
            var cookie = window.document.cookie;
            var cookieName = encodeURIComponent(storageKey);
            var location2 = cookie.indexOf(cookieName + "=");
            if (location2 !== -1) {
              storedLevel = /^([^;]+)/.exec(
                cookie.slice(location2 + cookieName.length + 1)
              )[1];
            }
          } catch (ignore) {
          }
        }
        if (self2.levels[storedLevel] === void 0) {
          storedLevel = void 0;
        }
        return storedLevel;
      }
      function clearPersistedLevel() {
        if (typeof window === undefinedType || !storageKey) return;
        try {
          window.localStorage.removeItem(storageKey);
        } catch (ignore) {
        }
        try {
          window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
        } catch (ignore) {
        }
      }
      function normalizeLevel(input) {
        var level = input;
        if (typeof level === "string" && self2.levels[level.toUpperCase()] !== void 0) {
          level = self2.levels[level.toUpperCase()];
        }
        if (typeof level === "number" && level >= 0 && level <= self2.levels.SILENT) {
          return level;
        } else {
          throw new TypeError("log.setLevel() called with invalid level: " + input);
        }
      }
      self2.name = name2;
      self2.levels = {
        "TRACE": 0,
        "DEBUG": 1,
        "INFO": 2,
        "WARN": 3,
        "ERROR": 4,
        "SILENT": 5
      };
      self2.methodFactory = factory || defaultMethodFactory;
      self2.getLevel = function() {
        if (userLevel != null) {
          return userLevel;
        } else if (defaultLevel != null) {
          return defaultLevel;
        } else {
          return inheritedLevel;
        }
      };
      self2.setLevel = function(level, persist) {
        userLevel = normalizeLevel(level);
        if (persist !== false) {
          persistLevelIfPossible(userLevel);
        }
        return replaceLoggingMethods.call(self2);
      };
      self2.setDefaultLevel = function(level) {
        defaultLevel = normalizeLevel(level);
        if (!getPersistedLevel()) {
          self2.setLevel(level, false);
        }
      };
      self2.resetLevel = function() {
        userLevel = null;
        clearPersistedLevel();
        replaceLoggingMethods.call(self2);
      };
      self2.enableAll = function(persist) {
        self2.setLevel(self2.levels.TRACE, persist);
      };
      self2.disableAll = function(persist) {
        self2.setLevel(self2.levels.SILENT, persist);
      };
      self2.rebuild = function() {
        if (defaultLogger !== self2) {
          inheritedLevel = normalizeLevel(defaultLogger.getLevel());
        }
        replaceLoggingMethods.call(self2);
        if (defaultLogger === self2) {
          for (var childName in _loggersByName) {
            _loggersByName[childName].rebuild();
          }
        }
      };
      inheritedLevel = normalizeLevel(
        defaultLogger ? defaultLogger.getLevel() : "WARN"
      );
      var initialLevel = getPersistedLevel();
      if (initialLevel != null) {
        userLevel = normalizeLevel(initialLevel);
      }
      replaceLoggingMethods.call(self2);
    }
    defaultLogger = new Logger2();
    defaultLogger.getLogger = function getLogger(name2) {
      if (typeof name2 !== "symbol" && typeof name2 !== "string" || name2 === "") {
        throw new TypeError("You must supply a name when creating a logger.");
      }
      var logger2 = _loggersByName[name2];
      if (!logger2) {
        logger2 = _loggersByName[name2] = new Logger2(
          name2,
          defaultLogger.methodFactory
        );
      }
      return logger2;
    };
    var _log = typeof window !== undefinedType ? window.log : void 0;
    defaultLogger.noConflict = function() {
      if (typeof window !== undefinedType && window.log === defaultLogger) {
        window.log = _log;
      }
      return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
      return _loggersByName;
    };
    defaultLogger["default"] = defaultLogger;
    return defaultLogger;
  });
})(loglevel$1);
var loglevelExports = loglevel$1.exports;
const loglevel = /* @__PURE__ */ getDefaultExportFromCjs(loglevelExports);
const log = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: loglevel
}, [loglevelExports]);
let LogService$1 = (_a = class {
  constructor() {
    const url2 = window.location.href;
    const isDev2 = url2.indexOf("useMocks=true") !== -1 || url2.indexOf("debug=true") !== -1;
    if (isDev2) {
      loglevelExports.setLevel("debug");
    } else {
      loglevelExports.setLevel("error");
    }
  }
}, __publicField(_a, "getLogger", () => {
  return log;
}), _a);
let primaryPlan = {
  database: "",
  planId: "",
  individualId: "",
  groupId: "",
  totalBal: 0,
  accountsDetailsLoaded: false
};
let pending$1 = false;
function getPrimaryGrpAcct() {
  if (pending$1 || primaryPlan.accountsDetailsLoaded) {
    return Promise.resolve(primaryPlan);
  }
  pending$1 = true;
  const getPrimaryGrpAcctResult = (response) => {
    if (response && response.data) {
      const plan = response.data;
      if (plan.indId && plan.gaId) {
        primaryPlan = {
          individualId: plan.indId,
          groupId: plan.gaId,
          planId: plan.planId,
          database: plan.database,
          totalBal: plan.totalBal,
          accountsDetailsLoaded: true
        };
      }
    }
    pending$1 = false;
    return primaryPlan;
  };
  const liveUrl = "" + ReferenceData.PRIMARY_PLAN_URL;
  const mock = window.location.origin + window.location.pathname + "data/get-primary-plan.json";
  const updatedUrl = localMocksTrue ? mock : liveUrl;
  const url2 = updatedUrl;
  return executeGet(url2, "getPrimaryGrpAcctFault").then(getPrimaryGrpAcctResult).catch((e) => {
    LogService$1.getLogger().error("Error - getPrimaryGrpAcct failed", e);
  });
}
const getAccountDetailsSvc = (groupAccount) => {
  const getAccountDetailsResult = (response) => {
    if (response) {
      response.data.groupId;
      response.data.individualId;
      return response.data;
    }
  };
  const mock = window.location.origin + window.location.pathname + "data/get-account-details.json";
  const liveUrl = "" + StringUtil$1.supplant(ReferenceData.ACCOUNT_DETAILS_URL, {
    individualId: groupAccount.individualId,
    groupId: groupAccount.groupId
  });
  const url2 = isLocalhost() && hasMocks() ? mock : liveUrl;
  return executeGet(url2, "getAccountDetailsFault").then(getAccountDetailsResult).catch((e) => {
    console.log("Error - getAccountDetails", e);
  });
};
const getAccountSummarySvc = (accountOpenInProgress) => {
  const getAccountSummaryAllResult = (response) => {
    if (response) {
      return response.data;
    } else {
      return null;
    }
  };
  const summaryUrl = accountOpenInProgress ? ReferenceData.ACCOUNT_SUMMARY_REFRESH : ReferenceData.ACCOUNT_SUMMARY_URL;
  const liveUrl = "" + summaryUrl;
  const mock = window.location.origin + window.location.pathname + "data/get-account-summary.json";
  const updatedUrl = localMocksTrue ? mock : liveUrl;
  return executeGet(updatedUrl, "getAccountSummarySvcFault").then(getAccountSummaryAllResult).catch((err) => {
    console.log("Error - getAccountSummarySvc", err);
    throw err;
  });
};
const getPrimaryPlanByIndIdSvc = (params) => {
  const getPrimaryPlanByIndIdSuccess = (response) => {
    if (response) {
      return response.data;
    } else {
      return null;
    }
  };
  const mock = window.location.origin + window.location.pathname + "data/get-primaryplan-by-indid.json";
  const liveUrl = "" + StringUtil$1.supplant(ReferenceData.PRIMARY_PLAN_BY_IND_ID, {
    individualId: params.individualId,
    dbName: params.dbName,
    accuCode: params.accuCode
  });
  const updatedUrl = localMocksTrue ? mock : liveUrl;
  return executeGet(updatedUrl, "getPrimaryPlanByIndIdFault").then(getPrimaryPlanByIndIdSuccess).catch((err) => {
    console.log("Error - getPrimaryPlanByIndIdSvc", err);
    throw err;
  });
};
const updateDefaultPlanSvc = (params) => {
  const updateDefaultPlanSuccess = (response) => {
    if (response && response.data) {
      return response.data.data;
    } else {
      return null;
    }
  };
  const url2 = StringUtil$1.supplant(ReferenceData.UPDATE_DEFAULT_PLAN, {
    individualId: params.individualId,
    dbName: params.dbName,
    accuCode: params.accuCode,
    updateDefault: params.updateDefault,
    gaId: params.gaId
  });
  const updatedUrl = "" + url2;
  return executeGet(updatedUrl, "updateDefaultPlanFault").then(updateDefaultPlanSuccess).catch((err) => {
    console.log("Error - updateDefaultPlanSvc", err);
    throw err;
  });
};
const updateEngDefaultPlan = (param) => {
  const updateEngDefaultPlanSuccess = (response) => {
    if (response) {
      return response.data;
    } else {
      return null;
    }
  };
  const url2 = getBaseApiUrl() + StringUtil$1.supplant(ReferenceData.UPDATE_DEFAULT_PLAN, {
    individualId: param.individualId,
    dbName: param.dbName,
    accuCode: param.accuCode,
    updateDefault: param.updateDefault,
    gaId: param.gaId
  });
  return executeGet(url2, "updateEngDefaultPlanFault").then(updateEngDefaultPlanSuccess).catch((err) => {
    console.log("Error - updateEngDefaultPlanSvc", err);
    throw err;
  });
};
const refreshNewAcctContext = () => {
  const refreshNewAcctContextSuccess = (response) => {
    if (response && response.data) {
      return response.data;
    } else {
      return null;
    }
  };
  const updatedUrl = "" + ReferenceData.UPDATE_NEW_ACCT_CONTEXT;
  return executeGet(updatedUrl, "refreshNewAcctContextFault").then(refreshNewAcctContextSuccess).catch((err) => {
    console.log("Error - refreshNewAcctContext", err);
    throw err;
  });
};
const RequestFactory = {
  /**
   * Logger.
   */
  logger: ExternalLogger$1.getInstance("RequestFactory"),
  /**
   * Boolean indicating if the locator should grab the endpoint for live or mock services.
   * @type {boolean}
   */
  useMocks: UrlUtil.getURLParam("useMocks") === "true",
  /**
   * Values for HTTP content type.
   */
  HTTP_METHOD: {
    GET: "get",
    POST: "post",
    PUT: "put",
    DELETE: "delete",
    PATCH: "patch"
  },
  /**
   * Values for HTTP content type.
   */
  HTTP_CONTENT_TYPE: {
    URL_ENCODED: "application/x-www-form-urlencoded",
    JSON: "application/json"
  },
  /**
   * Creates a generic request object that's typically the same for app server API endpoints.
   *
   * @param {string} url The service URL.
   * @param {object} params The request object's JSON payload.
   * @param {string} method The HTTP method or action like "GET", "POST", "DELETE", etc.
   * @param {object} contentType The request object's JSON payload.
   * @returns {object}
   */
  create: function(url2, params, method, contentType, samlToken) {
    if (RequestFactory.useMocks || url2.indexOf("data/") !== -1) {
      RequestFactory.logger.warn("create( Method = HTTP GET; forcing since using Mocks )");
      method = RequestFactory.HTTP_METHOD.GET;
    } else if (ObjectUtil.isUndefinedOrNull(method)) {
      RequestFactory.logger.info(
        "create( Method = HTTP POST; Defaulting since not provided )"
      );
      method = RequestFactory.HTTP_METHOD.POST;
    }
    if (ObjectUtil.isUndefinedOrNull(contentType)) {
      RequestFactory.logger.info("create( ContentType = {0}; Defaulting )", [
        RequestFactory.HTTP_CONTENT_TYPE.URL_ENCODED
      ]);
      contentType = RequestFactory.HTTP_CONTENT_TYPE.URL_ENCODED;
    }
    const request = {
      url: url2,
      method,
      headers: {
        "Content-Type": contentType,
        samlToken
      }
    };
    if (method === RequestFactory.HTTP_METHOD.GET) {
      request.params = ObjectUtil.isUndefinedOrNull(params) || RequestFactory.useMocks ? null : params;
    } else {
      request.data = params;
    }
    request.withCredentials = true;
    return request;
  }
};
const cache = {};
const pending = {};
const getTxnAccess = (params, desc) => {
  const cacheUrl = "" + ReferenceData.TXN_ACCESS_URL;
  const hasAccessCodes = function(txnCodes) {
    return every(txnCodes.split(","), function(code) {
      return has$1(cache, trim$1(code));
    });
  };
  const getTxnAccessResult = (resp) => {
    extend$1(
      cache,
      mapValues(resp.data, function(value) {
        return value === "true" || value === true;
      })
    );
    delete pending[params.txnCode];
    return cache;
  };
  const getTxnAccessFault = (fault) => {
    delete pending[params.txnCode];
    return handleFault(fault);
  };
  const method = RequestFactory.HTTP_METHOD.GET;
  const contentType = RequestFactory.HTTP_CONTENT_TYPE.JSON;
  if (pending[params.txnCode]) {
    return pending[params.txnCode];
  }
  const url2 = cacheUrl + params.txnCode;
  let mockFile = "";
  switch (desc) {
    case "advice-mocks":
      mockFile = "data/txnAccess-WNAMAS-WNFESS.json";
      break;
    case "integrated-mocks":
      mockFile = "data/txnAccess-integrated.json";
      break;
  }
  const mock = window.location.origin + window.location.pathname + mockFile;
  const updatedUrl = isLocalhost() && hasMocks() ? mock : url2;
  const request = RequestFactory.create(updatedUrl, {}, method, contentType);
  delete request.headers.samlToken;
  if (hasAccessCodes(params.txnCode)) {
    delete pending[params.txnCode];
    return cache;
  } else {
    return axios(request).then(getTxnAccessResult, getTxnAccessFault);
  }
};
const adviceLog = ExternalLogger$1.getInstance("adviceService");
const getFeSamlToken = (account2, pagecode, treatment, lastAlert) => {
  let tokenFunction = "getFeSamlToken";
  const getFeSamlTokenSuccess = (results) => {
    if (results) {
      return results.data;
    }
  };
  if (account2 && account2.individualId) {
    ({
      individualId: account2.individualId,
      groupId: account2.groupId
    });
    tokenFunction = "getFeSamlTokenForPlan";
  }
  const url2 = tokenFunction === "getFeSamlToken" ? ReferenceData.GET_FE_SAML_TOKEN : StringUtil$1.supplant(ReferenceData.GET_FE_SAML_TOKEN_FOR_PLAN, {
    individualId: account2.individualId,
    groupId: account2.groupId,
    pagecode,
    treatment,
    lastAlert,
    clickthrough: "true"
  });
  const baseUrl = window.location.origin;
  const updatedUrl = baseUrl + url2;
  return executeGet(updatedUrl, "getFeSamlTokenFault").then(getFeSamlTokenSuccess).catch((e) => {
    adviceLog.error("Error - getFeSamlToken failed", e);
  });
};
const filterSamlData = (samlResponse) => {
  return (samlResponse.replace ? samlResponse : "").replace(/\\n/g, "\n");
};
const getFeSamlTokenResult = async (data) => {
  var _a2;
  adviceLog.info("getFeSamlTokenResult()");
  const translations = globalThis.integratedSharedData.translations.get("header");
  const form = document.createElement("form");
  const textarea = document.createElement("textarea");
  Object.assign(form, {
    id: "SAMLFORM",
    method: "post",
    target: "_blank",
    action: data.postUrl
  });
  Object.assign(textarea, {
    id: "SAMLResponse",
    name: "SAMLResponse"
  });
  textarea.setAttribute("id", "SAMLResponse");
  textarea.setAttribute("name", "SAMLResponse");
  textarea.setAttribute("type", "hidden");
  (_a2 = document.querySelector("#SAMLFORM")) == null ? void 0 : _a2.remove();
  document.body.append(form);
  document.querySelector("#SAMLFORM").append(textarea);
  document.querySelector("#SAMLResponse").innerHTML = filterSamlData(data.samlResponse);
  let feWindow;
  let feWindowLoaded = false;
  let rejectMsgDisplayed = false;
  const feProm = new Promise(function(resolve2, reject) {
    if (!feWindowLoaded) {
      feWindow = window.open("", "feWindow");
      document.querySelector("#SAMLFORM").setAttribute("target", "feWindow");
      if (!feWindow || (feWindow == null ? void 0 : feWindow.closed) || typeof (feWindow == null ? void 0 : feWindow.closed) == "undefined") {
        alert(translations.fe.disablePopUp);
        rejectMsgDisplayed = true;
        reject(translations.fe.windowDisabled);
      } else {
        feWindow.onfocus = function() {
          document.querySelector("#SAMLFORM").submit();
          resolve2();
        };
      }
    }
  });
  return await feProm.then(
    function() {
      feWindowLoaded = true;
    },
    function(err) {
      adviceLog.error(translations.fe.errorWithProviderWindow + err);
    }
  ).catch(function(err) {
    adviceLog.error(translations.fe.errorWithProviderWindow, err);
    if (!feWindow || (feWindow == null ? void 0 : feWindow.closed) || typeof (feWindow == null ? void 0 : feWindow.closed) == "undefined") {
      rejectMsgDisplayed = true;
      alert(translations.fe.disablePopUp + err);
    }
  }).finally(function() {
    setTimeout(function() {
      if (!feWindowLoaded) {
        let errorMessage = translations.fe.disablePopUp;
        if (!feWindow || (feWindow == null ? void 0 : feWindow.closed) || typeof (feWindow == null ? void 0 : feWindow.closed) == "undefined") {
          errorMessage += translations.fe.disablePopUp;
        }
        if (!rejectMsgDisplayed) {
          alert(errorMessage);
        }
      }
    }, 6e3);
  });
};
const navigateFE = (groupAccount) => {
  adviceLog.info("navigateFE()", groupAccount);
  const getFeSamlTokenFault = function(err) {
    adviceLog.error("getFeSamlTokenFault: " + err.toString());
  };
  return getFeSamlToken(groupAccount).then(getFeSamlTokenResult).catch(getFeSamlTokenFault);
};
const checkPaeUser = (groupAccount) => {
  const getCheckPaeUserSuccess = (results) => {
    const { loginType: type, partnerSSOResponse: isEmulator } = results.data;
    globalThis.integratedEligibility = {
      ...globalThis.integratedEligibility,
      type,
      isEmulator
    };
    return results.data;
  };
  const method = "getCheckPaeUser";
  const liveUrl = "" + ReferenceData.IS_PAE_USER;
  const mock = window.location.origin + window.location.pathname + "data/is-pae-user.json";
  const updatedUrl = localMocksTrue ? mock : liveUrl;
  const paeUserParams = {
    individualId: groupAccount.individualId,
    groupId: groupAccount.groupId
  };
  return executeGet(updatedUrl, "getCheckPaeUserFault", paeUserParams).then(getCheckPaeUserSuccess).catch((e) => {
    console.log(method + "Error - getCheckPaeUser failed", e);
  });
};
const accountMenuListLogger = ExternalLogger$1.getInstance("AccountMenuListDirective");
const activate = (tierToActivate, navItem) => {
  return (dispatch, getState) => {
    const state = getState();
    const activeGroupAccount = state.account.activeGroupAccount;
    const activeMenuTier = state.navMenu.activeMenuTier;
    const isIncompleteModalExist = state.navMenu.isIncompleteModalExist;
    const method = "activate()";
    if (window.location.href.indexOf("/participant/enroll/") !== -1 && window.location.href.indexOf("confirm-changes") === -1 && !isIncompleteModalExist) {
      dispatch(setNextVal("ACCOUNT"));
      dispatch(setOpenSaveChanges(true));
    } else {
      if (tierToActivate <= activeMenuTier) {
        dispatch(inactivate(tierToActivate));
        return;
      }
      accountMenuListLogger.debug(
        "{0} - invoked.  tier=[{1}], navItem={2}, currentActiveGroupAccount={3}",
        [
          method,
          tierToActivate ? JSON.stringify(tierToActivate) : "null",
          navItem ? JSON.stringify(navItem) : "null",
          activeGroupAccount ? JSON.stringify(activeGroupAccount) : "null"
        ]
      );
      if (navItem.groupId) {
        navItem.isLoading = true;
        const currentGroupAccount = {
          individualId: navItem.individualId,
          groupId: navItem.groupId
        };
        accountMenuListLogger.debug("{0} - setting active groupAccount: {1}", [
          method,
          JSON.stringify(currentGroupAccount)
        ]);
        navItem.isLoading = false;
        dispatch(setActiveMenuTier(tierToActivate));
        dispatch(
          setActiveNavItems({
            navItem,
            tierToActivate
          })
        );
      } else {
        dispatch(setActiveMenuTier(tierToActivate));
        dispatch(
          setActiveNavItems({
            navItem,
            tierToActivate
          })
        );
      }
    }
  };
};
const navigateAway = (event, menuItem, subMenuItem) => {
  return (dispatch, getState) => {
    const state = getState();
    const activeGroupAccount = state.account.activeGroupAccount;
    const modals = state.header.menuItemModalManifest;
    const nonSubMenuGroups = state.navMenu.nonSubMenuGroups;
    const method = "navigateAway()";
    ExternalLogger$1.debug("{0} - invoked.  menuItem=[{1}], subMenuItem={2}", [
      method,
      menuItem ? JSON.stringify(menuItem) : "null",
      subMenuItem ? JSON.stringify(subMenuItem) : "null"
    ]);
    if (menuItem.groupId && menuItem.groupId !== activeGroupAccount.groupId) {
      const currentGroupAccount = {
        individualId: menuItem.individualId,
        groupId: menuItem.groupId
      };
      ExternalLogger$1.debug("{0} - setting active groupAccount: {1}", [
        method,
        JSON.stringify(currentGroupAccount)
      ]);
      activeGroupAccount.groupId = menuItem.groupId;
      dispatch(inactivate());
      dispatch(setAccountMenuActive(false));
      dispatch(setMobileMenuActiveSetting(false));
      if (subMenuItem.url && subMenuItem.url.indexOf("/#/") === 0) {
        subMenuItem.type = "nextGen";
      }
      if (subMenuItem.transactionCode === "WNACHC") ;
      else {
        dispatch(
          menuItemModalClick(
            modals,
            event,
            subMenuItem.url,
            getUrlForNavItem(subMenuItem, null, activeGroupAccount, nonSubMenuGroups),
            false,
            null,
            subMenuItem
          )
        );
      }
    } else {
      dispatch(inactivate());
      dispatch(setAccountMenuActive(false));
      dispatch(setMobileMenuActiveSetting(false));
      if (subMenuItem.url && subMenuItem.url.indexOf("/#/") === 0) {
        subMenuItem.type = "nextGen";
      }
      if (subMenuItem.transactionCode === "WNACHC") ;
      else {
        dispatch(
          menuItemModalClick(
            modals,
            event,
            subMenuItem.url,
            getUrlForNavItem(subMenuItem, null, activeGroupAccount, nonSubMenuGroups),
            false,
            null,
            subMenuItem
          )
        );
      }
    }
  };
};
const menuItemModalClick = (modals, evt, url2, fullUrl, fromIframe, iframeUrl, subMenuItem) => {
  return (dispatch, getState) => {
    const state = getState();
    const ibbotsonEnabled = state.advice.ibbotsonEnabled;
    const nextGenAdvisoryServicesEnabled = state.advice.nextGenAdvisoryServicesEnabled;
    const alreadyEnrolled = state.advice.alreadyEnrolled;
    const feEnabled = state.advice.feEnabled;
    const groupAccount = state.account.activeGroupAccount;
    const modal = find(modals, (modalObj) => {
      return !!RegExp(modalObj.urlPattern).exec(url2);
    });
    const openModal = () => {
      if (!modal.showModalOnClick) {
        modal.navigateOnInit = true;
        window.location.href = evt.target.href;
      }
      dispatch(setActiveMenuModal(modal));
    };
    if (modal) {
      evt.preventDefault();
      modal.url = fullUrl;
      if (!modal.aag) {
        openModal();
      } else if (modal.aag) {
        if (ibbotsonEnabled && nextGenAdvisoryServicesEnabled) {
          if (alreadyEnrolled) {
            const goToPAEUserError = () => {
              dispatch(
                setShowErrorModal({
                  show: true,
                  message: {
                    header: ReferenceData.errorModal.HEADING_TITLE,
                    body: ReferenceData.errorModal.UNAUTHORIZED
                  }
                })
              );
            };
            const paeCheckSuccess = (res) => {
              if (res) {
                if (res.partnerSSOResponse === false) {
                  window.location.href = "/participant/home/#/max-dashboard";
                } else {
                  console.error(
                    "pae users are prohibited from max-dashboard for enrolled ppts"
                  );
                  goToPAEUserError();
                }
              } else {
                console.error("unable to verify pae user status", res);
                goToPAEUserError();
              }
            };
            const paeCheckFault = function(res) {
              console.error("failed to perform pae user check.", res);
              goToPAEUserError();
            };
            checkPaeUser(groupAccount).then(paeCheckSuccess, paeCheckFault);
          } else if (!alreadyEnrolled) {
            const forcefullUrl = fullUrl.replace(
              "ibbotson-splash",
              "investment-options/allocations/marketing"
            );
            window.location.href = forcefullUrl;
          }
        } else if (feEnabled) {
          navigateFE(groupAccount).then(() => {
            console.log("succesfully called fe");
          });
        } else {
          openModal();
        }
      } else {
        const isNextGenFeat = subMenuItem && subMenuItem.type === "nextGen";
        const iframeElem = document.getElementById("legacyFeatureIframe");
        if (iframeElem && fromIframe === true && !isNextGenFeat) {
          iframeElem.src = iframeUrl;
          return true;
        } else {
          window.location.href = url2;
          return true;
        }
      }
    }
  };
};
var propTypes = { exports: {} };
var reactIs$1 = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function(a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense2 = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense2;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement2;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs$1.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs$1.exports = requireReactIs_production_min();
  } else {
    reactIs$1.exports = requireReactIs_development();
  }
  return reactIs$1.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$5 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
      return test2[n];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
  var from2;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from2 = Object(arguments[s]);
    for (var key in from2) {
      if (hasOwnProperty$5.call(from2, key)) {
        to[key] = from2[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from2);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from2, symbols[i])) {
          to[symbols[i]] = from2[symbols[i]];
        }
      }
    }
  }
  return to;
};
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values2, location2, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location2, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location2 + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location2 + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign2 = objectAssign;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location2, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location2, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location2, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location2, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location2, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location2, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location2, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location2, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location2, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location2, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location2, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location2 + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location2, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location2 + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator2 = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator2.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator2.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location2, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
const root$9 = {
  HEADER: "CoreHeaderEvent.",
  APPLICATION: "ApplicationEvent.",
  ENTERPRISE_CHAT: "chat."
};
const EventBusEvents = {
  HEADER: {
    LOGO: root$9.HEADER + "logo_clicked_event",
    LOGOUT: root$9.HEADER + "logout_clicked_event",
    MAIN_TOGGLE: root$9.HEADER + "main_nav_menu_toggled_event",
    GUIDANCE: root$9.HEADER + "guidance_link_clicked_event",
    BENEFICIARY: root$9.HEADER + "add_a_beneficiary_link_clicked_event",
    MANAGED: root$9.HEADER + "jp_managed_link_clicked_event",
    PROFILE: root$9.HEADER + "profile_link_clicked_event",
    ACCOUNT: root$9.HEADER + "account_dropdown_clicked_event",
    ACCOUNT_DROPDOWN_MENU: root$9.HEADER + "account_dropdown_menu_clicked_event",
    SHOW_CHANGE_LANGUAGE_MODAL: root$9.HEADER + "show_change_language_modal_clicked_event",
    CHANGE_LANGUAGE: root$9.HEADER + "change_language_clicked_event",
    WELLNESS: root$9.HEADER + "wellness_clicked_event",
    NAV_DD_CLICK: root$9.HEADER + "main_header_dropdown_clicked_event",
    ACCOUNT_SWITCH: root$9.HEADER + "account_switch_clicked_event",
    ENROLL_IN_MY_TOTAL_RETIREMENT: root$9.HEADER + "topnav_maenroll",
    SEARCHBOX_ICON_CLICK: root$9.HEADER + "search_icon_clicked",
    USER_ICON_DROPDOWN_CLICKED: root$9.HEADER + "user_icon_dropdown_clicked_event",
    USER_ICON_DROPDOWN_MENU_ITEM_CLICKED: root$9.HEADER + "user_icon_dropdown_menu_item_clicked_event"
  },
  APPLICATION: {
    INIT_COMPLETE: root$9.APPLICATION + "init_complete_event"
  },
  ENTERPRISE_CHAT: {
    ENTERPRISE_CHAT_EXECUTE: root$9.ENTERPRISE_CHAT + "openButton",
    ENTERPRISE_CHAT_CLOSE: root$9.ENTERPRISE_CHAT + "closeButton"
  },
  ACCOUNT_OPEN_MODAL: {
    STAY_CLICK: "AO_exit_popup_modal_Stay.clicked",
    LEAVE_CLICK: "AO_exit_popup_modal_Leave.clicked",
    X_CLICK: "AO_exit_popup_modal_X.clicked",
    BACKDROP_CLICK: "AO_exit_popup_modal_outside.clicked"
  }
};
const NavItem = ({ navItem, isActivated: isActivated2, account: account2 }) => {
  const dispatch = useDispatch();
  const activeNavItems = useSelector((state) => state.navMenu.activeNavItems);
  const navItemLegacyClass = navItem.isLegacy ? "legacy" : "";
  const navItemLinkTitle = navItem.helpText;
  const navItemActiveClass = isActivated2(
    navItem,
    account2.accountURL,
    "headerClick",
    activeNavItems
  ) ? "active" : "";
  const nonSubMenuGroups = useSelector((state) => state.navMenu.nonSubMenuGroups);
  const handleClick2 = (e, item, subItem) => {
    const url2 = getUrlForNavItem(subItem, null, account2, nonSubMenuGroups);
    const payload = accountDropdownMenuClick(subItem, account2, nonSubMenuGroups, false);
    dispatch(navigateAway(e, item, subItem));
    dispatch(dispatchEventBus(EventBusEvents.HEADER.ACCOUNT_DROPDOWN_MENU, payload));
    if (url2.indexOf("fe-splash") === -1 && url2.indexOf("ibbotson-splash") === -1) {
      window.location.href = url2;
    }
  };
  const renderSubItem = (subMenu) => {
    return subMenu.map((navSubItem, id2) => {
      const subItemLegacyClass = navSubItem.isLegacy ? "legacy" : "";
      const linkTitle = navSubItem.helpText;
      return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "nav-item", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          className: `menu-item-link ${subItemLegacyClass}`,
          id: id2,
          title: linkTitle,
          onClick: (e) => handleClick2(e, navItem, navSubItem),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: navSubItem.displayText })
        }
      ) }, `nav-sub-item${navSubItem.id}`);
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "nav-item", children: [
    !navItem.subMenu ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        className: `menu-item-link ${navItemLegacyClass}`,
        id: navItem.id,
        onClick: (e) => handleClick2(e, account2, navItem),
        title: navItemLinkTitle,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: navItem.displayText })
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: "menu-item-link", onClick: (e) => dispatch(activate(3, navItem)), children: navItem.displayText }),
    navItem.subMenu && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `navbar-section ${navItemActiveClass}`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "navbar-section-header", children: navItem.displayText }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "list-unstyled menu-section-nav", children: renderSubItem(navItem.subMenu) })
    ] })
  ] });
};
const Account = ({ account: account2 }) => {
  const dispatch = useDispatch();
  const menuNavigationObj = useSelector((state) => state.navMenu.menuNavigation);
  const activeNavItems = useSelector((state) => state.navMenu.activeNavItems);
  const menuItemClass = account2.isLoading ? "menu-item-loading" : "";
  const itemActiveClass = isActivated(account2, account2.accountURL, "accountClick", activeNavItems) ? "active" : "";
  const renderNavItems = (items) => {
    const navList = items[account2.groupId];
    return navList && navList.map((item) => {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        NavItem,
        {
          navItem: item,
          account: account2,
          isActivated
        },
        `nav-item${item.id}`
      );
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "nav-item", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        className: `menu-item-link ${menuItemClass}`,
        onClick: () => dispatch(activate(2, account2)),
        children: account2.name
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `navbar-section ${itemActiveClass}`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "navbar-section-header", children: account2.name }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "list-unstyled menu-section-nav", children: renderNavItems(menuNavigationObj) })
    ] })
  ] });
};
Account.propTypes = {
  account: PropTypes.object.isRequired
};
const AccountMenuList = () => {
  const allAccounts = useSelector((state) => state.account.accountSummaryList);
  const isActive = useSelector((state) => state.navMenu.accountMenuActive);
  const dispatch = useDispatch();
  const activeClass = isActive ? "active" : "";
  useEffect(() => {
    if (isActive) {
      dispatch(activate(1, {}));
    }
  }, [dispatch, isActive]);
  const renderAccounts = (accounts) => {
    if (accounts && accounts.length > 0) {
      return accounts.map((account2) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Account, { account: account2 }, `account-item${account2.name}`);
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `account-menu-list navbar-section ${activeClass}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "navbar-section-header", children: "Accounts" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "list-unstyled menu-section-nav", children: renderAccounts(allAccounts) })
  ] });
};
const getSiteContactInfo = (groupId) => {
  const getSiteContactInfoSuccess = (response) => {
    if (response && response.data) {
      return response.data;
    } else {
      return null;
    }
  };
  const url2 = StringUtil$1.supplant(ReferenceData.GET_SITE_CONTACT_INFO, {
    gaId: groupId
  });
  const liveUrl = "" + url2;
  const mock = window.location.origin + window.location.pathname + "data/get-site-contact-info.json";
  const updatedUrl = localMocksTrue ? mock : liveUrl;
  return executeGet(updatedUrl, "getSiteContactInfoFault").then(getSiteContactInfoSuccess).catch((err) => {
    console.log("Error - getSiteContactInfo", err);
    throw err;
  });
};
const getSiteContactInfoPreLogin = ({ accu: accu2, accuSpecificPrimDb, portalType }) => {
  const getSiteContactInfoPreloginSuccess = (response) => {
    if (response && response.data) {
      return response.data;
    } else {
      return null;
    }
  };
  const url2 = StringUtil$1.supplant(ReferenceData.GET_SITE_CONTACT_INFO_PRELOGIN, {
    accu: accu2,
    accuSpecificPrimDb,
    portalType
  });
  const updatedUrl = "" + url2;
  return executeGet(updatedUrl, "getSiteContactInfoPreLoginFault").then(getSiteContactInfoPreloginSuccess).catch((err) => {
    console.log("Error - getSiteContactInfoPreLogin", err);
    throw err;
  });
};
const getContactInfoPrelogin = (accuData) => (dispatch) => {
  getSiteContactInfoPreLogin(accuData).then((data) => {
    dispatch(setSiteContactInfo(data));
  });
};
const { isUndefinedOrNull: isUndefinedOrNull$g } = ObjectUtil;
const isEmulatorUser = () => {
  if (globalThis.integratedEligibility && !isUndefinedOrNull$g(globalThis.integratedEligibility.isEmulator)) {
    return globalThis.integratedEligibility.isEmulator;
  }
  return false;
};
const objectToString$3 = Object.prototype.toString;
function isError(wat) {
  switch (objectToString$3.call(wat)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
function isBuiltin(wat, className) {
  return objectToString$3.call(wat) === `[object ${className}]`;
}
function isErrorEvent(wat) {
  return isBuiltin(wat, "ErrorEvent");
}
function isDOMError(wat) {
  return isBuiltin(wat, "DOMError");
}
function isDOMException(wat) {
  return isBuiltin(wat, "DOMException");
}
function isString(wat) {
  return isBuiltin(wat, "String");
}
function isParameterizedString(wat) {
  return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function isPrimitive(wat) {
  return wat === null || isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function isPlainObject$1(wat) {
  return isBuiltin(wat, "Object");
}
function isEvent(wat) {
  return typeof Event !== "undefined" && isInstanceOf(wat, Event);
}
function isElement(wat) {
  return typeof Element !== "undefined" && isInstanceOf(wat, Element);
}
function isRegExp(wat) {
  return isBuiltin(wat, "RegExp");
}
function isThenable(wat) {
  return Boolean(wat && wat.then && typeof wat.then === "function");
}
function isSyntheticEvent(wat) {
  return isPlainObject$1(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function isNaN$1(wat) {
  return typeof wat === "number" && wat !== wat;
}
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e2) {
    return false;
  }
}
function isVueViewModel(wat) {
  return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}
function truncate(str, max = 0) {
  if (typeof str !== "string" || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return "";
  }
  const output = [];
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      if (isVueViewModel(value)) {
        output.push("[VueViewModel]");
      } else {
        output.push(String(value));
      }
    } catch (e) {
      output.push("[value cannot be serialized]");
    }
  }
  return output.join(delimiter);
}
function isMatchingPattern(value, pattern, requireExactStringMatch = false) {
  if (!isString(value)) {
    return false;
  }
  if (isRegExp(pattern)) {
    return pattern.test(value);
  }
  if (isString(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }
  return false;
}
function stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
  return patterns.some((pattern) => isMatchingPattern(testString, pattern, requireExactStringMatch));
}
function applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
  if (!event.exception || !event.exception.values || !hint || !isInstanceOf(hint.originalException, Error)) {
    return;
  }
  const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
  if (originalException) {
    event.exception.values = truncateAggregateExceptions(
      aggregateExceptionsFromError(
        exceptionFromErrorImplementation,
        parser,
        limit,
        hint.originalException,
        key,
        event.exception.values,
        originalException,
        0
      ),
      maxValueLimit
    );
  }
}
function aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
  if (prevExceptions.length >= limit + 1) {
    return prevExceptions;
  }
  let newExceptions = [...prevExceptions];
  if (isInstanceOf(error[key], Error)) {
    applyExceptionGroupFieldsForParentException(exception, exceptionId);
    const newException = exceptionFromErrorImplementation(parser, error[key]);
    const newExceptionId = newExceptions.length;
    applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
    newExceptions = aggregateExceptionsFromError(
      exceptionFromErrorImplementation,
      parser,
      limit,
      error[key],
      key,
      [newException, ...newExceptions],
      newException,
      newExceptionId
    );
  }
  if (Array.isArray(error.errors)) {
    error.errors.forEach((childError, i) => {
      if (isInstanceOf(childError, Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, childError);
        const newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(
          exceptionFromErrorImplementation,
          parser,
          limit,
          childError,
          key,
          [newException, ...newExceptions],
          newException,
          newExceptionId
        );
      }
    });
  }
  return newExceptions;
}
function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
  exception.mechanism = exception.mechanism || { type: "generic", handled: true };
  exception.mechanism = {
    ...exception.mechanism,
    ...exception.type === "AggregateError" && { is_exception_group: true },
    exception_id: exceptionId
  };
}
function applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
  exception.mechanism = exception.mechanism || { type: "generic", handled: true };
  exception.mechanism = {
    ...exception.mechanism,
    type: "chained",
    source,
    exception_id: exceptionId,
    parent_id: parentId
  };
}
function truncateAggregateExceptions(exceptions, maxValueLength) {
  return exceptions.map((exception) => {
    if (exception.value) {
      exception.value = truncate(exception.value, maxValueLength);
    }
    return exception;
  });
}
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : void 0;
}
const GLOBAL_OBJ = typeof globalThis == "object" && isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && isGlobalObj(window) || typeof self == "object" && isGlobalObj(self) || typeof global == "object" && isGlobalObj(global) || /* @__PURE__ */ function() {
  return this;
}() || {};
function getGlobalObject() {
  return GLOBAL_OBJ;
}
function getGlobalSingleton(name2, creator, obj) {
  const gbl = obj || GLOBAL_OBJ;
  const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
  const singleton = __SENTRY__[name2] || (__SENTRY__[name2] = creator());
  return singleton;
}
const WINDOW$6 = getGlobalObject();
const DEFAULT_MAX_STRING_LENGTH = 80;
function htmlTreeAsString(elem, options = {}) {
  if (!elem) {
    return "<unknown>";
  }
  try {
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = " > ";
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) {
        break;
      }
      out.push(nextStr);
      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }
    return out.reverse().join(separator);
  } catch (_oO) {
    return "<unknown>";
  }
}
function _htmlElementAsString(el2, keyAttrs) {
  const elem = el2;
  const out = [];
  let className;
  let classes;
  let key;
  let attr2;
  let i;
  if (!elem || !elem.tagName) {
    return "";
  }
  if (WINDOW$6.HTMLElement) {
    if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) {
      return elem.dataset["sentryComponent"];
    }
  }
  out.push(elem.tagName.toLowerCase());
  const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr) => elem.getAttribute(keyAttr)).map((keyAttr) => [keyAttr, elem.getAttribute(keyAttr)]) : null;
  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach((keyAttrPair) => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }
    className = elem.className;
    if (className && isString(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ["aria-label", "type", "name", "title", "alt"];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr2 = elem.getAttribute(key);
    if (attr2) {
      out.push(`[${key}="${attr2}"]`);
    }
  }
  return out.join("");
}
function getLocationHref() {
  try {
    return WINDOW$6.document.location.href;
  } catch (oO) {
    return "";
  }
}
function getComponentName(elem) {
  if (!WINDOW$6.HTMLElement) {
    return null;
  }
  let currentElem = elem;
  const MAX_TRAVERSE_HEIGHT = 5;
  for (let i = 0; i < MAX_TRAVERSE_HEIGHT; i++) {
    if (!currentElem) {
      return null;
    }
    if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) {
      return currentElem.dataset["sentryComponent"];
    }
    currentElem = currentElem.parentNode;
  }
  return null;
}
const DEBUG_BUILD$3 = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const PREFIX = "Sentry Logger ";
const CONSOLE_LEVELS = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
];
const originalConsoleMethods = {};
function consoleSandbox(callback) {
  if (!("console" in GLOBAL_OBJ)) {
    return callback();
  }
  const console2 = GLOBAL_OBJ.console;
  const wrappedFuncs = {};
  const wrappedLevels = Object.keys(originalConsoleMethods);
  wrappedLevels.forEach((level) => {
    const originalConsoleMethod = originalConsoleMethods[level];
    wrappedFuncs[level] = console2[level];
    console2[level] = originalConsoleMethod;
  });
  try {
    return callback();
  } finally {
    wrappedLevels.forEach((level) => {
      console2[level] = wrappedFuncs[level];
    });
  }
}
function makeLogger() {
  let enabled = false;
  const logger2 = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
    isEnabled: () => enabled
  };
  if (DEBUG_BUILD$3) {
    CONSOLE_LEVELS.forEach((name2) => {
      logger2[name2] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            GLOBAL_OBJ.console[name2](`${PREFIX}[${name2}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach((name2) => {
      logger2[name2] = () => void 0;
    });
  }
  return logger2;
}
const logger$2 = makeLogger();
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
  return protocol === "http" || protocol === "https";
}
function dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);
  if (!match) {
    consoleSandbox(() => {
      console.error(`Invalid Sentry Dsn: ${str}`);
    });
    return void 0;
  }
  const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
  let path = "";
  let projectId = lastPath;
  const split = projectId.split("/");
  if (split.length > 1) {
    path = split.slice(0, -1).join("/");
    projectId = split.pop();
  }
  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }
  return dsnFromComponents({ host, pass, path, projectId, port, protocol, publicKey });
}
function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || "",
    pass: components.pass || "",
    host: components.host,
    port: components.port || "",
    path: components.path || "",
    projectId: components.projectId
  };
}
function validateDsn(dsn) {
  if (!DEBUG_BUILD$3) {
    return true;
  }
  const { port, projectId, protocol } = dsn;
  const requiredComponents = ["protocol", "publicKey", "host", "projectId"];
  const hasMissingRequiredComponent = requiredComponents.find((component) => {
    if (!dsn[component]) {
      logger$2.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });
  if (hasMissingRequiredComponent) {
    return false;
  }
  if (!projectId.match(/^\d+$/)) {
    logger$2.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }
  if (!isValidProtocol(protocol)) {
    logger$2.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }
  if (port && isNaN(parseInt(port, 10))) {
    logger$2.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }
  return true;
}
function makeDsn(from2) {
  const components = typeof from2 === "string" ? dsnFromString(from2) : dsnFromComponents(from2);
  if (!components || !validateDsn(components)) {
    return void 0;
  }
  return components;
}
function fill(source, name2, replacementFactory) {
  if (!(name2 in source)) {
    return;
  }
  const original = source[name2];
  const wrapped = replacementFactory(original);
  if (typeof wrapped === "function") {
    markFunctionWrapped(wrapped, original);
  }
  source[name2] = wrapped;
}
function addNonEnumerableProperty(obj, name2, value) {
  try {
    Object.defineProperty(obj, name2, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value,
      writable: true,
      configurable: true
    });
  } catch (o_O) {
    DEBUG_BUILD$3 && logger$2.log(`Failed to add non-enumerable property "${name2}" to object`, obj);
  }
}
function markFunctionWrapped(wrapped, original) {
  try {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, "__sentry_original__", original);
  } catch (o_O) {
  }
}
function getOriginalFunction(func) {
  return func.__sentry_original__;
}
function convertToPlainObject(value) {
  if (isError(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value)
    };
  } else if (isEvent(value)) {
    const newObj = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value)
    };
    if (typeof CustomEvent !== "undefined" && isInstanceOf(value, CustomEvent)) {
      newObj.detail = value.detail;
    }
    return newObj;
  } else {
    return value;
  }
}
function serializeEventTarget(target) {
  try {
    return isElement(target) ? htmlTreeAsString(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return "<unknown>";
  }
}
function getOwnProperties(obj) {
  if (typeof obj === "object" && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = obj[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();
  if (!keys.length) {
    return "[object has no keys]";
  }
  if (keys[0].length >= maxLength) {
    return truncate(keys[0], maxLength);
  }
  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(", ");
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return truncate(serialized, maxLength);
  }
  return "";
}
function dropUndefinedKeys(inputValue) {
  const memoizationMap = /* @__PURE__ */ new Map();
  return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
  if (isPojo(inputValue)) {
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) {
      return memoVal;
    }
    const returnValue = {};
    memoizationMap.set(inputValue, returnValue);
    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== "undefined") {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }
    return returnValue;
  }
  if (Array.isArray(inputValue)) {
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) {
      return memoVal;
    }
    const returnValue = [];
    memoizationMap.set(inputValue, returnValue);
    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });
    return returnValue;
  }
  return inputValue;
}
function isPojo(input) {
  if (!isPlainObject$1(input)) {
    return false;
  }
  try {
    const name2 = Object.getPrototypeOf(input).constructor.name;
    return !name2 || name2 === "Object";
  } catch (e) {
    return true;
  }
}
const defaultFunctionName = "<anonymous>";
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== "function") {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    return defaultFunctionName;
  }
}
const handlers = {};
const instrumented = {};
function addHandler(type, handler) {
  handlers[type] = handlers[type] || [];
  handlers[type].push(handler);
}
function maybeInstrument(type, instrumentFn) {
  if (!instrumented[type]) {
    instrumentFn();
    instrumented[type] = true;
  }
}
function triggerHandlers(type, data) {
  const typeHandlers = type && handlers[type];
  if (!typeHandlers) {
    return;
  }
  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      DEBUG_BUILD$3 && logger$2.error(
        `Error while triggering instrumentation handler.
Type: ${type}
Name: ${getFunctionName(handler)}
Error:`,
        e
      );
    }
  }
}
function addConsoleInstrumentationHandler(handler) {
  const type = "console";
  addHandler(type, handler);
  maybeInstrument(type, instrumentConsole);
}
function instrumentConsole() {
  if (!("console" in GLOBAL_OBJ)) {
    return;
  }
  CONSOLE_LEVELS.forEach(function(level) {
    if (!(level in GLOBAL_OBJ.console)) {
      return;
    }
    fill(GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
      originalConsoleMethods[level] = originalConsoleMethod;
      return function(...args) {
        const handlerData = { args, level };
        triggerHandlers("console", handlerData);
        const log2 = originalConsoleMethods[level];
        log2 && log2.apply(GLOBAL_OBJ.console, args);
      };
    });
  });
}
function uuid4() {
  const gbl = GLOBAL_OBJ;
  const crypto2 = gbl.crypto || gbl.msCrypto;
  let getRandomByte = () => Math.random() * 16;
  try {
    if (crypto2 && crypto2.randomUUID) {
      return crypto2.randomUUID().replace(/-/g, "");
    }
    if (crypto2 && crypto2.getRandomValues) {
      getRandomByte = () => {
        const typedArray = new Uint8Array(1);
        crypto2.getRandomValues(typedArray);
        return typedArray[0];
      };
    }
  } catch (_2) {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (c) => (
      // eslint-disable-next-line no-bitwise
      (c ^ (getRandomByte() & 15) >> c / 4).toString(16)
    )
  );
}
function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : void 0;
}
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }
  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || "<unknown>";
  }
  return eventId || "<unknown>";
}
function addExceptionTypeValue(event, value, type) {
  const exception = event.exception = event.exception || {};
  const values2 = exception.values = exception.values || [];
  const firstException = values2[0] = values2[0] || {};
  if (!firstException.value) {
    firstException.value = value || "";
  }
  if (!firstException.type) {
    firstException.type = "Error";
  }
}
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }
  const defaultMechanism = { type: "generic", handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };
  if (newMechanism && "data" in newMechanism) {
    const mergedData = { ...currentMechanism && currentMechanism.data, ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}
const WINDOW$5 = GLOBAL_OBJ;
const DEBOUNCE_DURATION = 1e3;
let debounceTimerID;
let lastCapturedEventType;
let lastCapturedEventTargetId;
function addClickKeypressInstrumentationHandler(handler) {
  const type = "dom";
  addHandler(type, handler);
  maybeInstrument(type, instrumentDOM);
}
function instrumentDOM() {
  if (!WINDOW$5.document) {
    return;
  }
  const triggerDOMHandler = triggerHandlers.bind(null, "dom");
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  WINDOW$5.document.addEventListener("click", globalDOMEventHandler, false);
  WINDOW$5.document.addEventListener("keypress", globalDOMEventHandler, false);
  ["EventTarget", "Node"].forEach((target) => {
    const proto = WINDOW$5[target] && WINDOW$5[target].prototype;
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) {
      return;
    }
    fill(proto, "addEventListener", function(originalAddEventListener) {
      return function(type, listener, options) {
        if (type === "click" || type == "keypress") {
          try {
            const el2 = this;
            const handlers2 = el2.__sentry_instrumentation_handlers__ = el2.__sentry_instrumentation_handlers__ || {};
            const handlerForType = handlers2[type] = handlers2[type] || { refCount: 0 };
            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }
            handlerForType.refCount++;
          } catch (e) {
          }
        }
        return originalAddEventListener.call(this, type, listener, options);
      };
    });
    fill(
      proto,
      "removeEventListener",
      function(originalRemoveEventListener) {
        return function(type, listener, options) {
          if (type === "click" || type == "keypress") {
            try {
              const el2 = this;
              const handlers2 = el2.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers2[type];
              if (handlerForType) {
                handlerForType.refCount--;
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = void 0;
                  delete handlers2[type];
                }
                if (Object.keys(handlers2).length === 0) {
                  delete el2.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
            }
          }
          return originalRemoveEventListener.call(this, type, listener, options);
        };
      }
    );
  });
}
function isSimilarToLastCapturedEvent(event) {
  if (event.type !== lastCapturedEventType) {
    return false;
  }
  try {
    if (!event.target || event.target._sentryId !== lastCapturedEventTargetId) {
      return false;
    }
  } catch (e) {
  }
  return true;
}
function shouldSkipDOMEvent(eventType, target) {
  if (eventType !== "keypress") {
    return false;
  }
  if (!target || !target.tagName) {
    return true;
  }
  if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
    return false;
  }
  return true;
}
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    if (!event || event["_sentryCaptured"]) {
      return;
    }
    const target = getEventTarget(event);
    if (shouldSkipDOMEvent(event.type, target)) {
      return;
    }
    addNonEnumerableProperty(event, "_sentryCaptured", true);
    if (target && !target._sentryId) {
      addNonEnumerableProperty(target, "_sentryId", uuid4());
    }
    const name2 = event.type === "keypress" ? "input" : event.type;
    if (!isSimilarToLastCapturedEvent(event)) {
      const handlerData = { event, name: name2, global: globalListener };
      handler(handlerData);
      lastCapturedEventType = event.type;
      lastCapturedEventTargetId = target ? target._sentryId : void 0;
    }
    clearTimeout(debounceTimerID);
    debounceTimerID = WINDOW$5.setTimeout(() => {
      lastCapturedEventTargetId = void 0;
      lastCapturedEventType = void 0;
    }, DEBOUNCE_DURATION);
  };
}
function getEventTarget(event) {
  try {
    return event.target;
  } catch (e) {
    return null;
  }
}
const WINDOW$4 = getGlobalObject();
function supportsFetch() {
  if (!("fetch" in WINDOW$4)) {
    return false;
  }
  try {
    new Headers();
    new Request("http://www.example.com");
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function supportsNativeFetch() {
  if (typeof EdgeRuntime === "string") {
    return true;
  }
  if (!supportsFetch()) {
    return false;
  }
  if (isNativeFetch(WINDOW$4.fetch)) {
    return true;
  }
  let result2 = false;
  const doc = WINDOW$4.document;
  if (doc && typeof doc.createElement === "function") {
    try {
      const sandbox = doc.createElement("iframe");
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        result2 = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      DEBUG_BUILD$3 && logger$2.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
  }
  return result2;
}
function addFetchInstrumentationHandler(handler) {
  const type = "fetch";
  addHandler(type, handler);
  maybeInstrument(type, instrumentFetch);
}
function instrumentFetch() {
  if (!supportsNativeFetch()) {
    return;
  }
  fill(GLOBAL_OBJ, "fetch", function(originalFetch) {
    return function(...args) {
      const { method, url: url2 } = parseFetchArgs(args);
      const handlerData = {
        args,
        fetchData: {
          method,
          url: url2
        },
        startTimestamp: Date.now()
      };
      triggerHandlers("fetch", {
        ...handlerData
      });
      return originalFetch.apply(GLOBAL_OBJ, args).then(
        (response) => {
          const finishedHandlerData = {
            ...handlerData,
            endTimestamp: Date.now(),
            response
          };
          triggerHandlers("fetch", finishedHandlerData);
          return response;
        },
        (error) => {
          const erroredHandlerData = {
            ...handlerData,
            endTimestamp: Date.now(),
            error
          };
          triggerHandlers("fetch", erroredHandlerData);
          throw error;
        }
      );
    };
  });
}
function hasProp(obj, prop) {
  return !!obj && typeof obj === "object" && !!obj[prop];
}
function getUrlFromResource(resource) {
  if (typeof resource === "string") {
    return resource;
  }
  if (!resource) {
    return "";
  }
  if (hasProp(resource, "url")) {
    return resource.url;
  }
  if (resource.toString) {
    return resource.toString();
  }
  return "";
}
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return { method: "GET", url: "" };
  }
  if (fetchArgs.length === 2) {
    const [url2, options] = fetchArgs;
    return {
      url: getUrlFromResource(url2),
      method: hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
    };
  }
  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg),
    method: hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
  };
}
let _oldOnErrorHandler = null;
function addGlobalErrorInstrumentationHandler(handler) {
  const type = "error";
  addHandler(type, handler);
  maybeInstrument(type, instrumentError);
}
function instrumentError() {
  _oldOnErrorHandler = GLOBAL_OBJ.onerror;
  GLOBAL_OBJ.onerror = function(msg, url2, line, column, error) {
    const handlerData = {
      column,
      error,
      line,
      msg,
      url: url2
    };
    triggerHandlers("error", handlerData);
    if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) {
      return _oldOnErrorHandler.apply(this, arguments);
    }
    return false;
  };
  GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
let _oldOnUnhandledRejectionHandler = null;
function addGlobalUnhandledRejectionInstrumentationHandler(handler) {
  const type = "unhandledrejection";
  addHandler(type, handler);
  maybeInstrument(type, instrumentUnhandledRejection);
}
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = GLOBAL_OBJ.onunhandledrejection;
  GLOBAL_OBJ.onunhandledrejection = function(e) {
    const handlerData = e;
    triggerHandlers("unhandledrejection", handlerData);
    if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) {
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }
    return true;
  };
  GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
const WINDOW$3 = getGlobalObject();
function supportsHistory() {
  const chromeVar = WINDOW$3.chrome;
  const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
  const hasHistoryApi = "history" in WINDOW$3 && !!WINDOW$3.history.pushState && !!WINDOW$3.history.replaceState;
  return !isChromePackagedApp && hasHistoryApi;
}
const WINDOW$2 = GLOBAL_OBJ;
let lastHref;
function addHistoryInstrumentationHandler(handler) {
  const type = "history";
  addHandler(type, handler);
  maybeInstrument(type, instrumentHistory);
}
function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }
  const oldOnPopState = WINDOW$2.onpopstate;
  WINDOW$2.onpopstate = function(...args) {
    const to = WINDOW$2.location.href;
    const from2 = lastHref;
    lastHref = to;
    const handlerData = { from: from2, to };
    triggerHandlers("history", handlerData);
    if (oldOnPopState) {
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
      }
    }
  };
  function historyReplacementFunction(originalHistoryFunction) {
    return function(...args) {
      const url2 = args.length > 2 ? args[2] : void 0;
      if (url2) {
        const from2 = lastHref;
        const to = String(url2);
        lastHref = to;
        const handlerData = { from: from2, to };
        triggerHandlers("history", handlerData);
      }
      return originalHistoryFunction.apply(this, args);
    };
  }
  fill(WINDOW$2.history, "pushState", historyReplacementFunction);
  fill(WINDOW$2.history, "replaceState", historyReplacementFunction);
}
const WINDOW$1 = GLOBAL_OBJ;
const SENTRY_XHR_DATA_KEY = "__sentry_xhr_v3__";
function addXhrInstrumentationHandler(handler) {
  const type = "xhr";
  addHandler(type, handler);
  maybeInstrument(type, instrumentXHR);
}
function instrumentXHR() {
  if (!WINDOW$1.XMLHttpRequest) {
    return;
  }
  const xhrproto = XMLHttpRequest.prototype;
  fill(xhrproto, "open", function(originalOpen) {
    return function(...args) {
      const startTimestamp = Date.now();
      const method = isString(args[0]) ? args[0].toUpperCase() : void 0;
      const url2 = parseUrl$1(args[1]);
      if (!method || !url2) {
        return originalOpen.apply(this, args);
      }
      this[SENTRY_XHR_DATA_KEY] = {
        method,
        url: url2,
        request_headers: {}
      };
      if (method === "POST" && url2.match(/sentry_key/)) {
        this.__sentry_own_request__ = true;
      }
      const onreadystatechangeHandler = () => {
        const xhrInfo = this[SENTRY_XHR_DATA_KEY];
        if (!xhrInfo) {
          return;
        }
        if (this.readyState === 4) {
          try {
            xhrInfo.status_code = this.status;
          } catch (e) {
          }
          const handlerData = {
            args: [method, url2],
            endTimestamp: Date.now(),
            startTimestamp,
            xhr: this
          };
          triggerHandlers("xhr", handlerData);
        }
      };
      if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") {
        fill(this, "onreadystatechange", function(original) {
          return function(...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(this, readyStateArgs);
          };
        });
      } else {
        this.addEventListener("readystatechange", onreadystatechangeHandler);
      }
      fill(this, "setRequestHeader", function(original) {
        return function(...setRequestHeaderArgs) {
          const [header2, value] = setRequestHeaderArgs;
          const xhrInfo = this[SENTRY_XHR_DATA_KEY];
          if (xhrInfo && isString(header2) && isString(value)) {
            xhrInfo.request_headers[header2.toLowerCase()] = value;
          }
          return original.apply(this, setRequestHeaderArgs);
        };
      });
      return originalOpen.apply(this, args);
    };
  });
  fill(xhrproto, "send", function(originalSend) {
    return function(...args) {
      const sentryXhrData = this[SENTRY_XHR_DATA_KEY];
      if (!sentryXhrData) {
        return originalSend.apply(this, args);
      }
      if (args[0] !== void 0) {
        sentryXhrData.body = args[0];
      }
      const handlerData = {
        args: [sentryXhrData.method, sentryXhrData.url],
        startTimestamp: Date.now(),
        xhr: this
      };
      triggerHandlers("xhr", handlerData);
      return originalSend.apply(this, args);
    };
  });
}
function parseUrl$1(url2) {
  if (isString(url2)) {
    return url2;
  }
  try {
    return url2.toString();
  } catch (e2) {
  }
  return void 0;
}
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === "function";
  const inner = hasWeakSet ? /* @__PURE__ */ new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }
  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}
function normalize(input, depth = 100, maxProperties = Infinity) {
  try {
    return visit("", input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}
function normalizeToSize(object, depth = 3, maxSize = 100 * 1024) {
  const normalized = normalize(object, depth);
  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }
  return normalized;
}
function visit(key, value, depth = Infinity, maxProperties = Infinity, memo2 = memoBuilder()) {
  const [memoize, unmemoize] = memo2;
  if (value == null || // this matches null and undefined -> eqeq not eqeqeq
  ["number", "boolean", "string"].includes(typeof value) && !isNaN$1(value)) {
    return value;
  }
  const stringified = stringifyValue(key, value);
  if (!stringified.startsWith("[object ")) {
    return stringified;
  }
  if (value["__sentry_skip_normalization__"]) {
    return value;
  }
  const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
  if (remainingDepth === 0) {
    return stringified.replace("object ", "");
  }
  if (memoize(value)) {
    return "[Circular ~]";
  }
  const valueWithToJSON = value;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      return visit("", jsonValue, remainingDepth - 1, maxProperties, memo2);
    } catch (err) {
    }
  }
  const normalized = Array.isArray(value) ? [] : {};
  let numAdded = 0;
  const visitable = convertToPlainObject(value);
  for (const visitKey in visitable) {
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }
    if (numAdded >= maxProperties) {
      normalized[visitKey] = "[MaxProperties ~]";
      break;
    }
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo2);
    numAdded++;
  }
  unmemoize(value);
  return normalized;
}
function stringifyValue(key, value) {
  try {
    if (key === "domain" && value && typeof value === "object" && value._events) {
      return "[Domain]";
    }
    if (key === "domainEmitter") {
      return "[DomainEmitter]";
    }
    if (typeof global !== "undefined" && value === global) {
      return "[Global]";
    }
    if (typeof window !== "undefined" && value === window) {
      return "[Window]";
    }
    if (typeof document !== "undefined" && value === document) {
      return "[Document]";
    }
    if (isVueViewModel(value)) {
      return "[VueViewModel]";
    }
    if (isSyntheticEvent(value)) {
      return "[SyntheticEvent]";
    }
    if (typeof value === "number" && value !== value) {
      return "[NaN]";
    }
    if (typeof value === "function") {
      return `[Function: ${getFunctionName(value)}]`;
    }
    if (typeof value === "symbol") {
      return `[${String(value)}]`;
    }
    if (typeof value === "bigint") {
      return `[BigInt: ${String(value)}]`;
    }
    const objName = getConstructorName(value);
    if (/^HTML(\w*)Element$/.test(objName)) {
      return `[HTMLElement: ${objName}]`;
    }
    return `[object ${objName}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}
function getConstructorName(value) {
  const prototype2 = Object.getPrototypeOf(value);
  return prototype2 ? prototype2.constructor.name : "null prototype";
}
function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}
var States;
(function(States2) {
  const PENDING = 0;
  States2[States2["PENDING"] = PENDING] = "PENDING";
  const RESOLVED = 1;
  States2[States2["RESOLVED"] = RESOLVED] = "RESOLVED";
  const REJECTED = 2;
  States2[States2["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));
class SyncPromise {
  constructor(executor) {
    SyncPromise.prototype.__init.call(this);
    SyncPromise.prototype.__init2.call(this);
    SyncPromise.prototype.__init3.call(this);
    SyncPromise.prototype.__init4.call(this);
    this._state = States.PENDING;
    this._handlers = [];
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }
  /** JSDoc */
  then(onfulfilled, onrejected) {
    return new SyncPromise((resolve2, reject) => {
      this._handlers.push([
        false,
        (result2) => {
          if (!onfulfilled) {
            resolve2(result2);
          } else {
            try {
              resolve2(onfulfilled(result2));
            } catch (e) {
              reject(e);
            }
          }
        },
        (reason) => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve2(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        }
      ]);
      this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(onrejected) {
    return this.then((val) => val, onrejected);
  }
  /** JSDoc */
  finally(onfinally) {
    return new SyncPromise((resolve2, reject) => {
      let val;
      let isRejected;
      return this.then(
        (value) => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        (reason) => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        }
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }
        resolve2(val);
      });
    });
  }
  /** JSDoc */
  __init() {
    this._resolve = (value) => {
      this._setResult(States.RESOLVED, value);
    };
  }
  /** JSDoc */
  __init2() {
    this._reject = (reason) => {
      this._setResult(States.REJECTED, reason);
    };
  }
  /** JSDoc */
  __init3() {
    this._setResult = (state, value) => {
      if (this._state !== States.PENDING) {
        return;
      }
      if (isThenable(value)) {
        void value.then(this._resolve, this._reject);
        return;
      }
      this._state = state;
      this._value = value;
      this._executeHandlers();
    };
  }
  /** JSDoc */
  __init4() {
    this._executeHandlers = () => {
      if (this._state === States.PENDING) {
        return;
      }
      const cachedHandlers = this._handlers.slice();
      this._handlers = [];
      cachedHandlers.forEach((handler) => {
        if (handler[0]) {
          return;
        }
        if (this._state === States.RESOLVED) {
          handler[1](this._value);
        }
        if (this._state === States.REJECTED) {
          handler[2](this._value);
        }
        handler[0] = true;
      });
    };
  }
}
function parseUrl(url2) {
  if (!url2) {
    return {};
  }
  const match = url2.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!match) {
    return {};
  }
  const query = match[6] || "";
  const fragment = match[8] || "";
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    search: query,
    hash: fragment,
    relative: match[5] + query + fragment
    // everything minus origin
  };
}
const validSeverityLevels = ["fatal", "error", "warning", "log", "info", "debug"];
function severityLevelFromString(level) {
  return level === "warn" ? "warning" : validSeverityLevels.includes(level) ? level : "log";
}
const ONE_SECOND_IN_MS = 1e3;
function dateTimestampInSeconds() {
  return Date.now() / ONE_SECOND_IN_MS;
}
function createUnixTimestampInSecondsFunc() {
  const { performance } = GLOBAL_OBJ;
  if (!performance || !performance.now) {
    return dateTimestampInSeconds;
  }
  const approxStartingTimeOrigin = Date.now() - performance.now();
  const timeOrigin = performance.timeOrigin == void 0 ? approxStartingTimeOrigin : performance.timeOrigin;
  return () => {
    return (timeOrigin + performance.now()) / ONE_SECOND_IN_MS;
  };
}
const timestampInSeconds = createUnixTimestampInSecondsFunc();
(() => {
  const { performance } = GLOBAL_OBJ;
  if (!performance || !performance.now) {
    return void 0;
  }
  const threshold = 3600 * 1e3;
  const performanceNow = performance.now();
  const dateNow = Date.now();
  const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === "number";
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;
  if (timeOriginIsReliable || navigationStartIsReliable) {
    if (timeOriginDelta <= navigationStartDelta) {
      return performance.timeOrigin;
    } else {
      return navigationStart;
    }
  }
  return dateNow;
})();
const DEBUG_BUILD$2 = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const DEFAULT_ENVIRONMENT = "production";
function getGlobalEventProcessors() {
  return getGlobalSingleton("globalEventProcessors", () => []);
}
function notifyEventProcessors(processors, event, hint, index2 = 0) {
  return new SyncPromise((resolve2, reject) => {
    const processor = processors[index2];
    if (event === null || typeof processor !== "function") {
      resolve2(event);
    } else {
      const result2 = processor({ ...event }, hint);
      DEBUG_BUILD$2 && processor.id && result2 === null && logger$2.log(`Event processor "${processor.id}" dropped event`);
      if (isThenable(result2)) {
        void result2.then((final) => notifyEventProcessors(processors, final, hint, index2 + 1).then(resolve2)).then(null, reject);
      } else {
        void notifyEventProcessors(processors, result2, hint, index2 + 1).then(resolve2).then(null, reject);
      }
    }
  });
}
function makeSession(context) {
  const startingTime = timestampInSeconds();
  const session = {
    sid: uuid4(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session)
  };
  {
    updateSession(session, context);
  }
  return session;
}
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }
    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }
  session.timestamp = context.timestamp || timestampInSeconds();
  if (context.abnormal_mechanism) {
    session.abnormal_mechanism = context.abnormal_mechanism;
  }
  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    session.sid = context.sid.length === 32 ? context.sid : uuid4();
  }
  if (context.init !== void 0) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === "number") {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = void 0;
  } else if (typeof context.duration === "number") {
    session.duration = context.duration;
  } else {
    const duration2 = session.timestamp - session.started;
    session.duration = duration2 >= 0 ? duration2 : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === "number") {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}
function closeSession(session, status) {
  let context = {};
  if (session.status === "ok") {
    context = { status: "exited" };
  }
  updateSession(session, context);
}
function sessionToJSON(session) {
  return dropUndefinedKeys({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1e3).toISOString(),
    timestamp: new Date(session.timestamp * 1e3).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
    duration: session.duration,
    abnormal_mechanism: session.abnormal_mechanism,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent
    }
  });
}
const TRACE_FLAG_SAMPLED = 1;
function spanToTraceContext(span) {
  const { spanId: span_id, traceId: trace_id } = span.spanContext();
  const { data, op, parent_span_id, status, tags, origin: origin2 } = spanToJSON(span);
  return dropUndefinedKeys({
    data,
    op,
    parent_span_id,
    span_id,
    status,
    tags,
    trace_id,
    origin: origin2
  });
}
function spanToJSON(span) {
  if (spanIsSpanClass(span)) {
    return span.getSpanJSON();
  }
  if (typeof span.toJSON === "function") {
    return span.toJSON();
  }
  return {};
}
function spanIsSpanClass(span) {
  return typeof span.getSpanJSON === "function";
}
function spanIsSampled(span) {
  const { traceFlags } = span.spanContext();
  return Boolean(traceFlags & TRACE_FLAG_SAMPLED);
}
function parseEventHintOrCaptureContext(hint) {
  if (!hint) {
    return void 0;
  }
  if (hintIsScopeOrFunction(hint)) {
    return { captureContext: hint };
  }
  if (hintIsScopeContext(hint)) {
    return {
      captureContext: hint
    };
  }
  return hint;
}
function hintIsScopeOrFunction(hint) {
  return hint instanceof Scope || typeof hint === "function";
}
const captureContextKeys = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function hintIsScopeContext(hint) {
  return Object.keys(hint).some((key) => captureContextKeys.includes(key));
}
function captureException(exception, hint) {
  return getCurrentHub().captureException(exception, parseEventHintOrCaptureContext(hint));
}
function captureEvent(event, hint) {
  return getCurrentHub().captureEvent(event, hint);
}
function addBreadcrumb(breadcrumb, hint) {
  getCurrentHub().addBreadcrumb(breadcrumb, hint);
}
function withScope(...rest) {
  const hub = getCurrentHub();
  if (rest.length === 2) {
    const [scope, callback] = rest;
    if (!scope) {
      return hub.withScope(callback);
    }
    return hub.withScope(() => {
      hub.getStackTop().scope = scope;
      return callback(scope);
    });
  }
  return hub.withScope(rest[0]);
}
function getClient() {
  return getCurrentHub().getClient();
}
function getCurrentScope() {
  return getCurrentHub().getScope();
}
function getRootSpan(span) {
  return span.transaction;
}
function getDynamicSamplingContextFromClient(trace_id, client2, scope) {
  const options = client2.getOptions();
  const { publicKey: public_key } = client2.getDsn() || {};
  const { segment: user_segment } = scope && scope.getUser() || {};
  const dsc = dropUndefinedKeys({
    environment: options.environment || DEFAULT_ENVIRONMENT,
    release: options.release,
    user_segment,
    public_key,
    trace_id
  });
  client2.emit && client2.emit("createDsc", dsc);
  return dsc;
}
function getDynamicSamplingContextFromSpan(span) {
  const client2 = getClient();
  if (!client2) {
    return {};
  }
  const dsc = getDynamicSamplingContextFromClient(spanToJSON(span).trace_id || "", client2, getCurrentScope());
  const txn = getRootSpan(span);
  if (!txn) {
    return dsc;
  }
  const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
  if (v7FrozenDsc) {
    return v7FrozenDsc;
  }
  const { sampleRate: maybeSampleRate, source } = txn.metadata;
  if (maybeSampleRate != null) {
    dsc.sample_rate = `${maybeSampleRate}`;
  }
  const jsonSpan = spanToJSON(txn);
  if (source && source !== "url") {
    dsc.transaction = jsonSpan.description;
  }
  dsc.sampled = String(spanIsSampled(txn));
  client2.emit && client2.emit("createDsc", dsc);
  return dsc;
}
function applyScopeDataToEvent(event, data) {
  const { fingerprint, span, breadcrumbs, sdkProcessingMetadata } = data;
  applyDataToEvent(event, data);
  if (span) {
    applySpanToEvent(event, span);
  }
  applyFingerprintToEvent(event, fingerprint);
  applyBreadcrumbsToEvent(event, breadcrumbs);
  applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function applyDataToEvent(event, data) {
  const {
    extra,
    tags,
    user,
    contexts,
    level,
    // eslint-disable-next-line deprecation/deprecation
    transactionName
  } = data;
  const cleanedExtra = dropUndefinedKeys(extra);
  if (cleanedExtra && Object.keys(cleanedExtra).length) {
    event.extra = { ...cleanedExtra, ...event.extra };
  }
  const cleanedTags = dropUndefinedKeys(tags);
  if (cleanedTags && Object.keys(cleanedTags).length) {
    event.tags = { ...cleanedTags, ...event.tags };
  }
  const cleanedUser = dropUndefinedKeys(user);
  if (cleanedUser && Object.keys(cleanedUser).length) {
    event.user = { ...cleanedUser, ...event.user };
  }
  const cleanedContexts = dropUndefinedKeys(contexts);
  if (cleanedContexts && Object.keys(cleanedContexts).length) {
    event.contexts = { ...cleanedContexts, ...event.contexts };
  }
  if (level) {
    event.level = level;
  }
  if (transactionName) {
    event.transaction = transactionName;
  }
}
function applyBreadcrumbsToEvent(event, breadcrumbs) {
  const mergedBreadcrumbs = [...event.breadcrumbs || [], ...breadcrumbs];
  event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
  event.sdkProcessingMetadata = {
    ...event.sdkProcessingMetadata,
    ...sdkProcessingMetadata
  };
}
function applySpanToEvent(event, span) {
  event.contexts = { trace: spanToTraceContext(span), ...event.contexts };
  const rootSpan = getRootSpan(span);
  if (rootSpan) {
    event.sdkProcessingMetadata = {
      dynamicSamplingContext: getDynamicSamplingContextFromSpan(span),
      ...event.sdkProcessingMetadata
    };
    const transactionName = spanToJSON(rootSpan).description;
    if (transactionName) {
      event.tags = { transaction: transactionName, ...event.tags };
    }
  }
}
function applyFingerprintToEvent(event, fingerprint) {
  event.fingerprint = event.fingerprint ? arrayify(event.fingerprint) : [];
  if (fingerprint) {
    event.fingerprint = event.fingerprint.concat(fingerprint);
  }
  if (event.fingerprint && !event.fingerprint.length) {
    delete event.fingerprint;
  }
}
const DEFAULT_MAX_BREADCRUMBS = 100;
class Scope {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called after {@link applyToEvent}. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  // eslint-disable-next-line deprecation/deprecation
  /**
   * Transaction Name
   */
  /** Span */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
    this._propagationContext = generatePropagationContext();
  }
  /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */
  static clone(scope) {
    return scope ? scope.clone() : new Scope();
  }
  /**
   * Clone this scope instance.
   */
  clone() {
    const newScope = new Scope();
    newScope._breadcrumbs = [...this._breadcrumbs];
    newScope._tags = { ...this._tags };
    newScope._extra = { ...this._extra };
    newScope._contexts = { ...this._contexts };
    newScope._user = this._user;
    newScope._level = this._level;
    newScope._span = this._span;
    newScope._session = this._session;
    newScope._transactionName = this._transactionName;
    newScope._fingerprint = this._fingerprint;
    newScope._eventProcessors = [...this._eventProcessors];
    newScope._requestSession = this._requestSession;
    newScope._attachments = [...this._attachments];
    newScope._sdkProcessingMetadata = { ...this._sdkProcessingMetadata };
    newScope._propagationContext = { ...this._propagationContext };
    newScope._client = this._client;
    return newScope;
  }
  /** Update the client on the scope. */
  setClient(client2) {
    this._client = client2;
  }
  /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */
  getClient() {
    return this._client;
  }
  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
  addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }
  /**
   * @inheritDoc
   */
  setUser(user) {
    this._user = user || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      segment: void 0,
      username: void 0
    };
    if (this._session) {
      updateSession(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }
  /**
   * @inheritDoc
   */
  setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags
    };
    this._notifyScopeListeners();
    return this;
  }
  /**
   * @inheritDoc
   */
  setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }
  /**
   * @inheritDoc
   */
  setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras
    };
    this._notifyScopeListeners();
    return this;
  }
  /**
   * @inheritDoc
   */
  setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }
  /**
   * @inheritDoc
   */
  setLevel(level) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Sets the transaction name on the scope for future events.
   */
  setTransactionName(name2) {
    this._transactionName = name2;
    this._notifyScopeListeners();
    return this;
  }
  /**
   * @inheritDoc
   */
  setContext(key, context) {
    if (context === null) {
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */
  setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */
  getSpan() {
    return this._span;
  }
  /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */
  getTransaction() {
    const span = this._span;
    return span && span.transaction;
  }
  /**
   * @inheritDoc
   */
  setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(captureContext) {
    if (!captureContext) {
      return this;
    }
    const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
    if (scopeToMerge instanceof Scope) {
      const scopeData = scopeToMerge.getScopeData();
      this._tags = { ...this._tags, ...scopeData.tags };
      this._extra = { ...this._extra, ...scopeData.extra };
      this._contexts = { ...this._contexts, ...scopeData.contexts };
      if (scopeData.user && Object.keys(scopeData.user).length) {
        this._user = scopeData.user;
      }
      if (scopeData.level) {
        this._level = scopeData.level;
      }
      if (scopeData.fingerprint.length) {
        this._fingerprint = scopeData.fingerprint;
      }
      if (scopeToMerge.getRequestSession()) {
        this._requestSession = scopeToMerge.getRequestSession();
      }
      if (scopeData.propagationContext) {
        this._propagationContext = scopeData.propagationContext;
      }
    } else if (isPlainObject$1(scopeToMerge)) {
      const scopeContext = captureContext;
      this._tags = { ...this._tags, ...scopeContext.tags };
      this._extra = { ...this._extra, ...scopeContext.extra };
      this._contexts = { ...this._contexts, ...scopeContext.contexts };
      if (scopeContext.user) {
        this._user = scopeContext.user;
      }
      if (scopeContext.level) {
        this._level = scopeContext.level;
      }
      if (scopeContext.fingerprint) {
        this._fingerprint = scopeContext.fingerprint;
      }
      if (scopeContext.requestSession) {
        this._requestSession = scopeContext.requestSession;
      }
      if (scopeContext.propagationContext) {
        this._propagationContext = scopeContext.propagationContext;
      }
    }
    return this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = void 0;
    this._transactionName = void 0;
    this._fingerprint = void 0;
    this._requestSession = void 0;
    this._span = void 0;
    this._session = void 0;
    this._notifyScopeListeners();
    this._attachments = [];
    this._propagationContext = generatePropagationContext();
    return this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
    if (maxCrumbs <= 0) {
      return this;
    }
    const mergedBreadcrumb = {
      timestamp: dateTimestampInSeconds(),
      ...breadcrumb
    };
    const breadcrumbs = this._breadcrumbs;
    breadcrumbs.push(mergedBreadcrumb);
    this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
    this._notifyScopeListeners();
    return this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }
  /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */
  getAttachments() {
    const data = this.getScopeData();
    return data.attachments;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    this._attachments = [];
    return this;
  }
  /** @inheritDoc */
  getScopeData() {
    const {
      _breadcrumbs,
      _attachments,
      _contexts,
      _tags,
      _extra,
      _user,
      _level,
      _fingerprint,
      _eventProcessors,
      _propagationContext,
      _sdkProcessingMetadata,
      _transactionName,
      _span
    } = this;
    return {
      breadcrumbs: _breadcrumbs,
      attachments: _attachments,
      contexts: _contexts,
      tags: _tags,
      extra: _extra,
      user: _user,
      level: _level,
      fingerprint: _fingerprint || [],
      eventProcessors: _eventProcessors,
      propagationContext: _propagationContext,
      sdkProcessingMetadata: _sdkProcessingMetadata,
      transactionName: _transactionName,
      span: _span
    };
  }
  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */
  applyToEvent(event, hint = {}, additionalEventProcessors = []) {
    applyScopeDataToEvent(event, this.getScopeData());
    const eventProcessors = [
      ...additionalEventProcessors,
      // eslint-disable-next-line deprecation/deprecation
      ...getGlobalEventProcessors(),
      ...this._eventProcessors
    ];
    return notifyEventProcessors(eventProcessors, event, hint);
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
  setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };
    return this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(context) {
    this._propagationContext = context;
    return this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */
  captureException(exception, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : uuid4();
    if (!this._client) {
      logger$2.warn("No client configured on scope - will not capture exception!");
      return eventId;
    }
    const syntheticException = new Error("Sentry syntheticException");
    this._client.captureException(
      exception,
      {
        originalException: exception,
        syntheticException,
        ...hint,
        event_id: eventId
      },
      this
    );
    return eventId;
  }
  /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */
  captureMessage(message, level, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : uuid4();
    if (!this._client) {
      logger$2.warn("No client configured on scope - will not capture message!");
      return eventId;
    }
    const syntheticException = new Error(message);
    this._client.captureMessage(
      message,
      level,
      {
        originalException: message,
        syntheticException,
        ...hint,
        event_id: eventId
      },
      this
    );
    return eventId;
  }
  /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */
  captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : uuid4();
    if (!this._client) {
      logger$2.warn("No client configured on scope - will not capture event!");
      return eventId;
    }
    this._client.captureEvent(event, { ...hint, event_id: eventId }, this);
    return eventId;
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach((callback) => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }
}
function generatePropagationContext() {
  return {
    traceId: uuid4(),
    spanId: uuid4().substring(16)
  };
}
const SDK_VERSION = "7.120.3";
const API_VERSION = parseFloat(SDK_VERSION);
const DEFAULT_BREADCRUMBS = 100;
class Hub {
  /** Is a {@link Layer}[] containing the client and scope */
  /** Contains the last event id of a captured event.  */
  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */
  constructor(client2, scope, isolationScope, _version = API_VERSION) {
    this._version = _version;
    let assignedScope;
    if (!scope) {
      assignedScope = new Scope();
      assignedScope.setClient(client2);
    } else {
      assignedScope = scope;
    }
    let assignedIsolationScope;
    if (!isolationScope) {
      assignedIsolationScope = new Scope();
      assignedIsolationScope.setClient(client2);
    } else {
      assignedIsolationScope = isolationScope;
    }
    this._stack = [{ scope: assignedScope }];
    if (client2) {
      this.bindClient(client2);
    }
    this._isolationScope = assignedIsolationScope;
  }
  /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */
  isOlderThan(version2) {
    return this._version < version2;
  }
  /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */
  bindClient(client2) {
    const top = this.getStackTop();
    top.client = client2;
    top.scope.setClient(client2);
    if (client2 && client2.setupIntegrations) {
      client2.setupIntegrations();
    }
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
  pushScope() {
    const scope = this.getScope().clone();
    this.getStack().push({
      // eslint-disable-next-line deprecation/deprecation
      client: this.getClient(),
      scope
    });
    return scope;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
  popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */
  withScope(callback) {
    const scope = this.pushScope();
    let maybePromiseResult;
    try {
      maybePromiseResult = callback(scope);
    } catch (e) {
      this.popScope();
      throw e;
    }
    if (isThenable(maybePromiseResult)) {
      return maybePromiseResult.then(
        (res) => {
          this.popScope();
          return res;
        },
        (e) => {
          this.popScope();
          throw e;
        }
      );
    }
    this.popScope();
    return maybePromiseResult;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */
  getStack() {
    return this._stack;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */
  captureException(exception, hint) {
    const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4();
    const syntheticException = new Error("Sentry syntheticException");
    this.getScope().captureException(exception, {
      originalException: exception,
      syntheticException,
      ...hint,
      event_id: eventId
    });
    return eventId;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */
  captureMessage(message, level, hint) {
    const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4();
    const syntheticException = new Error(message);
    this.getScope().captureMessage(message, level, {
      originalException: message,
      syntheticException,
      ...hint,
      event_id: eventId
    });
    return eventId;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */
  captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : uuid4();
    if (!event.type) {
      this._lastEventId = eventId;
    }
    this.getScope().captureEvent(event, { ...hint, event_id: eventId });
    return eventId;
  }
  /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */
  addBreadcrumb(breadcrumb, hint) {
    const { scope, client: client2 } = this.getStackTop();
    if (!client2) return;
    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } = client2.getOptions && client2.getOptions() || {};
    if (maxBreadcrumbs <= 0) return;
    const timestamp = dateTimestampInSeconds();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb ? consoleSandbox(() => beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client2.emit) {
      client2.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    }
    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */
  setUser(user) {
    this.getScope().setUser(user);
    this.getIsolationScope().setUser(user);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */
  setTags(tags) {
    this.getScope().setTags(tags);
    this.getIsolationScope().setTags(tags);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */
  setExtras(extras) {
    this.getScope().setExtras(extras);
    this.getIsolationScope().setExtras(extras);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */
  setTag(key, value) {
    this.getScope().setTag(key, value);
    this.getIsolationScope().setTag(key, value);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */
  setExtra(key, extra) {
    this.getScope().setExtra(key, extra);
    this.getIsolationScope().setExtra(key, extra);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setContext(name2, context) {
    this.getScope().setContext(name2, context);
    this.getIsolationScope().setContext(name2, context);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */
  configureScope(callback) {
    const { scope, client: client2 } = this.getStackTop();
    if (client2) {
      callback(scope);
    }
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */
  getIntegration(integration) {
    const client2 = this.getClient();
    if (!client2) return null;
    try {
      return client2.getIntegration(integration);
    } catch (_oO) {
      DEBUG_BUILD$2 && logger$2.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }
  /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */
  startTransaction(context, customSamplingContext) {
    const result2 = this._callExtensionMethod("startTransaction", context, customSamplingContext);
    if (DEBUG_BUILD$2 && !result2) {
      const client2 = this.getClient();
      if (!client2) {
        logger$2.warn(
          "Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'"
        );
      } else {
        logger$2.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
      }
    }
    return result2;
  }
  /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */
  traceHeaders() {
    return this._callExtensionMethod("traceHeaders");
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */
  captureSession(endSession = false) {
    if (endSession) {
      return this.endSession();
    }
    this._sendSessionUpdate();
  }
  /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */
  endSession() {
    const layer = this.getStackTop();
    const scope = layer.scope;
    const session = scope.getSession();
    if (session) {
      closeSession(session);
    }
    this._sendSessionUpdate();
    scope.setSession();
  }
  /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */
  startSession(context) {
    const { scope, client: client2 } = this.getStackTop();
    const { release, environment = DEFAULT_ENVIRONMENT } = client2 && client2.getOptions() || {};
    const { userAgent } = GLOBAL_OBJ.navigator || {};
    const session = makeSession({
      release,
      environment,
      user: scope.getUser(),
      ...userAgent && { userAgent },
      ...context
    });
    const currentSession = scope.getSession && scope.getSession();
    if (currentSession && currentSession.status === "ok") {
      updateSession(currentSession, { status: "exited" });
    }
    this.endSession();
    scope.setSession(session);
    return session;
  }
  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */
  shouldSendDefaultPii() {
    const client2 = this.getClient();
    const options = client2 && client2.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }
  /**
   * Sends the current Session on the scope
   */
  _sendSessionUpdate() {
    const { scope, client: client2 } = this.getStackTop();
    const session = scope.getSession();
    if (session && client2 && client2.captureSession) {
      client2.captureSession(session);
    }
  }
  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") {
      return sentry.extensions[method].apply(this, args);
    }
    DEBUG_BUILD$2 && logger$2.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}
function getMainCarrier() {
  GLOBAL_OBJ.__SENTRY__ = GLOBAL_OBJ.__SENTRY__ || {
    extensions: {},
    hub: void 0
  };
  return GLOBAL_OBJ;
}
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}
function getCurrentHub() {
  const registry = getMainCarrier();
  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    const hub = registry.__SENTRY__.acs.getCurrentHub();
    if (hub) {
      return hub;
    }
  }
  return getGlobalHub(registry);
}
function getGlobalHub(registry = getMainCarrier()) {
  if (!hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
  getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }
  return getHubFromCarrier(registry);
}
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function getHubFromCarrier(carrier) {
  return getGlobalSingleton("hub", () => new Hub(), carrier);
}
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
  __SENTRY__.hub = hub;
  return true;
}
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
  const port = dsn.port ? `:${dsn.port}` : "";
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function getReportDialogEndpoint(dsnLike, dialogOptions) {
  const dsn = makeDsn(dsnLike);
  if (!dsn) {
    return "";
  }
  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;
  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (const key in dialogOptions) {
    if (key === "dsn") {
      continue;
    }
    if (key === "onClose") {
      continue;
    }
    if (key === "user") {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
  }
  return `${endpoint}?${encodedOptions}`;
}
function convertIntegrationFnToClass(name2, fn) {
  return Object.assign(
    function ConvertedIntegration(...args) {
      return fn(...args);
    },
    { id: name2 }
  );
}
function defineIntegration(fn) {
  return fn;
}
const DEFAULT_IGNORE_ERRORS = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  /^Cannot redefine property: googletag$/
];
const DEFAULT_IGNORE_TRANSACTIONS = [
  /^.*\/healthcheck$/,
  /^.*\/healthy$/,
  /^.*\/live$/,
  /^.*\/ready$/,
  /^.*\/heartbeat$/,
  /^.*\/health$/,
  /^.*\/healthz$/
];
const INTEGRATION_NAME$7 = "InboundFilters";
const _inboundFiltersIntegration = (options = {}) => {
  return {
    name: INTEGRATION_NAME$7,
    // TODO v8: Remove this
    setupOnce() {
    },
    // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(event, _hint, client2) {
      const clientOptions = client2.getOptions();
      const mergedOptions = _mergeOptions(options, clientOptions);
      return _shouldDropEvent$1(event, mergedOptions) ? null : event;
    }
  };
};
const inboundFiltersIntegration = defineIntegration(_inboundFiltersIntegration);
convertIntegrationFnToClass(
  INTEGRATION_NAME$7,
  inboundFiltersIntegration
);
function _mergeOptions(internalOptions = {}, clientOptions = {}) {
  return {
    allowUrls: [...internalOptions.allowUrls || [], ...clientOptions.allowUrls || []],
    denyUrls: [...internalOptions.denyUrls || [], ...clientOptions.denyUrls || []],
    ignoreErrors: [
      ...internalOptions.ignoreErrors || [],
      ...clientOptions.ignoreErrors || [],
      ...internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS
    ],
    ignoreTransactions: [
      ...internalOptions.ignoreTransactions || [],
      ...clientOptions.ignoreTransactions || [],
      ...internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS
    ],
    ignoreInternal: internalOptions.ignoreInternal !== void 0 ? internalOptions.ignoreInternal : true
  };
}
function _shouldDropEvent$1(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    DEBUG_BUILD$2 && logger$2.warn(`Event dropped due to being internal Sentry Error.
Event: ${getEventDescription(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    DEBUG_BUILD$2 && logger$2.warn(
      `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${getEventDescription(event)}`
    );
    return true;
  }
  if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
    DEBUG_BUILD$2 && logger$2.warn(
      `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${getEventDescription(event)}`
    );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    DEBUG_BUILD$2 && logger$2.warn(
      `Event dropped due to being matched by \`denyUrls\` option.
Event: ${getEventDescription(
        event
      )}.
Url: ${_getEventFilterUrl(event)}`
    );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    DEBUG_BUILD$2 && logger$2.warn(
      `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${getEventDescription(
        event
      )}.
Url: ${_getEventFilterUrl(event)}`
    );
    return true;
  }
  return false;
}
function _isIgnoredError(event, ignoreErrors) {
  if (event.type || !ignoreErrors || !ignoreErrors.length) {
    return false;
  }
  return _getPossibleEventMessages(event).some((message) => stringMatchesSomePattern(message, ignoreErrors));
}
function _isIgnoredTransaction(event, ignoreTransactions) {
  if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) {
    return false;
  }
  const name2 = event.transaction;
  return name2 ? stringMatchesSomePattern(name2, ignoreTransactions) : false;
}
function _isDeniedUrl(event, denyUrls) {
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url2 = _getEventFilterUrl(event);
  return !url2 ? false : stringMatchesSomePattern(url2, denyUrls);
}
function _isAllowedUrl(event, allowUrls) {
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url2 = _getEventFilterUrl(event);
  return !url2 ? true : stringMatchesSomePattern(url2, allowUrls);
}
function _getPossibleEventMessages(event) {
  const possibleMessages = [];
  if (event.message) {
    possibleMessages.push(event.message);
  }
  let lastException;
  try {
    lastException = event.exception.values[event.exception.values.length - 1];
  } catch (e) {
  }
  if (lastException) {
    if (lastException.value) {
      possibleMessages.push(lastException.value);
      if (lastException.type) {
        possibleMessages.push(`${lastException.type}: ${lastException.value}`);
      }
    }
  }
  if (DEBUG_BUILD$2 && possibleMessages.length === 0) {
    logger$2.error(`Could not extract message for event ${getEventDescription(event)}`);
  }
  return possibleMessages;
}
function _isSentryError(event) {
  try {
    return event.exception.values[0].type === "SentryError";
  } catch (e) {
  }
  return false;
}
function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];
    if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") {
      return frame.filename || null;
    }
  }
  return null;
}
function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    DEBUG_BUILD$2 && logger$2.error(`Cannot extract url for event ${getEventDescription(event)}`);
    return null;
  }
}
let originalFunctionToString;
const INTEGRATION_NAME$6 = "FunctionToString";
const SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const _functionToStringIntegration = () => {
  return {
    name: INTEGRATION_NAME$6,
    setupOnce() {
      originalFunctionToString = Function.prototype.toString;
      try {
        Function.prototype.toString = function(...args) {
          const originalFunction = getOriginalFunction(this);
          const context = SETUP_CLIENTS.has(getClient()) && originalFunction !== void 0 ? originalFunction : this;
          return originalFunctionToString.apply(context, args);
        };
      } catch (e) {
      }
    },
    setup(client2) {
      SETUP_CLIENTS.set(client2, true);
    }
  };
};
const functionToStringIntegration = defineIntegration(_functionToStringIntegration);
convertIntegrationFnToClass(
  INTEGRATION_NAME$6,
  functionToStringIntegration
);
const WINDOW = GLOBAL_OBJ;
let ignoreOnError = 0;
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}
function ignoreNextOnError() {
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}
function wrap(fn, options = {}, before) {
  if (typeof fn !== "function") {
    return fn;
  }
  try {
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      if (typeof wrapper === "function") {
        return wrapper;
      } else {
        return fn;
      }
    }
    if (getOriginalFunction(fn)) {
      return fn;
    }
  } catch (e) {
    return fn;
  }
  const sentryWrapped = function() {
    const args = Array.prototype.slice.call(arguments);
    try {
      if (before && typeof before === "function") ;
      const wrappedArguments = args.map((arg) => wrap(arg, options));
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();
      withScope((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            addExceptionTypeValue(event, void 0);
            addExceptionMechanism(event, options.mechanism);
          }
          event.extra = {
            ...event.extra,
            arguments: args
          };
          return event;
        });
        captureException(ex);
      });
      throw ex;
    }
  };
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {
  }
  markFunctionWrapped(sentryWrapped, fn);
  addNonEnumerableProperty(fn, "__sentry_wrapped__", sentryWrapped);
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, "name", {
        get() {
          return fn.name;
        }
      });
    }
  } catch (_oO) {
  }
  return sentryWrapped;
}
const DEBUG_BUILD$1 = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
function exceptionFromError(stackParser, ex) {
  const frames = parseStackFrames(stackParser, ex);
  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex)
  };
  if (frames.length) {
    exception.stacktrace = { frames };
  }
  if (exception.type === void 0 && exception.value === "") {
    exception.value = "Unrecoverable error caught";
  }
  return exception;
}
function eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
  const client2 = getClient();
  const normalizeDepth = client2 && client2.getOptions().normalizeDepth;
  const event = {
    exception: {
      values: [
        {
          type: isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
          value: getNonErrorObjectExceptionValue(exception, { isUnhandledRejection })
        }
      ]
    },
    extra: {
      __serialized__: normalizeToSize(exception, normalizeDepth)
    }
  };
  return event;
}
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)]
    }
  };
}
function parseStackFrames(stackParser, ex) {
  const stacktrace = ex.stacktrace || ex.stack || "";
  const popSize = getPopSize(ex);
  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
  }
  return [];
}
const reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === "number") {
      return ex.framesToPop;
    }
    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }
  return 0;
}
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return "No error message";
  }
  if (message.error && typeof message.error.message === "string") {
    return message.error.message;
  }
  return message;
}
function eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
  let event;
  if (isErrorEvent(exception) && exception.error) {
    const errorEvent = exception;
    return eventFromError(stackParser, errorEvent.error);
  }
  if (isDOMError(exception) || isDOMException(exception)) {
    const domException = exception;
    if ("stack" in exception) {
      event = eventFromError(stackParser, exception);
    } else {
      const name2 = domException.name || (isDOMError(domException) ? "DOMError" : "DOMException");
      const message = domException.message ? `${name2}: ${domException.message}` : name2;
      event = eventFromString(stackParser, message);
      addExceptionTypeValue(event, message);
    }
    if ("code" in domException) {
      event.tags = { ...event.tags, "DOMException.code": `${domException.code}` };
    }
    return event;
  }
  if (isError(exception)) {
    return eventFromError(stackParser, exception);
  }
  if (isPlainObject$1(exception) || isEvent(exception)) {
    const objectException = exception;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    addExceptionMechanism(event, {
      synthetic: true
    });
    return event;
  }
  event = eventFromString(stackParser, exception);
  addExceptionTypeValue(event, `${exception}`);
  addExceptionMechanism(event, {
    synthetic: true
  });
  return event;
}
function eventFromString(stackParser, message, syntheticException, attachStacktrace) {
  const event = {};
  if (isParameterizedString(message)) {
    const { __sentry_template_string__, __sentry_template_values__ } = message;
    event.logentry = {
      message: __sentry_template_string__,
      params: __sentry_template_values__
    };
    return event;
  }
  event.message = message;
  return event;
}
function getNonErrorObjectExceptionValue(exception, { isUnhandledRejection }) {
  const keys = extractExceptionKeysForMessage(exception);
  const captureType = isUnhandledRejection ? "promise rejection" : "exception";
  if (isErrorEvent(exception)) {
    return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
  }
  if (isEvent(exception)) {
    const className = getObjectClassName(exception);
    return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
  }
  return `Object captured as ${captureType} with keys: ${keys}`;
}
function getObjectClassName(obj) {
  try {
    const prototype2 = Object.getPrototypeOf(obj);
    return prototype2 ? prototype2.constructor.name : void 0;
  } catch (e) {
  }
}
const MAX_ALLOWED_STRING_LENGTH = 1024;
const INTEGRATION_NAME$5 = "Breadcrumbs";
const _breadcrumbsIntegration = (options = {}) => {
  const _options = {
    console: true,
    dom: true,
    fetch: true,
    history: true,
    sentry: true,
    xhr: true,
    ...options
  };
  return {
    name: INTEGRATION_NAME$5,
    // TODO v8: Remove this
    setupOnce() {
    },
    // eslint-disable-line @typescript-eslint/no-empty-function
    setup(client2) {
      if (_options.console) {
        addConsoleInstrumentationHandler(_getConsoleBreadcrumbHandler(client2));
      }
      if (_options.dom) {
        addClickKeypressInstrumentationHandler(_getDomBreadcrumbHandler(client2, _options.dom));
      }
      if (_options.xhr) {
        addXhrInstrumentationHandler(_getXhrBreadcrumbHandler(client2));
      }
      if (_options.fetch) {
        addFetchInstrumentationHandler(_getFetchBreadcrumbHandler(client2));
      }
      if (_options.history) {
        addHistoryInstrumentationHandler(_getHistoryBreadcrumbHandler(client2));
      }
      if (_options.sentry && client2.on) {
        client2.on("beforeSendEvent", _getSentryBreadcrumbHandler(client2));
      }
    }
  };
};
const breadcrumbsIntegration = defineIntegration(_breadcrumbsIntegration);
convertIntegrationFnToClass(INTEGRATION_NAME$5, breadcrumbsIntegration);
function _getSentryBreadcrumbHandler(client2) {
  return function addSentryBreadcrumb(event) {
    if (getClient() !== client2) {
      return;
    }
    addBreadcrumb(
      {
        category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
        event_id: event.event_id,
        level: event.level,
        message: getEventDescription(event)
      },
      {
        event
      }
    );
  };
}
function _getDomBreadcrumbHandler(client2, dom) {
  return function _innerDomBreadcrumb(handlerData) {
    if (getClient() !== client2) {
      return;
    }
    let target;
    let componentName;
    let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
    let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      DEBUG_BUILD$1 && logger$2.warn(
        `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`
      );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }
    if (typeof keyAttrs === "string") {
      keyAttrs = [keyAttrs];
    }
    try {
      const event = handlerData.event;
      const element = _isEvent(event) ? event.target : event;
      target = htmlTreeAsString(element, { keyAttrs, maxStringLength });
      componentName = getComponentName(element);
    } catch (e) {
      target = "<unknown>";
    }
    if (target.length === 0) {
      return;
    }
    const breadcrumb = {
      category: `ui.${handlerData.name}`,
      message: target
    };
    if (componentName) {
      breadcrumb.data = { "ui.component_name": componentName };
    }
    addBreadcrumb(breadcrumb, {
      event: handlerData.event,
      name: handlerData.name,
      global: handlerData.global
    });
  };
}
function _getConsoleBreadcrumbHandler(client2) {
  return function _consoleBreadcrumb(handlerData) {
    if (getClient() !== client2) {
      return;
    }
    const breadcrumb = {
      category: "console",
      data: {
        arguments: handlerData.args,
        logger: "console"
      },
      level: severityLevelFromString(handlerData.level),
      message: safeJoin(handlerData.args, " ")
    };
    if (handlerData.level === "assert") {
      if (handlerData.args[0] === false) {
        breadcrumb.message = `Assertion failed: ${safeJoin(handlerData.args.slice(1), " ") || "console.assert"}`;
        breadcrumb.data.arguments = handlerData.args.slice(1);
      } else {
        return;
      }
    }
    addBreadcrumb(breadcrumb, {
      input: handlerData.args,
      level: handlerData.level
    });
  };
}
function _getXhrBreadcrumbHandler(client2) {
  return function _xhrBreadcrumb(handlerData) {
    if (getClient() !== client2) {
      return;
    }
    const { startTimestamp, endTimestamp } = handlerData;
    const sentryXhrData = handlerData.xhr[SENTRY_XHR_DATA_KEY];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) {
      return;
    }
    const { method, url: url2, status_code, body } = sentryXhrData;
    const data = {
      method,
      url: url2,
      status_code
    };
    const hint = {
      xhr: handlerData.xhr,
      input: body,
      startTimestamp,
      endTimestamp
    };
    addBreadcrumb(
      {
        category: "xhr",
        data,
        type: "http"
      },
      hint
    );
  };
}
function _getFetchBreadcrumbHandler(client2) {
  return function _fetchBreadcrumb(handlerData) {
    if (getClient() !== client2) {
      return;
    }
    const { startTimestamp, endTimestamp } = handlerData;
    if (!endTimestamp) {
      return;
    }
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") {
      return;
    }
    if (handlerData.error) {
      const data = handlerData.fetchData;
      const hint = {
        data: handlerData.error,
        input: handlerData.args,
        startTimestamp,
        endTimestamp
      };
      addBreadcrumb(
        {
          category: "fetch",
          data,
          level: "error",
          type: "http"
        },
        hint
      );
    } else {
      const response = handlerData.response;
      const data = {
        ...handlerData.fetchData,
        status_code: response && response.status
      };
      const hint = {
        input: handlerData.args,
        response,
        startTimestamp,
        endTimestamp
      };
      addBreadcrumb(
        {
          category: "fetch",
          data,
          type: "http"
        },
        hint
      );
    }
  };
}
function _getHistoryBreadcrumbHandler(client2) {
  return function _historyBreadcrumb(handlerData) {
    if (getClient() !== client2) {
      return;
    }
    let from2 = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = parseUrl(WINDOW.location.href);
    let parsedFrom = from2 ? parseUrl(from2) : void 0;
    const parsedTo = parseUrl(to);
    if (!parsedFrom || !parsedFrom.path) {
      parsedFrom = parsedLoc;
    }
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
      to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
      from2 = parsedFrom.relative;
    }
    addBreadcrumb({
      category: "navigation",
      data: {
        from: from2,
        to
      }
    });
  };
}
function _isEvent(event) {
  return !!event && !!event.target;
}
const INTEGRATION_NAME$4 = "Dedupe";
const _dedupeIntegration = () => {
  let previousEvent;
  return {
    name: INTEGRATION_NAME$4,
    // TODO v8: Remove this
    setupOnce() {
    },
    // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(currentEvent) {
      if (currentEvent.type) {
        return currentEvent;
      }
      try {
        if (_shouldDropEvent(currentEvent, previousEvent)) {
          DEBUG_BUILD$1 && logger$2.warn("Event dropped due to being a duplicate of previously captured event.");
          return null;
        }
      } catch (_oO) {
      }
      return previousEvent = currentEvent;
    }
  };
};
const dedupeIntegration = defineIntegration(_dedupeIntegration);
convertIntegrationFnToClass(INTEGRATION_NAME$4, dedupeIntegration);
function _shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }
  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }
  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }
  return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;
  if (!currentMessage && !previousMessage) {
    return false;
  }
  if (currentMessage && !previousMessage || !currentMessage && previousMessage) {
    return false;
  }
  if (currentMessage !== previousMessage) {
    return false;
  }
  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }
  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }
  return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);
  if (!previousException || !currentException) {
    return false;
  }
  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }
  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }
  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }
  return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);
  if (!currentFrames && !previousFrames) {
    return true;
  }
  if (currentFrames && !previousFrames || !currentFrames && previousFrames) {
    return false;
  }
  currentFrames = currentFrames;
  previousFrames = previousFrames;
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];
    if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) {
      return false;
    }
  }
  return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }
  if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) {
    return false;
  }
  currentFingerprint = currentFingerprint;
  previousFingerprint = previousFingerprint;
  try {
    return !!(currentFingerprint.join("") === previousFingerprint.join(""));
  } catch (_oO) {
    return false;
  }
}
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}
function _getFramesFromEvent(event) {
  const exception = event.exception;
  if (exception) {
    try {
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return void 0;
    }
  }
  return void 0;
}
const INTEGRATION_NAME$3 = "GlobalHandlers";
const _globalHandlersIntegration = (options = {}) => {
  const _options = {
    onerror: true,
    onunhandledrejection: true,
    ...options
  };
  return {
    name: INTEGRATION_NAME$3,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(client2) {
      if (_options.onerror) {
        _installGlobalOnErrorHandler(client2);
        globalHandlerLog("onerror");
      }
      if (_options.onunhandledrejection) {
        _installGlobalOnUnhandledRejectionHandler(client2);
        globalHandlerLog("onunhandledrejection");
      }
    }
  };
};
const globalHandlersIntegration = defineIntegration(_globalHandlersIntegration);
convertIntegrationFnToClass(
  INTEGRATION_NAME$3,
  globalHandlersIntegration
);
function _installGlobalOnErrorHandler(client2) {
  addGlobalErrorInstrumentationHandler((data) => {
    const { stackParser, attachStacktrace } = getOptions();
    if (getClient() !== client2 || shouldIgnoreOnError()) {
      return;
    }
    const { msg, url: url2, line, column, error } = data;
    const event = error === void 0 && isString(msg) ? _eventFromIncompleteOnError(msg, url2, line, column) : _enhanceEventWithInitialFrame(
      eventFromUnknownInput(stackParser, error || msg, void 0, attachStacktrace, false),
      url2,
      line,
      column
    );
    event.level = "error";
    captureEvent(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: "onerror"
      }
    });
  });
}
function _installGlobalOnUnhandledRejectionHandler(client2) {
  addGlobalUnhandledRejectionInstrumentationHandler((e) => {
    const { stackParser, attachStacktrace } = getOptions();
    if (getClient() !== client2 || shouldIgnoreOnError()) {
      return;
    }
    const error = _getUnhandledRejectionError(e);
    const event = isPrimitive(error) ? _eventFromRejectionWithPrimitive(error) : eventFromUnknownInput(stackParser, error, void 0, attachStacktrace, true);
    event.level = "error";
    captureEvent(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: "onunhandledrejection"
      }
    });
  });
}
function _getUnhandledRejectionError(error) {
  if (isPrimitive(error)) {
    return error;
  }
  const e = error;
  try {
    if ("reason" in e) {
      return e.reason;
    } else if ("detail" in e && "reason" in e.detail) {
      return e.detail.reason;
    }
  } catch (e2) {
  }
  return error;
}
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`
        }
      ]
    }
  };
}
function _eventFromIncompleteOnError(msg, url2, line, column) {
  const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
  let message = isErrorEvent(msg) ? msg.message : msg;
  let name2 = "Error";
  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name2 = groups[1];
    message = groups[2];
  }
  const event = {
    exception: {
      values: [
        {
          type: name2,
          value: message
        }
      ]
    }
  };
  return _enhanceEventWithInitialFrame(event, url2, line, column);
}
function _enhanceEventWithInitialFrame(event, url2, line, column) {
  const e = event.exception = event.exception || {};
  const ev = e.values = e.values || [];
  const ev0 = ev[0] = ev[0] || {};
  const ev0s = ev0.stacktrace = ev0.stacktrace || {};
  const ev0sf = ev0s.frames = ev0s.frames || [];
  const colno = isNaN(parseInt(column, 10)) ? void 0 : column;
  const lineno = isNaN(parseInt(line, 10)) ? void 0 : line;
  const filename = isString(url2) && url2.length > 0 ? url2 : getLocationHref();
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: "?",
      in_app: true,
      lineno
    });
  }
  return event;
}
function globalHandlerLog(type) {
  DEBUG_BUILD$1 && logger$2.log(`Global Handler attached: ${type}`);
}
function getOptions() {
  const client2 = getClient();
  const options = client2 && client2.getOptions() || {
    stackParser: () => [],
    attachStacktrace: false
  };
  return options;
}
const INTEGRATION_NAME$2 = "HttpContext";
const _httpContextIntegration = () => {
  return {
    name: INTEGRATION_NAME$2,
    // TODO v8: Remove this
    setupOnce() {
    },
    // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent(event) {
      if (!WINDOW.navigator && !WINDOW.location && !WINDOW.document) {
        return;
      }
      const url2 = event.request && event.request.url || WINDOW.location && WINDOW.location.href;
      const { referrer } = WINDOW.document || {};
      const { userAgent } = WINDOW.navigator || {};
      const headers = {
        ...event.request && event.request.headers,
        ...referrer && { Referer: referrer },
        ...userAgent && { "User-Agent": userAgent }
      };
      const request = { ...event.request, ...url2 && { url: url2 }, headers };
      event.request = request;
    }
  };
};
const httpContextIntegration = defineIntegration(_httpContextIntegration);
convertIntegrationFnToClass(INTEGRATION_NAME$2, httpContextIntegration);
const DEFAULT_KEY = "cause";
const DEFAULT_LIMIT = 5;
const INTEGRATION_NAME$1 = "LinkedErrors";
const _linkedErrorsIntegration = (options = {}) => {
  const limit = options.limit || DEFAULT_LIMIT;
  const key = options.key || DEFAULT_KEY;
  return {
    name: INTEGRATION_NAME$1,
    // TODO v8: Remove this
    setupOnce() {
    },
    // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent(event, hint, client2) {
      const options2 = client2.getOptions();
      applyAggregateErrorsToEvent(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        exceptionFromError,
        options2.stackParser,
        options2.maxValueLength,
        key,
        limit,
        event,
        hint
      );
    }
  };
};
const linkedErrorsIntegration = defineIntegration(_linkedErrorsIntegration);
convertIntegrationFnToClass(INTEGRATION_NAME$1, linkedErrorsIntegration);
const DEFAULT_EVENT_TARGET = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "BroadcastChannel",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "SharedWorker",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
];
const INTEGRATION_NAME = "TryCatch";
const _browserApiErrorsIntegration = (options = {}) => {
  const _options = {
    XMLHttpRequest: true,
    eventTarget: true,
    requestAnimationFrame: true,
    setInterval: true,
    setTimeout: true,
    ...options
  };
  return {
    name: INTEGRATION_NAME,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      if (_options.setTimeout) {
        fill(WINDOW, "setTimeout", _wrapTimeFunction);
      }
      if (_options.setInterval) {
        fill(WINDOW, "setInterval", _wrapTimeFunction);
      }
      if (_options.requestAnimationFrame) {
        fill(WINDOW, "requestAnimationFrame", _wrapRAF);
      }
      if (_options.XMLHttpRequest && "XMLHttpRequest" in WINDOW) {
        fill(XMLHttpRequest.prototype, "send", _wrapXHR);
      }
      const eventTargetOption = _options.eventTarget;
      if (eventTargetOption) {
        const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
        eventTarget.forEach(_wrapEventTarget);
      }
    }
  };
};
const browserApiErrorsIntegration = defineIntegration(_browserApiErrorsIntegration);
convertIntegrationFnToClass(
  INTEGRATION_NAME,
  browserApiErrorsIntegration
);
function _wrapTimeFunction(original) {
  return function(...args) {
    const originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: getFunctionName(original) },
        handled: false,
        type: "instrument"
      }
    });
    return original.apply(this, args);
  };
}
function _wrapRAF(original) {
  return function(callback) {
    return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: getFunctionName(original)
          },
          handled: false,
          type: "instrument"
        }
      })
    ]);
  };
}
function _wrapXHR(originalSend) {
  return function(...args) {
    const xhr = this;
    const xmlHttpRequestProps = ["onload", "onerror", "onprogress", "onreadystatechange"];
    xmlHttpRequestProps.forEach((prop) => {
      if (prop in xhr && typeof xhr[prop] === "function") {
        fill(xhr, prop, function(original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: getFunctionName(original)
              },
              handled: false,
              type: "instrument"
            }
          };
          const originalFunction = getOriginalFunction(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = getFunctionName(originalFunction);
          }
          return wrap(original, wrapOptions);
        });
      }
    });
    return originalSend.apply(this, args);
  };
}
function _wrapEventTarget(target) {
  const globalObject = WINDOW;
  const proto = globalObject[target] && globalObject[target].prototype;
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) {
    return;
  }
  fill(proto, "addEventListener", function(original) {
    return function(eventName, fn, options) {
      try {
        if (typeof fn.handleEvent === "function") {
          fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: "handleEvent",
                handler: getFunctionName(fn),
                target
              },
              handled: false,
              type: "instrument"
            }
          });
        }
      } catch (err) {
      }
      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        wrap(fn, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: getFunctionName(fn),
              target
            },
            handled: false,
            type: "instrument"
          }
        }),
        options
      ]);
    };
  });
  fill(
    proto,
    "removeEventListener",
    function(originalRemoveEventListener) {
      return function(eventName, fn, options) {
        const wrappedEventHandler = fn;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    }
  );
}
[
  inboundFiltersIntegration(),
  functionToStringIntegration(),
  browserApiErrorsIntegration(),
  breadcrumbsIntegration(),
  globalHandlersIntegration(),
  linkedErrorsIntegration(),
  dedupeIntegration(),
  httpContextIntegration()
];
const showReportDialog = (options = {}, hub = getCurrentHub()) => {
  if (!WINDOW.document) {
    DEBUG_BUILD$1 && logger$2.error("Global document not defined in showReportDialog call");
    return;
  }
  const { client: client2, scope } = hub.getStackTop();
  const dsn = options.dsn || client2 && client2.getDsn();
  if (!dsn) {
    DEBUG_BUILD$1 && logger$2.error("DSN not configured for showReportDialog call");
    return;
  }
  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user
    };
  }
  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }
  const script = WINDOW.document.createElement("script");
  script.async = true;
  script.crossOrigin = "anonymous";
  script.src = getReportDialogEndpoint(dsn, options);
  if (options.onLoad) {
    script.onload = options.onLoad;
  }
  const { onClose } = options;
  if (onClose) {
    const reportDialogClosedMessageHandler = (event) => {
      if (event.data === "__sentry_reportdialog_closed__") {
        try {
          onClose();
        } finally {
          WINDOW.removeEventListener("message", reportDialogClosedMessageHandler);
        }
      }
    };
    WINDOW.addEventListener("message", reportDialogClosedMessageHandler);
  }
  const injectionPoint = WINDOW.document.head || WINDOW.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    DEBUG_BUILD$1 && logger$2.error("Not injecting report dialog. No injection point found in HTML");
  }
};
var reactIs = requireReactIs();
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
function isAtLeastReact17(version2) {
  const major = version2.match(/^([^.]+)/);
  return major !== null && parseInt(major[0]) >= 17;
}
const INITIAL_STATE = {
  componentStack: null,
  error: null,
  eventId: null
};
function setCause(error, cause) {
  const seenErrors = /* @__PURE__ */ new WeakMap();
  function recurse(error2, cause2) {
    if (seenErrors.has(error2)) {
      return;
    }
    if (error2.cause) {
      seenErrors.set(error2, true);
      return recurse(error2.cause, cause2);
    }
    error2.cause = cause2;
  }
  recurse(error, cause);
}
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    ErrorBoundary.prototype.__init.call(this);
    this.state = INITIAL_STATE;
    this._openFallbackReportDialog = true;
    const client2 = getClient();
    if (client2 && client2.on && props.showDialog) {
      this._openFallbackReportDialog = false;
      client2.on("afterSendEvent", (event) => {
        if (!event.type && event.event_id === this._lastEventId) {
          showReportDialog({ ...props.dialogOptions, eventId: this._lastEventId });
        }
      });
    }
  }
  componentDidCatch(error, { componentStack }) {
    const { beforeCapture, onError, showDialog, dialogOptions } = this.props;
    withScope((scope) => {
      if (isAtLeastReact17(React.version) && isError(error)) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        setCause(error, errorBoundaryError);
      }
      if (beforeCapture) {
        beforeCapture(scope, error, componentStack);
      }
      const eventId = captureException(error, {
        captureContext: {
          contexts: { react: { componentStack } }
        },
        // If users provide a fallback component we can assume they are handling the error.
        // Therefore, we set the mechanism depending on the presence of the fallback prop.
        mechanism: { handled: !!this.props.fallback }
      });
      if (onError) {
        onError(error, componentStack, eventId);
      }
      if (showDialog) {
        this._lastEventId = eventId;
        if (this._openFallbackReportDialog) {
          showReportDialog({ ...dialogOptions, eventId });
        }
      }
      this.setState({ error, componentStack, eventId });
    });
  }
  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) {
      onMount();
    }
  }
  componentWillUnmount() {
    const { error, componentStack, eventId } = this.state;
    const { onUnmount } = this.props;
    if (onUnmount) {
      onUnmount(error, componentStack, eventId);
    }
  }
  __init() {
    this.resetErrorBoundary = () => {
      const { onReset } = this.props;
      const { error, componentStack, eventId } = this.state;
      if (onReset) {
        onReset(error, componentStack, eventId);
      }
      this.setState(INITIAL_STATE);
    };
  }
  render() {
    const { fallback, children } = this.props;
    const state = this.state;
    if (state.error) {
      let element = void 0;
      if (typeof fallback === "function") {
        element = fallback({
          error: state.error,
          componentStack: state.componentStack,
          resetError: this.resetErrorBoundary,
          eventId: state.eventId
        });
      } else {
        element = fallback;
      }
      if (React.isValidElement(element)) {
        return element;
      }
      if (fallback) {
        DEBUG_BUILD && logger$2.warn("fallback did not produce a valid ReactElement");
      }
      return null;
    }
    if (typeof children === "function") {
      return children();
    }
    return children;
  }
}
var objectProto$6 = Object.prototype;
function isPrototype$2(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$6;
  return value === proto;
}
var _isPrototype = isPrototype$2;
function overArg$1(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$1;
var overArg = _overArg;
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype$1 = _isPrototype, nativeKeys = _nativeKeys;
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
function baseKeys$1(object) {
  if (!isPrototype$1(object)) {
    return nativeKeys(object);
  }
  var result2 = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$4.call(object, key) && key != "constructor") {
      result2.push(key);
    }
  }
  return result2;
}
var _baseKeys = baseKeys$1;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$8 = freeGlobal || freeSelf || Function("return this")();
var _root = root$8;
var root$7 = _root;
var Symbol$3 = root$7.Symbol;
var _Symbol = Symbol$3;
var Symbol$2 = _Symbol;
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
var nativeObjectToString$1 = objectProto$4.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$3.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result2 = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result2;
}
var _getRawTag = getRawTag$1;
var objectProto$3 = Object.prototype;
var nativeObjectToString = objectProto$3.toString;
function objectToString$2(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$2;
var Symbol$1 = _Symbol, getRawTag = _getRawTag, objectToString$1 = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag$4(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString$1(value);
}
var _baseGetTag = baseGetTag$4;
function isObject$2(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$2;
var baseGetTag$3 = _baseGetTag, isObject$1 = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$3(value) {
  if (!isObject$1(value)) {
    return false;
  }
  var tag = baseGetTag$3(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$3;
var root$6 = _root;
var coreJsData$1 = root$6["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$2 = isFunction_1, isMasked = _isMasked, isObject = isObject_1, toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$2 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(object, key) {
  return object == null ? void 0 : object[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$5(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$5;
var getNative$4 = _getNative, root$5 = _root;
var DataView$1 = getNative$4(root$5, "DataView");
var _DataView = DataView$1;
var getNative$3 = _getNative, root$4 = _root;
var Map$2 = getNative$3(root$4, "Map");
var _Map = Map$2;
var getNative$2 = _getNative, root$3 = _root;
var Promise$2 = getNative$2(root$3, "Promise");
var _Promise = Promise$2;
var getNative$1 = _getNative, root$2 = _root;
var Set$2 = getNative$1(root$2, "Set");
var _Set = Set$2;
var getNative = _getNative, root$1 = _root;
var WeakMap$2 = getNative(root$1, "WeakMap");
var _WeakMap = WeakMap$2;
var DataView = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap$1 = _WeakMap, baseGetTag$2 = _baseGetTag, toSource = _toSource;
var mapTag$2 = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag$2 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$1 = "[object DataView]";
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1);
var getTag$1 = baseGetTag$2;
if (DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag$1 || Map$1 && getTag$1(new Map$1()) != mapTag$2 || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag$2 || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag$1) {
  getTag$1 = function(value) {
    var result2 = baseGetTag$2(value), Ctor = result2 == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;
        case mapCtorString:
          return mapTag$2;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$2;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result2;
  };
}
var _getTag = getTag$1;
function isObjectLike$3(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$3;
var baseGetTag$1 = _baseGetTag, isObjectLike$2 = isObjectLike_1;
var argsTag$1 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$2(value) && baseGetTag$1(value) == argsTag$1;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$1 = isObjectLike_1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;
var isArguments$1 = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$1(value) && hasOwnProperty$1.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
var isArguments_1 = isArguments$1;
var isArray$2 = Array.isArray;
var isArray_1 = isArray$2;
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength$2(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$2;
var isFunction$1 = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$1(value) {
  return value != null && isLength$1(value.length) && !isFunction$1(value);
}
var isArrayLike_1 = isArrayLike$1;
var isBuffer$1 = { exports: {} };
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
isBuffer$1.exports;
(function(module, exports) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer2 = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  module.exports = isBuffer2;
})(isBuffer$1, isBuffer$1.exports);
var isBufferExports = isBuffer$1.exports;
var baseGetTag = _baseGetTag, isLength = isLength_1, isObjectLike = isObjectLike_1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$1(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$1;
var _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(module, exports) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports;
var baseIsTypedArray = _baseIsTypedArray, baseUnary = _baseUnary, nodeUtil = _nodeUtilExports;
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray$1 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$1;
var baseKeys = _baseKeys, getTag = _getTag, isArguments = isArguments_1, isArray$1 = isArray_1, isArrayLike = isArrayLike_1, isBuffer = isBufferExports, isPrototype = _isPrototype, isTypedArray = isTypedArray_1;
var mapTag = "[object Map]", setTag = "[object Set]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray$1(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}
var isEmpty_1 = isEmpty;
const isEmpty$1 = /* @__PURE__ */ getDefaultExportFromCjs(isEmpty_1);
const isChatParticipantDataValid = (chatParticipantData) => {
  if (!chatParticipantData) {
    return false;
  }
  const { participantName, participantIdNumber, planName, planNumber } = chatParticipantData;
  return Boolean(participantName && participantIdNumber && planName && planNumber);
};
const EnterpriseChat = React__default.lazy(() => import("./EnterpriseChat-BQCtvUnA.js"));
const { isUndefinedOrNull: isUndefinedOrNull$f } = ObjectUtil;
const ENTERPRISE_CHAT_DETAILS_DEFAULT = {};
const EnterpriseChatContainer = (props) => {
  var _a2;
  const { chatParticipantData, isEmulator } = props;
  const { accuCustomization: accuCustomization2, translations } = useSelector((state) => state.shared);
  const { authenticated: authenticated2 } = useSelector((state) => state.shared.authenticationStatus);
  const { chatBotEnable, liveChatEnable } = useSelector(
    (state) => state.header.txnAccess
  );
  if (isUndefinedOrNull$f(translations)) return null;
  const enterpriseChatCustomization = (accuCustomization2 == null ? void 0 : accuCustomization2.enterpriseChat) || ENTERPRISE_CHAT_DETAILS_DEFAULT;
  if (isEmpty$1(enterpriseChatCustomization)) {
    return null;
  }
  const chatParticipantDataValid = isChatParticipantDataValid(chatParticipantData);
  const isPAE = ((_a2 = globalThis.integratedEligibility) == null ? void 0 : _a2.type) !== ReferenceData.USER_TYPE_PARTICIPANT;
  if (!authenticated2 || isEmulator || isPAE || !liveChatEnable && !chatBotEnable || !chatParticipantDataValid) {
    return null;
  }
  const translationsEnterpriseChat = translations.footer.enterpriseChat;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "loadingEnterpriseChat" }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    EnterpriseChat,
    {
      enterpriseChatCustomization,
      chatParticipantData,
      chatBotEnable,
      liveChatEnable,
      translationsEnterpriseChat
    }
  ) }) });
};
const WrapperEnterpriseChat = ({
  chatParticipantData,
  chatBotEnable,
  liveChatEnable,
  enterpriseChatEnable
}) => {
  const [showEnterpriseChatLegacy, setShowEnterpriseChatLegacy] = useState(false);
  const [isEmulator, setIsEmulator] = useState(false);
  useEffect(() => {
    setIsEmulator(isEmulatorUser());
  }, [globalThis.integratedEligibility, globalThis.integratedEligibility.isEmulator]);
  useEffect(() => {
    const showLiveChatOrChatBot = !isEmulator && (chatBotEnable || liveChatEnable);
    setShowEnterpriseChatLegacy(!enterpriseChatEnable && showLiveChatOrChatBot);
  }, [chatBotEnable, liveChatEnable, enterpriseChatEnable, isEmulator]);
  return showEnterpriseChatLegacy ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    EnterpriseChatContainer,
    {
      chatParticipantData,
      isEmulator
    }
  ) : null;
};
const DEFAULT_TIMEZONE = "MST";
const TIME_ZONES = {
  HST: "HST",
  HDT: "HST",
  AKT: "AKT",
  ADT: "AKT",
  AKDT: "AKT",
  PST: "PST",
  PDT: "PST",
  MST: "MST",
  MDT: "MST",
  CST: "CST",
  CDT: "CST",
  EST: "EST",
  EDT: "EST"
};
const browserTimeZoneCode = (/* @__PURE__ */ new Date()).toLocaleTimeString("en-us", { timeZoneName: "short" }).split(" ")[2];
const useTimeZone = () => {
  const timeZone = useSelector((state) => state.shared.siteContactInfo.timeZone);
  if (TIME_ZONES[browserTimeZoneCode]) {
    return TIME_ZONES[browserTimeZoneCode];
  }
  if (timeZone && TIME_ZONES[timeZone]) {
    return timeZone;
  }
  return DEFAULT_TIMEZONE;
};
const getRemoteComponent = (src) => {
  return axios.get(src).then((res) => res.data).catch((err) => console.log(err));
};
const CONTACT_MODAL_SRC = "contactModalSrc";
const FEEDBACK_MODAL_SRC = "feedbackModalSrc";
const CLASS_CONTACT_SUBLINKS = "contact-sublinks";
const CLASS_CONTACT_US_LINK_INLINE = "btn btn-link no-padding contactus-inline-link";
const CLASS_PHONE_NOT_LINK = "phone not-link";
const CLASS_PHONE_ALIAS = "phone-alias";
const CLASS_SUPPORT_TITLE = "support-title";
const CLASS_UL_NEED_HELP_LIST_LINKS = "list-inline with-rules";
const ENTER = ["Enter"];
const ESCAPE = ["Escape"];
const ENTER_OR_SPACE = ["Enter", " "];
const keyboardInteractions = {
  link: ENTER,
  escapeKey: ESCAPE,
  button: ENTER_OR_SPACE,
  menuItem: ENTER_OR_SPACE
};
const handleKeyboardDownEvent = ({ event, keys, output }) => {
  if (event.key === " ") {
    event.preventDefault();
  }
  if (keys.includes(event.key)) {
    output();
  }
};
const queryFocusableElements = '[tabindex="0"], a:not([tabindex="-1"]), button:not([tabindex="-1"]), input:not([tabindex="-1"]), textarea:not([tabindex="-1"]), select:not([tabindex="-1"]), details:not([tabindex="-1"])';
const extractGroupId = (HTMLElementId) => {
  const getPosition = (mainstring, substring, pos) => {
    let len = pos;
    if (mainstring.split(substring).length > 3) {
      len = 3;
    }
    return mainstring.split(substring, len).join(substring).length;
  };
  return HTMLElementId.substring(0, getPosition(HTMLElementId, "-", 2));
};
const ContactUsPostLogin = ({ openFooterModal, timeZone, phone, alias, isTaxable }) => {
  var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa, _ta, _ua, _va, _wa, _xa, _ya, _za, _Aa;
  const { translations } = useSelector((state) => state.shared);
  const handleOpenContactModal = () => {
    openFooterModal({ modalType: CONTACT_MODAL_SRC });
  };
  const handleOpenContactModalKeyDown = (event) => {
    handleKeyboardDownEvent({
      event,
      keys: keyboardInteractions.button,
      output: handleOpenContactModal
    });
  };
  const handleFeedbackModal = useCallback(() => {
    if (isTaxable) return null;
    openFooterModal({ modalType: FEEDBACK_MODAL_SRC });
  }, [isTaxable, openFooterModal]);
  const handleFeedbackModalKeyDown = (event) => {
    handleKeyboardDownEvent({
      event,
      keys: keyboardInteractions.button,
      output: handleFeedbackModal
    });
  };
  useEffect(() => {
    document.addEventListener("openFeedbackModalFromSearchboxEvent", handleFeedbackModal);
    return () => {
      document.removeEventListener(
        "openFeedbackModalFromSearchboxEvent",
        handleFeedbackModal
      );
    };
  }, [handleFeedbackModal]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    ((_c2 = (_b2 = (_a2 = translations == null ? void 0 : translations.footer) == null ? void 0 : _a2.customerSupport) == null ? void 0 : _b2.postLoginSection) == null ? void 0 : _c2.supportTitle) && /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: CLASS_SUPPORT_TITLE, children: (_f2 = (_e2 = (_d2 = translations == null ? void 0 : translations.footer) == null ? void 0 : _d2.customerSupport) == null ? void 0 : _e2.postLoginSection) == null ? void 0 : _f2.supportTitle }),
    (((_i2 = (_h2 = (_g2 = translations == null ? void 0 : translations.footer) == null ? void 0 : _g2.customerSupport) == null ? void 0 : _h2.postLoginSection) == null ? void 0 : _i2.supportSubTitle) || ((_l = (_k = (_j2 = translations == null ? void 0 : translations.footer) == null ? void 0 : _j2.customerSupport) == null ? void 0 : _k.postLoginSection) == null ? void 0 : _l.availableDaysText)) && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      parse(
        ((_o = (_n = (_m = translations == null ? void 0 : translations.footer) == null ? void 0 : _m.customerSupport) == null ? void 0 : _n.postLoginSection) == null ? void 0 : _o.supportSubTitle) || "",
        {}
      ),
      ((_r = (_q = (_p = translations == null ? void 0 : translations.footer) == null ? void 0 : _p.customerSupport) == null ? void 0 : _q.postLoginSection) == null ? void 0 : _r.contactUsLink) && /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: handleOpenContactModal,
          onKeyDown: handleOpenContactModalKeyDown,
          className: CLASS_CONTACT_US_LINK_INLINE,
          children: ` ${(_u = (_t = (_s = translations == null ? void 0 : translations.footer) == null ? void 0 : _s.customerSupport) == null ? void 0 : _t.postLoginSection) == null ? void 0 : _u.contactUsLink} `
        }
      ),
      ((_x = (_w = (_v = translations == null ? void 0 : translations.footer) == null ? void 0 : _v.customerSupport) == null ? void 0 : _w.postLoginSection) == null ? void 0 : _x.availableDaysText) && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
        (_A = (_z = (_y = translations == null ? void 0 : translations.footer) == null ? void 0 : _y.customerSupport) == null ? void 0 : _z.postLoginSection) == null ? void 0 : _A.availableDaysText,
        " "
      ] }),
      ((_D = (_C = (_B = translations == null ? void 0 : translations.footer) == null ? void 0 : _B.customerSupport) == null ? void 0 : _C.postLoginSection) == null ? void 0 : _D.useTimeZone) && timeZone && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
        timeZone,
        "."
      ] })
    ] }),
    (((_G = (_F = (_E = translations == null ? void 0 : translations.footer) == null ? void 0 : _E.customerSupport) == null ? void 0 : _F.postLoginSection) == null ? void 0 : _G.phoneNumber) || phone) && /* @__PURE__ */ jsxRuntimeExports.jsx("section", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: CLASS_PHONE_NOT_LINK, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: ((_J = (_I = (_H = translations == null ? void 0 : translations.footer) == null ? void 0 : _H.customerSupport) == null ? void 0 : _I.postLoginSection) == null ? void 0 : _J.phoneNumber) || phone }),
      (alias || ((_M = (_L = (_K = translations == null ? void 0 : translations.footer) == null ? void 0 : _K.customerSupport) == null ? void 0 : _L.postLoginSection) == null ? void 0 : _M.phoneAlias)) && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: CLASS_PHONE_ALIAS, children: alias ?? ((_P = (_O = (_N = translations == null ? void 0 : translations.footer) == null ? void 0 : _N.customerSupport) == null ? void 0 : _O.postLoginSection) == null ? void 0 : _P.phoneAlias) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: CLASS_CONTACT_SUBLINKS, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { className: CLASS_UL_NEED_HELP_LIST_LINKS, children: [
      ((_S = (_R = (_Q = translations == null ? void 0 : translations.footer) == null ? void 0 : _Q.customerSupport) == null ? void 0 : _R.postLoginSection) == null ? void 0 : _S.additionalHelpText) && /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          role: "button",
          tabIndex: 0,
          onClick: handleFeedbackModal,
          onKeyDown: handleFeedbackModalKeyDown,
          children: (_V = (_U = (_T = translations == null ? void 0 : translations.footer) == null ? void 0 : _T.customerSupport) == null ? void 0 : _U.postLoginSection) == null ? void 0 : _V.additionalHelpText
        }
      ) }),
      ((_Y = (_X = (_W = translations == null ? void 0 : translations.footer) == null ? void 0 : _W.customerSupport) == null ? void 0 : _X.postLoginSection) == null ? void 0 : _Y.contactUsItem) && /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          href: (_aa = (_$ = (__ = (_Z = translations == null ? void 0 : translations.footer) == null ? void 0 : _Z.customerSupport) == null ? void 0 : __.postLoginSection) == null ? void 0 : _$.contactUsItem) == null ? void 0 : _aa.href,
          target: "_blank",
          rel: "noreferrer",
          children: (_ea = (_da = (_ca = (_ba = translations == null ? void 0 : translations.footer) == null ? void 0 : _ba.customerSupport) == null ? void 0 : _ca.postLoginSection) == null ? void 0 : _da.contactUsItem) == null ? void 0 : _ea.text
        }
      ) }),
      ((_ha = (_ga = (_fa = translations == null ? void 0 : translations.footer) == null ? void 0 : _fa.customerSupport) == null ? void 0 : _ga.postLoginSection) == null ? void 0 : _ha.emailItem) && /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          target: "_top",
          href: (_la = (_ka = (_ja = (_ia = translations == null ? void 0 : translations.footer) == null ? void 0 : _ia.customerSupport) == null ? void 0 : _ja.postLoginSection) == null ? void 0 : _ka.emailItem) == null ? void 0 : _la.href,
          children: (_pa = (_oa = (_na = (_ma = translations == null ? void 0 : translations.footer) == null ? void 0 : _ma.customerSupport) == null ? void 0 : _na.postLoginSection) == null ? void 0 : _oa.emailItem) == null ? void 0 : _pa.text
        }
      ) })
    ] }) }),
    ((_sa = (_ra = (_qa = translations == null ? void 0 : translations.footer) == null ? void 0 : _qa.customerSupport) == null ? void 0 : _ra.postLoginSection) == null ? void 0 : _sa.appLogos) && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "app-logo", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        href: (_wa = (_va = (_ua = (_ta = translations == null ? void 0 : translations.footer) == null ? void 0 : _ta.customerSupport) == null ? void 0 : _ua.postLoginSection) == null ? void 0 : _va.appLogos) == null ? void 0 : _wa.href,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            className: "app-logos",
            src: (_Aa = (_za = (_ya = (_xa = translations == null ? void 0 : translations.footer) == null ? void 0 : _xa.customerSupport) == null ? void 0 : _ya.postLoginSection) == null ? void 0 : _za.appLogos) == null ? void 0 : _Aa.imgSrc,
            alt: "App Logos"
          }
        )
      }
    ) })
  ] });
};
const getPhonePreLogin = ({ alias, phone, translations }) => {
  var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J;
  let phonePreLoginObj = {};
  let phoneNumberText = null;
  let phoneNumberLink = null;
  let phoneNumberAliasText = null;
  let phoneNumberAliasLink = null;
  const usePhoneAliasService = ((_c2 = (_b2 = (_a2 = translations == null ? void 0 : translations.footer) == null ? void 0 : _a2.customerSupport) == null ? void 0 : _b2.preLoginSection) == null ? void 0 : _c2.usePhoneAliasService) ?? true;
  if ((_f2 = (_e2 = (_d2 = translations == null ? void 0 : translations.footer) == null ? void 0 : _d2.customerSupport) == null ? void 0 : _e2.preLoginOverridePhoneNumberData) == null ? void 0 : _f2.phoneNumberText) {
    phoneNumberText = (_i2 = (_h2 = (_g2 = translations == null ? void 0 : translations.footer) == null ? void 0 : _g2.customerSupport) == null ? void 0 : _h2.preLoginOverridePhoneNumberData) == null ? void 0 : _i2.phoneNumberText;
    phoneNumberLink = (_l = (_k = (_j2 = translations == null ? void 0 : translations.footer) == null ? void 0 : _j2.customerSupport) == null ? void 0 : _k.preLoginOverridePhoneNumberData) == null ? void 0 : _l.phoneNumberLink;
    phoneNumberAliasText = ((_o = (_n = (_m = translations == null ? void 0 : translations.footer) == null ? void 0 : _m.customerSupport) == null ? void 0 : _n.preLoginOverridePhoneNumberData) == null ? void 0 : _o.phoneNumberAliasText) || null;
    phoneNumberAliasLink = ((_r = (_q = (_p = translations == null ? void 0 : translations.footer) == null ? void 0 : _p.customerSupport) == null ? void 0 : _q.preLoginOverridePhoneNumberData) == null ? void 0 : _r.phoneNumberAliasLink) || null;
  } else {
    phoneNumberText = ((_u = (_t = (_s = translations == null ? void 0 : translations.footer) == null ? void 0 : _s.customerSupport) == null ? void 0 : _t.preLoginSection) == null ? void 0 : _u.phoneNumber) || phone;
    phoneNumberLink = ((_x = (_w = (_v = translations == null ? void 0 : translations.footer) == null ? void 0 : _v.customerSupport) == null ? void 0 : _w.preLoginSection) == null ? void 0 : _x.phoneNumber) || phone;
    if ((_A = (_z = (_y = translations == null ? void 0 : translations.footer) == null ? void 0 : _y.customerSupport) == null ? void 0 : _z.preLoginSection) == null ? void 0 : _A.phoneAlias) {
      phoneNumberAliasText = (_D = (_C = (_B = translations == null ? void 0 : translations.footer) == null ? void 0 : _B.customerSupport) == null ? void 0 : _C.preLoginSection) == null ? void 0 : _D.phoneAlias;
      phoneNumberAliasLink = (_G = (_F = (_E = translations == null ? void 0 : translations.footer) == null ? void 0 : _E.customerSupport) == null ? void 0 : _F.preLoginSection) == null ? void 0 : _G.phoneAlias;
    } else if (alias && !((_J = (_I = (_H = translations == null ? void 0 : translations.footer) == null ? void 0 : _H.customerSupport) == null ? void 0 : _I.preLoginSection) == null ? void 0 : _J.phoneAliasText) && usePhoneAliasService) {
      phoneNumberAliasText = alias;
      phoneNumberAliasLink = alias;
    }
  }
  phonePreLoginObj = {
    phoneNumberText,
    phoneNumberLink,
    phoneNumberAliasText,
    phoneNumberAliasLink
  };
  return phonePreLoginObj;
};
const { isUndefinedOrNull: isUndefinedOrNull$e } = ObjectUtil;
const PhonePreLogin = ({ alias, phone, translations }) => {
  const phonePreLoginObj = getPhonePreLogin({ alias, phone, translations });
  if (isUndefinedOrNull$e(phonePreLoginObj.phoneNumberText)) return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("section", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: CLASS_PHONE_NOT_LINK, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: phonePreLoginObj.phoneNumberText }),
    phonePreLoginObj.phoneNumberAliasText ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: CLASS_PHONE_ALIAS, children: phonePreLoginObj.phoneNumberAliasText }) : null
  ] }) });
};
const ContactUsPreLogin = ({ alias, openFooterModal, phone, timeZone }) => {
  var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma;
  const { translations } = useSelector((state) => state.shared);
  const handleOpenContactModal = () => {
    var _a3, _b3, _c3, _d3, _e3, _f3;
    if ((_c3 = (_b3 = (_a3 = translations == null ? void 0 : translations.footer) == null ? void 0 : _a3.customerSupport) == null ? void 0 : _b3.preLoginSection) == null ? void 0 : _c3.contactUsUrl) {
      window.location.href = (_f3 = (_e3 = (_d3 = translations == null ? void 0 : translations.footer) == null ? void 0 : _d3.customerSupport) == null ? void 0 : _e3.preLoginSection) == null ? void 0 : _f3.contactUsUrl;
    } else {
      openFooterModal({ modalType: CONTACT_MODAL_SRC });
    }
  };
  const handleOpenContactModalKeyDown = (event) => {
    handleKeyboardDownEvent({
      event,
      keys: keyboardInteractions.button,
      output: handleOpenContactModal
    });
  };
  const supportSubTitle = parse(
    ((_c2 = (_b2 = (_a2 = translations == null ? void 0 : translations.footer) == null ? void 0 : _a2.customerSupport) == null ? void 0 : _b2.preLoginSection) == null ? void 0 : _c2.supportSubTitle) || "",
    {}
  );
  const urlIsFreemium = () => {
    return window.location.href.includes("loginPart");
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    ((_f2 = (_e2 = (_d2 = translations == null ? void 0 : translations.footer) == null ? void 0 : _d2.customerSupport) == null ? void 0 : _e2.preLoginSection) == null ? void 0 : _f2.supportTitle) && /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: CLASS_SUPPORT_TITLE, children: (_i2 = (_h2 = (_g2 = translations == null ? void 0 : translations.footer) == null ? void 0 : _g2.customerSupport) == null ? void 0 : _h2.preLoginSection) == null ? void 0 : _i2.supportTitle }),
    (((_l = (_k = (_j2 = translations == null ? void 0 : translations.footer) == null ? void 0 : _j2.customerSupport) == null ? void 0 : _k.preLoginSection) == null ? void 0 : _l.supportSubTitle) || ((_o = (_n = (_m = translations == null ? void 0 : translations.footer) == null ? void 0 : _m.customerSupport) == null ? void 0 : _n.preLoginSection) == null ? void 0 : _o.availableDaysText)) && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      supportSubTitle,
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: handleOpenContactModal,
          onKeyDown: handleOpenContactModalKeyDown,
          className: CLASS_CONTACT_US_LINK_INLINE,
          children: `${(_r = (_q = (_p = translations == null ? void 0 : translations.footer) == null ? void 0 : _p.customerSupport) == null ? void 0 : _q.preLoginSection) == null ? void 0 : _r.contactUsLink}`
        }
      ),
      ((_u = (_t = (_s = translations == null ? void 0 : translations.footer) == null ? void 0 : _s.customerSupport) == null ? void 0 : _t.preLoginSection) == null ? void 0 : _u.availableDaysText) && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
        (_x = (_w = (_v = translations == null ? void 0 : translations.footer) == null ? void 0 : _v.customerSupport) == null ? void 0 : _w.preLoginSection) == null ? void 0 : _x.availableDaysText,
        " "
      ] }),
      ((_A = (_z = (_y = translations == null ? void 0 : translations.footer) == null ? void 0 : _y.customerSupport) == null ? void 0 : _z.preLoginSection) == null ? void 0 : _A.useTimeZone) && timeZone && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
        timeZone,
        "."
      ] })
    ] }),
    !urlIsFreemium() && /* @__PURE__ */ jsxRuntimeExports.jsx(PhonePreLogin, { alias, phone, translations }),
    ((_D = (_C = (_B = translations == null ? void 0 : translations.footer) == null ? void 0 : _B.customerSupport) == null ? void 0 : _C.preLoginSection) == null ? void 0 : _D.phoneAliasText) && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: (_G = (_F = (_E = translations == null ? void 0 : translations.footer) == null ? void 0 : _E.customerSupport) == null ? void 0 : _F.preLoginSection) == null ? void 0 : _G.phoneAliasText }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: CLASS_CONTACT_SUBLINKS, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { className: CLASS_UL_NEED_HELP_LIST_LINKS, children: [
      ((_J = (_I = (_H = translations == null ? void 0 : translations.footer) == null ? void 0 : _H.customerSupport) == null ? void 0 : _I.preLoginSection) == null ? void 0 : _J.faqText) && ((_M = (_L = (_K = translations == null ? void 0 : translations.footer) == null ? void 0 : _K.customerSupport) == null ? void 0 : _L.preLoginSection) == null ? void 0 : _M.faqLink) && /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          href: (_P = (_O = (_N = translations == null ? void 0 : translations.footer) == null ? void 0 : _N.customerSupport) == null ? void 0 : _O.preLoginSection) == null ? void 0 : _P.faqLink,
          children: (_S = (_R = (_Q = translations == null ? void 0 : translations.footer) == null ? void 0 : _Q.customerSupport) == null ? void 0 : _R.preLoginSection) == null ? void 0 : _S.faqText
        }
      ) }),
      ((_V = (_U = (_T = translations == null ? void 0 : translations.footer) == null ? void 0 : _T.customerSupport) == null ? void 0 : _U.preLoginSection) == null ? void 0 : _V.contactUsItem) && /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          href: (_Z = (_Y = (_X = (_W = translations == null ? void 0 : translations.footer) == null ? void 0 : _W.customerSupport) == null ? void 0 : _X.preLoginSection) == null ? void 0 : _Y.contactUsItem) == null ? void 0 : _Z.href,
          target: "_blank",
          rel: "noreferrer",
          children: (_ba = (_aa = (_$ = (__ = translations == null ? void 0 : translations.footer) == null ? void 0 : __.customerSupport) == null ? void 0 : _$.preLoginSection) == null ? void 0 : _aa.contactUsItem) == null ? void 0 : _ba.text
        }
      ) }),
      ((_ea = (_da = (_ca = translations == null ? void 0 : translations.footer) == null ? void 0 : _ca.customerSupport) == null ? void 0 : _da.preLoginSection) == null ? void 0 : _ea.emailItem) && /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          target: "_top",
          href: (_ia = (_ha = (_ga = (_fa = translations == null ? void 0 : translations.footer) == null ? void 0 : _fa.customerSupport) == null ? void 0 : _ga.preLoginSection) == null ? void 0 : _ha.emailItem) == null ? void 0 : _ia.href,
          children: (_ma = (_la = (_ka = (_ja = translations == null ? void 0 : translations.footer) == null ? void 0 : _ja.customerSupport) == null ? void 0 : _ka.preLoginSection) == null ? void 0 : _la.emailItem) == null ? void 0 : _ma.text
        }
      ) })
    ] }) })
  ] });
};
const ContactInfo = ({
  accuCustomization: accuCustomization2,
  isAuthenticated,
  setModalContent,
  setShow,
  siteContactInfo: siteContactInfo2,
  styleEnv,
  translations,
  isTaxable
}) => {
  const userTimeZone = useTimeZone();
  const { timeZones } = translations.footer;
  const { phone, alias } = siteContactInfo2;
  const openFooterModal = ({ modalType }) => {
    const modalSrc = (modalType === FEEDBACK_MODAL_SRC || modalType === CONTACT_MODAL_SRC) && accuCustomization2[modalType] ? styleEnv.concat(accuCustomization2[modalType]) : null;
    async function getModalView() {
      const View = await getRemoteComponent(modalSrc);
      return View;
    }
    getModalView().then((data) => {
      setModalContent(data);
      setShow(true);
    });
  };
  const timezoneTemplate = useMemo(() => {
    if (timeZones && timeZones[userTimeZone]) {
      return timeZones[userTimeZone];
    }
    if (timeZones) {
      return values(timeZones)[0];
    }
  }, [timeZones, userTimeZone]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "customer-support", children: isAuthenticated ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    ContactUsPostLogin,
    {
      openFooterModal,
      timeZone: timezoneTemplate,
      phone,
      alias,
      isTaxable
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    ContactUsPreLogin,
    {
      alias,
      openFooterModal,
      phone,
      timeZone: timezoneTemplate
    }
  ) });
};
ContactInfo.propTypes = {
  accuCustomization: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  setModalContent: PropTypes.func.isRequired,
  setShow: PropTypes.func.isRequired,
  siteContactInfo: PropTypes.object.isRequired,
  styleEnv: PropTypes.string.isRequired,
  translations: PropTypes.object.isRequired,
  isTaxable: PropTypes.bool
};
const ContactInfo$1 = memo(ContactInfo);
const CoreUIModal = ({ content = null, handleClose, show, ariaLabelledBy = null }) => {
  if (!content) {
    return null;
  }
  const handleOnShow = () => {
    const firstFoccusableElement = document.querySelector(".modal-dialog").querySelector(queryFocusableElements);
    firstFoccusableElement.focus();
  };
  const modalProps = {
    onHide: handleClose,
    onShow: handleOnShow,
    show
  };
  if (ariaLabelledBy) {
    modalProps["aria-labelledby"] = ariaLabelledBy;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { ...modalProps, children: content });
};
/*!
 * mustache.js - Logic-less {{mustache}} templates with JavaScript
 * http://github.com/janl/mustache.js
 */
var objectToString = Object.prototype.toString;
var isArray = Array.isArray || function isArrayPolyfill(object) {
  return objectToString.call(object) === "[object Array]";
};
function isFunction(object) {
  return typeof object === "function";
}
function typeStr(obj) {
  return isArray(obj) ? "array" : typeof obj;
}
function escapeRegExp(string) {
  return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function hasProperty(obj, propName) {
  return obj != null && typeof obj === "object" && propName in obj;
}
function primitiveHasOwnProperty(primitive, propName) {
  return primitive != null && typeof primitive !== "object" && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
}
var regExpTest = RegExp.prototype.test;
function testRegExp(re, string) {
  return regExpTest.call(re, string);
}
var nonSpaceRe = /\S/;
function isWhitespace(string) {
  return !testRegExp(nonSpaceRe, string);
}
var entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;",
  "`": "&#x60;",
  "=": "&#x3D;"
};
function escapeHtml(string) {
  return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
    return entityMap[s];
  });
}
var whiteRe = /\s*/;
var spaceRe = /\s+/;
var equalsRe = /\s*=/;
var curlyRe = /\s*\}/;
var tagRe = /#|\^|\/|>|\{|&|=|!/;
function parseTemplate(template, tags) {
  if (!template)
    return [];
  var lineHasNonSpace = false;
  var sections = [];
  var tokens = [];
  var spaces = [];
  var hasTag = false;
  var nonSpace = false;
  var indentation = "";
  var tagIndex = 0;
  function stripSpace() {
    if (hasTag && !nonSpace) {
      while (spaces.length)
        delete tokens[spaces.pop()];
    } else {
      spaces = [];
    }
    hasTag = false;
    nonSpace = false;
  }
  var openingTagRe, closingTagRe, closingCurlyRe;
  function compileTags(tagsToCompile) {
    if (typeof tagsToCompile === "string")
      tagsToCompile = tagsToCompile.split(spaceRe, 2);
    if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
      throw new Error("Invalid tags: " + tagsToCompile);
    openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + "\\s*");
    closingTagRe = new RegExp("\\s*" + escapeRegExp(tagsToCompile[1]));
    closingCurlyRe = new RegExp("\\s*" + escapeRegExp("}" + tagsToCompile[1]));
  }
  compileTags(tags || mustache.tags);
  var scanner = new Scanner(template);
  var start, type, value, chr, token, openSection;
  while (!scanner.eos()) {
    start = scanner.pos;
    value = scanner.scanUntil(openingTagRe);
    if (value) {
      for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
        chr = value.charAt(i);
        if (isWhitespace(chr)) {
          spaces.push(tokens.length);
          indentation += chr;
        } else {
          nonSpace = true;
          lineHasNonSpace = true;
          indentation += " ";
        }
        tokens.push(["text", chr, start, start + 1]);
        start += 1;
        if (chr === "\n") {
          stripSpace();
          indentation = "";
          tagIndex = 0;
          lineHasNonSpace = false;
        }
      }
    }
    if (!scanner.scan(openingTagRe))
      break;
    hasTag = true;
    type = scanner.scan(tagRe) || "name";
    scanner.scan(whiteRe);
    if (type === "=") {
      value = scanner.scanUntil(equalsRe);
      scanner.scan(equalsRe);
      scanner.scanUntil(closingTagRe);
    } else if (type === "{") {
      value = scanner.scanUntil(closingCurlyRe);
      scanner.scan(curlyRe);
      scanner.scanUntil(closingTagRe);
      type = "&";
    } else {
      value = scanner.scanUntil(closingTagRe);
    }
    if (!scanner.scan(closingTagRe))
      throw new Error("Unclosed tag at " + scanner.pos);
    if (type == ">") {
      token = [type, value, start, scanner.pos, indentation, tagIndex, lineHasNonSpace];
    } else {
      token = [type, value, start, scanner.pos];
    }
    tagIndex++;
    tokens.push(token);
    if (type === "#" || type === "^") {
      sections.push(token);
    } else if (type === "/") {
      openSection = sections.pop();
      if (!openSection)
        throw new Error('Unopened section "' + value + '" at ' + start);
      if (openSection[1] !== value)
        throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
    } else if (type === "name" || type === "{" || type === "&") {
      nonSpace = true;
    } else if (type === "=") {
      compileTags(value);
    }
  }
  stripSpace();
  openSection = sections.pop();
  if (openSection)
    throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
  return nestTokens(squashTokens(tokens));
}
function squashTokens(tokens) {
  var squashedTokens = [];
  var token, lastToken;
  for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
    token = tokens[i];
    if (token) {
      if (token[0] === "text" && lastToken && lastToken[0] === "text") {
        lastToken[1] += token[1];
        lastToken[3] = token[3];
      } else {
        squashedTokens.push(token);
        lastToken = token;
      }
    }
  }
  return squashedTokens;
}
function nestTokens(tokens) {
  var nestedTokens = [];
  var collector = nestedTokens;
  var sections = [];
  var token, section;
  for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
    token = tokens[i];
    switch (token[0]) {
      case "#":
      case "^":
        collector.push(token);
        sections.push(token);
        collector = token[4] = [];
        break;
      case "/":
        section = sections.pop();
        section[5] = token[2];
        collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
        break;
      default:
        collector.push(token);
    }
  }
  return nestedTokens;
}
function Scanner(string) {
  this.string = string;
  this.tail = string;
  this.pos = 0;
}
Scanner.prototype.eos = function eos() {
  return this.tail === "";
};
Scanner.prototype.scan = function scan(re) {
  var match = this.tail.match(re);
  if (!match || match.index !== 0)
    return "";
  var string = match[0];
  this.tail = this.tail.substring(string.length);
  this.pos += string.length;
  return string;
};
Scanner.prototype.scanUntil = function scanUntil(re) {
  var index2 = this.tail.search(re), match;
  switch (index2) {
    case -1:
      match = this.tail;
      this.tail = "";
      break;
    case 0:
      match = "";
      break;
    default:
      match = this.tail.substring(0, index2);
      this.tail = this.tail.substring(index2);
  }
  this.pos += match.length;
  return match;
};
function Context(view, parentContext) {
  this.view = view;
  this.cache = { ".": this.view };
  this.parent = parentContext;
}
Context.prototype.push = function push(view) {
  return new Context(view, this);
};
Context.prototype.lookup = function lookup(name2) {
  var cache2 = this.cache;
  var value;
  if (cache2.hasOwnProperty(name2)) {
    value = cache2[name2];
  } else {
    var context = this, intermediateValue, names, index2, lookupHit = false;
    while (context) {
      if (name2.indexOf(".") > 0) {
        intermediateValue = context.view;
        names = name2.split(".");
        index2 = 0;
        while (intermediateValue != null && index2 < names.length) {
          if (index2 === names.length - 1)
            lookupHit = hasProperty(intermediateValue, names[index2]) || primitiveHasOwnProperty(intermediateValue, names[index2]);
          intermediateValue = intermediateValue[names[index2++]];
        }
      } else {
        intermediateValue = context.view[name2];
        lookupHit = hasProperty(context.view, name2);
      }
      if (lookupHit) {
        value = intermediateValue;
        break;
      }
      context = context.parent;
    }
    cache2[name2] = value;
  }
  if (isFunction(value))
    value = value.call(this.view);
  return value;
};
function Writer() {
  this.templateCache = {
    _cache: {},
    set: function set(key, value) {
      this._cache[key] = value;
    },
    get: function get2(key) {
      return this._cache[key];
    },
    clear: function clear() {
      this._cache = {};
    }
  };
}
Writer.prototype.clearCache = function clearCache2() {
  if (typeof this.templateCache !== "undefined") {
    this.templateCache.clear();
  }
};
Writer.prototype.parse = function parse2(template, tags) {
  var cache2 = this.templateCache;
  var cacheKey = template + ":" + (tags || mustache.tags).join(":");
  var isCacheEnabled = typeof cache2 !== "undefined";
  var tokens = isCacheEnabled ? cache2.get(cacheKey) : void 0;
  if (tokens == void 0) {
    tokens = parseTemplate(template, tags);
    isCacheEnabled && cache2.set(cacheKey, tokens);
  }
  return tokens;
};
Writer.prototype.render = function render(template, view, partials, config2) {
  var tags = this.getConfigTags(config2);
  var tokens = this.parse(template, tags);
  var context = view instanceof Context ? view : new Context(view, void 0);
  return this.renderTokens(tokens, context, partials, template, config2);
};
Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config2) {
  var buffer2 = "";
  var token, symbol, value;
  for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
    value = void 0;
    token = tokens[i];
    symbol = token[0];
    if (symbol === "#") value = this.renderSection(token, context, partials, originalTemplate, config2);
    else if (symbol === "^") value = this.renderInverted(token, context, partials, originalTemplate, config2);
    else if (symbol === ">") value = this.renderPartial(token, context, partials, config2);
    else if (symbol === "&") value = this.unescapedValue(token, context);
    else if (symbol === "name") value = this.escapedValue(token, context, config2);
    else if (symbol === "text") value = this.rawValue(token);
    if (value !== void 0)
      buffer2 += value;
  }
  return buffer2;
};
Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config2) {
  var self2 = this;
  var buffer2 = "";
  var value = context.lookup(token[1]);
  function subRender(template) {
    return self2.render(template, context, partials, config2);
  }
  if (!value) return;
  if (isArray(value)) {
    for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
      buffer2 += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config2);
    }
  } else if (typeof value === "object" || typeof value === "string" || typeof value === "number") {
    buffer2 += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config2);
  } else if (isFunction(value)) {
    if (typeof originalTemplate !== "string")
      throw new Error("Cannot use higher-order sections without the original template");
    value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
    if (value != null)
      buffer2 += value;
  } else {
    buffer2 += this.renderTokens(token[4], context, partials, originalTemplate, config2);
  }
  return buffer2;
};
Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config2) {
  var value = context.lookup(token[1]);
  if (!value || isArray(value) && value.length === 0)
    return this.renderTokens(token[4], context, partials, originalTemplate, config2);
};
Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
  var filteredIndentation = indentation.replace(/[^ \t]/g, "");
  var partialByNl = partial.split("\n");
  for (var i = 0; i < partialByNl.length; i++) {
    if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) {
      partialByNl[i] = filteredIndentation + partialByNl[i];
    }
  }
  return partialByNl.join("\n");
};
Writer.prototype.renderPartial = function renderPartial(token, context, partials, config2) {
  if (!partials) return;
  var tags = this.getConfigTags(config2);
  var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
  if (value != null) {
    var lineHasNonSpace = token[6];
    var tagIndex = token[5];
    var indentation = token[4];
    var indentedValue = value;
    if (tagIndex == 0 && indentation) {
      indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
    }
    var tokens = this.parse(indentedValue, tags);
    return this.renderTokens(tokens, context, partials, indentedValue, config2);
  }
};
Writer.prototype.unescapedValue = function unescapedValue(token, context) {
  var value = context.lookup(token[1]);
  if (value != null)
    return value;
};
Writer.prototype.escapedValue = function escapedValue(token, context, config2) {
  var escape2 = this.getConfigEscape(config2) || mustache.escape;
  var value = context.lookup(token[1]);
  if (value != null)
    return typeof value === "number" && escape2 === mustache.escape ? String(value) : escape2(value);
};
Writer.prototype.rawValue = function rawValue(token) {
  return token[1];
};
Writer.prototype.getConfigTags = function getConfigTags(config2) {
  if (isArray(config2)) {
    return config2;
  } else if (config2 && typeof config2 === "object") {
    return config2.tags;
  } else {
    return void 0;
  }
};
Writer.prototype.getConfigEscape = function getConfigEscape(config2) {
  if (config2 && typeof config2 === "object" && !isArray(config2)) {
    return config2.escape;
  } else {
    return void 0;
  }
};
var mustache = {
  name: "mustache.js",
  version: "4.2.0",
  tags: ["{{", "}}"],
  clearCache: void 0,
  escape: void 0,
  parse: void 0,
  render: void 0,
  Scanner: void 0,
  Context: void 0,
  Writer: void 0,
  /**
   * Allows a user to override the default caching strategy, by providing an
   * object with set, get and clear methods. This can also be used to disable
   * the cache by setting it to the literal `undefined`.
   */
  set templateCache(cache2) {
    defaultWriter.templateCache = cache2;
  },
  /**
   * Gets the default or overridden caching object from the default writer.
   */
  get templateCache() {
    return defaultWriter.templateCache;
  }
};
var defaultWriter = new Writer();
mustache.clearCache = function clearCache3() {
  return defaultWriter.clearCache();
};
mustache.parse = function parse3(template, tags) {
  return defaultWriter.parse(template, tags);
};
mustache.render = function render2(template, view, partials, config2) {
  if (typeof template !== "string") {
    throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first argument for mustache#render(template, view, partials)');
  }
  return defaultWriter.render(template, view, partials, config2);
};
mustache.escape = escapeHtml;
mustache.Scanner = Scanner;
mustache.Context = Context;
mustache.Writer = Writer;
const { render: render3 } = mustache;
const MustacheHTML = ({ template, data }) => {
  if (!template) return false;
  const html = render3(template, data);
  return html;
};
const ContactModal = ({
  content = null,
  handleClose,
  isAuthenticated,
  setShow,
  show,
  siteContactInfo: siteContactInfo2,
  translations
}) => {
  const btnDismiss = "btn-dismiss";
  if (!content) {
    return null;
  }
  const options = {
    replace: (domNode) => {
      if (!domNode.attribs) return;
      if (domNode.attribs.class) {
        domNode.attribs = { ...{ className: domNode.attribs.class } };
        delete domNode.attribs.class;
      }
      if (domNode.name === "button") {
        let onclick = null;
        if (domNode.attribs.class || domNode.attribs.className) {
          const domClass = domNode.attribs.class || domNode.attribs.className;
          if (domClass.includes(btnDismiss)) {
            onclick = () => setShow(false);
          }
        }
        return show && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { ...domNode.attribs, onClick: onclick, children: domToReact(domNode.children, options) });
      }
    }
  };
  if (!isAuthenticated) {
    const phonePreLoginObj = getPhonePreLogin({ phone: null, alias: null, translations });
    if (phonePreLoginObj && (phonePreLoginObj == null ? void 0 : phonePreLoginObj.phoneNumberText)) {
      siteContactInfo2.phone = (phonePreLoginObj == null ? void 0 : phonePreLoginObj.phoneNumberText) || null;
      siteContactInfo2.alias = (phonePreLoginObj == null ? void 0 : phonePreLoginObj.phoneNumberAliasText) || null;
    }
  }
  const contentMustache = MustacheHTML({ template: content, data: { siteContactInfo: siteContactInfo2 } });
  const html = parse(contentMustache, options);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CoreUIModal, { content: html, handleClose, show });
};
const { isUndefinedOrNull: isUndefinedOrNull$d } = ObjectUtil;
const FooterContact = (props) => {
  const {
    accountGroupInfo,
    accuCustomization: accuCustomization2,
    isAuthenticated,
    siteContactInfo: siteContactInfo2,
    styleEnv,
    translations,
    isTaxable
  } = props;
  const [modalContent, setModalContent] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  if (isUndefinedOrNull$d(accountGroupInfo) || isUndefinedOrNull$d(siteContactInfo2) || isUndefinedOrNull$d(translations) || isUndefinedOrNull$d(accuCustomization2)) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ContactInfo$1,
      {
        accuCustomization: accuCustomization2,
        isAuthenticated,
        setModalContent,
        setShow,
        siteContactInfo: siteContactInfo2,
        styleEnv,
        translations,
        isTaxable
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ContactModal,
      {
        content: modalContent,
        handleClose,
        isAuthenticated,
        siteContactInfo: siteContactInfo2,
        show,
        setShow,
        translations
      }
    )
  ] });
};
const FooterContact$1 = memo(FooterContact);
const { isUndefinedOrNull: isUndefinedOrNull$c, resolve: resolve$5 } = ObjectUtil;
const isValidURL = (url2) => {
  const res = url2.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
  );
  return res !== null;
};
const getUrlDisclosureLink = (href) => {
  const httpUrl = isValidURL(href);
  const url2 = httpUrl ? href : `${getCurrentDomain()}participant/${href}`;
  return url2;
};
const getTestIdFromTranslationKey = (translationKey) => {
  return translationKey.replaceAll(".", "-");
};
const Link$1 = ({
  href,
  target = "_self",
  translationKey,
  translations,
  isOpenAccount,
  onClickHandler = null
}) => {
  const handleClick2 = (event) => {
    event.preventDefault();
    if (onClickHandler) {
      new Function("event", "window", onClickHandler)(event, window);
    } else {
      const targetUrl = getUrlDisclosureLink(href) + "?accu=" + window.accu;
      const a = document.createElement("a");
      a.target = target;
      a.href = targetUrl;
      const userAgent = navigator.userAgent;
      const msie = userAgent.indexOf("MSIE ");
      const trident = userAgent.indexOf("Trident/");
      if (msie > 0 || trident > 0) {
        window.open(targetUrl, target);
      } else {
        a.click();
      }
    }
  };
  const handleOnKeyDown = (event) => {
    const codes = ["Enter_", " "].map((code) => code.replace("_", ""));
    return codes.includes(event.key) && handleClick2(event);
  };
  const testId = getTestIdFromTranslationKey(translationKey);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { onClick: handleClick2, onKeyDown: handleOnKeyDown, href: "#", "data-testid": testId, children: isOpenAccount ? resolve$5(translations, translationKey).text : resolve$5(translations, translationKey) });
};
const DisclosureLinks = ({ links, translations }) => {
  if (isUndefinedOrNull$c(links) || isUndefinedOrNull$c(translations)) return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "footer-doc-links text-notation", role: "navigation", children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "list-inline with-rules", children: links.map(({ text: translationKey, href, target, onClickHandler }) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { ...{ translationKey, href, target, translations, onClickHandler } }) }, translationKey)) }) });
};
DisclosureLinks.propTypes = {
  links: PropTypes.array,
  translations: PropTypes.object
};
const { resolve: resolve$4 } = ObjectUtil;
const Disclosure = ({ class: cssClass, text: key, templateValues: templateValues2, translations, resolveText }) => {
  const options = {
    replace: (domNode) => {
      if (!domNode.attribs) return;
      if (domNode.attribs.class) {
        domNode.attribs = { ...{ className: cssClass } };
        delete domNode.attribs.class;
      }
    }
  };
  const html = resolve$4(translations, resolveText || key);
  const testId = key.text ? key.text.replaceAll(".", "-") : key.replaceAll(".", "-");
  if (!html) return null;
  if (String(resolveText).toLowerCase().indexOf("disclosures.crs") > -1) {
    const id2 = String(resolveText).split(".")[1];
    const href = translations.disclosures[id2].href;
    const target = "_blank";
    const isOpenAccount = true;
    const translationKey = resolveText;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: cssClass, "data-testid": testId, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { ...{ translationKey, href, target, translations, isOpenAccount } }) });
  } else {
    const contentMustache = MustacheHTML({ template: html, data: templateValues2 });
    const reactElement = parse(contentMustache, options);
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: cssClass, "data-testid": testId, children: reactElement });
  }
};
Disclosure.propTypes = {
  text: PropTypes.any,
  // translation key
  class: PropTypes.string
  // css class to wrap
};
const DisclosureInformation = ({ disclosures, translations, templateValues: templateValues2, resolveText = "" }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: disclosures && disclosures.map((disclosure, id2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Disclosure,
    {
      templateValues: templateValues2,
      ...disclosure,
      translations,
      resolveText: resolveText ? `${resolveText}.${Object.getOwnPropertyNames(translations.disclosures)[id2]}` : ""
    },
    disclosure.text
  )) });
};
DisclosureInformation.propTypes = {
  disclosures: PropTypes.array,
  translations: PropTypes.object,
  templateValues: PropTypes.object,
  resolveText: PropTypes.string
};
const { isUndefinedOrNull: isUndefinedOrNull$b } = ObjectUtil;
const DEFAULT_DISCLOSURES = [];
const templateValues = {
  urlDomain: "",
  year: (/* @__PURE__ */ new Date()).getFullYear()
};
const FooterDisclosureInfo = (props) => {
  var _a2;
  const { resolveText = "", disclosures, translations } = props;
  const { accuCustomization: accuCustomization2 } = useSelector((state) => state.shared);
  const styleEnv = useSelector((state) => state.header.styleEnv);
  if (isUndefinedOrNull$b(translations)) return null;
  const disclosuresInfo = disclosures || ((_a2 = accuCustomization2 == null ? void 0 : accuCustomization2.footer) == null ? void 0 : _a2.disclosures) || DEFAULT_DISCLOSURES;
  if (isEmpty$1(disclosuresInfo)) {
    return null;
  }
  templateValues.urlDomain = styleEnv;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DisclosureInformation,
    {
      disclosures: disclosuresInfo,
      templateValues,
      translations,
      resolveText
    }
  );
};
const { isUndefinedOrNull: isUndefinedOrNull$a } = ObjectUtil;
const DEFAULT_LINKS = [];
const FooterDisclosureLinks = () => {
  var _a2;
  const { accuCustomization: accuCustomization2, translations } = useSelector((state) => state.shared);
  if (isUndefinedOrNull$a(translations)) return null;
  const links = ((_a2 = accuCustomization2 == null ? void 0 : accuCustomization2.footer) == null ? void 0 : _a2.docs) || DEFAULT_LINKS;
  if (isEmpty$1(links)) {
    return null;
  }
  if (accuCustomization2.showOneTrustOptOut) {
    links.filter((link) => !link.isOneTrust);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DisclosureLinks, { translations, links });
};
const OpenAccountFooter = ({
  templateValues: templateValues2,
  translations,
  isAuthenticated,
  accuCustomization: accuCustomization2,
  siteContactInfo: siteContactInfo2,
  accuDependent
}) => {
  const openAccountTranslations = translations.footer.openAccount.disclosures;
  const contactTranslations = translations.footer.openAccount.contact;
  const timeZones = translations.footer.timeZones;
  const DEFAULT_TZ = "MST";
  const disclosures = [];
  const timeZone = timeZones[siteContactInfo2.timeZone || DEFAULT_TZ];
  const CONTACT_MODAL_SRC2 = "contactModalSrc";
  const openFooterSiteContactInfo = cloneDeep(siteContactInfo2);
  openFooterSiteContactInfo.phone = contactTranslations.contactNumber;
  const [modalContent, setModalContent] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  function openFooterModal() {
    const styleEnv = "/ui/customization-ui/";
    const modalSrc = styleEnv.concat(accuCustomization2[CONTACT_MODAL_SRC2]);
    async function getModalView() {
      const View = await getRemoteComponent(modalSrc);
      return View;
    }
    getModalView().then((data) => {
      setModalContent(data);
      setShow(true);
    });
  }
  for (const key in openAccountTranslations) {
    disclosures.push({
      text: openAccountTranslations[key],
      class: key === "crs" ? "copyright" : ""
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "row", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-3 col-md-push-9", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "customer-support", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "support-title", children: contactTranslations.title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
        contactTranslations.representativeDc,
        /* @__PURE__ */ jsxRuntimeExports.jsx("a", { onClick: openFooterModal, children: "contact us " }),
        StringUtil$1.supplant(contactTranslations.operationalHours, {
          timeZone
        })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ContactModal,
        {
          content: modalContent,
          handleClose,
          isAuthenticated,
          siteContactInfo: openFooterSiteContactInfo,
          show,
          setShow,
          translations
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "phone not-link", children: contactTranslations.contactNumber }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        BrokerCheckComponent,
        {
          isAuthenticated,
          accuCustomization: accuCustomization2,
          accuDependent
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-md-9 col-md-pull-3", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      FooterDisclosureInfo,
      {
        disclosures,
        templateValues: templateValues2,
        translations: translations.footer.openAccount,
        resolveText: "disclosures"
      }
    ) })
  ] });
};
const { isUndefinedOrNull: isUndefinedOrNull$9, resolve: resolve$3 } = ObjectUtil;
const PartnershipLogo = () => {
  const { accuCustomization: accuCustomization2, translations, authenticationStatus } = useSelector(
    (state) => state.shared
  );
  const { authenticated: authenticated2 } = authenticationStatus;
  if (isUndefinedOrNull$9(translations) || !(accuCustomization2 == null ? void 0 : accuCustomization2.footer) || !authenticated2) {
    return null;
  }
  const partnershipText = resolve$3(translations, "footer.partnership");
  const altLogo = resolve$3(translations, "footer.logoAlt");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "footer-partnership-logo", "data-testid": "footer-partnership-logo", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: partnershipText }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
        alt: altLogo
      }
    )
  ] });
};
const { isUndefinedOrNull: isUndefinedOrNull$8, resolve: resolve$2 } = ObjectUtil;
const DEFAULT_SOCIAL_NETWORKS = [];
const SocialNetworkIcon = (props) => {
  const { href, bootstrapIconClass, imageAlt } = props;
  const iconCssClasses = `fa fa-stack-1x fa-brands ${bootstrapIconClass}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "a",
    {
      href,
      target: "_blank",
      "data-testid": bootstrapIconClass,
      rel: "noreferrer",
      "aria-label": imageAlt,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "fa-stack fa-lg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": "true", className: iconCssClasses }) })
    }
  );
};
const SocialLinks = () => {
  var _a2;
  const { accuCustomization: accuCustomization2, translations } = useSelector((state) => state.shared);
  if (isUndefinedOrNull$8(translations)) return null;
  const socialNetworks = ((_a2 = accuCustomization2 == null ? void 0 : accuCustomization2.footer) == null ? void 0 : _a2.socialMedia) || DEFAULT_SOCIAL_NETWORKS;
  if (isEmpty$1(socialNetworks)) {
    return null;
  }
  const tagline = resolve$2(translations, "footer.socialMedia.tagline");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { className: "list-inline footer-social-media", children: [
    tagline && /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "tagline", children: tagline }),
    socialNetworks.map(({ href, imageAlt, text: translationKey, icon }) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      SocialNetworkIcon,
      {
        translations,
        ...{
          href,
          imageAlt,
          bootstrapIconClass: icon,
          translationKey
        }
      },
      translationKey
    ) }, translationKey))
  ] });
};
const SocialLinks$1 = memo(SocialLinks);
const { isUndefinedOrNull: isUndefinedOrNull$7, resolve: resolve$1 } = ObjectUtil;
const BrokerCheckComponent = ({ isAuthenticated, accuCustomization: accuCustomization2, accuDependent }) => {
  const brokerCheckUrl = accuCustomization2 && accuCustomization2.footer && accuCustomization2.footer.brokerCheck;
  const translations = useSelector((state) => state.shared.translations);
  if (!isAuthenticated && brokerCheckUrl || !accuDependent) {
    const brokerCls = !accuDependent ? { display: "block" } : { display: "none" };
    const t = (key) => resolve$1(translations, key);
    return brokerCheckUrl ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "broker-check", style: brokerCls, children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: brokerCheckUrl, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
        alt: t("footer.brokerCheckAlt")
      }
    ) }) }) : null;
  }
  return null;
};
const FooterView = () => {
  const dispatch = useDispatch();
  const account2 = useSelector((state) => state.account);
  const accu2 = useSelector((state) => state.header.accu);
  const accuLogoLoaded = useSelector((state) => state.header.accuCustomization);
  const accuCustomization2 = useSelector((state) => state.shared.accuCustomization);
  const activeGroupAccount = useSelector((state) => state.account.activeGroupAccount);
  const currentAccount = useSelector((state) => state.account.currentAccount);
  const isAuthenticated = useSelector((state) => state.shared.authenticationStatus.authenticated);
  const selectedLanguage = useSelector((state) => state.shared.selectedLanguage);
  const siteContactInfo2 = useSelector((state) => state.shared.siteContactInfo);
  const { chatBotEnable, liveChatEnable, enterpriseChatEnable } = useSelector(
    (state) => state.header.txnAccess
  );
  const styleEnv = useSelector((state) => state.header.styleEnv);
  const translations = useSelector((state) => state.shared.translations);
  const [chatParticipantData, setChatParticipantData] = useState(null);
  const [reRender, setReRender] = useState(false);
  const [renderOpenAccountFooter, setRenderOpenAccountFooter] = useState(false);
  useEffect(() => {
    const participantName = () => {
      const firstName = account2.accountDetails.firstName ? account2.accountDetails.firstName : "";
      const middleName = account2.accountDetails.middleName ? account2.accountDetails.middleName : "";
      const lastName = account2.accountDetails.lastName ? account2.accountDetails.lastName : "";
      return firstName + " " + middleName + " " + lastName;
    };
    const chatParticipantData2 = {
      languague: selectedLanguage,
      participantIdNumber: activeGroupAccount.individualId,
      participantName: participantName(),
      planNumber: activeGroupAccount.groupId,
      planName: account2.accountDetails.name,
      unit: ""
    };
    setChatParticipantData(chatParticipantData2);
  }, [account2, activeGroupAccount.groupId, activeGroupAccount.individualId, selectedLanguage]);
  useEffect(() => {
    const callService = !isAuthenticated && !reRender && !!accuCustomization2.primaryDatabase;
    if (callService) {
      const ContactInfoPayload = {
        accu: accu2,
        accuSpecificPrimDb: accuCustomization2.primaryDatabase.preLoginPrimaryDB,
        portalType: "TOLLFREE"
      };
      setReRender(true);
      dispatch(getContactInfoPrelogin({ ...ContactInfoPayload }));
    }
  }, [accu2, accuCustomization2, dispatch, isAuthenticated, reRender]);
  useEffect(() => {
    window.addEventListener("show-account-footer", (e) => {
      setRenderOpenAccountFooter(e.detail.show);
    });
  }, []);
  if (isUndefinedOrNull$7(activeGroupAccount)) {
    return null;
  }
  const currentYearForFooter = (/* @__PURE__ */ new Date()).getFullYear();
  const isOauthLogin = String(getCookie$1("isOauthLogin")) === "true";
  return !isOauthLogin && /* @__PURE__ */ jsxRuntimeExports.jsx("footer", { className: "site-footer", children: !isUndefinedOrNull$7(accu2) && accuLogoLoaded && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "container", children: [
    renderOpenAccountFooter && translations && /* @__PURE__ */ jsxRuntimeExports.jsx(
      OpenAccountFooter,
      {
        templateValues: {
          urlDomain: styleEnv,
          year: currentYearForFooter
        },
        translations,
        isAuthenticated,
        accuCustomization: accuCustomization2,
        siteContactInfo: siteContactInfo2,
        accuDependent: false
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "row", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "col-md-9", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FooterDisclosureInfo, { translations }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FooterDisclosureLinks, {})
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "col-md-3", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          FooterContact$1,
          {
            accu: accu2,
            accuCustomization: accuCustomization2,
            accountGroupInfo: activeGroupAccount,
            isAuthenticated,
            siteContactInfo: siteContactInfo2,
            styleEnv,
            translations,
            isTaxable: Boolean(currentAccount.pcapAccountId)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          WrapperEnterpriseChat,
          {
            chatParticipantData,
            chatBotEnable,
            liveChatEnable,
            enterpriseChatEnable
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(PartnershipLogo, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(SocialLinks$1, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          BrokerCheckComponent,
          {
            accuCustomization: accuCustomization2,
            isAuthenticated,
            accuDependent: false
          }
        )
      ] })
    ] })
  ] }) });
};
const mapStateToProps$1 = (state) => {
  return {
    ...state
  };
};
const mapDispatchToProps$1 = (dispatch) => {
  return bindActionCreators(
    {
      // No mapping yet
    },
    dispatch
  );
};
const FooterContainerComponent = connect(mapStateToProps$1, mapDispatchToProps$1)(FooterView);
const FooterViewProviderComponent = function() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Provider, { store, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FooterContainerComponent, {}) });
};
var Subscribable = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set();
    this.subscribe = this.subscribe.bind(this);
  }
  subscribe(listener) {
    this.listeners.add(listener);
    this.onSubscribe();
    return () => {
      this.listeners.delete(listener);
      this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
};
var isServer = typeof window === "undefined" || "Deno" in globalThis;
function noop$1() {
}
function functionalUpdate(updater, input) {
  return typeof updater === "function" ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === "number" && value >= 0 && value !== Infinity;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function resolveStaleTime(staleTime, query) {
  return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function resolveEnabled(enabled, query) {
  return typeof enabled === "function" ? enabled(query) : enabled;
}
function matchQuery(filters, query) {
  const {
    type = "all",
    exact,
    fetchStatus,
    predicate,
    queryKey,
    stale
  } = filters;
  if (queryKey) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }
  if (type !== "all") {
    const isActive = query.isActive();
    if (type === "active" && !isActive) {
      return false;
    }
    if (type === "inactive" && isActive) {
      return false;
    }
  }
  if (typeof stale === "boolean" && query.isStale() !== stale) {
    return false;
  }
  if (fetchStatus && fetchStatus !== query.state.fetchStatus) {
    return false;
  }
  if (predicate && !predicate(query)) {
    return false;
  }
  return true;
}
function matchMutation(filters, mutation) {
  const { exact, status, predicate, mutationKey } = filters;
  if (mutationKey) {
    if (!mutation.options.mutationKey) {
      return false;
    }
    if (exact) {
      if (hashKey(mutation.options.mutationKey) !== hashKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }
  if (status && mutation.state.status !== status) {
    return false;
  }
  if (predicate && !predicate(mutation)) {
    return false;
  }
  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashKey;
  return hashFn(queryKey);
}
function hashKey(queryKey) {
  return JSON.stringify(
    queryKey,
    (_2, val) => isPlainObject(val) ? Object.keys(val).sort().reduce((result2, key) => {
      result2[key] = val[key];
      return result2;
    }, {}) : val
  );
}
function partialMatchKey(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (a && b && typeof a === "object" && typeof b === "object") {
    return !Object.keys(b).some((key) => !partialMatchKey(a[key], b[key]));
  }
  return false;
}
function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }
  const array = isPlainArray(a) && isPlainArray(b);
  if (array || isPlainObject(a) && isPlainObject(b)) {
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? [] : {};
    let equalItems = 0;
    for (let i = 0; i < bSize; i++) {
      const key = array ? i : bItems[i];
      if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
        copy[key] = void 0;
        equalItems++;
      } else {
        copy[key] = replaceEqualDeep(a[key], b[key]);
        if (copy[key] === a[key] && a[key] !== void 0) {
          equalItems++;
        }
      }
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
  }
  return b;
}
function shallowEqualObjects(a, b) {
  if (!b || Object.keys(a).length !== Object.keys(b).length) {
    return false;
  }
  for (const key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }
  return true;
}
function isPlainArray(value) {
  return Array.isArray(value) && value.length === Object.keys(value).length;
}
function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  }
  const ctor = o.constructor;
  if (ctor === void 0) {
    return true;
  }
  const prot = ctor.prototype;
  if (!hasObjectPrototype(prot)) {
    return false;
  }
  if (!prot.hasOwnProperty("isPrototypeOf")) {
    return false;
  }
  if (Object.getPrototypeOf(o) !== Object.prototype) {
    return false;
  }
  return true;
}
function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === "[object Object]";
}
function sleep(timeout2) {
  return new Promise((resolve2) => {
    setTimeout(resolve2, timeout2);
  });
}
function replaceData(prevData, data, options) {
  if (typeof options.structuralSharing === "function") {
    return options.structuralSharing(prevData, data);
  } else if (options.structuralSharing !== false) {
    if (process.env.NODE_ENV !== "production") {
      try {
        return replaceEqualDeep(prevData, data);
      } catch (error) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${options.queryHash}]: ${error}`
        );
      }
    }
    return replaceEqualDeep(prevData, data);
  }
  return data;
}
function addToEnd(items, item, max = 0) {
  const newItems = [...items, item];
  return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function addToStart(items, item, max = 0) {
  const newItems = [item, ...items];
  return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var skipToken = Symbol();
function ensureQueryFn(options, fetchOptions) {
  if (process.env.NODE_ENV !== "production") {
    if (options.queryFn === skipToken) {
      console.error(
        `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${options.queryHash}'`
      );
    }
  }
  if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) {
    return () => fetchOptions.initialPromise;
  }
  if (!options.queryFn || options.queryFn === skipToken) {
    return () => Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
  }
  return options.queryFn;
}
var FocusManager = (_b = class extends Subscribable {
  constructor() {
    super();
    __privateAdd(this, _focused);
    __privateAdd(this, _cleanup);
    __privateAdd(this, _setup);
    __privateSet(this, _setup, (onFocus) => {
      if (!isServer && window.addEventListener) {
        const listener = () => onFocus();
        window.addEventListener("visibilitychange", listener, false);
        return () => {
          window.removeEventListener("visibilitychange", listener);
        };
      }
      return;
    });
  }
  onSubscribe() {
    if (!__privateGet(this, _cleanup)) {
      this.setEventListener(__privateGet(this, _setup));
    }
  }
  onUnsubscribe() {
    var _a2;
    if (!this.hasListeners()) {
      (_a2 = __privateGet(this, _cleanup)) == null ? void 0 : _a2.call(this);
      __privateSet(this, _cleanup, void 0);
    }
  }
  setEventListener(setup) {
    var _a2;
    __privateSet(this, _setup, setup);
    (_a2 = __privateGet(this, _cleanup)) == null ? void 0 : _a2.call(this);
    __privateSet(this, _cleanup, setup((focused) => {
      if (typeof focused === "boolean") {
        this.setFocused(focused);
      } else {
        this.onFocus();
      }
    }));
  }
  setFocused(focused) {
    const changed = __privateGet(this, _focused) !== focused;
    if (changed) {
      __privateSet(this, _focused, focused);
      this.onFocus();
    }
  }
  onFocus() {
    const isFocused = this.isFocused();
    this.listeners.forEach((listener) => {
      listener(isFocused);
    });
  }
  isFocused() {
    var _a2;
    if (typeof __privateGet(this, _focused) === "boolean") {
      return __privateGet(this, _focused);
    }
    return ((_a2 = globalThis.document) == null ? void 0 : _a2.visibilityState) !== "hidden";
  }
}, _focused = new WeakMap(), _cleanup = new WeakMap(), _setup = new WeakMap(), _b);
var focusManager = new FocusManager();
var OnlineManager = (_c = class extends Subscribable {
  constructor() {
    super();
    __privateAdd(this, _online, true);
    __privateAdd(this, _cleanup2);
    __privateAdd(this, _setup2);
    __privateSet(this, _setup2, (onOnline) => {
      if (!isServer && window.addEventListener) {
        const onlineListener = () => onOnline(true);
        const offlineListener = () => onOnline(false);
        window.addEventListener("online", onlineListener, false);
        window.addEventListener("offline", offlineListener, false);
        return () => {
          window.removeEventListener("online", onlineListener);
          window.removeEventListener("offline", offlineListener);
        };
      }
      return;
    });
  }
  onSubscribe() {
    if (!__privateGet(this, _cleanup2)) {
      this.setEventListener(__privateGet(this, _setup2));
    }
  }
  onUnsubscribe() {
    var _a2;
    if (!this.hasListeners()) {
      (_a2 = __privateGet(this, _cleanup2)) == null ? void 0 : _a2.call(this);
      __privateSet(this, _cleanup2, void 0);
    }
  }
  setEventListener(setup) {
    var _a2;
    __privateSet(this, _setup2, setup);
    (_a2 = __privateGet(this, _cleanup2)) == null ? void 0 : _a2.call(this);
    __privateSet(this, _cleanup2, setup(this.setOnline.bind(this)));
  }
  setOnline(online) {
    const changed = __privateGet(this, _online) !== online;
    if (changed) {
      __privateSet(this, _online, online);
      this.listeners.forEach((listener) => {
        listener(online);
      });
    }
  }
  isOnline() {
    return __privateGet(this, _online);
  }
}, _online = new WeakMap(), _cleanup2 = new WeakMap(), _setup2 = new WeakMap(), _c);
var onlineManager = new OnlineManager();
function pendingThenable() {
  let resolve2;
  let reject;
  const thenable = new Promise((_resolve, _reject) => {
    resolve2 = _resolve;
    reject = _reject;
  });
  thenable.status = "pending";
  thenable.catch(() => {
  });
  function finalize(data) {
    Object.assign(thenable, data);
    delete thenable.resolve;
    delete thenable.reject;
  }
  thenable.resolve = (value) => {
    finalize({
      status: "fulfilled",
      value
    });
    resolve2(value);
  };
  thenable.reject = (reason) => {
    finalize({
      status: "rejected",
      reason
    });
    reject(reason);
  };
  return thenable;
}
function defaultRetryDelay(failureCount) {
  return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function canFetch(networkMode) {
  return (networkMode ?? "online") === "online" ? onlineManager.isOnline() : true;
}
var CancelledError = class extends Error {
  constructor(options) {
    super("CancelledError");
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
  }
};
function isCancelledError(value) {
  return value instanceof CancelledError;
}
function createRetryer(config2) {
  let isRetryCancelled = false;
  let failureCount = 0;
  let isResolved = false;
  let continueFn;
  const thenable = pendingThenable();
  const cancel = (cancelOptions) => {
    var _a2;
    if (!isResolved) {
      reject(new CancelledError(cancelOptions));
      (_a2 = config2.abort) == null ? void 0 : _a2.call(config2);
    }
  };
  const cancelRetry = () => {
    isRetryCancelled = true;
  };
  const continueRetry = () => {
    isRetryCancelled = false;
  };
  const canContinue = () => focusManager.isFocused() && (config2.networkMode === "always" || onlineManager.isOnline()) && config2.canRun();
  const canStart = () => canFetch(config2.networkMode) && config2.canRun();
  const resolve2 = (value) => {
    var _a2;
    if (!isResolved) {
      isResolved = true;
      (_a2 = config2.onSuccess) == null ? void 0 : _a2.call(config2, value);
      continueFn == null ? void 0 : continueFn();
      thenable.resolve(value);
    }
  };
  const reject = (value) => {
    var _a2;
    if (!isResolved) {
      isResolved = true;
      (_a2 = config2.onError) == null ? void 0 : _a2.call(config2, value);
      continueFn == null ? void 0 : continueFn();
      thenable.reject(value);
    }
  };
  const pause = () => {
    return new Promise((continueResolve) => {
      var _a2;
      continueFn = (value) => {
        if (isResolved || canContinue()) {
          continueResolve(value);
        }
      };
      (_a2 = config2.onPause) == null ? void 0 : _a2.call(config2);
    }).then(() => {
      var _a2;
      continueFn = void 0;
      if (!isResolved) {
        (_a2 = config2.onContinue) == null ? void 0 : _a2.call(config2);
      }
    });
  };
  const run = () => {
    if (isResolved) {
      return;
    }
    let promiseOrValue;
    const initialPromise = failureCount === 0 ? config2.initialPromise : void 0;
    try {
      promiseOrValue = initialPromise ?? config2.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    }
    Promise.resolve(promiseOrValue).then(resolve2).catch((error) => {
      var _a2;
      if (isResolved) {
        return;
      }
      const retry = config2.retry ?? (isServer ? 0 : 3);
      const retryDelay = config2.retryDelay ?? defaultRetryDelay;
      const delay2 = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
      const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
      if (isRetryCancelled || !shouldRetry) {
        reject(error);
        return;
      }
      failureCount++;
      (_a2 = config2.onFail) == null ? void 0 : _a2.call(config2, failureCount, error);
      sleep(delay2).then(() => {
        return canContinue() ? void 0 : pause();
      }).then(() => {
        if (isRetryCancelled) {
          reject(error);
        } else {
          run();
        }
      });
    });
  };
  return {
    promise: thenable,
    cancel,
    continue: () => {
      continueFn == null ? void 0 : continueFn();
      return thenable;
    },
    cancelRetry,
    continueRetry,
    canStart,
    start: () => {
      if (canStart()) {
        run();
      } else {
        pause().then(run);
      }
      return thenable;
    }
  };
}
function createNotifyManager() {
  let queue = [];
  let transactions = 0;
  let notifyFn = (callback) => {
    callback();
  };
  let batchNotifyFn = (callback) => {
    callback();
  };
  let scheduleFn = (cb) => setTimeout(cb, 0);
  const schedule = (callback) => {
    if (transactions) {
      queue.push(callback);
    } else {
      scheduleFn(() => {
        notifyFn(callback);
      });
    }
  };
  const flush = () => {
    const originalQueue = queue;
    queue = [];
    if (originalQueue.length) {
      scheduleFn(() => {
        batchNotifyFn(() => {
          originalQueue.forEach((callback) => {
            notifyFn(callback);
          });
        });
      });
    }
  };
  return {
    batch: (callback) => {
      let result2;
      transactions++;
      try {
        result2 = callback();
      } finally {
        transactions--;
        if (!transactions) {
          flush();
        }
      }
      return result2;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (callback) => {
      return (...args) => {
        schedule(() => {
          callback(...args);
        });
      };
    },
    schedule,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (fn) => {
      notifyFn = fn;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (fn) => {
      batchNotifyFn = fn;
    },
    setScheduler: (fn) => {
      scheduleFn = fn;
    }
  };
}
var notifyManager = createNotifyManager();
var Removable = (_d = class {
  constructor() {
    __privateAdd(this, _gcTimeout);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout();
    if (isValidTimeout(this.gcTime)) {
      __privateSet(this, _gcTimeout, setTimeout(() => {
        this.optionalRemove();
      }, this.gcTime));
    }
  }
  updateGcTime(newGcTime) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      newGcTime ?? (isServer ? Infinity : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    if (__privateGet(this, _gcTimeout)) {
      clearTimeout(__privateGet(this, _gcTimeout));
      __privateSet(this, _gcTimeout, void 0);
    }
  }
}, _gcTimeout = new WeakMap(), _d);
var Query = (_e = class extends Removable {
  constructor(config2) {
    super();
    __privateAdd(this, _Query_instances);
    __privateAdd(this, _initialState);
    __privateAdd(this, _revertState);
    __privateAdd(this, _cache);
    __privateAdd(this, _client);
    __privateAdd(this, _retryer);
    __privateAdd(this, _defaultOptions);
    __privateAdd(this, _abortSignalConsumed);
    __privateSet(this, _abortSignalConsumed, false);
    __privateSet(this, _defaultOptions, config2.defaultOptions);
    this.setOptions(config2.options);
    this.observers = [];
    __privateSet(this, _client, config2.client);
    __privateSet(this, _cache, __privateGet(this, _client).getQueryCache());
    this.queryKey = config2.queryKey;
    this.queryHash = config2.queryHash;
    __privateSet(this, _initialState, getDefaultState$1(this.options));
    this.state = config2.state ?? __privateGet(this, _initialState);
    this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var _a2;
    return (_a2 = __privateGet(this, _retryer)) == null ? void 0 : _a2.promise;
  }
  setOptions(options) {
    this.options = { ...__privateGet(this, _defaultOptions), ...options };
    this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    if (!this.observers.length && this.state.fetchStatus === "idle") {
      __privateGet(this, _cache).remove(this);
    }
  }
  setData(newData, options) {
    const data = replaceData(this.state.data, newData, this.options);
    __privateMethod(this, _Query_instances, dispatch_fn).call(this, {
      data,
      type: "success",
      dataUpdatedAt: options == null ? void 0 : options.updatedAt,
      manual: options == null ? void 0 : options.manual
    });
    return data;
  }
  setState(state, setStateOptions) {
    __privateMethod(this, _Query_instances, dispatch_fn).call(this, { type: "setState", state, setStateOptions });
  }
  cancel(options) {
    var _a2, _b2;
    const promise = (_a2 = __privateGet(this, _retryer)) == null ? void 0 : _a2.promise;
    (_b2 = __privateGet(this, _retryer)) == null ? void 0 : _b2.cancel(options);
    return promise ? promise.then(noop$1).catch(noop$1) : Promise.resolve();
  }
  destroy() {
    super.destroy();
    this.cancel({ silent: true });
  }
  reset() {
    this.destroy();
    this.setState(__privateGet(this, _initialState));
  }
  isActive() {
    return this.observers.some(
      (observer) => resolveEnabled(observer.options.enabled, this) !== false
    );
  }
  isDisabled() {
    if (this.getObserversCount() > 0) {
      return !this.isActive();
    }
    return this.options.queryFn === skipToken || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    if (this.state.isInvalidated) {
      return true;
    }
    if (this.getObserversCount() > 0) {
      return this.observers.some(
        (observer) => observer.getCurrentResult().isStale
      );
    }
    return this.state.data === void 0;
  }
  isStaleByTime(staleTime = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !timeUntilStale(this.state.dataUpdatedAt, staleTime);
  }
  onFocus() {
    var _a2;
    const observer = this.observers.find((x) => x.shouldFetchOnWindowFocus());
    observer == null ? void 0 : observer.refetch({ cancelRefetch: false });
    (_a2 = __privateGet(this, _retryer)) == null ? void 0 : _a2.continue();
  }
  onOnline() {
    var _a2;
    const observer = this.observers.find((x) => x.shouldFetchOnReconnect());
    observer == null ? void 0 : observer.refetch({ cancelRefetch: false });
    (_a2 = __privateGet(this, _retryer)) == null ? void 0 : _a2.continue();
  }
  addObserver(observer) {
    if (!this.observers.includes(observer)) {
      this.observers.push(observer);
      this.clearGcTimeout();
      __privateGet(this, _cache).notify({ type: "observerAdded", query: this, observer });
    }
  }
  removeObserver(observer) {
    if (this.observers.includes(observer)) {
      this.observers = this.observers.filter((x) => x !== observer);
      if (!this.observers.length) {
        if (__privateGet(this, _retryer)) {
          if (__privateGet(this, _abortSignalConsumed)) {
            __privateGet(this, _retryer).cancel({ revert: true });
          } else {
            __privateGet(this, _retryer).cancelRetry();
          }
        }
        this.scheduleGc();
      }
      __privateGet(this, _cache).notify({ type: "observerRemoved", query: this, observer });
    }
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    if (!this.state.isInvalidated) {
      __privateMethod(this, _Query_instances, dispatch_fn).call(this, { type: "invalidate" });
    }
  }
  fetch(options, fetchOptions) {
    var _a2, _b2, _c2;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        this.cancel({ silent: true });
      } else if (__privateGet(this, _retryer)) {
        __privateGet(this, _retryer).continueRetry();
        return __privateGet(this, _retryer).promise;
      }
    }
    if (options) {
      this.setOptions(options);
    }
    if (!this.options.queryFn) {
      const observer = this.observers.find((x) => x.options.queryFn);
      if (observer) {
        this.setOptions(observer.options);
      }
    }
    if (process.env.NODE_ENV !== "production") {
      if (!Array.isArray(this.options.queryKey)) {
        console.error(
          `As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']`
        );
      }
    }
    const abortController = new AbortController();
    const addSignalProperty = (object) => {
      Object.defineProperty(object, "signal", {
        enumerable: true,
        get: () => {
          __privateSet(this, _abortSignalConsumed, true);
          return abortController.signal;
        }
      });
    };
    const fetchFn = () => {
      const queryFn = ensureQueryFn(this.options, fetchOptions);
      const queryFnContext = {
        client: __privateGet(this, _client),
        queryKey: this.queryKey,
        meta: this.meta
      };
      addSignalProperty(queryFnContext);
      __privateSet(this, _abortSignalConsumed, false);
      if (this.options.persister) {
        return this.options.persister(
          queryFn,
          queryFnContext,
          this
        );
      }
      return queryFn(queryFnContext);
    };
    const context = {
      fetchOptions,
      options: this.options,
      queryKey: this.queryKey,
      client: __privateGet(this, _client),
      state: this.state,
      fetchFn
    };
    addSignalProperty(context);
    (_a2 = this.options.behavior) == null ? void 0 : _a2.onFetch(
      context,
      this
    );
    __privateSet(this, _revertState, this.state);
    if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b2 = context.fetchOptions) == null ? void 0 : _b2.meta)) {
      __privateMethod(this, _Query_instances, dispatch_fn).call(this, { type: "fetch", meta: (_c2 = context.fetchOptions) == null ? void 0 : _c2.meta });
    }
    const onError = (error) => {
      var _a3, _b3, _c3, _d2;
      if (!(isCancelledError(error) && error.silent)) {
        __privateMethod(this, _Query_instances, dispatch_fn).call(this, {
          type: "error",
          error
        });
      }
      if (!isCancelledError(error)) {
        (_b3 = (_a3 = __privateGet(this, _cache).config).onError) == null ? void 0 : _b3.call(
          _a3,
          error,
          this
        );
        (_d2 = (_c3 = __privateGet(this, _cache).config).onSettled) == null ? void 0 : _d2.call(
          _c3,
          this.state.data,
          error,
          this
        );
      }
      this.scheduleGc();
    };
    __privateSet(this, _retryer, createRetryer({
      initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
      fn: context.fetchFn,
      abort: abortController.abort.bind(abortController),
      onSuccess: (data) => {
        var _a3, _b3, _c3, _d2;
        if (data === void 0) {
          if (process.env.NODE_ENV !== "production") {
            console.error(
              `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
            );
          }
          onError(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(data);
        } catch (error) {
          onError(error);
          return;
        }
        (_b3 = (_a3 = __privateGet(this, _cache).config).onSuccess) == null ? void 0 : _b3.call(_a3, data, this);
        (_d2 = (_c3 = __privateGet(this, _cache).config).onSettled) == null ? void 0 : _d2.call(
          _c3,
          data,
          this.state.error,
          this
        );
        this.scheduleGc();
      },
      onError,
      onFail: (failureCount, error) => {
        __privateMethod(this, _Query_instances, dispatch_fn).call(this, { type: "failed", failureCount, error });
      },
      onPause: () => {
        __privateMethod(this, _Query_instances, dispatch_fn).call(this, { type: "pause" });
      },
      onContinue: () => {
        __privateMethod(this, _Query_instances, dispatch_fn).call(this, { type: "continue" });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay,
      networkMode: context.options.networkMode,
      canRun: () => true
    }));
    return __privateGet(this, _retryer).start();
  }
}, _initialState = new WeakMap(), _revertState = new WeakMap(), _cache = new WeakMap(), _client = new WeakMap(), _retryer = new WeakMap(), _defaultOptions = new WeakMap(), _abortSignalConsumed = new WeakMap(), _Query_instances = new WeakSet(), dispatch_fn = function(action) {
  const reducer = (state) => {
    switch (action.type) {
      case "failed":
        return {
          ...state,
          fetchFailureCount: action.failureCount,
          fetchFailureReason: action.error
        };
      case "pause":
        return {
          ...state,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...state,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...state,
          ...fetchState(state.data, this.options),
          fetchMeta: action.meta ?? null
        };
      case "success":
        return {
          ...state,
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: false,
          status: "success",
          ...!action.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const error = action.error;
        if (isCancelledError(error) && error.revert && __privateGet(this, _revertState)) {
          return { ...__privateGet(this, _revertState), fetchStatus: "idle" };
        }
        return {
          ...state,
          error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          fetchFailureReason: error,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...state,
          isInvalidated: true
        };
      case "setState":
        return {
          ...state,
          ...action.state
        };
    }
  };
  this.state = reducer(this.state);
  notifyManager.batch(() => {
    this.observers.forEach((observer) => {
      observer.onQueryUpdate();
    });
    __privateGet(this, _cache).notify({ query: this, type: "updated", action });
  });
}, _e);
function fetchState(data, options) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: canFetch(options.networkMode) ? "fetching" : "paused",
    ...data === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function getDefaultState$1(options) {
  const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
  const hasData = data !== void 0;
  const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
  return {
    data,
    dataUpdateCount: 0,
    dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: hasData ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var QueryCache = (_f = class extends Subscribable {
  constructor(config2 = {}) {
    super();
    __privateAdd(this, _queries);
    this.config = config2;
    __privateSet(this, _queries, /* @__PURE__ */ new Map());
  }
  build(client2, options, state) {
    const queryKey = options.queryKey;
    const queryHash = options.queryHash ?? hashQueryKeyByOptions(queryKey, options);
    let query = this.get(queryHash);
    if (!query) {
      query = new Query({
        client: client2,
        queryKey,
        queryHash,
        options: client2.defaultQueryOptions(options),
        state,
        defaultOptions: client2.getQueryDefaults(queryKey)
      });
      this.add(query);
    }
    return query;
  }
  add(query) {
    if (!__privateGet(this, _queries).has(query.queryHash)) {
      __privateGet(this, _queries).set(query.queryHash, query);
      this.notify({
        type: "added",
        query
      });
    }
  }
  remove(query) {
    const queryInMap = __privateGet(this, _queries).get(query.queryHash);
    if (queryInMap) {
      query.destroy();
      if (queryInMap === query) {
        __privateGet(this, _queries).delete(query.queryHash);
      }
      this.notify({ type: "removed", query });
    }
  }
  clear() {
    notifyManager.batch(() => {
      this.getAll().forEach((query) => {
        this.remove(query);
      });
    });
  }
  get(queryHash) {
    return __privateGet(this, _queries).get(queryHash);
  }
  getAll() {
    return [...__privateGet(this, _queries).values()];
  }
  find(filters) {
    const defaultedFilters = { exact: true, ...filters };
    return this.getAll().find(
      (query) => matchQuery(defaultedFilters, query)
    );
  }
  findAll(filters = {}) {
    const queries = this.getAll();
    return Object.keys(filters).length > 0 ? queries.filter((query) => matchQuery(filters, query)) : queries;
  }
  notify(event) {
    notifyManager.batch(() => {
      this.listeners.forEach((listener) => {
        listener(event);
      });
    });
  }
  onFocus() {
    notifyManager.batch(() => {
      this.getAll().forEach((query) => {
        query.onFocus();
      });
    });
  }
  onOnline() {
    notifyManager.batch(() => {
      this.getAll().forEach((query) => {
        query.onOnline();
      });
    });
  }
}, _queries = new WeakMap(), _f);
var Mutation = (_g = class extends Removable {
  constructor(config2) {
    super();
    __privateAdd(this, _Mutation_instances);
    __privateAdd(this, _observers);
    __privateAdd(this, _mutationCache);
    __privateAdd(this, _retryer2);
    this.mutationId = config2.mutationId;
    __privateSet(this, _mutationCache, config2.mutationCache);
    __privateSet(this, _observers, []);
    this.state = config2.state || getDefaultState();
    this.setOptions(config2.options);
    this.scheduleGc();
  }
  setOptions(options) {
    this.options = options;
    this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(observer) {
    if (!__privateGet(this, _observers).includes(observer)) {
      __privateGet(this, _observers).push(observer);
      this.clearGcTimeout();
      __privateGet(this, _mutationCache).notify({
        type: "observerAdded",
        mutation: this,
        observer
      });
    }
  }
  removeObserver(observer) {
    __privateSet(this, _observers, __privateGet(this, _observers).filter((x) => x !== observer));
    this.scheduleGc();
    __privateGet(this, _mutationCache).notify({
      type: "observerRemoved",
      mutation: this,
      observer
    });
  }
  optionalRemove() {
    if (!__privateGet(this, _observers).length) {
      if (this.state.status === "pending") {
        this.scheduleGc();
      } else {
        __privateGet(this, _mutationCache).remove(this);
      }
    }
  }
  continue() {
    var _a2;
    return ((_a2 = __privateGet(this, _retryer2)) == null ? void 0 : _a2.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(variables) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
    __privateSet(this, _retryer2, createRetryer({
      fn: () => {
        if (!this.options.mutationFn) {
          return Promise.reject(new Error("No mutationFn found"));
        }
        return this.options.mutationFn(variables);
      },
      onFail: (failureCount, error) => {
        __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, { type: "failed", failureCount, error });
      },
      onPause: () => {
        __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, { type: "pause" });
      },
      onContinue: () => {
        __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => __privateGet(this, _mutationCache).canRun(this)
    }));
    const restored = this.state.status === "pending";
    const isPaused = !__privateGet(this, _retryer2).canStart();
    try {
      if (!restored) {
        __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, { type: "pending", variables, isPaused });
        await ((_b2 = (_a2 = __privateGet(this, _mutationCache).config).onMutate) == null ? void 0 : _b2.call(
          _a2,
          variables,
          this
        ));
        const context = await ((_d2 = (_c2 = this.options).onMutate) == null ? void 0 : _d2.call(_c2, variables));
        if (context !== this.state.context) {
          __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, {
            type: "pending",
            context,
            variables,
            isPaused
          });
        }
      }
      const data = await __privateGet(this, _retryer2).start();
      await ((_f2 = (_e2 = __privateGet(this, _mutationCache).config).onSuccess) == null ? void 0 : _f2.call(
        _e2,
        data,
        variables,
        this.state.context,
        this
      ));
      await ((_h2 = (_g2 = this.options).onSuccess) == null ? void 0 : _h2.call(_g2, data, variables, this.state.context));
      await ((_j2 = (_i2 = __privateGet(this, _mutationCache).config).onSettled) == null ? void 0 : _j2.call(
        _i2,
        data,
        null,
        this.state.variables,
        this.state.context,
        this
      ));
      await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
      __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, { type: "success", data });
      return data;
    } catch (error) {
      try {
        await ((_n = (_m = __privateGet(this, _mutationCache).config).onError) == null ? void 0 : _n.call(
          _m,
          error,
          variables,
          this.state.context,
          this
        ));
        await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(
          _o,
          error,
          variables,
          this.state.context
        ));
        await ((_r = (_q = __privateGet(this, _mutationCache).config).onSettled) == null ? void 0 : _r.call(
          _q,
          void 0,
          error,
          this.state.variables,
          this.state.context,
          this
        ));
        await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(
          _s,
          void 0,
          error,
          variables,
          this.state.context
        ));
        throw error;
      } finally {
        __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, { type: "error", error });
      }
    } finally {
      __privateGet(this, _mutationCache).runNext(this);
    }
  }
}, _observers = new WeakMap(), _mutationCache = new WeakMap(), _retryer2 = new WeakMap(), _Mutation_instances = new WeakSet(), dispatch_fn2 = function(action) {
  const reducer = (state) => {
    switch (action.type) {
      case "failed":
        return {
          ...state,
          failureCount: action.failureCount,
          failureReason: action.error
        };
      case "pause":
        return {
          ...state,
          isPaused: true
        };
      case "continue":
        return {
          ...state,
          isPaused: false
        };
      case "pending":
        return {
          ...state,
          context: action.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: action.isPaused,
          status: "pending",
          variables: action.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...state,
          data: action.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: false
        };
      case "error":
        return {
          ...state,
          data: void 0,
          error: action.error,
          failureCount: state.failureCount + 1,
          failureReason: action.error,
          isPaused: false,
          status: "error"
        };
    }
  };
  this.state = reducer(this.state);
  notifyManager.batch(() => {
    __privateGet(this, _observers).forEach((observer) => {
      observer.onMutationUpdate(action);
    });
    __privateGet(this, _mutationCache).notify({
      mutation: this,
      type: "updated",
      action
    });
  });
}, _g);
function getDefaultState() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var MutationCache = (_h = class extends Subscribable {
  constructor(config2 = {}) {
    super();
    __privateAdd(this, _mutations);
    __privateAdd(this, _scopes);
    __privateAdd(this, _mutationId);
    this.config = config2;
    __privateSet(this, _mutations, /* @__PURE__ */ new Set());
    __privateSet(this, _scopes, /* @__PURE__ */ new Map());
    __privateSet(this, _mutationId, 0);
  }
  build(client2, options, state) {
    const mutation = new Mutation({
      mutationCache: this,
      mutationId: ++__privateWrapper(this, _mutationId)._,
      options: client2.defaultMutationOptions(options),
      state
    });
    this.add(mutation);
    return mutation;
  }
  add(mutation) {
    __privateGet(this, _mutations).add(mutation);
    const scope = scopeFor(mutation);
    if (typeof scope === "string") {
      const scopedMutations = __privateGet(this, _scopes).get(scope);
      if (scopedMutations) {
        scopedMutations.push(mutation);
      } else {
        __privateGet(this, _scopes).set(scope, [mutation]);
      }
    }
    this.notify({ type: "added", mutation });
  }
  remove(mutation) {
    if (__privateGet(this, _mutations).delete(mutation)) {
      const scope = scopeFor(mutation);
      if (typeof scope === "string") {
        const scopedMutations = __privateGet(this, _scopes).get(scope);
        if (scopedMutations) {
          if (scopedMutations.length > 1) {
            const index2 = scopedMutations.indexOf(mutation);
            if (index2 !== -1) {
              scopedMutations.splice(index2, 1);
            }
          } else if (scopedMutations[0] === mutation) {
            __privateGet(this, _scopes).delete(scope);
          }
        }
      }
    }
    this.notify({ type: "removed", mutation });
  }
  canRun(mutation) {
    const scope = scopeFor(mutation);
    if (typeof scope === "string") {
      const mutationsWithSameScope = __privateGet(this, _scopes).get(scope);
      const firstPendingMutation = mutationsWithSameScope == null ? void 0 : mutationsWithSameScope.find(
        (m) => m.state.status === "pending"
      );
      return !firstPendingMutation || firstPendingMutation === mutation;
    } else {
      return true;
    }
  }
  runNext(mutation) {
    var _a2;
    const scope = scopeFor(mutation);
    if (typeof scope === "string") {
      const foundMutation = (_a2 = __privateGet(this, _scopes).get(scope)) == null ? void 0 : _a2.find((m) => m !== mutation && m.state.isPaused);
      return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
    } else {
      return Promise.resolve();
    }
  }
  clear() {
    notifyManager.batch(() => {
      __privateGet(this, _mutations).forEach((mutation) => {
        this.notify({ type: "removed", mutation });
      });
      __privateGet(this, _mutations).clear();
      __privateGet(this, _scopes).clear();
    });
  }
  getAll() {
    return Array.from(__privateGet(this, _mutations));
  }
  find(filters) {
    const defaultedFilters = { exact: true, ...filters };
    return this.getAll().find(
      (mutation) => matchMutation(defaultedFilters, mutation)
    );
  }
  findAll(filters = {}) {
    return this.getAll().filter((mutation) => matchMutation(filters, mutation));
  }
  notify(event) {
    notifyManager.batch(() => {
      this.listeners.forEach((listener) => {
        listener(event);
      });
    });
  }
  resumePausedMutations() {
    const pausedMutations = this.getAll().filter((x) => x.state.isPaused);
    return notifyManager.batch(
      () => Promise.all(
        pausedMutations.map((mutation) => mutation.continue().catch(noop$1))
      )
    );
  }
}, _mutations = new WeakMap(), _scopes = new WeakMap(), _mutationId = new WeakMap(), _h);
function scopeFor(mutation) {
  var _a2;
  return (_a2 = mutation.options.scope) == null ? void 0 : _a2.id;
}
function infiniteQueryBehavior(pages) {
  return {
    onFetch: (context, query) => {
      var _a2, _b2, _c2, _d2, _e2;
      const options = context.options;
      const direction = (_c2 = (_b2 = (_a2 = context.fetchOptions) == null ? void 0 : _a2.meta) == null ? void 0 : _b2.fetchMore) == null ? void 0 : _c2.direction;
      const oldPages = ((_d2 = context.state.data) == null ? void 0 : _d2.pages) || [];
      const oldPageParams = ((_e2 = context.state.data) == null ? void 0 : _e2.pageParams) || [];
      let result2 = { pages: [], pageParams: [] };
      let currentPage = 0;
      const fetchFn = async () => {
        let cancelled = false;
        const addSignalProperty = (object) => {
          Object.defineProperty(object, "signal", {
            enumerable: true,
            get: () => {
              if (context.signal.aborted) {
                cancelled = true;
              } else {
                context.signal.addEventListener("abort", () => {
                  cancelled = true;
                });
              }
              return context.signal;
            }
          });
        };
        const queryFn = ensureQueryFn(context.options, context.fetchOptions);
        const fetchPage = async (data, param, previous) => {
          if (cancelled) {
            return Promise.reject();
          }
          if (param == null && data.pages.length) {
            return Promise.resolve(data);
          }
          const queryFnContext = {
            client: context.client,
            queryKey: context.queryKey,
            pageParam: param,
            direction: previous ? "backward" : "forward",
            meta: context.options.meta
          };
          addSignalProperty(queryFnContext);
          const page = await queryFn(
            queryFnContext
          );
          const { maxPages } = context.options;
          const addTo = previous ? addToStart : addToEnd;
          return {
            pages: addTo(data.pages, page, maxPages),
            pageParams: addTo(data.pageParams, param, maxPages)
          };
        };
        if (direction && oldPages.length) {
          const previous = direction === "backward";
          const pageParamFn = previous ? getPreviousPageParam : getNextPageParam;
          const oldData = {
            pages: oldPages,
            pageParams: oldPageParams
          };
          const param = pageParamFn(options, oldData);
          result2 = await fetchPage(oldData, param, previous);
        } else {
          const remainingPages = pages ?? oldPages.length;
          do {
            const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : getNextPageParam(options, result2);
            if (currentPage > 0 && param == null) {
              break;
            }
            result2 = await fetchPage(result2, param);
            currentPage++;
          } while (currentPage < remainingPages);
        }
        return result2;
      };
      if (context.options.persister) {
        context.fetchFn = () => {
          var _a3, _b3;
          return (_b3 = (_a3 = context.options).persister) == null ? void 0 : _b3.call(
            _a3,
            fetchFn,
            {
              client: context.client,
              queryKey: context.queryKey,
              meta: context.options.meta,
              signal: context.signal
            },
            query
          );
        };
      } else {
        context.fetchFn = fetchFn;
      }
    }
  };
}
function getNextPageParam(options, { pages, pageParams }) {
  const lastIndex = pages.length - 1;
  return pages.length > 0 ? options.getNextPageParam(
    pages[lastIndex],
    pages,
    pageParams[lastIndex],
    pageParams
  ) : void 0;
}
function getPreviousPageParam(options, { pages, pageParams }) {
  var _a2;
  return pages.length > 0 ? (_a2 = options.getPreviousPageParam) == null ? void 0 : _a2.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
var QueryClient = (_i = class {
  constructor(config2 = {}) {
    __privateAdd(this, _queryCache);
    __privateAdd(this, _mutationCache2);
    __privateAdd(this, _defaultOptions2);
    __privateAdd(this, _queryDefaults);
    __privateAdd(this, _mutationDefaults);
    __privateAdd(this, _mountCount);
    __privateAdd(this, _unsubscribeFocus);
    __privateAdd(this, _unsubscribeOnline);
    __privateSet(this, _queryCache, config2.queryCache || new QueryCache());
    __privateSet(this, _mutationCache2, config2.mutationCache || new MutationCache());
    __privateSet(this, _defaultOptions2, config2.defaultOptions || {});
    __privateSet(this, _queryDefaults, /* @__PURE__ */ new Map());
    __privateSet(this, _mutationDefaults, /* @__PURE__ */ new Map());
    __privateSet(this, _mountCount, 0);
  }
  mount() {
    __privateWrapper(this, _mountCount)._++;
    if (__privateGet(this, _mountCount) !== 1)
      return;
    __privateSet(this, _unsubscribeFocus, focusManager.subscribe(async (focused) => {
      if (focused) {
        await this.resumePausedMutations();
        __privateGet(this, _queryCache).onFocus();
      }
    }));
    __privateSet(this, _unsubscribeOnline, onlineManager.subscribe(async (online) => {
      if (online) {
        await this.resumePausedMutations();
        __privateGet(this, _queryCache).onOnline();
      }
    }));
  }
  unmount() {
    var _a2, _b2;
    __privateWrapper(this, _mountCount)._--;
    if (__privateGet(this, _mountCount) !== 0)
      return;
    (_a2 = __privateGet(this, _unsubscribeFocus)) == null ? void 0 : _a2.call(this);
    __privateSet(this, _unsubscribeFocus, void 0);
    (_b2 = __privateGet(this, _unsubscribeOnline)) == null ? void 0 : _b2.call(this);
    __privateSet(this, _unsubscribeOnline, void 0);
  }
  isFetching(filters) {
    return __privateGet(this, _queryCache).findAll({ ...filters, fetchStatus: "fetching" }).length;
  }
  isMutating(filters) {
    return __privateGet(this, _mutationCache2).findAll({ ...filters, status: "pending" }).length;
  }
  getQueryData(queryKey) {
    var _a2;
    const options = this.defaultQueryOptions({ queryKey });
    return (_a2 = __privateGet(this, _queryCache).get(options.queryHash)) == null ? void 0 : _a2.state.data;
  }
  ensureQueryData(options) {
    const defaultedOptions = this.defaultQueryOptions(options);
    const query = __privateGet(this, _queryCache).build(this, defaultedOptions);
    const cachedData = query.state.data;
    if (cachedData === void 0) {
      return this.fetchQuery(options);
    }
    if (options.revalidateIfStale && query.isStaleByTime(resolveStaleTime(defaultedOptions.staleTime, query))) {
      void this.prefetchQuery(defaultedOptions);
    }
    return Promise.resolve(cachedData);
  }
  getQueriesData(filters) {
    return __privateGet(this, _queryCache).findAll(filters).map(({ queryKey, state }) => {
      const data = state.data;
      return [queryKey, data];
    });
  }
  setQueryData(queryKey, updater, options) {
    const defaultedOptions = this.defaultQueryOptions({ queryKey });
    const query = __privateGet(this, _queryCache).get(
      defaultedOptions.queryHash
    );
    const prevData = query == null ? void 0 : query.state.data;
    const data = functionalUpdate(updater, prevData);
    if (data === void 0) {
      return void 0;
    }
    return __privateGet(this, _queryCache).build(this, defaultedOptions).setData(data, { ...options, manual: true });
  }
  setQueriesData(filters, updater, options) {
    return notifyManager.batch(
      () => __privateGet(this, _queryCache).findAll(filters).map(({ queryKey }) => [
        queryKey,
        this.setQueryData(queryKey, updater, options)
      ])
    );
  }
  getQueryState(queryKey) {
    var _a2;
    const options = this.defaultQueryOptions({ queryKey });
    return (_a2 = __privateGet(this, _queryCache).get(
      options.queryHash
    )) == null ? void 0 : _a2.state;
  }
  removeQueries(filters) {
    const queryCache = __privateGet(this, _queryCache);
    notifyManager.batch(() => {
      queryCache.findAll(filters).forEach((query) => {
        queryCache.remove(query);
      });
    });
  }
  resetQueries(filters, options) {
    const queryCache = __privateGet(this, _queryCache);
    return notifyManager.batch(() => {
      queryCache.findAll(filters).forEach((query) => {
        query.reset();
      });
      return this.refetchQueries(
        {
          type: "active",
          ...filters
        },
        options
      );
    });
  }
  cancelQueries(filters, cancelOptions = {}) {
    const defaultedCancelOptions = { revert: true, ...cancelOptions };
    const promises = notifyManager.batch(
      () => __privateGet(this, _queryCache).findAll(filters).map((query) => query.cancel(defaultedCancelOptions))
    );
    return Promise.all(promises).then(noop$1).catch(noop$1);
  }
  invalidateQueries(filters, options = {}) {
    return notifyManager.batch(() => {
      __privateGet(this, _queryCache).findAll(filters).forEach((query) => {
        query.invalidate();
      });
      if ((filters == null ? void 0 : filters.refetchType) === "none") {
        return Promise.resolve();
      }
      return this.refetchQueries(
        {
          ...filters,
          type: (filters == null ? void 0 : filters.refetchType) ?? (filters == null ? void 0 : filters.type) ?? "active"
        },
        options
      );
    });
  }
  refetchQueries(filters, options = {}) {
    const fetchOptions = {
      ...options,
      cancelRefetch: options.cancelRefetch ?? true
    };
    const promises = notifyManager.batch(
      () => __privateGet(this, _queryCache).findAll(filters).filter((query) => !query.isDisabled()).map((query) => {
        let promise = query.fetch(void 0, fetchOptions);
        if (!fetchOptions.throwOnError) {
          promise = promise.catch(noop$1);
        }
        return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
      })
    );
    return Promise.all(promises).then(noop$1);
  }
  fetchQuery(options) {
    const defaultedOptions = this.defaultQueryOptions(options);
    if (defaultedOptions.retry === void 0) {
      defaultedOptions.retry = false;
    }
    const query = __privateGet(this, _queryCache).build(this, defaultedOptions);
    return query.isStaleByTime(
      resolveStaleTime(defaultedOptions.staleTime, query)
    ) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  }
  prefetchQuery(options) {
    return this.fetchQuery(options).then(noop$1).catch(noop$1);
  }
  fetchInfiniteQuery(options) {
    options.behavior = infiniteQueryBehavior(options.pages);
    return this.fetchQuery(options);
  }
  prefetchInfiniteQuery(options) {
    return this.fetchInfiniteQuery(options).then(noop$1).catch(noop$1);
  }
  ensureInfiniteQueryData(options) {
    options.behavior = infiniteQueryBehavior(options.pages);
    return this.ensureQueryData(options);
  }
  resumePausedMutations() {
    if (onlineManager.isOnline()) {
      return __privateGet(this, _mutationCache2).resumePausedMutations();
    }
    return Promise.resolve();
  }
  getQueryCache() {
    return __privateGet(this, _queryCache);
  }
  getMutationCache() {
    return __privateGet(this, _mutationCache2);
  }
  getDefaultOptions() {
    return __privateGet(this, _defaultOptions2);
  }
  setDefaultOptions(options) {
    __privateSet(this, _defaultOptions2, options);
  }
  setQueryDefaults(queryKey, options) {
    __privateGet(this, _queryDefaults).set(hashKey(queryKey), {
      queryKey,
      defaultOptions: options
    });
  }
  getQueryDefaults(queryKey) {
    const defaults2 = [...__privateGet(this, _queryDefaults).values()];
    const result2 = {};
    defaults2.forEach((queryDefault) => {
      if (partialMatchKey(queryKey, queryDefault.queryKey)) {
        Object.assign(result2, queryDefault.defaultOptions);
      }
    });
    return result2;
  }
  setMutationDefaults(mutationKey, options) {
    __privateGet(this, _mutationDefaults).set(hashKey(mutationKey), {
      mutationKey,
      defaultOptions: options
    });
  }
  getMutationDefaults(mutationKey) {
    const defaults2 = [...__privateGet(this, _mutationDefaults).values()];
    const result2 = {};
    defaults2.forEach((queryDefault) => {
      if (partialMatchKey(mutationKey, queryDefault.mutationKey)) {
        Object.assign(result2, queryDefault.defaultOptions);
      }
    });
    return result2;
  }
  defaultQueryOptions(options) {
    if (options._defaulted) {
      return options;
    }
    const defaultedOptions = {
      ...__privateGet(this, _defaultOptions2).queries,
      ...this.getQueryDefaults(options.queryKey),
      ...options,
      _defaulted: true
    };
    if (!defaultedOptions.queryHash) {
      defaultedOptions.queryHash = hashQueryKeyByOptions(
        defaultedOptions.queryKey,
        defaultedOptions
      );
    }
    if (defaultedOptions.refetchOnReconnect === void 0) {
      defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
    }
    if (defaultedOptions.throwOnError === void 0) {
      defaultedOptions.throwOnError = !!defaultedOptions.suspense;
    }
    if (!defaultedOptions.networkMode && defaultedOptions.persister) {
      defaultedOptions.networkMode = "offlineFirst";
    }
    if (defaultedOptions.queryFn === skipToken) {
      defaultedOptions.enabled = false;
    }
    return defaultedOptions;
  }
  defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }
    return {
      ...__privateGet(this, _defaultOptions2).mutations,
      ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
      ...options,
      _defaulted: true
    };
  }
  clear() {
    __privateGet(this, _queryCache).clear();
    __privateGet(this, _mutationCache2).clear();
  }
}, _queryCache = new WeakMap(), _mutationCache2 = new WeakMap(), _defaultOptions2 = new WeakMap(), _queryDefaults = new WeakMap(), _mutationDefaults = new WeakMap(), _mountCount = new WeakMap(), _unsubscribeFocus = new WeakMap(), _unsubscribeOnline = new WeakMap(), _i);
var QueryObserver = (_j = class extends Subscribable {
  constructor(client2, options) {
    super();
    __privateAdd(this, _QueryObserver_instances);
    __privateAdd(this, _client2);
    __privateAdd(this, _currentQuery);
    __privateAdd(this, _currentQueryInitialState);
    __privateAdd(this, _currentResult);
    __privateAdd(this, _currentResultState);
    __privateAdd(this, _currentResultOptions);
    __privateAdd(this, _currentThenable);
    __privateAdd(this, _selectError);
    __privateAdd(this, _selectFn);
    __privateAdd(this, _selectResult);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    __privateAdd(this, _lastQueryWithDefinedData);
    __privateAdd(this, _staleTimeoutId);
    __privateAdd(this, _refetchIntervalId);
    __privateAdd(this, _currentRefetchInterval);
    __privateAdd(this, _trackedProps, /* @__PURE__ */ new Set());
    this.options = options;
    __privateSet(this, _client2, client2);
    __privateSet(this, _selectError, null);
    __privateSet(this, _currentThenable, pendingThenable());
    if (!this.options.experimental_prefetchInRender) {
      __privateGet(this, _currentThenable).reject(
        new Error("experimental_prefetchInRender feature flag is not enabled")
      );
    }
    this.bindMethods();
    this.setOptions(options);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    if (this.listeners.size === 1) {
      __privateGet(this, _currentQuery).addObserver(this);
      if (shouldFetchOnMount(__privateGet(this, _currentQuery), this.options)) {
        __privateMethod(this, _QueryObserver_instances, executeFetch_fn).call(this);
      } else {
        this.updateResult();
      }
      __privateMethod(this, _QueryObserver_instances, updateTimers_fn).call(this);
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.destroy();
    }
  }
  shouldFetchOnReconnect() {
    return shouldFetchOn(
      __privateGet(this, _currentQuery),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return shouldFetchOn(
      __privateGet(this, _currentQuery),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set();
    __privateMethod(this, _QueryObserver_instances, clearStaleTimeout_fn).call(this);
    __privateMethod(this, _QueryObserver_instances, clearRefetchInterval_fn).call(this);
    __privateGet(this, _currentQuery).removeObserver(this);
  }
  setOptions(options, notifyOptions) {
    const prevOptions = this.options;
    const prevQuery = __privateGet(this, _currentQuery);
    this.options = __privateGet(this, _client2).defaultQueryOptions(options);
    if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof resolveEnabled(this.options.enabled, __privateGet(this, _currentQuery)) !== "boolean") {
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    }
    __privateMethod(this, _QueryObserver_instances, updateQuery_fn).call(this);
    __privateGet(this, _currentQuery).setOptions(this.options);
    if (prevOptions._defaulted && !shallowEqualObjects(this.options, prevOptions)) {
      __privateGet(this, _client2).getQueryCache().notify({
        type: "observerOptionsUpdated",
        query: __privateGet(this, _currentQuery),
        observer: this
      });
    }
    const mounted = this.hasListeners();
    if (mounted && shouldFetchOptionally(
      __privateGet(this, _currentQuery),
      prevQuery,
      this.options,
      prevOptions
    )) {
      __privateMethod(this, _QueryObserver_instances, executeFetch_fn).call(this);
    }
    this.updateResult(notifyOptions);
    if (mounted && (__privateGet(this, _currentQuery) !== prevQuery || resolveEnabled(this.options.enabled, __privateGet(this, _currentQuery)) !== resolveEnabled(prevOptions.enabled, __privateGet(this, _currentQuery)) || resolveStaleTime(this.options.staleTime, __privateGet(this, _currentQuery)) !== resolveStaleTime(prevOptions.staleTime, __privateGet(this, _currentQuery)))) {
      __privateMethod(this, _QueryObserver_instances, updateStaleTimeout_fn).call(this);
    }
    const nextRefetchInterval = __privateMethod(this, _QueryObserver_instances, computeRefetchInterval_fn).call(this);
    if (mounted && (__privateGet(this, _currentQuery) !== prevQuery || resolveEnabled(this.options.enabled, __privateGet(this, _currentQuery)) !== resolveEnabled(prevOptions.enabled, __privateGet(this, _currentQuery)) || nextRefetchInterval !== __privateGet(this, _currentRefetchInterval))) {
      __privateMethod(this, _QueryObserver_instances, updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
  }
  getOptimisticResult(options) {
    const query = __privateGet(this, _client2).getQueryCache().build(__privateGet(this, _client2), options);
    const result2 = this.createResult(query, options);
    if (shouldAssignObserverCurrentProperties(this, result2)) {
      __privateSet(this, _currentResult, result2);
      __privateSet(this, _currentResultOptions, this.options);
      __privateSet(this, _currentResultState, __privateGet(this, _currentQuery).state);
    }
    return result2;
  }
  getCurrentResult() {
    return __privateGet(this, _currentResult);
  }
  trackResult(result2, onPropTracked) {
    const trackedResult = {};
    Object.keys(result2).forEach((key) => {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: () => {
          this.trackProp(key);
          onPropTracked == null ? void 0 : onPropTracked(key);
          return result2[key];
        }
      });
    });
    return trackedResult;
  }
  trackProp(key) {
    __privateGet(this, _trackedProps).add(key);
  }
  getCurrentQuery() {
    return __privateGet(this, _currentQuery);
  }
  refetch({ ...options } = {}) {
    return this.fetch({
      ...options
    });
  }
  fetchOptimistic(options) {
    const defaultedOptions = __privateGet(this, _client2).defaultQueryOptions(options);
    const query = __privateGet(this, _client2).getQueryCache().build(__privateGet(this, _client2), defaultedOptions);
    return query.fetch().then(() => this.createResult(query, defaultedOptions));
  }
  fetch(fetchOptions) {
    return __privateMethod(this, _QueryObserver_instances, executeFetch_fn).call(this, {
      ...fetchOptions,
      cancelRefetch: fetchOptions.cancelRefetch ?? true
    }).then(() => {
      this.updateResult();
      return __privateGet(this, _currentResult);
    });
  }
  createResult(query, options) {
    var _a2;
    const prevQuery = __privateGet(this, _currentQuery);
    const prevOptions = this.options;
    const prevResult = __privateGet(this, _currentResult);
    const prevResultState = __privateGet(this, _currentResultState);
    const prevResultOptions = __privateGet(this, _currentResultOptions);
    const queryChange = query !== prevQuery;
    const queryInitialState = queryChange ? query.state : __privateGet(this, _currentQueryInitialState);
    const { state } = query;
    let newState = { ...state };
    let isPlaceholderData = false;
    let data;
    if (options._optimisticResults) {
      const mounted = this.hasListeners();
      const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
      if (fetchOnMount || fetchOptionally) {
        newState = {
          ...newState,
          ...fetchState(state.data, query.options)
        };
      }
      if (options._optimisticResults === "isRestoring") {
        newState.fetchStatus = "idle";
      }
    }
    let { error, errorUpdatedAt, status } = newState;
    if (options.select && newState.data !== void 0) {
      if (prevResult && newState.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === __privateGet(this, _selectFn)) {
        data = __privateGet(this, _selectResult);
      } else {
        try {
          __privateSet(this, _selectFn, options.select);
          data = options.select(newState.data);
          data = replaceData(prevResult == null ? void 0 : prevResult.data, data, options);
          __privateSet(this, _selectResult, data);
          __privateSet(this, _selectError, null);
        } catch (selectError) {
          __privateSet(this, _selectError, selectError);
        }
      }
    } else {
      data = newState.data;
    }
    if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
      let placeholderData;
      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === "function" ? options.placeholderData(
          (_a2 = __privateGet(this, _lastQueryWithDefinedData)) == null ? void 0 : _a2.state.data,
          __privateGet(this, _lastQueryWithDefinedData)
        ) : options.placeholderData;
        if (options.select && placeholderData !== void 0) {
          try {
            placeholderData = options.select(placeholderData);
            __privateSet(this, _selectError, null);
          } catch (selectError) {
            __privateSet(this, _selectError, selectError);
          }
        }
      }
      if (placeholderData !== void 0) {
        status = "success";
        data = replaceData(
          prevResult == null ? void 0 : prevResult.data,
          placeholderData,
          options
        );
        isPlaceholderData = true;
      }
    }
    if (__privateGet(this, _selectError)) {
      error = __privateGet(this, _selectError);
      data = __privateGet(this, _selectResult);
      errorUpdatedAt = Date.now();
      status = "error";
    }
    const isFetching = newState.fetchStatus === "fetching";
    const isPending = status === "pending";
    const isError2 = status === "error";
    const isLoading = isPending && isFetching;
    const hasData = data !== void 0;
    const result2 = {
      status,
      fetchStatus: newState.fetchStatus,
      isPending,
      isSuccess: status === "success",
      isError: isError2,
      isInitialLoading: isLoading,
      isLoading,
      data,
      dataUpdatedAt: newState.dataUpdatedAt,
      error,
      errorUpdatedAt,
      failureCount: newState.fetchFailureCount,
      failureReason: newState.fetchFailureReason,
      errorUpdateCount: newState.errorUpdateCount,
      isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
      isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching,
      isRefetching: isFetching && !isPending,
      isLoadingError: isError2 && !hasData,
      isPaused: newState.fetchStatus === "paused",
      isPlaceholderData,
      isRefetchError: isError2 && hasData,
      isStale: isStale(query, options),
      refetch: this.refetch,
      promise: __privateGet(this, _currentThenable)
    };
    const nextResult = result2;
    if (this.options.experimental_prefetchInRender) {
      const finalizeThenableIfPossible = (thenable) => {
        if (nextResult.status === "error") {
          thenable.reject(nextResult.error);
        } else if (nextResult.data !== void 0) {
          thenable.resolve(nextResult.data);
        }
      };
      const recreateThenable = () => {
        const pending2 = __privateSet(this, _currentThenable, nextResult.promise = pendingThenable());
        finalizeThenableIfPossible(pending2);
      };
      const prevThenable = __privateGet(this, _currentThenable);
      switch (prevThenable.status) {
        case "pending":
          if (query.queryHash === prevQuery.queryHash) {
            finalizeThenableIfPossible(prevThenable);
          }
          break;
        case "fulfilled":
          if (nextResult.status === "error" || nextResult.data !== prevThenable.value) {
            recreateThenable();
          }
          break;
        case "rejected":
          if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) {
            recreateThenable();
          }
          break;
      }
    }
    return nextResult;
  }
  updateResult(notifyOptions) {
    const prevResult = __privateGet(this, _currentResult);
    const nextResult = this.createResult(__privateGet(this, _currentQuery), this.options);
    __privateSet(this, _currentResultState, __privateGet(this, _currentQuery).state);
    __privateSet(this, _currentResultOptions, this.options);
    if (__privateGet(this, _currentResultState).data !== void 0) {
      __privateSet(this, _lastQueryWithDefinedData, __privateGet(this, _currentQuery));
    }
    if (shallowEqualObjects(nextResult, prevResult)) {
      return;
    }
    __privateSet(this, _currentResult, nextResult);
    const defaultNotifyOptions = {};
    const shouldNotifyListeners = () => {
      if (!prevResult) {
        return true;
      }
      const { notifyOnChangeProps } = this.options;
      const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
      if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !__privateGet(this, _trackedProps).size) {
        return true;
      }
      const includedProps = new Set(
        notifyOnChangePropsValue ?? __privateGet(this, _trackedProps)
      );
      if (this.options.throwOnError) {
        includedProps.add("error");
      }
      return Object.keys(__privateGet(this, _currentResult)).some((key) => {
        const typedKey = key;
        const changed = __privateGet(this, _currentResult)[typedKey] !== prevResult[typedKey];
        return changed && includedProps.has(typedKey);
      });
    };
    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) {
      defaultNotifyOptions.listeners = true;
    }
    __privateMethod(this, _QueryObserver_instances, notify_fn).call(this, { ...defaultNotifyOptions, ...notifyOptions });
  }
  onQueryUpdate() {
    this.updateResult();
    if (this.hasListeners()) {
      __privateMethod(this, _QueryObserver_instances, updateTimers_fn).call(this);
    }
  }
}, _client2 = new WeakMap(), _currentQuery = new WeakMap(), _currentQueryInitialState = new WeakMap(), _currentResult = new WeakMap(), _currentResultState = new WeakMap(), _currentResultOptions = new WeakMap(), _currentThenable = new WeakMap(), _selectError = new WeakMap(), _selectFn = new WeakMap(), _selectResult = new WeakMap(), _lastQueryWithDefinedData = new WeakMap(), _staleTimeoutId = new WeakMap(), _refetchIntervalId = new WeakMap(), _currentRefetchInterval = new WeakMap(), _trackedProps = new WeakMap(), _QueryObserver_instances = new WeakSet(), executeFetch_fn = function(fetchOptions) {
  __privateMethod(this, _QueryObserver_instances, updateQuery_fn).call(this);
  let promise = __privateGet(this, _currentQuery).fetch(
    this.options,
    fetchOptions
  );
  if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
    promise = promise.catch(noop$1);
  }
  return promise;
}, updateStaleTimeout_fn = function() {
  __privateMethod(this, _QueryObserver_instances, clearStaleTimeout_fn).call(this);
  const staleTime = resolveStaleTime(
    this.options.staleTime,
    __privateGet(this, _currentQuery)
  );
  if (isServer || __privateGet(this, _currentResult).isStale || !isValidTimeout(staleTime)) {
    return;
  }
  const time = timeUntilStale(__privateGet(this, _currentResult).dataUpdatedAt, staleTime);
  const timeout2 = time + 1;
  __privateSet(this, _staleTimeoutId, setTimeout(() => {
    if (!__privateGet(this, _currentResult).isStale) {
      this.updateResult();
    }
  }, timeout2));
}, computeRefetchInterval_fn = function() {
  return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(__privateGet(this, _currentQuery)) : this.options.refetchInterval) ?? false;
}, updateRefetchInterval_fn = function(nextInterval) {
  __privateMethod(this, _QueryObserver_instances, clearRefetchInterval_fn).call(this);
  __privateSet(this, _currentRefetchInterval, nextInterval);
  if (isServer || resolveEnabled(this.options.enabled, __privateGet(this, _currentQuery)) === false || !isValidTimeout(__privateGet(this, _currentRefetchInterval)) || __privateGet(this, _currentRefetchInterval) === 0) {
    return;
  }
  __privateSet(this, _refetchIntervalId, setInterval(() => {
    if (this.options.refetchIntervalInBackground || focusManager.isFocused()) {
      __privateMethod(this, _QueryObserver_instances, executeFetch_fn).call(this);
    }
  }, __privateGet(this, _currentRefetchInterval)));
}, updateTimers_fn = function() {
  __privateMethod(this, _QueryObserver_instances, updateStaleTimeout_fn).call(this);
  __privateMethod(this, _QueryObserver_instances, updateRefetchInterval_fn).call(this, __privateMethod(this, _QueryObserver_instances, computeRefetchInterval_fn).call(this));
}, clearStaleTimeout_fn = function() {
  if (__privateGet(this, _staleTimeoutId)) {
    clearTimeout(__privateGet(this, _staleTimeoutId));
    __privateSet(this, _staleTimeoutId, void 0);
  }
}, clearRefetchInterval_fn = function() {
  if (__privateGet(this, _refetchIntervalId)) {
    clearInterval(__privateGet(this, _refetchIntervalId));
    __privateSet(this, _refetchIntervalId, void 0);
  }
}, updateQuery_fn = function() {
  const query = __privateGet(this, _client2).getQueryCache().build(__privateGet(this, _client2), this.options);
  if (query === __privateGet(this, _currentQuery)) {
    return;
  }
  const prevQuery = __privateGet(this, _currentQuery);
  __privateSet(this, _currentQuery, query);
  __privateSet(this, _currentQueryInitialState, query.state);
  if (this.hasListeners()) {
    prevQuery == null ? void 0 : prevQuery.removeObserver(this);
    query.addObserver(this);
  }
}, notify_fn = function(notifyOptions) {
  notifyManager.batch(() => {
    if (notifyOptions.listeners) {
      this.listeners.forEach((listener) => {
        listener(__privateGet(this, _currentResult));
      });
    }
    __privateGet(this, _client2).getQueryCache().notify({
      query: __privateGet(this, _currentQuery),
      type: "observerResultsUpdated"
    });
  });
}, _j);
function shouldLoadOnMount(query, options) {
  return resolveEnabled(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.data !== void 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
  if (resolveEnabled(options.enabled, query) !== false) {
    const value = typeof field === "function" ? field(query) : field;
    return value === "always" || value !== false && isStale(query, options);
  }
  return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return (query !== prevQuery || resolveEnabled(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && isStale(query, options);
}
function isStale(query, options) {
  return resolveEnabled(options.enabled, query) !== false && query.isStaleByTime(resolveStaleTime(options.staleTime, query));
}
function shouldAssignObserverCurrentProperties(observer, optimisticResult) {
  if (!shallowEqualObjects(observer.getCurrentResult(), optimisticResult)) {
    return true;
  }
  return false;
}
var QueryClientContext = React.createContext(
  void 0
);
var useQueryClient = (queryClient2) => {
  const client2 = React.useContext(QueryClientContext);
  if (queryClient2) {
    return queryClient2;
  }
  if (!client2) {
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  }
  return client2;
};
var QueryClientProvider = ({
  client: client2,
  children
}) => {
  React.useEffect(() => {
    client2.mount();
    return () => {
      client2.unmount();
    };
  }, [client2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(QueryClientContext.Provider, { value: client2, children });
};
var IsRestoringContext = React.createContext(false);
var useIsRestoring = () => React.useContext(IsRestoringContext);
IsRestoringContext.Provider;
function createValue() {
  let isReset = false;
  return {
    clearReset: () => {
      isReset = false;
    },
    reset: () => {
      isReset = true;
    },
    isReset: () => {
      return isReset;
    }
  };
}
var QueryErrorResetBoundaryContext = React.createContext(createValue());
var useQueryErrorResetBoundary = () => React.useContext(QueryErrorResetBoundaryContext);
function shouldThrowError(throwError, params) {
  if (typeof throwError === "function") {
    return throwError(...params);
  }
  return !!throwError;
}
function noop() {
}
var ensurePreventErrorBoundaryRetry = (options, errorResetBoundary) => {
  if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
    if (!errorResetBoundary.isReset()) {
      options.retryOnMount = false;
    }
  }
};
var useClearResetErrorBoundary = (errorResetBoundary) => {
  React.useEffect(() => {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
};
var getHasError = ({
  result: result2,
  errorResetBoundary,
  throwOnError,
  query,
  suspense
}) => {
  return result2.isError && !errorResetBoundary.isReset() && !result2.isFetching && query && (suspense && result2.data === void 0 || shouldThrowError(throwOnError, [result2.error, query]));
};
var ensureSuspenseTimers = (defaultedOptions) => {
  const originalStaleTime = defaultedOptions.staleTime;
  if (defaultedOptions.suspense) {
    defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args) => Math.max(originalStaleTime(...args), 1e3) : Math.max(originalStaleTime ?? 1e3, 1e3);
    if (typeof defaultedOptions.gcTime === "number") {
      defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
  }
};
var willFetch = (result2, isRestoring) => result2.isLoading && result2.isFetching && !isRestoring;
var shouldSuspend = (defaultedOptions, result2) => (defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result2.isPending;
var fetchOptimistic = (defaultedOptions, observer, errorResetBoundary) => observer.fetchOptimistic(defaultedOptions).catch(() => {
  errorResetBoundary.clearReset();
});
function useBaseQuery(options, Observer, queryClient2) {
  var _a2, _b2, _c2, _d2, _e2;
  if (process.env.NODE_ENV !== "production") {
    if (typeof options !== "object" || Array.isArray(options)) {
      throw new Error(
        'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
      );
    }
  }
  const client2 = useQueryClient(queryClient2);
  const isRestoring = useIsRestoring();
  const errorResetBoundary = useQueryErrorResetBoundary();
  const defaultedOptions = client2.defaultQueryOptions(options);
  (_b2 = (_a2 = client2.getDefaultOptions().queries) == null ? void 0 : _a2._experimental_beforeQuery) == null ? void 0 : _b2.call(
    _a2,
    defaultedOptions
  );
  if (process.env.NODE_ENV !== "production") {
    if (!defaultedOptions.queryFn) {
      console.error(
        `[${defaultedOptions.queryHash}]: No queryFn was passed as an option, and no default queryFn was found. The queryFn parameter is only optional when using a default queryFn. More info here: https://tanstack.com/query/latest/docs/framework/react/guides/default-query-function`
      );
    }
  }
  defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
  ensureSuspenseTimers(defaultedOptions);
  ensurePreventErrorBoundaryRetry(defaultedOptions, errorResetBoundary);
  useClearResetErrorBoundary(errorResetBoundary);
  const isNewCacheEntry = !client2.getQueryCache().get(defaultedOptions.queryHash);
  const [observer] = React.useState(
    () => new Observer(
      client2,
      defaultedOptions
    )
  );
  const result2 = observer.getOptimisticResult(defaultedOptions);
  const shouldSubscribe = !isRestoring && options.subscribed !== false;
  React.useSyncExternalStore(
    React.useCallback(
      (onStoreChange) => {
        const unsubscribe = shouldSubscribe ? observer.subscribe(notifyManager.batchCalls(onStoreChange)) : noop;
        observer.updateResult();
        return unsubscribe;
      },
      [observer, shouldSubscribe]
    ),
    () => observer.getCurrentResult(),
    () => observer.getCurrentResult()
  );
  React.useEffect(() => {
    observer.setOptions(defaultedOptions, { listeners: false });
  }, [defaultedOptions, observer]);
  if (shouldSuspend(defaultedOptions, result2)) {
    throw fetchOptimistic(defaultedOptions, observer, errorResetBoundary);
  }
  if (getHasError({
    result: result2,
    errorResetBoundary,
    throwOnError: defaultedOptions.throwOnError,
    query: client2.getQueryCache().get(defaultedOptions.queryHash),
    suspense: defaultedOptions.suspense
  })) {
    throw result2.error;
  }
  (_d2 = (_c2 = client2.getDefaultOptions().queries) == null ? void 0 : _c2._experimental_afterQuery) == null ? void 0 : _d2.call(
    _c2,
    defaultedOptions,
    result2
  );
  if (defaultedOptions.experimental_prefetchInRender && !isServer && willFetch(result2, isRestoring)) {
    const promise = isNewCacheEntry ? (
      // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
      fetchOptimistic(defaultedOptions, observer, errorResetBoundary)
    ) : (
      // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
      (_e2 = client2.getQueryCache().get(defaultedOptions.queryHash)) == null ? void 0 : _e2.promise
    );
    promise == null ? void 0 : promise.catch(noop).finally(() => {
      observer.updateResult();
    });
  }
  return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result2) : result2;
}
function useQuery(options, queryClient2) {
  return useBaseQuery(options, QueryObserver, queryClient2);
}
const AMPLITUDE_EVENTS = {
  CHANGE_FIELD: "change_field",
  DISMISS_MODAL: "dismiss_modal",
  REPORT_DIAGNOSTICS: "report_diagnostics",
  REPORT_PERFORMANCE_TELMETRY: "report_performance_telemetry",
  INITIALIZE_APPLICATION: "initialize_application_complete_event",
  LIAT_APP_START: "cached_liat_load_complete_event",
  LIAT_APP_START_FULL: "full_liat_load_complete_event",
  SELECT_BUTTON: "select_button",
  SELECT_EVENT: "select_event",
  SELECT_FIELD: "select_field",
  SELECT_LINK: "select_link",
  SELECT_MENU: "select_menu",
  SELECT_MODAL: "select_modal",
  SELECT_SLIDER: "select_slider",
  SELECT_TOOLTIP: "select_tooltip",
  SELECT_VIEW: "select_view",
  SELECT_WIDGET: "select_widget",
  SELECT_TITLE: "select_title",
  SELECT_SEARCH: "select_search",
  STARTFLOW_LINK_ACCOUNT: "startflow_link_account",
  ENDFLOW_LINK_ACCOUNT: "endflow_link_account",
  TOGGLE_EVENT: "toggle_event",
  TTLIATF: "time_to_liat_full_load",
  TTLIAT: "time_to_liat_load",
  VIEW_PAGE: "view_page",
  VIEW_WIDGET: "view_widget",
  VIEW_ZS_CARD: "view_zero_state_card",
  SELECT_DASHBOARD_TILE: "select_dashboard_tile",
  DEFAULT_TAB: "default_tab"
};
const dispatchAmplitude = ({
  eventType,
  selection,
  payload
}) => {
  if (!eventType) {
    throw new Error("eventType is required");
  }
  if (!selection) {
    throw new Error("selection is required");
  }
  const eventBus = new EventBus(window, document);
  return eventBus.dispatchAmplitude({
    event_type: eventType,
    event_properties: {
      selection,
      ...payload
    }
  });
};
const PaeConstants = {
  PAE: "PAE",
  PRIVILEGED: "PRIVILEGED",
  PARTICIPANT: "PARTICIPANT"
};
const logger$1 = ExternalLogger$1.getInstance("IntegratedEligibilityService");
`${__HTTP_PREFIX__}://localhost:${__LOGIN_UI_PORT__}`;
const handleEligibilityServiceResponse = (data, currentStoredData) => {
  const usingLocalMocks = isLocalhost() && hasMocks();
  globalThis.integratedEligibility = {
    ...currentStoredData,
    ...data.data,
    eligibilityLoaded: true,
    groupDetails: data.logInfo,
    notifications: data.notifications
  };
  if (!globalThis.integratedEligibility.setEmulator) {
    if (usingLocalMocks) {
      globalThis.integratedEligibility.isEmulator = globalThis.forceEmulator || false;
      globalThis.integratedEligibility.setEmulator = true;
    } else {
      globalThis.integratedEligibility.isEmulator = globalThis.forceEmulator || data.data.type !== PaeConstants.PARTICIPANT;
      globalThis.integratedEligibility.setEmulator = true;
    }
  }
  if (pcapBundleEnv) {
    let pcapEnv = getParameterByName("pcapBundle");
    if (pcapEnv === "prod") {
      pcapEnv = "";
    } else {
      pcapEnv = "-" + pcapEnv;
    }
    const pcapEnvUrl = "pc-api" + pcapEnv;
    const baseUrl = window.location.protocol + "//" + pcapEnvUrl + "." + window.location.host.split(".").slice(1).join(".");
    const versionPath = "/static/bin/version.json";
    $.ajax({
      url: baseUrl + versionPath,
      success: function(response) {
        logger$1.info("OVERRIDING PCAP BUNDLES");
        globalThis.integratedEligibility.integratedJS = `${baseUrl}/static/js/empower.bundle${response.version}.js`;
        globalThis.integratedEligibility.integratedCSS = `${baseUrl}/static/css/empower/app/main${response.version}.css`;
      },
      dataType: "json"
    });
  }
  if (data.data.integrated && ObjectUtil.isUndefinedOrNull(data.data.samlToken)) {
    logger$1.error("IntegratedEligibilityService - NO SAML TOKEN - bad data :>> ", data);
    const samlTokenError = {
      message: DEFAULT_MESSAGE,
      code: "SAMLTKN",
      error: true
    };
    if (data.notifications.length > 0) {
      const isWarning = data.notifications[0].type === "WARNING";
      const isTerminated = String(data.notifications[0].message).indexOf("terminated with no Balance") > -1;
      if (isWarning && isTerminated) {
        samlTokenError.code = "LIAT_CODE1";
      }
    }
    globalThis.integratedEligibility.samlTokenError = samlTokenError;
    return Promise.reject(data);
  }
  if (data.data.integrated && data.notifications && data.notifications.length > 0 && data.notifications[0].type === "ERROR") {
    return Promise.reject({
      message: DEFAULT_MESSAGE,
      showError: true
    });
  }
  return data.data;
};
const name = "core-ui";
const version = "25.2.8-OFFRELEASEMAR122025.1";
const coreQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1e3 * 60 * 5,
      // 5 minutes
      gcTime: 1e3 * 60 * 15,
      // 15 minutes
      refetchOnWindowFocus: false
    }
  }
});
ExternalLogger$1.getInstance("menuService");
const retrieveAccountMenuDetails = () => {
  const retrieveAccountMenuResult = (result2) => {
    if (result2) {
      return result2.data;
    }
  };
  const liveUrl = "" + ReferenceData.ACCOUNT_MENU_URL;
  const mock = window.location.origin + window.location.pathname + "data/get-account-menu-details.json";
  const updatedUrl = localMocksTrue ? mock : liveUrl;
  return executeGet(updatedUrl, "retrieveAccountMenuFault").then(retrieveAccountMenuResult).catch((e) => {
    console.log("retrieveAccountMenu Error:", e);
  });
};
const getGroupMenuService = async (groupId) => {
  const url2 = StringUtil$1.supplant(ReferenceData.GROUP_MENU_URL, { groupId });
  const liveUrl = "" + url2;
  const mock = window.location.origin + window.location.pathname + "data/get-group-navigation-menu.json";
  const updatedUrl = localMocksTrue ? mock : liveUrl;
  return await executeGet(updatedUrl, "getGroupMenuFault");
};
const getGroupMenu = async (groupId) => {
  return await coreQueryClient.fetchQuery({
    queryKey: ["get-group-menu", groupId],
    queryFn: () => {
      const response = getGroupMenuService(groupId);
      return response.data;
    }
  });
};
const showTotalRewardsPromise = () => {
  const showTotalRewardsResult = (response) => {
    if (response) {
      return response.data;
    } else {
      return null;
    }
  };
  const liveUrl = "" + ReferenceData.SHOW_TOTAL_REWARDS;
  const mock = window.location.origin + window.location.pathname + "data/show-total-rewards.json";
  const updatedUrl = localMocksTrue ? mock : liveUrl;
  return executeGet(updatedUrl, "showTotalRewardsFault", {}).then(showTotalRewardsResult).catch((err) => {
    return err;
  });
};
var accounting$1 = { exports: {} };
/*!
 * accounting.js v0.4.1
 * Copyright 2014 Open Exchange Rates
 *
 * Freely distributable under the MIT license.
 * Portions of accounting.js are inspired or borrowed from underscore.js
 *
 * Full details and documentation:
 * http://openexchangerates.github.io/accounting.js/
 */
(function(module, exports) {
  (function(root2, undefined$1) {
    var lib = {};
    lib.version = "0.4.1";
    lib.settings = {
      currency: {
        symbol: "$",
        // default currency symbol is '$'
        format: "%s%v",
        // controls output: %s = symbol, %v = value (can be object, see docs)
        decimal: ".",
        // decimal point separator
        thousand: ",",
        // thousands separator
        precision: 2,
        // decimal places
        grouping: 3
        // digit grouping (not implemented yet)
      },
      number: {
        precision: 0,
        // default precision on numbers is 0
        grouping: 3,
        // digit grouping (not implemented yet)
        thousand: ",",
        decimal: "."
      }
    };
    var nativeMap = Array.prototype.map, nativeIsArray = Array.isArray, toString3 = Object.prototype.toString;
    function isString2(obj) {
      return !!(obj === "" || obj && obj.charCodeAt && obj.substr);
    }
    function isArray2(obj) {
      return nativeIsArray ? nativeIsArray(obj) : toString3.call(obj) === "[object Array]";
    }
    function isObject2(obj) {
      return obj && toString3.call(obj) === "[object Object]";
    }
    function defaults2(object, defs) {
      var key;
      object = object || {};
      defs = defs || {};
      for (key in defs) {
        if (defs.hasOwnProperty(key)) {
          if (object[key] == null) object[key] = defs[key];
        }
      }
      return object;
    }
    function map2(obj, iterator2, context) {
      var results = [], i, j;
      if (!obj) return results;
      if (nativeMap && obj.map === nativeMap) return obj.map(iterator2, context);
      for (i = 0, j = obj.length; i < j; i++) {
        results[i] = iterator2.call(context, obj[i], i, obj);
      }
      return results;
    }
    function checkPrecision(val, base) {
      val = Math.round(Math.abs(val));
      return isNaN(val) ? base : val;
    }
    function checkCurrencyFormat(format2) {
      var defaults3 = lib.settings.currency.format;
      if (typeof format2 === "function") format2 = format2();
      if (isString2(format2) && format2.match("%v")) {
        return {
          pos: format2,
          neg: format2.replace("-", "").replace("%v", "-%v"),
          zero: format2
        };
      } else if (!format2 || !format2.pos || !format2.pos.match("%v")) {
        return !isString2(defaults3) ? defaults3 : lib.settings.currency.format = {
          pos: defaults3,
          neg: defaults3.replace("%v", "-%v"),
          zero: defaults3
        };
      }
      return format2;
    }
    var unformat2 = lib.unformat = lib.parse = function(value, decimal) {
      if (isArray2(value)) {
        return map2(value, function(val) {
          return unformat2(val, decimal);
        });
      }
      value = value || 0;
      if (typeof value === "number") return value;
      decimal = decimal || lib.settings.number.decimal;
      var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]), unformatted = parseFloat(
        ("" + value).replace(/\((.*)\)/, "-$1").replace(regex, "").replace(decimal, ".")
        // make sure decimal point is standard
      );
      return !isNaN(unformatted) ? unformatted : 0;
    };
    var toFixed = lib.toFixed = function(value, precision) {
      precision = checkPrecision(precision, lib.settings.number.precision);
      var power = Math.pow(10, precision);
      return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
    };
    var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
      if (isArray2(number)) {
        return map2(number, function(val) {
          return formatNumber(val, precision, thousand, decimal);
        });
      }
      number = unformat2(number);
      var opts = defaults2(
        isObject2(precision) ? precision : {
          precision,
          thousand,
          decimal
        },
        lib.settings.number
      ), usePrecision = checkPrecision(opts.precision), negative = number < 0 ? "-" : "", base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "", mod = base.length > 3 ? base.length % 3 : 0;
      return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split(".")[1] : "");
    };
    var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format2) {
      if (isArray2(number)) {
        return map2(number, function(val) {
          return formatMoney(val, symbol, precision, thousand, decimal, format2);
        });
      }
      number = unformat2(number);
      var opts = defaults2(
        isObject2(symbol) ? symbol : {
          symbol,
          precision,
          thousand,
          decimal,
          format: format2
        },
        lib.settings.currency
      ), formats = checkCurrencyFormat(opts.format), useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;
      return useFormat.replace("%s", opts.symbol).replace("%v", formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
    };
    lib.formatColumn = function(list, symbol, precision, thousand, decimal, format2) {
      if (!list) return [];
      var opts = defaults2(
        isObject2(symbol) ? symbol : {
          symbol,
          precision,
          thousand,
          decimal,
          format: format2
        },
        lib.settings.currency
      ), formats = checkCurrencyFormat(opts.format), padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false, maxLength = 0, formatted = map2(list, function(val, i) {
        if (isArray2(val)) {
          return lib.formatColumn(val, opts);
        } else {
          val = unformat2(val);
          var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero, fVal = useFormat.replace("%s", opts.symbol).replace("%v", formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));
          if (fVal.length > maxLength) maxLength = fVal.length;
          return fVal;
        }
      });
      return map2(formatted, function(val, i) {
        if (isString2(val) && val.length < maxLength) {
          return padAfterSymbol ? val.replace(opts.symbol, opts.symbol + new Array(maxLength - val.length + 1).join(" ")) : new Array(maxLength - val.length + 1).join(" ") + val;
        }
        return val;
      });
    };
    {
      if (module.exports) {
        exports = module.exports = lib;
      }
      exports.accounting = lib;
    }
  })();
})(accounting$1, accounting$1.exports);
var accountingExports = accounting$1.exports;
var localeCurrency$1 = {};
var map$1 = {
  AD: "EUR",
  AE: "AED",
  AF: "AFN",
  AG: "XCD",
  AI: "XCD",
  AL: "ALL",
  AM: "AMD",
  AN: "ANG",
  AO: "AOA",
  AR: "ARS",
  AS: "USD",
  AT: "EUR",
  AU: "AUD",
  AW: "AWG",
  AX: "EUR",
  AZ: "AZN",
  BA: "BAM",
  BB: "BBD",
  BD: "BDT",
  BE: "EUR",
  BF: "XOF",
  BG: "BGN",
  BH: "BHD",
  BI: "BIF",
  BJ: "XOF",
  BL: "EUR",
  BM: "BMD",
  BN: "BND",
  BO: "BOB",
  BQ: "USD",
  BR: "BRL",
  BS: "BSD",
  BT: "BTN",
  BV: "NOK",
  BW: "BWP",
  BY: "BYR",
  BZ: "BZD",
  CA: "CAD",
  CC: "AUD",
  CD: "CDF",
  CF: "XAF",
  CG: "XAF",
  CH: "CHF",
  CI: "XOF",
  CK: "NZD",
  CL: "CLP",
  CM: "XAF",
  CN: "CNY",
  CO: "COP",
  CR: "CRC",
  CU: "CUP",
  CV: "CVE",
  CW: "ANG",
  CX: "AUD",
  CY: "EUR",
  CZ: "CZK",
  DE: "EUR",
  DJ: "DJF",
  DK: "DKK",
  DM: "XCD",
  DO: "DOP",
  DZ: "DZD",
  EC: "USD",
  EE: "EUR",
  EG: "EGP",
  EH: "MAD",
  ER: "ERN",
  ES: "EUR",
  ET: "ETB",
  FI: "EUR",
  FJ: "FJD",
  FK: "FKP",
  FM: "USD",
  FO: "DKK",
  FR: "EUR",
  GA: "XAF",
  GB: "GBP",
  GD: "XCD",
  GE: "GEL",
  GF: "EUR",
  GG: "GBP",
  GH: "GHS",
  GI: "GIP",
  GL: "DKK",
  GM: "GMD",
  GN: "GNF",
  GP: "EUR",
  GQ: "XAF",
  GR: "EUR",
  GS: "GBP",
  GT: "GTQ",
  GU: "USD",
  GW: "XOF",
  GY: "GYD",
  HK: "HKD",
  HM: "AUD",
  HN: "HNL",
  HR: "HRK",
  HT: "HTG",
  HU: "HUF",
  ID: "IDR",
  IE: "EUR",
  IL: "ILS",
  IM: "GBP",
  IN: "INR",
  IO: "USD",
  IQ: "IQD",
  IR: "IRR",
  IS: "ISK",
  IT: "EUR",
  JE: "GBP",
  JM: "JMD",
  JO: "JOD",
  JP: "JPY",
  KE: "KES",
  KG: "KGS",
  KH: "KHR",
  KI: "AUD",
  KM: "KMF",
  KN: "XCD",
  KP: "KPW",
  KR: "KRW",
  KW: "KWD",
  KY: "KYD",
  KZ: "KZT",
  LA: "LAK",
  LB: "LBP",
  LC: "XCD",
  LI: "CHF",
  LK: "LKR",
  LR: "LRD",
  LS: "LSL",
  LT: "LTL",
  LU: "EUR",
  LV: "LVL",
  LY: "LYD",
  MA: "MAD",
  MC: "EUR",
  MD: "MDL",
  ME: "EUR",
  MF: "EUR",
  MG: "MGA",
  MH: "USD",
  MK: "MKD",
  ML: "XOF",
  MM: "MMK",
  MN: "MNT",
  MO: "MOP",
  MP: "USD",
  MQ: "EUR",
  MR: "MRO",
  MS: "XCD",
  MT: "EUR",
  MU: "MUR",
  MV: "MVR",
  MW: "MWK",
  MX: "MXN",
  MY: "MYR",
  MZ: "MZN",
  NA: "NAD",
  NC: "XPF",
  NE: "XOF",
  NF: "AUD",
  NG: "NGN",
  NI: "NIO",
  NL: "EUR",
  NO: "NOK",
  NP: "NPR",
  NR: "AUD",
  NU: "NZD",
  NZ: "NZD",
  OM: "OMR",
  PA: "PAB",
  PE: "PEN",
  PF: "XPF",
  PG: "PGK",
  PH: "PHP",
  PK: "PKR",
  PL: "PLN",
  PM: "EUR",
  PN: "NZD",
  PR: "USD",
  PS: "ILS",
  PT: "EUR",
  PW: "USD",
  PY: "PYG",
  QA: "QAR",
  RE: "EUR",
  RO: "RON",
  RS: "RSD",
  RU: "RUB",
  RW: "RWF",
  SA: "SAR",
  SB: "SBD",
  SC: "SCR",
  SD: "SDG",
  SE: "SEK",
  SG: "SGD",
  SH: "SHP",
  SI: "EUR",
  SJ: "NOK",
  SK: "EUR",
  SL: "SLL",
  SM: "EUR",
  SN: "XOF",
  SO: "SOS",
  SR: "SRD",
  ST: "STD",
  SV: "SVC",
  SX: "ANG",
  SY: "SYP",
  SZ: "SZL",
  TC: "USD",
  TD: "XAF",
  TF: "EUR",
  TG: "XOF",
  TH: "THB",
  TJ: "TJS",
  TK: "NZD",
  TL: "USD",
  TM: "TMT",
  TN: "TND",
  TO: "TOP",
  TR: "TRY",
  TT: "TTD",
  TV: "AUD",
  TW: "TWD",
  TZ: "TZS",
  UA: "UAH",
  UG: "UGX",
  UM: "USD",
  US: "USD",
  UY: "UYU",
  UZ: "UZS",
  VA: "EUR",
  VC: "XCD",
  VE: "VEF",
  VG: "USD",
  VI: "USD",
  VN: "VND",
  VU: "VUV",
  WF: "XPF",
  WS: "WST",
  YE: "YER",
  YT: "EUR",
  ZA: "ZAR",
  ZM: "ZMK",
  ZW: "ZWL"
};
var map_1 = map$1;
var map = map_1;
var getCountryCode = function(localeString) {
  var components = localeString.split("_");
  if (components.length == 2) {
    return components.pop();
  }
  components = localeString.split("-");
  if (components.length == 2) {
    return components.pop();
  }
  return localeString;
};
localeCurrency$1.getCurrency = function(locale) {
  var countryCode2 = getCountryCode(locale).toUpperCase();
  if (countryCode2 in map) {
    return map[countryCode2];
  }
  return null;
};
localeCurrency$1.getLocales = function(currencyCode) {
  currencyCode = currencyCode.toUpperCase();
  var locales = [];
  for (countryCode in map) {
    if (map[countryCode] === currencyCode) {
      locales.push(countryCode);
    }
  }
  return locales;
};
const AED = {
  code: "AED",
  symbol: "د.إ.‏",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const AFN = {
  code: "AFN",
  symbol: "؋",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const ALL = {
  code: "ALL",
  symbol: "Lek",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const AMD = {
  code: "AMD",
  symbol: "֏",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const ANG = {
  code: "ANG",
  symbol: "ƒ",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const AOA = {
  code: "AOA",
  symbol: "Kz",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const ARS = {
  code: "ARS",
  symbol: "$",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const AUD = {
  code: "AUD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const AWG = {
  code: "AWG",
  symbol: "ƒ",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const AZN = {
  code: "AZN",
  symbol: "₼",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const BAM = {
  code: "BAM",
  symbol: "КМ",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const BBD = {
  code: "BBD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const BDT = {
  code: "BDT",
  symbol: "৳",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 0
};
const BGN = {
  code: "BGN",
  symbol: "лв.",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const BHD = {
  code: "BHD",
  symbol: "د.ب.‏",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 3
};
const BIF = {
  code: "BIF",
  symbol: "FBu",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const BMD = {
  code: "BMD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const BND = {
  code: "BND",
  symbol: "$",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const BOB = {
  code: "BOB",
  symbol: "Bs",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const BRL = {
  code: "BRL",
  symbol: "R$",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const BSD = {
  code: "BSD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const BTC = {
  code: "BTC",
  symbol: "Ƀ",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 8
};
const BTN = {
  code: "BTN",
  symbol: "Nu.",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 1
};
const BWP = {
  code: "BWP",
  symbol: "P",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const BYR = {
  code: "BYR",
  symbol: "р.",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const BYN = {
  code: "BYN",
  symbol: "р.",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const BZD = {
  code: "BZD",
  symbol: "BZ$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const CAD = {
  code: "CAD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const CDF = {
  code: "CDF",
  symbol: "FC",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const CHF = {
  code: "CHF",
  symbol: "CHF",
  thousandsSeparator: "'",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const CLP = {
  code: "CLP",
  symbol: "$",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 0
};
const CNY = {
  code: "CNY",
  symbol: "¥",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const COP = {
  code: "COP",
  symbol: "$",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const CRC = {
  code: "CRC",
  symbol: "₡",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const CUC = {
  code: "CUC",
  symbol: "CUC",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const CUP = {
  code: "CUP",
  symbol: "$MN",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const CVE = {
  code: "CVE",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const CZK = {
  code: "CZK",
  symbol: "Kč",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const DJF = {
  code: "DJF",
  symbol: "Fdj",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const DKK = {
  code: "DKK",
  symbol: "kr.",
  thousandsSeparator: "",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const DOP = {
  code: "DOP",
  symbol: "RD$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const DZD = {
  code: "DZD",
  symbol: "د.ج.‏",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const EGP = {
  code: "EGP",
  symbol: "ج.م.‏",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const ERN = {
  code: "ERN",
  symbol: "Nfk",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const ETB = {
  code: "ETB",
  symbol: "ETB",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const EUR = {
  code: "EUR",
  symbol: "€",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const FJD = {
  code: "FJD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const FKP = {
  code: "FKP",
  symbol: "£",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const GBP = {
  code: "GBP",
  symbol: "£",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const GEL = {
  code: "GEL",
  symbol: "GEL",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const GHS = {
  code: "GHS",
  symbol: "₵",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const GIP = {
  code: "GIP",
  symbol: "£",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const GMD = {
  code: "GMD",
  symbol: "D",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const GNF = {
  code: "GNF",
  symbol: "FG",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const GTQ = {
  code: "GTQ",
  symbol: "Q",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const GYD = {
  code: "GYD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const HKD = {
  code: "HKD",
  symbol: "HK$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const HNL = {
  code: "HNL",
  symbol: "L.",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const HRK = {
  code: "HRK",
  symbol: "kn",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const HTG = {
  code: "HTG",
  symbol: "G",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const HUF = {
  code: "HUF",
  symbol: "Ft",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const IDR = {
  code: "IDR",
  symbol: "Rp",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const ILS = {
  code: "ILS",
  symbol: "₪",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const INR = {
  code: "INR",
  symbol: "₹",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const IQD = {
  code: "IQD",
  symbol: "د.ع.‏",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const IRR = {
  code: "IRR",
  symbol: "﷼",
  thousandsSeparator: ",",
  decimalSeparator: "/",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const ISK = {
  code: "ISK",
  symbol: "kr.",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 0
};
const JMD = {
  code: "JMD",
  symbol: "J$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const JOD = {
  code: "JOD",
  symbol: "د.ا.‏",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 3
};
const JPY = {
  code: "JPY",
  symbol: "¥",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const KES = {
  code: "KES",
  symbol: "KSh",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const KGS = {
  code: "KGS",
  symbol: "сом",
  thousandsSeparator: " ",
  decimalSeparator: "-",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const KHR = {
  code: "KHR",
  symbol: "៛",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const KMF = {
  code: "KMF",
  symbol: "CF",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const KPW = {
  code: "KPW",
  symbol: "₩",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const KRW = {
  code: "KRW",
  symbol: "₩",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const KWD = {
  code: "KWD",
  symbol: "د.ك.‏",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 3
};
const KYD = {
  code: "KYD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const KZT = {
  code: "KZT",
  symbol: "₸",
  thousandsSeparator: " ",
  decimalSeparator: "-",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const LAK = {
  code: "LAK",
  symbol: "₭",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const LBP = {
  code: "LBP",
  symbol: "ل.ل.‏",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const LKR = {
  code: "LKR",
  symbol: "₨",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 0
};
const LRD = {
  code: "LRD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const LSL = {
  code: "LSL",
  symbol: "M",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const LYD = {
  code: "LYD",
  symbol: "د.ل.‏",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 3
};
const MAD = {
  code: "MAD",
  symbol: "د.م.‏",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const MDL = {
  code: "MDL",
  symbol: "lei",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const MGA = {
  code: "MGA",
  symbol: "Ar",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const MKD = {
  code: "MKD",
  symbol: "ден.",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const MMK = {
  code: "MMK",
  symbol: "K",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const MNT = {
  code: "MNT",
  symbol: "₮",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const MOP = {
  code: "MOP",
  symbol: "MOP$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const MRO = {
  code: "MRO",
  symbol: "UM",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const MTL = {
  code: "MTL",
  symbol: "₤",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const MUR = {
  code: "MUR",
  symbol: "₨",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const MVR = {
  code: "MVR",
  symbol: "MVR",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 1
};
const MWK = {
  code: "MWK",
  symbol: "MK",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const MXN = {
  code: "MXN",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const MYR = {
  code: "MYR",
  symbol: "RM",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const MZN = {
  code: "MZN",
  symbol: "MT",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const NAD = {
  code: "NAD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const NGN = {
  code: "NGN",
  symbol: "₦",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const NIO = {
  code: "NIO",
  symbol: "C$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const NOK = {
  code: "NOK",
  symbol: "kr",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const NPR = {
  code: "NPR",
  symbol: "₨",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const NZD = {
  code: "NZD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const OMR = {
  code: "OMR",
  symbol: "﷼",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 3
};
const PAB = {
  code: "PAB",
  symbol: "B/.",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const PEN = {
  code: "PEN",
  symbol: "S/.",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const PGK = {
  code: "PGK",
  symbol: "K",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const PHP = {
  code: "PHP",
  symbol: "₱",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const PKR = {
  code: "PKR",
  symbol: "₨",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const PLN = {
  code: "PLN",
  symbol: "zł",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const PYG = {
  code: "PYG",
  symbol: "₲",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const QAR = {
  code: "QAR",
  symbol: "﷼",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const RON = {
  code: "RON",
  symbol: "L",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const RSD = {
  code: "RSD",
  symbol: "Дин.",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const RUB = {
  code: "RUB",
  symbol: "₽",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const RWF = {
  code: "RWF",
  symbol: "RWF",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const SAR = {
  code: "SAR",
  symbol: "﷼",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const SBD = {
  code: "SBD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const SCR = {
  code: "SCR",
  symbol: "₨",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const SDD = {
  code: "SDD",
  symbol: "LSd",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const SDG = {
  code: "SDG",
  symbol: "£‏",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const SEK = {
  code: "SEK",
  symbol: "kr",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const SGD = {
  code: "SGD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const SHP = {
  code: "SHP",
  symbol: "£",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const SLL = {
  code: "SLL",
  symbol: "Le",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const SOS = {
  code: "SOS",
  symbol: "S",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const SRD = {
  code: "SRD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const STD = {
  code: "STD",
  symbol: "Db",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const SVC = {
  code: "SVC",
  symbol: "₡",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const SYP = {
  code: "SYP",
  symbol: "£",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const SZL = {
  code: "SZL",
  symbol: "E",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const THB = {
  code: "THB",
  symbol: "฿",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const TJS = {
  code: "TJS",
  symbol: "TJS",
  thousandsSeparator: " ",
  decimalSeparator: ";",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const TMT = {
  code: "TMT",
  symbol: "m",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const TND = {
  code: "TND",
  symbol: "د.ت.‏",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 3
};
const TOP = {
  code: "TOP",
  symbol: "T$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const TRY = {
  code: "TRY",
  symbol: "₺",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const TTD = {
  code: "TTD",
  symbol: "TT$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const TVD = {
  code: "TVD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const TWD = {
  code: "TWD",
  symbol: "NT$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const TZS = {
  code: "TZS",
  symbol: "TSh",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const UAH = {
  code: "UAH",
  symbol: "₴",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const UGX = {
  code: "UGX",
  symbol: "USh",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const USD = {
  code: "USD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const UYU = {
  code: "UYU",
  symbol: "$U",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const UZS = {
  code: "UZS",
  symbol: "сўм",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const VEB = {
  code: "VEB",
  symbol: "Bs.",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const VEF = {
  code: "VEF",
  symbol: "Bs. F.",
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const VND = {
  code: "VND",
  symbol: "₫",
  thousandsSeparator: ".",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 0
};
const VUV = {
  code: "VUV",
  symbol: "VT",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 0
};
const WST = {
  code: "WST",
  symbol: "WS$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const XAF = {
  code: "XAF",
  symbol: "F",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const XCD = {
  code: "XCD",
  symbol: "$",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const XBT = {
  code: "XBT",
  symbol: "Ƀ",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const XOF = {
  code: "XOF",
  symbol: "F",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const XPF = {
  code: "XPF",
  symbol: "F",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const YER = {
  code: "YER",
  symbol: "﷼",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const ZAR = {
  code: "ZAR",
  symbol: "R",
  thousandsSeparator: " ",
  decimalSeparator: ",",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const ZMW = {
  code: "ZMW",
  symbol: "ZK",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const WON = {
  code: "WON",
  symbol: "₩",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
const require$$3 = {
  AED,
  AFN,
  ALL,
  AMD,
  ANG,
  AOA,
  ARS,
  AUD,
  AWG,
  AZN,
  BAM,
  BBD,
  BDT,
  BGN,
  BHD,
  BIF,
  BMD,
  BND,
  BOB,
  BRL,
  BSD,
  BTC,
  BTN,
  BWP,
  BYR,
  BYN,
  BZD,
  CAD,
  CDF,
  CHF,
  CLP,
  CNY,
  COP,
  CRC,
  CUC,
  CUP,
  CVE,
  CZK,
  DJF,
  DKK,
  DOP,
  DZD,
  EGP,
  ERN,
  ETB,
  EUR,
  FJD,
  FKP,
  GBP,
  GEL,
  GHS,
  GIP,
  GMD,
  GNF,
  GTQ,
  GYD,
  HKD,
  HNL,
  HRK,
  HTG,
  HUF,
  IDR,
  ILS,
  INR,
  IQD,
  IRR,
  ISK,
  JMD,
  JOD,
  JPY,
  KES,
  KGS,
  KHR,
  KMF,
  KPW,
  KRW,
  KWD,
  KYD,
  KZT,
  LAK,
  LBP,
  LKR,
  LRD,
  LSL,
  LYD,
  MAD,
  MDL,
  MGA,
  MKD,
  MMK,
  MNT,
  MOP,
  MRO,
  MTL,
  MUR,
  MVR,
  MWK,
  MXN,
  MYR,
  MZN,
  NAD,
  NGN,
  NIO,
  NOK,
  NPR,
  NZD,
  OMR,
  PAB,
  PEN,
  PGK,
  PHP,
  PKR,
  PLN,
  PYG,
  QAR,
  RON,
  RSD,
  RUB,
  RWF,
  SAR,
  SBD,
  SCR,
  SDD,
  SDG,
  SEK,
  SGD,
  SHP,
  SLL,
  SOS,
  SRD,
  STD,
  SVC,
  SYP,
  SZL,
  THB,
  TJS,
  TMT,
  TND,
  TOP,
  TRY,
  TTD,
  TVD,
  TWD,
  TZS,
  UAH,
  UGX,
  USD,
  UYU,
  UZS,
  VEB,
  VEF,
  VND,
  VUV,
  WST,
  XAF,
  XCD,
  XBT,
  XOF,
  XPF,
  YER,
  ZAR,
  ZMW,
  WON
};
const de = {
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const el = {
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  thousandsSeparator: ".",
  decimalSeparator: ",",
  decimalDigits: 2
};
const es = {
  thousandsSeparator: ".",
  decimalSeparator: ",",
  symbolOnLeft: false,
  spaceBetweenAmountAndSymbol: true,
  decimalDigits: 2
};
const it = {
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  thousandsSeparator: ".",
  decimalSeparator: ",",
  decimalDigits: 2
};
const nl = {
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  thousandsSeparator: ".",
  decimalSeparator: ",",
  decimalDigits: 2
};
const require$$4 = {
  de,
  el,
  "en-US": {
    thousandsSeparator: ",",
    decimalSeparator: ".",
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false,
    decimalDigits: 2
  },
  "en-IE": {
    symbolOnLeft: true,
    thousandsSeparator: ",",
    decimalSeparator: ".",
    spaceBetweenAmountAndSymbol: true,
    decimalDigits: 2
  },
  "zh-CN": {
    thousandsSeparator: ",",
    decimalSeparator: ".",
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false,
    decimalDigits: 2
  },
  es,
  it,
  nl
};
var accounting = accountingExports;
var assign = objectAssign;
var localeCurrency = localeCurrency$1;
var currencies = require$$3;
var localeFormats = require$$4;
var defaultCurrency = {
  symbol: "",
  thousandsSeparator: ",",
  decimalSeparator: ".",
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
};
var defaultLocaleFormat = {};
var formatMapping = [
  {
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false,
    format: {
      pos: "%s%v",
      neg: "-%s%v",
      zero: "%s%v"
    }
  },
  {
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: true,
    format: {
      pos: "%s %v",
      neg: "-%s %v",
      zero: "%s %v"
    }
  },
  {
    symbolOnLeft: false,
    spaceBetweenAmountAndSymbol: false,
    format: {
      pos: "%v%s",
      neg: "-%v%s",
      zero: "%v%s"
    }
  },
  {
    symbolOnLeft: false,
    spaceBetweenAmountAndSymbol: true,
    format: {
      pos: "%v %s",
      neg: "-%v %s",
      zero: "%v %s"
    }
  }
];
function format(value, options) {
  var code = options.code || options.locale && localeCurrency.getCurrency(options.locale);
  var localeMatch = /^([a-z]+)([_-]([a-z]+))?$/i.exec(options.locale) || [];
  var language = localeMatch[1];
  var region = localeMatch[3];
  var localeFormat = assign(
    {},
    defaultLocaleFormat,
    localeFormats[language] || {},
    localeFormats[language + "-" + region] || {}
  );
  var currency = assign({}, defaultCurrency, findCurrency(code), localeFormat);
  var symbolOnLeft = currency.symbolOnLeft;
  var spaceBetweenAmountAndSymbol = currency.spaceBetweenAmountAndSymbol;
  var format2 = formatMapping.filter(function(f) {
    return f.symbolOnLeft == symbolOnLeft && f.spaceBetweenAmountAndSymbol == spaceBetweenAmountAndSymbol;
  })[0].format;
  return accounting.formatMoney(value, {
    symbol: isUndefined$1(options.symbol) ? currency.symbol : options.symbol,
    decimal: isUndefined$1(options.decimal) ? currency.decimalSeparator : options.decimal,
    thousand: isUndefined$1(options.thousand) ? currency.thousandsSeparator : options.thousand,
    precision: typeof options.precision === "number" ? options.precision : currency.decimalDigits,
    format: ["string", "object"].indexOf(typeof options.format) > -1 ? options.format : format2
  });
}
function findCurrency(currencyCode) {
  return currencies[currencyCode];
}
function isUndefined$1(val) {
  return typeof val === "undefined";
}
function unformat(value, options) {
  var code = options.code || options.locale && localeCurrency.getCurrency(options.locale);
  var localeFormat = localeFormats[options.locale] || defaultLocaleFormat;
  var currency = assign({}, defaultCurrency, findCurrency(code), localeFormat);
  var decimal = isUndefined$1(options.decimal) ? currency.decimalSeparator : options.decimal;
  return accounting.unformat(value, decimal);
}
var currencyFormatter = {
  defaultCurrency,
  get currencies() {
    return Object.keys(currencies).map(function(key) {
      return currencies[key];
    });
  },
  findCurrency,
  format,
  unformat
};
const getObjAsArray = (obj) => {
  let result2 = [];
  if (obj) {
    result2 = isArray$5(obj) ? obj : [obj];
  }
  return result2;
};
const sortPlans = (allAccounts) => {
  let currentContextPlans = [];
  const otherContextPlans = [];
  const nmrowList = {};
  let combinedPlanList = [];
  if (allAccounts.length > 1) {
    const inContextListInit = filter$1(allAccounts, (item) => {
      return item.currentContext;
    });
    currentContextPlans = sortBy(inContextListInit, (o) => o.groupId);
    const outOfContextListInit = filter$1(allAccounts, (item) => {
      return !item.currentContext;
    });
    const outOfContextList = sortBy(outOfContextListInit, (o) => o.individualId);
    forEach$1(outOfContextList, function(nmplan) {
      const key = nmplan.individualId + "-" + nmplan.accuCode;
      if (nmrowList[key] === void 0 || nmrowList[key] === null) {
        nmplan.showToolTip = String(nmplan.name).length > 18;
        nmrowList[key] = [];
        nmrowList[key].push(nmplan);
      } else {
        nmplan.showToolTip = String(nmplan.name).length > 18;
        nmrowList[key].push(nmplan);
      }
    });
    Object.keys(nmrowList).forEach(function(key) {
      if (nmrowList[key].length > 1) {
        const sortedOtherContextPlans = sortBy(nmrowList[key], (o) => o.groupId);
        forEach$1(sortedOtherContextPlans, function(plan) {
          otherContextPlans.push(plan);
        });
      } else if (nmrowList[key].length == 1) {
        otherContextPlans.push(nmrowList[key][0]);
      }
    }, nmrowList);
    forEach$1(currentContextPlans, function(plan) {
      combinedPlanList.push(plan);
    });
    forEach$1(otherContextPlans, function(plan) {
      combinedPlanList.push(plan);
    });
  } else {
    combinedPlanList = allAccounts;
  }
  return combinedPlanList;
};
const formatCurrency = (value) => {
  let formattedNum = "";
  const locale = "en_US";
  const precision = 2;
  if (typeof value === "number") {
    formattedNum = "$" + currencyFormatter.format(value, { lcale: locale, precision });
  } else {
    formattedNum = value;
  }
  return formattedNum;
};
const truncateSubsetName = (name2, limit) => {
  return name2.length >= limit ? `${name2.slice(0, limit)}…` : name2;
};
const logger = ExternalLogger$1.getInstance("navMenuMiddleware");
const checkCharCount = (str, len) => {
  if (str != null && str != "" && str != "undefined" && str.length > len) {
    return true;
  }
  return false;
};
const retrieveMenuNavDetails = (groupId, needToChangeActiveMenuItem) => {
  return (dispatch) => {
    if (groupId && !needToChangeActiveMenuItem) {
      getGroupMenu(groupId).then((data) => {
        const tmpMenuNavigation = [];
        each(data, (item) => {
          if (item.subMenu && item.subMenu.length) {
            tmpMenuNavigation.push(item);
          }
        });
        dispatch(setMenuNavigation({ tmpMenuNavigation, groupId }));
        logger.debug("Got menu data. Set activeMenuItem then resolve.");
        dispatch(callSetActiveMenuItem());
      }).catch((e) => {
        console.log("Get Group Menu Error:", e);
      });
    } else {
      logger.debug("No need to call factory again. Set activeMenuItem then resolve.");
      dispatch(callSetActiveMenuItem());
    }
  };
};
const retrieveAccountMenuDetailsOnly = (activeGroupAccount) => {
  return (dispatch, getState) => {
    const state = getState();
    const accountMenuList = state.navMenu.accountMenuList;
    if (accountMenuList.length === 0) {
      retrieveAccountMenuDetails().then((data) => {
        let tempList = [];
        const contextData = {};
        const nonCurrentContextNums = {};
        const nonCurrentcontenxtPlanName = {};
        if (data) {
          if (data.length > 1) {
            data = sortPlans(data);
            map$3(data, function(item) {
            });
            each(data, function(item) {
              const contextKey = item.individualId + "-" + item.accuCode;
              if (item.currentContext && data.length > 1 && activeGroupAccount.individualId && item.individualId && activeGroupAccount.individualId != item.individualId) {
                item.currentContext = false;
              }
              if (item.currentContext) {
                const displayPlanName = item.planName;
                if (displayPlanName && displayPlanName.length > 80) {
                  item.planName = displayPlanName.slice(0, 80) + "…";
                }
                contextData[contextKey] = item.planName;
              } else {
                if (contextData[contextKey]) {
                  if (nonCurrentContextNums[contextKey] < 3) {
                    const concatenatedPlanName = contextData[contextKey] + ", " + (checkCharCount(item.planName, 26) ? item.planName.slice(0, 26) + "…" : item.planName);
                    contextData[contextKey] = concatenatedPlanName;
                    nonCurrentContextNums[contextKey]++;
                  }
                } else {
                  contextData[contextKey] = checkCharCount(item.planName, 26) ? item.planName.slice(0, 26) + "…" : item.planName;
                  nonCurrentContextNums[contextKey] = 1;
                  nonCurrentcontenxtPlanName[contextKey] = item.planName;
                }
              }
            });
            each(data, function(item) {
              item.plName = item.planName;
              if (item.currentContext) {
                tempList.push(item);
              } else {
                const contextKey = item.individualId + "-" + item.accuCode;
                if (nonCurrentContextNums[contextKey] && nonCurrentContextNums[contextKey] == 1) {
                  contextData[contextKey] = checkCharCount(
                    nonCurrentcontenxtPlanName[contextKey],
                    80
                  ) ? nonCurrentcontenxtPlanName[contextKey].slice(0, 80) + "…" : nonCurrentcontenxtPlanName[contextKey];
                }
                const planName = contextData[contextKey];
                const copyItem = item;
                if (planName) {
                  copyItem.plName = planName;
                  tempList.push(copyItem);
                  delete contextData[contextKey];
                }
              }
            });
            tempList = sortPlans(tempList);
            dispatch(setAccountMenuList(tempList));
          } else {
            dispatch(setAccountMenuList(data));
          }
        }
      });
    }
  };
};
const activateAccountDropDown = (activeGroupAccount) => {
  return (dispatch, getState) => {
    const state = getState();
    const accountMenuList = state.navMenu.accountMenuList;
    if (accountMenuList.length === 0) {
      dispatch(retrieveAccountMenuDetailsOnly(activeGroupAccount));
    }
  };
};
const setMobileActiveState = (activeState, callbacksArr) => {
  const menuActive = activeState;
  each(callbacksArr, function(callback) {
    callback(menuActive);
  });
  return menuActive;
};
const toggleMobileMenu = (isActive) => {
  return (dispatch, getState) => {
    const state = getState();
    const mobileMenuActive = state.navMenu.mobileMenuActive;
    const callsbackArr = state.navMenu.callbacksArr;
    const activeState = isActive || !mobileMenuActive;
    dispatch(setMobileMenuActiveSetting(setMobileActiveState(activeState, callsbackArr)));
  };
};
const getTotalRewards = () => {
  return (dispatch) => {
    let displayTotalRewards = false;
    const TRData = {};
    showTotalRewardsPromise().then(
      function(response) {
        if (response.data && response.data.status) {
          TRData.data = response.data.data;
          TRData.status = response.data.status;
        } else {
          TRData.data = response.data;
          TRData.status = response.status;
        }
        if (TRData.status === "SUCCESSFUL" && !TRData.status.error && TRData.data === true) {
          displayTotalRewards = TRData.data;
        } else {
          displayTotalRewards = false;
        }
        dispatch(setDisplayTotalRewards(displayTotalRewards));
      },
      function() {
        displayTotalRewards = false;
        dispatch(setDisplayTotalRewards(displayTotalRewards));
      }
    );
  };
};
var NativeCustomEvent = commonjsGlobal.CustomEvent;
function useNative() {
  try {
    var p = new NativeCustomEvent("cat", { detail: { foo: "bar" } });
    return "cat" === p.type && "bar" === p.detail.foo;
  } catch (e) {
  }
  return false;
}
var customEvent = useNative() ? NativeCustomEvent : (
  // IE >= 9
  "undefined" !== typeof document && "function" === typeof document.createEvent ? function CustomEvent2(type, params) {
    var e = document.createEvent("CustomEvent");
    if (params) {
      e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
    } else {
      e.initCustomEvent(type, false, false, void 0);
    }
    return e;
  } : (
    // IE <= 8
    function CustomEvent3(type, params) {
      var e = document.createEventObject();
      e.type = type;
      if (params) {
        e.bubbles = Boolean(params.bubbles);
        e.cancelable = Boolean(params.cancelable);
        e.detail = params.detail;
      } else {
        e.bubbles = false;
        e.cancelable = false;
        e.detail = void 0;
      }
      return e;
    }
  )
);
const CustomEvent$1 = /* @__PURE__ */ getDefaultExportFromCjs(customEvent);
const LANGUAGES = {
  ENG: "ENG",
  SPN: "SPN"
};
const getLanguageCode = () => {
  const cacheUrl = "" + ReferenceData.RETRIEVE_LANGUAGE_CODE;
  const cache2 = {};
  const pending2 = {};
  const getResult = (resp) => {
    extend$1(
      cache2,
      mapValues(resp.data, function(value) {
        return value;
      })
    );
    delete pending2["selectedLanguage"];
    return cache2;
  };
  const getFault = (fault) => {
    delete pending2["selectedLanguage"];
    throw new Error(fault);
  };
  const method = RequestFactory.HTTP_METHOD.GET;
  const contentType = RequestFactory.HTTP_CONTENT_TYPE.JSON;
  if (pending2["selectedLanguage"]) {
    return pending2["selectedLanguage"];
  }
  const liveUrl = cacheUrl;
  const mock = window.location.origin + window.location.pathname + "data/retrieve-language-code.json";
  const updatedUrl = localMocksTrue ? mock : liveUrl;
  if (localMocksTrue) {
    return executeGet(updatedUrl, "retrieveLanguageCodeFault").then(getResult).catch((e) => {
      console.log("Error - retrieveLanguageCode failed " + e);
    });
  } else {
    const request = RequestFactory.create(updatedUrl, {}, method, contentType);
    delete request.headers.samlToken;
    return axios(request).then(getResult, getFault);
  }
};
const updateLanguage = (newLang) => {
  const getUpdateLangResult = (resp) => {
    if (resp && resp.data) {
      return resp.data;
    }
  };
  const param = { selectedLanguage: newLang };
  const liveUrl = "" + ReferenceData.UPDATE_LANGUAGE_CODE;
  const mock = window.location.origin + window.location.pathname + "data/update-language-code.json";
  const updatedUrl = localMocksTrue ? mock : liveUrl;
  if (localMocksTrue) {
    return executeGet(updatedUrl, "updateLanguageCodeFault").then(getUpdateLangResult).catch((e) => {
      console.log("updateLanguage mocks : Error - updateLanguageCode failed " + e);
    });
  } else {
    return axios.post(updatedUrl, param, { withCredentials: true }).then((response) => {
      return response.data;
    }).catch((err) => {
      console.log("updateLanguageError - updateLanguageCode failed " + err);
    });
  }
};
const setLanguageCookies = () => {
  const setLanguageCookiesSuccess = (response) => {
    if (response) {
      return response.data;
    } else {
      return null;
    }
  };
  const url2 = "" + ReferenceData.SET_LANGUAGE_COOKIES;
  return axios.post(url2, {}, { withCredentials: true }).then(setLanguageCookiesSuccess).catch((err) => {
    throw handleFault(err, "setLanguageCookiesFault");
  });
};
const getAcctsCustomizationRetrievalList = (accu2) => {
  const getAcctsCustomizationRetrievalResult = (response) => {
    globalThis.showOpenAccountFooter = Boolean(response.data.showOpenAccountFooter);
    return response.data;
  };
  const url2 = "/ui/customization-ui/" + ReferenceData.ACCTS_CUSTOMIZATON_RETRIEVAL_URL;
  const updatedUrl = StringUtil$1.supplant(url2, {
    accu: accu2,
    suffixPath: "AccountsCustomization.json"
  });
  return executeGet(updatedUrl, "getAcctsCustomizationRetrievalFault").then(getAcctsCustomizationRetrievalResult).catch((error) => {
    console.log("Error: ", error);
  });
};
const getMessagesList = () => {
  const getMessagesListResult = function(result2) {
    if (ObjectUtil.isUndefinedOrNull(result2) || ObjectUtil.isUndefinedOrNull(result2.data)) {
      return null;
    } else {
      return result2.data;
    }
  };
  const liveUrl = "" + ReferenceData.HDR_PLAN_MSGS_URL;
  const mock = window.location.origin + window.location.pathname + "data/get-plan-messages.json";
  const updatedUrl = localMocksTrue ? mock : liveUrl;
  return executeGet(updatedUrl, "getMessagesListFault").then(getMessagesListResult).catch((e) => {
    console.log("Error - Plan messages", e);
  });
};
const getUserProfileSvc = () => {
  const getUserProfileResult = (response) => {
    if (ObjectUtil.isUndefinedOrNull(response) || ObjectUtil.isUndefinedOrNull(response.data)) {
      return null;
    } else {
      return response.data;
    }
  };
  const liveUrl = "" + ReferenceData.USER_PROFILE_URL;
  const mock = window.location.origin + window.location.pathname + "data/get-user-profile.json";
  const updatedUrl = isLocalhost() && hasMocks() ? mock : liveUrl;
  return executeGet(updatedUrl, "getUserProfileFault").then(getUserProfileResult).catch((e) => {
    console.log("User profile Error:", e);
  });
};
const getNavSettings = (acctOpened) => {
  const getNavSettingsResult = (response) => {
    if (response) {
      const LearningCtr = {
        parentItems: null,
        url: null,
        displayText: "cxLearningCenter",
        helpText: null,
        id: 1500,
        transactionCode: "CXRDW",
        type: "WEB",
        subMenu: [],
        decorations: null,
        isAccountHeaderRelated: false
      };
      response.data.data.push(LearningCtr);
      return response.data.data;
    }
  };
  const liveUrl = acctOpened ? "" + ReferenceData.GET_TOPNAV_LINKS_REFRESH : "" + ReferenceData.GET_TOPNAV_LINKS;
  const mock = window.location.origin + window.location.pathname + "data/get-top-nav-links.json";
  const updatedUrl = isLocalhost() && hasMocks() ? mock : liveUrl;
  return executeGet(updatedUrl, "getNavSettingsFault").then(getNavSettingsResult).catch((error) => {
    console.log("unable to get nav links", error);
  });
};
const getRetailUserMessages = () => {
  const formData = new FormData();
  formData.append("csrf", window.csrf);
  return axios({
    method: RequestFactory.HTTP_METHOD.POST,
    url: getPcapEndpoint("MESSAGES", "GET_USER_MESSAGES"),
    data: formData,
    headers: { "content-type": RequestFactory.HTTP_CONTENT_TYPE.URL_ENCODED },
    xhrFields: { withCredentials: true }
  }).then((response) => {
    const hasData = !ObjectUtil.isUndefinedOrNull(response) && !ObjectUtil.isUndefinedOrNull(response.data) && !ObjectUtil.isUndefinedOrNull(response.data.spData);
    return hasData ? response.data.spData.userMessages : null;
  }).catch((error) => {
    console.log("ERROR - RETAIL - GET_USER_MESSAGES", error);
  });
};
const updateRetailUserMessage = (userMessageId) => {
  const formData = new FormData();
  formData.append("csrf", window.csrf);
  formData.append("userMessageId", userMessageId);
  formData.append("markViewed", true);
  return axios({
    method: RequestFactory.HTTP_METHOD.POST,
    url: getPcapEndpoint("MESSAGES", "UPDATE_USER_MESSAGES"),
    data: formData,
    headers: { "content-type": RequestFactory.HTTP_CONTENT_TYPE.URL_ENCODED },
    xhrFields: { withCredentials: true }
  }).then((response) => {
    return response;
  }).catch((error) => {
    console.log("ERROR - RETAIL - UPDATE_USER_MESSAGES", error);
  });
};
const endPCAPSession = () => {
  const csrf = window.csrf || null;
  const formData = new FormData();
  formData.append("csrf", csrf);
  formData.append("apiClient", "WEB");
  formData.append("lastServerChangeId", -1);
  return axios({
    method: RequestFactory.HTTP_METHOD.POST,
    url: getPcapEndpoint("AUTH", "SWITCH_USER"),
    data: formData,
    headers: { "content-type": RequestFactory.HTTP_CONTENT_TYPE.URL_ENCODED },
    withCredentials: true
  }).then((response) => {
    return response;
  }).catch((error) => {
    console.log("ERROR - RETAIL - SWITCH_USER", error);
  });
};
const getPcapEndpoint = (apiSet, endpoint) => {
  return globalThis.integratedEligibility.postOriginUrl + ReferenceData.PC_API[apiSet][endpoint];
};
const callLogoutSvc = () => {
  const callLogoutSvcResult = (response) => {
    return response;
  };
  const url2 = "" + ReferenceData.LOGOUT_SVC_URL;
  return executeGet(url2, "callLogoutSvcFault", {}).then(callLogoutSvcResult).catch((err) => {
    return err;
  });
};
const getPSCPathSvc = () => {
  const getPSCPathSuccess = (results) => {
    if (result) {
      return results.data;
    }
  };
  const method = "getPSCPath";
  const url2 = "" + ReferenceData.PSC_PATH_URL;
  return executeGet(url2, "getPSCPathFault").then(getPSCPathSuccess).catch((e) => {
    LogService$1.getLogger().error(method + "Error - getPSCPath failed", e);
  });
};
const { isUndefinedOrNull: isUndefinedOrNull$6 } = ObjectUtil;
const initGlobalSharedData = () => {
  if (isUndefinedOrNull$6(globalThis.integratedSharedData)) {
    globalThis.integratedSharedData = {};
  }
};
const setGlobalSharedAuthData = (authData) => {
  const { integratedSharedData } = globalThis;
  if (!isUndefinedOrNull$6(integratedSharedData) && !isEmpty$3(integratedSharedData.isInboundSSOUser)) {
    return;
  }
  if (isUndefinedOrNull$6(authData)) {
    console.warn("No data passed to setGlobalAuthData");
    return;
  }
  globalThis.integratedSharedData.isInboundSSOUser = authData.inboundSSOUser;
};
const { isUndefinedOrNull: isUndefinedOrNull$5 } = ObjectUtil;
const setGlobalTranslations = (data) => {
  initGlobalSharedData();
  const { integratedSharedData } = globalThis;
  if (!isUndefinedOrNull$5(integratedSharedData) && !_.isEmpty(integratedSharedData.translations)) {
    return;
  }
  if (isUndefinedOrNull$5(data)) {
    console.warn("No data passed to setGlobalTranslations");
    return;
  }
  const translations = new Map(Object.entries(data));
  globalThis.integratedSharedData.translations = translations;
};
const selectTranslations = (label) => {
  const { integratedSharedData } = globalThis;
  if (isUndefinedOrNull$5(label)) {
    console.warn("No label selected for selectTranslations");
    return null;
  }
  if (_.isEmpty(integratedSharedData) || isUndefinedOrNull$5(integratedSharedData.translations) || _.isEmpty(integratedSharedData.translations)) {
    console.warn("Translations are not ready");
    return null;
  }
  return integratedSharedData.translations.get(label);
};
const getCookie = (cookieKey) => {
  let cookieValue = document.cookie.split("; ").find((row) => row.startsWith(`${cookieKey}=`));
  if (cookieValue) {
    cookieValue = cookieValue.split("=")[1];
  }
  return cookieValue;
};
const accu$2 = getCookie("accu") || "Empower";
const getTranslationsService = () => {
  const method = "getTranslations";
  const getTranslationsSuccess = (results) => {
    if (results) {
      setGlobalTranslations(results.data);
      return results.data;
    }
  };
  const getCustomizationPath = (accuCode) => {
    return "/ui/customization-ui/customizations/" + accuCode + "/locales/";
  };
  const getUrl = (accuCode) => {
    const cacheBustEveryFifteenMinutes = Math.floor(Date.now() / 9e5);
    const url2 = getCustomizationPath(accuCode) + "en_US.json?v=" + cacheBustEveryFifteenMinutes;
    return url2;
  };
  return executeGet(getUrl(accu$2), "getTranslationsFault").then(getTranslationsSuccess).catch((e) => {
    LogService$1.getLogger().error(method + "Error - getTranslations failed", e);
  });
};
async function generateHashValue(string) {
  const utf8 = new TextEncoder().encode(string);
  const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, "0")).join("");
  return hashHex;
}
const { isUndefinedOrNull: isUndefinedOrNull$4 } = ObjectUtil;
const headerLogger = ExternalLogger$1.getInstance("headerMiddleware");
const getTranslations = () => {
  return async (dispatch) => {
    var _a2;
    if (!((_a2 = globalThis == null ? void 0 : globalThis.integratedSharedData) == null ? void 0 : _a2.translations)) {
      const data = await getTranslationsService();
      if (data) {
        dispatch(setTranslations(data));
      }
    } else {
      dispatch(
        setTranslations({
          header: globalThis.integratedSharedData.translations.get("header"),
          accountList: globalThis.integratedSharedData.translations.get("accountList"),
          footer: globalThis.integratedSharedData.translations.get("footer"),
          keepAlive: globalThis.integratedSharedData.translations.get("keepAlive"),
          investingSSOmodal: globalThis.integratedSharedData.translations.get("investingSSOmodal")
        })
      );
    }
  };
};
const getTransactionAccess = () => {
  const params = {
    txnCode: "WNLIAT,WNAMAS,WNFESS,WNCHAL,WNDNPS,WNWLNS,WNLANG,CXARP,CXASP,CXAPF,WNSPWB,WNACHT,WNACHB,WNCCHB,WNQVD,WNROR,WNAOC,WNTRHN,WNTRHI,WNBEN,CXAOE,CXMCDP,WNADDA,WNADDT,WNUPLD,WNSTMT,WNBALT,WNRIV2,CXEXPT,WNAORI,WNQVR"
  };
  return (dispatch, getState) => {
    return getTxnAccess(params, "integrated-mocks").then(function({
      WNLIAT,
      WNAMAS,
      WNFESS,
      WNCHAL,
      WNDNPS,
      WNWLNS,
      WNLANG,
      CXARP,
      CXASP,
      CXAPF,
      WNSPWB,
      WNACHT,
      WNACHB,
      WNCCHB,
      WNQVD,
      WNROR,
      WNAOC,
      WNTRHN,
      WNTRHI,
      WNBEN,
      CXAOE,
      CXMCDP,
      WNADDA,
      WNADDT,
      WNUPLD,
      WNSTMT,
      WNBALT,
      WNRIV2,
      CXEXPT,
      WNAORI,
      WNQVR
    }) {
      const state = getState();
      const txnAccess = {
        liatEnabled: WNLIAT,
        advisoryServiceEnabled: WNAMAS,
        financialEngineSSOEnabled: WNFESS,
        changeAllocationsEnabled: WNCHAL,
        dnpSSOEnabled: WNDNPS,
        wellnessEnabled: WNWLNS,
        showCommunicationPreferences: CXMCDP,
        changeLanguageEnabled: WNLANG,
        retirementPlannerEnabled: CXARP,
        savingsPlannerEnabled: CXASP,
        performanceEnabled: CXAPF,
        wnspwbEnabled: WNSPWB,
        txnAccessLoaded: true,
        liveChatEnable: WNACHT,
        chatBotEnable: WNACHB,
        enterpriseChatEnable: WNCCHB,
        quickViewEnabled: WNQVD,
        // disable Accounts Quick View section
        rateOfReturnEnabled: WNROR,
        contributionCardEnabled: WNAOC,
        legacyTransActionHistoryEnabled: WNTRHN,
        reactTransActionHistoryEnabled: WNTRHI,
        beneficiaries: WNBEN,
        investingSSOModal: CXAOE,
        addressUpdateForActiveEmployeeEnabled: WNADDA,
        addressUpdateForTermEmployeeEnabled: WNADDT,
        uploadDocumentsEnabled: WNUPLD,
        statementsAndDocuments: WNSTMT,
        newBalancesViewEnabled: WNBALT,
        isFeUser: WNRIV2,
        experimentsEnabled: CXEXPT,
        teacherInsuranceAnnuityAssoc: WNAORI,
        quickViewRedesignEnabled: WNQVR
      };
      globalThis.integratedEligibility.showCommunicationPreferences = CXMCDP === true;
      globalThis.integratedEligibility.savingsPlannerEnabled = txnAccess.savingsPlannerEnabled;
      globalThis.integratedEligibility.retirementPlannerEnabled = txnAccess.retirementPlannerEnabled;
      globalThis.integratedEligibility.addressUpdateForActiveEmployeeEnabled = txnAccess.addressUpdateForActiveEmployeeEnabled;
      globalThis.integratedEligibility.addressUpdateForTermEmployeeEnabled = txnAccess.addressUpdateForTermEmployeeEnabled;
      globalThis.integratedEligibility.uploadDocumentsEnabled = txnAccess.uploadDocumentsEnabled;
      globalThis.integratedEligibility.statementsAndDocuments = txnAccess.statementsAndDocuments;
      globalThis.integratedEligibility.loginWithSSO = state.sso.showSSOInvestingModal;
      globalThis.integratedEligibility.isFeUser = txnAccess.isFeUser;
      globalThis.liatEnabled = Boolean(txnAccess.liatEnabled);
      globalThis.quickView = {
        enabled: Boolean(!txnAccess.quickViewEnabled),
        rateOfReturn: Boolean(txnAccess.rateOfReturnEnabled),
        contributionCard: Boolean(txnAccess.contributionCardEnabled),
        legacyTransActionHistory: Boolean(txnAccess.legacyTransActionHistoryEnabled),
        reactTransActionHistory: Boolean(txnAccess.reactTransActionHistoryEnabled),
        beneficiaries: Boolean(txnAccess.beneficiaries)
      };
      globalThis.quickViewRedesign = {
        enabled: Boolean(txnAccess.quickViewRedesignEnabled)
      };
      window.dispatchEvent(new CustomEvent("quick-view-set"));
      dispatch(setPlanTxnAccess(txnAccess));
      let counter = 0;
      const setPlanMessaging = () => {
        if (isUndefinedOrNull$4(window.csrf) && counter < 5) {
          setTimeout(() => {
            setPlanMessaging();
            counter += 1;
          }, 1e3);
        } else {
          dispatch(setPlanMessageList());
        }
      };
      setPlanMessaging();
      if (globalThis.integratedEligibility || localMocksTrue && window.location.port === "3001" && globalThis.integratedEligibility) {
        const urlSubRoute = window.location.hash.split("/")[2];
        if (!CXARP && urlSubRoute === "retirement-planner" || !CXASP && urlSubRoute === "savings-planner" || !CXAPF && urlSubRoute === "performance") {
          window.location.href = ReferenceData.INTEGRATED_DASHBOARD;
        }
      }
    });
  };
};
const setPlanMessageList = () => {
  return (dispatch, getState) => {
    const state = getState();
    const headerProps = state.header;
    const account2 = state.account;
    const activeGroupAccount = account2.activeGroupAccount;
    const broadcastPlanMessagesEvent = (planMessages) => {
      window.dispatchEvent(
        new CustomEvent("plan-messaging-set", {
          detail: planMessages
        })
      );
    };
    const extendProperties = (planMessages) => {
      return _.map(planMessages, (message, index2) => {
        return _.extend(message, {
          expand: false,
          appleHtml: _.includes(_.get(message, "planName"), "Apple"),
          active: index2 === 0,
          navigable: _.includes(_.get(message, "information"), "apple-k"),
          onClick: void 0 ? function() {
            window.location.href = [
              getCurrentDomain,
              "participant/accounts/",
              "#/account/",
              activeGroupAccount.individualId,
              "/",
              activeGroupAccount.groupId,
              "/contribution"
            ].join("");
          } : _.noop
        });
      });
    };
    if (globalThis.integratedEligibility.isRetail) {
      getRetailUserMessages().then((response) => {
        const getFormattedMessages = (userMessages) => {
          const allMessages = { messages: [], dashboardMessages: {} };
          each(userMessages, (message) => {
            const message1stDisplayLocation = message.displayLocations && message.displayLocations.length > 0 ? message.displayLocations[0] : "";
            const isDashboardMessage = message1stDisplayLocation.indexOf("#/dashboard") > -1;
            if (isDashboardMessage && message.category !== "ZERO_STATE" && !message.isStale) {
              if (typeof dashboardMessageCallback === "function") {
                message.dismissFunction = function() {
                  dashboardMessageCallback(message);
                };
              }
              if (message1stDisplayLocation > "") {
                if (message1stDisplayLocation === "#/dashboard/ace-block") {
                  if (dashboardMessages[message1stDisplayLocation]) {
                    const previousMsgRank = dashboardMessages[`${message1stDisplayLocation}.rank`] || 0;
                    const currentMsgRank = message.rank || 0;
                    if (currentMsgRank > previousMsgRank) {
                      dashboardMessages[message1stDisplayLocation] = message;
                    }
                  } else {
                    dashboardMessages[message1stDisplayLocation] = message;
                  }
                } else if (!dashboardMessages[message1stDisplayLocation]) {
                  dashboardMessages[message1stDisplayLocation] = message;
                }
              }
            } else if (isDashboardMessage && message.category === "ZERO_STATE") {
              if (message1stDisplayLocation > "") {
                if (message1stDisplayLocation !== "#/pla" || message1stDisplayLocation !== "#/insights") {
                  allMessages.messages.push(message);
                }
              } else {
                allMessages.messages.push(message);
              }
            } else if (!message.isStale && !message.lastViewedTime) {
              allMessages.messages.push(message);
            }
          });
          return allMessages.messages;
        };
        if (response && !isUndefinedOrNull$4(response)) {
          const userMessages = getFormattedMessages(response);
          broadcastPlanMessagesEvent(extendProperties(userMessages));
          dispatch(setHeaderPlanMessages(userMessages));
        }
      });
    } else {
      if (!headerProps.planMessagingSvcCalled) {
        getMessagesList().then(function(response) {
          if (response && response.length > 0) {
            broadcastPlanMessagesEvent(extendProperties(response));
            dispatch(setHeaderPlanMessages(response));
          }
        });
      }
    }
  };
};
const logout = function() {
  return async (dispatch, getState) => {
    var _a2;
    const state = getState();
    const headerProps = state.header;
    const logoutLegacyUrl = headerProps.iframeUrl + ReferenceData.LOGOUT_LEGACY_URL;
    if (!((_a2 = window.widgetStates) == null ? void 0 : _a2.hasSeenWelcomeWidget)) {
      await generateHashValue(window.userGuid).then((hashedUserGuid) => {
        const key = `hasSeenWelcomeWidget-${hashedUserGuid}`;
        localStorage.setItem(key, true);
      });
    }
    try {
      await endPCAPSession();
    } catch (e) {
      console.error("ERROR - endPCAPSession()", e);
    }
    const eventBusPayload = { action: "logout" };
    dispatch(dispatchEventBus(EventBusEvents.HEADER.LOGOUT, eventBusPayload));
    dispatchAmplitude({
      eventType: AMPLITUDE_EVENTS.SELECT_BUTTON,
      selection: EventBusEvents.HEADER.LOGOUT,
      payload: eventBusPayload
    });
    const event = new CustomEvent("authenticationStatusUpdated", {
      authenticationStatus: headerProps.authenticationStatus
    });
    window.dispatchEvent(event);
    sessionStorage.clear();
    axios.get(logoutLegacyUrl).then(() => {
      if (logoutTimer) {
        clearTimeout(logoutTimer);
      }
      dispatch(PWSLogout());
    }).catch(() => {
      if (logoutTimer) {
        clearTimeout(logoutTimer);
      }
      dispatch(PWSLogout());
    });
    let logoutTimer = setTimeout(function() {
      dispatch(PWSLogout());
    }, 2e3);
  };
};
const PWSLogout = () => {
  return (dispatch, getState) => {
    const state = getState();
    const accu2 = state.header.accu;
    const authenticationStatus = state.header.authenticationStatus;
    const isRetail = globalThis.integratedEligibility.isRetail;
    dispatch(setCache("clear"));
    clearCache();
    dispatch(setIsDeepLink(false));
    dispatch(setInitHeaderDone(false));
    if (isRetail) {
      setTimeout(() => {
        dispatch(
          setNonAuthHeader({
            showNonAuthHeader: true,
            initLogin: true,
            ssoLogin: false
          })
        );
      }, 800);
    } else {
      dispatch(
        setNonAuthHeader({
          showNonAuthHeader: true,
          initLogin: true,
          ssoLogin: false
        })
      );
    }
    if (!window.location.origin) {
      window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
    }
    const https = "https://";
    const http = "http://";
    const fromLangCode = "es";
    const period = ".";
    let logoutOrigin = window.location.origin;
    const clearAuthenticationStatusAndRedirect = (logoutDest2) => {
      headerLogger.info("clearAuthenticationStatusAndRedirect : starting");
      const authenticationStatus2 = {
        accuCode: "",
        authenticated: false,
        inboundSSOUser: false,
        partialAuth: false
      };
      setGlobalSharedAuthData(authenticationStatus2);
      dispatch(setAuthStatus(authenticationStatus2));
      headerLogger.info("clearAuthenticationStatusAndRedirect : redirecting to [{0}]", [
        logoutDest2
      ]);
      window.location.href = logoutDest2;
    };
    const postLogout = (authenticationStatus2, logoutDest2) => {
      headerLogger.info("logOut.postLogout starting..");
      deleteCookie("JSESSIONID", "/participant-web-services");
      deleteCookie("JSESSIONID", "/participant-authentication");
      deleteCookie("site_tok", "/");
      deleteCookie("site_tok", "/participant");
      deleteCookie("accu", "/");
      deleteCookie("accu", "/participant");
      deleteCookie("clientAccu", "/");
      deleteCookie("clientAccu", "/participant");
      if (authenticationStatus2.inboundSSOUser) {
        getAcctsCustomizationRetrievalList(accu2).then(
          function(customizedData) {
            headerLogger.info("customized data {0}", [JSON.stringify(customizedData)]);
            if (customizedData.inboundSSOLogoutRedirectURL) {
              logoutDest2 = customizedData.inboundSSOLogoutRedirectURL;
            }
            clearAuthenticationStatusAndRedirect(logoutDest2);
          },
          function() {
            clearAuthenticationStatusAndRedirect(logoutDest2);
          }
        );
      } else {
        clearAuthenticationStatusAndRedirect(logoutDest2);
      }
    };
    if (logoutOrigin.indexOf(https + fromLangCode) >= 0 || logoutOrigin.indexOf(http + fromLangCode) >= 0) {
      logoutOrigin = logoutOrigin.replace(https + fromLangCode + period, https);
      logoutOrigin = logoutOrigin.replace(http + fromLangCode + period, http);
    }
    clearResponseLanguageCookies().then(
      function(data) {
        headerLogger.info("Logout cookies have been cleared. {0}", [data]);
        clearLanguageCookies().then(
          function(resp) {
            headerLogger.info("Logout cookies have been cleared. {0}", [resp]);
          },
          () => {
            headerLogger.info("Logout cookies have NOT been cleared. {0}");
          }
        );
      },
      () => {
        headerLogger.info("Logout cookies have NOT been cleared. {0}");
      }
    );
    const logoutDest = logoutOrigin + ReferenceData.LOGIN_URL_W_ACCU + accu2;
    callLogoutSvc().then(
      function() {
        headerLogger.info("logOut.postLogoutSuccess");
        postLogout(authenticationStatus, logoutDest);
      },
      function(err) {
        headerLogger.info("logOut.postLogOutErr : {0}", [JSON.stringify(err)]);
        postLogout(authenticationStatus, logoutDest);
      }
    );
  };
};
const getPSCPath = () => {
  return (dispatch) => {
    return getPSCPathSvc().then(function(results) {
      dispatch(setPscUrl(results));
    });
  };
};
const getUserProfile = () => {
  return (dispatch) => {
    return getUserProfileSvc().then(function(results) {
      if (results) {
        dispatch(setUserData(results));
      }
    });
  };
};
const sortTopNavPlans = function(allAccounts) {
  let currentContextPlans = [];
  const otherContextPlans = [];
  const nmrowList = {};
  let combinedPlanList = [];
  if (allAccounts.length > 1) {
    const inContextListInit = filter$1(allAccounts, (item) => {
      return item.currentContext;
    });
    currentContextPlans = sortBy(inContextListInit, (o) => o.groupId);
    const outOfContextListInit = filter$1(allAccounts, (item) => {
      return !item.currentContext;
    });
    const outOfContextList = sortBy(outOfContextListInit, (o) => o.individualId);
    forEach$1(outOfContextList, function(nmplan) {
      const tempArr = String(nmplan.groupId).split("-");
      const isTaxableAcct = tempArr.length > 2;
      const groupId = isTaxableAcct ? tempArr[0] + "-" + tempArr[1] : nmplan.groupId;
      let key = nmplan.individualId + "-" + nmplan.accuCode;
      if (isTaxableAcct) {
        key = nmplan.individualId + "-" + nmplan.accuCode + "-" + groupId;
      }
      if (nmrowList[key] === void 0 || nmrowList[key] === null) {
        nmplan.showToolTip = String(nmplan.planName).length > 18;
        nmrowList[key] = [];
        nmrowList[key].push(nmplan);
      } else {
        nmplan.showToolTip = String(nmplan.planName).length > 18;
        nmrowList[key].push(nmplan);
      }
    });
    Object.keys(nmrowList).forEach(function(key) {
      if (nmrowList[key].length > 1) {
        const sortedOtherContextPlans = sortBy(nmrowList[key], (o) => o.groupId);
        forEach$1(sortedOtherContextPlans, function(plan) {
          otherContextPlans.push(plan);
        });
      } else if (nmrowList[key].length == 1) {
        otherContextPlans.push(nmrowList[key][0]);
      }
    }, nmrowList);
    forEach$1(currentContextPlans, function(plan) {
      combinedPlanList.push(plan);
    });
    forEach$1(otherContextPlans, function(plan) {
      combinedPlanList.push(plan);
    });
  } else {
    combinedPlanList = allAccounts;
  }
  return combinedPlanList;
};
const processAccounts = (data, activeGroupAccount) => {
  if (!data || !data.length > 0 || String(data[1].displayText).indexOf("Account") === -1)
    return data;
  let processedAccounts = [];
  const truncateDisplayName = (item) => {
    const displayPlanName = item.planName;
    if (displayPlanName && displayPlanName.length > 80) {
      item.planName = displayPlanName.slice(0, 80) + "…";
    }
  };
  const truncateSubsetName2 = (item) => {
    const subsetName = item.subsetName;
    if (subsetName && subsetName.length >= 70) {
      item.subsetName = subsetName.slice(0, 70) + "…";
    }
  };
  const verifyCurrentContext = (item) => {
    const tempArr = String(item.groupId).split("-");
    const isTaxableAcct = tempArr.length > 2;
    const groupId = isTaxableAcct ? tempArr[0] + "-" + tempArr[1] : item.groupId;
    if (item.currentContext && data[1].subMenu.length > 1 && activeGroupAccount.individualId && item.individualId && activeGroupAccount.individualId != item.individualId) {
      if (isTaxableAcct && activeGroupAccount.groupId !== groupId) {
        item.currentContext = false;
      } else if (!isTaxableAcct) {
        item.currentContext = false;
      }
    }
  };
  const checkSiteName = (item) => {
    if (item.siteName && ReferenceData.HAS_RETAIL_ACCOUNT.SITE_NAME.some(
      (siteName) => siteName === item.siteName
    )) {
      globalThis.integratedEligibility.hasRetailAccount = true;
    }
  };
  if (data[1].subMenu.length > 0) {
    each(data[1].subMenu, (item) => {
      item.planName = item.displayText;
    });
  }
  if (data[1].subMenu.length > 1) {
    each(data[1].subMenu, function(item) {
      verifyCurrentContext(item);
      truncateDisplayName(item);
      checkSiteName(item);
      if (item.subsetName) truncateSubsetName2(item);
      item.plName = item.planName;
      processedAccounts.push(item);
    });
    processedAccounts = sortTopNavPlans(processedAccounts);
    data[1].subMenu = processedAccounts;
  }
  return data;
};
const refreshTopNav = (acctOpened) => {
  return (dispatch, getState) => {
    const state = getState();
    const account2 = state.account;
    const activeGroupAccount = account2.activeGroupAccount;
    if (acctOpened) {
      return getNavSettings(acctOpened).then(function(response) {
        const updatedData = processAccounts(response, activeGroupAccount);
        dispatch(setAccountMenuList(updatedData));
        dispatch(setNavSettings(updatedData));
        dispatch(getAccountSummary());
      });
    } else {
      return getNavSettings(false).then(function(response) {
        const updatedData = processAccounts(response, activeGroupAccount);
        dispatch(setNavSettings(updatedData));
      });
    }
  };
};
const accountLogger$1 = ExternalLogger$1.getInstance("accountSwitchMiddleware");
const getCurrentLanguageSite = () => {
  const currentUrl = window.location.href;
  const https = "https://";
  const http = "http://";
  const spnLangCode = "es";
  let retLanguageSite = "ENG";
  if (currentUrl.indexOf(https + spnLangCode) >= 0 || currentUrl.indexOf(http + spnLangCode) >= 0) {
    retLanguageSite = "SPN";
  }
  return retLanguageSite;
};
const updateQueryStringParameter$1 = (uri) => {
  const key = "accu";
  const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  const separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + window.accu + "$2");
  } else {
    return uri + separator + key + "=" + window.accu;
  }
};
const switchRedirect = (nextgenDest, dispatch) => {
  continueEnd(dispatch);
  let currentDomain = window.location.protocol + "//" + window.location.hostname;
  if (window.location.port !== "") {
    currentDomain += ":" + window.location.port;
  }
  currentDomain += "/";
  const locationPriorToRedirect = window.location.href;
  const redirectDest = currentDomain + nextgenDest;
  if (window.location.href === redirectDest || locationPriorToRedirect.indexOf("plan-balances") >= 0 || locationPriorToRedirect.indexOf("other-assets") >= 0) {
    window.location.reload();
    return false;
  }
  if (locationPriorToRedirect.indexOf("retirement-income") >= 0 && redirectDest.indexOf("retirement-income") >= 0) {
    accountLogger$1.error("Updating window.location and reload - {0}", [redirectDest]);
    window.location.href = redirectDest;
    setTimeout(function() {
      window.location.reload();
      return false;
    }, 100);
  } else if (locationPriorToRedirect.indexOf("enroll") >= 0 && redirectDest.indexOf("enroll") >= 0) {
    window.location.href = redirectDest;
    setTimeout(function() {
      window.location.reload();
      return false;
    }, 100);
  } else if (redirectDest.indexOf("account-details") >= 0) {
    window.location.href = redirectDest;
    setTimeout(function() {
      window.location.reload();
      return false;
    }, 100);
  } else {
    accountLogger$1.error("Updating and reload window.location - {0}", [redirectDest]);
    window.location.href = redirectDest;
    setTimeout(function() {
      window.location.reload();
      return false;
    }, 100);
  }
};
const continueEnd = (dispatch) => {
  dispatch(setIsContinueCalled(false));
};
const redirectToPreferredLanguageSite$1 = (nextgenDest, selectedLanguage, req, dispatch) => {
  const currentUrl = window.location.href;
  const https = "https://";
  const http = "http://";
  const period = ".";
  const toLangCode = "es";
  let newUrl = currentUrl;
  let idx = currentUrl.indexOf("participant/");
  if (idx < 0) {
    idx = currentUrl.indexOf(window.location.pathname);
  }
  if (idx >= 0) {
    const newOrigin = currentUrl.substr(0, idx);
    if (selectedLanguage === "SPN") {
      if (newOrigin.indexOf(https + toLangCode) < 0 && newOrigin.indexOf(http + toLangCode) < 0) {
        newUrl = newOrigin.replace(https, https + toLangCode + period);
        newUrl = newUrl.replace(http, http + toLangCode + period);
      }
      clearResponseLanguageCookies().then(
        function() {
          setLanguageCookies().then(
            function(response) {
              if (response) {
                continueEnd(dispatch);
                window.location.href = updateQueryStringParameter$1(
                  newUrl + nextgenDest
                );
              } else {
                accountLogger$1.error(
                  "Failed to clone the cookie for Spanish site",
                  response
                );
                switchRedirect(nextgenDest, dispatch);
              }
            },
            function(error) {
              accountLogger$1.error(
                "Failed to clone the cookie for Spanish site",
                error
              );
              switchRedirect(nextgenDest, dispatch);
            }
          );
        },
        function(error) {
          accountLogger$1.error("Failed to clear Spanish site cookie", error);
          switchRedirect(nextgenDest, dispatch);
        }
      );
    } else {
      newUrl = newOrigin.replace(https + toLangCode + period, https);
      newUrl = newUrl.replace(http + toLangCode + period, http);
      updateEngDefaultPlan(req).then(
        function() {
          const method = "AccountSwitchController updateEngDefaultPlan";
          accountLogger$1.error(method + " - redirect to " + nextgenDest);
          setAccuCodeCookies().then(
            function() {
              continueEnd(dispatch);
              window.location.href = updateQueryStringParameter$1(newUrl + nextgenDest);
            },
            function(error) {
              accountLogger$1.error("Failed to add accuCode language cookie", error);
              switchRedirect(nextgenDest, dispatch);
            }
          );
        },
        function(error) {
          accountLogger$1.error("Failed to add accuCode language cookie", error);
          switchRedirect(nextgenDest, dispatch);
        }
      );
    }
  } else {
    accountLogger$1.error("Failed to get current site origin", currentUrl);
    switchRedirect(nextgenDest);
  }
};
const navToPlan = (req) => {
  return (dispatch, getState) => {
    const state = getState();
    const header2 = state.header;
    const tempAccountArr = String(state.account.clickedAccount.groupId).split("-");
    const isTaxableAcct = tempAccountArr.length > 2;
    if (isTaxableAcct) {
      req.gaId = tempAccountArr[0] + "-" + tempAccountArr[1];
    }
    const isLanguageEnabled = header2.txnAccess && header2.txnAccess.changeLanguageEnabled ? header2.txnAccess.changeLanguageEnabled : false;
    updateDefaultPlanSvc(req).then(
      function(response) {
        const method = "AccountSwitchController updateDefaultPlan";
        let newAccuCode = req.accuCode;
        const customAccuFolder = window.supportedACCU.folders;
        let itemIndex;
        if (response) {
          if (response.primaryPlan && response.primaryPlan.accuCode) {
            newAccuCode = response.primaryPlan.accuCode;
          }
          itemIndex = customAccuFolder.indexOf(newAccuCode);
          if (itemIndex < 0) {
            newAccuCode = "Empower";
            itemIndex = customAccuFolder.indexOf(newAccuCode);
          }
        }
        if (newAccuCode && window.accu !== newAccuCode && itemIndex >= 0) {
          accountLogger$1.error(
            "{0} - Empower Restricted authentication..changing accu to [{1}]",
            [method, newAccuCode]
          );
          deleteCookie(window.accu, "/");
          deleteCookie(window.accu, "/participant");
          deleteCookie(window.accu, "/");
          deleteCookie(window.accu, "/participant");
          window.accu = newAccuCode;
          accountLogger$1.error("{0} - updating accu...", [method]);
          const currentUrl = window.location.href;
          const currentDomain = window.location.hostname;
          let priorDomain = currentDomain.replace("es.", "");
          const https = "https://";
          const http = "http://";
          const toLangCode = "es";
          if (currentUrl.indexOf(https + toLangCode) >= 0 || currentUrl.indexOf(http + toLangCode) >= 0) {
            deleteCookie("accu", "/", priorDomain);
            deleteCookie("accu", "/participant", priorDomain);
            deleteCookie("clientAccu", "/", priorDomain);
            deleteCookie("clientAccu", "/participant", priorDomain);
          } else {
            priorDomain = "." + currentDomain;
            deleteCookie("accu", "/", priorDomain);
            deleteCookie("accu", "/participant", priorDomain);
            deleteCookie("clientAccu", "/", priorDomain);
            deleteCookie("clientAccu", "/participant", priorDomain);
          }
          updateAccuCookie(newAccuCode);
          dispatch(getAccuCode());
        }
        let nextgenDest = response ? response.destinationUrl : "";
        const locationPriorToRedirect = window.location.href;
        const participantAccountsPage = window.location.pathname === "/participant/accounts/";
        if (nextgenDest.indexOf("liatLanding") >= 0 || locationPriorToRedirect.indexOf("other-assets") >= 0) {
          if (participantAccountsPage && !isTaxableAcct) {
            if (String(locationPriorToRedirect).indexOf("myerira-account-details") > -1 && String(response.primaryPlan.accuCode).toLowerCase().includes("myerira")) {
              nextgenDest = `participant/accounts/#/account/${response.primaryPlan.indId}/${response.primaryPlan.gaId}/myerira-account-details`;
            } else {
              nextgenDest = `participant/accounts/#/account/${response.primaryPlan.indId}/${response.primaryPlan.gaId}/account-details`;
            }
          } else {
            nextgenDest = `participant/home/#/dashboard/retirement-income`;
          }
        }
        let languageCode = response ? response.languageCode : null;
        const currentLanguageSite = getCurrentLanguageSite();
        if (!isLanguageEnabled) {
          languageCode = "ENG";
        }
        try {
          if (languageCode && languageCode !== currentLanguageSite) {
            redirectToPreferredLanguageSite$1(nextgenDest, languageCode, req, dispatch);
          } else {
            switchRedirect(nextgenDest, dispatch);
          }
        } catch (err) {
          accountLogger$1.error("Failed to redirect to language site", err);
          switchRedirect(nextgenDest, dispatch);
        }
      },
      function(err) {
        accountLogger$1.error("AccountSwitch Error - updateDefaultPlan", err);
      }
    );
  };
};
const refreshContext = () => {
  return (dispatch, getState) => {
    const state = getState();
    const header2 = state.header;
    refreshNewAcctContext().then(
      function(response) {
        if (response && response.data && response.data.gaId) {
          dispatch(setAccountOpenInProgress(true));
          if (header2.accountOpenInProgress) {
            const event = new CustomEvent$1("finish_acct_open_refresh");
            window.dispatchEvent(event);
          }
        } else {
          accountLogger$1.error(
            "refreshNewAcctContext Error - empty response data; data missing"
          );
        }
        dispatch(refreshTopNav(true));
      },
      function(err) {
        accountLogger$1.error("refreshNewAcctContext Error", err);
      }
    );
  };
};
function redirectToPreferredLanguageSite(selectedLanguage) {
  const currentUrl = window.location.href;
  const https = "https://";
  const http = "http://";
  const period = ".";
  let newUrl = currentUrl;
  const toLangCode = "es";
  if (selectedLanguage === "SPN") {
    if (currentUrl.indexOf(https + toLangCode) < 0 && currentUrl.indexOf(http + toLangCode) < 0) {
      newUrl = currentUrl.replace(https, https + toLangCode + period);
      newUrl = newUrl.replace(http, http + toLangCode + period);
    }
  } else {
    newUrl = currentUrl.replace(https + toLangCode + period, https);
    newUrl = newUrl.replace(http + toLangCode + period, http);
  }
  if (newUrl.indexOf("dashboard") > -1) {
    newUrl = updateQueryStringParameter(newUrl);
  }
  window.location.href = newUrl;
}
const getCookieValue = (key) => {
  return document.cookie.split("; ").find((row) => row.startsWith(key)).split("=")[1];
};
const updateQueryStringParameter = function(uri) {
  const key = "accu";
  const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  const separator = uri.indexOf("?") !== -1 ? "&" : "?";
  const accu2 = getCookieValue("accu");
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + accu2 + "$2");
  } else {
    return uri + separator + key + "=" + accu2;
  }
};
ExternalLogger$1.getInstance("sharedMiddleware");
const clearAccuCookies = (newLanguage) => {
  const currentUrl = window.location.href;
  const https = "https://";
  const http = "http://";
  const toLangCode = "es";
  const currentDomain = window.location.hostname;
  if (newLanguage === "SPN") {
    if ((currentUrl.indexOf(https + toLangCode) < 0 || currentUrl.indexOf(http + toLangCode) < 0) && currentUrl.indexOf("participant") >= 0 && currentUrl.indexOf("login") < 0) {
      clearResponseLanguageCookies().then(
        (resp) => {
          console.log("SSO Spanish cookies have been cleared.", resp);
          setLanguageCookies().then((data) => {
            console.log("SSO Cloned cookies for Spanish site", data);
          });
        },
        (error) => {
          console.log("SSO Failed to clearSpanishLanguageCookies", error);
        }
      );
    }
  } else {
    if (currentUrl.indexOf(https + toLangCode) >= 0 || currentUrl.indexOf(http + toLangCode) >= 0) {
      const priorDomain = currentDomain.replace("es.", "");
      const currentAccu = window.accu;
      if (currentUrl.indexOf(https + toLangCode) >= 0 || currentUrl.indexOf(http + toLangCode) >= 0) {
        deleteCookie("accu", "/", priorDomain);
        deleteCookie("accu", "/participant", priorDomain);
        deleteCookie("clientAccu", "/", priorDomain);
        deleteCookie("clientAccu", "/participant", priorDomain);
        saveCookie("accu", currentAccu, "/", priorDomain);
        saveCookie("accu", currentAccu, "/participant", priorDomain);
        saveCookie("clientAccu", currentAccu, "/", priorDomain);
        saveCookie("clientAccu", currentAccu, "/participant", priorDomain);
      }
    }
  }
};
const checkSwitchAccu = () => {
  const https = "https://";
  const http = "http://";
  const toLangCode = "es";
  const period = ".";
  const switchAccu = document.cookie.replace(
    /(?:(?:^|.*;\s*)switchAccu\s*=\s*([^;]*).*$)|^.*$/,
    "$1"
  );
  let currentDomain = window.location.protocol + "://" + window.location.hostname;
  if (window.location.port !== "") {
    currentDomain += ":" + window.location.port;
  }
  if (switchAccu) {
    const expiresAt = "Thu, 01 Jan 1970 00:00:01 GMT";
    console.log("Found switchAccu, resetAccu.", switchAccu);
    let wildCardDomain = currentDomain;
    if (wildCardDomain && wildCardDomain.indexOf(toLangCode + period) >= 0) {
      wildCardDomain = wildCardDomain.replace(https + toLangCode, "");
      wildCardDomain = wildCardDomain.replace(http + toLangCode, "");
    } else {
      wildCardDomain = wildCardDomain.replace(https, ".");
      wildCardDomain = wildCardDomain.replace(http, ".");
    }
    console.log("footer view in the switchAccu with accu" + switchAccu);
    deleteCookie("accu", "/");
    deleteCookie("accu", "/participant");
    deleteCookie("clientAccu", "/");
    deleteCookie("clientAccu", "/participant");
    deleteCookie("switchAccu", "/");
    saveCookie("accu", "", "/", wildCardDomain, expiresAt);
    saveCookie("accu", "", "/participant", wildCardDomain, expiresAt);
    saveCookie("clientAccu", "", "/", wildCardDomain, expiresAt);
    saveCookie("clientAccu", "", "/participant", wildCardDomain, expiresAt);
    saveCookie("switchAccu", "", "/", wildCardDomain, expiresAt);
  }
};
const updateSelectedLanguage = (newLanguage, wnspwbEnabled) => {
  return (dispatch, getState) => {
    const state = getState();
    const shared2 = state.shared;
    updateLanguage(newLanguage).then((result2) => {
      if (result2 && result2.updateStatus === "successful") {
        console.log("updated lang", result2.languageCode);
        const eventBusPayload = { action: "change_language" };
        dispatch(dispatchEventBus(EventBusEvents.HEADER.CHANGE_LANGUAGE, eventBusPayload));
        dispatchAmplitude({
          eventType: AMPLITUDE_EVENTS.SELECT_BUTTON,
          selection: EventBusEvents.HEADER.CHANGE_LANGUAGE,
          payload: eventBusPayload
        });
        if (wnspwbEnabled) {
          redirectToPreferredLanguageSite(newLanguage);
          checkSwitchAccu();
          clearAccuCookies(newLanguage);
        }
        if (shared2.selectedLanguage !== newLanguage) {
          dispatch(setLanguageCode(result2.languageCode));
        }
      }
    });
  };
};
const getSelectedLanguage = () => {
  return (dispatch) => {
    getLanguageCode().then((result2) => {
      if (result2) {
        dispatch(setLanguageCode(result2.languageCode));
      }
    });
  };
};
const accountLogger = ExternalLogger$1.getInstance("accountMiddleware");
const getPrimaryGroupAccount = (initCss) => {
  return (dispatch, getState) => {
    const state = getState();
    const accounts = state.account;
    return getPrimaryGrpAcct().then(
      function(response) {
        if ((initCss || accounts.cssGroupId === "not-initialized") && response) {
          const groupClient = String(response.groupId).split("-");
          const groupClientId = groupClient[0];
          dispatch(
            setCss({
              type: "group",
              groupId: response.groupId,
              groupClient: groupClientId
            })
          );
        }
        if (response == null ? void 0 : response.groupId) {
          dispatch(setAccountLoaded(response));
          const groupAcct = {
            individualId: response.individualId,
            groupId: response.groupId
          };
          dispatch(retrieveAccountMenuDetailsOnly(groupAcct));
          return getAccountDetailsSvc(response).then(function(acctDetails) {
            if (acctDetails) {
              const groupClient = String(acctDetails.groupId).split("-");
              const groupClientId = groupClient[0];
              dispatch(
                setCss({
                  type: "product",
                  productId: acctDetails.productId,
                  groupId: acctDetails.groupId,
                  groupClient: groupClientId
                })
              );
              dispatch(setAccountDetailsData(acctDetails));
              if (acctDetails.defaultPlan) {
                dispatch(
                  setDefaultGrpIdIndId({
                    defaultGroupId: acctDetails.groupId,
                    defaultIndId: acctDetails.individualId
                  })
                );
              }
              return acctDetails;
            }
          });
        }
      },
      function(error) {
        accountLogger.error("Error - get primary group acct", error);
      }
    ).then(function(acctDetails) {
      if (acctDetails) {
        dispatch(setAccountDetailsLoaded(true));
        const userProps = {
          age: acctDetails.age,
          individualId: acctDetails.individualId,
          planId: acctDetails.groupId,
          planName: acctDetails.description,
          terminated: acctDetails.statusCode !== "A",
          appVersion: `${name}@${version} `,
          platformSource: "pptweb-ao"
        };
        acctDetails.userProperties = userProps;
        dispatch(
          dispatchEventBus(EventBusEvents.APPLICATION.INIT_COMPLETE, {}, acctDetails)
        );
      }
    }).catch((error) => {
      console.log("ERROR - getPrimaryGroupAccount :: ", error);
    });
  };
};
const getAccountSummary = (newAccountHasOpened) => {
  return (dispatch) => {
    let accountsArr = [];
    return getAccountSummarySvc(newAccountHasOpened).then(function(accountData) {
      if (accountData) {
        accountData.asOfDate;
        accountData.totalBalance;
        const tmpAccounts = [];
        getObjAsArray(accountData.nonMonthlyAccounts).forEach(function(account2) {
          tmpAccounts.push(account2);
        });
        getObjAsArray(accountData.monthlyAccounts).forEach(function(account2) {
          tmpAccounts.push(account2);
        });
        accountsArr = sortPlans(tmpAccounts);
        dispatch(setAccountSummaryList(accountsArr));
        const currentContextAcct = filter$1(accountsArr, (item) => {
          return item.currentContext;
        });
        if (currentContextAcct.length > 0) {
          dispatch(setCurrentAccount(currentContextAcct[0]));
        }
        dispatch(setAcctSummaryBalance(accountData));
      }
    });
  };
};
const continueSwitchPlan = (accountParam, isList) => {
  const method = "continueSwitchPlan";
  return (dispatch, getState) => {
    const state = getState();
    const account2 = state.account;
    const navMenu2 = state.navMenu;
    const tempAccountArr = String(accountParam.groupId).split("-");
    const isTaxableAcct = tempAccountArr.length > 2;
    let taxableAcctGroupId = "";
    if (isTaxableAcct) {
      taxableAcctGroupId = tempAccountArr[0] + "-" + tempAccountArr[1];
    }
    let allMenuAccounts = account2.accountSummaryList;
    allMenuAccounts.forEach((acctItem) => {
      if (account2.activeGroupAccount.groupId === acctItem.groupId && account2.activeGroupAccount.individualId === acctItem.individualId) {
        dispatch(setCurrentAccount(acctItem));
      }
    });
    try {
      if (!accountParam) {
        accountLogger.error(
          "continueSwitchPlan Error: Account not found on account summary"
        );
      }
      let matchSelectedAssetWithAccount = [];
      if (accountParam.userAccountId) {
        matchSelectedAssetWithAccount = find(allMenuAccounts, (accountItem) => {
          return accountItem.groupId === accountParam.groupId && accountParam.userAccountId && accountItem.pcapAccountId === accountParam.userAccountId || accountItem.groupId === accountParam.planId && !accountParam.individualId || accountItem.groupId === accountParam.planId && accountItem.individualId === accountParam.individualId || accountItem.groupId === accountParam.groupId && accountItem.individualId === accountParam.individualId;
        });
      } else {
        matchSelectedAssetWithAccount = find(allMenuAccounts, (accountItem) => {
          return accountItem.groupId === accountParam.planId && !accountParam.individualId || accountItem.groupId === accountParam.planId && accountItem.individualId === accountParam.individualId || accountItem.groupId === accountParam.groupId && accountItem.individualId === accountParam.individualId;
        });
      }
      const { individualId } = matchSelectedAssetWithAccount;
      let reqParams = {
        individualId: accountParam.individualId,
        dbName: accountParam.dbName ? accountParam.dbName : "NONE",
        accuCode: accountParam.accuCode,
        groupId: isTaxableAcct ? taxableAcctGroupId : accountParam.groupId
      };
      if (individualId !== account2.currentAccount.individualId || individualId === account2.currentAccount.individualId && accountParam.accuCode !== account2.currentAccount.accuCode) {
        if (!isList) {
          reqParams = {
            individualId: matchSelectedAssetWithAccount.individualId,
            dbName: matchSelectedAssetWithAccount.dbName,
            accuCode: matchSelectedAssetWithAccount.accuCode
          };
        }
        getPrimaryPlanByIndIdSvc(reqParams).then(
          function(response) {
            if (response) {
              allMenuAccounts = account2.accountSummaryList;
              allMenuAccounts.forEach(function(acct) {
                if (isTaxableAcct) {
                  const responseGrpId = response.gaId + "-" + tempAccountArr[2];
                  if (acct.groupId === responseGrpId && acct.individualId === response.indId) {
                    dispatch(setClickedAccount(acct));
                  }
                } else if (acct.groupId === response.gaId && acct.individualId === response.indId) {
                  dispatch(setClickedAccount(acct));
                }
              });
              const param = {
                defaultGroupId: response.defaultGroupId,
                defaultIndId: response.defaultIndId
              };
              dispatch(setDefaultGrpIdIndId(param));
              if (navMenu2.openSaveChanges) {
                dispatch(setOpenSaveChanges(false));
              }
              dispatch(navToPlan(reqParams));
            }
          },
          function(err) {
            accountLogger.error(method + " Error - Get Primary Plan By IndId", err);
          }
        );
      }
    } catch (error) {
      accountLogger.error("continueSwitchPlan Error: {0}", [error.message]);
    }
  };
};
const retrieveSiteContactInfo = () => {
  return (dispatch, getState) => {
    const state = getState();
    const account2 = state.account;
    getSiteContactInfo(account2.activeGroupAccount.groupId).then(function(response) {
      dispatch(setSiteContactInfo(response));
      dispatch(getSelectedLanguage());
    });
  };
};
const setAccountLoaded = (data) => {
  return {
    type: SET_ACCOUNT_LOADED,
    payload: data
  };
};
const setAccountDetailsData = (acctDetails) => {
  return {
    type: SET_ACCOUNT_DETAILS,
    payload: acctDetails
  };
};
const setAccountDetailsLoaded = (payload) => {
  return {
    type: SET_ACCOUNT_DETAILS_LOADED,
    payload
  };
};
const setAccountSummaryList = (payload) => {
  return (dispatch) => {
    each(payload, async (account2) => {
      if (ObjectUtil.isUndefinedOrNull(account2.pcapAccountId)) {
        await dispatch(retrieveMenuNavDetails(account2.groupId));
      }
    });
    dispatch({
      type: SET_ACCOUNT_SUMMARY_LIST,
      payload
    });
  };
};
const setAcctSummaryBalance = (item) => {
  const summaryOfAllAccounts = {
    asOfDate: item.asOfDate,
    totalBalance: item.totalBalance
  };
  return {
    type: SET_SUMMARY_TOTAL,
    payload: summaryOfAllAccounts
  };
};
const setSelectedAccount = (payload) => {
  return {
    type: SET_SELECTED_ACCOUNT,
    payload
  };
};
const setCurrentAccount = (payload) => {
  payload.planName = payload.name;
  return {
    type: SET_CURRENT_ACCOUNT,
    payload
  };
};
const setClickedAccount = (payload) => {
  payload.planName = payload.name;
  return {
    type: SET_CLICKED_ACCOUNT,
    payload
  };
};
const setDefaultGrpIdIndId = (payload) => {
  return {
    type: SET_DEFAULT_GRPID_INDID,
    payload
  };
};
const setIsContinueCalled = (payload) => {
  return {
    type: SET_IS_CONTINUE_CALLED,
    payload
  };
};
const setCss = (payload) => {
  return {
    type: SET_CSS,
    payload
  };
};
const switchPlan = (accountParam, planId, closeMenu, indId) => {
  return (dispatch, getState) => {
    const state = getState();
    const navMenu2 = state.navMenu;
    const account2 = state.account;
    const accountList = account2.accountSummaryList;
    if (planId && indId) {
      accountParam = find(accountList, (account3) => {
        return planId === account3.groupId && indId === account3.individualId;
      });
    } else if (planId) {
      accountParam = find(accountList, (account3) => {
        return planId === account3.groupId || account3.groupId.indexOf(planId) > -1;
      });
    }
    if (accountParam) {
      accountParam.planId = planId;
    }
    if (isPreventUrl(navMenu2, dispatch)) {
      dispatch(setNextVal("SWITCH_PLAN"));
      dispatch(setOpenSaveChanges(true));
      dispatch(setSelectedAccount(accountParam));
    } else {
      if (closeMenu) {
        closeMenu();
      }
      dispatch(continueSwitchPlan(accountParam));
    }
  };
};
const openOrCloseSSOInvestingModal = (payload) => {
  return {
    type: OPEN_OR_CLOSE_SSO_INVESTING_MODAL,
    payload
  };
};
const setActiveDeepLink = (payload) => {
  return {
    type: SET_ACTIVE_DEEP_LINK,
    payload
  };
};
const getDefaultAcctsCustRetrievalList = () => {
  const getDefaultAcctsCustRetrievalResult = (response) => {
    return response.data;
  };
  const url2 = "/ui/customization-ui/" + ReferenceData.DEFAULT_ACCTS_CUST_RETRIEVAL_URL;
  return executeGet(url2, "getDefaultAcctsCustRetrievalFault").then(getDefaultAcctsCustRetrievalResult).catch((error) => {
    console.log("Error: ", error);
  });
};
const headerLog = ExternalLogger$1.getInstance("headerLogic");
let authenticated = false;
let showGenericLogoPrelogin = false;
let accuLogo = "";
let accuLogoPNG = "";
let accuLogoClass = "";
let accuCustomization = {};
let accu$1 = "";
const propertyToBoolean = (val) => {
  const booleanState = ["false", "true"].indexOf(val);
  return booleanState >= 0 ? Boolean(booleanState) : val;
};
function redirectToLogin() {
  window.location.href = `/participant/#/login?accu=${getCookie("accu")}`;
}
const processAuthentication = (data, dispatch, headerProps, hash) => {
  try {
    if (data) {
      dispatch(setCache(data));
    }
    const authenticationStatus = {};
    const method = "processAuthentication()";
    const exclusionList = ["ssoSpinner", "/d/", "deepLink"];
    headerLog.debug(method + "Enter method. header logic");
    extend$1(authenticationStatus, mapValues(data, propertyToBoolean));
    authenticated = authenticationStatus.authenticated;
    const redirectForNoAuth = exclusionList.filter((item) => {
      return hash.indexOf(item) !== -1;
    }).length === 0;
    setGlobalSharedAuthData(authenticationStatus);
    dispatch(setAuthStatus(authenticationStatus));
    if (authenticated) {
      headerLog.debug(method + " - User is authenticated. Call HeaderFactory.");
      if (!headerProps.showNonAuthHeader) {
        dispatch(setAccountDetailsLoaded(false));
        dispatch(getPrimaryGroupAccount());
        dispatch(getUserProfile());
        dispatch(getAccountSummary());
      }
      dispatch(setInitHeaderDone(true));
      return true;
    } else if (!authenticated && redirectForNoAuth) {
      redirectToLogin();
      dispatch(setInitHeaderDone(true));
      return false;
    } else {
      dispatch(setInitHeaderDone(true));
      return false;
    }
  } catch (error) {
    console.error("Error in Process Authentication: ", error);
  }
};
const setAccuLogoClass = (accu2) => {
  accuLogoClass = accu2.toLowerCase() + "-logo";
};
const setPageTitle = (hdrTitle) => {
  const doc = document.getElementById("header-title");
  if (doc) {
    doc.innerHTML = hdrTitle;
  }
};
const setAccuData = (data) => {
  globalThis.faviconPng = data.faviconPng;
  try {
    document.getElementsByTagName("body").className += " " + String(accu$1).toLowerCase();
    if (ObjectUtil.isUndefinedOrNull(data)) {
      return;
    }
    accuCustomization = data;
    showGenericLogoPrelogin = !ObjectUtil.isUndefinedOrNull(data.showGenericLogoPrelogin) ? data.showGenericLogoPrelogin : false;
    if (authenticated || !(showGenericLogoPrelogin && !authenticated)) {
      accuLogo = !ObjectUtil.isUndefinedOrNull(accuCustomization.logoUrl) ? accuCustomization.logoUrl : "";
      accuLogoPNG = !ObjectUtil.isUndefinedOrNull(accuCustomization.logoUrlpng) ? accuCustomization.logoUrlpng : "";
      setAccuLogoClass(accu$1);
    }
    const payload = {
      showGenericLogoPrelogin,
      accuLogo,
      accuLogoPNG,
      accuLogoClass,
      accuLogoAltAttribute: accuCustomization.preLoginLogoAltAttribute,
      accuCustomization,
      educationCenterUrl: accuCustomization.educationCntrURL,
      faviconIco: accuCustomization.faviconIco,
      faviconPng: accuCustomization.faviconPng,
      menuItemModalManifest: data.menuItemModalManifest
    };
    return payload;
  } catch (error) {
    console.error("Error in SetAccu method: ", error);
  }
};
const setFavicon = () => {
  const accuFaviconPngUrl = sessionStorage.getItem("accuFaviconPng");
  const styleEnv = "/ui/customization-ui/";
  const empowerHref = `${styleEnv}customizations/Default/images/magic-login/favicon.png`;
  const customHref = `${styleEnv}${accuFaviconPngUrl}`;
  const faviconPngEl = document.createElement("link");
  faviconPngEl.rel = `icon`;
  faviconPngEl.type = `image/png`;
  faviconPngEl.href = globalThis.accu === "Empower" ? empowerHref : customHref;
  Array.from(document.head.querySelectorAll('link[type="image/png"]')).forEach(
    (el2) => el2.remove()
  );
  document.head.append(faviconPngEl);
};
const initCustomizations = (dispatch, headerProps) => {
  const method = "initCustomizations()";
  accu$1 = headerProps.accu;
  if (headerProps.initializeHeaderDone || headerProps.showNonAuthHeader) {
    return;
  }
  if (window.location.href.indexOf("/npdi") !== -1 || window.location.href.indexOf("/mfa") !== -1 || window.location.href.indexOf("/login") !== -1 || window.location.href.indexOf("/register") !== -1) {
    clearCache();
  }
  dispatch(setPscUrl([ReferenceData.PSC_PATH_DEFAULT_URL]));
  if (headerProps.cache) {
    dispatch(setCache("clear"));
  }
  setTimeout(function() {
    Promise.all([
      getAuthData(),
      getDefaultAcctsCustRetrievalList(),
      getAcctsCustomizationRetrievalList(accu$1)
    ]).then(
      function(responses) {
        processAuthentication(
          first(responses),
          dispatch,
          headerProps,
          window.location.hash
        );
        const defaultStyles = setAccuData(responses[1]);
        dispatch(setAccuCustomizations(defaultStyles));
        const accuStyles = setAccuData(responses[2]);
        dispatch(setAccuCustomizations(accuStyles));
        setFavicon();
      },
      function(fault) {
        headerLog.error(method + " - Enter method.  header logic" + String(fault));
      }
    ).catch(function(fault) {
      headerLog.error("Exception initCustomizations at non login pages: {0}", fault);
    });
  }, 2e3);
  headerLog.debug(method + " -  initCustomizations done. headerLogic");
  dispatch(setAccuLogoLoaded());
};
const initLoginCustomization = (dispatch, headerProps) => {
  const setAuthData = (data, dispatch2) => {
    const authenticationStatus = data;
    authenticated = authenticationStatus.authenticated;
    setGlobalSharedAuthData(authenticationStatus);
    dispatch2(setAuthStatus(authenticationStatus));
  };
  if (headerProps.initializeLoginDone) {
    return;
  }
  const method = "initLoginCustomization";
  dispatch(setPscUrl([ReferenceData.PSC_PATH_DEFAULT_URL]));
  if (headerProps.cache) {
    dispatch(setCache("clear"));
  }
  dispatch(getPSCPath());
  setTimeout(function() {
    Promise.all([
      getAuthData(),
      getDefaultAcctsCustRetrievalList(headerProps.styleEnv),
      getAcctsCustomizationRetrievalList(headerProps.accu)
    ]).then(
      function(responses) {
        setAuthData(first(responses), dispatch);
        const defaultStyles = setAccuData(responses[1]);
        dispatch(setAccuCustomizations(defaultStyles));
        const accuStyles = setAccuData(responses[2]);
        dispatch(setAccuCustomizations(accuStyles));
        setFavicon();
        dispatch(setInitCustomizationsDone());
      },
      function(fault) {
        headerLog.error(method + " - Enter method.  header logic" + String(fault));
        dispatch(setInitCustomizationsDone());
      }
    ).catch(function(fault) {
      headerLog.error("Exception initLoginCustomizations at login pages {0}: ", fault);
      dispatch(setInitCustomizationsDone());
    });
  }, 1e3);
  headerLog.debug(method + " - login initCustomizations done. headerLogic");
  dispatch(setAccuLogoLoaded());
};
const useBoomerang = () => {
  useEffect(() => {
    if (window.BOOMR && window.BOOMR.version) {
      window.BOOMR.subscribe("before_beacon", function(performanceMetrics) {
        const prefix = `bmg_`;
        const { "et.e": etE, restiming, ...performanceMetricsTrimmed } = performanceMetrics;
        const performanceMetricsPrefixed = {};
        const initiator = performanceMetricsTrimmed["http.initiator"];
        const initSelection = !initiator ? "page_load" : initiator;
        const u = performanceMetricsTrimmed["u"];
        if (u) {
          const url2 = new URL(u);
          const hashSearchCombined = url2.hash.split("?");
          let search = "";
          if (!url2.search) {
            search = hashSearchCombined.length > 1 ? `?${hashSearchCombined[1]}` : "";
          } else {
            search = `${url2.search}${hashSearchCombined.length > 1 ? `??${hashSearchCombined[1]}` : ""}`;
          }
          performanceMetricsTrimmed["path_hash"] = url2.pathname + hashSearchCombined[0];
          performanceMetricsTrimmed["search"] = search;
        }
        for (const key in performanceMetricsTrimmed) {
          performanceMetricsPrefixed[`${prefix}${key}`] = performanceMetricsTrimmed[key];
        }
        dispatchAmplitude({
          eventType: AMPLITUDE_EVENTS.REPORT_PERFORMANCE_TELMETRY,
          selection: initSelection,
          payload: performanceMetricsPrefixed
        });
      });
      window.BOOMR.page_ready();
    }
  }, []);
};
const DEFAULT_LOCATION_STRING_MATCH = [];
const getArrayFromLocation = (locationStr) => {
  const regex = /[a-z|A-Z-]+|(\?[a-zA-Z]+=[a-zA-Z]+)/gm;
  const locationArrayMatch = locationStr.match(regex) || DEFAULT_LOCATION_STRING_MATCH;
  const transformed = locationArrayMatch.filter((text) => text !== "-" && !text.includes("?"));
  return transformed;
};
const searchTitle = (keyList, dictionary) => {
  const [firstValue, ...rest] = keyList;
  const result2 = dictionary[firstValue];
  if (typeof result2 === "string" || result2 === void 0 || rest.length === 0) {
    const { baseTitle } = result2 || {};
    return baseTitle || result2;
  } else {
    return searchTitle(rest, result2);
  }
};
function calculateNewTitle(translations, locationStr) {
  const { titleList, title: defaultTitle, titleSeparator = "|" } = translations;
  const arrayFromLocation = getArrayFromLocation(locationStr);
  if (isEmpty$1(titleList)) {
    return defaultTitle;
  }
  const newTitle = searchTitle(arrayFromLocation, titleList);
  if (typeof newTitle === "string") {
    if (newTitle === "") {
      return defaultTitle;
    }
    if (defaultTitle === "") {
      return newTitle;
    }
    return `${newTitle} ${titleSeparator} ${defaultTitle}`;
  }
  return defaultTitle;
}
const getTitle = (location2) => {
  var _a2;
  const locationStr = getLocation(location2);
  if (!((_a2 = globalThis == null ? void 0 : globalThis.integratedSharedData) == null ? void 0 : _a2.translations)) {
    return getTranslationsService().then((resp) => {
      if (resp) {
        return calculateNewTitle(resp, locationStr);
      }
    });
  } else {
    return Promise.resolve(
      calculateNewTitle(
        {
          title: globalThis.integratedSharedData.translations.get("title"),
          titleList: globalThis.integratedSharedData.translations.get("titleList")
        },
        locationStr
      )
    );
  }
};
const useDocumentTitle = () => {
  useEffect(() => {
    const handleHashChange = () => {
      getTitle(window.location).then((title) => {
        setPageTitle(title);
      });
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);
};
const useEventListenerSearchbox = () => {
  const [isSearchboxVisible, setIsSearchboxVisible] = useState(false);
  const [ariaSearchBoxMsg, setAriaSearchBoxMsg] = useState("");
  useEffect(() => {
    const handleSelectedOptionSearchbox = (event) => {
      setAriaSearchBoxMsg(event.detail.message);
    };
    document.addEventListener("optionSelectedSearchbox", handleSelectedOptionSearchbox);
    const handleCloseSearchbox = () => setIsSearchboxVisible(false);
    document.addEventListener("closeSearchbox", handleCloseSearchbox);
    return () => {
      document.removeEventListener("optionSelectedSearchbox", handleSelectedOptionSearchbox);
      document.removeEventListener("closeSearchbox", handleCloseSearchbox);
    };
  }, []);
  useEffect(() => {
    if (isSearchboxVisible) {
      const searchboxOpenEvent = new CustomEvent("openSearchbox");
      document.dispatchEvent(searchboxOpenEvent);
    }
  }, [isSearchboxVisible]);
  return { ariaSearchBoxMsg, isSearchboxVisible, setIsSearchboxVisible };
};
const isMobileDevice = function(userAgent = null) {
  const savedIsMobile = localStorage.isMobile;
  const ua = userAgent ? userAgent : window.navigator.userAgent;
  const isMobileTest = /Mobi|Android/i.test(ua);
  const isiPadRequestDesktopWebsite = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /Macintosh/.test(ua);
  const isMobile = isMobileTest && !isiPadRequestDesktopWebsite;
  if (savedIsMobile && isMobile) {
    return Boolean(savedIsMobile);
  } else {
    if (isMobile) {
      localStorage.setItem("isMobile", String(isMobile));
    }
    return Boolean(isMobile);
  }
};
const getEnvironment = (currentHost) => {
  const devEnvRegex = /(proj\d+)|(uat\d+)|(uat\.)|(cte\d+)|(cdemo\d+)|(aws\.gwl\.com)|(^uat)|(qa)|(localhost)|(evaluate\d+)/i;
  return devEnvRegex.test(currentHost);
};
const getSecondLevelDomain = () => {
  const islocalhost = () => {
    return window.location.hostname === "localhost";
  };
  if (islocalhost()) {
    return "retirementpartner.com";
  } else {
    const currentDomain = document.location.hostname;
    let secondLevelDomain = currentDomain.split(".").slice(-2).join(".");
    if (secondLevelDomain === "gwl.com") {
      secondLevelDomain = "retirementpartner.com";
    } else if (secondLevelDomain === "empower.com") {
      secondLevelDomain = "empower-retirement.com";
    }
    return secondLevelDomain;
  }
};
const { isEmptyObject, isUndefined } = ObjectUtil;
const useOneTrustBannerScript = (accuCustomizations) => {
  const styleEnv = useSelector((state) => state.header.styleEnv);
  const checkParamsRef = useRef(false);
  const mobileDevice = isMobileDevice();
  useEffect(() => {
    if (!mobileDevice && !isEmptyObject(accuCustomizations) && !isEmptyObject(accuCustomizations.oneTrustToken)) {
      if (accuCustomizations.showOneTrustOptOut) {
        const consent = document.createElement("script");
        const optout = document.createElement("script");
        const secondLevelDomain = getSecondLevelDomain();
        const currentHost = window.location.hostname;
        const useTestToken = getEnvironment(currentHost);
        const testOrProd = useTestToken ? "test" : "production";
        consent.type = "text/javascript";
        consent.charset = "UTF-8";
        optout.type = "text/javascript";
        optout.text = "function OptanonWrapper() {}";
        const head = document.querySelector("head");
        if (checkParamsRef.current) return;
        checkParamsRef.current = true;
        if (!isUndefined(accuCustomizations.oneTrustToken[secondLevelDomain])) {
          const tokenToUse = useTestToken ? accuCustomizations.oneTrustToken[secondLevelDomain]["test"] : accuCustomizations.oneTrustToken[secondLevelDomain]["prod"];
          consent.setAttribute("data-domain-script", tokenToUse);
          const instAccus = accuCustomizations.instAccus;
          const accuOrEmpower = instAccus.includes(accu) ? accu : "Empower";
          consent.src = `${styleEnv}customizations/${accuOrEmpower}/scripts/vendors/oneTrust/${secondLevelDomain}/oneTrust_${testOrProd}/consent/${tokenToUse}/otSDKStub.js`;
          head.insertBefore(optout, head.firstChild);
          head.insertBefore(consent, head.firstChild);
        } else {
          console.log("One trust token does not exist for this domain");
        }
      }
    }
  }, [accuCustomizations, styleEnv, mobileDevice]);
};
const OPTIMIZELY_SRC = "https://cdn.optimizely.com/js/26343461333.js";
const appendScript$1 = () => {
  const optimizelyScriptEl = document.querySelector(`script[src="${OPTIMIZELY_SRC}"]`);
  if (!optimizelyScriptEl) {
    const head = document.querySelector("head");
    const script = document.createElement("script");
    script.src = OPTIMIZELY_SRC;
    script.type = "text/javascript";
    script.async = true;
    head.appendChild(script);
  }
};
const useOptimizelyScript = (showNonAuthHeader, txnAccess = {}, accuCustomization2 = {}) => {
  useEffect(() => {
    const { experimentsEnabled } = txnAccess;
    const { addOptimizelyScript } = accuCustomization2;
    const addPreLogin = showNonAuthHeader && addOptimizelyScript;
    const addPostLogin = !showNonAuthHeader && experimentsEnabled;
    if (addPreLogin || addPostLogin) {
      appendScript$1();
    }
  }, [
    showNonAuthHeader,
    accuCustomization2.addOptimizelyScript,
    txnAccess.experimentsEnabled,
    txnAccess,
    accuCustomization2
  ]);
};
const envDisplayName = getEnvironmentDisplayName(window.location.hostname);
const addTestPath = envDisplayName !== "Production";
const WALK_ME_SRC = `https://cdn.walkme.com/users/c39541e892a643ec8f634a77c5b5f2c0/${addTestPath ? "test/" : ""}walkme_c39541e892a643ec8f634a77c5b5f2c0_https.js`;
const appendScript = () => {
  const walkMeScriptEl = document.querySelector(`script[src="${WALK_ME_SRC}"]`);
  if (!walkMeScriptEl) {
    window._walkmeConfig = { smartLoad: true };
    const head = document.querySelector("head");
    const script = document.createElement("script");
    script.src = WALK_ME_SRC;
    script.type = "text/javascript";
    script.async = true;
    head.appendChild(script);
  }
};
const useWalkMeScript = (showNonAuthHeader) => {
  useEffect(() => {
    const isPostLogin = !showNonAuthHeader;
    if (isPostLogin) {
      appendScript();
    }
  }, [showNonAuthHeader]);
};
const getEligibilitySettings = () => {
  const getEligibilitySettingsResult = (response) => {
    if (response && response.data) {
      return response.data;
    }
  };
  const liveUrl = "" + ReferenceData.ELIGIBILITY_URL;
  const mock = window.location.origin + window.location.pathname + "data/get-integrated-eligibility.json";
  const updatedUrl = localMocksTrue ? mock : liveUrl;
  const url2 = updatedUrl;
  return executeGet(url2, "getEligibilitySettingsFault").then(getEligibilitySettingsResult).catch((e) => {
    LogService$1.getLogger().error("Error - getEligibilitySettings failed", e);
    return e;
  });
};
const isAccountOpenFlow = () => {
  return window.location.hash === "#/open-account" || window.location.hash === "#/open-account-ps";
};
const isOtsFlow = () => {
  return globalThis.integratedEligibility.isRetail && !globalThis.integratedEligibility.hasRetailAccount;
};
const showFeatureNotAvailableModal = () => {
  return isOtsFlow() && !isAccountOpenFlow();
};
const checkIsAccountOpenFlow = (continueNav, dispatch) => {
  if (isAccountOpenFlow()) {
    dispatch(
      setShowOpenAccountWarning({
        show: true,
        isOts: isOtsFlow(),
        redirect: continueNav
      })
    );
  } else {
    continueNav();
  }
};
const featureNotAvailableModal = (dispatch) => {
  dispatch(
    setShowErrorModal({
      show: true,
      message: {
        body: ReferenceData.errorModal.FEATURE_NOT_AVAILABLE,
        showContinueButton: true
      }
    })
  );
};
const getActivity = () => {
  const url2 = "" + ReferenceData.ACTIVITY_URL;
  return axios({
    method: "get",
    url: url2,
    timeout: 5e3,
    responseType: "text"
  });
};
const pingKeepAlive = () => {
  const url2 = "" + ReferenceData.KEEP_ALIVE_URL;
  return axios.get(url2);
};
let pageIdle = false;
const idleLogic = (setShowModal, start, reset, setKeepAliveInterval) => {
  pingKeepAlive().then((response) => {
    let isPartialAuth = response.data.partialAuth;
    if (window.location.href.indexOf("login") !== -1) {
      isPartialAuth = false;
    }
    getActivity().then((res) => {
      const { isAuthenticated, isIdle } = JSON.parse(res.data);
      if (isAuthenticated && isIdle || isPartialAuth && isIdle) {
        start();
        setShowModal(true);
        pageIdle = true;
        setKeepAliveInterval(true);
      } else {
        reset();
      }
    });
  });
};
const notIdleLogic = (setShowModal, reset, setKeepAliveInterval) => {
  if (pageIdle) {
    pingKeepAlive();
    setKeepAliveInterval(false);
    setShowModal(false);
    reset();
    pageIdle = false;
  }
};
try {
  if (new Worker()) {
    () => import("./HackTimer-CVoNLBs4.js");
  }
} catch (e) {
}
const TOTAL_SECONDS = 240;
const IDLE_TIMER = 4 * 60 * 1e3;
const PING_INTERVAL = 2 * 60 * 1e3;
const KeepAliveView = ({ showKeepAliveWarn, setShowKeepAliveWarn, translations }) => {
  var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
  const pingKeepAliveIntervalRef = useRef(null);
  const dispatch = useDispatch();
  const handleTimerFinish = () => {
    var _a3, _b3;
    if (counter === 0 && isIdle()) {
      setKeepAliveInterval(true);
      dispatch(logout());
      setShowKeepAliveWarn(false);
      document.title = ((_b3 = (_a3 = translations == null ? void 0 : translations.keepAlive) == null ? void 0 : _a3.title) == null ? void 0 : _b3.timedOut) ?? "";
    }
  };
  const { counter, seconds, minutes, pause, resume, reset } = useTimer(
    TOTAL_SECONDS,
    handleTimerFinish
  );
  const authenticationStatus = useSelector((state) => state.header.authenticationStatus);
  const modalTitle = ((_b2 = (_a2 = translations == null ? void 0 : translations.keepAlive) == null ? void 0 : _a2.modal) == null ? void 0 : _b2.modalTitle) || "";
  const modalBodyText = ((_d2 = (_c2 = translations == null ? void 0 : translations.keepAlive) == null ? void 0 : _c2.modal) == null ? void 0 : _d2.modalBody) || "";
  const modalDismissText = ((_f2 = (_e2 = translations == null ? void 0 : translations.keepAlive) == null ? void 0 : _e2.modal) == null ? void 0 : _f2.modalDismiss) || "";
  const timeoutWarning = ((_h2 = (_g2 = translations == null ? void 0 : translations.keepAlive) == null ? void 0 : _g2.title) == null ? void 0 : _h2.timeoutWarning) || "";
  const setKeepAliveInterval = useCallback(
    (remove) => {
      if (remove) {
        window.clearInterval(pingKeepAliveIntervalRef.current);
      } else {
        pingKeepAliveIntervalRef.current = window.setInterval(pingKeepAlive, PING_INTERVAL);
      }
    },
    [pingKeepAliveIntervalRef]
  );
  const callIdleLogic = () => idleLogic(
    setShowKeepAliveWarn,
    resume,
    resetTimer,
    setKeepAliveInterval,
    authenticationStatus.partialAuth
  );
  const callNotIdleLogic = () => notIdleLogic(setShowKeepAliveWarn, reset, setKeepAliveInterval);
  const { isIdle, reset: resetTimer } = useIdleTimer({
    timeout: IDLE_TIMER,
    onIdle: callIdleLogic,
    onActive: callNotIdleLogic,
    debounce: 500,
    crossTab: {
      type: "localStorage",
      channelName: "idle-timer",
      fallbackInterval: 2e3,
      responseTime: 100,
      emitOnAllTabs: false
    },
    events: [
      "mousemove",
      "keydown",
      "wheel",
      "DOMMouseScroll",
      "mousewheel",
      "mousedown",
      "touchstart",
      "touchmove",
      "MSPointerDown",
      "MSPointerMove"
    ]
  });
  const handleDismiss = () => {
    setShowKeepAliveWarn(false);
  };
  useEffect(() => {
    let ignore = false;
    if (!ignore) {
      setKeepAliveInterval(false);
    }
    return () => {
      ignore = true;
      setKeepAliveInterval(true);
    };
  }, [setKeepAliveInterval]);
  useEffect(() => {
    if (minutes && !isIdle()) {
      pause();
    }
  }, [isIdle, minutes, pause]);
  useEffect(() => {
    if (isIdle()) {
      document.title = StringUtil$1.supplant(timeoutWarning, { minutes, seconds });
    } else {
      getTitle(window.location).then((title) => {
        if (document.title !== title) {
          setPageTitle(title);
        }
      });
    }
  }, [counter, isIdle, minutes, seconds, timeoutWarning]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { dialogClassName: "keep-alive-modal", show: showKeepAliveWarn, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Header, { className: "modal-header", children: /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { className: "modal-title", children: modalTitle }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal.Body, { className: "modal-body", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
        "You only have",
        Number(minutes) ? /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          ` ${Number(minutes)}`,
          " minutes and"
        ] }) : null,
        ` ${Number(seconds)} `,
        " seconds until you are automatically logged out."
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: modalBodyText })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Footer, { className: "modal-footer", children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "btn btn-link", onClick: () => handleDismiss(), children: modalDismissText }) })
  ] });
};
KeepAliveView.propTypes = {
  translations: PropTypes.object,
  showKeepAliveWarn: PropTypes.bool.isRequired,
  setShowKeepAliveWarn: PropTypes.func.isRequired
};
const ContextSwitchBlockedModal = () => {
  var _a2, _b2;
  const showModal = useSelector((state) => state.header.showContextSwitchBlockedModal);
  const translations = useSelector((state) => state.header.translations);
  const dispatch = useDispatch();
  const closeModal = () => {
    dispatch(setShowContextSwitchBlockedModal(false));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { dialogClassName: "context-switch-blocked-modal", show: showModal, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Body, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: (_a2 = translations == null ? void 0 : translations.contextSwitchBlockedModal) == null ? void 0 : _a2.message }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Footer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        className: "btn btn-primary pull-right",
        onClick: closeModal,
        onKeyDown: (e) => handleKeyboardDownEvent({
          event: e,
          keys: keyboardInteractions.button,
          output: closeModal
        }),
        children: (_b2 = translations == null ? void 0 : translations.contextSwitchBlockedModal) == null ? void 0 : _b2.closeButton
      }
    ) })
  ] });
};
const ErrorModal = () => {
  const dispatch = useDispatch();
  const errorModal = useSelector((state) => state.header.errorModal);
  const closeModal = () => {
    dispatch(
      setShowErrorModal({
        show: false
      })
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { dialogClassName: "error-modal", show: errorModal.show, children: [
    !!errorModal.message.header && /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Header, { className: "contained-form-header margin-top-default", children: /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: errorModal.message.header }) }),
    !errorModal.message.showContinueButton && /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Body, { className: "inner-container with-padding", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: errorModal.message.body }) }),
    errorModal.message.showContinueButton && /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Body, { className: "inner-container with-padding", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: errorModal.message.body }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal.Footer, { children: [
      errorModal.footer.canShow && !errorModal.message.showContinueButton && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "errorCode text-muted", style: { paddingTop: "6px" }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Code" }),
        ": ",
        errorModal.footer.code
      ] }),
      !errorModal.message.showContinueButton && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "btn btn-link", onClick: closeModal, children: "Dismiss" }),
      errorModal.message.showContinueButton && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "btn btn-primary", onClick: closeModal, children: "Continue" })
    ] })
  ] });
};
const AdvisoryServicesReturn = ({ showReturnModal }) => {
  const [changeStatus, setChangeStatus] = useState("");
  const handleOnChange = (e) => {
    const value = e.target.value;
    setChangeStatus(value);
  };
  const submitChanges = () => {
    switch (changeStatus) {
      case "noChanges":
        break;
      case "enrolledInManagedAcct":
        break;
      case "appliedRecommendations":
        break;
      default:
        showReturnModal(false);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { dialogClassName: "advisory-services-return", show: showReturnModal, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Header, { className: "modal-header", children: /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { className: "modal-title", children: "What actions did you take within Advisory Services?" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { className: "with-padding", name: "changeForm", noValidate: true, onSubmit: submitChanges, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Body, { className: "modal-body", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "panel-group", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel panel-default", children: /* @__PURE__ */ jsxRuntimeExports.jsx("header", { className: "panel-heading form-group", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "radio-inline panel-title", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              type: "radio",
              onChange: handleOnChange,
              value: "noChanges"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "I did not perform a transaction." })
        ] }) }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "panel panel-default", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("header", { className: "panel-heading form-group", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "radio-inline panel-title", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "input",
              {
                type: "radio",
                onChange: handleOnChange,
                value: "appliedRecommendations"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "I implemented Online Advice recommendations." })
          ] }) }),
          changeStatus === "appliedRecommendations" && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel-body panel-collapse", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel-collapse-content", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Your Online Advice transactions will reflect as pending until implemented." }) }) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "panel panel-default", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("header", { className: "panel-heading form-group", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "radio-inline panel-title", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "input",
              {
                type: "radio",
                onChange: handleOnChange,
                value: "enrolledInManagedAcct"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "I enrolled in Professional Management program." })
          ] }) }),
          changeStatus === "enrolledInManagedAcct" && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel-body panel-collapse", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel-collapse-content", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Your request to enroll in Professional Management program will be processed and your enrollment status will be reflected as soon as administratively possible." }) }) })
        ] })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Footer, { className: "modal-footer", children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "btn btn-primary", type: "submit", children: "Close and continue" }) })
    ] })
  ] });
};
AdvisoryServicesReturn.propTypes = {
  showReturnModal: PropTypes.bool.isRequired
};
const DisclaimerEvents = {
  GUIDANCE: "DisclaimerEvent.guidance_link_clicked_event"
};
const AdvisoryServicesDisclaimer = ({ closeMobileMenu, accountMenuActive }) => {
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(true);
  const [showReturnModal, setShowReturnModal] = useState(true);
  const account2 = useSelector((state) => state.account);
  const dispatch = useDispatch();
  const buttonClass = "pull-left";
  const dismiss = () => {
    if (isModal) {
      dispatch(setActiveMenuModal(null));
      setShowDisclaimerModal(false);
      if (accountMenuActive) {
        closeMobileMenu();
      }
    } else {
      window.history.back();
    }
  };
  const handleGuidanceClick = () => {
    dispatchEventBus(DisclaimerEvents.GUIDANCE, void 0);
    dispatchAmplitude({
      eventType: AMPLITUDE_EVENTS.SELECT_LINK,
      selection: DisclaimerEvents.GUIDANCE
    });
    navigateFE(account2.activeGroupAccount).then(() => {
      dispatch(setActiveMenuModal(null));
      setShowDisclaimerModal(false);
      if ($scope.showReturnPrompt) {
        setShowDisclaimerModal(false);
        setShowReturnModal(true);
      }
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { dialogClassName: "advisory-services-disclaimer", show: showDisclaimerModal, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal.Body, { className: "modal-body margin-top-100", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { className: "modal-title", children: "You are now accessing Advisory Services" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "By clicking on the Continue button below, you will be redirected from the Empower website to access the advisory services offered by Advised Assets Group, LLC (AAG), powered by Financial Engines Advisors, L.L.C., each a federally registered investment adviser. AAG is a wholly owned subsidiary of Great-West Life & Annuity Insurance Company and an affiliate of Great-West Life & Annuity Insurance Company of New York." })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal.Footer, { className: "modal-footer", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: `btn btn-default ${buttonClass}`, onClick: dismiss, children: "Dismiss" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "btn btn-primary pull-right", onClick: handleGuidanceClick, children: "Continue" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hide", children: /* @__PURE__ */ jsxRuntimeExports.jsx("form", { id: "SAMLFORM", method: "post", target: "_blank", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "textarea",
          {
            type: "hidden",
            id: "SAMLResponse",
            name: "SAMLResponse"
          }
        ) }) })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AdvisoryServicesReturn, { showReturnModal: setShowReturnModal })
  ] });
};
const clearIbbotsonCache = (groupId) => {
  const url2 = "" + StringUtil$1.supplant(ReferenceData.CLEAR_IBBOTSON_URL, {
    groupId
  });
  return executeGet(url2, "clearIbbotsonFault");
};
const clearIbbotsonMiddlware = (setShowModal) => {
  return (dispatch, getState) => {
    const state = getState();
    const groupId = state.account.groupId;
    clearIbbotsonCache(groupId).then(() => {
      dispatch(setActiveMenuModal(null));
      setShowModal(false);
      window.location.reload();
    });
  };
};
const AdvisoryServicesIbbotson = () => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const accountDetails = useSelector((state) => state.account.accountDetails);
  const nextGenAdvisoryServicesEnabled = useSelector(
    (state) => state.advice.nextGenAdvisoryServicesEnabled
  );
  const managedAccountsOptions = useSelector((state) => state.advice.managedAccountsOptions);
  const submitChanges = (event) => {
    event.preventDefault();
    dispatch(clearIbbotsonMiddlware(setShowModal));
  };
  useEffect(() => {
    if (nextGenAdvisoryServicesEnabled && managedAccountsOptions.enrolledInFullManagedAccounts) {
      sessionStorage.setItem("gId", accountDetails.groupId);
      sessionStorage.setItem("indId", accountDetails.individualId);
      window.location.href = "/participant/home/#/max-dashboard";
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { dialogClassName: "advisory-services-ibbotson", show: showModal, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { className: "with-padding", name: "changeForm", noValidate: true, onSubmit: submitChanges, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Body, { className: "modal-body", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Click Refresh to update your information with the enrollment and strategy changes you made in Advisory Services." }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Footer, { className: "modal-footer", children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "btn btn-primary", type: "submit", children: "Refresh" }) })
  ] }) });
};
const HardshipWithdrawalRequest = ({ url: url2, closeMobileMenu, accountMenuActive }) => {
  const [showModal, setShowModal] = useState(true);
  const shared2 = useSelector((state) => state.shared);
  let continueText = useSelector(
    (state) => state.shared.translations ? state.shared.translations.header.saveChanges.continue : ""
  );
  const dispatch = useDispatch();
  const closeModal = () => {
    dispatch(setActiveMenuModal(null));
    setShowModal(false);
    if (accountMenuActive) {
      closeMobileMenu();
    }
    window.location.href = url2;
  };
  useEffect(() => {
    if (shared2.translations && shared2.translations.header) {
      continueText = shared2.translations.header.saveChanges.continue;
    }
  }, [shared2.translations]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { dialogClassName: "hardship-widthdrawal", show: showModal, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal.Body, { className: "modal-body margin-top-100", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Please note, you may contact a service representative to request hardship paperwork, which identifies the plan and/or IRS requirements, including supporting documentation, applicable to obtain a hardship withdrawal." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "If you decide to proceed, this process only initiates your request for a hardship withdrawal. Your initiation of a hardship withdrawal request does not confirm your eligibility or the amount available." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Once your request is submitted you will be contacted by a service representative to determine eligibility, review reasons for a hardship withdrawal and be provided with an explanation of the supporting documentation that is required to proceed with your request. You will be required to sign and return the applicable paperwork and supporting documentation in good order before your request will be submitted for processing." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "The estimated hardship withdrawal amount available is based on a variety of factors, including price fluctuation and supporting documentation approval. As a result, the amount you receive may be different from the estimated amount." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Footer, { className: "modal-footer", children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: closeModal, className: "btn btn-primary btn-primary pull-right", children: continueText }) })
  ] });
};
const MenuItemModal = ({ activeModal }) => {
  const dispatch = useDispatch();
  const accountMenuActive = useSelector((state) => state.navMenu.accountMenuActive);
  const closeMobileMenu = () => {
    dispatch(setAccountMenuActive(false));
    dispatch(setMobileMenuActiveSetting(false));
    dispatch(inactivate());
  };
  if (activeModal) {
    switch (activeModal.reactView) {
      case "advisoryServicesDisclaimer":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          AdvisoryServicesDisclaimer,
          {
            closeMobileMenu,
            accountMenuActive
          }
        );
      case "advisoryServicesIbbotson":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          AdvisoryServicesIbbotson,
          {
            closeMobileMenu,
            accountMenuActive
          }
        );
      case "hardshipWithdrawalRequest":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          HardshipWithdrawalRequest,
          {
            url: activeModal.url,
            closeMobileMenu,
            accountMenuActive
          }
        );
      default:
        return null;
    }
  }
  return null;
};
const OpenAccountWarningModal = () => {
  var _a2, _b2, _c2, _d2, _e2, _f2;
  const header2 = selectTranslations("header");
  const openAccountWarning = useSelector((state) => state.header.openAccountWarning);
  const dispatch = useDispatch();
  const handleClose = useCallback(
    (e) => {
      if (e) {
        const label = e.target.textContent.toUpperCase();
        dispatch(dispatchEventBus(EventBusEvents.ACCOUNT_OPEN_MODAL[`${label}_CLICK`]));
      }
      dispatch(
        setShowOpenAccountWarning({
          ...openAccountWarning,
          show: false
        })
      );
    },
    [dispatch, openAccountWarning]
  );
  useEffect(() => {
    if (openAccountWarning.show) {
      window.addEventListener("popstate", () => {
        handleClose();
      });
    }
  }, [handleClose, openAccountWarning]);
  const handleLeave = () => {
    dispatch(dispatchEventBus(EventBusEvents.ACCOUNT_OPEN_MODAL.LEAVE_CLICK));
    if (openAccountWarning.isOts) {
      dispatch(logout());
    } else {
      handleClose();
      openAccountWarning.redirect();
    }
  };
  const handleBackdropClick = () => {
    dispatch(dispatchEventBus(EventBusEvents.ACCOUNT_OPEN_MODAL.BACKDROP_CLICK));
    handleClose();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Modal,
    {
      backdropClassName: "open-account-warning__backdrop",
      onHide: handleBackdropClick,
      keyboard: false,
      dialogClassName: "open-account-warning",
      show: openAccountWarning.show,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal.Header, { className: "open-account-warning__header", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: (_a2 = header2 == null ? void 0 : header2.openAccountWarningModal) == null ? void 0 : _a2.heading }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              type: "button",
              className: "pc-modal__close-button btn-close close",
              onClick: handleClose,
              children: "x"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Body, { className: "open-account-warning__body", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: (_b2 = header2 == null ? void 0 : header2.openAccountWarningModal) == null ? void 0 : _b2.body }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal.Footer, { className: "open-account-warning__footer", children: [
          !openAccountWarning.isOts && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "pc-btn", onClick: handleLeave, children: (_d2 = (_c2 = header2 == null ? void 0 : header2.openAccountWarningModal) == null ? void 0 : _c2.footer) == null ? void 0 : _d2.leave }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "pc-btn pc-btn--primary", onClick: handleClose, children: (_f2 = (_e2 = header2 == null ? void 0 : header2.openAccountWarningModal) == null ? void 0 : _e2.footer) == null ? void 0 : _f2.stay })
        ] })
      ]
    }
  );
};
const SaveChangesModal = () => {
  const dispatch = useDispatch();
  const showSaveChanges = useSelector((state) => state.navMenu.openSaveChanges);
  const isEnroll = useSelector((state) => state.navMenu.isEnroll);
  const isEnrollmentPage = useSelector((state) => state.navMenu.isEnrollmentPage);
  const nextVal = useSelector((state) => state.navMenu.nextVal);
  const header2 = useSelector((state) => state.header);
  const translations = useSelector((state) => state.header.translations);
  const enrollTitle = translations ? translations.saveChanges.headline : "";
  const enrollMessage = translations ? translations.saveChanges.description : "";
  const genericTitle = translations ? translations.genericModal.headline : "";
  const genericMessage = translations ? translations.genericModal.description : "";
  const cancelLabel = translations ? translations.saveChanges.cancel : "Cancel";
  const continueLabel = translations ? translations.saveChanges.continue : "Continue";
  const account2 = useSelector((state) => state.account);
  const loginAppURL = ReferenceData.LOGIN_APP_URL;
  const getTitle2 = () => {
    return isEnrollmentPage ? enrollTitle : genericTitle;
  };
  const getMessage = () => {
    return isEnrollmentPage ? enrollMessage : genericMessage;
  };
  const onCancelClick = () => {
    dispatch(setOpenSaveChanges(false));
  };
  const notificationContinue = () => {
    dispatch(setOnViewAllPrevent(false));
  };
  const onContinueClick = (e) => {
    if (nextVal === "LOGOUT") {
      dispatch(setIsIncompleteModal(true));
      dispatch(logout());
    } else if (nextVal === "PROFILE") {
      dispatch(setIsIncompleteModal(true));
      window.location.href = loginAppURL + "/#/profile?accu=" + header2.accu;
    } else if (nextVal === "SWITCH_PLAN") {
      dispatch(setIsIncompleteModal(true));
      dispatch(continueSwitchPlan(account2.selectedAccount));
    } else if (nextVal === "ACCOUNT") {
      dispatch(setIsIncompleteModal(true));
      dispatch(activate(e));
    } else if (nextVal === "CHANGEACCOUNT") {
      dispatch(setIsIncompleteModal(true));
    } else if (nextVal === "NOTIFICATION") {
      dispatch(setIsIncompleteModal(true));
      notificationContinue();
    } else if (nextVal != "" && nextVal != void 0) {
      window.location.href = nextVal;
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { dialogClassName: "save-changes-modal", show: showSaveChanges, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal.Header, { className: "modal-header auto-increase", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modal-title", children: getTitle2() }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("hr", { className: "hr-auto-increase" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal.Body, { className: "modal-body auto-increase", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-sm-12", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: getMessage() }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal.Footer, { className: "modal-footer auto-increase", children: [
      isEnroll && /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          type: "button",
          className: "btn btn-default pull-left",
          onClick: onCancelClick,
          children: cancelLabel
        }
      ),
      !isEnroll && /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: "cancel-link", onClick: onCancelClick, children: cancelLabel }),
      !isEnroll && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "btn btn-primary", onClick: onContinueClick, children: continueLabel })
    ] })
  ] });
};
const { isUndefinedOrNull: isUndefinedOrNull$3 } = ObjectUtil;
const deepLinkReAuth = function(url2) {
  return (dispatch, getState) => {
    const state = getState();
    const logoutOrigin = window.location.origin;
    let deepLinkUrlFormatted, deepLinkUrl, urlSplit, urlPop, urlSplitAgain, deepLinkPointer, logoutDest;
    const formatLink = (url3) => {
      deepLinkUrl = url3;
      urlSplit = deepLinkUrl.split("/");
      urlPop = urlSplit.pop();
      urlSplitAgain = urlPop.split("-");
      if (urlSplitAgain.length > 1) {
        deepLinkPointer = toCamelCase2(urlSplitAgain);
      } else {
        deepLinkPointer = urlPop;
      }
      return deepLinkPointer;
    };
    const toCamelCase2 = (linkArray) => {
      let result2 = "";
      for (let i = 0, len = linkArray.length; i < len; i++) {
        const currentStr = linkArray[i];
        let tempStr = currentStr.toLowerCase();
        if (i != 0) {
          tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1);
        }
        result2 += tempStr;
      }
      return result2;
    };
    if (!isUndefinedOrNull$3(url2)) {
      deepLinkUrlFormatted = "/participant/#/d/" + formatLink(url2) + "?loggingOut=true";
      logoutDest = logoutOrigin + deepLinkUrlFormatted;
      window.location.href = logoutDest;
    } else if (state.sso.activeDeepLinkItem !== null) {
      deepLinkUrlFormatted = "/participant/#/d/" + formatLink(state.sso.activeDeepLinkItem) + "?loggingOut=true";
      logoutDest = logoutOrigin + deepLinkUrlFormatted;
      window.location.href = logoutDest;
    }
  };
};
const InvestingSSOModal = () => {
  const dispatch = useDispatch();
  const header2 = useSelector((state) => state.header);
  const showSSOInvestingModal = useSelector((state) => state.sso.showSSOInvestingModal);
  const translations = useSelector((state) => state.shared.translations);
  const [cancelBtnLbl, setCancelBtnLbl] = useState("Cancel");
  const [continueBtnLbl, setContinueBtnLbl] = useState("Continue");
  const [contentModal, setContentModal] = useState(null);
  const activeDeeplink = useSelector((state) => state.sso.setActiveDeepLink);
  useEffect(() => {
    if (translations && translations.accountList && translations.investingSSOmodal) {
      setCancelBtnLbl(translations.accountList.totalRewards.cancel);
      setContinueBtnLbl(translations.accountList.totalRewards.continue);
      setContentModal(translations.investingSSOmodal);
    }
  }, [translations]);
  const dismiss = () => {
    dispatch(openOrCloseSSOInvestingModal(false));
  };
  const reAuth = () => {
    dispatch(deepLinkReAuth(activeDeeplink));
    dispatch(openOrCloseSSOInvestingModal(false));
  };
  return contentModal && translations && header2 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Modal,
    {
      dialogClassName: "liat-pc-modal",
      show: showSSOInvestingModal,
      size: "sm",
      onEscapeKeyDown: dismiss,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal.Header, { className: "pc-modal__header", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { className: "pc-modal__title", children: contentModal.title }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "button",
            {
              type: "button",
              className: "close pc-modal__close-button",
              onClick: dismiss,
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-hidden": "true", children: "✕" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: "Close" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Modal.Body, { className: "pc-modal__content", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: contentModal.content }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal.Footer, { className: "modal-footer-buttons", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              type: "button",
              id: "cancel",
              className: "btn btn-link btn-cancel",
              "data-dismiss": "modal",
              onClick: dismiss,
              children: cancelBtnLbl
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              type: "button",
              className: "btn btn-pcap-primary",
              "data-dismiss": "modal",
              onClick: reAuth,
              children: continueBtnLbl
            }
          )
        ] })
      ]
    }
  );
};
const { isUndefinedOrNull: isUndefinedOrNull$2, resolve } = ObjectUtil;
const handleClick = (e) => {
  if (isMobileBrowser()) {
    window.location.href = e.currentTarget.href;
    window.location.reload();
  }
};
const SubLink = ({ sublink }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-button", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "a",
    {
      className: "subnav-dropdown-link",
      href: sublink.href,
      target: sublink.target,
      onClick: handleClick,
      children: sublink.text
    }
  ) });
};
const Link = ({ link }) => {
  const { subnavLinks } = link;
  const LinkDropdown = ({ items }) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "menu-item dropdown", role: "menuitem", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          className: "menu-item-link dropdown-toggle",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
          target: link.target,
          children: [
            link.text,
            " ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "nav-link-caret caret" }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "mobile-toggle-indicator", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "em em-plus2" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "em em-minus" })
            ] })
          ]
        }
      ),
      items && /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "uib-dropdown-menu dropdown-menu dropdown-menu-login", role: "menu", children: items.map((sublink) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SubLink, { sublink }) }, `header-nav-sublink-${sublink.href}-${sublink.text}`)) })
    ] });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: subnavLinks ? /* @__PURE__ */ jsxRuntimeExports.jsx(LinkDropdown, { items: subnavLinks }) : (
    /*<!-- If no dropdown exists --> */
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-button", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        className: "menu-item-link",
        href: link.href,
        target: link.target,
        dangerouslySetInnerHTML: { __html: link.text }
      }
    ) }) })
  ) });
};
const TemplatePreLoginNavHeader = (props) => {
  const { headerNavLinks } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "prelogin header-secondary-nav navbar-default navbar", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        type: "button",
        className: "navbar-toggle",
        "data-toggle": "collapse",
        "data-target": ".navbar-collapse",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: "Toggle navigation" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-bar" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-bar" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-bar" })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "collapse navbar-collapse", children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "nav navbar-nav", children: headerNavLinks.map((link) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { link }) }, `header-nav-link-${link.text}`)) }) })
  ] });
};
const TemplatePreLoginHeader = (props) => {
  const { urlPscPath, translations } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "header-secondary-nav", children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "nav navbar-nav", children: /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("a", { className: "plan-sponsor", href: urlPscPath, id: "sponsor-site-link", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "fa fa-external-link" }),
    " ",
    resolve(translations, "header.planSponsorLinkContent")
  ] }) }) }) });
};
const getByTemplate = ({ templatePath }) => {
  if (templatePath.includes("templatePreLoginHeader")) {
    return TemplatePreLoginHeader;
  } else if (templatePath.includes("templatePreLoginNavHeader")) {
    return TemplatePreLoginNavHeader;
  } else {
    throw new Error(`The template "${templatePath}" is not valid`);
  }
};
const HeaderNoLogin = ({ accuCustomization: accuCustomization2, urls }) => {
  const [translations, setTranslations2] = useState(null);
  useEffect(() => {
    var _a2;
    if (!((_a2 = globalThis == null ? void 0 : globalThis.integratedSharedData) == null ? void 0 : _a2.translations)) {
      getTranslationsService().then(({ header: header2 }) => {
        setTranslations2({ header: header2 });
      });
    }
  }, []);
  const { preLoginHeaderTemplate } = accuCustomization2;
  if (isUndefinedOrNull$2(accuCustomization2) || isUndefinedOrNull$2(preLoginHeaderTemplate)) {
    return null;
  }
  const blockingMobileDevices = accuCustomization2.blockingMobileDevices || false;
  const HeaderNotLogged = getByTemplate({
    templatePath: preLoginHeaderTemplate,
    blockingMobileDevices
  });
  const { headerNavLinks } = accuCustomization2;
  const isOauthLogin = String(getCookie$1("isOauthLogin")) === "true";
  return !isOauthLogin && /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "site-tagline", children: accuCustomization2.preLoginLogoTagline }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      HeaderNotLogged,
      {
        ...{ urls, headerNavLinks, blockingMobileDevices },
        translations
      }
    )
  ] });
};
const LoginSiteHeader = ({ accuCustomization: accuCustomization2, accuLogoAltAttribute, urlPscPath }) => {
  const loginHref = String(getCookie$1("isOauthLogin")) === "true" ? "#/oauth/login" : "#/login";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "site-logo-wrapper", children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: loginHref, className: "remove-outline", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
        className: "site-logo",
        alt: accuLogoAltAttribute
      }
    ) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      HeaderNoLogin,
      {
        accuCustomization: accuCustomization2,
        urlPscPath
      }
    )
  ] });
};
var customParseFormat$1 = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    var e = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e2) {
      return (e2 = +e2) + (e2 > 68 ? 1900 : 2e3);
    };
    var f = function(e2) {
      return function(t2) {
        this[e2] = +t2;
      };
    }, h = [/[+-]\d\d:?(\d\d)?|Z/, function(e2) {
      (this.zone || (this.zone = {})).offset = function(e3) {
        if (!e3) return 0;
        if ("Z" === e3) return 0;
        var t2 = e3.match(/([+-]|\d\d)/g), n2 = 60 * t2[1] + (+t2[2] || 0);
        return 0 === n2 ? 0 : "+" === t2[0] ? -n2 : n2;
      }(e2);
    }], u = function(e2) {
      var t2 = s[e2];
      return t2 && (t2.indexOf ? t2 : t2.s.concat(t2.f));
    }, d = function(e2, t2) {
      var n2, r2 = s.meridiem;
      if (r2) {
        for (var i2 = 1; i2 <= 24; i2 += 1) if (e2.indexOf(r2(i2, 0, t2)) > -1) {
          n2 = i2 > 12;
          break;
        }
      } else n2 = e2 === (t2 ? "pm" : "PM");
      return n2;
    }, c = { A: [o, function(e2) {
      this.afternoon = d(e2, false);
    }], a: [o, function(e2) {
      this.afternoon = d(e2, true);
    }], Q: [n, function(e2) {
      this.month = 3 * (e2 - 1) + 1;
    }], S: [n, function(e2) {
      this.milliseconds = 100 * +e2;
    }], SS: [r, function(e2) {
      this.milliseconds = 10 * +e2;
    }], SSS: [/\d{3}/, function(e2) {
      this.milliseconds = +e2;
    }], s: [i, f("seconds")], ss: [i, f("seconds")], m: [i, f("minutes")], mm: [i, f("minutes")], H: [i, f("hours")], h: [i, f("hours")], HH: [i, f("hours")], hh: [i, f("hours")], D: [i, f("day")], DD: [r, f("day")], Do: [o, function(e2) {
      var t2 = s.ordinal, n2 = e2.match(/\d+/);
      if (this.day = n2[0], t2) for (var r2 = 1; r2 <= 31; r2 += 1) t2(r2).replace(/\[|\]/g, "") === e2 && (this.day = r2);
    }], w: [i, f("week")], ww: [r, f("week")], M: [i, f("month")], MM: [r, f("month")], MMM: [o, function(e2) {
      var t2 = u("months"), n2 = (u("monthsShort") || t2.map(function(e3) {
        return e3.slice(0, 3);
      })).indexOf(e2) + 1;
      if (n2 < 1) throw new Error();
      this.month = n2 % 12 || n2;
    }], MMMM: [o, function(e2) {
      var t2 = u("months").indexOf(e2) + 1;
      if (t2 < 1) throw new Error();
      this.month = t2 % 12 || t2;
    }], Y: [/[+-]?\d+/, f("year")], YY: [r, function(e2) {
      this.year = a(e2);
    }], YYYY: [/\d{4}/, f("year")], Z: h, ZZ: h };
    function l(n2) {
      var r2, i2;
      r2 = n2, i2 = s && s.formats;
      for (var o2 = (n2 = r2.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t2, n3, r3) {
        var o3 = r3 && r3.toUpperCase();
        return n3 || i2[r3] || e[r3] || i2[o3].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e2, t3, n4) {
          return t3 || n4.slice(1);
        });
      })).match(t), a2 = o2.length, f2 = 0; f2 < a2; f2 += 1) {
        var h2 = o2[f2], u2 = c[h2], d2 = u2 && u2[0], l2 = u2 && u2[1];
        o2[f2] = l2 ? { regex: d2, parser: l2 } : h2.replace(/^\[|\]$/g, "");
      }
      return function(e2) {
        for (var t2 = {}, n3 = 0, r3 = 0; n3 < a2; n3 += 1) {
          var i3 = o2[n3];
          if ("string" == typeof i3) r3 += i3.length;
          else {
            var s2 = i3.regex, f3 = i3.parser, h3 = e2.slice(r3), u3 = s2.exec(h3)[0];
            f3.call(t2, u3), e2 = e2.replace(u3, "");
          }
        }
        return function(e3) {
          var t3 = e3.afternoon;
          if (void 0 !== t3) {
            var n4 = e3.hours;
            t3 ? n4 < 12 && (e3.hours += 12) : 12 === n4 && (e3.hours = 0), delete e3.afternoon;
          }
        }(t2), t2;
      };
    }
    return function(e2, t2, n2) {
      n2.p.customParseFormat = true, e2 && e2.parseTwoDigitYear && (a = e2.parseTwoDigitYear);
      var r2 = t2.prototype, i2 = r2.parse;
      r2.parse = function(e3) {
        var t3 = e3.date, r3 = e3.utc, o2 = e3.args;
        this.$u = r3;
        var a2 = o2[1];
        if ("string" == typeof a2) {
          var f2 = true === o2[2], h2 = true === o2[3], u2 = f2 || h2, d2 = o2[2];
          h2 && (d2 = o2[2]), s = this.$locale(), !f2 && d2 && (s = n2.Ls[d2]), this.$d = function(e4, t4, n3, r4) {
            try {
              if (["x", "X"].indexOf(t4) > -1) return new Date(("X" === t4 ? 1e3 : 1) * e4);
              var i3 = l(t4)(e4), o3 = i3.year, s2 = i3.month, a3 = i3.day, f3 = i3.hours, h3 = i3.minutes, u3 = i3.seconds, d3 = i3.milliseconds, c3 = i3.zone, m2 = i3.week, M2 = /* @__PURE__ */ new Date(), Y = a3 || (o3 || s2 ? 1 : M2.getDate()), p = o3 || M2.getFullYear(), v = 0;
              o3 && !s2 || (v = s2 > 0 ? s2 - 1 : M2.getMonth());
              var D, w = f3 || 0, g = h3 || 0, y = u3 || 0, L = d3 || 0;
              return c3 ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c3.offset * 1e3)) : n3 ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m2 && (D = r4(D).week(m2).toDate()), D);
            } catch (e5) {
              return /* @__PURE__ */ new Date("");
            }
          }(t3, a2, r3, n2), this.init(), d2 && true !== d2 && (this.$L = this.locale(d2).$L), u2 && t3 != this.format(a2) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
        } else if (a2 instanceof Array) for (var c2 = a2.length, m = 1; m <= c2; m += 1) {
          o2[1] = a2[m - 1];
          var M = n2.apply(this, o2);
          if (M.isValid()) {
            this.$d = M.$d, this.$L = M.$L, this.init();
            break;
          }
          m === c2 && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else i2.call(this, e3);
      };
    };
  });
})(customParseFormat$1);
var customParseFormatExports = customParseFormat$1.exports;
const customParseFormat = /* @__PURE__ */ getDefaultExportFromCjs(customParseFormatExports);
var dayOfYear$1 = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    return function(e, t, n) {
      t.prototype.dayOfYear = function(e2) {
        var t2 = Math.round((n(this).startOf("day") - n(this).startOf("year")) / 864e5) + 1;
        return null == e2 ? t2 : this.add(e2 - t2, "day");
      };
    };
  });
})(dayOfYear$1);
var dayOfYearExports = dayOfYear$1.exports;
const dayOfYear = /* @__PURE__ */ getDefaultExportFromCjs(dayOfYearExports);
var duration$1 = { exports: {} };
(function(module, exports) {
  !function(t, s) {
    module.exports = s();
  }(commonjsGlobal, function() {
    var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, h = { years: u, months: d, days: r, hours: e, minutes: i, seconds: n, milliseconds: 1, weeks: 6048e5 }, c = function(t2) {
      return t2 instanceof g;
    }, f = function(t2, s2, n2) {
      return new g(t2, n2, s2.$l);
    }, m = function(t2) {
      return s.p(t2) + "s";
    }, l = function(t2) {
      return t2 < 0;
    }, $2 = function(t2) {
      return l(t2) ? Math.ceil(t2) : Math.floor(t2);
    }, y = function(t2) {
      return Math.abs(t2);
    }, v = function(t2, s2) {
      return t2 ? l(t2) ? { negative: true, format: "" + y(t2) + s2 } : { negative: false, format: "" + t2 + s2 } : { negative: false, format: "" };
    }, g = function() {
      function l2(t2, s2, n2) {
        var i2 = this;
        if (this.$d = {}, this.$l = n2, void 0 === t2 && (this.$ms = 0, this.parseFromMilliseconds()), s2) return f(t2 * h[m(s2)], this);
        if ("number" == typeof t2) return this.$ms = t2, this.parseFromMilliseconds(), this;
        if ("object" == typeof t2) return Object.keys(t2).forEach(function(s3) {
          i2.$d[m(s3)] = t2[s3];
        }), this.calMilliseconds(), this;
        if ("string" == typeof t2) {
          var e2 = t2.match(a);
          if (e2) {
            var r2 = e2.slice(2).map(function(t3) {
              return null != t3 ? Number(t3) : 0;
            });
            return this.$d.years = r2[0], this.$d.months = r2[1], this.$d.weeks = r2[2], this.$d.days = r2[3], this.$d.hours = r2[4], this.$d.minutes = r2[5], this.$d.seconds = r2[6], this.calMilliseconds(), this;
          }
        }
        return this;
      }
      var y2 = l2.prototype;
      return y2.calMilliseconds = function() {
        var t2 = this;
        this.$ms = Object.keys(this.$d).reduce(function(s2, n2) {
          return s2 + (t2.$d[n2] || 0) * h[n2];
        }, 0);
      }, y2.parseFromMilliseconds = function() {
        var t2 = this.$ms;
        this.$d.years = $2(t2 / u), t2 %= u, this.$d.months = $2(t2 / d), t2 %= d, this.$d.days = $2(t2 / r), t2 %= r, this.$d.hours = $2(t2 / e), t2 %= e, this.$d.minutes = $2(t2 / i), t2 %= i, this.$d.seconds = $2(t2 / n), t2 %= n, this.$d.milliseconds = t2;
      }, y2.toISOString = function() {
        var t2 = v(this.$d.years, "Y"), s2 = v(this.$d.months, "M"), n2 = +this.$d.days || 0;
        this.$d.weeks && (n2 += 7 * this.$d.weeks);
        var i2 = v(n2, "D"), e2 = v(this.$d.hours, "H"), r2 = v(this.$d.minutes, "M"), o2 = this.$d.seconds || 0;
        this.$d.milliseconds && (o2 += this.$d.milliseconds / 1e3, o2 = Math.round(1e3 * o2) / 1e3);
        var u2 = v(o2, "S"), d2 = t2.negative || s2.negative || i2.negative || e2.negative || r2.negative || u2.negative, a2 = e2.format || r2.format || u2.format ? "T" : "", h2 = (d2 ? "-" : "") + "P" + t2.format + s2.format + i2.format + a2 + e2.format + r2.format + u2.format;
        return "P" === h2 || "-P" === h2 ? "P0D" : h2;
      }, y2.toJSON = function() {
        return this.toISOString();
      }, y2.format = function(t2) {
        var n2 = t2 || "YYYY-MM-DDTHH:mm:ss", i2 = { Y: this.$d.years, YY: s.s(this.$d.years, 2, "0"), YYYY: s.s(this.$d.years, 4, "0"), M: this.$d.months, MM: s.s(this.$d.months, 2, "0"), D: this.$d.days, DD: s.s(this.$d.days, 2, "0"), H: this.$d.hours, HH: s.s(this.$d.hours, 2, "0"), m: this.$d.minutes, mm: s.s(this.$d.minutes, 2, "0"), s: this.$d.seconds, ss: s.s(this.$d.seconds, 2, "0"), SSS: s.s(this.$d.milliseconds, 3, "0") };
        return n2.replace(o, function(t3, s2) {
          return s2 || String(i2[t3]);
        });
      }, y2.as = function(t2) {
        return this.$ms / h[m(t2)];
      }, y2.get = function(t2) {
        var s2 = this.$ms, n2 = m(t2);
        return "milliseconds" === n2 ? s2 %= 1e3 : s2 = "weeks" === n2 ? $2(s2 / h[n2]) : this.$d[n2], s2 || 0;
      }, y2.add = function(t2, s2, n2) {
        var i2;
        return i2 = s2 ? t2 * h[m(s2)] : c(t2) ? t2.$ms : f(t2, this).$ms, f(this.$ms + i2 * (n2 ? -1 : 1), this);
      }, y2.subtract = function(t2, s2) {
        return this.add(t2, s2, true);
      }, y2.locale = function(t2) {
        var s2 = this.clone();
        return s2.$l = t2, s2;
      }, y2.clone = function() {
        return f(this.$ms, this);
      }, y2.humanize = function(s2) {
        return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s2);
      }, y2.valueOf = function() {
        return this.asMilliseconds();
      }, y2.milliseconds = function() {
        return this.get("milliseconds");
      }, y2.asMilliseconds = function() {
        return this.as("milliseconds");
      }, y2.seconds = function() {
        return this.get("seconds");
      }, y2.asSeconds = function() {
        return this.as("seconds");
      }, y2.minutes = function() {
        return this.get("minutes");
      }, y2.asMinutes = function() {
        return this.as("minutes");
      }, y2.hours = function() {
        return this.get("hours");
      }, y2.asHours = function() {
        return this.as("hours");
      }, y2.days = function() {
        return this.get("days");
      }, y2.asDays = function() {
        return this.as("days");
      }, y2.weeks = function() {
        return this.get("weeks");
      }, y2.asWeeks = function() {
        return this.as("weeks");
      }, y2.months = function() {
        return this.get("months");
      }, y2.asMonths = function() {
        return this.as("months");
      }, y2.years = function() {
        return this.get("years");
      }, y2.asYears = function() {
        return this.as("years");
      }, l2;
    }(), p = function(t2, s2, n2) {
      return t2.add(s2.years() * n2, "y").add(s2.months() * n2, "M").add(s2.days() * n2, "d").add(s2.hours() * n2, "h").add(s2.minutes() * n2, "m").add(s2.seconds() * n2, "s").add(s2.milliseconds() * n2, "ms");
    };
    return function(n2, i2, e2) {
      t = e2, s = e2().$utils(), e2.duration = function(t2, s2) {
        var n3 = e2.locale();
        return f(t2, { $l: n3 }, s2);
      }, e2.isDuration = c;
      var r2 = i2.prototype.add, o2 = i2.prototype.subtract;
      i2.prototype.add = function(t2, s2) {
        return c(t2) ? p(this, t2, 1) : r2.bind(this)(t2, s2);
      }, i2.prototype.subtract = function(t2, s2) {
        return c(t2) ? p(this, t2, -1) : o2.bind(this)(t2, s2);
      };
    };
  });
})(duration$1);
var durationExports = duration$1.exports;
const duration = /* @__PURE__ */ getDefaultExportFromCjs(durationExports);
var isLeapYear$1 = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    return function(e, t) {
      t.prototype.isLeapYear = function() {
        return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
      };
    };
  });
})(isLeapYear$1);
var isLeapYearExports = isLeapYear$1.exports;
const isLeapYear = /* @__PURE__ */ getDefaultExportFromCjs(isLeapYearExports);
var isoWeeksInYear$1 = { exports: {} };
(function(module, exports) {
  !function(e, n) {
    module.exports = n();
  }(commonjsGlobal, function() {
    return function(e, n) {
      n.prototype.isoWeeksInYear = function() {
        var e2 = this.isLeapYear(), n2 = this.endOf("y").day();
        return 4 === n2 || e2 && 5 === n2 ? 53 : 52;
      };
    };
  });
})(isoWeeksInYear$1);
var isoWeeksInYearExports = isoWeeksInYear$1.exports;
const isoWeeksInYear = /* @__PURE__ */ getDefaultExportFromCjs(isoWeeksInYearExports);
var localeData$1 = { exports: {} };
(function(module, exports) {
  !function(n, e) {
    module.exports = e();
  }(commonjsGlobal, function() {
    return function(n, e, t) {
      var r = e.prototype, o = function(n2) {
        return n2 && (n2.indexOf ? n2 : n2.s);
      }, u = function(n2, e2, t2, r2, u2) {
        var i2 = n2.name ? n2 : n2.$locale(), a2 = o(i2[e2]), s2 = o(i2[t2]), f = a2 || s2.map(function(n3) {
          return n3.slice(0, r2);
        });
        if (!u2) return f;
        var d = i2.weekStart;
        return f.map(function(n3, e3) {
          return f[(e3 + (d || 0)) % 7];
        });
      }, i = function() {
        return t.Ls[t.locale()];
      }, a = function(n2, e2) {
        return n2.formats[e2] || function(n3) {
          return n3.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(n4, e3, t2) {
            return e3 || t2.slice(1);
          });
        }(n2.formats[e2.toUpperCase()]);
      }, s = function() {
        var n2 = this;
        return { months: function(e2) {
          return e2 ? e2.format("MMMM") : u(n2, "months");
        }, monthsShort: function(e2) {
          return e2 ? e2.format("MMM") : u(n2, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return n2.$locale().weekStart || 0;
        }, weekdays: function(e2) {
          return e2 ? e2.format("dddd") : u(n2, "weekdays");
        }, weekdaysMin: function(e2) {
          return e2 ? e2.format("dd") : u(n2, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(e2) {
          return e2 ? e2.format("ddd") : u(n2, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(e2) {
          return a(n2.$locale(), e2);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      r.localeData = function() {
        return s.bind(this)();
      }, t.localeData = function() {
        var n2 = i();
        return { firstDayOfWeek: function() {
          return n2.weekStart || 0;
        }, weekdays: function() {
          return t.weekdays();
        }, weekdaysShort: function() {
          return t.weekdaysShort();
        }, weekdaysMin: function() {
          return t.weekdaysMin();
        }, months: function() {
          return t.months();
        }, monthsShort: function() {
          return t.monthsShort();
        }, longDateFormat: function(e2) {
          return a(n2, e2);
        }, meridiem: n2.meridiem, ordinal: n2.ordinal };
      }, t.months = function() {
        return u(i(), "months");
      }, t.monthsShort = function() {
        return u(i(), "monthsShort", "months", 3);
      }, t.weekdays = function(n2) {
        return u(i(), "weekdays", null, null, n2);
      }, t.weekdaysShort = function(n2) {
        return u(i(), "weekdaysShort", "weekdays", 3, n2);
      }, t.weekdaysMin = function(n2) {
        return u(i(), "weekdaysMin", "weekdays", 2, n2);
      };
    };
  });
})(localeData$1);
var localeDataExports = localeData$1.exports;
const localeData = /* @__PURE__ */ getDefaultExportFromCjs(localeDataExports);
var quarterOfYear$1 = { exports: {} };
(function(module, exports) {
  !function(t, n) {
    module.exports = n();
  }(commonjsGlobal, function() {
    var t = "month", n = "quarter";
    return function(e, i) {
      var r = i.prototype;
      r.quarter = function(t2) {
        return this.$utils().u(t2) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (t2 - 1));
      };
      var s = r.add;
      r.add = function(e2, i2) {
        return e2 = Number(e2), this.$utils().p(i2) === n ? this.add(3 * e2, t) : s.bind(this)(e2, i2);
      };
      var u = r.startOf;
      r.startOf = function(e2, i2) {
        var r2 = this.$utils(), s2 = !!r2.u(i2) || i2;
        if (r2.p(e2) === n) {
          var o = this.quarter() - 1;
          return s2 ? this.month(3 * o).startOf(t).startOf("day") : this.month(3 * o + 2).endOf(t).endOf("day");
        }
        return u.bind(this)(e2, i2);
      };
    };
  });
})(quarterOfYear$1);
var quarterOfYearExports = quarterOfYear$1.exports;
const quarterOfYear = /* @__PURE__ */ getDefaultExportFromCjs(quarterOfYearExports);
var relativeTime$1 = { exports: {} };
(function(module, exports) {
  !function(r, e) {
    module.exports = e();
  }(commonjsGlobal, function() {
    return function(r, e, t) {
      r = r || {};
      var n = e.prototype, o = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function i(r2, e2, t2, o2) {
        return n.fromToBase(r2, e2, t2, o2);
      }
      t.en.relativeTime = o, n.fromToBase = function(e2, n2, i2, d2, u) {
        for (var f, a, s, l = i2.$locale().relativeTime || o, h = r.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], m = h.length, c = 0; c < m; c += 1) {
          var y = h[c];
          y.d && (f = d2 ? t(e2).diff(i2, y.d, true) : i2.diff(e2, y.d, true));
          var p = (r.rounding || Math.round)(Math.abs(f));
          if (s = f > 0, p <= y.r || !y.r) {
            p <= 1 && c > 0 && (y = h[c - 1]);
            var v = l[y.l];
            u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n2, y.l, s);
            break;
          }
        }
        if (n2) return a;
        var M = s ? l.future : l.past;
        return "function" == typeof M ? M(a) : M.replace("%s", a);
      }, n.to = function(r2, e2) {
        return i(r2, e2, this, true);
      }, n.from = function(r2, e2) {
        return i(r2, e2, this);
      };
      var d = function(r2) {
        return r2.$u ? t.utc() : t();
      };
      n.toNow = function(r2) {
        return this.to(d(this), r2);
      }, n.fromNow = function(r2) {
        return this.from(d(this), r2);
      };
    };
  });
})(relativeTime$1);
var relativeTimeExports = relativeTime$1.exports;
const relativeTime = /* @__PURE__ */ getDefaultExportFromCjs(relativeTimeExports);
var timezone$1 = { exports: {} };
(function(module, exports) {
  !function(t, e) {
    module.exports = e();
  }(commonjsGlobal, function() {
    var t = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, e = {};
    return function(n, i, o) {
      var r, a = function(t2, n2, i2) {
        void 0 === i2 && (i2 = {});
        var o2 = new Date(t2), r2 = function(t3, n3) {
          void 0 === n3 && (n3 = {});
          var i3 = n3.timeZoneName || "short", o3 = t3 + "|" + i3, r3 = e[o3];
          return r3 || (r3 = new Intl.DateTimeFormat("en-US", { hour12: false, timeZone: t3, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: i3 }), e[o3] = r3), r3;
        }(n2, i2);
        return r2.formatToParts(o2);
      }, u = function(e2, n2) {
        for (var i2 = a(e2, n2), r2 = [], u2 = 0; u2 < i2.length; u2 += 1) {
          var f2 = i2[u2], s2 = f2.type, m = f2.value, c = t[s2];
          c >= 0 && (r2[c] = parseInt(m, 10));
        }
        var d = r2[3], l = 24 === d ? 0 : d, h = r2[0] + "-" + r2[1] + "-" + r2[2] + " " + l + ":" + r2[4] + ":" + r2[5] + ":000", v = +e2;
        return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
      }, f = i.prototype;
      f.tz = function(t2, e2) {
        void 0 === t2 && (t2 = r);
        var n2, i2 = this.utcOffset(), a2 = this.toDate(), u2 = a2.toLocaleString("en-US", { timeZone: t2 }), f2 = Math.round((a2 - new Date(u2)) / 1e3 / 60), s2 = 15 * -Math.round(a2.getTimezoneOffset() / 15) - f2;
        if (!Number(s2)) n2 = this.utcOffset(0, e2);
        else if (n2 = o(u2, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(s2, true), e2) {
          var m = n2.utcOffset();
          n2 = n2.add(i2 - m, "minute");
        }
        return n2.$x.$timezone = t2, n2;
      }, f.offsetName = function(t2) {
        var e2 = this.$x.$timezone || o.tz.guess(), n2 = a(this.valueOf(), e2, { timeZoneName: t2 }).find(function(t3) {
          return "timezonename" === t3.type.toLowerCase();
        });
        return n2 && n2.value;
      };
      var s = f.startOf;
      f.startOf = function(t2, e2) {
        if (!this.$x || !this.$x.$timezone) return s.call(this, t2, e2);
        var n2 = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return s.call(n2, t2, e2).tz(this.$x.$timezone, true);
      }, o.tz = function(t2, e2, n2) {
        var i2 = n2 && e2, a2 = n2 || e2 || r, f2 = u(+o(), a2);
        if ("string" != typeof t2) return o(t2).tz(a2);
        var s2 = function(t3, e3, n3) {
          var i3 = t3 - 60 * e3 * 1e3, o2 = u(i3, n3);
          if (e3 === o2) return [i3, e3];
          var r2 = u(i3 -= 60 * (o2 - e3) * 1e3, n3);
          return o2 === r2 ? [i3, o2] : [t3 - 60 * Math.min(o2, r2) * 1e3, Math.max(o2, r2)];
        }(o.utc(t2, i2).valueOf(), f2, a2), m = s2[0], c = s2[1], d = o(m).utcOffset(c);
        return d.$x.$timezone = a2, d;
      }, o.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, o.tz.setDefault = function(t2) {
        r = t2;
      };
    };
  });
})(timezone$1);
var timezoneExports = timezone$1.exports;
const timezone = /* @__PURE__ */ getDefaultExportFromCjs(timezoneExports);
var utc$1 = { exports: {} };
(function(module, exports) {
  !function(t, i) {
    module.exports = i();
  }(commonjsGlobal, function() {
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
      var u = f.prototype;
      n.utc = function(t2) {
        var i2 = { date: t2, utc: true, args: arguments };
        return new f(i2);
      }, u.utc = function(i2) {
        var e2 = n(this.toDate(), { locale: this.$L, utc: true });
        return i2 ? e2.add(this.utcOffset(), t) : e2;
      }, u.local = function() {
        return n(this.toDate(), { locale: this.$L, utc: false });
      };
      var o = u.parse;
      u.parse = function(t2) {
        t2.utc && (this.$u = true), this.$utils().u(t2.$offset) || (this.$offset = t2.$offset), o.call(this, t2);
      };
      var r = u.init;
      u.init = function() {
        if (this.$u) {
          var t2 = this.$d;
          this.$y = t2.getUTCFullYear(), this.$M = t2.getUTCMonth(), this.$D = t2.getUTCDate(), this.$W = t2.getUTCDay(), this.$H = t2.getUTCHours(), this.$m = t2.getUTCMinutes(), this.$s = t2.getUTCSeconds(), this.$ms = t2.getUTCMilliseconds();
        } else r.call(this);
      };
      var a = u.utcOffset;
      u.utcOffset = function(s2, f2) {
        var n2 = this.$utils().u;
        if (n2(s2)) return this.$u ? 0 : n2(this.$offset) ? a.call(this) : this.$offset;
        if ("string" == typeof s2 && (s2 = function(t2) {
          void 0 === t2 && (t2 = "");
          var s3 = t2.match(i);
          if (!s3) return null;
          var f3 = ("" + s3[0]).match(e) || ["-", 0, 0], n3 = f3[0], u3 = 60 * +f3[1] + +f3[2];
          return 0 === u3 ? 0 : "+" === n3 ? u3 : -u3;
        }(s2), null === s2)) return this;
        var u2 = Math.abs(s2) <= 16 ? 60 * s2 : s2, o2 = this;
        if (f2) return o2.$offset = u2, o2.$u = 0 === s2, o2;
        if (0 !== s2) {
          var r2 = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (o2 = this.local().add(u2 + r2, t)).$offset = u2, o2.$x.$localOffset = r2;
        } else o2 = this.utc();
        return o2;
      };
      var h = u.format;
      u.format = function(t2) {
        var i2 = t2 || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return h.call(this, i2);
      }, u.valueOf = function() {
        var t2 = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * t2;
      }, u.isUTC = function() {
        return !!this.$u;
      }, u.toISOString = function() {
        return this.toDate().toISOString();
      }, u.toString = function() {
        return this.toDate().toUTCString();
      };
      var l = u.toDate;
      u.toDate = function(t2) {
        return "s" === t2 && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
      };
      var c = u.diff;
      u.diff = function(t2, i2, e2) {
        if (t2 && this.$u === t2.$u) return c.call(this, t2, i2, e2);
        var s2 = this.local(), f2 = n(t2).local();
        return c.call(s2, f2, i2, e2);
      };
    };
  });
})(utc$1);
var utcExports = utc$1.exports;
const utc = /* @__PURE__ */ getDefaultExportFromCjs(utcExports);
var weekOfYear$1 = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    var e = "week", t = "year";
    return function(i, n, r) {
      var f = n.prototype;
      f.week = function(i2) {
        if (void 0 === i2 && (i2 = null), null !== i2) return this.add(7 * (i2 - this.week()), "day");
        var n2 = this.$locale().yearStart || 1;
        if (11 === this.month() && this.date() > 25) {
          var f2 = r(this).startOf(t).add(1, t).date(n2), s = r(this).endOf(e);
          if (f2.isBefore(s)) return 1;
        }
        var a = r(this).startOf(t).date(n2).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, true);
        return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
      }, f.weeks = function(e2) {
        return void 0 === e2 && (e2 = null), this.week(e2);
      };
    };
  });
})(weekOfYear$1);
var weekOfYearExports = weekOfYear$1.exports;
const weekOfYear = /* @__PURE__ */ getDefaultExportFromCjs(weekOfYearExports);
dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(weekOfYear);
dayjs.extend(dayOfYear);
dayjs.extend(isLeapYear);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeeksInYear);
dayjs.extend(localeData);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(quarterOfYear);
const DateUtil = function() {
  const util = {};
  util.getMinimumDateOfBirth = () => {
    return "1850-01-01";
  };
  util.addToDate = (time, unitTime, date) => date ? dayjs(date).add(time, unitTime) : dayjs().add(time, unitTime);
  util.getDate = (date) => date ? dayjs(date) : dayjs();
  util.subtractFromDate = (time, unitTime, date) => {
    return date ? date.subtract(time, unitTime) : dayjs().subtract(time, unitTime);
  };
  util.isSame = (firstDate, secondDate) => dayjs(firstDate).isSame(dayjs(secondDate));
  util.isAfter = (prevDate, oldDate) => dayjs(prevDate).isAfter(oldDate);
  util.isBefore = (prevDate, oldDate) => dayjs(prevDate).isBefore(oldDate);
  util.getYear = (date) => dayjs(date).year();
  util.getMonth = (date) => dayjs(date).month() + 1;
  util.getDay = (date) => dayjs(date).date();
  util.getUTCFormatted = (date, format2) => dayjs(date).utc().format(format2);
  util.formatExistingDate = (format2, date) => date.format(format2);
  util.getDateFormatted = (format2, date) => date ? dayjs(date).format(format2) : dayjs().format(format2);
  util.getMonthsShort = () => dayjs.monthsShort();
  util.getTimeDuration = (time, unitTime) => dayjs.duration({ time, unitTime });
  util.getUnix = (number) => dayjs.unix(number);
  util.getValueOf = (date) => date ? dayjs(date).valueOf() : dayjs().valueOf();
  util.getUTCOffset = () => dayjs().utcOffset();
  util.getRange = (startDate, endDate) => dayjs(startDate).to(endDate);
  util.getCalendar = (date) => {
    return dayjs(new Date(date).setHours(0, 0, 0, 0)).utc().toDate();
  };
  util.isValid = (date, format2, flag = false) => dayjs(date, format2, flag).isValid();
  util.diff = (firstDate, secondDate, unitTime, flag = true) => dayjs(firstDate).diff(secondDate, unitTime, flag);
  util.isDayjs = (date) => dayjs.isDayjs(dayjs(date));
  util.getTimeZone = (timeStamp, timeZone) => dayjs(timeStamp).tz(timeZone);
  util.swapDateFormat = (date, oldFormat, newFormat) => {
    return dayjs(date, oldFormat).format(newFormat);
  };
  util.getGenericFormat = (date, anyFormat) => {
    return dayjs(date, anyFormat);
  };
  util.dayOfYear = (d, n) => dayjs(d).dayOfYear(n);
  util.getQuarterStart = () => dayjs().startOf("quarter");
  util.formatDateInputField = (date, keyCode) => {
    const valLength = date == null ? void 0 : date.length;
    if (keyCode !== 8) {
      if (valLength === 2 || valLength === 5) {
        return date + "/";
      }
    } else {
      if (valLength === 2 || valLength === 5) {
        return date.slice(0, -1);
      }
    }
    return date;
  };
  return util;
};
const DateUtil$1 = DateUtil();
const ROUTE_PLAN_MESSAGES = "/participant/accounts/#/plan-messages";
const ROUTE_RETAIL_NOTIFICATIONS = "/participant/home/#/notifications";
const root = "HeaderPlanMessagingEvent.";
const headerPlanMessagingEvents = {
  VIEW_ALL_CLICK: root + "view_all_clicked_event",
  NEXT_CLICK: root + "next_clicked_event",
  PREVIOUS_CLICK: root + "previous_clicked_event",
  OPEN_CLICK: root + "open_clicked_event",
  CLOSE_CLICK: root + "close_clicked_event",
  EXPAND_CLICK: root + "expand_slide_clicked_event",
  COLLAPSE_CLICK: root + "collapse_slide_clicked_event",
  MESSAGE_CLICK: root + "message_content_clicked_event",
  BACKGROUND_CLICK: root + "background_dismiss_event"
};
function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });
  const setValue = (value) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.log(error);
    }
  };
  return [storedValue, setValue];
}
const BACK_DROP_STYLES = {
  position: "fixed",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  zIndex: 999,
  backgroundColor: "transparent"
};
const Backdrop = (props) => {
  const { dismissDialog } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      role: "button",
      tabIndex: 0,
      onClick: (e) => dismissDialog(e),
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          dismissDialog(e);
        }
      },
      style: BACK_DROP_STYLES
    }
  );
};
const NextButton = (props) => {
  const { onClick, onKeyDown, slides, focusableElements, ...restProps } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "button",
    {
      role: "option",
      "aria-selected": "false",
      onClick,
      onKeyDown,
      ref: (ref) => ref && focusableElements && focusableElements.current && (focusableElements.current[slides.length - 1] = ref),
      ...restProps,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            src: globalThis.__styleEnv__ + "/customizations/Default/images/carousel/icon-next.svg",
            alt: "Next"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: "Previous" })
      ]
    }
  );
};
const PrevButton = (props) => {
  const { onClick, onKeyDown, slides, focusableElements, ...restProps } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "button",
    {
      role: "option",
      "aria-selected": "false",
      onClick,
      onKeyDown,
      ref: (ref) => ref && focusableElements && focusableElements.current && (focusableElements.current[slides.length] = ref),
      ...restProps,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            src: globalThis.__styleEnv__ + "/customizations/Default/images/carousel/icon-prev.svg",
            alt: "Previous"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: "Previous" })
      ]
    }
  );
};
const MESSAGE_MORE_LESS_LABEL = "Toggle complete/condensed message view";
const SUBSET_LIMIT = 70;
const { getUTCFormatted, isAfter, subtractFromDate } = DateUtil$1;
const oldestDate$1 = subtractFromDate(180, "days");
const removeHTML = (text) => {
  const regex = /<[^>]*>/g;
  if (regex.test(text)) {
    text = text.replace(regex, "");
  }
  return text;
};
const showView = (text, threshold) => {
  const pureText = removeHTML(text);
  return (pureText && pureText.length) > threshold;
};
const truncateInformation = (slide, threshold) => {
  let text = slide.information;
  let shortText = slide.information;
  if (showView(text, threshold) && !slide.expand) {
    text = text.slice(0, threshold);
    shortText = shortText.slice(140, threshold);
    let n = shortText.lastIndexOf("&");
    if (n > -1) {
      n = text.lastIndexOf("&");
      text = String(text).slice(0, n) + "<span>&#8230;</span>";
    } else {
      text = text + "<span>&#8230;</span>";
    }
  }
  return { __html: text };
};
const isViewingAll = () => window.location.hash === "#/plan-messages";
const HeaderPlanMessaging = (props) => {
  const dispatch = useDispatch();
  const [planMessaging] = useState(props.translations.planMessaging);
  const [link] = useState(props.translations.link);
  const [showDialog, setShowDialog] = useState(false);
  const [hasUnread, setHasUnread] = useState(false);
  const [shouldAutopop, setShouldAutopop] = useState(() => !isViewingAll());
  const [isAutopopActive, setIsAutopopActive] = useState(false);
  const [hasAutopopped, setHasAutopopped] = useState(false);
  const [readMessages, setReadMessages] = useLocalStorage("readMessages", []);
  const badgeRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isEmulator, setIsEmulator] = useState(false);
  const planMessagingButton = document.querySelector(".plan-messaging");
  const focusableElements = useRef([]);
  let limit = props.slides.length <= 5 ? props.slides.length : 5;
  const updateSlidesReadState = (slides2) => slides2.map((slide) => ({
    ...slide,
    read: readMessages.includes(slide.bulletinId)
  }));
  const removeOldSlides = (slides2) => slides2.filter(({ displayEffdate }) => isAfter(displayEffdate, oldestDate$1));
  const [slides, setSlides] = useState(removeOldSlides(updateSlidesReadState([...props.slides])));
  limit = slides.length <= 5 ? slides.length : 5;
  const handleEventDispatch = useCallback(
    (selection) => {
      dispatch(dispatchEventBus(selection));
      dispatchAmplitude({
        eventType: AMPLITUDE_EVENTS.SELECT_BUTTON,
        selection
      });
    },
    [dispatch]
  );
  const toggleView = (slide, id2) => {
    const newSlides = [...slides];
    const newSlide = { ...slide };
    newSlide.expand = !newSlide.expand;
    newSlides[id2] = newSlide;
    setSlides(newSlides);
    if (slide.expand) {
      handleEventDispatch(headerPlanMessagingEvents.COLLAPSE_CLICK);
    } else {
      handleEventDispatch(headerPlanMessagingEvents.EXPAND_CLICK);
    }
    slide.expand = !slide.expand;
  };
  const getReadMessageIds = (slides2) => slides2.reduce(
    (arr, { read, bulletinId }) => read ? [.../* @__PURE__ */ new Set([...arr, bulletinId])] : [...arr],
    []
  );
  const markAsRead = (selectedIndex) => {
    const newSlides = [...slides];
    const newSlide = { ...newSlides[selectedIndex] };
    if (globalThis.integratedEligibility.isRetail && !isEmulator) {
      updateRetailUserMessage(newSlide.bulletinId);
    }
    newSlide.read = true;
    newSlides[selectedIndex] = newSlide;
    setReadMessages(getReadMessageIds(newSlides));
    setSlides(newSlides);
  };
  const handleAnyPlanMessagingInteraction = (event) => {
    if (badgeRef.current.contains(event.target)) {
      if (showDialog) {
        markAsRead(activeIndex);
      }
      if (isAutopopActive) {
        setIsAutopopActive(false);
      }
    }
    handleBadgeClick();
  };
  const handleViewAll = (event) => {
    event.stopPropagation();
    event.preventDefault();
    event.nativeEvent.stopImmediatePropagation();
    if (props.onViewAllPrevent !== null && !props.onViewAllPrevent) {
      viewAllClick();
    }
    if (isPreventUrl(props.navMenu, dispatch)) {
      setShowDialog(false);
    }
    props.prevent(event, "NOTIFICATION");
  };
  const viewAllClick = () => {
    handleEventDispatch(headerPlanMessagingEvents.VIEW_ALL_CLICK);
    setShowDialog(false);
    slides.map((item) => {
      item.read = true;
    });
    setReadMessages(getReadMessageIds(slides));
    window.location.href = globalThis.integratedEligibility.isRetail ? ROUTE_RETAIL_NOTIFICATIONS : ROUTE_PLAN_MESSAGES;
  };
  useEffect(() => {
    if (props.onViewAllPrevent !== null && props.onViewAllPrevent !== void 0 && !props.onViewAllPrevent) {
      viewAllClick();
    }
    if (props.onViewAllPrevent !== null && props.onViewAllPrevent) {
      setShowDialog(false);
    }
  }, [props.onViewAllPrevent]);
  const handleBadgeClick = () => {
    if (!showDialog) {
      setShowDialog(true);
      handleEventDispatch(headerPlanMessagingEvents.OPEN_CLICK);
    } else {
      setShowDialog(false);
    }
  };
  const dismissDialog = (e) => {
    setShowDialog(false);
    handleAnyPlanMessagingInteraction(e);
    e.stopPropagation();
    handleEventDispatch(headerPlanMessagingEvents.BACKGROUND_CLICK);
  };
  const closeDialog = (e) => {
    setShowDialog(false);
    handleAnyPlanMessagingInteraction(e);
    handleEventDispatch(headerPlanMessagingEvents.CLOSE_CLICK);
  };
  const handleNext = () => {
    if (isAutopopActive && hasAutopopped && showDialog) {
      markAsRead(Math.max(activeIndex, 0));
    }
    setActiveIndex(Math.min(activeIndex + 1, limit - 1));
    handleEventDispatch(headerPlanMessagingEvents.NEXT_CLICK);
  };
  const handlePrev = () => {
    if (isAutopopActive && hasAutopopped && showDialog) {
      markAsRead(Math.max(activeIndex, 0));
    }
    setActiveIndex(Math.max(activeIndex - 1, 0));
    handleEventDispatch(headerPlanMessagingEvents.PREVIOUS_CLICK);
  };
  const handleKeydownCarouselButtons = (e, handleCarouselDirection) => handleKeyboardDownEvent({
    event: e,
    keys: keyboardInteractions.button,
    output: () => {
      setFocusToElement(e.target);
      handleCarouselDirection();
    }
  });
  const handleKeydownToggleView = (e, slide, id2) => handleKeyboardDownEvent({
    event: e,
    keys: keyboardInteractions.button,
    output: () => {
      setFocusToElement(e.target);
      toggleView(slide, id2);
    }
  });
  const handleKeydownCarouselIndicators = (e, id2) => handleKeyboardDownEvent({
    event: e,
    keys: keyboardInteractions.button,
    output: () => {
      setFocusToElement(e.target);
      setActiveIndex(id2);
    }
  });
  const setFocusToElement = (eventTarget) => {
    focusableElements.current.forEach((element, index2) => {
      if (element === eventTarget) {
        setTimeout(() => {
          const carouselControlButtons = document.querySelector("#plan-messaging-container").querySelectorAll("button.carousel-control");
          const indexListActive = focusableElements.current.indexOf(
            document.querySelector("#plan-messaging-container").querySelector("li.active")
          );
          if (eventTarget.className.includes("right") && carouselControlButtons.length === 1) {
            focusableElements.current[indexListActive].focus();
          } else if (eventTarget.className.includes("left") && carouselControlButtons.length === 1) {
            focusableElements.current[0].focus();
          } else {
            focusableElements.current[index2].focus();
          }
        }, 50);
      }
    });
  };
  const Messages = ({ slides: slides2 = [], limit: limit2, viewLess, viewMore }) => {
    const showControls = slides2.length > 1;
    const showPrevButton = activeIndex > 0;
    const showNextButton = activeIndex < limit2 - 1;
    const { isRetail } = globalThis.integratedEligibility;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Carousel,
        {
          className: "messaging-body",
          interval: null,
          wrap: false,
          controls: false,
          indicators: false,
          activeIndex,
          children: slides2.slice(0, limit2).map((slide, id2) => {
            const navigable = slide.navigable ? "navigable" : "";
            return /* @__PURE__ */ jsxRuntimeExports.jsx(
              Carousel.Item,
              {
                className: `messaging-body-inner item ${navigable}`,
                children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "message-date", children: getUTCFormatted(slide.displayEffdate, "M/D/YYYY") }),
                  isRetail ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "message-title", children: slide.title }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "p",
                    {
                      className: `message-title ${slide.subsetName ? "margin-bottom-0" : ""}`,
                      children: slide.planName
                    }
                  ),
                  slide.subsetName && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { "data-testid": "subset-name", className: "message-sub-title", children: [
                    "-",
                    " ",
                    /* @__PURE__ */ jsxRuntimeExports.jsx("em", { children: truncateSubsetName(slide.subsetName, SUBSET_LIMIT) })
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    "p",
                    {
                      className: "message-content",
                      id: `ID${id2}`,
                      role: "presentation",
                      onKeyDown: (e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          handleEventDispatch(
                            headerPlanMessagingEvents.MESSAGE_CLICK
                          );
                        }
                      },
                      onClick: () => handleEventDispatch(
                        headerPlanMessagingEvents.MESSAGE_CLICK
                      ),
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(
                          "span",
                          {
                            dangerouslySetInnerHTML: truncateInformation(
                              slide,
                              150
                            )
                          }
                        ),
                        showView(slide.information, 150) ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                          "button",
                          {
                            className: "btn-no-style",
                            tabIndex: 0,
                            "aria-label": MESSAGE_MORE_LESS_LABEL,
                            "aria-expanded": slide.expand,
                            onKeyDown: (e) => handleKeydownToggleView(e, slide, id2),
                            "aria-controls": `ID${id2}`,
                            onClick: () => toggleView(slide, id2),
                            ref: (ref) => ref && (focusableElements.current[slides2.length + id2 + 1] = ref),
                            children: slide.expand ? viewLess : viewMore
                          }
                        ) }) : null
                      ]
                    }
                  )
                ] })
              },
              slide.userMessageId
            );
          })
        }
      ),
      showControls && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "carousel slide custom-controls", role: "listbox", children: [
        showPrevButton && /* @__PURE__ */ jsxRuntimeExports.jsx(
          PrevButton,
          {
            onClick: handlePrev,
            onKeyDown: (e) => handleKeydownCarouselButtons(e, handlePrev),
            className: "carousel-control left"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("ol", { className: "carousel-indicators", role: "listbox", children: slides2.slice(0, limit2).map(({ bulletinId }, id2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          "li",
          {
            role: "option",
            "aria-selected": id2 === activeIndex,
            tabIndex: "0",
            className: `${id2 === activeIndex ? "active" : ""}`,
            onKeyDown: (e) => handleKeydownCarouselIndicators(e, id2),
            onClick: () => setActiveIndex(id2),
            ref: (ref) => ref && (focusableElements.current[id2] = ref)
          },
          bulletinId
        )) }),
        showNextButton && /* @__PURE__ */ jsxRuntimeExports.jsx(
          NextButton,
          {
            onClick: handleNext,
            onKeyDown: (e) => handleKeydownCarouselButtons(e, handleNext),
            className: "carousel-control right"
          }
        )
      ] })
    ] });
  };
  useEffect(() => {
    setSlides(
      slides.map((slide) => ({
        ...slide,
        read: readMessages.includes(slide.bulletinId)
      }))
    );
  }, [readMessages]);
  useEffect(() => {
    if (slides.some((slide) => !slide.read)) {
      setHasUnread(true);
    } else {
      setHasUnread(false);
    }
  }, [slides, limit]);
  useEffect(() => {
    if (!showDialog && slides.slice(0, limit).some((slide) => !slide.read)) {
      setActiveIndex(
        Math.min(
          findIndex(slides.slice(0, limit), (slide) => !slide.read),
          limit
        )
      );
    }
  }, [showDialog, slides, limit, hasUnread]);
  useEffect(() => {
    if (props.slides.length > 0) {
      if (globalThis.integratedEligibility.isRetail) {
        setSlides([...props.slides]);
      } else {
        setSlides(removeOldSlides(updateSlidesReadState([...props.slides])));
      }
    }
  }, [props.slides]);
  useEffect(() => {
    setIsEmulator(isEmulatorUser());
  }, [globalThis.integratedEligibility, globalThis.integratedEligibility.isEmulator]);
  const checkIsViewingAll = useCallback(() => {
    if (isViewingAll()) {
      setShouldAutopop(false);
    }
  }, [shouldAutopop]);
  useEffect(() => {
    window.addEventListener("hashchange", checkIsViewingAll);
    return () => window.removeEventListener("hashchange", checkIsViewingAll);
  }, []);
  useEffect(() => {
    if (isAutopopActive) {
      setHasAutopopped(true);
    }
  }, [isAutopopActive]);
  useEffect(() => {
    if (shouldAutopop && !hasAutopopped && hasUnread && !isAutopopActive && !showDialog) {
      setIsAutopopActive(true);
      setShowDialog(true);
    }
    if (isAutopopActive && !showDialog) {
      setIsAutopopActive(false);
    }
  }, [hasUnread, showDialog, isAutopopActive, hasAutopopped, shouldAutopop]);
  useEffect(() => {
    if (!isAutopopActive && hasAutopopped && showDialog) {
      markAsRead(activeIndex);
    }
  }, [isAutopopActive, hasAutopopped, showDialog, activeIndex]);
  useEffect(() => {
    const planMessagingContainer = document.querySelector("#plan-messaging-container");
    if (!showDialog && planMessagingButton) {
      planMessagingButton.addEventListener("keydown", handleKeydownOpenDialog);
      return () => planMessagingButton.addEventListener("keydown", handleKeydownOpenDialog);
    }
    if (showDialog && planMessagingContainer) {
      planMessagingContainer.addEventListener(
        "keydown",
        (e) => handleKeydownCloseDialog(e, planMessagingContainer)
      );
      return () => planMessagingContainer.addEventListener(
        "keydown",
        (e) => handleKeydownCloseDialog(e, planMessagingContainer)
      );
    }
  });
  const handleKeydownCloseDialog = (e, planMessagingContainer) => {
    if (!["Tab", "Shift"].includes(e.key)) {
      return;
    }
    setTimeout(() => {
      if (document.activeElement.tagName !== "BODY" && ![...planMessagingContainer.querySelectorAll(queryFocusableElements)].includes(
        document.activeElement
      ))
        closeDialog(e);
    }, 10);
  };
  const handleKeydownOpenDialog = (e) => {
    if (!["Tab", "Shift", "Enter", " "].includes(e.key)) {
      return;
    }
    if (document.activeElement === planMessagingButton) {
      handleKeyboardDownEvent({
        event: e,
        keys: keyboardInteractions.button,
        output: handleBadgeClick
      });
      return e.key === "Tab" && e.shiftKey && closeDialog(e);
    }
  };
  const handleKeydownViewAll = (e) => {
    handleKeyboardDownEvent({
      event: e,
      keys: keyboardInteractions.link,
      output: () => handleViewAll(e, props.prevent)
    });
  };
  const MessagingPopover = ({ limit: limit2 }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Backdrop, { dismissDialog }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Popover,
      {
        placement: "bottom",
        id: "plan-messaging",
        className: "plan-messaging-popover popover-content",
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id: "plan-messaging-container", role: "application", "aria-expanded": showDialog, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { className: "messaging-header", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "messaging-header-title", children: planMessaging.title }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "messaging-header-controls", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "messaging-header-all-link", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                "a",
                {
                  onKeyDown: handleKeydownViewAll,
                  onClick: (e) => handleViewAll(e, props.prevent),
                  "aria-label": link.viewAllMessages,
                  children: link.viewAll
                }
              ) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  className: "btn btn-close",
                  onClick: closeDialog,
                  "aria-label": link.closeLabel,
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: planMessaging.close })
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Messages,
            {
              slides,
              limit: limit2,
              viewLess: planMessaging.viewLess,
              viewMore: planMessaging.viewMore
            }
          )
        ] })
      }
    )
  ] });
  if (slides.length > 0 && planMessaging) {
    const className = ["badge", hasUnread ? "badge-danger" : "badge-primary"].join(" ");
    const { unreadState, readState, alertSingular, alertPlural, title } = planMessaging;
    const planMessagingTitle = `${slides.length} ${hasUnread ? unreadState : readState} ${slides.length === 1 ? alertSingular : alertPlural} - ${title}`;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { ref: badgeRef, className: "plan-messaging", "data-testid": "header-plan-messaging", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          id: "planMessages",
          type: "button",
          "aria-haspopup": "true",
          "aria-expanded": showDialog,
          "aria-label": planMessagingTitle,
          onClick: handleAnyPlanMessagingInteraction,
          className: "btn-no-style",
          "data-testid": "plan-messaging-badge",
          children: [
            !globalThis.integratedEligibility.isRetail ? /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                className: "messages-envelope",
                alt: "",
                "aria-hidden": "true",
                src: "/ui/customization-ui/customizations/Default/images/envelope_icon.svg"
              }
            ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                className: "messages-bell",
                alt: "",
                "aria-hidden": "true",
                src: "/ui/customization-ui/customizations/Default/images/bell_icon.svg"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "badge-count", children: slides.length }) })
          ]
        }
      ),
      showDialog && /* @__PURE__ */ jsxRuntimeExports.jsx(MessagingPopover, { limit })
    ] });
  }
  return null;
};
class LogService {
}
__publicField(LogService, "getLogger", () => {
  return log;
});
__publicField(LogService, "setLevel", (level) => {
  if (loglevelExports.levels[String(level).toUpperCase()] === void 0) {
    loglevelExports.error("LogService setLevel() called with invalid level: " + level);
    return;
  }
  loglevelExports.setLevel(level);
});
__publicField(LogService, "enableLog", (level = loglevelExports.levels.TRACE) => {
  level = String(level).toLowerCase();
  loglevelExports.debug("LogService log enabled and set to " + level);
  loglevelExports.setLevel(level);
});
__publicField(LogService, "disableLog", () => {
  loglevelExports.debug("LogService log disabled and set to " + loglevelExports.levels.SILENT);
  loglevelExports.setLevel(loglevelExports.levels.SILENT);
});
const url = window.location.href;
const isDev = url.indexOf("useMocks=true") !== -1 || url.indexOf("debug=true") !== -1;
isDev ? loglevelExports.setLevel(loglevelExports.levels.DEBUG) : loglevelExports.setLevel(loglevelExports.levels.ERROR);
const _DataLayer = class _DataLayer {
};
/**
 * events need to be named with following convention
 *
 *     [component].[event_type]
 * e.g.  paycheck .   click
 *
 * NOTE! event parsed results will be overwritten if payload object has the same property names
 */
__publicField(_DataLayer, "push", (event, payload = {}) => {
  if (typeof event !== "string") {
    _DataLayer.log.error(
      "DataLayer.push() incorrect event type, expect a string, got " + typeof event + " instead."
    );
    return;
  }
  const eventDetails = event.split(".");
  let componentName, actionType2, obj;
  if (eventDetails[0] === "CoreHeaderEvent") {
    componentName = eventDetails[0];
    actionType2 = eventDetails[1] + "." + eventDetails[2];
  } else {
    if (eventDetails.length === 2) {
      componentName = eventDetails[0];
      actionType2 = eventDetails[1];
    } else {
      _DataLayer.log.error(
        "DataLayer.push() incorrect event format, using default values instead."
      );
      componentName = "LIAT";
      actionType2 = "click";
    }
  }
  if (payload.url && payload.url > "") {
    obj = Object.assign(
      {
        event,
        "event.category": componentName,
        "event.label": actionType2,
        eventCallback: () => {
          if (payload.url && payload.url > "") {
            setTimeout(() => {
              window.location.href = payload.url;
            }, 300);
          }
        }
      },
      payload
    );
  } else {
    obj = Object.assign(
      {
        event: actionType2,
        "event.category": componentName
      },
      payload
    );
  }
  window.dataLayer.push(obj);
  if (_DataLayer.isDeepLoggingEnabled) {
    console.log(obj);
  }
});
let DataLayer = _DataLayer;
DataLayer.log = LogService.getLogger();
DataLayer.isDeepLoggingEnabled = UrlUtil.getURLParam("logEvents") === "true";
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el2 = this;
    do {
      if (el2.matches(s)) return el2;
      el2 = el2.parentElement || el2.parentNode;
    } while (el2 !== null && el2.nodeType === 1);
    return null;
  };
}
const useDropdownMenu = (itemCount) => {
  const [isOpen, setIsOpen] = useState(false);
  const currentFocusIndex = useRef(null);
  const firstRun = useRef(true);
  const clickedOpen = useRef(false);
  const buttonRef = useRef(null);
  const itemRefs = useMemo(
    () => Array.from({ length: itemCount }, () => createRef()),
    [itemCount]
  );
  const isKeyboardEvent = (e) => e.key !== void 0;
  const [hasClicked, setHasClicked] = useState(false);
  const moveFocus = useCallback(
    (itemIndex) => {
      let _a2;
      currentFocusIndex.current = itemIndex;
      (_a2 = itemRefs[itemIndex].current) === null || _a2 === void 0 ? void 0 : _a2.focus();
      itemRefs[itemIndex].current.style.outline = "3px auto #0061b3";
    },
    [itemRefs]
  );
  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    if (isOpen && !clickedOpen.current) {
      itemRefs[0].current.tabIndex = 0;
      moveFocus(0);
    } else if (!isOpen) {
      clickedOpen.current = false;
    }
  }, [isOpen, itemRefs, moveFocus]);
  useEffect(() => {
    if (!isOpen) {
      return;
    }
    const handleEveryClick = (event) => {
      setTimeout(() => {
        if (!(event.target instanceof Element)) {
          return;
        }
        const previousSiblingId = event.target.previousSibling ? event.target.previousSibling.id : void 0;
        if (event.target.closest('[role="menu"]') instanceof Element && previousSiblingId) {
          return;
        }
        const newFocusIndex = currentFocusIndex.current;
        if (newFocusIndex !== null && itemRefs[newFocusIndex].current) {
          itemRefs[newFocusIndex].current.style.outline = "none";
        }
        setHasClicked(false);
        setIsOpen(false);
      }, 10);
    };
    setTimeout(() => {
      document.addEventListener("click", handleEveryClick);
    }, 1);
    return () => document.removeEventListener("click", handleEveryClick);
  }, [isOpen, itemRefs]);
  useEffect(() => {
    const disableArrowScroll = (event) => {
      if (isOpen && (event.key === "ArrowDown" || event.key === "ArrowUp")) {
        event.preventDefault();
      }
    };
    document.addEventListener("keydown", disableArrowScroll);
    return () => document.removeEventListener("keydown", disableArrowScroll);
  }, [isOpen]);
  const buttonListener = (e) => {
    if (e.key === void 0) {
      setHasClicked(true);
    } else {
      setHasClicked(false);
    }
    if (isKeyboardEvent(e)) {
      const { key } = e;
      if (!["Enter", " ", "Tab", "ArrowDown"].includes(key)) {
        return;
      }
      if ((key === "Tab" || key === "ArrowDown") && clickedOpen.current && isOpen) {
        e.preventDefault();
        moveFocus(0);
      } else if (key !== "Tab") {
        e.preventDefault();
        setIsOpen(true);
        if (key === "Enter") {
          setHasClicked(false);
        }
      }
    } else {
      clickedOpen.current = !isOpen;
      setIsOpen(!isOpen);
    }
  };
  const itemListener = (e) => {
    let _a2;
    const key = e.detail.key !== void 0 ? e.detail.key : e.key !== void 0 && e.key !== "Unidentified" ? e.key : " ";
    if (!["Tab", "Shift", "Enter", "Escape", "ArrowUp", "ArrowDown"].includes(key)) {
      return;
    }
    let newFocusIndex = currentFocusIndex.current;
    if (key === "Escape") {
      if (newFocusIndex !== null) {
        itemRefs[newFocusIndex].current.style.outline = "none";
      }
      setIsOpen(false);
      (_a2 = buttonRef.current) === null || _a2 === void 0 ? void 0 : _a2.focus();
      return;
    } else if (key === "Tab") {
      if (newFocusIndex !== null) {
        itemRefs[newFocusIndex].current.style.outline = "none";
      }
      setIsOpen(false);
      return;
    } else if (key === "Enter") {
      const isPlanList = e.currentTarget.classList.contains("planlist");
      if (newFocusIndex !== null && itemRefs[newFocusIndex].current && !isPlanList) {
        itemRefs[newFocusIndex].current.style.outline = "none";
      }
      e.currentTarget.click();
      if (!isPlanList) {
        setIsOpen(false);
      }
      return;
    }
    if (newFocusIndex !== null) {
      itemRefs[newFocusIndex].current.tabIndex = -1;
      itemRefs[newFocusIndex].current.style.outline = "none";
      if (key === "ArrowUp") {
        newFocusIndex -= 1;
      } else if (key === "ArrowDown") {
        newFocusIndex += 1;
      }
      if (newFocusIndex > itemRefs.length - 1) {
        newFocusIndex = 0;
      } else if (newFocusIndex < 0) {
        newFocusIndex = itemRefs.length - 1;
      }
    }
    if (newFocusIndex !== null) {
      itemRefs[newFocusIndex].current.tabIndex = 0;
      moveFocus(newFocusIndex);
    }
  };
  const buttonProps = {
    onKeyDown: buttonListener,
    onClick: buttonListener,
    tabIndex: 0,
    ref: buttonRef,
    role: "button",
    "aria-haspopup": true,
    "aria-expanded": isOpen
  };
  const itemProps = Array.from({ length: itemCount }, (_ignore, index2) => ({
    onKeyDown: itemListener,
    tabIndex: -1,
    role: "menuitem",
    ref: itemRefs[index2]
  }));
  return { buttonProps, itemProps, isOpen, setIsOpen, hasClicked, setHasClicked, buttonListener };
};
const useNestedDropdownMenu = (itemCount) => {
  const [isNestedOpen, setIsNestedOpen] = useState(false);
  const currentFocusIndexNested = useRef(null);
  const firstRunNested = useRef(true);
  const clickedOpenNested = useRef(false);
  const nestedButtonRef = useRef(null);
  const nestedItemRefs = useMemo(
    () => Array.from({ length: itemCount }, () => createRef()),
    [itemCount]
  );
  const isKeyboardEvent = (e) => e.key !== void 0 && e.detail.key !== void 0;
  const [isClickOnly, setIsClickOnly] = useState(false);
  const moveNestedFocus = useCallback(
    (itemIndex) => {
      let _a2;
      currentFocusIndexNested.current = itemIndex;
      if (nestedItemRefs.length > 0) {
        (_a2 = nestedItemRefs[itemIndex].current) === null || _a2 === void 0 ? void 0 : _a2.focus();
        nestedItemRefs[itemIndex].current.style.outline = isClickOnly ? "none" : "3px auto #0061b3";
      }
    },
    [isClickOnly, nestedItemRefs]
  );
  useEffect(() => {
    if (firstRunNested.current) {
      firstRunNested.current = false;
      return;
    }
    if (isNestedOpen) {
      if (nestedItemRefs.length > 0) {
        nestedItemRefs[0].current.tabIndex = 0;
      }
      moveNestedFocus(0);
    } else if (!isNestedOpen) {
      clickedOpenNested.current = false;
    }
  }, [isNestedOpen, moveNestedFocus, nestedItemRefs]);
  useEffect(() => {
    if (!isNestedOpen) {
      return;
    }
    const handleEveryNestedClick = (event) => {
      setTimeout(() => {
        if (!(event.target instanceof Element)) {
          return;
        }
        if (event.target.closest('[role="menu"]') instanceof Element) {
          return;
        }
        const newFocusIndex = currentFocusIndexNested.current;
        if (newFocusIndex !== null && nestedItemRefs.length > 0 && nestedItemRefs[newFocusIndex].current) {
          nestedItemRefs[newFocusIndex].current.style.outline = "none";
        }
        setIsNestedOpen(false);
      }, 10);
    };
    setTimeout(() => {
      document.addEventListener("click", handleEveryNestedClick);
    }, 1);
    return () => document.removeEventListener("click", handleEveryNestedClick);
  }, [isNestedOpen, nestedItemRefs]);
  useEffect(() => {
    const disableNestedArrowScroll = (event) => {
      if (isNestedOpen && (event.key === "ArrowDown" || event.key === "ArrowUp")) {
        event.preventDefault();
      }
    };
    document.addEventListener("keydown", disableNestedArrowScroll);
    return () => document.removeEventListener("keydown", disableNestedArrowScroll);
  }, [isNestedOpen]);
  const nestedButtonListener = (e) => {
    if (isKeyboardEvent(e)) {
      const key = e.detail.key !== void 0 ? e.detail.key : e.key !== void 0 && e.key !== "Unidentified" ? e.key : " ";
      if (!["Enter", " ", "Tab", "ArrowDown"].includes(key)) {
        return;
      }
      if ((key === "Tab" || key === "ArrowDown") && clickedOpenNested.current && isNestedOpen) {
        e.preventDefault();
        moveNestedFocus(0);
      } else if (key !== "Tab") {
        e.preventDefault();
        setIsNestedOpen(true);
      }
    } else {
      clickedOpenNested.current = !isNestedOpen;
      setIsNestedOpen(!isNestedOpen);
      if (isNestedOpen) {
        e.preventDefault();
        moveNestedFocus(0);
      }
    }
  };
  const nestedItemListener = (e) => {
    let _a2;
    const key = e.detail.key !== void 0 ? e.detail.key : e.key !== void 0 && e.key !== "Unidentified" ? e.key : " ";
    if (!["Tab", "Shift", "Enter", "Escape", "ArrowUp", "ArrowDown"].includes(key)) {
      return;
    }
    let newFocusIndex = currentFocusIndexNested.current;
    if (key === "Escape") {
      if (newFocusIndex !== null) {
        nestedItemRefs[newFocusIndex].current.style.outline = "none";
      }
      setIsNestedOpen(false);
      (_a2 = nestedButtonRef.current) === null || _a2 === void 0 ? void 0 : _a2.focus();
      return;
    } else if (key === "Tab") {
      if (newFocusIndex !== null) {
        nestedItemRefs[newFocusIndex].current.style.outline = "none";
      }
      const groupId = e.currentTarget.id.substr(0, e.currentTarget.id.length - 2);
      const evt2 = new CustomEvent$1("click", {
        bubbles: true,
        cancelable: true,
        detail: { key: "Tab" }
      });
      const anchor = document.getElementById(groupId);
      anchor.dispatchEvent(evt2);
      const item = document.getElementById(groupId);
      const evt = new CustomEvent$1("keydown", {
        bubbles: true,
        cancelable: true,
        detail: { key: "Tab" }
      });
      item.dispatchEvent(evt);
      setIsNestedOpen(false);
      return;
    } else if (key === "Enter") {
      const isPlanList = e.currentTarget.classList.contains("planlist");
      if (newFocusIndex !== null && nestedItemRefs[newFocusIndex].current && !isPlanList) {
        nestedItemRefs[newFocusIndex].current.style.outline = "none";
      }
      e.currentTarget.click();
      if (!isPlanList) {
        setIsNestedOpen(false);
      }
      return;
    }
    if (newFocusIndex !== null) {
      nestedItemRefs[newFocusIndex].current.tabIndex = -1;
      nestedItemRefs[newFocusIndex].current.style.outline = "none";
      if (key === "ArrowUp") {
        newFocusIndex -= 1;
      } else if (key === "ArrowDown") {
        newFocusIndex += 1;
      }
      if (newFocusIndex > nestedItemRefs.length - 1) {
        newFocusIndex = 0;
      } else if (newFocusIndex < 0) {
        newFocusIndex = nestedItemRefs.length - 1;
      }
    }
    if (newFocusIndex !== null) {
      nestedItemRefs[newFocusIndex].current.tabIndex = 0;
      moveNestedFocus(newFocusIndex);
    }
  };
  const nestedButtonProps = {
    onKeyDown: nestedButtonListener,
    onClick: nestedButtonListener,
    tabIndex: 0,
    ref: nestedButtonRef,
    role: "menuitem",
    "aria-haspopup": true,
    "aria-expanded": isNestedOpen
  };
  const nestedItemProps = Array.from({ length: itemCount }, (_ignore, index2) => ({
    onKeyDown: nestedItemListener,
    tabIndex: -1,
    role: "menuitem",
    ref: nestedItemRefs[index2]
  }));
  return { nestedButtonProps, nestedItemProps, isNestedOpen, setIsNestedOpen, setIsClickOnly };
};
const MenuListItem = ({ planName, subsetName, hasSubmenu }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "menu-list-item", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "planName-container", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "data-testid": "plan-name", children: planName }),
      hasSubmenu && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "em-caret-right", "data-testid": "has-sub-menu" })
    ] }),
    subsetName && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "subsetName-container", "data-testid": "sub-set-Name", children: subsetName })
  ] });
};
const IntegratedAccountMenuOption = ({
  accountItem,
  onAccountEnter,
  onAccountClick,
  acctIndx,
  getSubMenuCls,
  setUrlAndDispatch,
  itemProps,
  hasClicked,
  setIsOpen
}) => {
  var _a2, _b2;
  const dispatch = useDispatch();
  const account2 = useSelector((state) => state.account);
  const header2 = useSelector((state) => state.header);
  const navMenu2 = useSelector((state) => state.navMenu);
  const [itemCount, setItemCount] = useState(0);
  const { nestedButtonProps, nestedItemProps, isNestedOpen, setIsNestedOpen, setIsClickOnly } = useNestedDropdownMenu(itemCount);
  const [top, setTop] = useState("auto");
  useEffect(() => {
    if (hasClicked && isNestedOpen) {
      document.querySelectorAll("[tabIndex]").forEach((e) => {
        e.addEventListener("focus", function() {
          this.style.outline = "none";
        });
      });
    }
  }, [hasClicked, isNestedOpen]);
  const handleOnClick = (event) => {
    if (accountItem.subMenu) {
      setItemCount(accountItem.subMenu.length);
    }
    onAccountClick(event, accountItem.groupId, accountItem);
    if (hasClicked) {
      setIsClickOnly(true);
    }
    const anchorEl = itemProps[acctIndx].ref.current;
    setTop(anchorEl.offsetTop + "px");
    if (accountItem.subMenu === void 0 && accountItem.siteName && accountItem.siteName.includes("empower-retail-pcap-ps-plus")) {
      setIsOpen(false);
      setIsNestedOpen(false);
      checkIsAccountOpenFlow(() => {
        account2.siteName = accountItem.siteName;
        account2.url = accountItem.url + "&tabId=summary";
        account2.userAccountId = accountItem.userAccountId;
        const submenu = {
          url: account2.url,
          userAccountId: accountItem.userAccountId,
          displayText: "",
          transactionCode: "",
          subMenu: []
        };
        setUrlAndDispatch(
          event,
          submenu,
          account2,
          header2,
          navMenu2.nonSubMenuGroups,
          accountItem.groupId
        );
      }, dispatch);
    }
  };
  const handleMouseOver = (event) => {
    const anchorEl = itemProps[acctIndx].ref.current;
    setTop(anchorEl.offsetTop + "px");
    setIsNestedOpen(true);
    onAccountEnter(event);
  };
  const renderSubMenu = (subMenuList, groupId, acctItem) => {
    if (!(subMenuList == null ? void 0 : subMenuList.length)) return null;
    return subMenuList == null ? void 0 : subMenuList.map((submenu, subMenuIndx) => {
      submenu.userAccountId = acctItem.userAccountId;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "li",
        {
          role: "none",
          className: "menu-item ",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              id: groupId + "-" + subMenuIndx,
              className: "menu-item-link secondary-link ",
              ...nestedItemProps[subMenuIndx],
              "aria-label": submenu.displayText,
              role: "button",
              tabIndex: "0",
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setIsOpen(false);
                  setIsNestedOpen(false);
                  checkIsAccountOpenFlow(() => {
                    setUrlAndDispatch(
                      e,
                      submenu,
                      account2,
                      header2,
                      navMenu2.nonSubMenuGroups,
                      groupId
                    );
                  }, dispatch);
                }
              },
              onClick: (e) => {
                setIsOpen(false);
                setIsNestedOpen(false);
                checkIsAccountOpenFlow(() => {
                  setUrlAndDispatch(
                    e,
                    submenu,
                    account2,
                    header2,
                    navMenu2.nonSubMenuGroups,
                    groupId
                  );
                }, dispatch);
              },
              children: submenu.displayText
            }
          )
        },
        submenu.displayText + "-" + submenu.url
      );
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        id: accountItem.groupId,
        className: `menu-item-link secondary-link dropdown-toggle remove-outline planlist`,
        ...nestedButtonProps,
        ...itemProps[acctIndx],
        "aria-label": `${accountItem.displayText}${accountItem.subsetName ? accountItem.subsetName : ""}`,
        role: "button",
        tabIndex: "0",
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            nestedButtonProps.onClick(e);
            handleOnClick(e);
          }
        },
        onClick: (e) => {
          nestedButtonProps.onClick(e);
          handleOnClick(e);
        },
        onMouseEnter: handleMouseOver,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          MenuListItem,
          {
            planName: accountItem.displayText,
            subsetName: accountItem.subsetName,
            hasSubmenu: ((_a2 = accountItem.subMenu) == null ? void 0 : _a2.length) > 0
          }
        )
      },
      accountItem.groupId + acctIndx
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "ul",
      {
        id: accountItem.groupId + "-submenu",
        className: `sub-menu dropdown-menu`,
        role: "menu",
        style: {
          display: `${isNestedOpen ? "block" : "none"}`,
          visibility: `${getSubMenuCls(accountItem.groupId, (_b2 = accountItem.subMenu) == null ? void 0 : _b2.length) && isNestedOpen ? "visible" : "hidden"}`,
          top
        },
        "aria-label": "plan features",
        children: renderSubMenu(accountItem.subMenu, accountItem.groupId, accountItem)
      },
      accountItem.groupId
    )
  ] });
};
const IntegratedAccountSubmenu = ({
  toggleAccountMenu,
  accountMenuList,
  translations,
  toggleUserDD,
  toggleNav,
  hasSelectedNav,
  setHasSelectedNav
}) => {
  var _a2, _b2, _c2;
  const dispatch = useDispatch();
  const account2 = useSelector((state) => state.account);
  const navMenu2 = useSelector((state) => state.navMenu);
  const header2 = useSelector((state) => state.header);
  const txnAccess = useSelector((state) => state.header.txnAccess);
  const inboundSSOUser = useSelector((state) => state.shared.authenticationStatus.inboundSSOUser);
  const [showAccountMenuDD, setShowAccountMenuDD] = useState(false);
  const [currentGroupId, setCurrentGroupId] = useState("");
  const [myAccounts, setTopNavLbl] = useState(null);
  const numberOfItems = accountMenuList.length === 2 && String(accountMenuList[1].plName).indexOf("cxOpenAccount") > -1 ? (_a2 = accountMenuList[0].subMenu) == null ? void 0 : _a2.length : accountMenuList.length === 1 ? (_b2 = accountMenuList[0].subMenu) == null ? void 0 : _b2.length : accountMenuList.length;
  const { buttonProps, itemProps, isOpen, setIsOpen, hasClicked } = useDropdownMenu(numberOfItems);
  const isOnlyCxOpenAccountItem = accountMenuList.length === 1 && ((_c2 = accountMenuList[0]) == null ? void 0 : _c2.planName) === "cxOpenAccount";
  useEffect(() => {
    if (translations && translations.header && myAccounts === null) {
      setTopNavLbl(translations.header.MyAccounts);
    }
  }, [myAccounts, translations]);
  useEffect(() => {
    if (hasSelectedNav) {
      setIsOpen(false);
    }
  }, [hasSelectedNav, setIsOpen]);
  const toggleDesktopAccountMenu = useCallback(
    (event) => {
      const selection = `${EventBusEvents.HEADER.MAIN_TOGGLE}.Account`;
      dispatch(dispatchEventBus(selection, {}));
      dispatchAmplitude({
        eventType: AMPLITUDE_EVENTS.SELECT_BUTTON,
        selection,
        payload: {
          show_menu: !isOpen
        }
      });
      const accountMenuObj = document.getElementById(event.currentTarget.id);
      if (!isMobileBrowser() && accountMenuObj) {
        if (!showAccountMenuDD) {
          setIsOpen(true);
        }
        setShowAccountMenuDD(!showAccountMenuDD);
        toggleUserDD(false);
        toggleNav(event);
        setHasSelectedNav(false);
      }
      event.stopPropagation();
    },
    [dispatch, isOpen, setHasSelectedNav, setIsOpen, showAccountMenuDD, toggleNav, toggleUserDD]
  );
  useEffect(() => {
    document.addEventListener("keyup", function(event) {
      if (event.keyCode === 13) {
        if (event.target.id === "AccountMenu") {
          toggleNav(event);
          toggleDesktopAccountMenu(event);
        }
      }
    });
  }, [toggleDesktopAccountMenu, toggleNav]);
  const accountsIsActive = function() {
    const pathname = window.location.pathname;
    const hash = window.location.hash;
    return pathname.indexOf("participant/accounts") > -1 && hash.indexOf("#/account") === 0;
  };
  const activateListDisplay = (event) => {
    if (!showAccountMenuDD) {
      dispatch(activateAccountDropDown(account2.activeGroupAccount));
      dispatch(dispatchEventBus(EventBusEvents.HEADER.ACCOUNT, event));
    }
    setHasSelectedNav(false);
  };
  const isEnrollmentPlan = (url2) => {
    return url2.indexOf("/enroll/") !== -1;
  };
  const isEnrollmentPage = () => {
    return window.location.href.indexOf("/participant/enroll/") !== -1;
  };
  const getUrlToEnroll = (enrollURL) => {
    return getCurrentDomain() + enrollURL;
  };
  const redirectEnrollmentPage = (enrollURL) => {
    if (window.location.href.indexOf(enrollURL) == -1) {
      window.location.href = getCurrentDomain() + enrollURL;
      window.location.reload();
    }
  };
  const closeAccountMenu = () => {
    setShowAccountMenuDD(false);
  };
  const onAccountEnter = (e) => {
    if (e.currentTarget.nextSibling) {
      setCurrentGroupId(extractGroupId(e.currentTarget.nextSibling.id));
    } else {
      setCurrentGroupId("");
    }
  };
  const onAccountClick = (e, groupId, item) => {
    if (item.currentContext) {
      const displayName = String(item.planName).replace(/\s/g, "_");
      dispatch(
        dispatchEventBus(EventBusEvents.HEADER.ACCOUNT_DROPDOWN_MENU + "." + displayName)
      );
      dispatchAmplitude({
        eventType: AMPLITUDE_EVENTS.SELECT_MENU,
        selection: EventBusEvents.HEADER.ACCOUNT_DROPDOWN_MENU,
        payload: {
          plan_name: displayName
        }
      });
    }
    if (e.currentTarget.nextSibling) {
      setShowAccountMenuDD(true);
      setCurrentGroupId(extractGroupId(e.currentTarget.nextSibling.id));
    } else {
      setCurrentGroupId("");
    }
    e.stopPropagation();
  };
  const dataLayerPushHandler = (type, payload) => {
    const dataLayerobj = Object.assign(
      {
        "options.type": EventBusEvents.HEADER.NAV_DD_CLICK,
        "event.category": "click"
      },
      payload
    );
    DataLayer.push(type, dataLayerobj);
  };
  const handleMenuClick = (item) => {
    if (isPreventUrl(navMenu2, dispatch)) {
      dispatch(preventNavigation(item, "Account", header2));
      return;
    }
    const displayName = String(item.displayText).replace(/\s/g, "_");
    const payload = {
      menuOption: displayName,
      url: ""
    };
    const isLocal = () => String(window.location.href).indexOf("localhost") > -1;
    const baseAcctUrl = isLocal() ? window.location.origin : "";
    const url2 = injectPcapApiParam(baseAcctUrl + item.url);
    payload.url = url2;
    if (item.planName === "cxOpenAccount" && inboundSSOUser) {
      window.dispatchEvent(new CustomEvent("open-sso-investment-modal", { detail: url2 }));
      return;
    }
    const eventBusAction = EventBusEvents.HEADER.ACCOUNT_DROPDOWN_MENU + "." + String(displayName).toLowerCase();
    dataLayerPushHandler(eventBusAction, payload);
    dispatch(
      dispatchEventBus(
        EventBusEvents.HEADER.ACCOUNT_DROPDOWN_MENU + "." + String(displayName).toLowerCase(),
        {
          menu: String(displayName).toLowerCase()
        }
      )
    );
    dispatchAmplitude({
      eventType: AMPLITUDE_EVENTS.SELECT_MENU,
      selection: EventBusEvents.HEADER.ACCOUNT_DROPDOWN_MENU,
      payload: {
        plan_name: displayName
      }
    });
  };
  const handleClick2 = (e) => {
    if (e.currentTarget && e.currentTarget.id === "AccountMenu") {
      const selection = `${EventBusEvents.HEADER.MAIN_TOGGLE}.Account`;
      dispatch(dispatchEventBus(selection, {}));
      dispatchAmplitude({
        eventType: AMPLITUDE_EVENTS.SELECT_BUTTON,
        selection,
        payload: {
          show_menu: !isOpen
        }
      });
    } else if (e.currentTarget && e.currentTarget.id > "") {
      dispatch(
        dispatchEventBus(
          EventBusEvents.HEADER.ACCOUNT_DROPDOWN_MENU + "." + e.currentTarget.id,
          { menu: e.currentTarget.id }
        )
      );
      dispatchAmplitude({
        eventType: AMPLITUDE_EVENTS.SELECT_MENU,
        selection: EventBusEvents.HEADER.ACCOUNT_DROPDOWN_MENU,
        payload: { plan_name: e.currentTarget.id }
      });
    } else if (e.planName) {
      dispatch(
        dispatchEventBus(EventBusEvents.HEADER.ACCOUNT_DROPDOWN_MENU + "." + e.planName, {
          menu: e.planName
        })
      );
      dispatchAmplitude({
        eventType: AMPLITUDE_EVENTS.SELECT_MENU,
        selection: EventBusEvents.HEADER.ACCOUNT_DROPDOWN_MENU,
        payload: { plan_name: e.planName }
      });
    }
  };
  const setUrlAndDispatch = (event, submenu, account22, header22, nonSubMenuGroups, groupId) => {
    if (isPreventUrl(navMenu2, dispatch)) {
      const selectedGroupAccount = account22.activeGroupAccount;
      selectedGroupAccount.groupId = groupId;
      let url2 = "";
      if (account22.subMenu === void 0 && account22.siteName && account22.siteName.includes("empower-retail-pcap-ps-plus")) {
        url2 = account22.url;
      } else if (submenu.userAccountId) {
        url2 = submenu.url;
      } else {
        url2 = getUrlForNavItem(submenu, null, selectedGroupAccount, nonSubMenuGroups);
      }
      dispatch(preventNavigation(event, url2, header22));
    } else {
      if (account22.subMenu === void 0 && account22.siteName && account22.siteName.includes("empower-retail-pcap-ps-plus")) {
        account22.accountMenuList = accountMenuList;
      }
      let selectAccount = account22.currentAccount;
      if (groupId !== account22.currentAccount.groupId && account22.accountMenuList.length > 0) {
        selectAccount = find(account22.accountMenuList, function(actItem) {
          return actItem.groupId == groupId;
        });
      }
      const displayplName = selectAccount ? String(selectAccount.planName).replace(/\s/g, "_") : "";
      const displaySubmenuText = submenu && submenu.displayText ? String(submenu.displayText).replace(/\s/g, "_") : "";
      const selectedGroupAccount = {
        groupId: selectAccount.groupId,
        individualId: selectAccount.individualId
      };
      let url2 = "";
      if (account22.subMenu === void 0 && account22.siteName && account22.siteName.includes("empower-retail-pcap-ps-plus")) {
        url2 = account22.url;
      } else if (submenu && submenu.userAccountId) {
        url2 = submenu.url;
      } else {
        if (submenu !== null && submenu.transactionCode === "WNBAL" && submenu.subMenu[0] && submenu.subMenu[0].transactionCode === "WNBALA" && txnAccess.newBalancesViewEnabled) {
          submenu.subMenu[0].type = "nextGen";
          submenu.subMenu[0].url = "/#/";
        }
        url2 = getUrlForNavItem(submenu, null, selectedGroupAccount, nonSubMenuGroups);
      }
      const payload = {
        url: url2,
        title: submenu.displayText
      };
      dispatch(
        dispatchEventBus(
          EventBusEvents.HEADER.ACCOUNT_DROPDOWN_MENU + "." + displayplName + "." + displaySubmenuText,
          payload
        )
      );
      dispatchAmplitude({
        eventType: AMPLITUDE_EVENTS.SELECT_MENU,
        selection: `${EventBusEvents.HEADER.ACCOUNT_DROPDOWN_MENU}.${displaySubmenuText.replace(" ", "_")}`,
        payload: {
          plan_name: displayplName
        }
      });
      setTimeout(() => {
        accountDropdownMenuClick(
          submenu,
          selectedGroupAccount,
          nonSubMenuGroups,
          true,
          header22.accountOpenInProgress
        );
      }, 300);
    }
  };
  function closeMenuAndNavigate(setIsOpen2, setUrlAndDispatch2, e, submenu, account22, header22, navMenu22, activeGroupAccount, dispatch2) {
    setIsOpen2(false);
    checkIsAccountOpenFlow(() => {
      setUrlAndDispatch2(
        e,
        submenu,
        account22,
        header22,
        navMenu22.nonSubMenuGroups,
        activeGroupAccount.groupId
      );
    }, dispatch2);
  }
  const renderSingleAccountMenuList = (accountList) => {
    const activeGroupAccount = account2.activeGroupAccount;
    if (accountList && accountList.length === 1) {
      return accountList.map((accountItem) => {
        if (!isMobileBrowser()) {
          const navigationList = accountItem.subMenu;
          const userAccount = accountItem.userAccountId;
          return navigationList == null ? void 0 : navigationList.map((submenu = {}, menuIndx) => {
            if (userAccount) {
              submenu.userAccountId = userAccount;
            }
            submenu.isPlanItem = true;
            if (String(submenu.plName).indexOf("cxOpenAccount") > -1) {
              submenu.isPlanItem = false;
            }
            return /* @__PURE__ */ jsxRuntimeExports.jsx(
              "li",
              {
                className: "menu-item",
                onClick: handleClick2,
                role: "none",
                children: submenu.isPlanItem ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "a",
                  {
                    id: "menu-item-" + menuIndx,
                    className: "menu-item-link secondary-link ",
                    ...itemProps[menuIndx],
                    "aria-label": submenu.displayTxt,
                    tabIndex: "0",
                    onKeyDown: (e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        closeMenuAndNavigate(
                          setIsOpen,
                          setUrlAndDispatch,
                          e,
                          submenu,
                          account2,
                          header2,
                          navMenu2,
                          activeGroupAccount,
                          dispatch
                        );
                      }
                    },
                    onClick: (e) => {
                      closeMenuAndNavigate(
                        setIsOpen,
                        setUrlAndDispatch,
                        e,
                        submenu,
                        account2,
                        header2,
                        navMenu2,
                        activeGroupAccount,
                        dispatch
                      );
                    },
                    role: "menuitem",
                    children: submenu.displayText
                  }
                ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "a",
                  {
                    id: "menu-item-" + menuIndx,
                    className: "menu-item-link secondary-link ",
                    ...itemProps[menuIndx],
                    "aria-label": submenu.displayTxt,
                    tabIndex: "0",
                    onKeyDown: (e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        checkIsAccountOpenFlow(
                          () => handleMenuClick(submenu),
                          dispatch
                        );
                      }
                    },
                    onClick: () => {
                      checkIsAccountOpenFlow(
                        () => handleMenuClick(submenu),
                        dispatch
                      );
                    },
                    role: "menuitem",
                    children: submenu.displayText
                  }
                )
              },
              `${submenu.displayText}-${submenu.url}`
            );
          });
        }
      });
    }
  };
  const getSubMenuCls = (groupId, menuLength) => {
    return groupId === currentGroupId && menuLength > 0;
  };
  const getContextKey = (account22) => {
    return account22.individualId + "-" + account22.accuCode + "-" + account22.dbName;
  };
  const shouldAddSeparator = (accountList, accountItem, acctIndx) => {
    const nextAccount = accountList[acctIndx + 1];
    const currentAccount = accountItem;
    return nextAccount && (getContextKey(currentAccount) !== getContextKey(nextAccount) || (nextAccount == null ? void 0 : nextAccount.planName) === "cxOpenAccount");
  };
  function handleAccountSwitch(handleClick22, accountItem, setIsOpen2, dispatch2, closeAccountMenu2) {
    handleClick22(accountItem);
    setIsOpen2(false);
    checkIsAccountOpenFlow(() => {
      dispatch2(switchPlan(accountItem, null, closeAccountMenu2));
    }, dispatch2);
  }
  const renderMultipleAccountsMenuList = (accountList) => {
    if (accountList && accountList.length > 0) {
      return accountList.map((accountItem, acctIndx) => {
        const currentContext = accountItem.currentContext;
        if (!currentContext && ObjectUtil.isUndefinedOrNull(accountItem.plName)) {
          accountItem.plName = accountItem.displayText;
          accountItem.planName = accountItem.displayText;
        }
        accountItem.isPlanItem = true;
        if (!currentContext && ObjectUtil.isUndefinedOrNull(accountItem.groupId)) {
          accountItem.isPlanItem = false;
          accountItem.plName = accountItem.displayText;
        }
        const addSeparator = shouldAddSeparator(accountList, accountItem, acctIndx);
        if (!isMobileBrowser()) {
          return /* @__PURE__ */ jsxRuntimeExports.jsxs(
            React__default.Fragment,
            {
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "menu-item", onClick: handleClick2, role: "none", children: [
                  isEnrollmentPlan(accountItem.url) && !isEnrollmentPage() && currentContext && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "a",
                    {
                      className: "menu-item-link secondary-link remove-outline",
                      role: "menuitem",
                      ...itemProps[acctIndx],
                      "aria-label": `${accountItem.planName}${accountItem.subsetName ? accountItem.subsetName : ""}`,
                      tabIndex: "0",
                      onKeyDown: (e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          checkIsAccountOpenFlow(() => {
                            window.location.href = getUrlToEnroll(
                              accountItem.url
                            );
                          }, dispatch);
                        }
                      },
                      onClick: () => {
                        checkIsAccountOpenFlow(() => {
                          window.location.href = getUrlToEnroll(
                            accountItem.url
                          );
                        }, dispatch);
                      },
                      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                        MenuListItem,
                        {
                          planName: accountItem.planName,
                          subsetName: accountItem.subsetName
                        }
                      )
                    }
                  ),
                  isEnrollmentPlan(accountItem.url) && isEnrollmentPage() && currentContext && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "a",
                    {
                      className: "menu-item-link secondary-link remove-outline",
                      role: "menuitem",
                      ...itemProps[acctIndx],
                      "aria-label": `${accountItem.planName}${accountItem.subsetName ? accountItem.subsetName : ""}`,
                      tabIndex: "0",
                      onKeyDown: (e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          redirectEnrollmentPage(accountItem.url);
                        }
                      },
                      onClick: () => {
                        redirectEnrollmentPage(accountItem.url);
                      },
                      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                        MenuListItem,
                        {
                          planName: accountItem.planName,
                          subsetName: accountItem.subsetName
                        }
                      )
                    }
                  ),
                  !isEnrollmentPlan(accountItem.url) && currentContext && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IntegratedAccountMenuOption,
                    {
                      idNum: 0,
                      accountItem,
                      onAccountEnter,
                      onAccountClick,
                      acctIndx,
                      getSubMenuCls,
                      setUrlAndDispatch,
                      itemProps,
                      hasClicked,
                      setIsOpen
                    }
                  ),
                  !currentContext && accountItem.isPlanItem && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "a",
                    {
                      className: "menu-item-link secondary-link remove-outline",
                      role: "menuitem",
                      ...itemProps[acctIndx],
                      "aria-label": `${accountItem.planName}${accountItem.subsetName ? accountItem.subsetName : ""}`,
                      onMouseEnter: onAccountEnter,
                      tabIndex: "0",
                      onKeyDown: (e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          handleAccountSwitch(
                            handleClick2,
                            accountItem,
                            setIsOpen,
                            dispatch,
                            closeAccountMenu
                          );
                        }
                      },
                      onClick: () => {
                        handleAccountSwitch(
                          handleClick2,
                          accountItem,
                          setIsOpen,
                          dispatch,
                          closeAccountMenu
                        );
                      },
                      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                        MenuListItem,
                        {
                          planName: accountItem.plName,
                          subsetName: accountItem.subsetName
                        }
                      )
                    }
                  ),
                  !currentContext && !accountItem.isPlanItem && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "a",
                    {
                      className: "menu-item-link secondary-link remove-outline",
                      role: "menuitem",
                      ...itemProps[acctIndx],
                      "aria-label": `${accountItem.plName}${accountItem.subsetName ? accountItem.subsetName : ""}`,
                      onMouseEnter: onAccountEnter,
                      tabIndex: "0",
                      onKeyDown: (e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          checkIsAccountOpenFlow(
                            () => handleMenuClick(accountItem),
                            dispatch
                          );
                          setIsOpen(false);
                        }
                      },
                      onClick: () => {
                        checkIsAccountOpenFlow(
                          () => handleMenuClick(accountItem),
                          dispatch
                        );
                        setIsOpen(false);
                      },
                      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                        MenuListItem,
                        {
                          planName: accountItem.plName,
                          subsetName: accountItem.subsetName
                        }
                      )
                    }
                  )
                ] }),
                addSeparator && /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "menu-item menu-item--separator", role: "none" })
              ]
            },
            `${accountItem.groupId}-${accountItem.url}-${accountItem.displayText}`
          );
        }
      });
    }
  };
  const renderMultipleAcctsMenuListNoLIAT = (accountList) => {
    if (accountList && accountList.length > 0) {
      return accountList.map((accountItem, acctIndx) => {
        const currentContext = accountItem.currentContext;
        LogService$1.getLogger().debug("item: {0} - current context [{1}] , [{2}]", [
          JSON.stringify(accountItem),
          accountItem.currentContext,
          accountItem["currentContext"]
        ]);
        if (!currentContext && ObjectUtil.isUndefinedOrNull(accountItem.plName)) {
          accountItem.plName = accountItem.displayText;
          accountItem.planName = accountItem.displayText;
        }
        accountItem.isPlanItem = true;
        if (!currentContext && ObjectUtil.isUndefinedOrNull(accountItem.groupId)) {
          accountItem.isPlanItem = false;
          accountItem.plName = accountItem.displayText;
        }
        const addSeparator = shouldAddSeparator(accountList, accountItem, acctIndx);
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(
          React__default.Fragment,
          {
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: "menu-item", onClick: handleClick2, role: "none", children: [
                !isMobileBrowser() && isEnrollmentPlan(accountItem.url) && !isEnrollmentPage() && currentContext && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "a",
                  {
                    className: "menu-item-link secondary-link remove-outline",
                    role: "menuitem",
                    ...itemProps[acctIndx],
                    "aria-label": `${accountItem.planName}${accountItem.subsetName ? accountItem.subsetName : ""}`,
                    tabIndex: "0",
                    onKeyDown: (e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        checkIsAccountOpenFlow(() => {
                          window.location.href = getUrlToEnroll(
                            accountItem.url
                          );
                        }, dispatch);
                      }
                    },
                    onClick: () => {
                      checkIsAccountOpenFlow(() => {
                        window.location.href = getUrlToEnroll(
                          accountItem.url
                        );
                      }, dispatch);
                    },
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                      MenuListItem,
                      {
                        planName: accountItem.planName,
                        subsetName: accountItem.subsetName
                      }
                    )
                  }
                ),
                !isMobileBrowser() && isEnrollmentPlan(accountItem.url) && isEnrollmentPage() && currentContext && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "a",
                  {
                    className: "menu-item-link secondary-link remove-outline",
                    role: "menuitem",
                    ...itemProps[acctIndx],
                    "aria-label": `${accountItem.planName}${accountItem.subsetName ? accountItem.subsetName : ""}`,
                    tabIndex: "0",
                    onKeyDown: (e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        checkIsAccountOpenFlow(
                          () => redirectEnrollmentPage(accountItem.url),
                          dispatch
                        );
                      }
                    },
                    onClick: () => {
                      checkIsAccountOpenFlow(
                        () => redirectEnrollmentPage(accountItem.url),
                        dispatch
                      );
                    },
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                      MenuListItem,
                      {
                        planName: accountItem.planName,
                        subsetName: accountItem.subsetName
                      }
                    )
                  }
                ),
                !isMobileBrowser() && !isEnrollmentPlan(accountItem.url) && currentContext && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  IntegratedAccountMenuOption,
                  {
                    idNum: 1,
                    accountItem,
                    onAccountEnter,
                    onAccountClick,
                    acctIndx,
                    getSubMenuCls,
                    setUrlAndDispatch,
                    itemProps,
                    hasClicked,
                    setIsOpen
                  }
                ),
                !currentContext && accountItem.isPlanItem && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "a",
                  {
                    className: "menu-item-link secondary-link remove-outline",
                    role: "menuitem",
                    ...itemProps[acctIndx],
                    "aria-label": `${accountItem.planName}${accountItem.subsetName ? accountItem.subsetName : ""}`,
                    tabIndex: "0",
                    onMouseEnter: onAccountEnter,
                    onClick: () => {
                      setIsOpen(false);
                      checkIsAccountOpenFlow(
                        () => dispatch(
                          switchPlan(accountItem, null, closeAccountMenu)
                        ),
                        dispatch
                      );
                    },
                    onKeyDown: (e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setIsOpen(false);
                        checkIsAccountOpenFlow(
                          () => dispatch(
                            switchPlan(
                              accountItem,
                              null,
                              closeAccountMenu
                            )
                          ),
                          dispatch
                        );
                      }
                    },
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                      MenuListItem,
                      {
                        planName: accountItem.plName,
                        subsetName: accountItem.subsetName
                      }
                    )
                  }
                ),
                !currentContext && !accountItem.isPlanItem && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "a",
                  {
                    className: "menu-item-link secondary-link remove-outline",
                    role: "menuitem",
                    ...itemProps[acctIndx],
                    "aria-label": `${accountItem.plName}${accountItem.subsetName ? accountItem.subsetName : ""}`,
                    onMouseEnter: onAccountEnter,
                    tabIndex: "0",
                    onKeyDown: (e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        checkIsAccountOpenFlow(
                          () => handleMenuClick(accountItem),
                          dispatch
                        );
                        setIsOpen(false);
                      }
                    },
                    onClick: () => {
                      checkIsAccountOpenFlow(
                        () => handleMenuClick(accountItem),
                        dispatch
                      );
                      setIsOpen(false);
                    },
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                      MenuListItem,
                      {
                        planName: accountItem.plName,
                        subsetName: accountItem.subsetName
                      }
                    )
                  }
                )
              ] }),
              addSeparator && /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "menu-item menu-item--separator", role: "none" })
            ]
          },
          `${accountItem.groupId}-${accountItem.url}-${accountItem.displayText}`
        );
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    txnAccess.liatEnabled && /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "li",
      {
        id: "AccountMenu",
        className: `menu-item ${accountsIsActive() ? "active" : ""}`,
        role: "none",
        onClick: handleClick2,
        children: [
          !isMobileBrowser() && /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "a",
            {
              className: "menu-item-link",
              id: "AccountMenuLink",
              tabIndex: "0",
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  activateListDisplay(e);
                  toggleDesktopAccountMenu(e);
                }
              },
              onClick: (e) => {
                activateListDisplay(e);
                toggleDesktopAccountMenu(e);
              },
              "aria-label": myAccounts,
              ...buttonProps,
              role: "menuitem",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "menu-item-link__display-text", children: myAccounts }),
                " ",
                /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: `fa fa-solid fa-chevron-down` })
              ]
            }
          ),
          (accountMenuList.length > 1 && !isMobileBrowser() || isOnlyCxOpenAccountItem) && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "ul",
            {
              id: "AccountSubMenuLiat",
              role: "menu",
              "aria-label": translations.header.Accessibility.listOfPlans,
              className: `dropdown-menu dropdown-menu-arrow ${isOpen ? "visible" : ""}`,
              style: {
                display: `${isOpen ? "block" : "none"}`,
                visibility: `${isOpen ? "visible" : "hidden"}`
              },
              children: renderMultipleAccountsMenuList(accountMenuList)
            }
          ),
          accountMenuList.length === 1 && !isOnlyCxOpenAccountItem && !isEnrollmentPlan(accountMenuList[0].url) && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "ul",
            {
              className: `dropdown-menu dropdown-menu-arrow ${isOpen ? "visible" : ""}`,
              role: "menu",
              "aria-label": translations.header.Accessibility.listOfPlans,
              style: { display: `${isOpen ? "block" : "none"}` },
              children: renderSingleAccountMenuList(accountMenuList)
            }
          ),
          isMobileBrowser() && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              className: "menu-item-link overview",
              role: "menuitem",
              "aria-label": myAccounts,
              onClick: (event) => {
                toggleAccountMenu(event);
              },
              children: myAccounts
            }
          ),
          isMobileBrowser() && /* @__PURE__ */ jsxRuntimeExports.jsx(AccountMenuList, {})
        ]
      }
    ),
    !txnAccess.liatEnabled && /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "li",
      {
        id: "AccountMenuNoLiat",
        className: `menu-item ${accountsIsActive() ? "active" : ""}`,
        onClick: handleClick2,
        role: "none",
        children: [
          !isMobileBrowser() && /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "a",
            {
              className: "menu-item-link",
              id: "AccountMenuNoLiatLink",
              tabIndex: "0",
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  activateListDisplay(e);
                  toggleDesktopAccountMenu(e);
                }
              },
              onClick: (e) => {
                activateListDisplay(e);
                toggleDesktopAccountMenu(e);
              },
              "aria-label": myAccounts,
              ...buttonProps,
              role: "menuitem",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "menu-item-link__display-text", children: myAccounts }),
                " ",
                /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: `fa fa-solid fa-chevron-down` })
              ]
            }
          ),
          (accountMenuList.length > 1 && !isMobileBrowser() || isOnlyCxOpenAccountItem) && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "ul",
            {
              id: "AccountSubMenuNoLiat",
              className: `dropdown-menu dropdown-menu-arrow ${isOpen ? "visible" : ""}`,
              role: "menu",
              "aria-label": translations.header.Accessibility.listOfPlans,
              style: {
                display: `${isOpen ? "block" : "none"}`,
                visibility: `${isOpen ? "visible" : "hidden"}`
              },
              children: renderMultipleAcctsMenuListNoLIAT(accountMenuList)
            }
          ),
          accountMenuList.length === 1 && !isOnlyCxOpenAccountItem && !isEnrollmentPlan(accountMenuList[0].url) && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "ul",
            {
              className: `dropdown-menu dropdown-menu-arrow ${isOpen ? "visible" : ""}`,
              role: "menu",
              "aria-label": translations.header.Accessibility.listOfPlans,
              style: { display: `${isOpen ? "block" : "none"}` },
              children: renderSingleAccountMenuList(accountMenuList)
            }
          ),
          isMobileBrowser() && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              className: "menu-item-link overview",
              role: "menuitem",
              "aria-label": myAccounts,
              onClick: (event) => {
                toggleAccountMenu(event);
              },
              children: myAccounts
            }
          ),
          isMobileBrowser() && /* @__PURE__ */ jsxRuntimeExports.jsx(AccountMenuList, {})
        ]
      }
    )
  ] });
};
ExternalLogger$1.getInstance("adviceService");
const navigateToFESite = (activeGroupAccount) => {
  return () => {
    navigateFE(activeGroupAccount);
  };
};
const IntegratedFeature = ({
  id: id2,
  menuOption,
  showMenuDD,
  clickFunction,
  isNavMenuMobileOpen,
  handleToggleEventDispatch
}) => {
  const dispatch = useDispatch();
  const account2 = useSelector((state) => state.account);
  const navMenu2 = useSelector((state) => state.navMenu);
  const header2 = useSelector((state) => state.header);
  const itemCount = menuOption.subMenu.length > 0 ? menuOption.subMenu.length : 0;
  const { buttonProps, itemProps, hasClicked, isOpen, setIsOpen, buttonListener } = useDropdownMenu(itemCount);
  const txnAccess = useSelector((state) => state.header.txnAccess);
  const isInboundSSO = useSelector((state) => state.shared.authenticationStatus.inboundSSOUser);
  const InvestingID = 1406;
  useEffect(() => {
    setIsOpen(showMenuDD);
  }, [setIsOpen, showMenuDD]);
  useEffect(() => {
    if (hasClicked) {
      handleToggleEventDispatch({ menuItem: menuOption.displayText, showMenu: isOpen });
    }
  }, [handleToggleEventDispatch, hasClicked, isOpen, menuOption.displayText]);
  const buildPayloadForAnalytics = (event, eventBusAction, val) => {
    const value = val.menuOption ? val.menuOption : "";
    const payload = {
      value,
      eventBusAction
    };
    dispatch(dispatchEventBus(payload.eventBusAction, void 0, payload));
    dispatchAmplitude({
      eventType: AMPLITUDE_EVENTS.SELECT_MENU,
      selection: eventBusAction,
      payload: { value }
    });
  };
  const dataLayerPushHandler = (type, payload) => {
    const dataLayerobj = Object.assign(
      {
        "options.type": EventBusEvents.HEADER.NAV_DD_CLICK,
        "event.category": "click"
      },
      payload
    );
    DataLayer.push(type, dataLayerobj);
  };
  const handleMenuClick = (e, item) => {
    const displayName = String(item.displayText).replace(/\s/g, "_");
    const payload = {
      menuOption: displayName,
      url: ""
    };
    if (isPreventUrl(navMenu2, dispatch)) {
      dispatch(preventNavigation(e, item.id, header2));
      return;
    }
    e.preventDefault();
    setIsOpen(false);
    let isProfessionalMgmtUrl = false;
    let url2 = window.location.href;
    const isInvestingItem = InvestingID === item.id;
    if (isInboundSSO && txnAccess.investingSSOModal && isInvestingItem) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      dispatch(setActiveDeepLink(item.url));
      dispatch(openOrCloseSSOInvestingModal(true));
    } else {
      const isLocal = () => String(window.location.href).indexOf("localhost") > -1;
      const baseAcctUrl = isLocal() ? window.location.origin : "";
      const enrollInManagement = [
        "ENROLL IN PROFESSIONAL MANAGEMENT PROGRAM",
        "INSCRIBIRSE EN EL PROGRAMA DE GESTIÓN PROFESIONAL"
      ];
      const professionalManagementProgramNames = [
        "PROFESSIONAL MANAGEMENT PROGRAM",
        "PROGRAMA DE GESTIÓN PROFESIONAL"
      ];
      const onlineAdvice = ["ONLINE ADVICE", "ASESORÍA EN LÍNEA"];
      if ((professionalManagementProgramNames.includes(
        String(item.displayText).toUpperCase()
      ) || enrollInManagement.includes(String(item.displayText).toUpperCase()) || onlineAdvice.includes(String(item.displayText).toUpperCase())) && globalThis.integratedEligibility.isEmulator) {
        dispatch(
          setShowErrorModal({
            show: true,
            message: {
              body: ReferenceData.errorModal.PAE_MESSAGES[0].MSG
            },
            footer: {
              canShow: true,
              code: ReferenceData.errorModal.PAE_MESSAGES[0].CODE
            }
          })
        );
        isProfessionalMgmtUrl = true;
      } else if (professionalManagementProgramNames.includes(
        String(item.displayText).toUpperCase()
      ) || onlineAdvice.includes(String(item.displayText).toUpperCase())) {
        if (String(item.url).indexOf("femaSaml") > -1) {
          setIsOpen(false);
          dispatch(navigateToFESite(account2.activeGroupAccount));
        } else {
          url2 = baseAcctUrl + item.url;
          setIsOpen(false);
          payload.url = url2;
        }
        isProfessionalMgmtUrl = true;
      } else if (String(item.displayText).toUpperCase() === "HOME") {
        if (globalThis.integratedEligibility.homePageEligibility) {
          url2 = injectPcapApiParam(baseAcctUrl + item.url);
          payload.url = url2;
        }
      } else if (displayName === "Student_Debt_Solution") {
        url2 = baseAcctUrl + item.url;
        payload.url = url2;
        setIsOpen(false);
      } else if (displayName === "Investing_help") {
        url2 = baseAcctUrl + `/participant/accounts/#/retirement-income/allocations/selection`;
        payload.url = url2;
      } else {
        url2 = injectPcapApiParam(baseAcctUrl + item.url);
        payload.url = url2;
      }
    }
    const eventBusAction = EventBusEvents.HEADER.NAV_DD_CLICK + "." + displayName;
    buildPayloadForAnalytics(e, eventBusAction, payload);
    if (displayName === "Enroll_in_My_Total_Retirement") {
      dispatchAmplitude({
        eventType: AMPLITUDE_EVENTS.SELECT_MENU,
        selection: EventBusEvents.HEADER.ENROLL_IN_MY_TOTAL_RETIREMENT
      });
    }
    if (displayName === "Student_Debt_Solution" || displayName === "529_Plan_Finder") {
      window.open(url2, "_blank", "noopener,noreferrer");
    } else {
      dataLayerPushHandler(eventBusAction, payload);
    }
    showMenuDD = false;
    const customevent = new CustomEvent("collapseDropdown");
    document.dispatchEvent(customevent);
    e.stopPropagation();
    if (header2.accountOpenInProgress && !isInvestingItem && !isProfessionalMgmtUrl && url2.indexOf("participant/home/#") > -1) {
      setTimeout(() => {
        window.location.reload();
      }, 1e3);
    }
  };
  const renderSingleList = (menuList, itemProps2) => {
    if (menuList) {
      return menuList.map((submenu, subMenuIndx) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          "li",
          {
            tabIndex: "0",
            className: "menu-item",
            role: "menuitem",
            ...itemProps2[subMenuIndx],
            onClick: (e) => {
              if (showFeatureNotAvailableModal()) {
                featureNotAvailableModal(dispatch);
              } else {
                checkIsAccountOpenFlow(() => handleMenuClick(e, submenu), dispatch);
              }
            },
            "aria-label": submenu.displayText,
            onKeyDown: (e) => {
              if (e.key === "Enter" || e.key === " ") {
                if (showFeatureNotAvailableModal()) {
                  featureNotAvailableModal(dispatch);
                } else {
                  checkIsAccountOpenFlow(
                    () => handleMenuClick(e, submenu),
                    dispatch
                  );
                }
              }
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "a",
              {
                id: id2.toLowerCase() + "-menu-item-" + subMenuIndx,
                className: "menu-item-link secondary-link remove-outline",
                children: submenu.displayText
              }
            )
          },
          submenu.displayText + -+submenu.id ? submenu.id : submenu.url
        );
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "a",
      {
        id: id2.toLowerCase() + "-link",
        className: `menu-item-link ${isNavMenuMobileOpen ? "" : "submenu-hide-class"}`,
        ...buttonProps,
        onClick: (e) => {
          buttonListener(e);
        },
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            clickFunction(e, false);
          }
          buttonListener(e);
        },
        "aria-label": menuOption.displayText,
        role: "menuitem",
        tabIndex: 0,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "menu-item-link__display-text", children: menuOption.displayText }),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: `fa fa-solid fa-chevron-down` })
        ]
      }
    ),
    isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "ul",
      {
        role: "menu",
        className: `dropdown-menu dropdown-menu-arrow ${isOpen ? "visible" : ""}`,
        style: { display: `${isOpen ? "block" : "none"}` },
        children: renderSingleList(menuOption.subMenu, itemProps)
      }
    )
  ] });
};
const { isArrayEmpty } = ObjectUtil;
const IntegratedNavView = ({
  prevent,
  skipMainNavigation,
  toggleAccountMenu,
  closeMobileMenu,
  homeClickHandler,
  profileClickHandler,
  logoutClickHandler,
  translations,
  closeOtherDD,
  toggleUserDD,
  closeUserDD,
  hash
}) => {
  const dispatch = useDispatch();
  const header2 = useSelector((state) => state.header);
  const navMenu2 = useSelector((state) => state.navMenu);
  const [showOverviewDD, setShowOverviewDD] = useState(false);
  const [showBudgetDD, setShowBudgetDD] = useState(false);
  const [showInvestingDD, setShowInvestingDD] = useState(false);
  const [showPlanningDD, setShowPlanningDD] = useState(false);
  const [showAccountDD, setShowAccountDD] = useState(false);
  const [showLearningCtrDD, setShowLearningCtrDD] = useState(false);
  const [hasSelectedNav, setHasSelectedNav] = useState(false);
  const integratedNav = useMemo(
    () => navMenu2.integratedNavSettings,
    [navMenu2.integratedNavSettings]
  );
  const [mobileHeaderClass, setMobileHeaderClass] = useState("");
  const [logout2, setLogoutLbl] = useState("");
  const userName = header2.userProfile.firstName + " " + header2.userProfile.lastName;
  useEffect(() => {
    if (integratedNav) {
      document.addEventListener("collapseDropdown", handleClickDropDown);
    }
  }, [integratedNav]);
  const toggleNav = useCallback(() => {
    setShowOverviewDD(false);
    setShowBudgetDD(false);
    setShowInvestingDD(false);
    setShowPlanningDD(false);
    setShowLearningCtrDD(false);
    const selection = `${EventBusEvents.HEADER.MAIN_TOGGLE}.Account`;
    dispatch(dispatchEventBus(selection, { action: selection }));
    dispatchAmplitude({ eventType: AMPLITUDE_EVENTS.SELECT_BUTTON, selection });
  }, [dispatch]);
  useEffect(() => {
    if (closeOtherDD) {
      toggleNav();
    }
  }, [closeOtherDD, toggleNav]);
  useEffect(() => {
    if (showOverviewDD || showBudgetDD || showInvestingDD || showPlanningDD || showAccountDD || showLearningCtrDD) {
      if (!closeUserDD) {
        toggleUserDD(true);
      } else {
        toggleUserDD(false);
      }
    } else {
      toggleUserDD(false);
    }
  }, [
    showOverviewDD,
    showBudgetDD,
    showInvestingDD,
    showPlanningDD,
    showAccountDD,
    showLearningCtrDD,
    closeUserDD,
    toggleUserDD,
    hash
  ]);
  useEffect(() => {
    if (translations && translations.header && logout2 === "") {
      setLogoutLbl(translations.header.Logout);
    }
  }, [logout2, translations]);
  useEffect(() => {
    let result2 = navMenu2.mobileMenuActive ? "navbar-toggled" : "";
    result2 += " navbar-tier-" + navMenu2.activeMenuTier;
    setMobileHeaderClass(result2);
  }, [navMenu2.mobileMenuActive, navMenu2.activeMenuTier]);
  useEffect(() => {
    if (!navMenu2.navUpdated && translations && integratedNav) {
      const navDataUpdated = convertDisplayText(translations.header, integratedNav);
      dispatch(setNavUpdated(navDataUpdated));
      setTimeout(function() {
        document.querySelectorAll("[tabIndex]").forEach((e) => {
          e.addEventListener("focus", function() {
            this.style.outline = "none";
          });
          e.addEventListener("keyup", function(e2) {
            if (e2.which == 9) {
              this.style.outline = "";
            }
          });
        });
      }, 1e3);
    }
  }, [translations, integratedNav, navMenu2.navUpdated, dispatch]);
  const isActive = (subMenu) => {
    const hash2 = window.location.hash;
    if (!Array.isArray(subMenu)) {
      return false;
    }
    const isActive2 = subMenu.find((val) => {
      return val.url.indexOf(hash2) > -1;
    });
    return !!isActive2;
  };
  const clickLearningCtr = () => {
    const selection = `${EventBusEvents.HEADER.MAIN_TOGGLE}.Learning Center`;
    dispatch(dispatchEventBus(selection, { action: selection }));
    dispatchAmplitude({ eventType: AMPLITUDE_EVENTS.SELECT_BUTTON, selection });
    const redirectUrl = header2.educationCenterUrl;
    window.open(redirectUrl, "_blank");
  };
  const handleToggleEventDispatch = useCallback(
    ({ menuItem, showMenu }) => {
      const selection = `${EventBusEvents.HEADER.MAIN_TOGGLE}.${menuItem}`;
      dispatch(dispatchEventBus(selection, { action: selection }));
      dispatchAmplitude({
        eventType: AMPLITUDE_EVENTS.SELECT_BUTTON,
        selection,
        payload: typeof showMenu === "boolean" ? { show_menu: showMenu } : {}
      });
    },
    [dispatch]
  );
  const toggleMenu = (e, redirectTo, accuCode) => {
    const id2 = e.currentTarget.id;
    const mapTranslatedMenuOptions = {
      Overview: ["Overview_", "Resumen_"],
      Home: ["Home_", "Inicio_"],
      Budgeting: ["Budgeting_", "Elaboración_de_presupuestos_"],
      Investing: ["Investing_", "Inversión_"],
      Planning: ["Planning_", "Planificación_"],
      LearningCenter: ["Learning_Center_link", "Centro_de_aprendizaje_link"]
    };
    const menuOptionKey = Object.entries(mapTranslatedMenuOptions).reduce(
      (previous, [menuOption, menuTranslations]) => {
        return menuTranslations.includes(id2) ? menuOption : previous;
      },
      ""
    );
    switch (menuOptionKey) {
      case Object.keys(mapTranslatedMenuOptions)[0]:
        if (redirectTo && accuCode === "Empower") {
          homeClickHandler(e);
        } else {
          setShowOverviewDD(!showOverviewDD);
        }
        setShowBudgetDD(false);
        setShowInvestingDD(false);
        setShowPlanningDD(false);
        setShowAccountDD(false);
        setShowLearningCtrDD(false);
        setHasSelectedNav(true);
        break;
      case Object.keys(mapTranslatedMenuOptions)[1]:
        setShowOverviewDD(!showOverviewDD);
        setShowBudgetDD(false);
        setShowInvestingDD(false);
        setShowPlanningDD(false);
        setShowAccountDD(false);
        setShowLearningCtrDD(false);
        setHasSelectedNav(true);
        break;
      case Object.keys(mapTranslatedMenuOptions)[2]:
        setShowOverviewDD(false);
        setShowBudgetDD(!showBudgetDD);
        setShowInvestingDD(false);
        setShowPlanningDD(false);
        setShowAccountDD(false);
        setShowLearningCtrDD(false);
        setHasSelectedNav(true);
        break;
      case Object.keys(mapTranslatedMenuOptions)[3]:
        setShowOverviewDD(false);
        setShowBudgetDD(false);
        setShowInvestingDD(!showInvestingDD);
        setShowPlanningDD(false);
        setShowAccountDD(false);
        setShowLearningCtrDD(false);
        setHasSelectedNav(true);
        break;
      case Object.keys(mapTranslatedMenuOptions)[4]:
        setShowOverviewDD(false);
        setShowBudgetDD(false);
        setShowInvestingDD(false);
        setShowPlanningDD(!showPlanningDD);
        setShowAccountDD(false);
        setShowLearningCtrDD(false);
        setHasSelectedNav(true);
        break;
      case Object.keys(mapTranslatedMenuOptions)[5]:
        if (redirectTo) {
          clickLearningCtr();
        }
        setShowOverviewDD(false);
        setShowBudgetDD(false);
        setShowInvestingDD(false);
        setShowPlanningDD(false);
        setShowAccountDD(false);
        setShowLearningCtrDD(!showLearningCtrDD);
        setHasSelectedNav(true);
        break;
      default:
        setHasSelectedNav(false);
        break;
    }
    if (e.currentTarget.id === "toggleBtn") {
      dispatch(toggleMobileMenu(!navMenu2.mobileMenuActive));
      sessionStorage.setItem("currentMenuState", 0);
    }
    e.stopPropagation();
  };
  const handleClickDropDown = () => {
    setShowOverviewDD(false);
    setShowBudgetDD(false);
    setShowInvestingDD(false);
    setShowPlanningDD(false);
    setShowAccountDD(false);
    setShowLearningCtrDD(false);
  };
  const handleKeyDown = (event) => {
    handleKeyboardDownEvent({
      event,
      keys: keyboardInteractions.link,
      output: () => toggleMenu(event, true, header2.accu)
    });
  };
  const renderNavItems = (navList) => {
    if (navList) {
      const list = navList;
      return list.map((item, index2) => {
        const lblText = String(item.displayText).replace(/\s/g, "_") + "_";
        let showMenuDD = showOverviewDD;
        switch (index2) {
          case 0:
            showMenuDD = showOverviewDD;
            break;
          case 1:
            showMenuDD = showAccountDD;
            break;
          case 2:
            showMenuDD = showBudgetDD;
            break;
          case 3:
            showMenuDD = showInvestingDD;
            break;
          case 4:
            showMenuDD = showPlanningDD;
            break;
          case 5:
            showMenuDD = showLearningCtrDD;
            break;
          default:
            showMenuDD = showOverviewDD;
            break;
        }
        if (index2 === 1) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            IntegratedAccountSubmenu,
            {
              toggleAccountMenu,
              accountMenuList: item.subMenu,
              translations,
              toggleUserDD,
              toggleNav,
              hasSelectedNav,
              setHasSelectedNav
            },
            item.displayText + item.id
          );
        } else if (Array.isArray(item.subMenu) && !isArrayEmpty(item.subMenu)) {
          const active = isActive(item.subMenu) ? "active" : "";
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            "li",
            {
              id: lblText,
              className: `menu-item  ${active}`,
              role: "none",
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                IntegratedFeature,
                {
                  menuOption: item,
                  showMenuDD,
                  id: lblText,
                  clickFunction: toggleMenu,
                  handleToggleEventDispatch,
                  isNavMenuMobileOpen: navMenu2.mobileMenuActive
                }
              )
            },
            item.displayText + item.id
          );
        } else {
          if (String(item.displayText).toUpperCase() === "LEARNING CENTER" || String(item.displayText).toUpperCase() === "CENTRO DE APRENDIZAJE") {
            const displayText = translations.header.LearningCenter;
            if (!header2.txnAccess.dnpSSOEnabled && !header2.txnAccess.wellnessEnabled) {
              return /* @__PURE__ */ jsxRuntimeExports.jsx(
                "li",
                {
                  id: lblText,
                  className: `menu-item ${isActive(index2) ? "active" : ""}`,
                  onClick: () => handleToggleEventDispatch({
                    menuItem: item.displayText
                  }),
                  role: "none",
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "a",
                    {
                      id: `${lblText}link`,
                      className: "menu-item-link overview",
                      onClick: (e) => toggleMenu(e, true, header2.accu),
                      onKeyDown: handleKeyDown,
                      "aria-label": item.displayText,
                      role: "menuitem",
                      tabIndex: "0",
                      children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "menu-item-link__display-text", children: displayText })
                    }
                  )
                },
                item.displayText + item.id
              );
            }
          }
        }
      });
    }
  };
  const handleCloseMobileMenu = () => {
    closeMobileMenu();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("nav", { className: "main-nav navbar-default", "aria-label": "header navigation", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        href: "",
        className: "sr-only sr-only-focusable",
        "aria-label": "skip main navigation",
        onClick: skipMainNavigation,
        children: "Skip main navigation"
      }
    ),
    isMobileBrowser() && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "plan-messaging-nav-menu", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      HeaderPlanMessaging,
      {
        slides: header2.planMessagingSlides,
        watchDepth: "reference",
        navMenu: navMenu2,
        prevent,
        translations,
        onViewAllPrevent: navMenu2.onViewAllPrevent
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        id: "toggleBtn",
        className: "navbar-toggle",
        "aria-controls": "main-nav",
        "aria-haspopup": "true",
        "aria-expanded": navMenu2.mobileMenuActive,
        onClick: (event) => toggleMenu(event),
        type: "button",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: "Toggle navigation" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-bar" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-bar" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "icon-bar" })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `main-nav-menu navbar-section ${mobileHeaderClass}`, id: "main-nav", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          id: "closeBtn",
          role: "button",
          className: "navbar-toggle navbar-toggle-close",
          onClick: closeMobileMenu,
          "aria-label": "Close mobile menu",
          children: "×"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "middle-nav nav navbar-nav integrated-nav-text", role: "menubar", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
        renderNavItems(integratedNav),
        isMobileBrowser() && /* @__PURE__ */ jsxRuntimeExports.jsx("li", { id: "nav-user", className: "menu-item", role: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            title: userName,
            id: "navMenuUserProfileName",
            onClick: profileClickHandler,
            children: userName
          }
        ) }, userName),
        isMobileBrowser() && /* @__PURE__ */ jsxRuntimeExports.jsx("li", { id: "ppt-logout", className: "menu-item", role: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            "aria-haspopup": "true",
            "aria-expanded": "false",
            onClick: logoutClickHandler,
            title: "Log out",
            children: logout2
          }
        ) })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: `navbar-mobile-overlay ${mobileHeaderClass}`,
        onClick: handleCloseMobileMenu,
        role: "button",
        tabIndex: "0",
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleCloseMobileMenu();
          }
        }
      }
    )
  ] }) });
};
const NavMenuView = ({ prevent, translations, closeOtherDD, toggleUserDD, closeUserDD }) => {
  const dispatch = useDispatch();
  const header2 = useSelector((state) => state.header);
  const navMenu2 = useSelector((state) => state.navMenu);
  const txnAccess = useSelector((state) => state.header.txnAccess);
  const account2 = useSelector((state) => state.account);
  const allAccounts = useSelector((state) => state.account.accountSummaryList);
  const preLoginText = translations && translations.header ? translations.PreloginText : null;
  const planSponsorLinkContent = translations && translations.header ? translations.planSponsorLinkContent : null;
  const urlPscPath = useSelector((state) => state.header.urlPscPath);
  const activeGroupAccount = useSelector((state) => state.account.activeGroupAccount);
  const [isInitDone, setIsInitDone] = useState(false);
  const initialLoadedHref = window.location.href;
  const customEvent2 = new CustomEvent$1("skipNavigationCheck");
  const [hash, setHash] = useState("");
  const homeClickHandler = useCallback(
    (event) => {
      dispatch(dispatchEventBus(EventBusEvents.HEADER.MAIN_TOGGLE + ".Home"));
      let redirectUrl = ReferenceData.PARTICIPANT_OVERVIEW_URL;
      if (txnAccess.liatEnabled || globalThis.integratedEligibility.homePageEligibility) {
        if (globalThis.integratedEligibility.homePageEligibility) {
          redirectUrl = ReferenceData.INTEGRATED_DASHBOARD;
        }
      }
      if (isPreventUrl(navMenu2, dispatch)) {
        dispatch(preventNavigation(event, "LIAT_HOME", header2));
      } else {
        if (navMenu2.accountMenuActive) {
          return;
        }
        const url2 = window.location.href;
        let transition = true;
        let statesToCheck = ReferenceData.ROUTES_TO_CHECK;
        if (url2.indexOf("dashboard") > -1 && url2.indexOf("/retirement-income") === -1) {
          statesToCheck = statesToCheck.splice(0, 1);
          if (document.querySelectorAll("#sidebar .hidden") && document.getElementById("sidebar") !== null) {
            document.getElementById("sidebar").classList.remove("hidden");
          }
        }
        let re;
        const leading = /^.*/;
        const noTrailingSlash = /[^/]*$/;
        for (let i = 0; i < statesToCheck.length; i++) {
          re = new RegExp(leading.source + statesToCheck[i] + noTrailingSlash.source);
          if (re.test(url2)) {
            transition = false;
            break;
          }
        }
        if (transition) {
          const currentUrl = window.location.href;
          if (currentUrl.indexOf("nqEnrollment") > -1) {
            window.location.href = currentUrl;
          } else {
            window.location.href = redirectUrl;
          }
          if (header2.accountOpenInProgress) {
            setTimeout(() => {
              window.location.reload();
            }, 1e3);
          }
        }
      }
    },
    [dispatch, header2, navMenu2, txnAccess.liatEnabled]
  );
  const closeMobileView = useCallback(() => {
    dispatch(setAccountMenuActive(false));
    dispatch(setMobileMenuActiveSetting(false));
    dispatch(inactivate());
  }, [dispatch]);
  const openWellnessPage = useCallback(
    (event) => {
      if (isPreventUrl(navMenu2, dispatch)) {
        dispatch(preventNavigation(event, "WELLNESS", header2));
      } else {
        dispatch(dispatchEventBus(EventBusEvents.HEADER.WELLNESS, event));
        if (navMenu2.accountMenuActive) {
          closeMobileView();
          return;
        }
        window.location.href = ReferenceData.PARTICIPANT_APP_URL + "/#/wellness";
      }
    },
    [closeMobileView, dispatch, header2, navMenu2]
  );
  useEffect(() => {
    document.addEventListener("keyup", function(event) {
      if (event.key === "Enter") {
        switch (event.target.id) {
          case "HomeNonIntegMenu": {
            homeClickHandler();
            break;
          }
          case "FinancialNonIntegMenu": {
            openWellnessPage();
            break;
          }
        }
      }
    });
  }, [homeClickHandler, openWellnessPage]);
  useEffect(() => {
    if (!isInitDone && allAccounts && header2.authenticationStatus.authenticated) {
      if (allAccounts && allAccounts.length > 0) {
        const contextData = {};
        const nonCurrentContextNums = {};
        const nonCurrentcontenxtPlanName = {};
        allAccounts.forEach((item) => {
          const contextKey = item.individualId + "-" + item.accuCode;
          if (item.currentContext && allAccounts.length > 1 && activeGroupAccount.individualId && item.individualId && activeGroupAccount.individualId != item.individualId) {
            item.currentContext = false;
          }
          if (item.currentContext) {
            const displayPlanName = item.name;
            if (displayPlanName && displayPlanName.length > 80) {
              item.contextPlanName = displayPlanName.slice(0, 80) + "…";
            }
            contextData[contextKey] = item.contextPlanName;
          } else {
            if (contextData[contextKey]) {
              if (nonCurrentContextNums[contextKey] < 3) {
                const concatenatedPlanName = contextData[contextKey] + ", " + (checkCharCount(item.name, 26) ? item.name.slice(0, 26) + "…" : item.name);
                contextData[contextKey] = concatenatedPlanName;
                nonCurrentContextNums[contextKey]++;
              }
            } else {
              contextData[contextKey] = checkCharCount(item.name, 26) ? item.name.slice(0, 26) + "…" : item.name;
              nonCurrentContextNums[contextKey] = 1;
              nonCurrentcontenxtPlanName[contextKey] = item.name;
            }
          }
        });
        allAccounts.forEach((item) => {
          if (item.currentContext) {
            item.contextPlanName = item.name.length > 80 ? item.name.slice(0, 80) + "…" : item.name;
          } else {
            const contextKey = item.individualId + "-" + item.accuCode;
            if (nonCurrentContextNums[contextKey] && nonCurrentContextNums[contextKey] == 1) {
              contextData[contextKey] = checkCharCount(
                nonCurrentcontenxtPlanName[contextKey],
                80
              ) ? nonCurrentcontenxtPlanName[contextKey].slice(0, 80) + "…" : nonCurrentcontenxtPlanName[contextKey];
            }
            const planName = contextData[contextKey];
            item.contextPlanName = planName;
            delete contextData[contextKey];
          }
        });
        if (!account2.accountSummaryListLoaded) {
          dispatch(setAccountSummaryList(allAccounts));
        }
        dispatch(getTotalRewards());
      }
      setIsInitDone(true);
    }
  }, [
    isInitDone,
    allAccounts,
    header2.authenticationStatus.authenticated,
    account2.accountSummaryListLoaded,
    dispatch,
    activeGroupAccount.individualId
  ]);
  useEffect(() => {
    if (header2.authenticationStatus.authenticated || header2.authenticationStatus.partialAuth) {
      dispatch(retrieveSiteContactInfo());
    }
  }, [
    dispatch,
    header2.authenticationStatus.authenticated,
    header2.authenticationStatus.partialAuth
  ]);
  useEffect(() => {
    const handleHashChange = () => {
      setHash(window.location.hash);
    };
    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);
  const toggleMenu = (evt) => {
    if (evt.currentTarget.id === "toggleBtn") {
      dispatch(toggleMobileMenu(!navMenu2.mobileMenuActive));
      sessionStorage.setItem("currentMenuState", 0);
    }
  };
  const skipMainNavigation = (e) => {
    if (initialLoadedHref.indexOf("dashboard")) {
      document.querySelector("#main-page").setAttribute("tabindex", -1);
      document.querySelector("#main-page").addEventListener("blur", function() {
        this.removeAttribute("tabindex");
      });
      document.querySelector("#main-page").addEventListener("focusout", function() {
        this.removeAttribute("tabindex");
      });
      document.querySelector("#main-page").focus();
    }
    document.dispatchEvent(customEvent2);
    e.stopPropagation();
    e.preventDefault();
  };
  const closeMobileMenu = () => {
    closeMobileView();
  };
  const toggleAccountMenu = (e) => {
    if (isMobileBrowser()) {
      dispatch(setAccountMenuActive(!navMenu2.accountMenuActive));
    }
    e.stopPropagation();
  };
  const profileClickHandler = (event) => {
    if (isPreventUrl(navMenu2, dispatch)) {
      dispatch(preventNavigation(event, "PROFILE", header2));
    } else {
      const profileUrl = "/home/#/settings/profile";
      const eventBusPayload = { action: "updateProfile" };
      closeMobileView();
      dispatch(dispatchEventBus(EventBusEvents.HEADER.PROFILE, eventBusPayload));
      dispatchAmplitude({
        eventType: AMPLITUDE_EVENTS.SELECT_LINK,
        selection: EventBusEvents.HEADER.PROFILE,
        payload: eventBusPayload
      });
      window.location.href = `${ReferenceData.LOGIN_APP_URL}${profileUrl}`;
    }
  };
  const logoutClickHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isPreventUrl(navMenu2, dispatch)) {
      dispatch(preventNavigation(e, "LOGOUT", header2));
    } else {
      dispatch(logout());
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    !header2.authenticationStatus.authenticated && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "", className: "sr-only sr-only-focusable", onClick: skipMainNavigation, children: "Skip main navigation" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "site-tagline", children: preLoginText }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "header-secondary-nav", children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "nav navbar-nav", children: /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: "plan-sponsor", href: urlPscPath, children: planSponsorLinkContent }) }) }) })
    ] }),
    header2.authenticationStatus.authenticated && /* @__PURE__ */ jsxRuntimeExports.jsx(
      IntegratedNavView,
      {
        skipMainNavigation,
        prevent,
        toggleMenu,
        toggleAccountMenu,
        closeMobileMenu,
        homeClickHandler: (e) => checkIsAccountOpenFlow(() => homeClickHandler(e), dispatch),
        profileClickHandler,
        logoutClickHandler,
        translations,
        closeOtherDD,
        toggleUserDD,
        closeUserDD,
        hash
      }
    )
  ] });
};
const PreInitHeader = ({ header: header2 }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (!header2.txnAccess.txnAccessLoaded) {
      dispatch(getTransactionAccess());
    }
  }, [dispatch, header2.txnAccess.txnAccessLoaded]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, {});
};
PreInitHeader.propTypes = {
  header: PropTypes.object.isRequired
};
const pcapServiceRequest = async ({ baseUrl, method, endpoint, csrf }) => {
  const formData = new FormData();
  formData.append("csrf", csrf);
  const response = await axios({
    method,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    url: `${isLocalhost() ? "" : baseUrl}${endpoint}`,
    data: formData,
    withCredentials: true
  });
  return response;
};
const getFunnelAttributes = async ({
  baseUrl,
  csrf
}) => {
  const response = await pcapServiceRequest({
    baseUrl,
    method: "POST",
    endpoint: ReferenceData.PC_API.FUNNEL_ATTRIBUTES.GET_FUNNEL_ATTRIBUTES,
    csrf
  });
  return response.data;
};
const QUERY_KEYS = {
  GET_ACCOUNT_DETAILS: "getAccountDetails",
  GET_ACCOUNT_CUSTOMIZATION: "getAccountCustomization",
  GET_ACCOUNTS_2_LIST: "getAccounts2List",
  GET_FUNNEL_DATA: "getFunnelData",
  GET_POST_SAML_RESPONSE: "getPostSamlResponse",
  GET_MTR_DETAILS: "getMADetails",
  GET_PRIMARY_PLAN: "getPrimaryPlan",
  GET_TOP_NAV_LINKS: "getTopNavLinks",
  GET_TXN_ACCESS: "getTxnAccess",
  GET_NQ_ENROLL_ELIGIBILITY: "getNQEnrollEligibility",
  GET_ACCOUNT_SUMMARY: "getAccountSummary"
};
const useGetFunnelAttributes = ({ csrf }) => {
  const baseUrl = globalThis.integratedEligibility.postOriginUrl;
  const results = useQuery(
    {
      queryKey: [QUERY_KEYS.GET_FUNNEL_DATA, csrf, baseUrl],
      queryFn: csrf ? async () => {
        const response = await getFunnelAttributes({ csrf, baseUrl });
        return response.spData;
      } : skipToken,
      enabled: !!csrf && !!baseUrl
    },
    coreQueryClient
  );
  return results;
};
const Dropdown = ({
  id: id2,
  mainMenuList,
  secondaryMenuList,
  primaryMenuItemName,
  secondaryMenuItemName,
  showMenuDD,
  hasSubMenuList,
  isComponentVisible,
  onClick
}) => {
  const handleMenuClick = (_2, item) => {
    if (window.history) {
      window.history.pushState(
        "",
        document.title,
        window.location.href.replace(window.location.hash, "")
      );
      window.history.pushState(
        "",
        document.title,
        window.location.href.replace(window.location.search, "")
      );
    } else {
      window.location.hash = "";
      window.location.search = "";
    }
    if (onClick) onClick(item);
    const url2 = window.location.href;
    let transition = true;
    const statesToCheck = ReferenceData.ROUTES_TO_CHECK;
    let re;
    const leading = /^.*/;
    const noTrailingSlash = /[^/]*$/;
    for (let i = 0; i < statesToCheck.length; i++) {
      re = new RegExp(leading.source + statesToCheck[i] + noTrailingSlash.source);
      if (re.test(url2)) {
        transition = false;
        break;
      }
    }
    if (transition) {
      window.location.href = item.url;
    }
    showMenuDD = false;
  };
  const handleSubMenuClick = () => {
  };
  const onMouseEnter = () => {
  };
  const renderSingleList = (menuList) => {
    if (menuList && menuList.length > 0) {
      return menuList.map((item) => {
        const ariaLabelText = String(item[primaryMenuItemName]).replace(/\s/g, "-");
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          "li",
          {
            id: ariaLabelText,
            role: "none",
            className: "menu-item",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "a",
              {
                className: "menu-item-link secondary-link",
                href: item.url,
                role: "menuitem",
                "aria-label": item[primaryMenuItemName],
                onClick: (e) => handleMenuClick(e, item),
                ...item == null ? void 0 : item.itemProps,
                children: item[primaryMenuItemName]
              }
            )
          },
          item[primaryMenuItemName]
        );
      });
    }
  };
  const renderSubMenu = (subMenuList) => {
    if ((subMenuList == null ? void 0 : subMenuList.length) > 0) {
      return subMenuList.map((submenu) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "menu-item", role: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            className: "menu-item-link secondary-link",
            role: "menuitem",
            "aria-label": submenu[secondaryMenuItemName],
            onClick: handleSubMenuClick,
            children: submenu[secondaryMenuItemName]
          }
        ) }, submenu[secondaryMenuItemName]);
      });
    } else {
      return null;
    }
  };
  const renderMultipleList = (menuList) => {
    if (menuList && menuList.length > 0) {
      return menuList.map((item, menuIndx) => {
        const ariaLabelText = String(item[primaryMenuItemName]).replace(/\s/g, "-");
        const secondaryList = item[secondaryMenuList];
        return /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { id: ariaLabelText, role: "none", className: "menu-item", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              className: "menu-item-link secondary-link dropdown-toggle",
              "data-toggle": "dropdown",
              role: "menuitem",
              "aria-label": item[primaryMenuItemName],
              onMouseEnter,
              children: item[primaryMenuItemName]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "ul",
            {
              id: item[ariaLabelText] + "submenu" + menuIndx,
              className: "sub-menu dropdown-menu",
              role: "menu",
              children: renderSubMenu(secondaryList)
            }
          )
        ] }, ariaLabelText);
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    isComponentVisible && !hasSubMenuList && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "ul",
      {
        id: id2,
        role: "menu",
        className: "dropdown-menu dropdown-menu-arrow ",
        style: { display: `${showMenuDD ? "block" : "none"}` },
        children: renderSingleList(mainMenuList)
      }
    ),
    isComponentVisible && hasSubMenuList && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "ul",
      {
        id: id2,
        "aria-labelledby": id2,
        "aria-expanded": "true",
        role: "listbox",
        className: "dropdown-menu dropdown-menu-arrow ",
        style: { display: `${showMenuDD ? "block" : "none"}` },
        children: renderMultipleList(mainMenuList)
      }
    )
  ] });
};
const getGroupTxnAccess = (individualId, planId, txnCodes) => {
  const getGroupTxnAccessResult = function(result2) {
    if (ObjectUtil.isUndefinedOrNull(result2) || ObjectUtil.isUndefinedOrNull(result2.data)) {
      return null;
    } else {
      return result2.data;
    }
  };
  const params = {
    txnCodes,
    individualId,
    groupId: planId
    // the primary plan's ID is the group ID
  };
  const url2 = StringUtil$1.supplant(ReferenceData.GET_GROUP_TXN_ACCESS, params);
  const updatedUrl = "" + url2;
  return executeGet(updatedUrl, "getGroupTxnAccessFault").then(getGroupTxnAccessResult).catch((err) => {
    console.log("Error in getGroupTxnAccess: ", err);
    throw err;
  });
};
const useGroupTxnAccess = ({ individualId, planId, txnCodes }) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const fetchGroupTxnAccess = async () => {
      try {
        setIsLoading(true);
        const access = await getGroupTxnAccess(individualId, planId, txnCodes);
        setData(access);
      } catch (error) {
        setData(null);
      } finally {
        setIsLoading(false);
      }
    };
    fetchGroupTxnAccess();
  }, [individualId, planId, txnCodes]);
  return { data, isLoading };
};
const CUSTOMER_WEB_SEARCH_TXN_CODE = "CXASN";
const DNP_SSO_ENABLED = "WNDNPS";
const WELNESS_ENABLED = "WNWLNS";
const useSearchEnabled = ({ individualId, groupId, productId }) => {
  var _a2, _b2, _c2;
  const { data: groupTxnAccessData } = useGroupTxnAccess({
    individualId,
    planId: groupId,
    txnCodes: [CUSTOMER_WEB_SEARCH_TXN_CODE, DNP_SSO_ENABLED, WELNESS_ENABLED].join(",")
  });
  const isSearchEnabled = ((_a2 = groupTxnAccessData == null ? void 0 : groupTxnAccessData[CUSTOMER_WEB_SEARCH_TXN_CODE]) == null ? void 0 : _a2.toString()) === "true";
  if (!isSearchEnabled) {
    return { enabled: false };
  }
  const isLearningCenterEnabled = ((_b2 = groupTxnAccessData == null ? void 0 : groupTxnAccessData[DNP_SSO_ENABLED]) == null ? void 0 : _b2.toString()) === "false" && ((_c2 = groupTxnAccessData == null ? void 0 : groupTxnAccessData[WELNESS_ENABLED]) == null ? void 0 : _c2.toString()) === "false";
  if (isLearningCenterEnabled) {
    return { enabled: false };
  }
  const isEnrollmentPage = window.location.href.indexOf("/participant/enroll/") !== -1;
  if (isEnrollmentPage) {
    if (productId.includes("NQDC") || productId.includes("NQSP")) {
      return { enabled: true };
    }
    return { enabled: false };
  }
  return { enabled: true };
};
const getPlanDetails = (accountSummaryList) => {
  const defaultPlanDetails = {
    individualId: "",
    groupId: "",
    productId: ""
  };
  const currentPlan = accountSummaryList == null ? void 0 : accountSummaryList.find((account2) => {
    return window.location.href.includes(account2 == null ? void 0 : account2.accountURL);
  });
  if (currentPlan) {
    return {
      individualId: currentPlan.individualId,
      groupId: currentPlan.groupId,
      productId: currentPlan.productId
    };
  } else {
    return defaultPlanDetails;
  }
};
const { isUndefinedOrNull: isUndefinedOrNull$1 } = ObjectUtil;
const LanguagePickerContent = ({
  availableLanguages,
  footer,
  onSelect,
  selectedLanguage,
  siteContactInfo: siteContactInfo2,
  title,
  trnsltWbTrnCode = true
}) => {
  const [firstParagraph, setFirstParagraph] = useState("");
  const [secondParagraph, setSecondParagraph] = useState("");
  useEffect(() => {
    const modalContentText = {
      SPN: {
        firstParagraph: {
          noTrnsltWb: () => /* @__PURE__ */ jsxRuntimeExports.jsx("p", { lang: "es", children: "Salvar su preferencia de idioma como español actualizará sus estados de cuenta para incluir contenido en inglés y español. Puede actualizar su preferencia de idioma en cualquier momento." }),
          trnsltWb: () => /* @__PURE__ */ jsxRuntimeExports.jsx("p", { lang: "es", children: "Salvar su preferencia de idioma como español actualizará sus estados de cuenta y el sitio web para incluir contenido en inglés y español. Puede actualizar su preferencia de idioma en cualquier momento." })
        },
        secondParagraph: () => /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { lang: "es", children: [
          "Si necesita más ayuda, por favor llame a nuestro centro de servicio al",
          " ",
          siteContactInfo2.phone,
          " y solicite un representante de habla hispana."
        ] })
      },
      ENG: {
        firstParagraph: {
          noTrnsltWb: () => {
            const rowOne = "Saving_your_language_preference_as_English_will_update_your_";
            const rowTwo = "statements_to_be_in_English._You_can_update_your_language_preference_";
            const rowThree = "at_any_time.";
            return /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { lang: "en", children: [
              rowOne.replace(/_/g, " "),
              rowTwo.replace(/_/g, " "),
              rowThree.replace(/_/g, " ")
            ] });
          },
          trnsltWb: () => {
            const rowOne = "Saving_your_language_preference_as_English_will_update_your_";
            const rowTwo = "statements_and_the_website_to_be_in_English._You_can_update_your_";
            const rowThree = "language_preference_at_any_time.";
            return /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { lang: "en", children: [
              rowOne.replace(/_/g, " "),
              rowTwo.replace(/_/g, " "),
              rowThree.replace(/_/g, " ")
            ] });
          }
        },
        secondParagraph: () => {
          const rowOne = "If_you_require_further_assistance,_you_can_call_our_service_center_";
          const rowTwo = "and_request_to_speak_with_a ";
          return /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { lang: "en", children: [
            rowOne.replace(/_/g, " "),
            "at ",
            siteContactInfo2.phone,
            " ",
            rowTwo.replace(/_/g, " "),
            "representative."
          ] });
        }
      }
    };
    const modalLangText = modalContentText[selectedLanguage];
    const trnsltWbTxt = trnsltWbTrnCode ? "trnsltWb" : "noTrnsltWb";
    setFirstParagraph(modalLangText.firstParagraph[trnsltWbTxt]);
    setSecondParagraph(modalLangText.secondParagraph);
  }, [selectedLanguage, siteContactInfo2.phone, trnsltWbTrnCode]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modal-header", children: /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { id: "language-dialog-title", children: title }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "modal-well with-background", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "row", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-xs-12", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "select",
        {
          id: "selectedLanguagePreference",
          onChange: (event) => {
            onSelect(event.target.value);
          },
          value: selectedLanguage,
          className: "form-control dropdown",
          children: availableLanguages.map((l) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: l.code, children: l.label }, l.code))
        }
      ) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "panel panel-default", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "panel-body", style: { padding: 10 }, children: [
        firstParagraph,
        secondParagraph
      ] }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modal-footer", children: footer })
  ] });
};
const LanguagePicker = ({
  availableLanguages,
  currentLanguage,
  handleClose,
  siteContactInfo: siteContactInfo2,
  onDismiss,
  onSave,
  show
}) => {
  const [lang, setLang] = useState(null);
  React__default.useEffect(() => {
    if (currentLanguage) {
      setLang(currentLanguage === LANGUAGES.SPN ? LANGUAGES.ENG : LANGUAGES.SPN);
    }
  }, [currentLanguage]);
  if (isUndefinedOrNull$1(currentLanguage)) return null;
  const isSpanishSelected = lang === "SPN";
  const title = isSpanishSelected ? "Idioma" : "Language";
  const LanguagePickerFooter = ({ onSave: onSave2, selectedLanguage }) => {
    const save = "S_ave";
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          type: "button",
          className: "btn btn-link btn-dismiss",
          onClick: () => onDismiss(),
          children: selectedLanguage === "SPN" ? "Cancelar" : "Cancel"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "btn btn-primary", onClick: () => onSave2(lang), children: selectedLanguage === "SPN" ? "Guardar" : save.replace("_", "") })
    ] });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CoreUIModal,
    {
      content: /* @__PURE__ */ jsxRuntimeExports.jsx(
        LanguagePickerContent,
        {
          availableLanguages,
          selectedLanguage: lang,
          onSelect: (newLang) => {
            setLang(newLang);
          },
          siteContactInfo: siteContactInfo2,
          footer: /* @__PURE__ */ jsxRuntimeExports.jsx(LanguagePickerFooter, { onSave: () => onSave(lang), selectedLanguage: lang }),
          title
        }
      ),
      handleClose,
      show,
      ariaLabelledBy: "language-dialog-title"
    }
  );
};
const oldestDate = DateUtil$1.subtractFromDate(180, "days");
const TopHeader = ({
  loginAppURL,
  prevent,
  translations,
  toggleOtherDD,
  closeUserDD,
  toggleUserDD,
  onSearchClick,
  isUISearchVisible,
  ToggleSearchButton,
  ariaSearchBoxMsg
}) => {
  var _a2, _b2;
  const [headerTranslations] = useState(translations.header);
  const [messagingTranslations] = useState(translations.messaging);
  const dispatch = useDispatch();
  const headerProps = useSelector((state) => state.header);
  const accountProps = useSelector((state) => state.account);
  const navMenuProps = useSelector((state) => state.navMenu);
  const siteContactInfo2 = useSelector((state) => state.shared.siteContactInfo);
  const accuCustomization2 = headerProps.accuCustomization;
  const userInitials = String(headerProps.userProfile.firstName).substr(0, 1) + String(headerProps.userProfile.lastName).substr(0, 1);
  const currentLanguage = useSelector((state) => state.shared.selectedLanguage);
  const changeLanguageEnabled = headerProps.txnAccess.changeLanguageEnabled;
  const wnspwbEnabled = headerProps.txnAccess.wnspwbEnabled;
  const [showLanguagePicker, setShowLanguagePicker] = useState(false);
  const [logOutLabel, setLogoutLbl] = useState("");
  const [changeLanguageLabel, setChangeLanguageLabel] = useState(null);
  const numberOfItems = 3;
  const { buttonProps, isOpen, setIsOpen, buttonListener, itemProps } = useDropdownMenu(numberOfItems);
  const { enabled: isSearchEnabled } = useSearchEnabled({
    individualId: accountProps == null ? void 0 : accountProps.individualId,
    groupId: accountProps == null ? void 0 : accountProps.groupId,
    productId: getPlanDetails(accountProps == null ? void 0 : accountProps.accountSummaryList).productId
  });
  const { data: funnelAttributes } = useGetFunnelAttributes({ csrf: window.csrf });
  const handleUserDropdownDispatchEvent = (item) => {
    dispatchAmplitude({
      eventType: AMPLITUDE_EVENTS.SELECT_MENU,
      selection: EventBusEvents.HEADER.USER_ICON_DROPDOWN_MENU_ITEM_CLICKED,
      payload: { name: item.menuItemName }
    });
  };
  const defaultUserProfileDropdownMenuItems = useMemo(
    () => {
      var _a3, _b3;
      return [
        {
          id: 1,
          menuItemName: (_a3 = headerTranslations == null ? void 0 : headerTranslations.dropdown) == null ? void 0 : _a3.Profile,
          href: "/participant/home/#/settings/profile",
          url: "/participant/home/#/settings/profile",
          itemProps: itemProps[0],
          onClick: handleUserDropdownDispatchEvent
        },
        {
          id: 2,
          menuItemName: (_b3 = headerTranslations == null ? void 0 : headerTranslations.dropdown) == null ? void 0 : _b3.Settings,
          href: "/participant/home/#/settings/settings",
          url: "/participant/home/#/settings/settings",
          itemProps: itemProps[1],
          onClick: handleUserDropdownDispatchEvent
        }
      ];
    },
    [headerTranslations, itemProps]
  );
  const searchEnabled = isSearchEnabled && !isUISearchVisible;
  globalThis.searchEngineEnabled = searchEnabled;
  const [showPipe, setShowPipe] = useState(false);
  const removeOldSlides = (slides) => slides.filter(({ displayEffdate }) => DateUtil$1.isAfter(displayEffdate, oldestDate));
  const { "aria-haspopup": ariaHash, "aria-expanded": ariaExp, ...buttonPropsRest } = buttonProps;
  useEffect(() => {
    var _a3;
    if (funnelAttributes !== void 0) {
      const supportLinkMenuItem = {
        id: 3,
        menuItemName: (_a3 = headerTranslations == null ? void 0 : headerTranslations.dropdown) == null ? void 0 : _a3.Support,
        href: funnelAttributes.supportURL,
        url: funnelAttributes.supportURL,
        itemProps: itemProps[2]
      };
      defaultUserProfileDropdownMenuItems.push(supportLinkMenuItem);
    }
  }, [
    defaultUserProfileDropdownMenuItems,
    funnelAttributes,
    (_a2 = headerTranslations == null ? void 0 : headerTranslations.dropdown) == null ? void 0 : _a2.Support,
    itemProps
  ]);
  useEffect(() => {
    if (headerProps.authenticationStatus.authenticated && !isMobileBrowser()) {
      document.addEventListener("collapseDropdown", handleClickDropDown);
    }
    if (headerProps.authenticationStatus.authenticated || headerProps.authenticationStatus.partialAuth) {
      dispatch(retrieveSiteContactInfo());
    }
  }, [
    dispatch,
    headerProps.authenticationStatus.authenticated,
    headerProps.authenticationStatus.partialAuth
  ]);
  useEffect(() => {
    if (headerProps.planMessagingSlides && headerProps.planMessagingSlides.length > 0) {
      const latestSlides = removeOldSlides(headerProps.planMessagingSlides);
      setShowPipe(changeLanguageEnabled && latestSlides.length > 0);
    }
  }, [headerProps.planMessagingSlides, changeLanguageEnabled]);
  useEffect(() => {
    if (isOpen) {
      toggleOtherDD("userDD", true);
    }
  }, [isOpen, toggleOtherDD]);
  useEffect(() => {
    if (closeUserDD) {
      if (isOpen) {
        setIsOpen(false);
        toggleUserDD(false);
      }
    }
  }, [closeUserDD, isOpen, setIsOpen, toggleUserDD]);
  useEffect(() => {
    if (navMenuProps.integratedNavSettings && navMenuProps.integratedNavSettings.length > 0) {
      document.addEventListener("keyup", function(event) {
        if (event.keyCode === 13) {
          if (event.target.id === "itemNavUserList") {
            buttonListener(event);
          }
        }
      });
    }
  }, [buttonListener, navMenuProps.integratedNavSettings]);
  useEffect(() => {
    if (headerTranslations && (logOutLabel === "" || changeLanguageLabel === null)) {
      setLogoutLbl((headerTranslations == null ? void 0 : headerTranslations.Logout) || "logout");
      setChangeLanguageLabel((headerTranslations == null ? void 0 : headerTranslations.changeLanguage) || "change language");
    }
  }, [changeLanguageLabel, headerTranslations, logOutLabel]);
  useEffect(() => {
    if (currentLanguage === ReferenceData.LANGUAGES.SPN && wnspwbEnabled) {
      dispatch(updateSelectedLanguage(currentLanguage, wnspwbEnabled));
    }
  }, [currentLanguage, dispatch, wnspwbEnabled]);
  const handleLogout = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (isPreventUrl(navMenuProps, dispatch)) {
        dispatch(preventNavigation(e, "LOGOUT", headerProps));
      } else {
        dispatch(logout());
      }
    },
    [dispatch, headerProps, navMenuProps]
  );
  useEffect(() => {
    document.addEventListener("keyup", function(event) {
      if (event.key === "Enter") {
        if (event.target.id === "ppt-logout") {
          handleLogout(event);
        }
      }
    });
  }, [handleLogout]);
  const handleClickDropDown = () => {
  };
  const mainNavToggle = () => {
    dispatch(
      dispatchEventBus(EventBusEvents.HEADER.MAIN_TOGGLE, {
        open: false
      })
    );
  };
  const availableLanguages = accuCustomization2.header && accuCustomization2.header.languagePreference && accuCustomization2.header.languagePreference.languageList;
  const handleChangeLanguage = useCallback(
    (e) => {
      var _a3;
      const isPAE = ((_a3 = globalThis.integratedEligibility) == null ? void 0 : _a3.type) !== ReferenceData.USER_TYPE_PARTICIPANT;
      e.preventDefault();
      if (isPAE) {
        dispatch(
          setShowErrorModal({
            show: true,
            message: {
              body: ReferenceData.errorModal.PAE_MESSAGES[0].MSG
            },
            footer: {
              canShow: true,
              code: ReferenceData.errorModal.PAE_MESSAGES[0].CODE
            }
          })
        );
        return;
      }
      const eventBusPayload = {
        // eslint-disable-next-line camelcase
        current_language: currentLanguage
      };
      dispatch(
        dispatchEventBus(EventBusEvents.HEADER.SHOW_CHANGE_LANGUAGE_MODAL, eventBusPayload)
      );
      dispatchAmplitude({
        eventType: AMPLITUDE_EVENTS.SELECT_BUTTON,
        selection: EventBusEvents.HEADER.SHOW_CHANGE_LANGUAGE_MODAL,
        payload: eventBusPayload
      });
      setShowLanguagePicker(true);
    },
    [currentLanguage, dispatch]
  );
  useEffect(() => {
    document.addEventListener("openLanguageModalFromSearchboxEvent", handleChangeLanguage);
    return () => {
      document.removeEventListener(
        "openLanguageModalFromSearchboxEvent",
        handleChangeLanguage
      );
    };
  }, [handleChangeLanguage]);
  const handleKeyboardDownChangeLanguage = (event) => {
    handleKeyboardDownEvent({
      event,
      keys: keyboardInteractions.link,
      output: () => handleChangeLanguage(event)
    });
  };
  const handleKeyboardDownLogout = (event) => {
    handleKeyboardDownEvent({
      event,
      keys: keyboardInteractions.link,
      output: () => handleLogout(event)
    });
  };
  const onLanguageSelected = (newLang) => {
    if (headerProps.txnAccess.changeLanguageEnabled && currentLanguage !== newLang) {
      dispatch(updateSelectedLanguage(newLang, wnspwbEnabled));
    }
    setShowLanguagePicker(false);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      id: "header-navigation",
      className: "main-nav utility-nav navbar-default pull-right",
      "aria-label": ((_b2 = headerTranslations == null ? void 0 : headerTranslations.Accessibility) == null ? void 0 : _b2.utilityNav) || "main navigation",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "aria-hidden": "false", className: "main-nav-menu", id: "utility-nav", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              className: "navbar-toggle utility-nav-toggle",
              "data-toggle-content": "#utility-nav",
              onClick: mainNavToggle,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: "fa fa-times" })
            }
          ),
          headerProps.authenticationStatus.authenticated && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "nav navbar-nav desktop-nav", children: [
            searchEnabled && ToggleSearchButton && /* @__PURE__ */ jsxRuntimeExports.jsx(ToggleSearchButton, { onClick: onSearchClick }),
            changeLanguageEnabled && currentLanguage && accuCustomization2.header && accuCustomization2.header.languagePreference && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "changeLanguage", className: "utility-nav-item", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "integrated-nav-text", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "a",
              {
                tabIndex: "0",
                role: "button",
                onKeyDown: (e) => handleKeyboardDownChangeLanguage(e),
                onClick: handleChangeLanguage,
                "aria-label": currentLanguage === ReferenceData.LANGUAGES.SPN ? `${accuCustomization2.header.languagePreference.linkSpanishLabel}` : `${accuCustomization2.header.languagePreference.linkEnglishLabel}`,
                children: currentLanguage === ReferenceData.LANGUAGES.SPN ? accuCustomization2.header.languagePreference.linkEnglish : accuCustomization2.header.languagePreference.linkSpanish
              }
            ) }) }),
            showPipe && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "utility-nav-item", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "gray-color-1", children: "|" }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "utility-nav-item", role: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              HeaderPlanMessaging,
              {
                slides: headerProps.planMessagingSlides,
                watchDepth: "reference",
                navMenu: navMenuProps,
                prevent,
                translations: messagingTranslations,
                onViewAllPrevent: navMenuProps.onViewAllPrevent
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "itemNavUserList", className: "utility-nav-item", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "button",
              {
                id: "navUserList",
                className: "user-id badge badge-primary menu-item-link ",
                "aria-label": (headerTranslations == null ? void 0 : headerTranslations.UserProfile) || "user profile",
                ...buttonPropsRest,
                role: "link",
                onClick: () => {
                  setIsOpen(!isOpen);
                  dispatchAmplitude({
                    eventType: AMPLITUDE_EVENTS.SELECT_BUTTON,
                    selection: EventBusEvents.HEADER.USER_ICON_DROPDOWN_CLICKED
                  });
                },
                onKeyDown: (e) => {
                  if (e.key === "Enter") {
                    setIsOpen(!isOpen);
                    dispatchAmplitude({
                      eventType: AMPLITUDE_EVENTS.SELECT_BUTTON,
                      selection: EventBusEvents.HEADER.USER_ICON_DROPDOWN_CLICKED
                    });
                  }
                },
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "sr-only", children: userInitials }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "badge-count", children: userInitials }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Dropdown,
                    {
                      id: "profile-dropdown",
                      isComponentVisible: isOpen,
                      showMenuDD: isOpen,
                      primaryMenuItemName: "menuItemName",
                      mainMenuList: defaultUserProfileDropdownMenuItems
                    }
                  )
                ]
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "utility-nav-item desktop-logout", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "integrated-nav-text", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "a",
              {
                tabIndex: "0",
                role: "button",
                onKeyDown: (e) => handleKeyboardDownLogout(e),
                id: "ppt-logout",
                onClick: handleLogout,
                href: loginAppURL + "/#/login?accu=" + headerProps.accu,
                children: logOutLabel
              }
            ) }) })
          ] }),
          changeLanguageEnabled && currentLanguage && availableLanguages && /* @__PURE__ */ jsxRuntimeExports.jsx(
            LanguagePicker,
            {
              show: showLanguagePicker,
              availableLanguages,
              currentLanguage,
              siteContactInfo: siteContactInfo2,
              onSave: onLanguageSelected,
              onDismiss: () => setShowLanguagePicker(false)
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "searchbox-live", "aria-live": "assertive", "aria-atomic": "true", className: "sr-only", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: !isUISearchVisible ? ariaSearchBoxMsg : headerTranslations.searchbox.searchOverlayOpened }) })
      ]
    }
  );
};
const { isUndefinedOrNull } = ObjectUtil;
const pagesThatNeedStyles = [
  "/faqSupportCenter",
  "/participant/home",
  "/participant/enroll",
  "/participant/accounts"
];
const HeaderView = (props) => {
  var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
  const activeModal = useSelector((state) => state.header.activeMenuModal);
  const menuItemModals = useSelector((state) => state.header.menuItemModalManifest);
  const account2 = useSelector((state) => state.account);
  const activeGroupAccount = account2.activeGroupAccount;
  const accuCustomization2 = useSelector((state) => state.shared.accuCustomization);
  const isInboundSSO = useSelector((state) => state.shared.authenticationStatus.inboundSSOUser);
  const [listenersAdded, setListenersAdded] = useState(false);
  const [isLIAT, setIsLIAT] = useState(false);
  const [showKeepAliveWarn, setShowKeepAliveWarn] = useState(false);
  const [closeOtherDD, setCloseOtherDD] = useState(false);
  const [closeUserDD, setCloseUserDD] = useState(false);
  const [altLogo, setAltLogo] = useState(props.header.accuLogoAltAttribute);
  const [hasLogoCss, setHasLogoCss] = useState(false);
  const [settingsLoaded, setSettingsLoaded] = useState(false);
  const [hasHdrCss, setHasHdrCss] = useState(false);
  const [hasBrandingCss, setHasBrandingCss] = useState(false);
  const [hasEligibilitySvcLoaded, setHasEligibilitySvcLoaded] = useState(false);
  const [hasTopNavRefresh, setHasTopNavRefresh] = useState(false);
  const [clsSiteLogo, setClsSiteLogo] = useState("site-logo-dashboard");
  const [headerClass] = useState(() => {
    const pagesArray = pagesThatNeedStyles.filter(
      (slug) => window.location.href.indexOf(slug) >= 0
    );
    return pagesArray.length > 0 ? "site-header integrated-header" : "site-header";
  });
  const isOauthLogin = String(getCookie$1("isOauthLogin")) === "true";
  const iframeUrl = globalThis.iframeUrl;
  let ssoLogin = false;
  const dispatch = useDispatch();
  const loginAppURL = ReferenceData.LOGIN_APP_URL;
  const isBalanceInTabletOrPhone = useMediaQuery({
    query: "(max-width: " + ReferenceData.MOBILE_TABLET_PHONE_WIDTH + "px)"
  });
  if (props.header.accu === null) {
    dispatch(setAccu(getCookie$1("accu") || "Empower"));
  }
  useDocumentTitle();
  const handleShowAccountSwitchModal = (e) => {
    const indx = String(e.detail.planId).indexOf("_");
    if (indx > -1) {
      const planId = String(e.detail.planId).substr(0, indx);
      dispatch(switchPlan(null, planId));
    } else {
      dispatch(switchPlan(null, e.detail.planId, void 0, e.detail.indId));
    }
  };
  const handleTopNavRefresh = () => {
    dispatch(refreshTopNav(false));
  };
  const handleRefreshAccountOpened = () => {
    if (!hasTopNavRefresh) {
      setHasTopNavRefresh(true);
      dispatch(refreshContext());
      setTimeout(() => {
        setHasTopNavRefresh(false);
      }, 3500);
    }
  };
  const handleFinishAccountOpenRefresh = () => {
    getEligibilitySettings().then(
      (response) => {
        handleIntegratedEligibilityState(response);
        dispatch(getAccountSummary(true));
        dispatch(setAccountOpenInProgress(false));
      },
      (err) => {
        handleEligibilitySvcError(err);
      }
    );
  };
  const getOpenAccountSubMenu = (menuData) => {
    let openAccountData = null;
    if (menuData) {
      menuData.forEach((menu) => {
        if (menu.url && menu.url.includes("#/open-account")) {
          openAccountData = menu;
        }
        menu.subMenu.forEach((subMenu) => {
          if (subMenu.url && subMenu.url.includes("#/open-account")) {
            openAccountData = subMenu;
          }
        });
      });
    }
    return openAccountData && {
      displayText: openAccountData.displayText,
      url: openAccountData.url,
      loginWithSSO: isInboundSSO
    };
  };
  const openNewAccountLinkEvent = (menuData) => {
    if (menuData) {
      const event = new CustomEvent("openNewAccountLink", {
        detail: menuData
      });
      window.dispatchEvent(event);
      globalThis.openNewAccountLink = {};
      globalThis.openNewAccountLink.data = menuData;
      globalThis.openNewAccountLink.isLoaded = true;
    }
  };
  useEffect(() => {
    dispatch(getTranslations());
    window.addEventListener("switch-plan", handleShowAccountSwitchModal);
    window.addEventListener("open-sso-investment-modal", handleShowSsoInvestingModal);
    window.addEventListener("pc_refresh_top_nav", handleTopNavRefresh);
    window.addEventListener("pc_new_account_opened", handleRefreshAccountOpened);
    window.addEventListener("finish_acct_open_refresh", handleFinishAccountOpenRefresh);
  }, []);
  const handleIntegratedEligibilityState = (response) => {
    if (isUndefinedOrNull(response)) {
      console.warn("Integrated Eligibility service - bad data :>> ", response);
      setHasEligibilitySvcLoaded(true);
    } else {
      setIntegratedEligbilityState();
      if (globalThis.integratedEligibility.eligibilityLoaded !== "in_progress") {
        const previousValues = globalThis.integratedEligibility;
        handleEligibilityServiceResponse(response, previousValues);
      }
    }
  };
  const handleShowSsoInvestingModal = (e) => {
    dispatch(setActiveDeepLink(e.detail));
    dispatch(openOrCloseSSOInvestingModal(true));
  };
  const setIntegratedEligbilityState = () => {
    if (!hasHdrCss) {
      setHasHdrCss(true);
    }
    if (!hasBrandingCss) {
      document.body.classList.remove("integrated-branding");
      document.body.classList.add("integrated-branding");
      setHasBrandingCss(true);
    }
    if (!settingsLoaded) {
      getNavSettings(false).then(function(response) {
        const updatedData = processAccounts(response, activeGroupAccount);
        setSettingsLoaded(true);
        dispatch(setNavSettings(updatedData));
        openNewAccountLinkEvent(getOpenAccountSubMenu(updatedData));
      });
    }
    setHasEligibilitySvcLoaded(true);
  };
  const handleEligibilitySvcError = (err) => {
    setIntegratedEligbilityState();
    if (err.notifications.length > 0) {
      const isWarning = err.notifications[0].type === "WARNING";
      const isTerminated = String(err.notifications[0].message).indexOf("terminated with no Balance") > -1;
      if (isWarning && isTerminated) {
        console.log("Account is terminated: ", isWarning);
      }
    }
    if (err.showError) {
      dispatch(
        setShowErrorModal({
          show: true,
          message: {
            body: err.messsage
          }
        })
      );
    }
    setHasEligibilitySvcLoaded(true);
  };
  useEffect(() => {
    if (props.header.authenticationStatus.authenticated && !hasEligibilitySvcLoaded) {
      if (globalThis.integratedEligibility && globalThis.integratedEligibility.eligibilityLoaded === true && !hasEligibilitySvcLoaded) {
        setIntegratedEligbilityState();
      } else {
        if (!hasEligibilitySvcLoaded) {
          getEligibilitySettings().then(
            (response) => {
              handleIntegratedEligibilityState(response);
            },
            (err) => {
              handleEligibilitySvcError(err);
            }
          );
        }
      }
    }
  }, [
    props.header.authenticationStatus.authenticated,
    globalThis.integratedEligibility.eligibilityLoaded
  ]);
  const statesToCheck = ReferenceData.ROUTES_TO_CHECK;
  useEffect(() => {
    const url2 = window.location.href;
    let showBalance = false;
    let re;
    const leading = /^.*/;
    const noTrailingSlash = /[^/]*$/;
    for (let i = 0; i < statesToCheck.length; i++) {
      re = new RegExp(leading.source + statesToCheck[i] + noTrailingSlash.source);
      if (re.test(url2)) {
        showBalance = true;
        break;
      }
    }
    if (showBalance) {
      setIsLIAT(true);
    }
    let isLogin = false;
    if (window.location.href.indexOf("login") !== -1 || window.location.href.indexOf("/mfa") !== -1 || window.location.href.indexOf("register") !== -1 || window.location.href.indexOf("npdi") !== -1 || window.location.href.indexOf("accountOpenDetails") !== -1 || window.location.href.indexOf("activationCodeDeliveryOptions") !== -1 || window.location.href.indexOf("verifyCode") !== -1 || window.location.href.indexOf("oauth") !== -1) {
      isLogin = true;
    }
    if (isLogin) {
      dispatch(
        setNonAuthHeader({
          showNonAuthHeader: true,
          initLogin: true,
          ssoLogin
        })
      );
      dispatch(setAccountDetailsLoaded(false));
    }
    if (window.location.href.indexOf("/participant/accounts") !== -1) {
      setClsSiteLogo("site-logo-account-details");
    } else {
      setClsSiteLogo("site-logo-dashboard");
    }
  }, [window.location.href]);
  useEffect(() => {
    if (window.location.href.indexOf("#/articles") !== -1 || window.location.href.indexOf("#/investmentInformation") !== -1) {
      if (!props.header.authenticated) {
        dispatch(setArticlesClicked(false));
        dispatch(
          setNonAuthHeader({
            showNonAuthHeader: true,
            initLogin: true,
            ssoLogin
          })
        );
        dispatch(setAccountDetailsLoaded(false));
      } else {
        dispatch(setArticlesClicked(true));
        dispatch(setAccuLogoLoaded());
        dispatch(
          setNonAuthHeader({
            showNonAuthHeader: false,
            initLogin: false,
            ssoLogin
          })
        );
        if (globalThis.css && globalThis.css.accu !== "not-initialized") {
          dispatch(setAccu(globalThis.css.accu));
        }
      }
    }
  }, [window.location.href, props.header.authenticated]);
  useEffect(() => {
    let gId = globalThis.sessionStorage.gId;
    if (globalThis.css && globalThis.css.group && globalThis.css.group !== "not-initialized") {
      gId = globalThis.css.group;
    }
    if (gId && gId !== props.account.cssGroupId) {
      const groupClient = String(gId).split("-");
      const groupClientId = groupClient[0];
      if (globalThis.css && globalThis.css.product && globalThis.css.product !== "not-initialized") {
        dispatch(
          setCss({
            type: "product",
            productId: globalThis.css.product,
            groupId: gId,
            groupClient: groupClientId
          })
        );
      } else {
        dispatch(
          setCss({
            type: "group",
            groupId: gId,
            groupClient: groupClientId
          })
        );
      }
    }
    const getCustomLogoSuccess = (response) => {
      function findCustomLogo(arr, str) {
        let item = null;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] === str) {
            item = arr[i];
            break;
          }
        }
        return item;
      }
      const data = response.data;
      const gaId = props.account.cssGroupId;
      const gcId = props.account.cssGroupClientId;
      if (!findCustomLogo(data.customizedGC, gcId) && !findCustomLogo(data.customizedGA, gaId)) {
        document.body.classList.add("no-custom-logo");
      }
    };
    const getCustomLogoFault = (response) => {
      console.error("custom logo service fault", response);
    };
    if (props.account.accountDetails.groupId !== "not-initialized") {
      axios.get("/ui/customization-ui/" + ReferenceData.DEFAULT_CUSTOM_LOGO_INVENTORY).then(getCustomLogoSuccess, getCustomLogoFault);
    }
    let isLogin = false;
    if (window.location.href.indexOf("login") !== -1 || window.location.href.indexOf("/mfa") !== -1 || window.location.href.indexOf("register") !== -1 || window.location.href.indexOf("npdi") !== -1 || window.location.href.indexOf("oauth") !== -1) {
      isLogin = true;
    }
    if ((props.account.accountDetails.productId === "not-initialized" || props.account.accountDetails.groupId === "not-initialized") && !isLogin && !hasLogoCss && props.header.authenticated) {
      dispatch(getPrimaryGroupAccount(true));
      setHasLogoCss(true);
    }
  }, [
    globalThis.sessionStorage.gId,
    props.account.accountDetails.productId,
    globalThis.css,
    props.header.authenticated
  ]);
  const handleSetAccount = () => {
    dispatch(setIsDeepLink(true));
    dispatch(setAccuLogoLoaded());
    dispatch(
      setNonAuthHeader({
        showNonAuthHeader: false,
        initLogin: false,
        ssoLogin
      })
    );
    if (globalThis.css && globalThis.css.accu !== "not-initialized") {
      dispatch(setAccu(globalThis.css.accu));
    }
  };
  const handleActiveGrpAcctForEnrollment = () => {
  };
  useEffect(() => {
    window.addEventListener("handleLoginSetAccountDetails", handleSetAccount);
    document.addEventListener(
      "updateEnrollActiveGroupAccount",
      handleActiveGrpAcctForEnrollment
    );
  }, []);
  useEffect(() => {
    if (!listenersAdded && menuItemModals.length) {
      document.addEventListener("menu-nav-click", function(e) {
        dispatch(
          menuItemModalClick(
            menuItemModals,
            e.detail.event,
            e.detail.navItem.url,
            e.detail.url,
            null,
            null,
            e.detail.navItem
          )
        );
      });
      setListenersAdded(true);
    }
  }, [listenersAdded, menuItemModals]);
  const availableLocales = ReferenceData.AVAILABLE_LOCALES;
  const showChangeLanguageButton = availableLocales.length > 1;
  if (window.location.href.indexOf("inbound") !== -1) {
    ssoLogin = true;
  }
  const prevent = (e, type) => {
    if (isPreventUrl(props.navMenu, dispatch)) {
      dispatch(preventNavigation(e, type, props.header));
    } else {
      dispatch(setOnViewAllPrevent(false));
    }
  };
  if (props.header.styleEnv === null) {
    dispatch(
      setGlobalSettings({
        styleEnv: "/ui/customization-ui/",
        iframeUrl,
        availableLocales,
        showChangeLanguageButton,
        baseApiUrl: ""
      })
    );
    if (window.location.href.indexOf("login") !== -1 || window.location.href.indexOf("/mfa") !== -1 || window.location.href.indexOf("register") !== -1 || window.location.href.indexOf("npdi") !== -1 || window.location.href.indexOf("oauth") !== -1) {
      dispatch(
        setNonAuthHeader({
          showNonAuthHeader: true,
          initLogin: true,
          ssoLogin
        })
      );
    }
  }
  useEffect(() => {
    if (props.header.isDeepLinkEnabled || props.header.isArticlesClicked) {
      dispatch(setAccuLogoLoaded());
      initCustomizations(dispatch, props.header);
    } else if (props.header.showNonAuthHeader === void 0 || props.header.isDeepLinkEnabled || props.header.isArticlesClicked) {
      if (!props.header.accuLogoLoaded && props.header.accu !== null) {
        initCustomizations(dispatch, props.header);
      }
    } else {
      if (props.header.showNonAuthHeader && props.header.initLogin) {
        initLoginCustomization(dispatch, props.header);
      }
      window.addEventListener(
        "loginAuthStatusVerified",
        initCustomizations(dispatch, props.header)
      );
    }
  }, [
    props.header.showNonAuthHeader,
    props.header.accuLogoLoaded,
    props.header.accu,
    props.header.isDeepLinkEnabled
  ]);
  useEffect(() => {
    const altLogoPosfix = get(
      props,
      ["shared", "translations", "header", "altLogoPosfix"],
      ""
    );
    const companyName = get(
      account2,
      ["accountDetails", "groupDetails", "groupClientName"],
      ""
    );
    if (altLogoPosfix !== "" && companyName !== "") {
      setAltLogo(`${companyName} ${altLogoPosfix}`);
    }
  }, [account2.accountDetails, props.shared.translations]);
  const accountOverviewTotalAccountBalance = ((_d2 = (_c2 = (_b2 = (_a2 = props == null ? void 0 : props.shared) == null ? void 0 : _a2.translations) == null ? void 0 : _b2.accountList) == null ? void 0 : _c2.accountOverview) == null ? void 0 : _d2.totalAccountBalance) || null;
  const toggleOtherDD = (source, setDDClose) => {
    setCloseOtherDD(setDDClose);
  };
  const toggleUserDD = (userDDState) => {
    setCloseUserDD(userDDState);
  };
  const homeClickHandler = (evt) => {
    dispatch(dispatchEventBus(EventBusEvents.HEADER.LOGO));
    dispatchAmplitude({
      eventType: AMPLITUDE_EVENTS.SELECT_LINK,
      selection: EventBusEvents.HEADER.LOGO
    });
    evt.preventDefault();
    if (isPreventUrl(props.navMenu, dispatch)) {
      dispatch(preventNavigation(evt, "LIAT_LOGO", props.header));
    } else {
      let transition = true;
      const url2 = window.location.href;
      let re;
      const leading = /^.*/;
      const noTrailingSlash = /[^/]*$/;
      for (let i = 0; i < statesToCheck.length; i++) {
        re = new RegExp(leading.source + statesToCheck[i] + noTrailingSlash.source);
        if (re.test(url2)) {
          transition = false;
          break;
        }
      }
      if (!props.header.txnAccess.liatEnabled) {
        transition = false;
      }
      let redirectUrl = ReferenceData.PARTICIPANT_OVERVIEW_URL;
      if (props.header.txnAccess.liatEnabled || globalThis.integratedEligibility.homePageEligibility) {
        if (globalThis.integratedEligibility.homePageEligibility) {
          redirectUrl = ReferenceData.INTEGRATED_DASHBOARD;
        }
        if (showFeatureNotAvailableModal()) {
          featureNotAvailableModal(dispatch);
          return;
        }
      }
      if (transition) {
        const currentUrl = window.location.href;
        if (currentUrl.indexOf("nqEnrollment") > -1) {
          window.location.href = redirectUrl;
        } else {
          window.location.href = redirectUrl;
        }
      } else {
        window.location.href = redirectUrl;
      }
      if (props.header.accountOpenInProgress) {
        setTimeout(() => {
          window.location.reload();
        }, 1e3);
      }
    }
  };
  const { ariaSearchBoxMsg, isSearchboxVisible, setIsSearchboxVisible } = useEventListenerSearchbox();
  const handleSearchClick = useCallback(() => {
    setIsSearchboxVisible(true);
    dispatchAmplitude({
      eventType: AMPLITUDE_EVENTS.SELECT_LINK,
      selection: EventBusEvents.HEADER.SEARCHBOX_ICON_CLICK
    });
  }, [setIsSearchboxVisible]);
  useBoomerang();
  useOneTrustBannerScript(accuCustomization2);
  const urlParams = new URLSearchParams(window.location.hash.split("?")[1]);
  if (urlParams.has("optimizelyEndUserId")) {
    const currentDomain = document.location.hostname;
    const secondLevelDomain = currentDomain.split(".").slice(-2).join(".");
    saveCookie(
      "optimizelyEndUserId",
      urlParams.get("optimizelyEndUserId"),
      "/",
      "." + secondLevelDomain,
      true,
      182
    );
  }
  useOptimizelyScript(props.header.showNonAuthHeader, props.header.txnAccess, accuCustomization2);
  useWalkMeScript(props.header.showNonAuthHeader);
  const logoKeyDown = (event) => {
    handleKeyboardDownEvent({
      event,
      keys: keyboardInteractions.button,
      output: () => checkIsAccountOpenFlow(() => homeClickHandler(event), dispatch)
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("header", { className: headerClass, children: props.header.accu !== null && props.header.accuLogoLoaded && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "container", children: [
    props.header.showNonAuthHeader && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      LoginSiteHeader,
      {
        accuLogoAltAttribute: props.header.accuLogoAltAttribute,
        accuCustomization: props.header.accuCustomization,
        styleEnv: props.header.styleEnv,
        urlPscPath: props.header.urlPscPath
      }
    ) }),
    props.header.showNonAuthHeader && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      KeepAliveView,
      {
        showKeepAliveWarn,
        setShowKeepAliveWarn,
        translations: props.shared.translations
      }
    ) }),
    (!props.header.showNonAuthHeader || props.header.isDeepLinkEnabled) && /* @__PURE__ */ jsxRuntimeExports.jsx(PreInitHeader, { header: props.header }),
    !props.header.showNonAuthHeader && props.account.accountsDetailsLoaded && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      props.header.authenticationStatus.authenticated && /* @__PURE__ */ jsxRuntimeExports.jsx(
        KeepAliveView,
        {
          showKeepAliveWarn,
          setShowKeepAliveWarn,
          translations: props.shared.translations
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "span",
        {
          id: "integrated-site-logo",
          className: `integrated-site-logo ${clsSiteLogo}`,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "span",
            {
              id: "logwrapper",
              tabIndex: "0",
              role: "link",
              className: "site-logo-wrapper",
              onClick: (e) => checkIsAccountOpenFlow(() => homeClickHandler(e), dispatch),
              onKeyDown: logoKeyDown,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                "img",
                {
                  src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
                  className: `site-logo p-${props.account.cssProductId} gc-${props.account.cssGroupClientId} ga-${props.account.cssGroupId}`,
                  alt: altLogo,
                  title: altLogo
                }
              )
            }
          )
        }
      ),
      isBalanceInTabletOrPhone && isLIAT && /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "span",
        {
          className: "balance-wrapper hidden-lg hidden-md visible-sm visible-xs",
          tabIndex: "0",
          role: "link",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "total-balance", children: accountOverviewTotalAccountBalance }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "total-balance-amount", children: formatCurrency(
              props.account.summaryOfAllAccounts.totalBalance
            ) })
          ]
        }
      ),
      !isSearchboxVisible && !isOauthLogin && /* @__PURE__ */ jsxRuntimeExports.jsx(
        NavMenuView,
        {
          prevent,
          translations: props.shared.translations,
          closeOtherDD,
          toggleUserDD,
          closeUserDD
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(SaveChangesModal, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorModal, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItemModal, { activeModal }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(InvestingSSOModal, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ContextSwitchBlockedModal, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(OpenAccountWarningModal, {}),
      props.header.authenticationStatus.authenticated && !isMobileBrowser() && !isOauthLogin && /* @__PURE__ */ jsxRuntimeExports.jsx(
        TopHeader,
        {
          loginAppURL,
          translations: {
            header: {
              ...(_f2 = (_e2 = globalThis == null ? void 0 : globalThis.integratedSharedData) == null ? void 0 : _e2.translations) == null ? void 0 : _f2.get(
                "header"
              )
            },
            messaging: {
              ...(_h2 = (_g2 = globalThis == null ? void 0 : globalThis.integratedSharedData) == null ? void 0 : _g2.translations) == null ? void 0 : _h2.get(
                "messaging"
              )
            }
          },
          toggleOtherDD,
          closeUserDD,
          toggleUserDD,
          prevent,
          onSearchClick: handleSearchClick,
          isUISearchVisible: isSearchboxVisible,
          ToggleSearchButton: props.ToggleSearchButton,
          ariaSearchBoxMsg
        }
      )
    ] })
  ] }) });
};
const mapStateToProps = (state) => {
  return {
    ...state,
    getAccuCode: getAccuCode()
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getAccuCode
    },
    dispatch
  );
};
const HeaderContainer = connect(mapStateToProps, mapDispatchToProps)(HeaderView);
const queryClient = new QueryClient();
const HeaderViewProviderComponent = (value, externalContext, externalStore, externalQueryClient) => {
  const ctx = externalContext ? {
    context: externalContext.context
  } : {};
  const qClient = externalQueryClient ? externalQueryClient : queryClient;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(QueryClientProvider, { client: qClient, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Provider, { store: externalStore ? externalStore : store, ...ctx, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    HeaderContainer,
    {
      $rootScope: value.$rootScope,
      ToggleSearchButton: value.ToggleSearchButton
    }
  ) }) });
};
const index = {
  headerStore: store,
  AccountSummaryProvider: AccountSummaryProviderComponent,
  AccountMenuList,
  HeaderNoLogin,
  HeaderPlanMessaging,
  HeaderViewProviderComponent,
  FooterViewProviderComponent
};
export {
  EventBusEvents as E,
  LogService$1 as L,
  ReferenceData as R,
  log as a,
  localMocksTrue as b,
  dispatchEventBus as d,
  executePost as e,
  index as i,
  jsxRuntimeExports as j,
  loglevelExports as l
};
